module.exports={
"label_emailtocloudcc_department":`Departamento`,
"label.wei.weiresearch":`Micro Voto`,
"message.error.appsecret.null":`A senha da chave secreta não pode ser nula!`,
"label.file.orderbylastmodifydate":`Ordenado pelo último tempo modificado`,
"label.minus":`-Minus`,
"label.horizontalbar":`Linhas Horizontais`,
"label.emailobject.emailsentfailed":`O correio não chegou a send！`,
"assignedresource.check":`Este recurso de serviço foi designado para uma consulta de serviço. Por favor, não adicione repetidamente.`,
"label.finish":`Completo`,
"label.document.history":`Baixar histórico`,
"label.customfields.number.numberLengthHelpText":`1. Favor digitar o comprimento do número e o número de casas decimais. Por exemplo, um número com um comprimento de 8 e 2 casas decimais pode aceitar valores até "12345678,90".`,
"label.standard.buttonandlink.info":`A substituição de botões e links padrão muda o significado do URL CloudCC.com e quaisquer chamadas para esse URL, como uma página personalizada do CloudCC.com, um atalho do navegador ou um sistema externo. Você pode substituir o URL CloudCC.com por um botão padrão ou um link por uma página personalizada.`,
"front-epwechat-module-v1-contacts-desc":`Quando ativado, o objeto da WeCom Contacts será adicionado ao sistema CloudCC, as informações do cliente da WeCom serão sincronizadas com este objeto.`,
"label.mr.caption.contact.result":`Encontrar duplicatas e fundir: Resultados para consulta de duplicatas de Contatos`,
"label.ems.selectaccount":`Selecione a conta`,
"label.group.no.activity":`Não há grupos ativos correspondentes.`,
"label.call.for":`Convidado por`,
"label.newreportguide":`Novo Guia de Relatório`,
"component.telerecord.label.name":`Nomes`,
"vue.add.dashboard.component":`Adicionar {nome do título} Componente`,
"label.chatter.sendEmailToGroupMember.check.V":`Ver Votos`,
"UG.ST.002":`Determine`,
"label.setting.intergrationmanage":`Gerenciamento da integração`,
"label.field.apiname.validate":`Favor inserir um número entre 0 e 6.`,
"label.emailmerge.list.deletefolder":`Apagar pasta`,
"vue_label_pool_received":`Recebido`,
"label_emailtocloudcc_step1_case1":`E-mail para o caso`,
"message.sumlength":`A soma do comprimento e do número de casas decimais não pode exceder 18 palcos.`,
"vue_label_approve_reassignapproval":`reatribuiu esta aprovação às pessoas.`,
"label.specify.time":`Hora: 13:00 de junho, 21 de junho, 2016`,
"vue_label_report_sortdown":`Ordenar em ordem decrescente`,
"chatter.login.now":`Carregando...`,
"label.import.page2.notsuited":`Não mapeado`,
"label.please.fill.out":`Favor preencher`,
"label.recordtype.edit.description":`Selecione um valor de "Valores Disponíveis", depois adicione-o a "Valores Selecionados" e faça dele um valor de lista de seleção para este tipo de registro. Observe que apagar um valor da lista de seleção não remove este valor de nenhum registro existente. Finalmente, selecione o valor padrão da lista de seleção para o tipo de registro.`,
"label.customer.tab.new":`Aba Novo Cliente`,
"label.sameas":`O mesmo que`,
"front-filter-module-v1-filter-a-week-ago":`Uma semana atrás`,
"label.processsetting.disable.process.failed":`Falha em desativar o processo!`,
"label.summaryreport.2018.step4":`Passo 4 Selecione os critérios do relatório`,
"label.secrecyinfo":`Informações Confidenciais,Não Espalhe`,
"label.custom.page.component.general.settings":`Componente Configurações gerais`,
"label.ccpeak.folder":`Pastas de classe não arquivadas`,
"vue_label_homepage_select_button_operation":`Selecionar Botão`,
"message.pleaseinputrightdistance":`Por favor, digite os dias de intervalo corretos`,
"label.mobile.phone.required.short":`é necessário`,
"vue_label_account_equityseructure":`Estrutura acionária`,
"label.file.library.error1":`Este arquivo já se encontra nesta biblioteca.`,
"fliter.nextmonth":`Próximo mês`,
"label.mr.descreption.oneGroupNote2":`conjunto de informações empresariais,há`,
"label.allfolderdashboard":`Todas as Pastas do Painel`,
"lable.opppdt.selPdt.bykeywords":`Por palavra-chave`,
"setup_layout_label_selectedfield":`Selecione os campos`,
"label.file.preview.convert.firstpage.failure":`Ocorreu um erro ao visualizar os detalhes da pré-visualização, por favor clique em pré-visualizar ou faça o download para visualizar`,
"vue_label_systemSettings_companie":`Configuração da empresa`,
"label.loginhis.recently":`Histórico de login recente`,
"label.permission.visualpagepermission.edit":`Atribuição de páginas personalizadas`,
"label.ccservice.validate.email":`O formato do valor correspondente {2} do campo {1} sob o objeto API {0} está incorreto. Por favor, digite o endereço de e-mail correto!`,
"label.sms.companyname.gm":`Configuração do SMS-2`,
"lable.opppdt.addpdt.table.discount":`Desconto (% de desconto)`,
"Lead.Scoring.Setting.LevelSetting":`Configurações de Popularidade de Liderança`,
"message.duplication.label.duplicationremark":`é a operação de consulta de dados duplicados quando novos ou editar registros`,
"label.file.preview.error":`Ocorreu um erro ao fazer o préveiw, favor baixar para ver`,
"label.imgfield.type.input":`Inserir imagem`,
"label.file.share.email.content1":`Nome do arquivo: #nome do arquivo`,
"vue_label_notice_batchedit_fail":`A atualização de dados com id {0} falha com motivo de falha {1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Quatro`,
"label.view.sortview.printview":`Imprimir`,
"label.projectManagement.Addposttask":`Adicionar pós-tarefa`,
"vue_label_commonobjects_view_fail":`Falha em definir a visualização padrão`,
"label.dayinweek":`da semana`,
"label.layout.notexist":`O layout não existe.`,
"label.brief.total":`Registro {total}`,
"label.dashboardSetup.tz.bb":`Ir para Relatórios`,
"label_emailtocloudcc_select3":`Por favor, selecione o proprietário do registro`,
"label.input.least.string":`Por favor, digite pelo menos {0} caracteres`,
"label.app.step2":`Passo 2 Digite os detalhes`,
"lable.account.LastWeek":`Semana passada`,
"label.notifications":`Notificações`,
"label.tabpage.viewname":`Ver nome`,
"label.knowledge.language.italian":`Italiano`,
"label.sendmail.step2.introduce":`Por favor, escolha um modelo de e-mail`,
"label_enable_or_no":`Você quer habilitar?`,
"pagecreator_button_save":`Salvar`,
"template.chart.cplb":`Categoria do produto`,
"label.knowledge.publish":`Não pode ser publicado para ele não qualificado.`,
"label.name.required":`O campo do nome é obrigatório`,
"component.chatter.label.myfans":`Meus seguidores`,
"label.rejectoperate":`Ações de rejeição`,
"label.report.action.addtodashboard3":`Selecione Painel de Controle`,
"label.icon.101":`Livro-texto`,
"label.data.exp.su.ok":`Exportando`,
"label.appupload.component.type.layout":`Layouts de página`,
"template.chart.yscb":`Custo orçamentado`,
"label.tabularreport.selectorder":`Determinar o tipo de exibição de cada coluna de relatório`,
"email.title.one":`Recuperar senha`,
"label.case.copy.link":`Copy Web Link`,
"label.mr.descreption.oneGroupReData4":`grupo,está permanecendo`,
"label.newprocess5.error.des":`Você pode inserir apenas números.`,
"label.partnerCloud.loginButton":`Botão Login`,
"label.interfaceconstraint.adminonly":`Somente administradores podem usar esta interface.`,
"label.campaign.channel.input.date":`2.Por favor, defina o periord de validade para seu canal de marketing:`,
"label.clientwebsiteentranceprofile":`Perfil do Portal do Cliente`,
"UG.opportunity.011":`Transação de importação`,
"label.page.copy.value.paste.template":`Copie e cole o valor do campo de fusão em seu modelo abaixo.`,
"label.notselect":`Sem seleção`,
"label.weixin.input.password":`Por favor, digite sua senha.`,
"label.email.select.template":`Selecione o modelo`,
"label_chatter_ok":`Confirme`,
"permissionService.error":`A atribuição do conjunto de permissões falhou, favor verificar se a licença do pedido expirou ou se a atribuição atingiu o limite superior.`,
"label.webtocloudcc.sorry":`Desculpe, erro de página, por favor tente novamente ou entre em contato com seu administrador.`,
"UG.opportunity.007":`Papel de contato`,
"label.manageAll.forapproval":`Itens a serem aprovados`,
"label.imgfield.type.ref":`Fórmula Imagem`,
"label.profile.setcustomtab":`Configurações de abas personalizadas`,
"label.tabpage.datatyoez":`Tipo de dados`,
"label.partnerCloud.basicSetting.editPersonal":`Permitir aos usuários da nuvem de parceiros editarem informações pessoais`,
"label.mr.caption.account":`Encontrar duplicatas e fundir: Codições para consulta de duplicatas de contas`,
"message.serviceterritoryMe.time.violation":`Violação do tempo de envio: o período de envio não está dentro do intervalo de tempo dos membros regionais.`,
"pagecreator_page_message_publish_success":`Página publicada com sucesso`,
"label.field.formula.timezonetip":`Ao usar a função do sistema como data do sistema em uma fórmula para obter a hora atual, ela deve ser substituída por sua função de fuso horário múltiplo correspondente, como data_corrente.`,
"label.marketseamemset.specialuser":`Membro especial`,
"label.staticresource.message":`Detalhe do Recurso Estático`,
"label.workflow.rulecondition":`Critérios de Regra`,
"component_salesperformance_label_nodata":`Adicione sua oportunidade de negócios e volte aqui para ver o gráfico de desempenho.`,
"label.customfields.textarea.tip":`Permite aos usuários inserir múltiplas linhas de texto, até 4000 caracteres.`,
"font-evaluate-module-v1-template":`Modelo personalizado`,
"label.step3.total5":`Etapa 3 de 5`,
"label.customfields.formula.percent.tip":`Calcule uma porcentagem e acrescente automaticamente o sinal de porcentagem ao número.`,
"label.sortdesc":`Descer`,
"lable.PowerProcess.edit":`Editar processo de direito de propriedade`,
"label.dongshifang.description":`Configure as informações do Dongshifang para atender às necessidades dos serviços de envio e recebimento de SMS de sua organização.`,
"label.chatter.addressee":`Destinatário`,
"vue_label_systemSettings_obj2":`Console de Gerenciamento de Objetos`,
"label.selectreporttype.tip":`Escolha o tipo de dados que você deseja incluir neste relatório`,
"label.version.enterprise":`Edição Empresarial`,
"label.area.add":`Adicionar Território`,
"label.h5.bookmarked":`Bookmarks`,
"label.step5.total7":`Passo 5 de 7`,
"front-lightning-module-v1-title-quotation":`Citação Preview`,
"label.search.onlymyrecords":`Limite aos itens que possuo`,
"vue_label_commonobjects_noduplication":`Duplicata de {字段} em {记录}`,
"label.customerpage.edit":`Abas de edição em páginas personalizadas`,
"message.please.choose.user":`Por favor, selecione o usuário`,
"label.approval.his.currentactor":`Aprovador atual`,
"label.field.duplicate.error.msg3":`Você pode crear no máximo 3 campos de propriedades exclusivas.`,
"label.page_url":`URL da página`,
"label.permission.goback":`Voltar aos Conjuntos de Permissões`,
"vue_label_commonobjects_view_kanban_notice2":`Para visualizar todos os registros, use a visualização de lista ou a visualização em tela dividida`,
"label.group.no.recent.searchs":`Não existem grupos que tenham sido vistos recentemente.`,
"label.event.fiducial.point":`pontual`,
"label.integrations.mailchimp.addtolist":`Adicione os contatos e leads selecionados de sua conta CloudCC à sua lista Mailchimp`,
"label.workflow.configrule.introduce":`Digite o nome, descrição e critérios para acionar sua regra de fluxo de trabalho. Na próxima etapa, associe as ações de fluxo de trabalho a esta regra de fluxo de trabalho.`,
"label.icon.161":`Mala`,
"label.recordtype.enable":`Ativo`,
"label_mailboxes_limit":`O número de caixas postais excede o limite.`,
"label.notification.time3":`{0} horas atrás`,
"label.setsharerule.step2":`Passo 2 Selecione os registros a serem compartilhados`,
"vue_label_homepage_somecomponents":`Cuidado! Depois de adicionar o componente, a altura excede o limite e causou a exibição incompleta. Favor excluir alguns componentes`,
"label.icon.63":`Poço Subterrâneo`,
"label.use.standard.sharerules":`Use as Regras Padrão de Ação`,
"label.button.step2.select.required.field":`Passo 2 Selecione os campos necessários`,
"lable.Confirm.collect.potential.customers":`Confirmar para coletar chumbo {nome}`,
"label.version.sum.custompage":`página(s) personalizada(s)`,
"label.file.ccchat.changefile":`Alterar arquivo`,
"label.mobile.phone.phone.call":`Ligue para`,
"label.appupload.managed.img":`Controlado`,
"vue_label_chatter_comment":`comentário`,
"label.central.european.time":`Tempo da Europa Central`,
"label.three.quarter":`Terceiro trimestre`,
"label.service.newBuildDialog.filter.editor":`Editor de filtros`,
"pagecreator_systemstyle_funcpath":`/ construtor / biblioteca de estilo de marca`,
"label_chatter_collect":`Favoritos`,
"label.custom.page.component.window.settings":`Configurações da janela de componentes`,
"component_chatter_file_label_title":`Carregamento de arquivos`,
"label.marketsea.button.discard":`Descartar`,
"label.Batch.input":`Batch Input`,
"vue_label_campaign_market_members":`Membros existentes no mercado`,
"label.salescloud.salesdashboard":`Painéis de vendas`,
"message.summaryconditionrepeated":`Desculpe, condições sumárias duplicatas, por favor, re-selecione!`,
"label.tianyancha.h5.companycode":`Código da empresa`,
"label.quickbooks.description":`Mantenha o controle de suas faturas, pagamentos e estimativas QuickBooks Online.`,
"label.colombia.time":`Tempo Colômbia`,
"label.usermanage.unknown.license":`Licença inválida, e você não pode criar novos usuários, por favor entre em contato com seu administrador.`,
"label.operatedata.selectoperateandobject":`Selecionar operação (Importação ou Exportação) e objetos`,
"message.setup.field.picklist.valuerepeated":`Os valores da lista não podem ser repetidos, favor entrar novamente.`,
"label.editerror.list":`A lista de dados não foi editada.`,
"pagecreator_page_message_save_success":`Página salva com sucesso`,
"label.icon.154":`Computador`,
"label.emailsync.setting":`Configurações pessoais de e-mail`,
"label.startuploadfile.step2":`Passo 3 Clique em "start upload" para carregar os arquivos`,
"label.dashboard.notmeet.conditions":`Nenhuma informação correspondente foi encontrada e o painel de controle não foi configurado.`,
"label.temp.del.conf":`Você tem certeza de que quer apagar?`,
"label.sms.authkey":`Senha de Autenticação`,
"lable.oppt.jieduan.choosejieduan":`Selecione a etapa fechada`,
"label.tabpage.viewNamez":`Por favor, digite o nome da vista`,
"label.totalQuotation":`Total da Cotação`,
"label.tabpage.hoursagoz":`Horas`,
"label.receiveadminnews":`Receber a transmissão de notícias da Administrator's News Broadcast`,
"label.field.is.lookup":`O campo é ralado ao campo de pesquisa?`,
"label.any_changes":`Qualquer mudança feita aqui também atualizará seu rodapé em`,
"lable.products.to.assets":`Confirmar a transferência do produto para o ativo?`,
"label.dashboard.compare":`Comparação`,
"vue_label_chatter_notice1":`Após a exclusão do grupo, todas as informações do grupo serão excluídas, mas os arquivos do grupo não serão excluídos.`,
"label_tabpage_exitz":`Logout`,
"label.potentialcustomerflow":`Processos de Leads`,
"label.longtext":`Área de texto (Longo)`,
"october":`Outubro`,
"label.customer.email":`Email`,
"label.partnerCloud.productSet.addChildren":`Adicionar Subnível`,
"label.defaultline.cannot.greater":`O número padrão de linhas não deve exceder 30.`,
"front-detail-module-v1-view-report":`Ver Relatório`,
"label.knowledge.setting.hint.sixteen":`Economize conhecimento e continue a transmitir`,
"label.page.use.merged.field":`Com o Merge Field`,
"label.salescloud.salescloud.continuerecover":`se continuar, a eliminação será feita e descoberta`,
"front-project-module-v1-from-template-create":`Criar a partir do modelo`,
"label.exportall":`Exportar todos os Registros de todos os Objetos`,
"label.weixin.recalculate.shared.results":`Recalcular os resultados das regras de compartilhamento`,
"label.components.isTemplate":`Dados do modelo`,
"label_emailsync_status":`Status do e-mail do usuário`,
"label.file.library.delete":`Você tem certeza que quer apagar {librayrname}？`,
"label.integrations.username":`Nome de usuário`,
"front-lightningset-module-v1-detail-page-report-chart":`Gráficos de relatórios na página de detalhes`,
"label_tabular":`Layout da lista`,
"label.approverecords":`Aprovar`,
"vue_label_helpcenter_topic":`Versão Relâmpago Uso e Ajuda`,
"label.h5.date.none":`Nona `,
"lable.outlook.mcto.allrecord":`Todos os Registros`,
"label.readandwrite":`Leitura/escrita`,
"label.allfold":`Colapsar tudo`,
"AD":`Endereço`,
"message.custom.field.donotdelete.reporttype":`O campo é referenciado pela fonte de dados do relatório`,
"label.escalation.setup.newaction.title":`Ação de Escalação Editar`,
"label.dashboard.snapshot.settings":`Configurações de instantâneos do painel de controle`,
"label.attendance.inner":`Trabalhador de escritório`,
"chatter.ns":`Nova mensagem`,
"label.validate.nowork":`Erro: campo inválido, favor re-selecionar o local da mensagem de erro.`,
"label.custom.EmptyCanvas":`Tela transparente`,
"label.service.miniProgram.fillImageOrder":`Favor entrar o pedido de carrossel.`,
"label.icon.16":`Serviço`,
"label.selected":`Selecionado`,
"component_chatter_link_label_name":`Nome do link`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Hora de início preferida`,
"label.file.uploadNewVersion":`Carregar nova versão`,
"chatter.group.theMembership":`Filiação`,
"label.knowledge.recommended.articles":`Artigos sugeridos`,
"label.appupload.install.parentobj":`Objeto principal`,
"label.file.recent":`Recentes`,
"vue_label_helpcenter_quote":`A cotação representa o preço sugerido para os produtos e serviços de sua empresa. Você pode criar cotações a partir de oportunidades e seus produtos.<br>?No canto superior direito das informações detalhadas, você pode usar o botão para sincronizar a cotação da oportunidade comercial, ou sincronizar a cotação com a oportunidade comercial. Quando a cotação é sincronizada com a oportunidade, quaisquer alterações na linha de cotação serão sincronizadas com o produto da oportunidade, e vice-versa. Cada oportunidade de negócios pode ter múltiplas cotações associadas, qualquer uma delas pode ser sincronizada com a oportunidade de negócios.<br>?No canto superior direito das informações detalhadas, você pode gerar pdf e visualizar a cotação, e você pode imprimir, baixar ou salvar diretamente.`,
"message.error.field.default":`O valor padrão deve ser um número inteiro positivo.`,
"label.campaignmember.main.importmember.contacts.desc":`Importar contatos da campanha a partir de arquivos.`,
"vue_label_calendar_show_only_this_calendar":`Mostrar apenas este Calendário`,
"vue_label_quot_syncfrom":`Sincronização a partir de oportunidades de negócios`,
"label.data.expnode.e_desc2":`2. Exportação por modelo: os usuários podem selecionar o modelo para exportar dados.`,
"label.login.verification.mfa.desc1":`Você deve instalar uma aplicação de AMF em seu dispositivo inteligente para continuar. As aplicações comuns que suportam AMF em dispositivos inteligentes são: Onions, Google Authenticator.`,
"label.jiandangfenpei.desc":`Atribuir o acesso da página personalizada atual ao perfil. Os administradores têm acesso a todas as páginas personalizadas.`,
"label_tabpage_thisrecord":`Este registro`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Valor do Rollup Receipts`,
"message.error.object.notvalidcurrency":`Moeda inválida`,
"label.edit.discount":`Editar Desconto`,
"label.setup.mobile.offlinecache.setenable":`Habilitar a função off-line do lado móvel`,
"UG.ST.005":`Já está, não me mostre esta página novamente e faça o login direto na próxima vez.`,
"label.assignedapprover":`Aprovador Designado`,
"template.chart.htlx":`Estatísticas do tipo de contrato`,
"scope":`Dentro do escopo`,
"label.workmate.search":`Buscar colegas`,
"message.validation.isnotdigits":`Por favor, digite o número inválido`,
"label.ccpeak.use.class.time.page":`Se a classe for chamada por uma página personalizada, chamar o método invoker() na classe PageClsInvoker.`,
"setup_mainpage_label_welcome27":`A plataforma CloudCC fornece funções como importação, exportação, exclusão de lotes e transferência de lotes de todos os dados de objetos do sistema.`,
"front-epwechat-module-v1-epwechat-integrate":`Integração WeCom`,
"label.file.publiclink":`Link público`,
"front-epwechat-module-v1-input-name":`Por favor, digite o nome da empresa`,
"lable.Number.of.columns":`Colunas`,
"message.error.dev.service.duplicateparameter":`Parâmetros de serviço duplicados.`,
"label.projectManagement.percent.complete":`Porcentagem de Conclusão`,
"label.chatter.nextSevenday":`Próximos 7 dias`,
"chatter.feed.myfollowers":`Meus seguidores`,
"label.bacchtransfer.pleaseselecttouser":`Transferir para`,
"label_partner_workspace_member_memo":`Todos os usuários com perfil selecionado e conjunto de permissões podem acessar esta nuvem de parceiros.`,
"label.marketsea.chosen.member":`Membros selecionados`,
"label.marketsea.assignment.setup":`Configurações de alocação`,
"label.myaccount":`Minhas contas`,
"label.schedulejob.setup.schedule.executedate":`Executar o tempo`,
"label.uploadaccessory":`Upload do anexo`,
"Homepage.News.004":`Nenhuma notícia recente.`,
"label.marketsea.name":`Nome do grupo de chumbo`,
"label.pending.task":`Tarefas abertas`,
"label.report.details":`Detalhes`,
"UG.homepage.008":`Compreender a situação atual dos negócios (briefings de vendas, quadros de liderança, funis de vendas, etc.), visualizar oportunidades de negócios que podem ser problemáticas, prever o desempenho futuro, aceitar e designar questões importantes em tempo hábil, e tomar decisões informadas.`,
"label.h5.similar.opportunity.clear.all":`Limpar tudo`,
"label.tabpage.noz":`Não`,
"label.report.recent.all.reports":`Todos os relatórios`,
"vue_label_lead_to_score":`Clique em Pontuar para pontuar leads na visão atual.`,
"vue_label_normal_receivable_sf":`Recebíveis`,
"label.layout.edittabdistribute":`Layout da aba Editar`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(campo)`,
"label.salescloud.field.editoptionlist":`Edição da lista de picking`,
"APPIntegration.Dropbox.01":`Selecione arquivos da Dropbox`,
"label.campaign.channel.step2":`Passo 2: Configurar os valores padrão do campo de chumbo deste canal de marketing`,
"label_partner_new_function":`Descrição da função`,
"vue_label_chat_no_search_results":`Nenhum resultado de busca`,
"vue_label_commonobjects_detail_visitstate":`Estado de visita`,
"label.sendemail.send.testemail":`Este é um e-mail de teste, se você pode receber este e-mail, você pode usar esta caixa de correio para enviar e-mails.`,
"label.attendance.clear.position":`Pontos de referência claros`,
"chatter.write.n":`Comentário sobre este post`,
"label_chatter_sendmail":`Enviar e-mail`,
"label.remindertime":`Tempo de lembrete`,
"label.app.elegantgray":`Cinza Elegante`,
"label.tabpage.ownedz":`Totalmente`,
"label.select.approval":`Selecione o autorizador`,
"UG.Lead.007":`Sincronização com o Google`,
"chatter.emailSetUp":`Meu CCChat Lembra a configuração`,
"label.default.censor":`Examinador por defeito`,
"vue_label_notice_uploadavatar_success":`Avatar carregado com sucesso`,
"label.sms.title":`Informações sobre a interface SMS`,
"front-console-choose-contact":`Escolha Contato`,
"label.field.edit.des":`A pontuação mais alta mostra mais ícones estelares, e a pontuação máxima é 100.`,
"label.pw.big.letter":`Caixa alta`,
"label.select.time.dimension":`Favor escolher a dimensão de tempo`,
"UG_Campaign_004":`Campanha de importação`,
"label.dashboard.summary":`Métrica`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Nome da regra de pontuação de chumbo`,
"vue_label_calendar_object_name":`Nome do objeto`,
"label.icon.69":`Máquina`,
"label.reporttotal":`Totais`,
"lable.SalesCommitmentKanBan.theActualContract":`Valor real do contrato`,
"label.project.member.data":`Este usuário já é um membro do projeto atual!`,
"label.cloudccclass.list.viewremark":`Ajuda para esta página`,
"label.deleteObject.isNotAdministrator":`Você não é um administrador e não pode apagar objetos.`,
"lable.edit.queue.nameandemail":`Nome da fila e endereço de e-mail`,
"label.recordtype.tabname":`Tipos de registros`,
"label.file.is.ok":`Está tudo bem?`,
"label.knowledge.language.german":`Alemão`,
"label.layout.realityapprover":`Aprovador real`,
"label.ems.with7day":`Dentro de 7 dias`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Criado`,
"label.weixin.edit.polls":`Mudança de voto`,
"label.layout.mobile.default.tab":`Selecione o padrão na guia Mobile App`,
"vue_label_report_deletegroupcolumn":`Eliminar coluna de grupo`,
"label.group.archived.success":`Arquivo com sucesso`,
"label.customfields.formula.returntype":`Tipo de Retorno de Fórmula`,
"label.file.followers":`Seguidores`,
"label.textmessage.new.templates.message1":`O nome do modelo não pode ser empty！`,
"label.selected.field.length":`Não mais que 10 fileds selecionados`,
"ObjectDetailed_ViewKeyInformation_Layout":`Editar informações-chave`,
"label.paging.totalofpage":`Um total de {0} páginas`,
"label.ccchat.message.new.error41":`Para falar com mais pessoas, tente usar grupos`,
"message.recordtype.detail.noselectlist":`Nenhuma lista de seleção pode ser exibida`,
"label.conditiontag.lookup.title":`Selecione os valores da lista de seleção abaixo para adicionar.`,
"label_partner_setup":`Configurações de nuvens de parceiros`,
"front-epwechat-module-v1-android-packname":`Nome do pacote Android:`,
"lable.custom.Current.CY":`CY atual`,
"label.newprocess2.desc":`Se o desconto for maior que 0,3%, avalia-se como verdadeiro.`,
"label.operatedata.selectobjectfields":`Selecione os campos do objeto exportado`,
"report_reportdatasource_label":`Fonte de dados do relatório`,
"label.chosesubject.others":`Outras atividades`,
"label.list.desc2":`Você pode gerar uma página de PC para acesso ao lado do PC ou uma página móvel para acesso a dispositivos móveis.`,
"vue_group_several_groups":`grupos {totalSize}`,
"label.page.button.linkurl":`Botão ou Link URL`,
"show.week":`Mostrar Fim de Semana`,
"label.gotocalendar.new":`Ir para o calendário e criar eventos`,
"button.reset.advancedsearch":`Limpar condições de busca avançada`,
"label.h5.chatter.feedandcomnum":`Enviar e deixar uma mensagem`,
"lable.opppdt.addpdt.table.unitprice":`Preço de venda`,
"label.dataimport.validate":`Selecione a verificação a ser executada`,
"label.lead.score":`Pontuação de chumbo`,
"vue_label_help_product":`Folheto de produtos e preços`,
"label.role.select":`Selecione os papéis`,
"lable.opppdt.selPdt.searchproduct":`Encontrar produtos`,
"component_event_label_newevent":`Novos eventos`,
"front-invoice-online-payment-setup-configure-button":`Configurar agora`,
"label.stdashbord.xsld.business.img2":`Quantidade total de estágio de oportunidade com 1%-99% de probabilidade`,
"label.event.moveup.2week":`2 semanas à frente`,
"label.partnerCloud.priceOfManual.allCustomer":`Todas as contas`,
"lable.account.dep":`Clique no botão Novo para definir um novo ano fiscal.`,
"label.dataimport.insertdata.error.null.update":`O valor de $schemefield_name$ neste registro é nulo e não pode ser atualizado. O registro ignorou a importação`,
"label_component_helper_businesschange_0activity":`30 dias sem nenhuma atividade`,
"lable.account.NextbbDays":`Próximos 60 dias`,
"label_scope_length":`Alcance-Comprimento`,
"label.customfields.operation":`executar uma exportação de dados`,
"serviceappointment.save.workorder":`Favor escolher uma ordem de trabalho associada ao item da linha de ordem de trabalho.`,
"label.field.update.hide.editor":`Esconder Editor de Fórmula`,
"button.partner.new":`Nova nuvem de parceiros`,
"label.stdashbord.xsld.business.oppdetails":`Detalhes da Oposição`,
"message.pleasewaitingnextversion":`Esta característica estará disponível no próximo lançamento.`,
"label_tabpage_potentialcustomersz":`Líderes`,
"label_emailtocloudcc_step2":`Etapa 2`,
"label.weixin.username":`Nome`,
"label.quickbooks.viewlist.type":`TIPO`,
"front-kefu-moudle-v1-Select-seats":`Escolha o Agente`,
"label.customsetting.manage":`Gerenciar`,
"label.tabpage.field":`Campo`,
"label.custom.page.button.icon.URL":`Botão Ícone URL`,
"font-evaluate-module-v1-evaluation-link":`Adicionar link de avaliação:`,
"vue_label_salesfunnel_notice3":`Quantidade de oportunidades de negócios com uma probabilidade de 1% - 99%`,
"front-email-payment-describe":`Obrigado por seu apoio aos nossos negócios. Você pode pagar online através do seguinte link, e visualizar, imprimir e baixar faturas em formato PDF.`,
"label.productsales.today.noevttskaddevt":`Não há eventos abertos e tarefas expirando, você pode clicar em " " no canto superior direito para adicionar um novo evento.`,
"component.setup.iframe.label.memo":`Clique no ícone de configurações e digite o endereço url incorporado.`,
"front-email-payment-select-country":`Favor entrar no país`,
"label.ems.starred":`Correios estrelados`,
"component_setup_label_object":`Objetos`,
"label.query.detail.viewpartneruser":`Ver usuário parceiro`,
"this.year":`Este Ano`,
"serviceresource.isactive.notactive":`Este serviço não está habilitado.`,
"label.marketing.message.recipientisnull":`O destinatário não pode estar vazio`,
"label.unfold":`Expandir`,
"label.service.assetBOM.view.tip":`Você não tem a permissão para visualizar a lista técnica de bens. Favor entrar em contato com o administrador.`,
"label.validate.function.funcExplain.ISCHANGED":`Verifique se o valor do campo é diferente do valor anterior. Caso contrário, retorne VERDADEIRO, caso contrário retorne FALSO.`,
"label.validate.function.funcExplain.NOW":`Retorna uma datat e ime representando o momento atual`,
"label.phoenix.islands.time":`Fênix é. Hora`,
"vue_label_checkduplicate_complete_filter_rules":`Favor completar as condições do filtro`,
"vue_label_report_rowcount":`Contagem de filas`,
"chatter.p":`pessoa`,
"label.umeng.activity.distributetask":`lhe designou uma tarefa.`,
"UG_quota_05":`Bisync com Oportunidades`,
"june":`Junho`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Terça-feira`,
"vue_label_commonobjects_view_chart_upto5":`Até 5 grupos`,
"vue_label_opportunity_contactrole_searchallcontacts":`Pesquisar todos os contatos`,
"label.custom.field.task.notice":`Notificação de tarefas`,
"label.weixin.insert.address":`Inserir local`,
"label.attachementNew.desc":`Arquive o anexo a um documento, e o anexo não pode ser apagado.`,
"setup_mainpage_label_welcome18":`As configurações de permissões de nível empresarial do CloudCC permitem controlar os direitos de uso de usuários individuais enquanto trabalham com dados e módulos. As configurações de permissões baseadas em funções também incluem posições de usuários, grupos, funções, regras de compartilhamento de dados e controles de segurança em nível de campo para permitir o compartilhamento de dados entre diferentes pessoas e departamentos da empresa.`,
"front-kefu-instance-noarea":`Nenhuma instância foi criada para esta área, favor selecionar novamente`,
"label.please.ChooseMax":`Por favor, escolha até {a} opções de produtos.`,
"label.businesschance":`Oportunidades`,
"label.verticalline-group":`Colunas Verticais - Agrupamento de Colunas`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Favor selecionar Livro de Preços`,
"vue_label_norm_addcomponent":`Novo Componente`,
"label.ServiceCloud.Installation.address":`Endereço de instalação`,
"vue_label_report_groupcolumn":`Coluna do grupo`,
"label.ccchat.person.invite.notallsucc":`{0} os endereços de e-mail foram salvos mas não enviados. para enviar um convite, corrigir o seguinte erro e clicar em enviar.`,
"label.customfields.optionlist.tip":`Permite aos usuários selecionar um valor a partir de uma lista que você define.`,
"UG.activity.07":`Criar uma tarefa`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Último`,
"label.permission.accessname":`Nome de acesso`,
"lable.custom.year.stadate":`Data de início do ano personalizado`,
"label.ems.inputmails":`Receber servidor de e-mail (i)`,
"label.cpq.quote.transfer.order.already":`Esta citação é transferida para encomenda. Favor apagar o pedido original e, em seguida, regenerar um pedido.`,
"label.sendletter.status":`Status de membro da campanha`,
"vue_label_commonobjects_view_save_as_view":`Salvar como vista`,
"message.mobilechooseatmostfive":`Selecione até 5 campos`,
"label.errormessage.batchedit.nopermission":`Nenhum registro de dados que você tenha permissão para editar.`,
"label.dataoperate.tip":`Selecione a operação e os objetos.`,
"label.enableoperate":`Ações disponíveis`,
"label.ems.usernamepassword.error":`Erro na conta da caixa postal ou na senha.`,
"label.campaignmember.selectmember.deletemember":`Retirar membros de`,
"label.Tab":`Tabs`,
"label.emailobject.template.message1":`Favor selecionar um campo e clicar em "Inserir". Com o ">" significa clicar para ver mais campos disponíveis.`,
"label.approvalstep3.tip":`Especifique o usuário que deve aprovar os registros que entram nesta etapa. Opcionalmente, escolha se o delegado do aprovador também está autorizado a aprovar estas solicitações.`,
"label.inusing":`Ativo`,
"label.edit.select.tre":`Lista de caixas de seleção`,
"label.appointmentconfirmail.wizard.title1":`Olá {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Configurar o Alipay`,
"lable.edit.queue.avobj":`Objetos disponíveis`,
"vue_label_checkduplicate_verify_all_characters":`Verificar todos os caracteres`,
"label.huntingzone":`Faixa de busca`,
"label.request.approved":`O pedido foi aprovado, não se repita.`,
"label.sharerule.msgerror":`Erro interno do servidor`,
"front-epwechat-module-v1-tick-unbound":`Por favor, assinale e aceite as informações acima não vinculativas`,
"label.console.step6":`Passo 6 Escolha como as listas são exibidas`,
"label.multilang.micropost.vote":`{0} bilhete(s)`,
"message.error.appid.null":`A chave secreta não pode ser nula!`,
"lable.product.delq":`Eliminar Questões`,
"label.h5.approval.leixing":`Tipo de aprovação`,
"label.edit.field.select.style1":`Telha cada opção`,
"label.passwordPolicy.setup.alpandnum":`Deve misturar caracteres alfa e numéricos`,
"label.ems.close2":`Fechar`,
"label.report.reporttypetitle":`Fonte de dados`,
"label.umeng.approval.approvalsuccess":`foi submetido para aprovação.`,
"label.page.showamount":`Total de registros por página:`,
"label.copy.asset.successfully":`Copiar a lista técnica de ativos com sucesso.`,
"vue_label_homepage_bigscreen_dark":`Escuro`,
"vue_label_email_selected_members":`Membros selecionados`,
"label.file.preview":`Pré-visualização`,
"label.partner.new.step3.name":`Nome`,
"label.forecast.settings.periods.ago":`ciclo(s) atrás`,
"label.evaluation.praise":`Bom`,
"label.cloudccsite.edit":`Edição do site`,
"label.knowledgebase.advanced.filtering":`Filtro avançado`,
"label.knowledgebase.framework":`Moldura`,
"vue_label_pool_ownedpool":`Piscina principal`,
"label.exchange.sync.setting.license":`Com este recurso habilitado, alguns de seus dados organizacionais podem ser salvos no servidor Microsoft Exchange em forma de implantação interna ou de base em nuvem e processados através do servidor Microsoft Exchange.`,
"front-console-conversation-btn2":`Resposta por email`,
"label.projectManagement.thelastone":`Este é o último registro.`,
"message.duplication.confirmscript.mergeoperation":`Estes registros são fundidos em um único registro através dos valores selecionados. Nota: a ação de fundir não pode ser revogada. Você tem certeza de que quer fundir os registros?`,
"lable.outlook.detail.nosyn":`Fora de sincronia`,
"label.iscopy":`Permitindo cópia`,
"message.matrixReportSetupStage.row":`Favor selecionar 【Specify Linha Headers】 base subtotal, e você deve selecionar uma base subtotal pelo menos em duas bases subtotal.`,
"label.forecast.forehistory.possibility":`Probabilidade`,
"label.timetrigger.validate":`O valor inserido deve ser um número inteiro positivo, e o sistema executará automaticamente as ações de fluxo de trabalho quando o número inteiro deve ser positivo, que é o momento em que a dependência do fluxo de trabalho é atendida, o sistema executará automaticamente a operação de fluxo de trabalho.`,
"member.name.choice.field":`O nome do membro é um campo obrigatório !`,
"label.undone_external page":`Isto é irreversível, portanto, por favor confirme. Este formulário não é usado em nenhuma página de login, mas pode ser usado em outro lugar. Por exemplo, você pode ter usado o código embutido para inserilo em uma página externa.`,
"UG_Lead_012":`Pistas de importação`,
"component_chatter_label_fans":`Seguidores`,
"label.systeminfo":`Informações do sistema`,
"label.mr.descreption.oneGroupNote1":`Selecione pelo menos dois dados e clique em [Load Selected Information] para saltar para a página de fusão de dados.<br>Esta é a página`,
"label.wtd.changefields.selfields":`Selecione os campos a serem incluídos em seu formulário Web-to-CloudCC:`,
"message.error.fileinfoid.null":`fileinfoid não pode estar vazio! Informações do arquivo id`,
"label_tabpage_cownerz":`Mudança de proprietário`,
"setup_layout_button_save":`Salvar`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Ordem`,
"button.partner.start":`Comece a usar`,
"label.htyj.remark1":`Sua edição atual não suporta a visualização do objeto do contrato`,
"component.event.label.person":`Pessoa designada`,
"label.appointmentconfirmail.wizard.subtitle3":`Localização`,
"label.emailtocloudcc.filed.username":`Endereço de e-mail`,
"label.vlidaterule.remark":`Definir uma regra de validação especificando uma condição de erro e uma mensagem de erro correspondente. O usuário pode corrigir o erro e tentar novamente.`,
"message.duplication.label.insertoption":`Ação em Criar`,
"front-web-module-v1-detail-comment-toast":`Por favor, complete todas as avaliações`,
"label.import.page2.notsuitedfiledwillbenotimport":`Aviso: O sistema não importará campos não mapeados`,
"label.h5.similar.opportunity.enable":`Possibilitar oportunidades similares`,
"label.allunfold":`Expandir tudo`,
"component_setup_iframe_label_inputurl":`Digite o endereço url`,
"label.manage.all":`Gerenciar tudo`,
"label.mobile.side.tab.cs":`Funções comuns`,
"label.datamanage.contact.information":`Informações de contato`,
"lable.outlook.edit.sel":`Selecione um valor`,
"label.imgfield.type.url.tip2":`Por exemplo: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Propriedades da Seção`,
"label.date":`Data`,
"vue_label_commonobjects_detail_openfilter":`Expandir o filtro`,
"label.loginip.pagecue":`Insira a gama de endereços IP válidos a partir dos quais os usuários com este perfil podem fazer o login.`,
"vue_label_email_not_valid":`O e-mail que você inseriu não é um endereço de e-mail válido`,
"label.page.step5.add.application":`Passo 5 Adicionar aos aplicativos personalizados`,
"label.dashboard.donot.delete":`Você não pode apagar esta pasta porque alguns painéis de controle nela estão contidos.`,
"label.visitAPPexchange":`CloudCC App Store (Nova Janela)`,
"label.generate.location":`Gerar dados de latitude e longitude do cliente.`,
"lable.quote.syncing.syncingbutton":`Sincronia:`,
"label.pw.error.text":`As duas senhas que você digitou não correspondem.`,
"label_partner_setup_Enable":`Verifique`,
"label.file.preview.unav":`Pré-visualização não cavalgáveld`,
"label.sms.tip":`Da Internet`,
"setup.mainpage.label.welcome21":`A plataforma CloudCC fornece a função de modelo de e-mail definido pelo usuário, que é conveniente para os usuários usarem e melhorarem a eficiência do trabalho.`,
"label.trigger.for.example":`Por exemplo: atualizar a oportunidade no gatilho de atualização da conta, atualizar o gatilho de atualização da conta na oportunidade e acionar o gatilho de atualização da conta. Se não houver controle condicional no gatilho, então o sistema permite até 3 chamadas circulares deste tipo.`,
"setup.layout.button.layoutprop":`Adequações`,
"component.chatter.label.fans":`Seguidores`,
"lable.PowerProcess.event.edit":`Editar Marco`,
"label.detailintro":`Itens de linha Descrição`,
"vue_label_report_nosearchresults":`Nenhum resultado de busca`,
"error.name.repeat":`O nome não pode ser repetido.`,
"label.emailEncoding":`Codificação de e-mail`,
"label.partnerCloud.financeSetting.enableAccount":`Ativar Conta de Rebate`,
"label_emailtocloudcc_clear":`Limpar`,
"setup_mainpage_label_welcome12":`O usuário pode completar a definição do relatório clicando no mouse, sem programação, e seguindo as etapas de solicitação do sistema. O sistema tem um relatório de lista, um relatório de resumo e um relatório de matriz para escolher. Opções de exibição para todos os campos também estão disponíveis. Remover informações desnecessárias sobre os campos. Ao mesmo tempo, ele fornece uma variedade de exibições gráficas incluindo tiras, linhas de dobra, anéis, funis e bolos, para que os usuários possam ver de relance.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Data de início do contrato`,
"front-starter-v1-potential-customer-tips-success":`Ativar o pool de chumbo com sucesso`,
"UG_Forcast_02":`As previsões são estimativas de vendas esperadas para um determinado período, e os modelos de previsão podem ajudá-lo a determinar a demanda do produto e a receita de vendas em um determinado período. Os gerentes podem usar previsões para estabelecer metas e medir o progresso da equipe. A previsão geral da organização pode refletir o resumo de todas as vendas por representante de vendas (independentemente do estágio de conclusão das vendas desde o estágio de pipeline até o estágio fechado).`,
"label.escalation.setup.detail.ruleentries":`Inscrições de Regras`,
"lable.SalesCommitmentKanBan.allComplete":`Montante total completo`,
"label.appupload.install.apicanuse":`O nome api está disponível`,
"label.organiza.field":`Campos de organização`,
"button.partner.workspace.manage":`Administração`,
"lable.PowerProcess.setevent":`Marco Marco histórico`,
"label.emailobject.groupemail.msg2":`Falta o endereço de e-mail. Isto evitará que o e-mail seja enviado a este recibo.`,
"label.h5.orderbyname":`Ordenados pelo nome`,
"vue_label_salesadvance_opportunities":`Número da oportunidade`,
"label.appointment.disable.cancel":`Desativar Cancelamento`,
"label.trigger.folder.edit":`Página de ativação : Edit Folder`,
"label.customfields.new.step2.opration.unique.info.v2":`Tratar "ABC" e "abc" como valores diferentes (sensível a maiúsculas e minúsculas)`,
"label.icon.40":`Posicionamento`,
"label.eventmenuandlink":`Botões de evento e links`,
"label.service.gantt.candidate":`Candidato`,
"label.top.userphoto":`Foto do usuário`,
"label.appointmentconfirmail.wizard.btn2":`Cancelar reunião`,
"label.print":`Imprimir`,
"saveandreturn":`Salvar e Voltar`,
"lable.account.CurrentandNextCY":`CY atual e CY seguinte`,
"label.group.no.recent1":`Você não visualizou nenhum grupo ativo.`,
"lable.Asset.conversion":`Gerar ativo de acordo com a "Transição de Ativos" do produto do pedido ao transferir ativos.`,
"label.emailtocloudcc.button.sure":`Confirme`,
"label.Path.List":`Lista de caminhos`,
"label.please.rule.name":`Por favor, digite o nome das regras.`,
"label.knowledge.category.hint.six":`Grupo de categorias disponíveis`,
"setup_mainpage_label_welcome28":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Gerenciamento de Dados → Importação e Exportação de Dados, Transferência de Lote, Excluir Lote.`,
"vue_label_commonobjects_view_chart_editchart":`Editar tabela`,
"label.permission.detail.app.object":`Configuração do objeto`,
"label.multilang.totalpage":`de`,
"label.marketsea.button.return":`Retornar`,
"Click.to.load.more":`Clique para carregar mais`,
"label.validate.globalvariable":`Variável Global`,
"label.marketsea.iseditseabymanager":`Permitir que os administradores mudem o grupo de liderança ao qual pertence.`,
"label.price.yuan":`Preço (Yuan)`,
"label.service.resource.uesr.tip":`Selecione um usuário para criar recursos de serviço e o tipo de recursos não pode ser tripulação.`,
"vue_label_help_viewusageguide":`Veja o guia do usuário da versão Relâmpago`,
"label.autoRegister.changepwd.setpwd.too.long":`Demasiado longo`,
"label.campagin.roi.fwsl":`Número de visitas`,
"label.campaign.mobile":`Aplicação móvel`,
"UG.Lead.012":`Pistas de importação`,
"link.recordtype.detail.backtoobject":`Voltar para Objetos Personalizados`,
"front-kefu-moudle-callcentrt-hasclose":`O Call Center Fechou`,
"label.category.5":`TI Alta tecnologia`,
"label.import.page1.selectwayofdealdata":`Selecione o modo de processamento de dados`,
"chatter.emailReceiveEmail":`Receba o lembrete CCChat`,
"vue_label_file_manage_lib_members":`Gerenciar os membros da biblioteca de arquivos`,
"label.appupload.upload.overview":`Recapitulação`,
"label.service.miniProgram.inputNumber":`Favor preencher um número dentro de 0-999.`,
"label.emailtemplate.finishdetailinfo":`Preencha os detalhes do modelo de e-mail.`,
"label.weixin.fmu.before.day":`{0} dias antes`,
"label.integrations.login":`Login`,
"label.dashboard.setUpHomePage":`A página inicial foi configurada para exibir`,
"label_partner_common_webSit":`Domínio`,
"front-epwechat-module-v1-unbound-user":`Usuários não vinculados`,
"label.partnerCloud.basicSetting.offline":`Ativar o pagamento offline`,
"label.start.loginip":`Endereço IP inicial`,
"label.projectManagement.delete.subtasks":`Todas as informações relacionadas a esta subtarefa também serão apagadas se você apagar esta subtarefa, e os dados não poderão ser recuperados. Você tem certeza de confirmar a exclusão?`,
"label.message.batchapp":`Aprovação em massa`,
"message.duplication.label.ruletitle":`Regras duplicadas`,
"label.all_networks":`Toda a rede`,
"label.select_columns":`Selecione as colunas que você gostaria de ver para o envio de seu formulário`,
"vue_label_notice_uploadavatar_exceed":`O tamanho da imagem do avatar carregado não pode exceder 2MB`,
"message.error.get.failed":`Falha em obter informações!`,
"label.quickbooks.viewlist.duedate":`DATA DE VIGÊNCIA`,
"label.ccchat.topic.search":`Tópico de busca`,
"label.forecast.shre.manager":`Atribuição de Gerente`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Quinta-feira`,
"lable.product.pricebooks.copy":`Clone do Livro de Preços Existentes`,
"label.instrumentPanel.minLabelname":`Este valor deve ser positivo e menor que o valor do ponto de parada 1.`,
"front-market-form-createdsecond":`Campo de preenchimento automático na página de registro`,
"label.submission_detail":`Detalhe da submissão`,
"label.customfields.checkbox.tip":`Permite aos usuários selecionar um valor Verdadeiro (verificado) ou Falso (não verificado).`,
"label.escalation.setup.list.description":`Você pode determinar automaticamente as ações quando os casos cumpriram os critérios e além do tempo especificado. Ao escalar um caso, você pode optar por notificar automaticamente o usuário e reatribuir o caso a um novo usuário.`,
"UG.Forcast.05":`Configurações de previsão: passo {0}/{1}`,
"label.data.import":`Importação de dados`,
"label.upload.error.cause":`o upload falhou devido a`,
"label.search.change.remark":`Aplica-se às configurações dos objetos exibidos na barra de busca no lado esquerdo da página inicial`,
"serviceappointment.edit.status.limitwithstatus":`O status da nomeação de serviço não pode ser alterado de {0} para {1}.`,
"label.department.operation":`Operação`,
"label.textmessage.vonage.message3":`Para procurar por API Key e API Secret, você pode fazer login em sua conta Vonage API e ir para "Settings" sob seu nome de conta. Para procurar os números de telefone que você tem em sua conta Vonage API, você pode ir para Numbers em Products, e clicar em "Your numbers" para ver todos os números de telefone que você tem.`,
"label.privacystatement.dialog":`Declaração de privacidade (Nova janela)`,
"label.datamanage.import.leadfield":`Na lista a seguir, selecione os campos no arquivo de importação que devem importar leads. Em seguida, clique em próximo:`,
"label.appupload.upload.install.failar":`Instalar Failed`,
"label.viewall":`Ver tudo`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat responde aos Bookmarked`,
"lable.custom.dp":`Esta página permite que você defina anos personalizados.`,
"label.mobile.more.share":`Compartilhar com Colegas ou Grupos`,
"lable.name.cannot.be.empty":`O nome não pode estar vazio`,
"label.autoRegister.changepwd.setpwd.password":`Sua senha`,
"label.multipleactivity.aevents":`Evento(s)`,
"label.many.dayline.lastday":`Último dia`,
"lable.Please.bind.the.QuickBooks.record.first":`Por favor, encadernar primeiro os registros do livro rápido.`,
"vue_no_related_dashboards":`Nenhum painel de controle relevante!`,
"label.newdashboardpage.name":`Nome`,
"vue_label_commonobjects_detail_network":`Rede de Relacionamento`,
"label.tianyancha.reginstitute":`Autoridade de registro`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`O limite inferior de cada nível deve ser igual ao limite superior do nível superior ao fixar os preços por blocos.`,
"label.chat.file.upload.info":`Upload de arquivos`,
"label.appexchange.vlidaterule":`Regras de validação`,
"label.salescloud.salesdashboard.current.business":`Oportunidades atuais`,
"label.app.step4.homeisfrist":`A página inicial deve ser a primeira aba e não pode ser removida.`,
"label.weixin.micro.research.optionname":`Nome da Micro Survey Choice`,
"label.paging.totalofnbsp":`Um total de {0}`,
"label.opportunity.perm.title":`Solicitar acesso`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Erro de verificação do locatário. Favor entrar novamente`,
"label.unsaved_changes":`Se você continuar a operação, as mudanças não salvas serão perdidas.`,
"label_partner_all_description":`Descrição`,
"lable.account.Next.CQ":`Próximo CQ`,
"chatter.feed.menutype.feed.me":`Para mim`,
"label.sourcetranstemp":`Fonte - Produz um arquivo que contém todo o texto que pode ser traduzido`,
"label.apply.newuser.validate":`Registro do CloudCC de novo usuário, código de validação:`,
"label.user.password.error":`Nome de usuário ou erro de senha, ou usuário inválido!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`Nenhum item de linha de cotação é encontrado neste grupo de linha de cotação. Favor clicar em "Adicionar Produto" para adicionar.`,
"lable.PowerProcess.time.filed":`Com base no campo de data e hora no {detailInterestType}`,
"label.file.default.value.is.integer":`Somente números inteiros podem ser inseridos`,
"label.processsetting.please.select.field":`Por favor, selecione os campos.`,
"label.app.step3.introduce":`O tamanho do arquivo de um logotipo de aplicativo personalizado deve ser menor do que 20 KB. As dimensões da imagem devem ter um máximo de 300 pixels de largura por 55 pixels de altura para obter melhores resultados. As imagens maiores serão redimensionadas e podem parecer distorcidas.`,
"button_partner_save":`Salvar`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Páginas personalizadas disponíveis`,
"label.salescloud.teamrole.optionlist.choose.correct":`O mesmo item existe na lista, por favor, modifique.`,
"System_ChangeUser_Info_001":`O proprietário mudou e clique para voltar à página anterior.`,
"front-console-no-contact":`Sem contato`,
"component.assistant.label.overduetask":`Oportunidades com Tarefas Vencidas`,
"label.roleofpartner":`Papel do parceiro`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Você e {0}`,
"front-template-V1-Please-select-a-picture":`Por favor escolha uma imagem`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Taxa de compromisso total assinada`,
"label.h5.similar.opportunity.step2.conment":`Selecione entre 3 e 10 campos ou listas relacionadas para comparar quando encontrar oportunidades similares.`,
"label.projectManagement.alert.frequency.will.not.work":`Quando você seleciona Não, o lembrete não funciona.`,
"vue_label_fllscreen":`Visualização em tela cheia`,
"label.customfields.selectcontainfieldlayout":`Selecione os layouts de página que devem incluir este campo.`,
"label.appointment.wizard.subtitle1-4":`45 min`,
"label.tianyancha.businessverify.unagree":`Discordo`,
"label.unique":`Único`,
"setup_mainpage_label_welcome10":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object → Object Name → Custom Layout.`,
"vue_label_account_subsidiary":`Subsidiária`,
"label.dataimport.format.error":`Erro de formato, favor usar o formato como MM/DD/YYYYY ou YYYY-MM-DD.`,
"label.email.new":`Novo e-mail`,
"label.log.descri":`Descrição da operação`,
"vue_label_dashboard_componentname":`Por favor, digite o nome do componente`,
"label.weixin.quick.reply":`Resposta rápida`,
"label.productsales.payment.badversion":`Sua edição atual não suporta a visualização do objeto do contrato, portanto você não pode visualizar a lista de pagamento.`,
"label.position":`Localização`,
"label.Annex.Conditions":`Adicionar filtros lógicos para condições adicionais （e.g.：1 e 2 ou 3 ）`,
"label_tabpage_endz":`Fim`,
"label.setup.mobile.bottombutton.prompt":`Aviso: Para salvar estas configurações mudará as configurações originais do usuário do aplicativo móvel de primeiro nível.`,
"lable.Edit.template":`Editar modelo de relatório de serviço`,
"vue_label_report_onlydisplay2000":`Exibe apenas 2000 dados`,
"label.salescloud.salesdashboard.sign.account.top5":`As 5 Contas Principais Assinadas`,
"label.weixin.ontime":`Pontual`,
"font-evaluate-module-v1-disappoint":`Desculpe desapontar você!`,
"chatter.sel.addre":`Até 5 destinatários podem ser selecionados!`,
"label.mobile.phone.month.summary":`Resumo mensal`,
"label.partnerCloud.priceOfManual.selected":`Conta selecionada`,
"label.south.georgia.time":`Horário padrão da Geórgia do Sul`,
"label.create.ccdocument":`Adicionar anexo`,
"label.chatter.to":`Para`,
"label.ems.minute":`Ata`,
"label.mobile.phone.submit.tome":`Enviado a mim`,
"label.approvalstep1":`Passo 1 Digite o nome e a descrição`,
"label.h5.similar.opportunity.last.months9":`6-9 Meses recentes`,
"Opportunity_Detailed_Phase_Label_003":`Estágio de mudança`,
"lable.PowerProcess.time.input":`Por favor, digite um horário.`,
"label.stdashbord.xsld.business.yqzsr":`Quantia total esperada`,
"label.icon.64":`Searchlight`,
"label.data.choses.i_desc":`De acordo com suas necessidades, importe dados de um único objeto.`,
"label.integrations.mainlandchinaleads":`China Continental Lidera`,
"vue_label_notice_savemenu_success":`Menu salvo com sucesso`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Escolha o serviço online Easemob`,
"label_chatter_name":`Nome`,
"label.Viewon_Linkedin":`Vista do LinkedIn`,
"lable.PowerProcess.chioce.event":`Por favor, selecione um marco.`,
"component.chatter.file.label.maxsize":`O tamanho máximo do arquivo é de 20m`,
"label.validate.function.funcExplain.SECOND":`Retornar segundo do dia (De campos de data/hora)`,
"label.data.downpage.i.title.num4":`4、If você tem um campo de relação de busca e um campo de relação de mestre-detalhe no objeto que você deseja importar, o valor para esse campo deve ser ID, caso contrário ele é inválido.`,
"label.icon.139":`Moeda`,
"label.app.step4.atleastone":`A guia Home não pode ser removida.`,
"label.weixin.input.telephone":`Favor digitar o número do celular`,
"label.setup.mobile.bottombutton.remark":`Uma organização poderia configurar as configurações iniciais da página de primeiro nível de acordo com o processo comercial.`,
"label.file.searchs":`Arquivos de Busca...`,
"vue_label_email_there_is_no_draft_yet":`Ainda não há rascunho`,
"front-kefu-moudle-v1-bind-seats":`Agente de ligação`,
"label.customfields.lookupmuti.tip":`Cria uma relação que liga este objeto a outro objeto. O campo de relacionamento permite aos usuários clicar em um ícone de busca para selecionar vários valores de uma lista popup. O outro objeto é a fonte dos valores da lista.`,
"label.integrations.password":`Senha`,
"label.data.newtemplate.t_conditions":`Condições do modelo`,
"message.error.repeatsubmit":`A apresentação é repetida ou múltiplas modificações de janela são abertas na mesma página. Se esta última, favor enviar na janela recém-aberta.`,
"label.umeng.approval.approvalreassign":`O pedido de aprovação para o #obj é reatribuído. #objnome`,
"lable.edit.queue.selobj":`Erro: A fila deve ter pelo menos um objeto selecionado`,
"label.compact.layout.frame":`Estrutura da página`,
"label.sms.companyname.dsf.infor":`Este serviço só apóia a China continental`,
"template.report.individual.case.source":`Fonte do caso`,
"pagecreator.button.pcpage":`Pc final`,
"vue_label_commonobject_selectdatatime":`Escolha data e hora`,
"label.icon.181":`Arquivo`,
"label.loginip.setup.please":`Favor especificar a faixa IP.`,
"vue_label_dashboard_?secondarygroup":`Por favor, selecione um grupo secundário`,
"lable.outlook.mcto.pleasedes":`Digite os domínios de e-mail com os quais você não quer se associar e separe-os por ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} envie um e-mail para {1}.`,
"label.sendmail.step4":`Passo 4 Os e-mails que você enviou estão sendo processados.`,
"label.monitorsys.delete.source":`Descrição`,
"label.monitorsys.log.datetime":`Download do registro de auditoria de operações-chave dentro do intervalo de tempo de busca (Excel.xls)`,
"component_chatter_label_myfans":`Meus seguidores`,
"label.tianyancha.h5.registereddate":`Data de registro`,
"label.multilang.feedtrack.operatecreate":`{0} o registro foi created：`,
"label.console.step6.no":`Escolha como as listas são exibidas`,
"four":`Quatro`,
"message.confirmsetpwdforuser":`Redefinir senha para novos usuários?`,
"label.cape.verde.time":`Hora de Cabo Verde`,
"label.queue.new":`Nova fila`,
"label.cloudccsite.start":`Página principal do site ativo`,
"label.data.exp.way":`Método de exportação`,
"label.lock.record.donot.delete":`Você não pode apagar os registros bloqueados.`,
"label_emailtocloudcc_filed_type":`Fornecedor`,
"frame_personinfo_label_minipic":`Imagem em miniatura`,
"label.checkfield.choosetab":`Selecione os campos para encontrar réplicas`,
"component.setup.tabs.label.default":`Página predefinida`,
"page.404.button.toknowmore":`Saiba mais`,
"vue_label_SMS_message_sent_cannot_be_empty":`O conteúdo da mensagem enviada não pode estar vazio`,
"label.lookupreplaceselectvalue":`Encontrar e Substituir a Lista de Escolha`,
"pagecreator_layout_button_new":`Novo layout`,
"label.mobile.more.upload":`Upload de nova versão`,
"front-kefu-moudle-v1-Connection-failure":`A conexão falhou`,
"label.version.support.unlimited":`Suporte Ilimitado`,
"message.error.notmarketseamember":`Não é membro do grupo de liderança`,
"label.taskandincident":`Tarefas e eventos`,
"label.report.export.print.title":`Visualizações de relatórios impressos`,
"label.file.publicview.error2":`O link público não está correto, por favor use um novo link público`,
"label_chatter_cancel":`Cancelar`,
"front-web-module-v1-detail-comment-satisfied":`Nível de satisfação`,
"label.knowledge.delete.topic":`Erro ao eliminar o assunto utilizado neste artigo de conhecimento.`,
"label.forecast.forehistory.all":`Todos`,
"label.displaybutton":`Botões exibidos`,
"label.icon.148":`Robô`,
"label_tabpage_ok":`Confirme`,
"label.checkfield.merge.mainrecord":`Registro mestre`,
"label.notification.arketsea.restored":`{5} restaurado {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Criar Aplicação →`,
"front-kefu-moudle-v1-jtrrt-connect":`Associando os usuários do CloudCC com as extensões do TRRT`,
"vue_label_calendar_please_select":`Favor selecionar o campo exibido`,
"setup.layout.label.pagename":`Nome do layout da página`,
"template.chart.schdywjhz":`Valor da Oportunidade de Campanha`,
"label.access_report":`Quem pode acessar este relatório?`,
"label.assignment.layout.section.optional":`Disponível em`,
"label_chatter_recently":`Recentemente`,
"lable.chat.advanced.setting":`Configuração avançada`,
"label.knowledge.category.hint.eight":`Categoria Grupo`,
"message.error.facebookuid.null":`O ID de usuário do Facebook não pode estar vazio!`,
"label.step5.total6":`Passo 5 de 6`,
"label.is.cancel.delete":`Cancelar a exclusão?`,
"setup_mainpage_label_welcome11":`Relatório personalizado`,
"label.answers":`Respostas`,
"label.approvalstep1.tip":`Digite um nome, descrição e número de etapa para sua nova etapa de aprovação.`,
"template.chart.htjeph":`Valor do Contrato Ranking`,
"label.campaigns.onsiteregistration":`Registro no local`,
"front-epwechat-module-v1-input-agentid":`Favor entrar agenteId`,
"label.emailobject.wizard.desc2":`Rastrear e-mails sendo abertos e horários de abertura`,
"label.multilang.chatterdetial.vote":`{0} bilhete(s)`,
"label.customsetting.manage.value":`Dados personalizados`,
"front-electronic-export-listCount":`{totalVer} dados no total na visão atual, selecione os dados importados`,
"label.dashboard.create.prompt":`Não é possível criar painéis de controle sobre relatórios tabulares.`,
"label_tabpage_askz":`O que você gostaria de perguntar`,
"label.ems.sentmail":`Caixa de saída`,
"label.reportlist.untop":`Não fixo`,
"label.owner.h5.plzchose":`Por favor, selecione o proprietário e salve`,
"label.callcenter.addup.10.pieces":`Adicionar 10 dados no máximo uma vez`,
"label.ccdocument.save":`Salvar documento`,
"label.productcannotnull":`O produto não pode estar vazio`,
"label_tabpage_enabletomobile":`Se a ativação do lado móvel`,
"lable.account.CYAgo":`2 CY Ago`,
"lable.Select.the.returned.high.seas.pool":`Selecione o pool de retorno`,
"tuesday":`Terça-feira`,
"label.partnerCloud.basicSetting.partnerPayment":`Ativar o Fundo de Parceiros`,
"label.validate.function.funcExplain.WEEKDAY":`Devolver um dia específico da semana. 1 representa o domingo e 7 representa o sábado`,
"label.query.detail.manageexuser":`Gerenciar usuários externos`,
"vue_label_systemSettings_environment":`Meio Ambiente`,
"component_setup_tabs_label_delete":`Excluir`,
"label.weixin.delete.ccchat":`Você tem certeza de que quer apagar este post?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`Você pode selecionar até 10 campos como seu critério de busca.`,
"label.project.hit.fourteen":`Aviso de Atualização de Marcos`,
"label.createby":`Criado por`,
"label.moreoperation":`Mais Operar`,
"label.lock.tip":`Bloquear os registros de serem editados`,
"label.check.input.condition.three":`O tipo de fórmula de campo e o resumo de rollup não são suportados para inserção`,
"label.quote.dingjia":`Preços`,
"label.currentuseremail":`O endereço de e-mail atual do usuário`,
"UG_homepage_004":`Automação`,
"chatter.link":`Link`,
"label.new.zealand.standard.time":`Horário de verão da Nova Zelândia`,
"APPIntegration.Dropbox.setting.02":`Deficiente`,
"label.version.searchandmerge":`Verificar Duplicação e Fusão`,
"label.allmenus.showmsg.nomenu":`Não encontrei o menu！`,
"front-template-V1-Enable-disable":`Ativar | Desativar`,
"label.marketing.setting4":`O registro retorna com sucesso à URL padrão`,
"UG.Forcast.07":`Permitir previsão`,
"vue_label_systemSettings_correlation":`Modo de exibição da lista relacionada`,
"label.cloudccsite.remark.length":`Permite que os usuários digitem até 255 caracteres`,
"label.favorite":`Favoritos`,
"template.report.converted.leads":`Leads convertidos`,
"label.campaignmember.main.description":`Use esta página para gerenciar memebers de campanha. Você pode adicionar novos membros à campanha ou atualizar o status atual dos membros da campanha.`,
"label.salescloud.teamrole.account.organization":`Os membros da equipe podem ter um nível mais alto de acesso a esta conta do que as configurações de acesso padrão por sua organização.`,
"label.permission.modifyAppPermission.canselectapp":`Aplicações disponíveis`,
"front-epwechat-module-v1-self":`Instalação de aplicativos autocriados`,
"message.duplication.label.matchexactletters":`Exato`,
"label.appointmentdetail.wizard.title18":`Plano de sexta-feira`,
"label.area":`Territórios`,
"label.sso.saml.sp.username":`Nome de usuário`,
"lable.outlook.new":`Nova Configuração de Sincronização de Troca`,
"label.custom.field.close.conversion":`Fechado - Convertido`,
"lable.outlook.detail.tmaping":`Campos de tarefas do mapa`,
"label.emailobject.emaildetail.nextactivity.event":`Adicionar um evento`,
"vue_label_commonobjects_detail_date":`A data de término não pode ser inferior à data de início`,
"vue_label_email_mark?as":`Marcar como`,
"label.guestgroup":`Equipes de contas`,
"label_emailtocloudcc_filed_server":`Servidor`,
"label.icon.186":`Assessoria`,
"label.department.user.edit":`Editar`,
"label.custom.page.component.button.settings":`Configurações dos botões de componentes`,
"label.partnerCloud.orderingPlatform.nextProduct":`Você deseja salvar a configuração atual do produto e configurar o próximo produto?`,
"vue_label_appstore_cloud_platform":`plataforma oficial da nuvem`,
"label.page.previous":`Anterior`,
"label.direct.dashboard.week.report":`Nova nota semanal de trabalho`,
"label.ServiceCloud.prompt.warning":`Sem estatísticas de distribuição de recursos por endereço.`,
"label.emailtocloudcc.position":`Posição`,
"vue_label_email_please_enter_the_message_content":`Por favor, digite o conteúdo do correio`,
"labal_About_to_jump":`Em breve será redirecionado.`,
"label_profile_mobile_setup_stand":`Página inicial padrão`,
"label.visualpage.component.n3":`3.Parâmetros. Os parâmetros estão escritos nas args propertites ,args="name:'zhang', age:26" Note as aspas duplas simples.`,
"vue_label_report_operationmode":`Modo de funcionamento do relatório`,
"label.reportsSubscription.select.attached.file":`Favor selecionar o tipo de arquivo anexo.`,
"label.afghanistan.time":`Tempo Afeganistão`,
"label.vlidaterule.formulatrue":`Se esta expressão de fórmula for?verdadeira, exibir o texto definido na área de Mensagem de Erro`,
"label.ccchat.person.invite.erroremail":`O formato do endereço de e-mail está incorreto.`,
"label.viewDashboard":`Ir para Lista de Painel de Controle`,
"label.at":`em`,
"label.notification.arketsea.beforeretrieve":`Sua {0}：{1} será reciclada até {2}，remaining tempo: 6 dias`,
"label.field.update.show.editor":`Mostrar Editor de Fórmula`,
"label.weixin.polls.time":`Data da votação`,
"vue_label_commonobjects_detail_activity_nostarttime":`Sem hora de início`,
"label.direct.dashboard.me.not.approval70":`Itens de Aprovação Pendentes Enviados por Mim`,
"label.data.setok.t_desc3":`Operação.`,
"label.view.edit.search.describe":`Busca após digitação de palavras-chave`,
"label.importsourcefiletip":`Antes de importar seu arquivo separado por tabulação traduzida, certifique-se do seguinte: <span><ul><li>1.Crie um arquivo separado para cada idioma que você gostaria de importar que contenha apenas o nome e a tradução.</li><li>2.O atributo de idioma na parte superior de cada arquivo é necessário. O atributo de idioma se parece com isto\uff1aLanguage=en_US.</li><li><li>3.Para garantir que seus arquivos de importação sejam salvos na codificação UTF-8 antes da importação.</li>4.Certifique-se de inserir o avanço de linha no final do arquivo que deseja importar.</li></ul></span>`,
"UG.Case.01":`Caso`,
"label.weixin.report.filters":`Filtros`,
"vue_label_homepage_profilehomepageassignment":`Atribuição da página inicial do perfil`,
"label_tabpage_editview":`Editar vista`,
"label.tabpage.allpotentialcustomers":`Todas as pistas`,
"label.sendemail.send.standbyemail":`(caixa de saída de reserva)`,
"errormessage.email.atleastonereceiver.z":`Você deve selecionar ou editar um endereço de recebimento.`,
"workflow.action.tasks.assignortype.ownertype":`Tipo de proprietário`,
"label.list.userinterface.new.page.setup":`Nova página`,
"chatter.seladress":`Por favor, selecione pelo menos um destinatário.`,
"Pagelayout_Setup_004":`Até 4 campos podem ser configurados`,
"label.mobile.home.page.tenbig.opp":`Top 10 Oportunidades nos próximos 30 dias`,
"label.wtd.changefields.newpc":`Gerar Página de PC`,
"label.opportunity.perm.remark":`Esta é uma oportunidade privada, por favor, entre em contato com o "owneridccname" <br> proprietário para obter acesso.`,
"label.data.exp.tempdes":`Descrição do modelo`,
"label.appointment.wizard.subtitle2-1":`De`,
"lable.currencyManage.button.manageexchangeRate":`Gerenciar taxas de câmbio datadas`,
"label.file.viewinfo":`Ver detalhes do arquivo`,
"label.integrations.mailchimp.export.failed":`A exportação de dados falhou, por favor verifique sua conexão de rede e tente novamente`,
"pagecreator_page_button_edit":`Editar`,
"label.icon.86":`Briefcase`,
"label.exchange.sync.reset":`Reset Sync`,
"label.customfields.lookupfilter":`Você pode criar um filtro para limitar os registros que estão disponíveis para o usuário no campo Lookup.`,
"label.component.hotdeal.nopermission":`Para ver seus dados relacionados a oportunidades de negócios, entre em contato com seu administrador do CloudCC.`,
"label.address.province":`Estado`,
"lable.PowerProcess.3digit.input":`Não mais do que três dígitos.`,
"label.asset":`Ativos`,
"label.passwordPolicy.setup.nopwdremember":`Nenhuma senha lembrada`,
"front-electronic-signature-setting-intro2":`Antes de iniciar um contrato, favor préajustar o modelo na plataforma DocuSign. Ao iniciar a assinatura, você pode selecionar o modelo de contrato prédefinido.`,
"pagecreator.page.button.new":`Nova página`,
"label.tabpage.step2":`Etapa 2 especificar as condições do filtro`,
"label_switch_two_column_or_responsive_layout":`Mudar para layout de duas colunas ou responsivo`,
"label.batchDelete":`Eliminação em massa`,
"chatter.edit.ct":`Edite suas informações de contato.`,
"UG_ST_003":`Você não tem permissão para criar {0}, entre em contato com o administrador, clique em confirmar para ir diretamente para a interface {0}.`,
"label.timzone.tip.info2":`Ao utilizar o formato de data simples para formatar a data, você deve definir fusos horários para instâncias do formato de data simples, como SimpleDateFormat myDateFormat=novo SimpleDateFormat("yyyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));ou obter uma instância usando o método de ferramenta fornecido por TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Pela primeira vez sincronizar os e-mails desde há quanto tempo`,
"label.currency.invalid":`Moedas inativas`,
"label.mask.custom":`Personalizar`,
"lable.opppdt.addpdt.title":`Selecione o produto`,
"label.appointment.wizard.subtitle3-3":`Quarta-feira`,
"label.weixin.report.criteria":`Agrupado por`,
"label.appupload.upload.install.uninstall":`Incapaz de instalar`,
"label.compact.layout.frame.split":`Exibição em tela separada`,
"label.email.attach.complete.info":`Após a conclusão do upload, o arquivo será exibido na lista de anexos abaixo`,
"label.Receivables":`Contas a receber`,
"label.linkedin.title.setting":`Informações integradas do LinkedIn`,
"label.companynotice":`Anúncio da empresa`,
"label.emailobject.discard":`Descartar`,
"label.selected.searchfield":`Campo de resultados de busca selecionado`,
"front-electronic-signature-explainDocusign":`DocuSign Esignature Descrição:`,
"chatter.link.name":`Nome do link`,
"label.low":`Baixo`,
"label.verticalline":`Colunas Verticais`,
"label.approval.isallowed.reject.label":`Permitir rejeição ao aprovar dados únicos?`,
"label.emailtocloudcc.button.enable":`Ativo`,
"label.dashboardSetup.showdw.d5":`Unidade Inteira`,
"label.usermanage.not.authority":`Você não tem permissão suficiente para fazer isso.`,
"label.customobjects.track.introduce0":`Esta página permite selecionar quais campos devem ser rastreados na lista {0} "Rastreamento de campo" relacionada. Sempre que um usuário modificar qualquer um dos campos selecionados abaixo, o valor do campo antigo e o valor do novo campo, bem como a data, hora, características da mudança e o usuário que faz a mudança são adicionados à lista relacionada ao "Rastreamento de Campo".`,
"canlendarmonth":`Mês do calendário`,
"vue_label_dashboard_minimum":`Por favor, digite o mínimo`,
"label.salescloud.optionlist.inputname.linealone":`Insira um ou mais valores da lista de picking abaixo, com cada valor separado por uma nova linha.`,
"message.error.organuzation.information.null":`Não existem informações sobre a organização.`,
"label.tabpage.maxfilez":`O tamanho máximo do arquivo é`,
"message.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras, números e sublinhado. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado. E o comprimento máximo é de 50 caracteres, o comprimento mínimo é de 2 caracteres.`,
"report.type.label.contractPayment":`Contratos e contas a receber`,
"label.limiting.choose.three.files":`Você pode selecionar 3 arquivos, selecionados agora.`,
"label.reportTypeFocus":`Foco na fonte de dados do relatório`,
"Report_Delete_Confirm_Title":`Por favor, confirme`,
"front-gantt-module-reorder-milestones":`Reordenar marcos`,
"front-starter-v1-customer-tips-success":`Ativar o pool de contas com sucesso`,
"label.tabpage.isdeleteview":`Você tem certeza de apagar esta visão?`,
"label.favorite.title":`Plataforma CloudCC`,
"page.layout.sysinfo":`Informações do sistema`,
"label.tabpage.pleaseSelectz":`Favor selecionar`,
"label.smsnotice":`Notificações SMS`,
"label.forecast.customforecast.foretype.Pipeline":`Gasoduto`,
"label.rejectbehaviour":`Comportamento de Rejeição`,
"label.searchlayout.view.example.new":`Ver exemplo (Nova Janela)`,
"vue_label_homepage_notice2":`Você pode atribuir manualmente o layout da página inicial, facilitando aos funcionários a conclusão eficaz de suas tarefas diárias`,
"label.import.index.chooseidorother":`3、You pode escolher usar o ID ou nome para corresponder ao registro e preencher o campo de busca. Se você precisar adquirir o ID do registro correspondente e outras informações, você pode criar um relatório e definir o nome do registro e o ID do registro como colunas de grupo, e então exportar o relatório.`,
"label.westem.european.summer.time":`Tempo da Europa Ocidental`,
"label.brackets":`Parênteses`,
"asset.serialnumber.unique":`O número de série do ativo já existe, por favor não o acrescente repetidamente.`,
"label.callcenter.access.keyID":`Acesso à chave secreta de identificação`,
"label.calendar.month.view":`Vista do mês`,
"label.realdelete":`Eliminar permanentemente`,
"label.partnerCloud.orderingPlatform.amountPaid:":`A ser pago:`,
"label.reportTypName":`fonte de dados do relatório Nome`,
"lable.newtabpage.opensearchresult":`Expandir os resultados da pesquisa`,
"front-kefu-moudle-v1-Session-duration":`Duração da sessão:`,
"label.import.index.ignore":`Ignorar`,
"label.customfields.url.tip":`Quando os usuários clicam no campo, a URL será aberta em uma nova janela ou janela atual de acordo com as configurações dos usuários, e o padrão é abrir a URL em uma nova janela.`,
"label.projectManagement.editMilestone":`Editar Marco`,
"front-gantt-module-v1-project-gantt-list":`Lista de projetos`,
"label.validate.remark":`As regras de validação ajudam a melhorar a qualidade dos dados, evitando que os usuários economizem dados incorretos. Você pode definir uma ou mais regras de validação que consistem em uma condição de erro e a mensagem de erro correspondente. As regras de validação são executadas em tempo recorde de economia de tempo. Se uma condição de erro for atendida, a gravação é abortada e uma mensagem de erro é exibida.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`O formato do número de telefone está incorreto. Favor entrar novamente`,
"label.channel.name":`Nome do canal`,
"label.weixin.cloudcc.user.message":`Informações aos usuários do CloudCC`,
"label.icon.59":`Workshop`,
"label.ccpeak.function":`Método`,
"lable.opppdt.selPdt.leastten.fields":`Favor selecionar até 5 campos`,
"label.deadline":`Data limite`,
"label.product.sel":`Seleção do Livro de Preços`,
"vue_label_helpcenter_detail2":`Todos os eventos: Mostrar todos os eventos aos quais você tem acesso, mesmo que você não esteja participando.<br>     Você também pode filtrar os registros de atividades que deseja visualizar com base no intervalo de datas e tipo de atividade.<br>    4. Dynamic<br>     Todas as pessoas que podem ver este registro podem deixar uma mensagem e postar sob a coluna "Dynamic" do registro, e você também pode ver todas as mudanças de informação, atividades mais recentes e comentários e postagens de outras pessoas sobre este registro. Esta coluna facilita a comunicação e colaboração online entre você e seus colegas, ajudando a melhorar o trabalho em equipe e a eficiência.<br> Posting<br>     Passo 1: Clique na barra de postagem e digite o conteúdo da postagem<br>     Passo 2: Clique no botão Arquivo/Link para adicionar um arquivo/link conforme necessário<br>       Passo 3: Clique em "Compartilhar" para finalizar a postagem. <br> Ver post<br>     Depois que o post for publicado com sucesso, você poderá ver o micro-post que acabou de publicar abaixo. O micro-post é composto das seguintes partes: avatar, nome da pessoa, conteúdo do micro-post e métodos de interação (como/comentar/editar/apagar post). <br> Ordenar e encontrar posts<br>     Clique na lista suspensa à direita de "Ordenar" para mudar a ordenação dos posts. <br>       Ordenação "Última Atividade": ordenar pelo último tempo de interação dos micro-postes;<br>     "Último Post "Ordenar": Organizar pelo tempo de publicação dos micro-postes;<br>     Ver diferentes tipos de micro-postes<br>     Micro-postes de texto simples: Navegue por todo o conteúdo diretamente na área de publicação do micro-post;<br>     ;  Micro-post contendo arquivos: clique no botão de download do arquivo para baixar o arquivo localmente para visualização;<br>     Micro-post contendo links: clique no link do micro-post para abri-lo;<br> Comentando e gostando de micro-postes<br>     Comentando<br>   Passo 1: Clique em "Comentar" abaixo de cada micro-post <br>     Passo 2: Digite o comentário na caixa de texto que abre<br>   Passo 3: Adicionar o arquivo/link ao comentário conforme necessário Passo 4: Clique em "Comentário" sob a caixa de texto para completar a operação<br>     Delete comment<br>    O editor do comentário pode apagar o conteúdo do comentário. Clique no botão à direita do comentário e selecione "Delete" na caixa suspensa.`,
"pagecreator_layout_button_mergecell":`Fusão de células`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Ativo`,
"label.query.detail.loginbypartneruser":`Login por usuário parceiro`,
"label.view.selectrenderfields":`Selecione os campos a serem exibidos`,
"label.code.add":`Adicionar informações de link do código QR`,
"label.appointmentconfirmpage.wizard.title1":`REUNIÃO AGENDADA`,
"label.timzone.tip.title":`Ao lidar com datas usando nova data() ou calendário, deve-se tomar cuidado para lidar com as questões de fuso horário múltiplo correspondentes. além disso, a classe de ferramentas de tempo fornece uma série de ferramentas que suportam fusos horários múltiplos.`,
"label.tag.addtags.visibility":`Visibilidade`,
"label.appointmentconfirmpage.wizard.title3":`Você tem certeza de cancelar o compromisso existente e fazer um novo compromisso?`,
"lable.outlook.detail.oldest":`Mais antigo`,
"label.account.custom.quarter.timeerror":`A data de início do trimestre ou a data de término do trimestre está entre os trimestres do histórico dos trimestres personalizados, verifique e reinicie`,
"label.sendsms.idea":`Respeitado`,
"label.manageAll.pagenum2":`Esta é a última página.`,
"serviceterritory.isactive.notactive":`Este território de serviço não está habilitado.`,
"label.userinfo.newpwd.notnull":`Por favor, digite sua nova senha.`,
"vue_label_dashboard_nolinkagedashboard":`Sem painel de controle de ligação`,
"message.cannotdeleteapproval":`Você não pode apagar este processo de aprovação.`,
"label.wtd.detail.m":`Móvel`,
"label.app.step4.introduce":`Escolha as abas a serem incluídas neste aplicativo personalizado.`,
"label.ccchat.error.permission":`Nenhum acesso`,
"UG_opportunity_009":`Ou`,
"label.Receivables.TheActualAmountOfMoney":`Recibos reais`,
"label.callcenter.no.search":`Nenhuma consulta relevante para as informações`,
"label.user.introduce":`Usuários`,
"message.datalocked.addpdt":`Este registro de oportunidade está bloqueado, você não pode adicionar Pruduct.`,
"label.sendsms.step1":`Passo1: Especificar destinatários`,
"label.brief.contracts":`Contratos`,
"label.setup.mini.swap":`Ajuste do carrossel`,
"label.emailobject.wizard.desc1":`Conecte seu e-mail, envie o correio aqui e sincronize automaticamente com o registro`,
"label.login.verification.mfa.desc2":`Se você não puder verificar por algum motivo, como perder ou excluir por engano aplicativos de AMF em seu telefone, você pode ter ouvido o administrador desobrigar o AMF.`,
"label.notification.receiveSms.message":`Você recebeu uma mensagem de texto de {!fromaddress}, clique para ver mais detalhes`,
"label.emailmerge.mergeFolder.publicfolder":`E-mail público não arquivado Fusão de modelos`,
"label.password.update.false":`Não foi possível mudar a senha, por favor, entre em contato com o administrador!`,
"label_tabpage_systemz":`Sistema(s)`,
"label.dataimport.objectid.null":`O ID do objeto está vazio e não pode ser importado`,
"label.currency.type":`Tipo de moeda`,
"component_setup_button_appurl":`Sistema url`,
"label.appointmentconfirmail.wizard.title2":`Você tem uma programação {0}`,
"lable.product.please.enter":`Favor entrar`,
"label.escalation.setup.title":`Regras de Escalação de Casos`,
"label.create_failure":`Falha na criação da forma`,
"label.weixin.brand.model":`Modelo de marca`,
"label.layout.nameoftestobj2":`Nome do Objeto de Teste Dois`,
"vue_label_filters_number":`10 arquivadores são suportados para cada relatório.`,
"label.file.following":`A seguir`,
"vue_label_account_all_contracts":`Transferir todos os contratos dos proprietários dos clientes`,
"label.service.please.select.cycle.type":`Favor selecionar o tipo de ciclo`,
"label.weixin.weipoll.optionname":`Nome da Micro Vote Choice`,
"label.data.newtemplate.null":`Nenhum`,
"message.passwordPolicy.validate.complexReq1":`Erro: Sua senha deve ter uma mistura de letras e números`,
"label.forecast.shre.editmanager":`Gerente Editar`,
"label.emailtemplate.tip":`Abaixo está uma lista de todos os seus modelos de e-mail na pasta selecionada. Clique no novo botão para criar um novo modelo de texto ou HTML para e-mail. Você pode usar estes modelos de e-mail ao enviar um único e-mail.`,
"label.tag.manage.button":`Gerenciar Etiquetas`,
"label.changepw":`Mudança de senha`,
"label.sso.saml.sp.idsource.nameid":`A identidade está no elemento NameIdentifier da declaração do Assunto`,
"label.salescloud.teamrole.addmember":`Adicionar membros do Grupo de Oportunidades CloudCC`,
"label.h5.similar.opportunity.last.months6":`3-6 meses recentes`,
"message.save.opportunity.role.save.failed":`Falha em salvar o papel de contato`,
"vue_label_report_formulainformation":`Informações sobre a fórmula`,
"label.area.assignuser.remark":`Atribuir usuários ao território`,
"label.multilang.viewlist.total":`{0} Selecionado`,
"label.newprocessstep4":`Passo 4 Selecione os modelos de notificação por e-mail`,
"label.permission.objectpermission.open":`Aberto`,
"label.service.gantt.close.list":`Lista de fechamento`,
"label.standarduserfield":`Campos de usuário padrão`,
"vue_label_commonobjects_detail_the_administrator":`O registro foi bloqueado, favor entrar em contato com o administrador.`,
"label.exchange.sync.account":`Credenciais da conta de serviços de câmbio`,
"label.mr.title.button.back":`voltar, e redefinir os critérios de busca`,
"label.notsetup.operation":`Erro de condição da linha, nenhum operador foi definido.`,
"label.notifications_center":`Notificações Cente`,
"label.event.moveup.5hour":`5 horas à frente`,
"report_label_pleaseinput":`Digite o que você deseja pesquisar`,
"label.batchadd.newbatchpage.errorlist":`A adição de dados falhou`,
"label.quickbooks.invoices":`Faturas`,
"chatter.feed.usingchatter":`Ligue o CCChat, seus usuários podem seguir algumas pessoas ou registros e postar.`,
"label.all.marketing.activities":`Proprietário da campanha de mercado`,
"label.lookup.finish":`Auto-Completamento de Pesquisa`,
"label.weixin.unbind":`Desobstruir`,
"front-console-closeTime":`Tempo de fechamento`,
"label.service.rest.time":`Tempo restante`,
"label.mr.descreption.condition1":`Digite o escopo e as regras para encontrar registros duplicados. Clique em [Find Duplicates] para obter registros duplicados qualificados.`,
"label.group.new":`Novo Grupo`,
"vue_label_SMS_sending_please_wait":`Envio, por favor aguarde`,
"label.Standardobj.tab":`Separadores de objetos padrão`,
"label_chatter_pastEvents":`Atividades passadas`,
"label.chatter.priority":`Prioridade`,
"select.nullvalue":`-Nona -`,
"setup_layout_group_pagecomponent":`Componentes da página`,
"label.dataimport.dataerror.check":`Erro de dados, favor verificar os dados.`,
"label.permission.detail.app.pagesetting.tip":`Ajustes de permissão de páginas personalizadas Excute`,
"label.knowledge.language.polish":`Polonês`,
"label.project.hit.two":`Lembrete de expiração da subtarefa`,
"label.customerapp":`Aplicação personalizada`,
"label.reportsSubscriptionPage.condition.value":`Valor`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Desculpe, você não tem acesso para operar. Favor entrar em contato com o administrador.`,
"homepage.layout.buttion":`Atribuição do layout da página`,
"label.notification.event.overlapEvent":`O usuário delegado já foi designado para um evento {subjeto} de {begintime}-{endtime}, você quer criar este evento de qualquer forma`,
"label.customfields":`Campos personalizados`,
"label.data.downpage.e.title":`Passos para a exportação de dados`,
"label.notification.serviceappointment.remove":`Sua ordem de trabalho enviada {0} foi cancelada, por favor providencie seu trabalho de forma razoável.`,
"label.campagin.roi.zhuangtai":`Status da campanha`,
"label.applt.updown":`Download do Código QR do Miniprograma`,
"label.customfields.new.step1.tip":`Especifique o tipo de informação que o campo personalizado conterá.`,
"label.staticresource.upload.limit":`Somente arquivos nestes formatos podem ser carregados: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Alterar foto do usuário`,
"label.icon.32":`Computador`,
"vue_label_homepage_notice_cantset":`A página inicial do perfil não está configurada para este perfil, a página inicial padrão do perfil não pode ser modificada`,
"front-epwechat-module-v1-agree-unbound":`Concordar e aceitar as informações acima não vinculativas`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Por favor, escolha um estilo de aba.`,
"label.select.an.asset":`Favor selecionar um ativo.`,
"label.search.sizer.field":`Pesquisar campos de filtros`,
"label.emailmerge.mergeFolder.lastone":`Por favor, selecione pelo menos um modelo.`,
"label_tabpage_step2":`Etapa 2 especificar as condições do filtro`,
"label.version.lead.automatic.allocation":`Regras de Atribuição de Chumbo`,
"label.projectManagement.update.succeeded":`Atualização com sucesso`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Tab`,
"label.pigeonhole.sel.f":`Escolha as pastas a serem arquivadas`,
"homepage.components.status":`Status do componente`,
"label.currency.edit.new":`Currency Edit: Nova moeda`,
"label.input.new.password":`Por favor, digite a nova senha correta`,
"chatter.group.membersName":`MMeMber Nome`,
"label.myinfo.modify":`Editar informações pessoais`,
"label_tabpage_next":`Próximo passo`,
"vue_label_homepage_card_closedopportunities":`Oportunidades fechadas`,
"label.permission.edit":`Editar Propriedades`,
"message.error.searchfield.objid.null":`A identificação do objeto requerida pelo campo de consulta não pode estar vazia`,
"label.partnerCloud.productSet":`Configuração do produto`,
"label.emailtocloudcc.filed.emailto":`Envie um e-mail para`,
"label.service.miniProgram.uploadingImage":`Por favor, carregue uma foto carrossel.`,
"label.sso.saml.idp.description1":`Aplicativos Conectados`,
"label.event.moveup.10minutes":`10 minutos à frente`,
"label.quote.createby":`Preparador`,
"label.workflow.baseontimeoparate":`Ações de fluxo de trabalho dependentes do tempo`,
"label.searchall.r":`Procurar novamente`,
"vue_label_homepage_differentprofiles":`Atribuir diferentes homepages a diferentes perfis`,
"label.campaign.channel.step1":`Passo1: Informações`,
"label.event.moveup.2hour":`2 horas à frente`,
"font-evaluate-module-v1-cancle-reply":`Cancelar a autoresposta`,
"message.datalocked.delete":`Você não pode apagar este registro porque ele estava trancado. Se você quiser apagá-lo, por favor, entre em contato com a administração.`,
"label.sso.listOfKey":`Lista de chaves`,
"label_chatter_newtask":`Nova tarefa`,
"label_emailsync_form_seversetting":`Configuração`,
"label.partner.new.function":`Descrição da característica`,
"vue_label_notice_homepage_pleaceentername":`Por favor, digite o nome da página inicial`,
"message.please.choose.opportunity":`Favor selecionar oportunidade de negócios`,
"label_file_use_most_user":`Usuários com o maior espaço de armazenamento utilizado`,
"label.htyj.remark2":`para que você não possa ver os valores do contrato`,
"label.formula.message":`quando a fórmula é avaliada como false，the pronto para a submissão de falhas`,
"UG_Case_04":`Atribuição de casos`,
"label.displaycolumn":`Mostrando Colunas`,
"vue_label_campaign_selected_member_status":`Atualização para o status de membro selecionado`,
"label.workflow.operate":`Ações de fluxo de trabalho`,
"label_chatter_mail":`Correio`,
"label.setup.mini.setting":`Ajuste do Backgroud Setting of Mini Programs`,
"vue_label_chat_invitetojoin":`Você convidou "{convidar}" para participar do bate-papo em grupo`,
"setup.object.field.dependency.label.linkedfieldvalue":`Campo Dependente`,
"vue_label_email_update_template":`Modelo de atualização`,
"label.email.template.private.mail":`Pasta Exclusiva de Modelos de Email`,
"lable.Confirm .potential.customers":`Confirmar para reciclar chumbo {nome}`,
"vue_label_leadpool":`Pool de chumbo`,
"label.ems.hostorpost.error":`Erro de configuração do servidor ou da porta, favor verificar.`,
"label.search.saveok":`Poupado com sucesso`,
"label.custom.field.cannot.maping":`Incapaz de mapear para este campo várias vezes`,
"label.projectManagement.dispatched":`Enviado`,
"time":`Hora`,
"label.choose_socialnetwork":`Escolha uma rede social para começar`,
"label.vlidaterule.checkedtrue":`Se a fórmula for caixa de seleção, não há necessidade de aspas duplas`,
"label.appointmentconfirmail.wizard.btn1":`Reprogramar`,
"front-kefu-moudle-v1-maxchars-input":`Podem ser inseridos até {0} caracteres`,
"setup.mainpage.label.welcome10":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object → Object Name → Custom Layout.`,
"label.ems.company.setup.title":`Configurar a caixa de e-mail da empresa`,
"label.channel":`Canais`,
"label.textmessage.groupsms":`Grupo SMS`,
"label.asset.deleted.successfully":`Eliminar a lista técnica de ativos com sucesso.`,
"label.knowledgebase.new.workspace":`Novo espaço de trabalho`,
"label.ServiceCloud.diliweizhi":`Localização`,
"label.private_me":`De particular para proprietário (eu)`,
"label.service.miniProgram.imageLink":`Elo Carrossel`,
"label.area.assigned":`Usuários Designados`,
"label.weixin..xsld.name":`Nome da oportunidade`,
"label.campaign.matchway.select.name":`Nome`,
"label.installedsoft":`Pacotes instalados`,
"label.projectManagement.spare.time":`Tempo disponível`,
"label.user.select.custom.text.sendemail":`Selecione um formato de texto personalizado para enviar e-mail diretamente`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Aprovar/Rejeitar`,
"startdate.enddate.time.illegal":`A data de início deve ser menor ou igual à data final.`,
"label.project.hit.eight":`Lembrete diário de tarefas`,
"message.duplication.label.uncheck":`Não-verificação`,
"label.allocation.role":`Atribuir usuários`,
"label.sendemail.lead.scoreinfo":`Prezado #username:{r}o sistema pontuou todas as pistas das visualizações que você selecionou "#viewlabel" com base nas regras de pontuação das pistas. é necessário #timestr.r{r}n faça o login e abra a visualização para verificar os resultados.\Atenção: Se você não conseguir visualizar a pontuação dos leads que você pontuou, por favor, edite a visualização e adicione "lead scoring" ao campo para exibir para ver o resultado da pontuação.`,
"lable.oppt.jieduan.closejieduan":`Feche esta oportunidade`,
"label.ems.verify":`Verifique`,
"message.error.startdate":`A data de início deve ser anterior à data final`,
"label.campaignmember.main.deletelead":`Remover as Leads Existentes de Membros`,
"label.partnerCloud.financeSetting.account":`Depois que o fundo parceiro for ativado, os objetos do fundo parceiro e a declaração do fundo serão adicionados. Os usuários parceiros podem usar a conta no CloudCC para pagar os pedidos.`,
"message.datalocked":`seu registro está trancado. Se você precisar editá-lo, por favor entre em contato com seu administrador.`,
"lable.opppdt.selPbk.pricebook":`Livros de preços`,
"label.knowledgebase.restore.article":`Restaurar o artigo?`,
"label.object.batchadd":`Adicionar Lote {objNome}`,
"label.what_happen":`Página após a submissão do formulário`,
"label.roleandunderling":`Papéis e Subordinados`,
"label.knowledge.language.russian":`Russo`,
"front-electronic-signature-explain-first":`Antes de vincular a assinatura eletrônica, recomendase que você se registre e certifique na plataforma Fadada.`,
"component.sendmail.label.subject":`Tema`,
"month":`Mês`,
"label_chatter_save":`Salvar`,
"label.view.sortview.sectiontitle":`A vista será exibida na ordem selecionada`,
"label.mobile.home.page.major.project":`Projetos-chave`,
"label.weixin.input.filename":`Por favor, digite o nome do arquivo`,
"label.pagelayout.remark":`Esta página permite que você crie diferentes layouts de página para exibir`,
"label.service.miniProgram.store":`A história da marca`,
"label.recordtype.edit.selected":`Valor Selecionado`,
"message.selectgroupcondition":`Favor selecionar as condições para o agrupamento`,
"label.y.axis.cannot.empty":`O eixo Y não pode ser nulo`,
"label.textmessage.vonage.connected.count":`Conte como Contato`,
"setup.layout.label.readonly":`Read-Only`,
"front-kefu-moudle-service-agent":`Atendimento ao cliente`,
"message.login.mfaverification.page.invalid":`A página é inválida. Por favor, atualize.`,
"label.central.standard.time":`Tempo Padrão Central`,
"label.processnoticepic":`Imagem de atenção do processo de aprovação`,
"vue_label_helpcenter_calendar1.2":`Regras de exibição da entrada do calendário: as entradas do calendário serão exibidas na grade do calendário, e a área da grade onde a entrada do calendário está localizada representa o intervalo de tempo do registro. As entradas do calendário que abrangem mais de 24 horas serão exibidas no topo da escala de tempo no dia, semana e visões de disponibilidade. Se houver múltiplas entradas de calendário em uma grade na visão do mês, você pode clicar em " Mais" para visualizá-las. O lado esquerdo ou direito da entrada do calendário é um semicírculo, o que significa que não há tal registro no dia anterior ou seguinte da grade. O lado esquerdo ou direito da entrada do calendário é arredondado em ângulos retos, indicando que ainda existe este registro no dia anterior ou no dia seguinte da grade. <br> Localize rapidamente a data na visualização do calendário: Você pode localizar o intervalo de datas exibido na visualização do calendário à esquerda, selecionando a hora no pequeno calendário no lado direito da página do calendário. Você também pode clicar nos ícones "<" e ">" no canto superior direito da página do calendário para mudar rapidamente as datas. Se a hora de sua visualização do calendário não for a hora atual, você pode clicar no ícone "Hoje" no canto superior direito da página do calendário para mudar rapidamente de volta para hoje. <br> Visualização de lista<br> Mudar da visualização de calendário para a visualização de lista: Clique no ícone "calendário" na parte superior direita da visualização do calendário e selecione "tabela" para mudar para a visualização da lista de eventos. <br> Uso da visualização de lista: Para visualizar eventos específicos ou múltiplos eventos ao mesmo tempo, abra a visualização de tabela. Há visões de lista predefinidas na visualização de lista. Clique no ícone "botão suspenso" no canto superior esquerdo da visualização de lista para exibir todas as visualizações de lista às quais você tem acesso. Você também pode personalizar a visualização da lista de eventos para atender às suas necessidades. <br> 2. Meu calendário e outros calendários<br> Meu calendário<br> Meu calendário contém meu calendário de eventos e meu calendário de objetos. <br> Meu calendário de eventos: Mostrar todos os registros de eventos onde a pessoa designada é sua na visualização do calendário. Meu calendário de eventos não pode ser removido, editado ou alterado em cores. Você pode compartilhar "Meu calendário de eventos" com seus colegas.`,
"label.approval.end":`Fim`,
"vue_label_report_notice_cannotdelete":`Há relatórios nesta pasta que não podem ser excluídos`,
"label.sso.saml.idp.loginurl":`URL de login do idP`,
"label.emailtocloudcc.filed.port":`Porto`,
"label.directdashboard.righttitle":`Painéis de análise de vendas`,
"label.knowledge.case.suggest.article":`Artigos sugeridos em casos`,
"label.version.maxcount":`além do limite.`,
"label.weixin..xsld.yjqyrq":`Data de fechamento`,
"front-project-module-v1-unmarket-is-template":`Modelo sem marca`,
"label.mobile.quickcreate.default.map":`Mapa`,
"chatter.click.p":`Clique para visualizar`,
"label.chat.topic.all.topic":`Todos os tópicos`,
"label.channel.head":`Supervisor do Canal`,
"lable.edit.queue.emaildes":`Digite o nome da fila e o endereço de e-mail a ser usado ao enviar notificações (por exemplo, quando um caso tiver sido colocado na fila). O endereço de e-mail pode ser para um indivíduo ou para uma lista de distribuição. Quando um objeto é atribuído a uma fila, somente os membros da fila serão notificados.`,
"label.tag.filter":`Filtro de etiquetas`,
"label_chatter_filterTimeLine":`Linha do tempo de filtragem`,
"label.dashboard.show.value":`Mostrar valores`,
"vue_label_normal_solution_sf":`Solução`,
"label.customfields.location.tip":`Permite ao usuário definir a localização. inclui componentes de longitude e dimensão que podem ser usados para calcular distâncias.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. Todos os direitos reservados por CloudCC.com`,
"label.icon.33":`Computador`,
"label.mr.title.opportunityName":`Nome da oportunidade`,
"template.report.sales.month":`Vendas deste mês`,
"chatter.group.lookingForPeople":`Comece a digitar um nome`,
"label_tabpage_userz":`Usuários`,
"label.reportsSubscriptionPage.email.formatselection":`Favor selecionar o formato do relatório que você deseja receber por e-mail`,
"lable.product.plist":`Preço de lista`,
"label.multilang.activity.monthline":`Semana {0}`,
"label.ccchat.whose.name.contains2":`Membros de qualquer grupo de campanha`,
"label.mobile.phone.day.report":`Notas de trabalho diário`,
"label.processsetting.set.files":`Campos definidos`,
"label.systemlog.s":`Sucesso`,
"label.tabpage.uploadsz":`Upload`,
"serviceterritory.member.time.conflict":`Dentro deste intervalo de tempo, os recursos de serviço se tornaram membros de outros territórios de serviço.`,
"label_chatter_startDate":`Dados iniciais`,
"label.search.at.least.two":`Os termos de busca não devem ser inferiores a 2 caracteres.`,
"label.approval.ressign.project":`Itens a serem Designados`,
"lable.custom.Previous.CY":`CY Anterior`,
"label_chatter_link":`Link`,
"label.weixin.group.name":`Nome`,
"label.partnerCloud.basicSetting.domainName":`A operação é irreversível e o nome de domínio não pode ser alterado após ser inicializado. Você tem certeza de confirmar a operação?`,
"lable.SalesCommitmentKanBan.targetContract":`Valor do Contrato Alvo`,
"label.currency.new":`Nova moeda corporativa`,
"message.passwordPolicy.validate.complexReq3":`Erro: Sua senha deve ter uma mistura de números e letras maiúsculas e minúsculas, e caracteres especiais.`,
"label.icon.127":`Médicos`,
"label.customfields.fieldname.tip":`O nome do campo é uma referência interna e é utilizado para fins de integração, como o API.`,
"chatter.feed.menutype.feed":`Sumário`,
"label.home.standard.dashboard.role":`Você não tem informações de função, portanto, não pode visualizar o painel de compromisso de vendas.`,
"label.customfields.fielddependency.button":`Clique no botão para incluir ou excluir valores selecionados da lista de seleção dependente`,
"label.recentprojects":`Itens recentes`,
"label.appupload.logo.introduce":`O logotipo da embalagem deve ser menor do que 20KB. As dimensões da imagem devem ter um máximo de 60 pixels de largura por 60 pixels de altura para obter melhores resultados. As imagens maiores serão redimensionadas e podem parecer distorcidas.`,
"label.integrations.northamericanleads":`Líderes Norte-Americanos`,
"label.sms.balance":`Equilíbrio (yuan)`,
"label.ccchat.message.num":`Notícias`,
"label.embed_website":`Para incorporar este formulário, basta copiar e colar o código abaixo no código HTML em seu site.`,
"label.trigger.check.error":`A verificação da sintaxe do gatilho falhou.`,
"label.bmap.baidu.maps":`Mapas Baidu`,
"label.nextapproverauto":`Próximo Aprovador Automatizado determinado por`,
"label.customfields.date.tip":`Permite aos usuários inserir uma data ou escolher uma data a partir de um calendário popup.`,
"button.partner.back":`Retornar`,
"label.layout.editcondition.tip":`Selecione os campos que você deseja usar como critério de busca. Observe que você pode selecionar até 10 campos.`,
"label.stacked.area":`Área empilhada`,
"font-evaluate-module-v1-case-closed":`Somente quando o caso é encerrado`,
"label_emailsync_status_log":`Log de conexão`,
"label.version.area.and.sales":`Equipe de Gestão de Territórios e Vendas`,
"label.service.booking.sessions":`Tempo de nomeação de serviço`,
"label.untransfile":`Sem tradução`,
"label.textmessage.sentfail":`Falha no envio de`,
"label.emailtemplate.detailinfo":`Detalhes do modelo`,
"setup_mainpage_label_welcome13":`Instruções: Clique no menu superior → Relatórios → Novo`,
"label.ccchat.error.nullid":`A identificação não pode estar vazia`,
"label.partnerCloud.partnerAccount.rebate":`Receitas de Rebate`,
"label.appupload.component.type.scheme":`Campo`,
"front-kefu-moudle-phonein":`Chamada entrante`,
"label.emailmerge.list.description":`Os modelos de fusão de correio são documentos MicroSoft Word com campos de fusão que fazem referência aos campos CloudCC.com.`,
"vue_label_commonobjects_detail_select_first":`Por favor, selecione primeiro os itens relacionados`,
"label_emailsync_form_action":`Ação`,
"label.customfieldrelation":`Campos e relações personalizadas`,
"label.ems.other.msg":`Por favor, conteúdo CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), iniciar o serviço de sincronização de correio.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":``,
"equal":`igual a`,
"label.partnerCloud.financeSetting.merchantInformation":`Caminho de acesso: Plataforma do comerciante  Centro de contas  Informações do comerciante`,
"vue_label_calendar_displayed_field_name":`Nome do campo exibido`,
"UG_opportunity_002":`Defina seu ciclo de vendas, configure a etapa`,
"label.tag.addtags.button1":`Salvar`,
"label.explain":`Instruções`,
"label.icon.166":`Pavilhão`,
"label.exchange.sync.setting.use":`Habilitar o Exchange Sync`,
"label.chatter.assignPerson":`Pessoa designada`,
"lable.PowerProcess.event.condition":`Condições de Marcos`,
"label.addattachment.step1":`Passo 1 Selecione o arquivo`,
"label.account.fiscal.quarter.timeerror":`A data de início ou término do trimestre fiscal está entre os trimestres fiscais históricos, favor verificar e reiniciar`,
"label.URL":`URL para referência`,
"label.icon.134":`Dados`,
"label.forecast.customforecast.foredis.sq":`Milhares`,
"label.custom.field.number.decimal":`Número de dígitos errado.`,
"label.version.history.track.error":`Sua versão suporta apenas para selecionar <=5 campos, não pode selecionar mais campos.`,
"label.log.os":`Sistema operacional`,
"label.partner.workspace.tab.option":`Abas disponíveis`,
"label.partnerCloud.partnerAccount.accountWater":`Declaração do Fundo`,
"setup_layout_label_norelatedlist":`Nenhuma lista relacionada`,
"label.import.page1.nextstep":`Próximo`,
"label.emailobject.view.attached":`E-mails com anexos`,
"label.SalesCommitmentKanBan.allTask":`Valor total da tarefa`,
"label.eastem.daylight.time":`Horário de verão do leste`,
"label.create_engaging":`Criar um posto atraente para se conectar com o mundo.`,
"label.area.adduser":`Adicionar ou excluir usuário`,
"label.timezone.importtimezone.user":`Use o fuso horário de login do usuário`,
"label.passwordPolicy.setup.pwdremember1":`1 senha lembrada`,
"label.query.detail.openpartneruser":`Habilitar usuário parceiro`,
"label.senduser":`Enviar de`,
"Pagelayout_Setup_001":`Por favor, selecione as listas relacionadas que seriam exibidas no layout de flutuação.`,
"label.mobile.parameter.setup":`Configurações de aplicativos móveis`,
"message.device.not.bound.mfa":`Dispositivos AMF não vinculados`,
"setup.layout.label.buttonarea":`Área de botões`,
"chatter.email.reply.like":`Comentários sobre um item que eu gosto`,
"label.chatter.day":`Dia`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat respondeu que o post gostou`,
"label.field.remark2":`página.`,
"label.ggReleaseRange.release":`Gama Publish`,
"lebel.alreadyback":`Chamado`,
"label.appupload.install.appname":`Nome do aplicativo`,
"label.selectnewadeckertag":`Selecione a etiqueta para o novo campo de hierarquia`,
"label.cliententrancewebsiteadmin":`Administrador do Portal do Cliente`,
"label.checkbox.checked":`Selecionado`,
"UG.Case.03":`Atualização automática de casos`,
"vue_label_dashboard_group":`Por favor, selecione um grupo`,
"label.import.index.preparedata":`Prepare os dados que você deseja importar`,
"vue_label_member_notice1":`Você pode carregar arquivos JPG, GIF ou PNG, o tamanho máximo do arquivo é de 2M`,
"message.modify.success":`Modificação bem sucedida.`,
"label.userquotas":`Cotas`,
"label.appointmentpage.wizard.subtitle3-1":`Nome`,
"label.import.index.maxdata2":`2、Before importando, certifique-se de importar todos os registros relacionados a ela primeiro. Por exemplo, se houver uma relação de busca entre o objeto que você está importando atualmente e os contatos, por favor, importe primeiro esses contatos, e depois importe seus dados. Se você precisar obter o ID do registro correspondente e outras informações, você pode criar um relatório e definir o nome do registro e o ID do registro como uma coluna de grupo, e depois exportar o relatório.`,
"label.pc.sectionpart":`Seção PC`,
"template.chart.wcldqzkh":`Líderes não processados`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Você quer salvar as informações de preços em bloco do livro de preços atual?`,
"label.partnerCloud.financeSetting.payments":`Permitindo o pagamento online`,
"lable.account.ThisWeek":`Esta Semana`,
"label.validate.function.funcFormat.RIGHT":`DIREITO(texto, num_chars)`,
"label.app.select.bgcolor":`Selecione a cor de fundo`,
"label.planned.work":`Trabalhos Planejados`,
"label.passwordPolicy.setup.nolimit":`Sem limite`,
"label.vlidaterule.s":`Se você desativar a moeda utilizada pelo usuário, a moeda do usuário será definida para a Moeda Corporativa.`,
"label.paging.totalofrecords":`Um total de {0} registros`,
"label.customobjects.behaviour":`Ações`,
"vue_label_ccchat_notice_deletecommentsuccess":`Comentário excluído com sucesso`,
"label.lock.record.dele":`O registro está bloqueado, não é possível apagá-lo.`,
"label.data.expnode.e.desc3":`3、Template Criar: o usuário pode fazer o modelo de acordo com os campos e condições que serão exportados para atender às suas necessidades, o que é conveniente para uso na próxima vez.`,
"label.button.step3.create.page":`Passo 3 Geração de páginas`,
"label.sharer":`Compartilhar de`,
"label.service.cycle.type":`Tipo de ciclo`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Taxa de Compromisso de Recibos Totais`,
"label.formuladate":`Formato da data: aaaa-MM-DD hh:mm:ss ou MM/DD/YYYYYhhh:mm:ss, como por exemplo: 2007-12-25 12:25:30 ou 25/12/2007 12:25:30.Você também pode usar hoje() ou agora();`,
"front-template-V1-addImg":`Adicionar foto`,
"label.basecontrol":`Acesso básico`,
"label.forecast.settings.lable1":`Agregação de Dados Previstos`,
"message.error.file.null":`O arquivo de upload não pode estar vazio`,
"label.multiply":`*Multiplicemente`,
"message.duplication.label.targetobject":`Objeto`,
"label.addattachment":`Adicionar anexo`,
"vue_label_dashboard_notice_editcertification":`Você tem certeza de que deseja editar o componente {nome}?`,
"label.notification.tip2":`Sem Novas Notificações`,
"lable.quote.syncingfrom.firstsync":`Sinc: Oportunidade de citação`,
"label.createtasktip":`Criar uma tarefa para associar com uma ou mais regras de fluxo de trabalho, processos de aprovação, ou processos de habilitação. Ao alterar uma tarefa, quaisquer modificações serão aplicadas a todas as regras, aprovações ou processos de habilitação associados a ela.`,
"label.leave":`Sair`,
"front-invoice-online-payment-setup-china":`Aplicar para contas chinesas`,
"label.appointment.wizard.subtitle4-1-2":`30 min`,
"label.projectManagement.the.person.not.be.informed":`Quando você seleciona Não, a pessoa responsável não pode ser notificada!`,
"label.campagin.roi.name":`Nome da campanha`,
"label.import.page1.newcreate":`Criar`,
"label.data.downpage.i.title.num2":`2、Before você começa a importar, certifique-se de que o nome do campo no arquivo que você deseja importar corresponda ao nome do campo objeto no CloudCC.`,
"label.callcenter.call.in":`Chamada em`,
"label.weixin.activity.phone":`Atividade: Ligue para`,
"label.forecast.customforecast.type.role":`Por Função`,
"label.moscow.standard.time":`Horário Padrão de Moscou`,
"label.profile.setcustomobjectrecordtype":`Configurações de tipo de registro personalizado`,
"lable.edit.queue.new":`Nova fila`,
"label.newAPPexchange":`Nova aplicação...`,
"message.custom.field.donotdelete.fieldupdate":`Este campo é referenciado por uma atualização de campo em outro fluxo de trabalho ou processo de aprovação.`,
"label.chatter.state":`Status`,
"label.subject_line":``,
"template.report.folder.active":`Análise de campanhas e ações`,
"label.icon.114":`Casa`,
"label.assignment.setup.newentries.step3":`Etapa 3 Selecione o usuário para atribuir o chumbo a`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Visão Geral do Comportamento Pessoal`,
"label.weixin.optiontwo":`Escolha 2`,
"label.sso.saml.idp.config.sp":`Prestadores de serviços`,
"System_TimeField_Description":`Permite que os usuários entrem em uma hora local. Por exemplo, "14:40", "14:40" e "14:40:00" são todos horários válidos para este campo.`,
"label.knowledgebase.draft":`Rascunho`,
"label.chat.topic.no.more.suggestions":`Nenhuma outra sugestão`,
"label.quote.product":`Produto`,
"label.cryptographictext":`Texto Criptografado`,
"label.custom.unlock":`Desbloquear`,
"label.assignment.setup.newentries.step2":`Passo 2 Selecione os critérios para esta entrada de regra`,
"label.tabularreport.selectline":`Selecione as colunas que você deseja incluir no relatório.`,
"label.exchange.sync.state.contact.m2":`Os registros foram sincronizados nos últimos 60 minutos:`,
"label.codeType":`Tipo de código`,
"saturday":`Sábado`,
"label.mask.type":`Tipos de máscaras`,
"label.schedulejob.setup.schedule.Monthly":`Mensalmente`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} campos no arquivo , {20}} não mapeados`,
"label.projectManagement.delete.item":`Todas as informações relacionadas a este projeto serão apagadas se você apagar o projeto, e os dados não podem ser recuperados. Você tem certeza de confirmar a exclusão?`,
"label.page.general.us.and.western.europe":`Línguas gerais dos EUA e da Europa Ocidental`,
"label.reportsSubscription.status":`Assinado`,
"label.discount.baifenbi":`Desconto (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Configuração de Avaliação Web`,
"message.error.searchwork":`Suas palavras-chave digitadas devem ter 2 ou mais caracteres.`,
"label.weixin.option.setting":`Configurações de escolha (até 10 escolhas)`,
"label.lead.score.prompt1":`Marcar um único registro de chumbo automaticamente ao criar ou editar. Mas você precisa pontuar manualmente vários registros de chumbo, ao importar ou criar por interface.`,
"label.exception.must.try.throw":`As exceções devem ser lançadas para fora em um bloco de estaca.`,
"label.activity.plan":`Plano`,
"label.partnerCloud.productSet.editor":`Opção de edição`,
"label.mobile.quickcreate.default.signinnew":`Faça o login`,
"label.summaryreport.2018.step6.new":`Passo 6 Selecione o tipo de gráfico e o item de destaque`,
"vue_label_homepage_owner":`Minha página inicial`,
"vue_label_dashboard_editfoldersuccessfully":`Editar pasta com sucesso`,
"label.quickbooks.view.overdueinvoices":`Faturas vencidas`,
"label.emailtocloudcc.redmessage4":`Por favor, insira os detalhes da porta`,
"label.tabpage.equalz":`Igual a`,
"lable.quote.syncing.firstsync":`Sinc: Citação inicial da Oportunidade`,
"label.download.CloudCCAPP":`Download do aplicativo CloudCC`,
"label.icon.6":`Moeda`,
"label.list.serial.number":`Número de série`,
"label.profile.setstandardobjectrecordtype":`Configurações de tipo de registro padrão`,
"label.customize.memory.function.sorting.error":`O tempo de resposta da consulta é muito longo e causa um timeout da página. Pode ser porque a memória de classificação de cabeçalhos está ativada. Por favor, vá para as configurações pessoais e desative esta função.`,
"message.view.addtoallusers":`Visibilidade dos usuários relacionados`,
"label.globaloperation.operationtype.record.phone":`Registrar uma chamada`,
"lable.opppdt.selPdt.searchresult":`Resultados da busca`,
"label.import":`Importação`,
"label.service.gantt.work.based.resources":`Recurso baseado nas horas de trabalho`,
"label_partner_template_detailimage":`Foto`,
"label.cpq.product.feature.option.count":`O mínimo de opções de produtos não pode ser maior do que o máximo de opções de produtos`,
"label.chatter.newtask":`Nova Tarefa`,
"font-trade-module-v1-invoice-total-price":`Total planejado de pagamentos`,
"setup_mainpage_label_welcome29":`Integração API padrão com produtos de terceiros`,
"label.data.exportall.all.btn":`Exportar todos os dados`,
"front-epwechat-module-v1-unbound-WeChat":`Desobrigar a WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Contratos de Vendas em Equipe - Valores Classificados`,
"label.import.page1.newcreateandupdate":`Atualizar e começar de novo`,
"component.chatter.post.button.file":`Acrescentar anexos`,
"label.partnerCloud.orderingPlatform.createOrder":`Novo pedido`,
"label.lookup.multiple.data":`Dados múltiplos encontrados, favor selecionar manualmente`,
"button.partner.save":`Salvar`,
"label.service.add.timeslot":`Acrescentar horário`,
"label.campaign.matchway.select.email":`Email`,
"front-sales-button-fromQB":`Atualização a partir do QuickBooks`,
"label.icon.108":`Flecha`,
"lable.outlook.edit.efmapping":`Mapeamentos de campo Editar`,
"label_tabpage_refreshz":`Atualização`,
"chatter.follow.cancel":`Pare de seguir`,
"label.totals.sum":`Total`,
"label.noRequest":`Nenhuma exigência`,
"vue_label_homepage_fixedcomponent":`Favor selecionar um componente fixo`,
"label.knowledge.delete.case":`Erro ao excluir o artigo do caso.`,
"label.weixin..xsld.yjwc":`Receita esperada`,
"label.customcomponent.page.index.console.btn":`Console do Desenvolvedor`,
"label.sendsms.batch":`SMS em massa`,
"vue_label_chat_onlychosechat":`Somente usuários da equipe podem ser selecionados para o bate-papo`,
"label.tabpage.page":`Página`,
"label.cyen.note":`Habilitar moeda. Note que a ação da moeda habilitada é irreversível.`,
"label.weixin.againsend":`Enviar novamente`,
"label.processnumber":`Etapa nº.`,
"label.emailobject.to":`Para:`,
"label.event.today":`Hoje`,
"label.dashboard.dispalyPosition":`Posição despalhada`,
"message.error.recalculate.dupoperate":`Recalculando, por favor, não opere com freqüência.`,
"vue_label_email_linkrecordsuccess":`Registro associado com sucesso`,
"label.updateoutboundnews":`Atualizar Mensagens de Saída`,
"label_emailtocloudcc_exists2":`Esta caixa de correio foi configurada para Enviar por e-mail para Case. Não repetir as configurações.`,
"label.tag.addtags.button2":`Cancelar`,
"label.stdashbord.xsld.business.role":`Este papel é tirado das funções de habilitação nas hierarquias de previsões`,
"label.commonnew":`Normal novo`,
"label.validate.remark2":`Amostra de uso:`,
"label.reportsSubscriptionPage.condition.checkbox":`Acrescentar condições a este relatório`,
"label.globalselect":`Conjunto de Valores da Lista Global de Opções`,
"label.partnerCloud.partnerAccount.available":`Quantia disponível`,
"label_tabpage_nothingz":`Nada`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Mapa do calor`,
"message.error.pleasecorrectdata":`Favor rever todas as seguintes mensagens de erro para corrigir os dados.`,
"label.hight.tip":`Quando o filtro avançado não está habilitado, a relação das diferentes condições de filtragem é "and", ou seja, um registro que satisfaz as características comuns de 1 e 2.`,
"label.workflow.estimatecondition3":`Criado ou cada vez que é editado`,
"AssetRelationship.time.limit.error":`A data de início deve ser anterior ou igual à data de vencimento.`,
"label.multilang.workflow.dayinmonth":`O {1} cada {0} mês(s)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Diariamente`,
"label.emailtocloudcc.step1.name":`Escolha a função`,
"label.follow_up":`Email de acompanhamento`,
"label.price.list.price.cannot.be.empty":`O preço de lista não pode estar vazio.`,
"label.chatter.link":`Link`,
"label.ccpeak.condition.return.record":`Retorna registros por condição e suporta condições "onde" comuns.`,
"pagecreator.layout.message.canntdelete":`O layout atual não é permitido excluir`,
"label.compact.layout.main":`Principal layout de informações-chave`,
"label.testandupdate":`Verificar por atualizações`,
"button_partner_cancel":`Cancelar`,
"label.activity":`Atividades`,
"label.knowledge.setting.hint.fourteen":`Prepare-se para escrever!`,
"vue_label_commonobjects_view_open_from_list":`Abra a partir da lista para começar`,
"front-electronic-export-intro":`2000 registros podem ser exportados para Mailchimp por uma vez`,
"label.chosen.all":`Todos os campos`,
"label.file.extension":`Extensão do arquivo`,
"vue_label_systemSettings_server_miniprogram":`Miniprograma de serviço`,
"label.weixin.no.pending.wdgz.qin.today":`Nenhum horário de trabalho para hoje.`,
"label_tabpage_issuez":`Edição`,
"label.staticresource.tip":`Use recursos estáticos para carregar o conteúdo que você deseja consultar em uma página personalizada, incluindo .zip, imagens, folhas de estilo, JavaScript e outros arquivos.`,
"label.approvalstep":`Passos para a aprovação`,
"label.china.standard.time":`Tempo padrão da China`,
"label.appexchange.download.tiaoguo":`Ignorar`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Incapaz de se submeter! Os itens exigidos não são preenchidos ou não estão de acordo com as regras.`,
"label.appointment.wizard.title1":`Definir a Disponibilidade`,
"label.chat.remove.bookmark":`Remover Bookmark`,
"label.tabpage.advancedsearch":`Busca avançada`,
"batch.ranf.f":`Os registros de transferência em massa falharam`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Contas`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Erro de parâmetro, favor entrar em contato com o administrador.`,
"label.object.create.two.number.field":`Podem ser criados até 2 campos personalizados de número automático por objeto.`,
"label.salecommit.not.roleinformation":`Você não tem nenhum papel e não pode visualizar os painéis de compromisso de vendas.`,
"label.defautline.cannot.less":`O número padrão de linhas não deve ser inferior a 1.`,
"label.selectedproducts":`Número de Produtos Selecionados`,
"label.productsales.today.notskadd":`Não há tarefas vencidas, você pode clicar em " " no canto superior direito para adicionar uma nova tarefa.`,
"lable.account.year.stadate":`Data de início do ano fiscal`,
"label.mobile.phone.month.plan2":`As Tarefas deste Mês`,
"label.ccpeakfolder":`Pastas de classe`,
"setup_mainpage_label_welcome21":`A plataforma CloudCC fornece a função de modelo de e-mail definido pelo usuário, que é conveniente para os usuários usarem e melhorarem a eficiência do trabalho.`,
"label.modify.layout":`Editar Layout`,
"report.label.folder":`Folders`,
"label.tianyancha.businessverify.rewritename":`Nome da conta de respaldo`,
"lable.currencyAdv.dao":`para`,
"label.mobilelayout":`Layout móvel`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`O modelo atual é ativado e não é editável.`,
"label_partner_all_disable":`Desativar`,
"label.ownerapproverfield":`Campo de Aprovação do Proprietário`,
"label.emailobject.template.message4":`Alguns dos campos inseridos na mensagem são nulos, favor editar e reenviar!`,
"label.productsales.today.notsk":`Não há tarefas em expiração.`,
"label.multilang.document.upload.success":`{0} os arquivos foram carregados com sucessolt e {1} os arquivos falharam`,
"label.manageAll.sta3":`Rejeitado`,
"vue_label_calendar_week_view":`Vista da semana do calendário`,
"setup_layout_label_nocustompage":`Sem páginas personalizadas`,
"label.weixin.wdyj.jxdcl":`Taxa de realização de desempenho pessoal`,
"label.donot.update":`Você não tem permissão para modificar!`,
"setup.mainpage.label.welcome14":`Gestão do processo de personalização do fluxo de trabalho, aprovação`,
"UG_Campaign_002":`Planejar, executar e monitorar a eficácia das atividades do mercado.`,
"label.layout2":`Layout Dois`,
"label.app.looup":`Encontrar aplicativos`,
"label.projectManagement.selectitem":`Por favor, selecione o projeto`,
"label.field.relating.rule":`Regras de associação dos campos de pesquisa`,
"vue_label_commonobjects_detail_selectname":`Por favor, selecione um nome primeiro`,
"front-email-payment-Invoice-select-pay":`Selecione Pagar por:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1,8 * Celsius__c 32`,
"component_event_label_enddate":`*End Time`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Limite de crédito`,
"label.chatter.newpost":`Último posto`,
"label.report_dashboard":`Este relatório será salvo em seus relatórios. Você também pode adicionálo a um painel de controle.`,
"label.assigned":`Atribuído a`,
"Homepage_News_002":`O componente de notícias não está disponível atualmente.`,
"label.approval.select.relatedobj":`Para selecionar o item relevante, ele deve escolher um tipo`,
"label.service.miniProgram.isTop":`Pegajoso na parte superior`,
"message.error.object.datatoolang":`O comprimento dos dados é muito longo, máximo {!comprimento} caracteres.`,
"label.importsourcetip":`A importação é projetada para aceitar os arquivos produzidos a partir de nosso processo de exportação. Se você não fez uma exportação, por favor, vá agora para a página de exportação.`,
"label.select.deadlineplease.deadline":`Por favor, selecione o prazo.`,
"vue_label_account_equityrelationship":`Relação de equidade`,
"label.account.Calendar.month":`Mês do calendário`,
"label.appointment.wizard.subtitle3-4":`Quinta-feira`,
"font-evaluate-module-v1-smaller-500":`O arquivo deve ser inferior a 500KB`,
"label.reportsSubscriptionPage.email.tome":`Enviado para mim`,
"label.ccchat.person.invite.existpers":`Já rastreado:`,
"label.appointment.wizard.subtitle1-3":`30 min`,
"front-kefu-moudle-connected":`Conectado`,
"label.campaignmember.main.duplicatelist.tip":`O sistema encontrará pistas duplicadas e membros da campanha com base nas configurações aqui.`,
"label.visualpage.such.tags.double":`Estas etiquetas aparecerão em par`,
"label.sendsms.batch.step2.introduce":`Favor selecionar um modelo de SMS.`,
"Account_News_Setting_002":`Use as configurações de conta abaixo para especificar o comportamento padrão da conta para sua organização.`,
"message.encryptchange.alert":`Você está prestes a converter {{!fieldapi}} de um campo de Texto Criptografado (Storage Encrypted) para um campo de Texto Criptografado (Display Encrypted), após a conversão bem sucedida, este campo será armazenado em texto claro no banco de dados, que pode ser exibido em texto claro ou texto criptografado de acordo com as configurações de perfil. Os campos são pesquisáveis.\r Esta operação é irreversível, você quer continuar?`,
"label.mainpageset.description":`Configure sua página inicial em nível organizacional com base em suas reais necessidades comerciais.<br>Os componentes em configuração padrão que não são relevantes para sua empresa podem ser desativados ou desligados.<br>Enable: os componentes habilitados são exibidos na página inicial de todos os membros.<br>Desabilitado: componentes desabilitados não são exibidos na homepage de todos os membros, nem serão exibidos na lista de "Configurar Minha Homepage" no app.<br>Desligar: componentes desligados não são exibidos nas homepages de todos os membros por padrão, e os usuários podem ligá-los por "Configurar Minha Homepage" no app.`,
"label_tabpage_linknamez":`Nome do link`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Moeda Corporativa atual`,
"label.campaignmember.main.duplicatelist.html.title":`Ajuste da remoção das duplicatas por meio de código de varredura`,
"label.sendsms.batch.step3.plan":`Plano de datas de entrega`,
"label.profile":`Perfil`,
"label.canceluploadfile.step":`Clique no botão Cancelar para cancelar todos os arquivos mostrados na área superior`,
"message.newreport":`Novo relatório`,
"label.service.newBuildDialog.date.selection":`Selecione a data`,
"label.lookup":`Consulta`,
"label.file.editinfo":`Editar detalhes do arquivo`,
"component_assistant_label_nodata":`Nenhum evento hoje, favor verificar mais tarde.`,
"label.tianyancha.businessverify.msg4":`Esta função usa serviços de terceiros e está atualmente disponível aos usuários gratuitamente. mas o CloudCC não garante que terceiros sempre fornecerão o serviço aos usuários gratuitamente. se terceiros cobrarem uma taxa, o CloudCC tem o direito de cobrar ou impedir o usuário de usar esta função.`,
"label.noequal":`!=Não Igual`,
"vue_label_metric_column":`A tabela deve ter pelo menos 1 coluna de avaliação.`,
"label_reportType_chose_and_form":`Selecione a fonte de dados do relatório e um formato de relatório`,
"vue_label_pool_reasondescription":`{0} descrição do motivo`,
"label.isusing":`Ativo`,
"label.passwordPolicy.setup.pwdremember5":`5 senhas lembradas`,
"label.cancel":`Cancelar`,
"vue_label_helpcenter_detail1.1":`atividades, e dinâmica de cada registro, e dobrar ou desdobrar as informações correspondentes no canto superior direito do módulo. Você também pode visualizar e gerenciar os dados associados ao registro através da lista relacionada.<br> 1. Você pode editar, copiar, apagar ou compartilhar dados para outro pessoal através dos botões no canto superior direito.<br>Ver as informações detalhadas do usuário, e você pode editar diretamente alguns campos na página para alterar o proprietário ou tipo de registro dos dados.<br>Ver e gerenciar os dados associados com o registro através da lista relacionada. Na lista relacionada ao arquivo, faça o upload do arquivo gravado, ou clique no nome do arquivo para baixar e visualizar o arquivo correspondente.<br> 2. Listas relacionadas<br>Conectar-se rapidamente através da lista relacionada, e usar a janela flutuante para visualizar até 10 registros relacionados. Clique para entrar na lista, visualizar todos os registros relacionados e editar inline.<br>Utilizar o layout da placa para visualizar e gerenciar os registros relacionados abaixo.<br> 3. Atividades<br> Na página de detalhes gravados, a versão Lightning não exibe as duas listas relacionadas de "atividades não processadas" ou "histórico de atividades". Ao invés disso, é exibida a linha do tempo de atividades.<br>Linha do tempo de atividades exibindo conteúdo<br> A linha do tempo de atividades pode exibir todas as atividades que do futuro para o passado no registro atual. Tarefas vencidas e próximas tarefas e eventos são exibidas no módulo "Vencidas e Vindouras" da linha do tempo do evento. Tarefas passadas ou atualmente concluídas, eventos, chamadas gravadas, e-mails e mensagens de texto serão exibidas no mês correspondente.<br>`,
"registration.page.preview":`Pré-visualização da página de registro`,
"label.quickbooks.search":`Busca`,
"label.setup.mobile.bottombutton.tab.show":`Afixação da aba na parte inferior`,
"lable.want.to.delete.tem":`Você tem certeza de que deseja excluir o modelo de relatório de serviço {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Modificar {0} de {1} para {2}.`,
"vue_label_pool_return":`Retornar`,
"vue_label_calendar_failed_to_share_calendar":`Falha no calendário de compartilhamento`,
"label.less":`< Menos do que`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Sem registros`,
"label.setarticlecon":`Especificar os critérios de entrada`,
"label.searchlayout.displayrow":`Colunas a serem exibidas`,
"label.change.task":`Visão da tarefa`,
"lable.quote.editqtpdt.title":`Itens de linha de cotações Editar`,
"label.appointment.wizard.subtitle4-4":`Até que ponto no futuro alguém pode reservar você?`,
"label.custom.page.button.css":`Botão CSS`,
"label.input.documentmessage":`Entrar detalhes`,
"vue_label_commonobjects_detail_email_address":`Endereço do destinatário`,
"label.chatter.filterTimeLine":`Linha do tempo de filtragem`,
"label.must.select.twoorthree.records":`Você deve selecionar dois ou três registros para fundir`,
"label.mobile.setup":`Configuração de aplicativos móveis`,
"vue_label_commonobjects_detail_key_field":`Campos chave`,
"label.chatter.relateitem":`Relacionado a`,
"label.customobjects.tip":`Uma vez criado um objeto personalizado, você pode criar uma aba personalizada, listas relacionadas, relatórios e painéis para os usuários interagirem com os dados do objeto personalizado. Você também pode acessar dados de objetos personalizados através da API.`,
"label.sso.saml.idp.config":`Provedor de Identidade`,
"label.knowledgebase.affect.article.version":`A modificação afetará a tradução existente? Se sim, você pode marcar a preciosa tradução como "Expirada" e gerar uma lista de pendentes para tradução para os fornecedores de tradução.`,
"message.error.record":`O registro correspondente não foi encontrado!`,
"message.duplication.label.fieldname":`Campo`,
"setup.layout.button.cancel":`Cancelar`,
"label_radar_map_function":`Use gráficos de radar com múltiplas métricas para medir o papel dos contatos na cadeia de decisão de vendas.`,
"label.campagin.roi.fss":`Número Enviado`,
"label.emailobject.template.giveup":`Cancelar`,
"label.apiname.exists":`O nome API já existe.`,
"message.failtoreaddata":`Dados lidos falharam`,
"label.file.versionedit":`Modificador de conteúdo`,
"template.report.lost.business.opportunity":`Oportunidades perdidas`,
"label.ccchat.group.allowgd":`Permitir o arquivamento de grupos`,
"label.fieldaccesslimit":`Acessibilidade de campo`,
"label_target_model":`Modelo alvo`,
"message.validation.isnoturl":`URL inválido`,
"servicecrew.member.time.conflict":`Dentro deste intervalo de tempo, os recursos de serviço se tornaram membros de outras equipes de serviço.`,
"label.knowledgebase.delete.details":`Ele excluirá qualquer informação de atribuição.`,
"vue_label_normal_bottom":`Fundo`,
"label.custombutton.editerror":`A edição falhou`,
"label.dashboardSetup.showdw.d6":`Automático`,
"message.error.field.decimalPlaces":`Erro no formato de entrada decimal.`,
"label.tabpage.busoppnamez":`Nome da oportunidade de negócios`,
"label.insertfield.intro":`Favor selecionar um campo e clicar em "Inserir". Com o ">" significa clicar para ver mais campos disponíveis.`,
"setup.layout.label.nocustompage":`Sem páginas personalizadas`,
"front-gantt-module-project-has-only":`Este projeto tem apenas {n} marcos`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Conta de e-mail conectada`,
"label.customcomponent.check.name.same":`Este nome já existe.`,
"label.validate.function.funcFormat.HOUR":`HORA(data)`,
"label.approvepagelayout4":`Copiar o layout da página anterior`,
"label.knowledge.category.hint.nine":`Ativar Grupo de Categoria`,
"label.report.sorting.column":`Coluna Ordenar`,
"label.hours":`Relógio`,
"label.email.clearAllemail":`Você quer esvaziar todos os e-mails sincronizados na caixa de correio?`,
"font-evaluate-module-v1-satisfaction":`Avaliação Satisfeita`,
"label.service.hide.more.info":`Esconder mais informações`,
"label.area.list.intro":`Você pode editar informações sobre o território nesta página.`,
"label.sendemail.chat.addPostat":`Prezado #nome:{\i1}olá! #userName mencionou você em um micropost.`,
"label.data.newtemplate.e_seltype.desc":`Há dois tipos de dados derivados</li><li class="titledesc1">1.um é o formato CSV(o padrão)</li><li class="titledesc1">2.o outro é o formato de compressão. O modo de formato de compressão é dividido em dois tipos</li><li class="titledesc1">2.1.um tipo é a geração automática de senha de arquivos compactados, a senha gerada automaticamente será enviada ao usuário após a caixa postal de exportação de dados bem sucedida</li><li class="titledesc1">2.2.outro é digitar manualmente a senha dos arquivos compactados, a senha de entrada manual não será enviada à caixa postal do usuário, portanto a necessidade de os usuários se lembrarem da senha.`,
"message.passwordPolicy.validate.minlengths":`Erro: Sua senha deve ser pelo menos`,
"message.save":`Você tem certeza de que quer economizar?`,
"label.marketsea.notfollowdays1":`Depois de obter`,
"label.app.step1":`Passo 1 Selecione o tipo`,
"message.error.pageid.null":`O ID da mídia social do Facebook não pode estar vazio!`,
"label.weixin.input.lookupfield":`Digite palavras-chave para encontrar o micro voto correspondente`,
"label.whChatAccount":`Conta WeChat`,
"label.tabpage.groupingitem":`Item de agrupamento`,
"label.callboard.introduce":`Todos os anúncios de sua empresa estão listados abaixo.`,
"label.financial.services.seminar":`Seminário de Planejamento Financeiro`,
"label.data.file.i_title.num1":`1. O arquivo importado deve ser um arquivo em formato CSV. O arquivo deve conter um título e não pode ser importado sem título.`,
"label.visualpage.filename.exist":`O nome do arquivo já existe.`,
"front-kefu-moudle-v1-new-chats":`Novo agente`,
"label.console.step5.tab":`aba aberta`,
"vue_label_opportunity_contactrole_edit":`Editar funções de contato`,
"label.projectManagement.delete.return":`Ele retornará à página anterior após a exclusão dos últimos dados.`,
"registration.page.designs":`Página de Aparência para Registro`,
"label.console.step6.heigth":`Heigth`,
"label.objectRelationshipAtLeast":`ter pelo menos um registro relacionado a`,
"label.knowledge.delete.viewstat":`Erroe ao apagar os dados de navegação do artigo de conhecimento`,
"label.direct.dashboard.month.report":`Nova Nota Mensal de Trabalho`,
"label_tabpage_lookatmorez":`Veja mais`,
"label.setup.rights.management":`Gestão dos direitos`,
"label.campaign.channel.clear.img":`Imagem clara`,
"label.calendar":`Calendário`,
"label.biaoqingfaxian.username":`Conta`,
"label.weixin.wdyj.jxht":`Contratos de Performance de Vendas Pessoais`,
"label.emailtocloudcc.exists1":`Esta caixa de correio foi configurada para enviar um e-mail para Lead. Não repetir as configurações.`,
"label.emailtocloudcc.filed.password":`Senha`,
"label.what_create":`Que tipo de formulário você deseja criar?`,
"vue_label_report_onlydisplaypart":`Um máximo de 50 dados pode ser exibido, e exibir todos os dados após a execução.`,
"label.up":`Para cima`,
"label.addattachment.edit":`Edição de anexos`,
"label.ccchat.message.search.desc5":`As palavras de busca não podem ser inferiores a 2 caracteres`,
"label.chose.nonotice":`Favor selecionar o registro que não mais o lembre`,
"UG_activity_06":`Deseja acompanhar com contas`,
"label.set_contactsmarketing":`Definir como contato da campanha`,
"pagecreator.layout.button.horizontal":`Desmontagem lateral`,
"label.brief.opportunity2":`Oportunidades esperadas para fechar`,
"label.ems.nomsg":`Não configurado`,
"label.fieldupdate.tip":`As atualizações de campo permitem que você altere automaticamente um valor de campo para aquele que você especificar. As atualizações de campo são ações associadas às regras de fluxo de trabalho e processos de aprovação.`,
"label.sso.saml.sp.federationid":`ID da Federação`,
"label.import.page2.suited":`Mapeado`,
"message.error.appexchange.integrity":`Assegurar a integridade dos componentes no pacote de upload.`,
"label.fielddatatype":`Tipo de dados de campo`,
"message.approval.cannotsubmit.detail2":`O registro deve satisfazer os seguintes critérios ou a fórmula avalia-se como verdadeira, caso contrário, o pedido de aprovação não pode ser submetido, por favor, reapresentar o pedido após a modificação.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Selecione a coluna na qual o agrupamento de relatórios se baseia`,
"label.tabpage.norecordtypez":`Tipo de registro inutilizável`,
"label.icon.141":`Moeda`,
"label.addattachment.step3.intruduce":`Se você estiver fazendo o upload, isto cancelará o upload em andamento.`,
"label.trigger.recursive.call.three":`Os gatilhos podem ser chamados interativamente, o número de loops é limitado a 3 vezes, se mais de 3 vezes o sistema terá um prompt de erro.`,
"maintenanceplan.workorder.type.asset.workorder":`Favor escolher "Uma ordem de trabalho para cada ativo" como o tipo de ordem de trabalho de geração.`,
"label.emailtocloudcc.select1":`Favor escolher`,
"label.system.log":`Log de auditoria de configuração`,
"vue_homepage_dashboard_not_support_fullscreen":`Desculpe, seu navegador não suporta tela cheia.`,
"label.projectManagement.nodata.resource":`Ainda não envolvido em nenhum projeto. Adicionar "Meu" projeto aos membros para ver a alocação de tempo dos membros da equipe.`,
"label.exchange.sync.state.contact":`Contatos`,
"label.field.type":`Tipo de campo`,
"label.selected.object":`Objeto Selecionado`,
"label.customfields.new.step2":`Passo 2 Digite os detalhes`,
"label.monitorsys.delete.style":`Tipos de operação`,
"label.projectcondition":`Critérios de entrada`,
"potential.customers.field.default":`Ajuste padrão dos eletrodos`,
"message.password.nosame":`As senhas não correspondem.`,
"label.validate.function.funcExplain.MONTH":`Retorna o mês, que é um número entre 1 (janeiro) e 12 (dezembro)`,
"label.project.user.project.count":`Número de Projetos em que os Usuários Participaram`,
"chatter.to":`para`,
"vue_label_commonobjects_detail_activity_owntask":`tarefa própria`,
"label.generate.mobile.page":`A página móvel é completada.`,
"label.escalation.setup.newentries.step1":`Passo 1 Defina a ordem na qual esta entrada de regra será processada`,
"label.email_footer":`Rodapé de email`,
"label_partner_workspace_member_profile":`Perfis disponíveis`,
"label.loginhis.between":`data de início distância data final não pode exceder 2 meses`,
"label.user.verficationcode.error":`Código de verificação incorreto.`,
"label.email_notifications":`Enviar notificação de envio por email`,
"APPIntegration_Dropbox_01":`Selecione arquivos da Dropbox`,
"label.projectManagement.Selectweek":`Selecione a Semana`,
"wednesday":`Quarta-feira`,
"message.atleastonereceiver":`Por favor, selecione pelo menos um destinatário`,
"label.applt.link.text":`Ligamos sua empresa ao mini programa do portal. Copie o endereço do portal do mini programa dedicado a sua empresa, coloque o endereço do mini programa no link de acesso ao menu oficial de acesso de sua empresa, depois os clientes podem clicar no menu para usar o mini programa. (Menu oficial de conta personalizada < Saltar para o mini programa < Caminho do mini programa)`,
"label.wait.for.a.moment":`Por favor, aguarde um momento enquanto estabelece o idioma...`,
"vue_label_chatter_only_group_members_look":`Somente os membros do grupo têm acesso à visualização, você pode tentar se inscrever para entrar no grupo`,
"label.knowledgebase.last.release":`Publicado pela última vez`,
"component.setup.label.pagesize":`Itens por página`,
"label.paging.totalofpages":`Um total de {0} páginas`,
"label.globaloperation.successmessage":`Mensagem de sucesso`,
"label.logout":`Logout`,
"label.partner.common.enable":`Habilitar a nuvem de parceiros`,
"label.permission.objectpermission.goback":`Voltar para a lista: Conjuntos de permissões`,
"label.approvalstep5.required":`Obrigatório`,
"component_chatter_label_to":`Para`,
"message.please.choose.role":`Por favor, selecione a função`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`Você deve selecionar o item do contrato sob o contrato de serviço associado ao plano de manutenção.`,
"label.projectManagement.Resource.usage.view":`Visão da utilização dos recursos`,
"label.smsmainbody":`Texto da mensagem`,
"label.ccchat.error.nullname":`O nome é obrigatório`,
"label.appupload.upload.version":`Número da versão`,
"label.data.setok.t_desc2":`Voltar à página de modelo de dados`,
"vue_label_pool_allocationstatus":`Status de alocação`,
"label.tianyancha.orgapprovedinstitute":`Instituto aprovado pela Org`,
"label.quickbooks.searchlist.startdate":`Data de início`,
"label.setapp":`Configurações do aplicativo`,
"chatter.about":`Sobre mim`,
"label.layoutname":`Nome do layout da página`,
"label.icon.160":`Terra`,
"label.tabpage.Rolesz":`Papéis e subordinados`,
"label.console.step5.introduce":`Escolha como exibir`,
"label.customfields.totalsummary.gettogetherfield":`Campo a agregar`,
"message.appexchange.addtopackage.profile":`Apenas um componente de perfil pode ser adicionado em um pacote!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Pagamentos detalhados`,
"homepage.components.three":`Passo 3 Digite o conteúdo do display de componentes personalizados`,
"nine":`Nove`,
"label.marketsea.button.restore":`Restaurar`,
"label.forecast.editshrepage.desc2":`O compartilhamento individual só pode ser usado para conceder maior acesso aos dados, não para restringir o acesso.`,
"label.cloudccsite.list":`Sites`,
"label.icon.35":`Nuvem`,
"vue_label_pricebook_price":`Acrescentar preço padrão`,
"label.version.sum.addressfield":`Campo(s) de endereço(s)`,
"label.projectManagement.Gotomilestone":`Volte-se para o marco miliário`,
"label.dataimport.name.length":`Erro: o comprimento do nome é muito longo.`,
"label_alculation_method":`Método de caculação`,
"label.uploadfile":`Carregar arquivo`,
"label.ems.otheraccount":`Outra conta`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Com certeza você vai se juntar a esta equipe`,
"message.error.chatter.img.nodata":`Erro: o arquivo de imagem não existe e não pode ser capturado.`,
"component.chatter.file.button.files":`Selecione um documento`,
"label.salescloud.teamrole.optionlist.choose.null":`O nome da função é necessário`,
"label.yourexportsuc":`Seu pedido de exportação foi processado, por favor, veja seu e-mail.`,
"pagecreator_systemstyle_label_modifycolor":`Editar cor`,
"label_partner_setup_title":`Configurações`,
"label.chat.topic.topic":`Tema`,
"file.error.nottype":`Erro: tipo inválido. tipos de arquivo que podem ser carregados são txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Todo o tempo`,
"homepage_componet_approval_label":`Itens a serem aprovados`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pagador N° Mercador`,
"label.user.resetpw":`Redefinir senha`,
"label.exchange.sync1":`Após criar uma conta de serviço com permissões de personalização para os usuários no Microsoft©Exchange, insira as credenciais da conta de serviço para permitir que o CloudCC se comunique com o servidor do Exchange.`,
"label.import.index.editfield":`Editar mapeamento de campo`,
"and":`E`,
"label.partnerCloud.cloudInfrastructure":`Configuração básica da nuvem de parceiros`,
"label.escalation.setup.newentries.createdate":`Quando o caso é criado`,
"Pagelayout.Setup.002":`Você selecionou 3 listas relacionadas e adicionar mais listas relacionadas afetará o layout da página.`,
"label.customfields.file.tip":`Permitir que o usuário carregue um arquivo entre 1 e N.`,
"label.tianyancha.businessverify.accname":`Consulta do nome do cliente em tempo real`,
"label.Additional.Conditions":`Filtrar a nomeação do serviço de acordo com condições adicionais.`,
"label.emailtocloudcc.filed.type":`Fornecedor`,
"vue_label_homepage_fixedcomponents":`Componente padrão`,
"label.visualpage.delerror":`Eliminar falhou, por favor tente novamente mais tarde.`,
"label.tabpage.filetypez":`Tipo de arquivo`,
"label.emailobject.search.input":`Busca`,
"label.createprocessstep2":`Etapa 2 Especificar critérios de entrada`,
"label.weixin.inhead":`Processamento`,
"component.recdetail.label.title":`Informações detalhadas`,
"label.weixin.telephone":`Número de telefone`,
"label.web.link":`Link web`,
"label.partnerCloud.paySuccess":`Pago com sucesso`,
"label.case.adress.link":`Portal de atendimento ao cliente na Web`,
"label.emailobject.view.connectopp":`Emails Conectados com Oportunidades Abertas`,
"front-kefu-moudle-think-again":`Deixeme Pensar de Novo`,
"label.Button":`Botão`,
"chatter.pt.most":`O tamanho máximo do arquivo é de 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Dias antes da data de nível`,
"label.ems.relatedobj":`Objeto relacionado`,
"label.notification.insert.approval":`[提交人] submete [对象] para sua aprovação`,
"label.setting.codeSet":`Conjunto de códigos`,
"vue_label_report_rowlevelformula":`Fórmula em nível de linha`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Copyright © 2008-2022 CloudCC Inc. Todos os direitos reservados.`,
"component.setup.button.save":`Salvar`,
"label.emailsync.button.sure":`Confirme`,
"label.multilang.dupicatecheck.getdatalist":`O {0}--grupo de dados duplicados, tem um total de {1} registros:`,
"label.ccchat.person.invite.tochat":`Convidar pessoas para o CCChat`,
"label_partner_all_maxNum":`Máximo de dados da nuvem de parceiros:`,
"label.checkfield":`Configurações de campo para encontrar duplicatas`,
"label.sales.dashboard.income":`Objetivo da receita`,
"label.setup":`Configuração`,
"label.dashboardSetup.center":`Médio`,
"lable.quote.syncing.finished":`Tradução: Equipa PT-Subs`,
"vue_label_helpcenter_dashboard1":`A fim de ajudá-lo a exibir dados estatísticos de forma mais intuitiva, o painel de controle do CloudCC Sales Cloud Lightning fornece a você uma poderosa capacidade de produção de gráficos.<br> CloudCC Sales Cloud Lightning versão painel de controle tem as seguintes características<br>Capacidade de usar diferentes fontes de dados: você pode selecionar os dados originais em uma visualização sob o objeto como fonte de dados, ou você pode selecionar os dados após o relatório ser processado como fonte de dados<br>??até 13 tipos de modelos de gráficos para você escolher: suporte a funil de vendas, apontador, gráfico de torta, histograma secundário agrupado, etc. <br> Arraste e solte livremente para mudar o tamanho e a posição do gráfico: o painel pode distinguir dados importantes e dados auxiliares colocando a posição e o tamanho de diferentes gráficos, que ficam completamente a seu critério<br>Filtragem geral do painel de instrumentos: O painel de controle suporta a filtragem dos dados do gráfico embutido com campos de filtragem definidos por faixa de tempo e usuário<br>?cache de dados: os dados do gráfico do painel de controle podem ser armazenados em cache quando são criados pela primeira vez, reduzindo o tempo de carga secundária. <br>Penetração de componentes: Você pode pular para os detalhes do relatório correspondente ou para a lista de registros na visão correspondente do objeto clicando no componente<br>Ligação de componentes: No mesmo painel, um componente pode configurar outros componentes da mesma fonte de dados para interagir com ele mesmo. Ao clicar na área de dados no componente, outros componentes podem ser definidos para recontar os dados de acordo com as condições de filtragem desta área de dados<br> 1. Como representante de vendas ou gerente do departamento de vendas, você pode exibir seus dados de vendas fazendo painéis de controle. A versão Lightning do CloudCC Sales Cloud fornece recursos ricos para fazer dashboards<br>Nota: Os dados da versão Lightning do dashboard e da versão antiga do dashboard não são interoperáveis. <br> Clique na aba "Dashboard", clique em "New Dashboard", preencha o nome do painel e selecione a pasta na qual você deseja salvar este painel. Você pode inserir um novo painel de controle.`,
"label.layout.availabletab.trackrecord":`Registros de Rastreamento`,
"label.campaignmember.main.deletecontact":`Remover Contatos de Membros-Existentes`,
"lable.outlook.mcto.emaltoc":`Quando os e-mails são enviados para o CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`As configurações de cache off-line foram salvas com sucesso.`,
"label.timezone.default":`Fuso horário padrão`,
"label.noRules.have.been.enabled":`Sem regras habilitadas.`,
"label.ccchat.person.invite.existsend":`Alguns dos endereços de e-mail que você inseriu correspondem aos usuários existentes.`,
"label.work":`Trabalho`,
"actualstarttime.actualendtime.time.illegal":`A hora real de início da nomeação do serviço deve ser menor ou igual ao tempo real de término.`,
"lable.product.stsp":`Preço padrão de instalação`,
"vue_label_normal_account_sf":`Conta`,
"label.finishpic":`Gráficos Gerados`,
"label.h5.similar.opportunity.step3":`Passo 3 Selecione os campos a serem exibidos para oportunidades similares`,
"label.relateobjDefault":`Registro de inadimplência`,
"label.customcomponent.check.tag.endwith":`O componente deve terminar com a etiqueta`,
"label.related.organization":`Oportunidade relacionada`,
"label.recordtype.edit.selectvalue.orderby":`Lista de opções de valores`,
"vue_label_homepage_enter_name":`Por favor, digite um nome`,
"label.permission.group":`Grupos de Permissão`,
"label.emailobject.send":`Enviar`,
"label.ralateuser":`Usuários relacionados`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(data,num)`,
"label.tablayoutedit.remark2":`Selecione os campos exibidos na página inicial da guia.`,
"setup_mainpage_label_welcome3":`A criação de formulários na plataforma CloudCC baseia-se em bancos de dados personalizados (objeto), objetos definidos pelo usuário são tabelas de banco de dados que armazenam dados específicos de sua organização. As relações tabela a tabela podem ser facilmente estabelecidas sem qualquer desenvolvimento de programa.`,
"label.user.notallowed.login.scope":`Você não está autorizado a entrar no sistema dentro do prazo ou seu IP é restrito.`,
"label.tel.ten.case":`Você pode digitar até 10 números de telefone para receber notificações, cada número é separado por ",".`,
"front-kefu-moudle-v1-user-info":`Informações ao usuário`,
"label.aboutme":`Sobre mim`,
"label.setfieldediting.tip":`Quando você define as etapas de aprovação, você pode atribuir pedidos de aprovação a diferentes usuários. Uma de suas opções é usar um campo de usuário para encaminhar automaticamente estas solicitações. Se você quiser usar esta opção para qualquer uma de suas etapas de aprovação, selecione um campo da lista de seleção abaixo. Além disso, quando um registro estiver em processo de aprovação, ele será sempre bloqueado - somente um administrador poderá editá-lo. Entretanto, você pode optar por permitir que o aprovador atualmente designado também edite o registro.`,
"label.existing_dashboard":`Adicionar ao painel de instrumentos existente`,
"label.sendemail.spotsign":`Prezado #nome: o membro da campanha #cliente que você convidou para #atividade chegou e assinou, por favor note que.`,
"UG_solution_01":`Fornecer a solução`,
"label.tianyancha.estiblishtime":`Tempo Estiblish`,
"label.pc.lightningpage":`Aplicação leve (beta)`,
"label.saveAndSync":`Salvar e sincronizar`,
"label.state.end":`Concluído`,
"label.sendemail.queue.assigninfo":`Filas: [#queueName] tem atribuído #objectName: #recordName`,
"label.approvalprocessname":`Nome do Processo de Aprovação`,
"label.view.conditions.message":`Filtrado por {!condições}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Conta comercial Alipay`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Por favor, configure pelo menos uma conta de pagamento on-line`,
"label.step1.total6":`Etapa 1 de 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min`,
"label.emailobject.markasread":`Marcar como lido`,
"message.error.orgid.null":`orgid não pode ser nulo!`,
"label.emailtemplate.mergefield":`Fundir valor de campo`,
"label.weixin.recent.list":`Listas vistas recentemente`,
"label.emailsync.form.email":`Email`,
"label.funnel":`Funil`,
"label.logintime.clear":`Tempo livre`,
"label.chatter.followed":`Seguiu-se`,
"label.ccpeak.function.field.spack":`Os campos em uma função devem ter seiva de ambos os lados.`,
"label.setup.mobile.offlinecache.remark":`Após habilitar esta função, os membros da organização podem criar, editar e excluir registros enquanto estiverem offline com dispositivos móveis`,
"label.product.function":`Categorias de embalagens`,
"label.icon.14":`Martelo`,
"message.report.nodata":`Nenhum dado foi devolvido.`,
"label.please.ChooseMin":`Favor escolher pelo menos {a} opções de produtos`,
"label.tabpage.releaseTourz":`Publicar guia`,
"vue_label_chat_opportunity":`Equipe de Oportunidades`,
"vue_label_chatter_refucecertification":`Você tem certeza de recusar "{nome}" para se juntar ao bate-papo da equipe?`,
"label.version.unlimited":`Ilimitado`,
"label.processsetting.enable.prompt":`Após habilitado, o caminho para as configurações estará na página de detalhes correspondente à versão relâmpago. Você também pode salvar as configurações primeiro e habilitar depois.`,
"label.page.display.property":`Propriedades de exibição`,
"label.service.appointmentList.thisOption":`Não verificado`,
"label.register.date":`Data de registro`,
"label.brief.contract.amount":`Montante do contrato`,
"setup.object.field.dependency.label.actionfieldnotnull":`Por favor, selecione primeiro um campo de controle.`,
"UG_homepage_009":`Acesso CRM`,
"label.icon.98":`Folder`,
"label.weixin.datacount":`Total`,
"label.mobile.hasbind":`Este número móvel tem sido utilizado. A última ligação será liberada se você continuar a amarrar.`,
"label.emailtemplate.choosemorecontacts":`Selecione mais destinatários`,
"setup_layout_button_deleteitem":`Remover os itens selecionados`,
"vue_label_account_collection_plan":`Plano de coleta não processada`,
"label_chatter_maturiyDate":`Data de expiração`,
"label.emailtocloudcc.license":`Licença`,
"vue_label_checkduplicate_complete_check_rules":`Favor completar as regras de verificação duplicadas`,
"chatter.up.type":`Você pode carregar um arquivo jpg, gif ou png.`,
"label.attendance.nocheckout":`Não Check-Out`,
"label.setup.mobile.offlinecache.remark2":`As guias selecionadas serão ativadas nos dispositivos móveis de todos os usuários de sua organização como as guias padrão de cache offline.cada usuário pode desativar as guias de cache offline das configurações organizacionais, ou ativar outras guias como guias de cache offline, dependendo de suas necessidades.`,
"template.report.count.marketing.activities":`Campanha Total`,
"label.multilingual.tip4":`Se o multilíngue estiver desabilitado, o idioma padrão da empresa será definido para chinês ou inglês com base no endereço da empresa, e o idioma de todos os usuários será definido para o idioma padrão da empresa.`,
"label.settings_area":`Área de ajustes`,
"label_assessment_content":`Conteúdo da avaliação`,
"label.top":`Top`,
"UG.Account.06":`Criar uma conta`,
"label.emailtocloudcc.step1.case2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registrados como registros de caso no CloudCC. De acordo com a caixa de saída, relacionar o caso ao contato e conta correspondentes, de modo a facilitar a aceitação e o acompanhamento dos casos.`,
"label.forecast.forehistory.best.remark":`Notas sobre os melhores casos`,
"label.project.problem.date":`A data de emissão deve estar dentro do intervalo de datas do marco ou projeto ao qual ele pertence.`,
"label.forecast.customforecast.foredis.wzs":`Números completos`,
"message.setup.field.name.value.notexists":`O valor da lista de papéis da equipe que você inseriu não existe, por favor, entre novamente.`,
"label.salescloud.teamrole.opportunity.organization":`Os membros da equipe podem ter maior acesso a esta oportunidade do que as configurações padrão de acesso a oportunidades de sua organização.`,
"label.sms.message.input":`Por favor, digite a mensagem`,
"label.document.type.not.allow":`Este tipo de documento não pode ser carregado!`,
"label.customfields.totalsummary.tip":`Um campo somente leitura que exibe a soma, o valor mínimo ou máximo de um campo em uma lista relacionada ou a contagem de todos os registros listados em uma lista relacionada.`,
"label.tabpage.filesizez":`Tamanho do arquivo`,
"label.import.page2.filedname":`Nome do arquivo`,
"label.same.analyze":`Minha análise de oportunidades similares`,
"label.service.gantt.refreshData":`Atualizar os dados após atualizar a página.`,
"label.sendsms.batch.step2.sendbycontext":`Enviar por conteúdo SMS personalizado`,
"UG_Account_05":`Diagrama da estrutura de contato`,
"label_emailtocloudcc_step1total3":`Etapa 1 de 3`,
"label.weixin.no.history":`Nenhum registro histórico`,
"label.datamanage.queryfield.error":`Erro de campo de consulta.`,
"label.emailmerge.mergeFolder.emailmerge":`Modelos de fusão de correio`,
"label.workflow.estimatecondition":`Critérios de avaliação`,
"label.autonumberfield.wrong":`Por favor, digite um número de 0-{0}`,
"label.data.setok.t.desc1":`Se você precisar usar este modelo de dados derivados, por favor clique`,
"label.data.downpage.i.title":`Etapas de importação de dados:`,
"label.data.downpage.i_list.desc2":`Após a importação dos dados, você receberá um e-mail lembrando-o da importação com sucesso.`,
"label.opportunity.jieduan":`Estágio atual`,
"vue_label_commonobjects_view_sumby":`Método agregado`,
"label.knowledge.setting.hint.three":`Nós podemos prepará-lo para a operação. Aqui está o que você precisa preparar:`,
"page.activity.history":`Histórico de atividades`,
"label.cancelQuoteLineGroup":`Cancelar grupo de linha de cotação`,
"label.addattachment.batch.step3":`Passo 3 clique no botão para terminar.`,
"label.chat.topic.follow":`Siga`,
"label.import.page1.uploadcsvfiled":`Arraste ou clique para carregar o arquivo CSV`,
"label.batchtransfer.datetype.tip":`Para os campos de data, digite o valor no seguinte formato:`,
"vue_label_systemSettings_application_util":`Console de gerenciamento de aplicações`,
"label.partner.workspace.member.selectedpermission":`Conjunto de permissões selecionadas`,
"label.service.appointmentList.plansToEnd":`Plano final`,
"label.industrialandcommercialverification.contactinformation":`Chamada para compra ou perguntas 400-642-2008`,
"chatter.del.p":`Apagar este posto`,
"label.forecast.customforecast.replacefirst":`Substituído por mim`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Nome da Regra de Pontuação`,
"label.weixin.appr.applicant":`Apresentado por`,
"component_event_label_calendar":`Ver calendário`,
"step":`Etapa`,
"label.attendance.setting.position.alert":`O trabalhador de escritório deve definir o local de referência.`,
"label.end":`Concluído`,
"label.mobile.change.owner.success":`mudou para o novo proprietário`,
"label.chinese":`Chinês`,
"label.textmessage.vonage.account":`Informações sobre a conta`,
"front-console-no-related-contact":`Por favor, associese primeiro ao contato`,
"label.dashboardSetup.seltype":`Tipo de Componente Opcional`,
"chatter.follow.user":`Siga este usuário`,
"label.textmessage.sentsuccess":`Enviado com sucesso`,
"label.australian.gentral.standard.time":`Horário de verão central australiano （South Australia）`,
"label.validate.function.funcFormat.AND":`E(lógico1,lógico2,...)`,
"lable.SalesCommitmentKanBan.contract":`Assinado`,
"label.processsetting.basic.settings":`Configuração básica`,
"label.escalation.setup.newentries.ifcondtions":`Execute esta regra se o`,
"label.lookup.nofound.data":`O valor não existe ou não corresponde ao filtro.`,
"vue_label_commonobjects_view_chart_chartname":`Nome do quadro`,
"label.dashboard.show.percent":`Mostrar %`,
"label.sso.saml.sp.userid":`Identificação do usuário`,
"label_tabpage_minutesagoz":`atas`,
"vue_label_chatter_comment_content":`Por favor, digite o conteúdo dos comentários`,
"label.campaign.channel.step6.mobilepc":`Gerar página móvel e PC`,
"vue_label_homepage_editprofilepage":`Editar Nome`,
"label.tabpage.crecordtypez":`Mudança de tipo de registro`,
"label.social.posts.type.null":`O tipo de poste não pode estar vazio`,
"label.projectManagement.groupbyuser":`Agrupamento por usuários`,
"vue_label_email_new_template":`Salvar como um novo modelo`,
"label.ems.close":`Cancelar`,
"label.ccdocument.noauthority.folder":`Você não tem permissão para operar esta pasta.`,
"message.filterconditionerror":`<é forte>Error: </strong> Suas condições de filtragem mal citadas:`,
"label.User.Interface":`Interface do usuário`,
"label_tabpage_greaterz":`Maior do que`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Selecione e Continue`,
"vue_label_commonobjects_detail_influence":`Influência`,
"label.total.have.priority":`é anterior`,
"label.manageAll.sta4":`Relembrar`,
"label.setup.mobile.offlinecache.setup":`Configurações de cache off-line do lado móvel`,
"vue_label_chatter_cancel_adding":`Cancelar`,
"vue_label_lead_select_existing":`Selecione os`,
"front-epwechat-module-v1-contacts-sync":`Contatos Sync WeCom`,
"label.appupload.component.type.recordtype":`Tipos de registros`,
"label.layout.hint":`Esta página não está disponível para visualização. Favor salvar e visualizar na página de primeiro plano.`,
"label.change":`Mudança`,
"setup_layout_label_detailpage":`Página de detalhes`,
"label.imgfield.use.tip":`img(docid,width,height), esta função é usada para emitir imagens, "docid" é o ID do documento, "width" define a largura da imagem (Tipo inteiro pode ser nulo), "height" define a altura da imagem (Tipo inteiro pode ser nulo).`,
"pagecreator.systemstyle.button.edit":`Estilo de edição`,
"label.delete_externalpage":`O ' ' que você deseja excluir não pode ser retirado, favor confirmar novamente. O formulário não é usado em nenhuma página de login, mas pode ser usado em outro lugar. Por exemplo, você pode ter usado o código embutido para inserilo em uma página externa.`,
"font-evaluate-module-v1-open-case":`Reabrir o caso:`,
"label_not_adjust":`Sem ajuste`,
"vue_label_title_ordernow":`Encomendar agora`,
"label.notification.serviceappointment.allocation":`Você foi despachado uma nova ordem de trabalho {0}, favor verificála.`,
"label.objectRelationshipDescription2":`. Você pode definir quais registros relacionados de outros objetos são devolvidos nos resultados do relatório, escolhendo uma relação com outro objeto.`,
"vue_label_calendar_notice_createfail":`Falha na criação do calendário`,
"label.ems.step1":`Passo 1`,
"label.ems.password":`Senha`,
"label.icon.143":`Banco de Porquinhos`,
"label.select.year":`Selecione o ano`,
"label.termsforusage.dialog":`Termos de uso (Nova janela)`,
"label.tag.addtags.create":`Criar`,
"label.emailobject.groupemail.msg4":`não será enviado devido a um endereço de e-mail inválido.`,
"label.version.sum.autonumberfield":`campo(s) de número(s) automático(s)`,
"label.projectManagement.unallocated.time":`Tempo não atribuído`,
"PageLayout.Search.MultiSearch.002":`Habilitar caixa de busca personalizada (Single Field Search)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Notificação por SMS Editar`,
"Opportunity.Detailed.Phase.Label.003":`Estágio de mudança`,
"vue_label_helpcenter_all":`1. Pesquisa geral<br> A pesquisa geral é uma ferramenta para ajudá-lo a encontrar rapidamente o que você precisa. <br>?Digite palavras-chave na caixa de entrada da busca na barra de navegação na parte superior da página. Durante o processo de entrada, o sistema recomendará o conteúdo relevante para você em tempo real de acordo com seu conteúdo de entrada; <br>?Clique em "Search" ou pressione diretamente a tecla Enter para abrir a página de resultados da busca; <br>?Na página de resultados, você pode filtrar o objeto à esquerda para ver a lista de resultados da busca sob aquele objeto. Até 10 registros foram recomendados para você na lista de resultados. Você pode clicar em "Ver mais" para entrar na página da lista deste objeto para ver mais resultados de busca; <br>Nota: O sistema procura por "cotação", "cliente", "lead", "oportunidade de negócio", "atividade de marketing", "contrato", "produto", "solicitação de serviço", "tarefa" e "evento" por padrão. <br> 2. Criar rapidamente<br> Clique em " " na barra de navegação e você pode selecionar o objeto que deseja criar na janela suspensa. <br> 3. My Center<br> Clique no avatar no lado direito da barra de navegação para abrir a janela My Center. As seguintes funções são fornecidas: <br>?Entre rapidamente na página de configurações pessoais, importação de lotes e entrada de lixeiras de reciclagem; <br>?Se você estiver no período de teste, clique em "Order Now" para entrar rapidamente na página de pedidos do Cloud CC; <br>?Clique em uma versão para mudar rapidamente; <br>?Sign out. <br>?4. Menu<br>> Alguns objetos do menu são recomendados para você na barra de menu. Você pode clicar em um menu para entrar rapidamente na página. Você também pode visualizar todos os menus e definir os menus freqüentemente utilizados a serem exibidos na barra de menu. <br>... Todos os menus: Clique em "Mais", e clique em "Todos os menus" na parte inferior da caixa suspensa; <br>?Personalizar meu menu: Clique no botão do lado direito do menu para abrir a janela do menu personalizado e defina os menus comuns que você precisa exibir na barra de menu em todos os menus. <br> 5. Application launch center<br> Clique no ícone no lado direito da barra de menu para mudar rapidamente para o administrador do sistema para configurar outros serviços de aplicação para você. <br>Nota: Uma aplicação é uma coleção de uma série de módulos funcionais (tais como gerenciamento de leads, oportunidades de negócios, gerenciamento de contratos, etc.) que podem ser usados para atender a necessidades comerciais específicas.`,
"label.summaryreport.2018.step5.new":`Passo 5 Selecione os critérios do relatório`,
"label.weixin.id":`Número`,
"chatter.pu.mess":`correio(s)`,
"label.weixin.lookup.record":`Encontrar Registros`,
"label.ServiceCloud.statistics.by.address":`Estatísticas por endereço`,
"label.jixiaoswitchoff":`Colapso`,
"label.savealipay.failure":`Falha em salvar informações do comerciante Alipay`,
"template.chart.khdqfb":`Contas Distribuição regional`,
"front-email-payment-immediate-payment":`Pague agora`,
"label.dashboard.unit5":`Unidade: 100 milhões`,
"label.tabpage.greaterz":`Maior do que`,
"vue_label_calendar_stop_sharing_calendar":`Pare de compartilhar o calendário`,
"label.projectManagement.allhours":`Todos (horas)`,
"label.currency":`Moeda`,
"label_vue_create_edit_obj_create_event_dialog_title":`Lembrete de horários repetitivos`,
"front-template-V1-templateSetting":`Configuração de gabaritos`,
"label.dashboard.away.condition":`Condição de colapso`,
"label.replacelayout":`Substituir o layout da página`,
"label.permission.detail.system.setting.tip":`Executar a operação aplicada às aplicações. Por exemplo: modificar as permissões para todos os dados`,
"label.customfield.delete.prompt":`Rótulo de campo personalizado`,
"label.add":`Adicione`,
"label.deputationalsoapprove":`O Aprovador Delegado também pode aprovar esta solicitação`,
"label.leave_nosave":`Após a saída, os dados atuais não serão salvos.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Restaurar`,
"chatter.feed.menutype.feed.markcom":`Marcador de Favoritos`,
"label.query.data.error":`Falha na consulta das listas relacionadas`,
"label.pc.ui.2018.unpin":`Unpin`,
"label.partner.template.memo":`Título`,
"label.weixin.cannot.gain.userinformation":`Incapaz de obter informações do usuário.`,
"label.stdashbord.xsld.department":`Departamento`,
"label.service.ganttBaiduMap.scheduled.starttime":`Hora de início planejada`,
"label.documentforms":`Documentos`,
"label.operator.insert":`Operador de inserção`,
"label.processsetting.select.five.fields":`Podem ser selecionados até 5 campos.`,
"label.weixin.password":`Senha`,
"vue_label_chatter_share_followers":`Compartilhar com seguidores`,
"label.brief.baifang":`Visitas`,
"label.emailobject.track.unopen":`Não aberto`,
"label.sendmail.immediately":`Enviar agora`,
"label.partnerCloud.payTheAmount":`Valor do pagamento`,
"label.integrations.mailchimp.connect":`Conecte o CloudCC à sua conta`,
"label.datamove.record.sucessfully":`registro(s) transferido(s) com sucesso.`,
"lable.outlook.edit.allocation":`Designar Usuários e Perfis`,
"label.chosesubject.talk":`Programar uma conversa`,
"label.escalation.setup.entrydetail.escalation.time":`Escalar em`,
"label.projectManagement.must.be.less.than.24.hours":`Menos de 24 horas`,
"setup_mainpage_label_welcome15":`As regras de fluxo de trabalho da Plataforma CloudCC automatizam o processo de suporte para suas vendas, marketing, e muito mais. Dependendo de um conjunto predefinido de regras, os registros podem ser automaticamente atribuídos aos usuários ou convertidos de um usuário para outro. O principal benefício da gestão do fluxo de trabalho é melhorar a eficiência do trabalho, eliminando muitas operações desnecessárias ao atualizar registros, e melhorar os níveis de processamento do negócio e otimizar os processos de controle, padronizando os métodos de trabalho e reduzindo os custos operacionais. Ele suporta aprovação infinita ilimitada para qualquer objeto, e pode acionar e-mail de lembrete, lembrete SMS, tarefa, atualização de campo e outras funções.`,
"label.mobile.phone.week.plan2":`Esta Semana`,
"label.add.newAsset":`Novo Ativo`,
"vue_label_salesadvance_losts":`Número de perdas`,
"vue_label_report_editcolumn":`Editar Coluna`,
"vue_label_homepage_assignedtasks":`Tarefas atribuídas`,
"label.posting_from":`Publicado por`,
"year":`Ano`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Pelo menos uma carta`,
"label.version.nonsupport.feature.staticresource":`Esta característica não é suportada temporariamente. Por favor, aguarde a atualização antes de usar.`,
"label.toleadmyclientandlinkman":`Importar minhas contas e meus contatos`,
"label.appupload.install.processcrash":`Lidar com os conflitos`,
"label.profile.setstandardtab":`Configurações de abas padrão`,
"template.chart.khhyfx":`Análise do setor de contas`,
"label.reportTypcrtC":`Objeto associado (c) favor clicar para selecionar o objeto relacionado`,
"vue_label_report_mayormaynothave":`O objeto pai pode ou não ter registros relacionados a este objeto`,
"label.service.gantt.plan.recommendation":`Cronograma recomendado`,
"label.version.sum.lookupfield":`campos de relacionamento de busca`,
"label.builder":`Construtor de páginas`,
"label.sharerule.remark":`Especifique o compartilhamento deste registro. Você pode compartilhar os registros e dados relacionados com o usuário, função, função e subordinados, usuários em um território, usuários no território e subterritório.  O compartilhamento individual só pode ser usado para conceder acesso mais amplo aos dados, e não para restringir o acesso.`,
"vue_label_email_benn_added":`A caixa de correio foi acrescentada`,
"label.version.allow.sum":`Se necessário, favor atualizar a versão CloudCC.`,
"label.icon.130":`Moeda`,
"label.custom.new":`Novo`,
"label.see_allfields":`Ver todos os campos`,
"front-marketing-module-v1-share-poster":`Compartilhar cartaz`,
"label.service.one":`Suas referências de filtro não definem as condições do filtro:`,
"lable.outlook.edit.alprec":`Sempre preferiu o CloudCC.com`,
"Account_News_Setting_001":`Configurações da conta`,
"label.mr.caption.opportunity.result":`Encontrar duplicatas e fundir: Resultados para consulta de duplicatas de Oportunidades`,
"label.forbidden":`Desativar`,
"label.query.detail.openpartner":`Habilitar como usuário parceiro`,
"label.session_date":`Data da sessão`,
"label.forecast.customforecast.submit.deyuce":`Previsão`,
"label.emailtocloudcc.filed.server":`Servidor`,
"label.emailtocloudcc.tip2":`Depois de excluir, você não poderá usar o Email to CloudCC, você tem certeza de que quer excluir?`,
"pagecreator_layout_message_delete_fail":`A eliminação do layout falhou`,
"front-lightning-module-v1-dashborad-export-PDF":`Exportar PDF`,
"lable.quote.syncing.syncingto":`Os itens da linha de cotações foram sincronizados com os produtos de oportunidade`,
"message.error.view.lastview.update":`Não é possível excluir a última visualização da lista pública</br>Não é possível alterar a visibilidade da última visualização da lista pública de "Visível para todos os usuários" para "Visível somente para mim"<br>>br>>`,
"label.weixin.select.one":`Selecione pelo menos um`,
"label.projectManagement.Pleaseenterprojectname":`Por favor, digite o nome do projeto...`,
"label.data.downpage.e_list.desc1":`Esta página exibe arquivos exportados com sucesso. Por favor, faça o download dos arquivos exportados em tempo hábil, acrescente o link para download em seu e-mail.`,
"label_tabpage_notexceed25":`O registro selecionado não deve exceder 25`,
"label.campaign.channel.step5.remark":`Você terminou de montar a página de registro.`,
"label.setup.mobile.bottombutton.profile.prompt":`Dicas:o menu inferior de perfil personalizado substituirá as configurações unificadas do menu inferior da empresa`,
"label.stdashbord.xsld.business.knx":`Probabilidade`,
"label.setemailtip":`Criar um alerta por e-mail para associar com uma ou mais regras de fluxo de trabalho ou processos de aprovação. Ao alterar um alerta por e-mail, quaisquer modificações serão aplicadas a todas as regras ou aprovações associadas a ele.`,
"report.button.go":`Ir para`,
"lable.the.united.arab.emirates":`Registros foram recebidos.`,
"label.writer. name.file":`Favor preencher o nome do arquivo de cotação`,
"label.validate.function.funcExplain.ADDMONTHS":`Adicione o num mês à data, usando a última data do mês se a data for o último dia do mês ou adicionando num mês tem menos dias.`,
"vue_label_chatter_enter_shared_content":`Por favor, digite o conteúdo compartilhado`,
"message.lookup.condition":`Os critérios de busca devem digitar mais de um caractere`,
"vue_label_commonobjects_detail_customers":`Os clientes que desativarem permanentemente os usuários externos proibirão todos os usuários externos associados ao cliente e os removerão de todas as comunidades, grupos, equipes, conjuntos de permissões e regras de compartilhamento associadas a eles. Ao mesmo tempo, os papéis e grupos associados à conta serão permanentemente excluídos e não aparecerão no caixote da reciclagem. Você tem certeza?`,
"label.emailobject.view.all":`Todos os e-mails`,
"vue_label_file_size_limit_new":`O upload falhou. O anexo excede o {tamanho}M.`,
"front-gantt-module-please-reorder-milestones":`Por favor, digite um número válido para reordenar os marcos`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Email`,
"label.namespaceprefix":`Prefixo do espaço de nomes`,
"label.ems.delete.success":`Eliminar com sucesso`,
"label.partnerCloud.financeSetting.setWechatPay":`Configurar o WeChat Pay`,
"front-epwechat-module-v1-input-token":`Por favor, insira o Token`,
"setup_object_field_dependency_button_setdependency":`Configurações de dependência de campo`,
"chatter.group.request01":`Solicitação(ões)`,
"message.error.field.number.length":`O comprimento do formato que você inseriu o erro.`,
"label.tabpage.lessz":`Menos de`,
"vue_label_notice_uploadavatar_format":`A imagem do avatar carregada só pode estar no formato JPG/PNG/GIF`,
"label.project.hit.thirteen":`Lembrete diário de marco miliário`,
"frame_personinfo_label_usethisimage":`Utilizaremos variações desta imagem em miniatura em torno da aplicação.`,
"label.startuploadfile.step":`Caso contrário, os arquivos não carregados com sucesso serão exibidos na área superior, precisam ser removidos, então escolha um novo arquivo.`,
"component_assistant_label_overduetask":`Oportunidades com Tarefas Vencidas`,
"label.partnerCloud.financeSetting.information":`Como configurar as informações de assinatura da Alipay?`,
"label.appupload.install.package.component":`Componentes da embalagem`,
"label.emailobject.emaildetail.nextactivity.task":`Adicionar tarefa`,
"vue_label_chatter_edit_post":`Edit Post`,
"label.appupload.upload.logo":`Ícone`,
"label.role.selecteduser":`Usuários selecionados`,
"label.letter.assign":`Especificar o conteúdo do convite`,
"label.forecast.shrepage.title":`Detalhes do Compartilhamento de Previsões`,
"lable.Generate.service.appointment":`Nomeações de serviço geradas pelo item de ordem de serviço`,
"label.productsales.nodata":`Sem dados`,
"vue_label_email_Please_select_at_least_one_email":`Favor selecionar pelo menos um e-mail`,
"label.data.downpage.i_title.num4":`4. Se você tiver um campo de relação de busca e um campo de relação de mestre-detalhe no objeto que deseja importar, o valor para esse campo deve ser ID, caso contrário ele é inválido.`,
"label.new.exchagecurrency":`Novas taxas de câmbio`,
"label.layout.listtip":`A tabela abaixo mostra a atribuição do layout da página para diferentes perfis.`,
"label.icon.2":`Carteira`,
"label.chat.topic.delete.prompt3":`Você tem certeza de que vai apagar este tópico?`,
"UG_Lead_008":`Código de escaneamento de cartões de visita`,
"label.multilang.databatchadd.fail":`{0} os dados não são added：`,
"front-kefu-moudle-v1-chzx-confirm":`Você tem certeza de que quer excluir o agente?`,
"label.import.page1.matchlabel":`Forma de combinar {{{$store.state.labelName}}}`,
"label.dashboardSetup.showdw.d3":`Milhões`,
"label.version.ifnecessary":`Se necessário, por favor, atualize sua versão do CloudCC.`,
"label.confirm.delete.default.tab":`Você tem certeza de que quer excluir as guias de registro padrão?`,
"label.emailtemplate.mergefields.tip":`Quando os usuários editam o conteúdo do e-mail, eles podem adicionar campos mesclados para substituir o texto no conteúdo do e-mail. Quando os e-mails são enviados, o sistema os substitui por texto. Por exemplo, {!Contact.name} em seu e-mail se tornará o nome do contato.`,
"vue_label_chatter_decline_members_join":`Recusar membros para se juntarem ao grupo`,
"label.role.no":`Sem papéis`,
"label.service.gantt.resources":`recursos`,
"label.knowledge.language.simplified":`Chinês simplificado`,
"label.eidt.queue.length.cannot.than":`O comprimento do nome não pode exceder 50 caracteres.`,
"label.mobile.quickcreate.default.tasks":`Tarefas`,
"label.discount.yuan":`Desconto (Yuan)`,
"message.error.delete.pending":`O registro está pendente para aprovação, você não pode apagá-lo.<br>Click <a href='javascript:history.back();'>here</a> para retornar.`,
"chatter.show.mostnews":`Mostrar mais`,
"label.optionlist":`Lista de picking`,
"template.chart.cpdj":`Preços de produtos`,
"label.user.usernamepassword.error":`Por favor, verifique seu nome de usuário e senha.`,
"label.file.sharetype.check":`Visualizador`,
"label.completed.generated.page":`A página do PC é completada`,
"label.martrixcross":`Matrix Cross`,
"label_tabpage_entercusnamez":`Por favor, digite o nome do cliente`,
"lable.account.NextwDays":`Próximos 30 dias`,
"label.list.userinterface.dashboard.hint":`Novos gráficos de painel de instrumentos rapidamente mostrados em telefones celulares, tablets, etc...`,
"message.fieldtrack.operatecreate":`Criado em`,
"label.service.gantt.available.plan":`Escalas de tempo que podem ser programadas:`,
"label.activity.setting":`Configurações de atividades`,
"label.tag.manage.record":`Número de registros`,
"label.customcomponent.page.edit.title":`Editar componentes personalizados`,
"label.import.index.creationrecord":`Criar um registro`,
"label.tabpage.printz":`Imprimir`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Unidade de Desconto:`,
"label.weixin.micro.message.profile.associated":`Conta oficial WeChat associada ao perfil da empresa`,
"label.cpq.opportunity.pricebook.change":`Esta oportunidade foi ligada a uma cotação primária e o livro de preços não pode ser alterado.`,
"vue_label_opportunity_business_opportunity":`Os resultados das oportunidades de negócios fechados e vencedores do cliente contêm registros com um ou mais dos mesmos campos que a oportunidade de negócios atual.`,
"message.standardreport":`Relatórios padrão`,
"vue_label_account_outstanding_business":`Transferir todas as oportunidades de negócios não processados de outros`,
"vue_label_commonobjects_detail_field":`Selecione o campo do filtro`,
"pagecreator_page_button_delete":`Excluir`,
"label.leadconvers.permisson":`Sem {!operator} permissão para o {!objectname}, favor entrar em contato com o admministrador!`,
"vue_label_systemSettings_customcode":`Código personalizado`,
"button.partner.cancel":`Cancelar`,
"label.whChatBindingState":`Status Vinculativo do WeChat`,
"label.appointmentconfirmail.wizard.subtitle6":`Telefone`,
"label.recycle.dis.tip2":`Clique em Esvaziar sua lixeira ou Esvaziar Tudo para esvaziar a lixeira de reciclagem dos usuários ou da organização . Isto levará algum tempo, quando o esvaziamento estiver concluído, você será notificado por e-mail.`,
"batch.transfer.succ":`dados de transferência de massa bem-sucedida`,
"label.chat.add.bookmark":`Favoritos`,
"label.mr.object.contact":`Contatos`,
"component_setup_label_parentobject":`Objeto superior`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Terça-feira`,
"vue_label_report_list":`Selecione o campo a ser exibido no título da lista`,
"label.checkbox.false":`Não`,
"label.chatter.followers":`Seja seguido`,
"label.mr.loadReDate":`Carregue o selecionado`,
"label.versiontype.Essential":`Essencial`,
"front-project-module-v1-input-actual_working_hours":`Por favor, digite as horashomem`,
"label.visualpage.staticresource.p2":`2. Note que os tipos de arquivo de recursos estáticos suportados são png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Por favor, escolha os itens de linha para clonar`,
"component.assistant.label.30daysnoact":`30 dias sem nenhuma campanha`,
"label.tianyancha.businessverify.relation":`Tem sido mapeado`,
"vue_label_email_havent_received_the_email_yet":`Nenhuma correspondência recebida agora`,
"label.isEnableVisualpage_new.title":`Habilitar acesso à página personalizada`,
"lable.SalesCommitmentKanBan.allContractAmount":`Montante total do contrato`,
"label.searchall":`Pesquisar tudo`,
"label.h5.similar.opportunity.select.all":`Selecione Todos`,
"label.area.tree.intro":`Você pode ver a hierarquia dos territórios aqui.`,
"label.select.up.three.fields":`Atenção: Podem ser selecionados, no máximo, três campos.`,
"label.leadscore.doing":`A pontuação já começou, por favor não repita a pontuação`,
"message.choosereportobj":`Favor selecionar objetos de relatório`,
"button_partner_start":`Comece a usar`,
"label.quote.print":`Imprimir cotação`,
"label.workflowoperateselect":`Passo 3 Especificar ações de fluxo de trabalho`,
"label.greate":`> Maior do que`,
"lable.setting.qrcodeOrbarcode.rule":`Configurações de Regras de Geração de Código QR/Geração de Código Bar`,
"label.partnerCloud.orderingPlatform.discounts":`Tabela de Descontos`,
"label.ems.save2draft":`Salvar como rascunho`,
"vue_label_homepage_editname":`Editar nome da página inicial`,
"label.ccdocument.save.error":`Salvar falhou e o código de erro é`,
"label.samoa.standard.time":`Tempo padrão de Samoa`,
"label.tianyancha.businessverify.msg7":`3. escopo do serviço`,
"vue_label_commonobjects_view_up_to_data":`A operação suporta até 200 dados`,
"label.manage":`Gerenciar`,
"label.tooltip":`fonte de dados do relatório foi utilizada, você não pode editar a relação de objetos!`,
"vue_label_calendar_edit_calendar":`Editar Calendário`,
"label.attendance.keywords":`Por favor, digite as palavras-chave`,
"label.otherinfo":`Outras informações`,
"System_TAB_SeeViewAmount":`Ver Totais`,
"label.recordtype.remark":`Descrição`,
"label.object.cannot.delete":`O objeto não pode ser apagado porque está associado às seguintes relações com outros objetos`,
"label.setup.mobile.bottombutton.saveprompt":`Por favor, selecione 4 páginas de primeiro nível`,
"label.department.lastpage":`É a última página`,
"label.emailtemplate.mergefield.use":`Copiar e colar valores de campo fundidos no e-mail`,
"vue_label_salesfunnel_notice8":`Proporção de conversões bem sucedidas desta etapa para a etapa seguinte`,
"lable.opppdt.addpdt.table.product":`Produtos`,
"vue_label_helpcenter_report2.2":`Passo 2: Selecione como você deseja resumir as colunas: Total, Média, Máximo, Mínimo. <br>? Ordene os dados no relatório em ordem ascendente ou descendente<br> Clique no símbolo ↑ ou ↓ ao lado de qualquer campo no cabeçalho do relatório de previsão. Os dados no relatório serão ordenados em ordem ascendente e descendente de acordo com este campo. <br>? <br>Mostrar ou ocultar linhas de detalhes<br> Após o agrupamento, você pode mostrar ou ocultar linhas de detalhes, pré-visualizando a chave "Detail Row" no canto superior direito do relatório. A "Linha de Detalhe" está desligada por padrão. <br>? Ligar ou desligar a pré-visualização automática de atualização<br> A "Pré-visualização automática de atualização" na parte superior direita do relatório de pré-visualização permite ligar ou desligar a pré-visualização automática de atualização. Quando ligado, o impacto de cada passo que você dá sobre os dados é automaticamente exibido no relatório de pré-visualização. ? Para filtrar os registros do relatório, clique nos filtros<br>Os filtros são divididos em filtros padrão e filtros de campo. <br>Os filtros padrão incluem o filtro Função, o filtro Show Me, e o filtro Data. <br>A. O filtro "Função" divide os dados por função atual e por funções subordinadas imediatas, e você pode alternar entre as funções clicando no nome da função. <br> B. O filtro "Show to Me" divide os dados por "Show to Me" e "Show to All", com "Show to Me" mostra dados onde o proprietário é o usuário atual, e "Show to All" mostra todos os dados onde o usuário atual tem privilégios de visualização. <br> C. O filtro "Date Range" divide os dados por data ao longo de um intervalo de tempo, como "Create Date", "End Date". <br> O filtro de campo inclui tanto um filtro de campo quanto um filtro avançado. <bbr>`,
"label.validate.function.funcFormat.YEAR":`ANO(data)`,
"label.service.gantt.timeScale":`Escolheu a escala de tempo em Gantt`,
"label.data.dataexptemplate.desc1":`1. Os arquivos de exportação de dados têm dois formatos: formato CSV e formato comprimido. Padrão para o formato CSV.`,
"template.chart.btjbkhqk":`Diferentes níveis de clientes`,
"label.role.assign.select":`Remover um usuário da lista <b>Selected Users</b> e designar o usuário para a função selecionada acima.`,
"label.event.lookupmulti.assigner":`Atribuído a`,
"label.appexchange.fieldupdata":`Atualizações de campo do fluxo de trabalho`,
"label.lookup.page.notexists":`A página não sai.`,
"label.appupload.install.error.choice3":`Fundir componentes conflitantes em um único componente`,
"vue_label_commonobjects_detail_team":`Administração da equipe`,
"label.approvereqiest":`Pedido de Aprovação`,
"message.error.id.replace":`As informações do calendário correspondentes a {0} não foram encontradas`,
"font-evaluate-module-v1-general":`O tipo de avaliação é Neutra`,
"vue_label_report_whatweek":`Em que dia`,
"vue_label_chatter_img_upload":`Você pode carregar arquivos JPG, GIF ou PNG, o tamanho máximo do arquivo é de 2M`,
"label.checkbox":`Caixa de seleção`,
"label.visualpage.component.n5":`5.Exemplo. Chamada:`,
"chatter.updat":`Atualização`,
"label.ems.emailaccount":`Conta de e-mail`,
"label.autoRegister.changepwd.setpwd.tip1":`Definir senha para a conta CloudCC`,
"label.import.step1.matchway":`Modo de combinar { labelNameshow }`,
"label.manageAll.sel.one4":`Itens I Rejeitados`,
"label.tabpage.lookatmorez":`Veja mais`,
"label_tabpage_addadvancedoptions":`Adicionar opções avançadas`,
"message.validation.accept":`Formato inválido`,
"label.handlingnooperate":`Os dados estão sendo processados, por favor não faça mais nada, caso contrário, o processamento falhará.`,
"label.mobile.buttom.homepage":`Página inicial`,
"lable.account.LastaDays":`Últimos 7 dias`,
"label.user.notexists":`O usuário não existe.`,
"front-electronic-signature-isclose":`Inativo`,
"label.optional.groups":`Grupos opcionais de linhas de citação`,
"pagecreator.layout.label.layoutname":`Nome do layout`,
"label.error404":`A página que você está tentando visualizar não está aqui, por favor tente novamente mais tarde.`,
"label.eventtrigger":`Acionadores de eventos`,
"label.projectManagement.next.page":`Próxima página`,
"vue_label_SMS_chosen":`Escolhido`,
"label.part.cannot.empty":`O campo não pode ser nulo`,
"label.call.center.jilu":`Histórico de chamadas`,
"front-kefu-moudle-v1-tenant-reinput":`Por favor, digite a identificação do locatário`,
"label.projectManagement.you.want.to.delete.this.data":`Você tem certeza de que quer apagar este registro?`,
"label.projectManagement.nocharge":`Grátis`,
"System_TAB_SeeViewPageAmount":`Ver Páginas`,
"label.password.query.error":`Erro de consulta do usuário.`,
"message.chooseatleastone":`Selecione um valor pelo menos.`,
"label.sortasc":`Ascender`,
"label.stdashbord.xsld.business.jinezhb":`Quantidade Proporção`,
"label.attendance.add":`Adicionar Presenças`,
"vue_label_account_invoices":`Transferir todas as faturas do proprietário do cliente`,
"label_delete _model":`A exclusão de um modelo também excluirá os dados de destino associados e é irreversível. Você quer confirmar a exclusão?`,
"label.folder.sort。discreption":`As pastas serão produzidas na ordem selecionada.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Caminho de acesso: Plataforma Comercial  Centro de Contas  Segurança API  API SecretＫey`,
"label.equal":`=igual`,
"lable.PowerProcess.Workorder":`Ordem de trabalho`,
"front-docusign-setting-error-tips":`Por favor, escolha o campo personalizado`,
"template.report.lead.status":`Status dos Leads`,
"label.create.remark":`Adicionar Nota`,
"font-evaluate-module-v1-one-points":`Marca Negativa: 1 ponto`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Valor de retorno por ano, mês, dia e hora GMT (Campo Data/Hora)`,
"label.report.select.group.mode":`Selecione o modo de agrupamento`,
"label.h5.editmydetails":`Editar meus dados`,
"front-epwechat-module-v1-authorize":`Domínio Autorizado Callback`,
"label.tabpage.kanban":`Configuração do painel de visualização`,
"label.emailobject.emaildetail.button.addtocontact":`Adicionar aos Contatos`,
"lable.opppdt.selPbk.description":`Selecione um livro de preços para esta oportunidade. Você só pode adicionar um produto de um único livro de preços, e mudar o livro de preços selecionado removerá todos os produtos existentes da oportunidade.`,
"component.event.button.save":`Salvar`,
"vue_label_homepage_homepage_assigned_success":`Página inicial atribuída com sucesso`,
"message.duplication.label.blankmatch":`Combinar campos em branco`,
"label.icon.24":`Kit de Primeiros Socorros`,
"label.mobile.same":`O novo número de telefone é o mesmo que o antigo`,
"label.file.library.managemembers.addmember":`Adicionar membros`,
"chatter.sp":`Mostrar Posts`,
"label.user.notlogin.range":`Fora da faixa de tempo de login.`,
"label.step3.total7":`Etapa 3 de 7`,
"label.user.fullname":`Nome completo`,
"label.button.menubar":`Barra de menu`,
"#label.importfilestep3":`Passo 3 Selecione e carregue seu(s) arquivo(s)#`,
"label.appointment.wizard.subtitle6":`Descrição`,
"message.lostnextapprover":`Se você deseja enviar o pedido de aprovação, preencha o campo "Usuário Relevante" para definir o próximo aprovador. Este é o campo "Usuário Relevante" não pode estar vazio. Qualquer outra pergunta, você pode entrar em contato com o administrador.`,
"label.sso.saml.sp.logoutUrl":`URL única de logout do fornecedor de identidade`,
"label.weixin.isgoon":`Suas informações de filiação já existem. Se continuar, o WeChat ID que vincula este número de telefone celular antes não poderá usar a conta oficial do AidMax WeChat. Você tem certeza de que deseja continuar?`,
"vue_label_notice_homepage1":`Favor digitar o valor alvo correto dentro de 12 dígitos`,
"label.umeng.activity.event.will":`irá`,
"label.insertURL":`Inserir URL`,
"label.partnerCloud.orderingPlatform.administrator":`Não há livro de preços disponível. Favor entrar em contato com o administrador.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Análise de campanha`,
"message.deleteapproval.tip":`Você só pode apagar o processo de aprovação com o qual não há dados ou registros associados.`,
"pagecreator_page_message_delete":`Você exclui a página selecionada atualmente?`,
"component.telerecord.label.message":`Comentário`,
"front-email-payment-Invoice-preview-opening":`Entre em contato com o administrador do sistema para ativar a função de pagamento online e configurar os parâmetros do método de pagamento correspondente.`,
"noless":`Maior ou igual a`,
"label_emailtocloudcc_button_back":`Cancelar`,
"lable.Please.select.a.template":`Por favor, escolha um modelo existente.`,
"front-lightning-module-v1-details-page-chart-relevant":` Quando os objetos associados do relatório selecionado contendo o objeto atual, é possível filtrar mais dados do relatório de acordo com o registro atual; Configurar se permite aos usuários atualizar manualmente os dados do caju.`,
"label.object.page.head":`Cabeçalho de página`,
"label.notification.time1":`em poucos segundos`,
"label.weixin.optionnine":`Escolha 9`,
"label.approval.content.tolang":`O conteúdo que você entrou é muito longo, por favor, entre novamente.`,
"label.leadconvers":`Conversão de chumbo`,
"label.compact.layout.frame.tabseq":`Exibir ordem da página de registro:`,
"label.permission":`Conjuntos de permissões`,
"vue_label_notice_new_success":`Criado com sucesso`,
"label.money":`Moeda`,
"label.ccchat.person.invite.unsuppem":`O endereço de e-mail que você digitou não suporta {0}`,
"message.profile.del":`Este perfil é um perfil de administrador e não pode ser apagado!`,
"vue_label_report_savelocation":`Salvar localização`,
"label.knowledgebase.select.lighting.target":`Por favor, escolha o alvo Relâmpago`,
"label.visualpage.labelname":`Nome da etiqueta da página`,
"label.notification.ccchat2":`【点赞用户名】liked seu posto.`,
"label.htyj.wanchenglv":`Porcentagem`,
"label.weixin.report.generatedchart":`Gráfico Gerado`,
"label.customer.tab.please.label":`Por favor, a etiqueta da etiqueta`,
"label.template.lookup":`Veja o modelo`,
"label.attendance.setting.wucha":`Desvio dentro de 200 metros`,
"vue_label_opportunity_product_addproduct":`Adicionar Produto`,
"label.data.setok.t.desc3":`Operação.`,
"label.emailobject.template.public":`Público`,
"label.setsubmit":`Configurações de submissão`,
"chatter.feed.menutype.feed.companycom":`Todas as empresas`,
"label.Generate.Document":`Gerar documento`,
"label.knowledge.setting.hint.six":`Organizar os artigos por classificação de dados.`,
"label.dashboard.show.total":`Mostrar total`,
"attachment.select.warning.001":`O anexo está arquivado e o botão Arquivar não está disponível, favor selecionar novamente um anexo.`,
"message.schedulejob.error.delete":`Ocorreu um erro ao eliminar a base de trabalho.`,
"setup.layout.group.pagecomponent":`Componentes da página`,
"label_partner_new_step3_meno":`Não tem certeza do que entrar? não se preocupe, você pode mudá-lo mais tarde a qualquer momento.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Subtotal Bases`,
"label.file.library.selectFile2Lib":`Adicionar arquivos`,
"label.lock.record":`Há( registros bloqueados`,
"label.multilang.addcustomreporttypestage2.description":`Esta fonte de dados gerará um relatório sobre {0}. Escolhendo um objeto que esteja relacionado a ele,
você pode definir quais registros relacionados em outros objetos serão devolvidos aos resultados da fonte de dados.`,
"message.duplication.errorinscript.greaterthan10":`Você pode selecionar até 10 registros para fundir.`,
"label.encd":`Mostrar Criptografado`,
"UG.Account.03":`Verificar e fundir proativamente as contas duplicadas`,
"label.salescloud.teamrole.main2":`Major`,
"label.email.to":`Receptor`,
"label.members.sign.notify":`Notificar o supervisor`,
"template.report.individual.case.priority":`Prioridade do caso`,
"vue_label_report_selectfolder":`Selecionar pasta`,
"label_partner_all":`Todas as nuvens de parceiros`,
"lable.custom.year":`Anos personalizados`,
"label.ispigeonhole":`Arquivo`,
"label.campaignmember.selectmember.steptotal":`Etapa 2 de 2`,
"label.userphoto.save":`Salvar`,
"label.knowledgebase.published.version.online":`As versões publicadas ainda estão online até que você publique este rascunho.`,
"template.report.customer.level.statistics":`Estatísticas de nível de conta`,
"label.mobile.phone.day.plan":`Amanhã`,
"label.icon.95":`Ensinando`,
"label.recordphone":`Registrar uma chamada`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`A desativação do gerenciamento avançado da moeda descontinuará o uso de todas as taxas de câmbio datadas para sua organização. As conversões de campos de moeda sobre oportunidades, produtos de oportunidade e relatórios associados a esses objetos não serão mais mapeados para um intervalo de datas - todas as conversões de moeda usarão a taxa de câmbio estática.`,
"label.service.gantt.is.candidate":`Candidato de`,
"label.ruleofchecktask":`Regras de validação de tarefas`,
"label.whole.page.show":`Despalhar página inteira`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expressão)`,
"label.ccdocument.template.set":`Função do conjunto de gabaritos`,
"label.icon.103":`Horário`,
"lable.no.products.to.assets":`Nenhum produto pode ser transferido para ativo.`,
"label.fristname":`Primeiro nome`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizador`,
"label.partner.workspace.myspace":`Meu espaço de trabalho`,
"label.tabpage.optionsz":`Opções`,
"component_chatter_link_button_save":`Publicar`,
"label.validate.function.funcFormat.NOW":`AGORA()`,
"label.discountPlanEditor":`Editor do Plano de Descontos`,
"label.weixin.fmu.pm":`PM`,
"front-gantt-module-milestone-sorting":`Classificação de marcos`,
"label.partnerCloud.maximumNumber":`O máximo de sites parceiros:`,
"label.mobile.place.record.interval.setup":`Intervalo de compartilhamento de localização`,
"label.visiblelinenumber":`Linhas Visíveis`,
"front-kefu-moudle-nopower-calluser":`Sem permissão, favor entrar em contato com o administrador`,
"label.field":`Campos`,
"label.projectManagement.groupbydate":`Grupo por data`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`programado`,
"label.operation.monitoring.history":`Histórico do Job Monitor`,
"label.data.dataexpalltype.all_desc1":`1. Você pode empurrar para gerar automaticamente e inserir manualmente a senha do arquivo das compressas exportadas. A senha gerada automaticamente será enviada para a caixa postal dos usuários quando os dados forem exportados com sucesso. A senha inserida manualmente não será enviada para a caixa de correio, portanto os usuários precisam se lembrar da senha inserida. Caso não tenha sido inserida, a senha não será inserida por padrão.`,
"front-web-module-v1-detail-comment-proposal":`Aguardando suas valiosas sugestões`,
"label_partner_workspace_member_selectedpermission":`Conjunto de permissões selecionadas`,
"vue_label_helpcenter_view1":`Na visão da versão de iluminação, você pode visualizar e gerenciar intuitiva e flexivelmente os dados aos quais você tem acesso. Através da visualização, você pode realizar funções básicas tais como visualização de classificação de dados, exibição de dados de múltiplas formas, adição, modificação e exclusão de dados, e você também pode visualizar convenientemente relatórios e gráficos para análise posterior de dados.<br> 1. Manage view<br> No menu suspenso no canto superior esquerdo da visualização, selecione a visualização que deseja visualizar, e selecione a visualização padrão através de configurações fixas. <br> Use o menu de controle da visualização de lista para criar, editar, excluir ou ordenar as visualizações. Ao mesmo tempo, use a função de filtro no canto superior direito para editar e criar rapidamente novas visualizações. <br> 2. Visualizar dados através de múltiplas visões <br> Você pode visualizar os dados de diferentes maneiras. No canto superior direito, você pode mudar a lista, Kanban, e tela dividida para visualizar os dados. <br>Na visualização de lista, alguns tipos de campos podem modificar diretamente um único ou vários dados. Clique duas vezes na célula a ser editada, ou clique no botão editar, você pode editar os dados diretamente na janela pop-up. Para editar vários pedaços de dados, basta selecionar primeiro vários pedaços de dados e depois selecionar "Aplicar aos dados selecionados" na janela pop-up de edição. <Na visualização de lista, você pode editar diretamente a coluna a ser exibida no canto superior esquerdo, clicar no cabeçalho da tabela para ordenar, ou selecionar a coluna a ser bloqueada através da janela flutuante suspensa. <br> Após definir a visualização Kanban, você pode visualizar os dados em grupos, e visualizar o valor resumido de cada grupo. Nas configurações da visão Kanban, você pode editar a base de agrupamento, a base de resumo e o método de resumo da visão Kanban, e também pode selecionar até quatro campos para exibir. Você pode alterar rapidamente o agrupamento de dados arrastando e soltando. <br>`,
"component.task.label.priority":`Prioridade`,
"label.datamanage.field.error":`Erro no campo do objeto de consulta.`,
"label.console.step3":`Passo 3. Selecione a fonte da imagem para o console`,
"label.ems.emailsyncsetup":`Configuração de sincronização de e-mail`,
"label_tabpage_placeenterz":`Favor entrar`,
"label.getontocolumn":`Saltar para a Coluna:`,
"label.file.down.e":`O tipo de arquivo atual não pode ser baixado`,
"vue_label_notificationcenter_unreadonly":`Somente não lido`,
"label.login.access.change":`Mudança`,
"label.globaloperation.operationtype.send_e-mail":`Enviar e-mail`,
"label.dashboard.refresh.hint":`Clique em Atualizar para carregar os últimos dados no painel de instrumentos. Vai levar algum tempo para executar a fonte de dados, você tem certeza de que quer atualizar?`,
"front-kefu-moudle-open-free":`Habilitar (Julgamento)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Gerencie sua Assinatura`,
"label.chatter.maturiyDate":`Data de expiração`,
"message.mobilechooseatmostthree":`A aba para Mobile App pode selecionar até três campos.`,
"label.customfields.formula.tip":`Um campo somente de leitura que deriva seu valor de uma expressão de fórmula que você define. O campo da fórmula é atualizado quando qualquer um dos campos de origem muda.`,
"lable.PowerProcess.start.time":`Por favor, selecione a hora de início.`,
"label.mr.title.button.group2":`conjunto(s) de registros duplicados, um total de`,
"label.atlantic.standard.time":`Horário Padrão do Atlântico`,
"label.account.LengthofTime":`Duração`,
"label.ccchat.message.search.desc2":`mensagens`,
"label.pigeonhole.desc":`O anexo de arquivo é válido somente para anexos não arquivados.<br/>Após um anexo ser arquivado, ele não será apagado.`,
"label.partnerCloud.orderingPlatform.sure":`O interruptor {alias} irá esvaziar o carrinho. Você tem certeza de confirmar a operação?`,
"label.default.value.is.positive.integer":`O valor padrão deve ser um número inteiro positivo`,
"label.partnerCloud.selectOne":`Selecione pelo menos um menu`,
"label.dashboard.more.condition":`Mais condições`,
"component.event.label.enddate":`*End Time`,
"label.forecast.settings.type":`Tipo de previsão`,
"com.cloudcc.login.error.message.licensenotstart":`A licença não começa`,
"lable.list.queue":`Filas de espera`,
"label.mobile.app.isdisablum":`Desativar a seleção de fotos do álbum móvel no checkin`,
"label.service.gantt.filter":`Ao filtrar por habilidades, somente os recursos com a habilidade selecionada serão exibidos no diagrama de Gantt.`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Retirar todos os contatos desta campanha em massa`,
"label.list.desc1":`Usando Web to CloudCC, você pode capturar informações de contato e perfil dos usuários e gerar automaticamente novos contatos no CloudCC.com`,
"label.generatepage.title.desc3":`O nome deve ser único, e o nome deve implorar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado. Não deve ter mais de 30 caracteres.`,
"label.emailtocloudcc.step2total3":`Etapa 2 de 3`,
"label.movablemenu":`Botões de atividade`,
"label.partnerCloud.partnerAccount.topUp":`Completar`,
"label.data.standobject":`Objetos padrão`,
"label.frequency":`Freqüência`,
"label.schedulejob.setup.schedule.end":`Fim`,
"label.chat.topic.following":`A seguir`,
"label.martrixreport.2018.step2":`Passo 2 Resumir as informações por:`,
"label.event.moveup.11hour":`11 horas à frente`,
"label.forecast.customforecast.directorcommit":`Compromisso dos Subordinados Diretos`,
"vue_label_homepage_card_view":`Vista do cartão`,
"vue_labenl_applauncher_notice_closecertification":`Os dados serão perdidos após o desligamento. Você tem certeza disso?`,
"component_setup_button_weburl":`url externa`,
"label_emailtocloudcc_button_addemailaddress":`Adicionar Caixa de Correio Empresarial`,
"vue_label_campaign_added_campaign_members":`Acrescentou, com sucesso, membros da campanha`,
"label_tabpage_rtemptyz":`O tipo de registro não pode estar vazio`,
"label.martrixreport.2018.step5":`Passo 5 Selecione o tipo de gráfico e o item de destaque`,
"label.moverecord":`Registro de transferência`,
"pagecreator_layout_label_layoutdesc":`Descrição do layout`,
"label.knowledge.setting.data.nine":`Sim, quero eliminar este grupo de categorias e as categorias sob este grupo.`,
"label.icon.90":`Pessoas`,
"label.weixin.micro.research.name":`Nome da Micro Pesquisa`,
"label.ccchat.micropost.allowedit":`Permitir que os usuários editem mensagens e comentários`,
"vue_label_homepage_fixed_components":`Componente padrão`,
"label.version.document":`Biblioteca de documentos`,
"label_assessment":`Avaliação (Oportunidades - Montante)`,
"label.appupload.component.type.lookuplayout":`Layout de busca`,
"label_chatter_loadmore":`Carregar mais`,
"component_setup_tabs_label_memo":`Definir o nome da etiqueta da aba`,
"label.icon.167":`Bússola`,
"vue_label_chatter_enter_content_sharing":`Favor entrar no grupo de compartilhamento de conteúdo e compartilhamento`,
"vue_label_notice_modify_success":`Modificado com sucesso`,
"label.sharerules":`Regras de compartilhamento`,
"label.field.api.exists":`Este campo API já existe.`,
"label.icon.83":`Tinta`,
"label.file":`Arquivo`,
"vue_label_report_foldernameisrequired":`É necessário o nome da pasta`,
"label.emailobject.wizard.btn2":`Conectado, vá para enviar e-mail`,
"label.data.downpage.i_title.num3":`3. B Antes de importar, certifique-se de importar todos os registros relacionados. Por exemplo: se houver uma relação de pesquisa entre os objetos que você está importando atualmente e os contatos, você deve importar primeiro os contatos e depois importar seus dados.`,
"label.email.original.content":`Conteúdo de referência`,
"vue_label_campaign_add_to_campaign":`Adicionar à campanha`,
"label.dashboard.new":`Novo Painel de Controle`,
"label.console.detail":`Detalhe do Console`,
"label.view.desc":`O campo de data pode ser igual a "ontem", "hoje", "amanhã", "último mês", "este mês", "próximo mês", "última semana", "esta semana", "próxima semana" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"label.emailobject.template.insert.continue":`Continuar`,
"label.notification.appointment.overlapEvent":`O horário selecionado está sendo programado, favor selecionar outro horário.`,
"label.console.step6.top":`Fixadas no topo e as listas são sempre visíveis.`,
"label.data.file.the_trigger":`Executar o gatilho`,
"message.report.error.operation":`A ação falhou, favor reiniciar o relatório`,
"vue_label_helpcenter_detail3":`<br>     Gostando e não gostando<br>    Você pode gostar de um comentário sobre um micro-post ou apenas um micro-post. Depois de gostar, você pode ver o número de likes para o posto, e você também pode diferenciar dele. <br>? Editar e excluir posts<br>     A editora de um post pode reeditar ou excluir o post. <br>     Passo 1: Clique no botão à direita do post e selecione Editar ou Excluir na caixa drop-down<br>    Passo 2: Abra o Edit/OK para excluir pop-up<br>     Passo 3: Clique em Save/OK para completar a operação<br>5. Histórico de Aprovação<br>? Submit for Approval<br>     O botão "Submit for Approval" aparece quando um novo registro é criado, um pedido de aprovação é chamado de volta, ou uma aprovação é finalmente negada. <br>     Passo 1: Clique em "Submit for Approval" (Enviar para aprovação). O sistema determina se o registro e o apresentante atendem ao projeto e às condições iniciais do apresentante estabelecidas pelo processo de aprovação, e se todas estas condições forem atendidas, a submissão é bem sucedida. <br>     Se a próxima etapa de aprovação na configuração do processo de aprovação exigir a seleção manual do aprovador, então a etapa 2 é executada após "Submeter para Aprovação".<br>   Etapa 2: Selecione o próximo aprovador e complete a operação de submissão. <br>? Histórico de aprovação<br>     A. Antes de submeter:<br>     Clique em "Previsão do processo de aprovação", o sistema determinará se o registro e o operador que submete os itens definidos no processo de aprovação e, em seguida, se todas estas condições forem atendidas, o processo de aprovação será exibido. <br>     B. Após o envio:<br>    No histórico de aprovação você pode não apenas visualizar as etapas do histórico de aprovação e o status atual do registro, mas também visualizar o próximo processo de aprovação. <br>? Pull back approval requests<br>     Se este processo de aprovação for configurado para retirar os pedidos de aprovação, eles podem ser retirados a qualquer momento depois que você os enviar. <br>     Passo 1: Clique em "Pull Back Approval Request" na página de detalhes do registro <br>   Passo 2: Abra a página Pull Back Approval Request e clique em "Call back approval request" para concluir a operação`,
"Opportunity_Detailed_Phase_Label_004":`dia(s)`,
"PageLayout_Search_MultiSearch_001":`Selecione até 3 campos.`,
"vue_label_systemSettings_set_business":`Configure o layout e os campos de objetos de acordo com a sua empresa.`,
"label.compact.layout.frame.select":`Favor selecionar um quadro de layout de página`,
"label.tabpage.rolez":`Papel`,
"label.weixin.appr.currentauditor":`Atribuído a`,
"label.knowledgebase.verification.status":`Status de verificação`,
"UG_Case_05":`Crie um caso`,
"label.service.marking.completed":`Marcar como Concluído`,
"label.notification.ccchat1":`【发出@的用户名】mentioned você.`,
"label.knowledgebase.no.action.available":`Nenhuma ação disponível`,
"label.tabpage.newlybuildz":`Novo`,
"label.appupload.install.error.choice2":`Renomear os componentes locais que entram em conflito com o pacote`,
"label_tabpage_as":`Como`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Data de início do estágio atual`,
"vue_label_homepage_singlepage":`Adicione até 10 componentes em uma única página`,
"font-evaluate-module-v1-fair-and-bad":`Quando o tipo de avaliação é Neutra e Negativa`,
"label.partnerCloud.orderingPlatform.orderInformation":`Confirmação do pedido`,
"label.custom.lead.conversion.notice":`Converter o Lembrete de Chumbo`,
"label.re.upload":`Re-carregar`,
"label.knowledgebase.top.window":`Janela superior`,
"label.h5.allmarkedasread":`Todos marcados como lidos`,
"vue_label_SMS_open_record_from_start_activation":`Abra o registro da lista para ativar.`,
"label.customer.tab.step2":`Etapa 2 Adicionar aos Perfis`,
"label.campaign.channel.input.owner.select2":`Pessoa de Solicitação deste Canal de Marketing`,
"component.task.button.save":`Salvar`,
"front-kefu-moudle-v1-phone-type":`Tipo de telefone`,
"label.wedge-shapearrows":`Flecha de cauda em forma de cunha`,
"vue_label_homepage_todaysevent":`Eventos de hoje`,
"label.data.exp.way.sel":`Selecione o modo de exportação`,
"label.setting.intergrationlist.status1":`Esta integração não está atualmente instalada.`,
"button_partner_workspace_disable":`Cancelar ativação`,
"label.customfields.reference":`Podem ser referenciados por outros campos, como fórmulas, listas de seleção, campos de pesquisa, e assim por diante.`,
"label.publicgroups.new":`Novo Grupo Pubilc`,
"label.data.setok.e_desc3":`， faça o download de seus dados exportados.`,
"vue_label_commonobjects_view_chart_countmode":`Modo de contagem`,
"label.service.appointmentList.earliest.allowedStart":`Primeira data de início`,
"label.data.choses.e.desc":`De acordo com suas necessidades, você pode exportar todos os dados ou exportar dados de um objeto.`,
"label.multilang.common.fieldlist.fieldremark":`Aplicar para os campos mostrados na página {0}`,
"label.umeng.activity.event":`evento`,
"label.project.hit.ten":`Lembrete de atualização de emissão`,
"label.c_d_least":`Cada registro "C" deve ter pelo menos um registro "D" relacionado.`,
"label.emailobject.wizard.btn1":`Conecte seu e-mail`,
"lable.product.pricebooks.info":`Detalhes do Livro de Preços`,
"component_telerecord_label_message":`Comentário`,
"lable.total.of.estimates":`0 estimativas no total`,
"label.stdashbord.xsld.business.oppcounts":`Quantidade de Oposição`,
"vue_label_commonobject_duplicatewith":`Duplicar {1} em {0}`,
"label.setpicandreport":`Configurações do gráfico`,
"label.category.2":`Geral`,
"label.emailtocloudcc.reauthorization":`Reautorização`,
"label.chatter.vote":`Enquete`,
"label_emailtocloudcc_edit":`Editar`,
"label.pleaseinput":`Entrada`,
"vue_label_homepage_user_particular_application":`A página inicial quando o usuário utiliza uma determinada aplicação, as atribuições substituem a página inicial padrão`,
"label.allianceID":`Identidade de estrangeiro`,
"label.h5.homepage.cannot.applied.mobile.terminal":`A página inicial do perfil não está configurada para este perfil. Ela não está disponível para o Mobile App`,
"label.appointmentpage.wizard.notif2":`O nome é obrigatório!`,
"label_emailsync_status_email":`E-mail com ação executada`,
"label.icon.179":`Pessoas`,
"UG_Contract_03":`Criar contrato`,
"label.cy.new":`Nova moeda`,
"label.version.setup.controllist":`Lista de controle de configuração`,
"label.vlidaterule":`Regras de validação`,
"label.customer.tab.name":`Nome do separador`,
"label.recentview.seloption1":`Visto recentemente`,
"vue_label_report_notice_nameisrequired":`O nome do relatório é obrigatório`,
"label.createapproveprocessstep":`<Criar templates de e-mail </li>>li>li>li>3.Criar templates de SMS </li>>li>li>4.Criar um processo de aprovação usando o Jump Start ou o Assistente Standard </li>li>5.Adicionar "Histórico de Aprovação" Lista relacionada a todos os layouts de página </li>>li>6.Ativar o processo para implantar em seus usuários </li>`,
"label.gotocalendar":`Ir para Calendário`,
"label.import.page1.pleaseselectobj":`Favor selecionar primeiro o objeto`,
"label_tabpage_messagez":`Por favor, digite seu comentário`,
"vue_label_homepage_profilepage":`Página inicial do perfil`,
"label.tabpage.choose":`Selecione`,
"label.campaignmember.setup.lead.field":`Campos de chumbo`,
"label.setalipay.null":`As informações necessárias para a configuração do Alipay estão vazias.`,
"label.custom.Current.and.NextCQ":`CQ atual e CQ seguinte`,
"label.knowledgebase.needto.publish.articles":`O artigo arquivado de novo criará uma versão preliminar. Você quer publicar o artigo?`,
"pagecreator.layout.message.save.success":`Layout salvo com sucesso`,
"homepage.componet.approval.label":`Itens a serem aprovados`,
"label.last_submission":`Último Tempo Submetido`,
"lable.outlook.detail.prefo":`A troca sempre vence`,
"label.projectManagement.new.subtask":`Nova Sub-tarefa`,
"label.service.appointmentList.checkThe":`Verificado em`,
"message.error.searchlayoutselectdefields":`Não pode ser apagado e deve ser o primeiro campo no layout de busca.`,
"label.ems.normal":`Normal`,
"vue_label_notice_pleaseselectobject":`Por favor, selecione um objeto`,
"component.sendmail.button.send":`Enviar`,
"label.relevant.records":`Registros relacionados`,
"label.weixin.login.CloudCC":`Log In`,
"label.tag.addtags.private":`Particular`,
"label.appointment.disable.remark":`Desculpe, a função está atualmente desativada. Se você quiser remarcar ou cancelar a reunião, favor entrar em contato com a pessoa responsável em {邮箱地址}.`,
"label.campaignmember.main.addMember1":`Adicionar membros`,
"message.error.objectnofound":`Objeto indefinido`,
"label.employeenum":`Número do funcionário`,
"label.search.applyfilter":`Aplicar filtro`,
"label.version.history.track.nonsupport":`Somente a versão infinita suporta a função de histórico de rastreamento de campo.`,
"label.ccpeak.direction.for.use.time":`Instrução para Classes Programadas [Versão 2.0]`,
"label.ems.settings":`Configurações`,
"label_tabpage_arecordtypez":`Tipo de registro disponível`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instrução para componentes personalizados [ versão 2.0]`,
"label.appupload.appname":`Nome do pacote`,
"label.cpq.order.status.no.active":`Somente pedidos com status ativo podem gerar contratos`,
"label.dashboard.maxlength":`Você pode digitar até 255 caracteres`,
"label.customize.memory.function.sorting.title2":`Memória de classificação de cabeçalhos`,
"label.report.chose.obj":`favor selecionar relação de objeto e fonte de dados do relatório`,
"label.partner.step3":`Passo 3 Informações básicas`,
"message.report.type.error.fail":`Fonte de dados do relatório inválido.`,
"pagecreator.page.message.publish.fail":`A publicação da página falhou`,
"label.minimun":`Mínimo`,
"label.state":`Status`,
"label.customcomponent.referencetype":`Tipo de referência`,
"label.nameandemailtemplate":`Digite um nome para seu processo na caixa abaixo e depois selecione um modelo de e-mail para notificar o autorizador (opcional).`,
"label.customobjects.track.introduce":`Esta página permite que você selecione os campos que deseja rastrear no`,
"label.campaign.matchway.label":`Método de correspondência`,
"label.redistribution":`Reatribuir`,
"label.groupmanage":`Gestão da Organização`,
"label.icon.157":`Câmera`,
"label.quickbooks.viewlist.total":`TOTAL`,
"label.file.copy.file.fail":`Cópia falhou, favor copiar manualmente`,
"label.outline.selectfield":`Campos selecionados em resumo:`,
"label.datetime.maxsize":`O ciclo de uma consulta não pode ser maior do que três meses.`,
"label.dashboard.CustomDashboardMyHomePage":`Personalizar minha página inicial Painel de Controle`,
"label.data.customobject":`Objetos personalizados`,
"vue_label_SMS_noselected":`Nenhum registro selecionado`,
"label_tabpage_value":`Valor`,
"label.quote.qianming":`Assinatura`,
"label.view.source":`Ver código fonte`,
"label_popup_infoz":`Pronto`,
"label.emailtocloudcc.redmessage8":`Erro de parâmetro, favor entrar em contato com o administrador.`,
"label.tianyancha.Search.business":`Buscar informações sobre o registro de empresas`,
"vue_label_systemSettings_server":`Serviço`,
"vue_label_homepage_dashboard_components":`Componente do painel de instrumentos`,
"label.search.listview":`Vista de lista`,
"label.service.gantt.distribution.success":`Atribuído com sucesso`,
"label.icon.4":`Carteira`,
"label.partnerCloud.orderingPlatform.calculate":`Calcular o preço`,
"label.forecast.edittotal.ycyx":`Prioridade Prevista`,
"vue_label_commonobjects_detail_to_precise_search":`Busca precisa`,
"label.order.number":`Ordem`,
"setup.mainpage.label.welcome7":`Instruções: Clique no menu do lado esquerdo da página → Configurações da Aplicação → Criar → Objeto → Nome do Objeto → Campo personalizado.`,
"label.weixin.user.binding":`Encadernação do usuário`,
"label.custom.canvas.size":`Tamanho da lona`,
"label.projectManagement.recent.projects":`Projeto recente`,
"vue_label_helpcenter_lead":`Rastreie e gerencie seus contatos através da Cloud CC. Use as regras configuradas para pontuar e atribuir leads, e converta-os em clientes, contatos e oportunidades de negócios correspondentes no momento certo.<br>Score<br> No canto superior direito da vista, use o botão de pontuação de lote para pontuar leads na vista.<br>distribuição<br>> Ao criar ou editar um lead, selecione Atribuir na parte inferior da página para atribuir o lead ao pessoal correspondente para processamento de acordo com as regras existentes.<br>Conversão<br> No momento certo, você pode converter leads em clientes e contatos clicando no botão de conversão no canto superior direito da página de detalhes. Ao mesmo tempo, você pode criar oportunidades de negócios e tarefas correspondentes para facilitar o acompanhamento contínuo das oportunidades de transação.`,
"label.enabledprocess":`Processos de aprovação ativos`,
"label.emailobject.noemail":`Nenhum correio ainda, vá e envie um!`,
"label.validate.remark3":`Determinar se um campo é necessário com base no valor de outro campo`,
"vue_label_salesadvance_retention":`Retenção`,
"label.product.managep":`Gerenciar livros de preços`,
"font-evaluate-module-v1-not-report":`Não reabrir`,
"label.emailmerge.mergepage.step1":`1. escolha os registros a serem fundidos:`,
"front-epwechat-module-v1-epwechat-describe":`O CloudCC proporciona a integração com a WeCom, combinando as poderosas características da WeCom com a versão H5 leve do sistema CloudCC,<br /> ajudando você a gerenciar convenientemente as relações com os clientes, operar o tráfego de domínio privado e melhorar a receita da empresa.`,
"label.partner.template.detailimage":`Foto`,
"label.recycle.clearall":`Lixeira Vazia de Sua Organização`,
"chatter.error.nottype":`Erro: Tipo de arquivo inválido. Favor utilizar arquivos JPG, GIF ou PNG.`,
"pagecreator.button.cancel":`Cancelar`,
"front-market-form-quired-ziduan":`Campos obrigatórios na página de registro`,
"vue_label_report_columnname":`Nome da coluna`,
"message.notdelete.type":`Você não pode excluir este tipo de registro, pois os perfis a seguir utilizam este tipo de registro como o valor padrão.`,
"label.ccpeak.folder.all.time":`Todas as Pastas de Classe Programadas`,
"label.quickbooks.searchlist.total3":`Existem {0} estimativas não vinculadas para um valor total de {1}`,
"label.forecast.detailforecast.quantity":`Previsão de quantidade`,
"label.knowledge.language.british":`Britânico`,
"label.vlidaterule.example.messagelocation":`Esta mensagem de erro pode aparecer na parte superior da página ou abaixo de um campo específico na página`,
"front-kefu-moudle-chf-success":`Dividido com sucesso`,
"vue_label_jihui_yi":`Oportunidade 1`,
"label.import.step1.null":`Não há opções disponíveis`,
"label.console.step5.tab.subtab":`Como uma subárea de`,
"batch.edit.permission":`Sem permissões para editar`,
"label.weixin.fmu.before.min":`{0} minutos antes do previsto`,
"chatter.up.file":`O upload do arquivo leva algum tempo, dependendo do tamanho do arquivo carregado, por favor aguarde.`,
"setup.layout.group.field":`Campos`,
"label.chat.unlike":`Gosto`,
"vue_label_dashboard_updatefrequency":`Freqüência de atualização`,
"label.trigger.folder.new":`Páginas de ativação: Nova Pasta`,
"label.process.des.app":`Clique no link à direita para ver detalhes do registro atual.`,
"vue_label_pool_assignselect":`Escolha para designar membros`,
"label.lookup.user":`Busca Colegas`,
"label.mobilescreentablayoutedit.remark2":`Selecione os campos de filtro exibidos na página inicial da guia no Mobile App.`,
"label.data.exp.objtemp":`Você criará o modelo para exportar os dados deste objeto como segue cretira`,
"label.weixin.moreselect.error":`Apenas 10 registros que você pode selecionar`,
"label.icon.25":`Atadura`,
"lable.sample.text":`Exemplo de texto`,
"label.most.setup.obj":`Podem ser definidos até 10 objetos.`,
"label.weixin.coming":`Em breve`,
"label.editdescription":`Nota Editar`,
"label.multipleactivity.multiple":`Multiusuários`,
"label.sso.saml.idp.entityid":`Identificação da entidade`,
"label.SMS.pho.filed":`Campo do telefone`,
"message.serviceabsence.violation":`Violação do período de atribuição: está em conflito com o registro de ausência.`,
"label.forecast.settings.type.clist":`Usar famílias de produtos`,
"label.state.noend":`Incompleto`,
"label.sourcetemp":`Fonte`,
"vue_label_chatter_name_link":`Favor preencher o nome e o link`,
"label.emailobject.attach":`Anexar`,
"label.everyother":`Todos os outros`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Você ainda não ativou uma conta de chat. Você quer ativar agora?`,
"pagecreator_layout_button_delete":`Excluir layout`,
"label.transfer.temporarily":`Ligue para`,
"label.service.dispatchingUnits.search.services":`Consulta de serviço de busca`,
"customer.message.fail.chat":`Falha na obtenção de registros de mensagens, favor contatar o administrador para obter ajuda`,
"label.apiname.toolong":`O nome API é muito longo.`,
"label.empty.filter":`Filtros transparentes`,
"label_tabpage_personalCenterz":`Centro pessoal`,
"label.minutes":`Ata`,
"label.multipleactivity.atasks":`Tarefa(s)`,
"label_tabpage_deleteview":`Eliminar a visão`,
"pagecreator_layout_message_save_success":`Layout salvo com sucesso`,
"label.reportlineorder":`Ordem das Colunas de Relatório`,
"label.total.forecast.have.priority":`qualquer previsão é anterior, mas as que aceitam outras sub-condições são anteriores`,
"label.custom.quarter.subtitle":`Trimestre personalizado`,
"label.icon.79":`Imprimir`,
"label.hiddenoperate":`Ocultar ações`,
"label.project.hit.six":`Aviso de atribuição de tarefas`,
"label.visualpageaction.errordesc":`Você não tem a permissão para excutar a operação que solicitou. Favor contatar o proprietário do registro ou seu administrador.`,
"label.chat.unmute":`Cancelar "não desconfiar".`,
"label.zhaiyao":`Abstrato`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`Versão API`,
"UG.quota.06":`Crie uma cotação`,
"label.icon.152":`Robô`,
"label.partnerCloud.partnerAccount.account":`Nome de usuário`,
"label.file.sharewith":`Compartilhador`,
"label.data.dataexptemplate.desc2":`2. O formato de compressão é dividido em dois tipos: um é gerar automaticamente a senha do arquivo comprimido, o outro é inserir manualmente a senha do arquivo comprimido.`,
"vue_label_dashboard_newfoldersuccessfully":`Criar uma nova pasta com sucesso`,
"label.campaignmember.main.importmember":`Membros de campanhas de importação em massa`,
"label.htyj.completed":`Concluído`,
"label.reportTypeLabel":`Rótulo do tipo de relatório`,
"label.customer.tab.label":`Rótulo da etiqueta`,
"label.dashboard.component":`Componentes`,
"label.safetystatement.dialog":`Declaração de segurança (Nova janela)`,
"label.forecast.settings.data":`Data prevista`,
"label.knowledgebase.modifiedby":`Modificado por`,
"label.batchadd.remark":`Adicionar vários registros`,
"button.partner.delete":`Excluir`,
"Pagelayout_Setup_005":`O nome tem que ser colocado em primeiro lugar.`,
"label.forecast.edit.wcpxl":`Nenhuma família de produtos`,
"lable.PowerProcess.seq.input":`Por favor, insira um pedido.`,
"pagecreator.layout.message.delete.fail":`A eliminação do layout falhou`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`Dez mil yuan`,
"setup.mainpage.button.manageobject":`Gerenciamento de Objetos`,
"label.weixin.participants.perfect.information":`Os participantes são obrigados a melhorar as informações`,
"vue_label_campaign_campaign_members":`Adicionar membros da campanha`,
"label.ccchat.person.invite.emplaceholder":`Digite os endereços de e-mail e separe por ponto-e-vírgula`,
"label.mobile.phone.new":`Novo`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Configuração de avaliação de miniprograma`,
"UG.opportunity.005":`Processo de vendas múltiplas`,
"vue_label_report_polymerization":`Agregado`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`A condição {0} da linha está incorreta, o tipo de campo não corresponde!`,
"label.knowledgebase.delete.draft":`Eliminar Draft?`,
"label.mr.descreption.condition3":`Correspondência exata de regras: verifique este item e encontre registros duplicados com os mesmos caracteres de campo. Se for verificado, encontrar duplicatas com os primeiros caracteres invaidará.`,
"Lead.Auto.Scoring.Setting":`Definição da pontuação de chumbo`,
"label.marketing.channel.default":`Canal de Marketing (Ativado por padrão)`,
"front-project-module-v1-select-projecttemplate":`Selecione o modelo do projeto`,
"front-email-payment-select-area":`Favor entrar no distrito`,
"lable.PowerProcess.message":`Informações sobre o processo de concessão de direitos`,
"label.weixin.free.get.captcha":`Obtenha o Código de Verificação Gratuito`,
"label.projectManagement.please.select.task.or.question":`Por favor, selecione Tarefa/assessoria`,
"label.pacific.daylight.time":`Horário de verão do Pacífico`,
"label.sendsms.batch.step1.introduce":`Selecione uma das seguintes visões (que contém os destinatários deste SMS)`,
"label.same.analyze.account.name":`Nome da conta`,
"Homepage.Contract.FieldMissed.DoesntSupport":`Não há campos "qdrq" e "htje" no objeto do contrato, portanto os dados não podem ser mostrados.`,
"label.partnerCloud.orderingPlatform.noProduct":`Não é necessária nenhuma configuração de opção de produto sob este produto.`,
"label.totalsummary":`Resumo do Roll-Up`,
"label.partner.workspace.tab":`Tab`,
"label.entitlement.process.name.unique":`Este nome já existe. Favor entrar novamente.`,
"report.label.norole":`Você não tem permissão para fazer isso, por favor, entre em contato com seu administrador.`,
"label.password.old.error":`Senha antiga incorreta, favor entrar novamente.`,
"lable.account.quarter.stadate":`Dia de Início do Trimestre Fiscal`,
"label.salescloud.contactrole.choose.correct":`Contatos duplicados selecionados, favor corrigir.`,
"label.schedulejob.setup.schedule.day":`Dia`,
"label.communalusergroup":`Grupos Públicos`,
"label.Display.Fields":`Campos exibidos na lista de serviços de apoio`,
"label.marketsea":`Piscina`,
"label_partner_setup_address":`Endereço da nuvem de parceiros`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Exportação de dados e criação de modelos`,
"label.pc.ui.2018":`Vertical`,
"label.version.free":`Edição gratuita`,
"label.dataimport.contact.length":`Erro: o comprimento do nome do contato é muito longo`,
"label.cy.vlidate":`A ação da moeda habilitada é irreversível. Você tem certeza de que quer habilitar o Gerenciamento de Moeda?`,
"label.recycle.all":`Todas as caixas de reciclagem`,
"label.message.changeaccount.isnot":`O contato permitiu ao usuário parceiro, não pode mudar de conta`,
"label.searchlayout.exactsearch":` Dica: Marque a caixa de seleção atrás do campo de busca para realizar uma busca exata por esse campo`,
"label.file.size.limit":`Nota: O tamanho máximo do arquivo é 10M.`,
"label.mobileapp.modelsetting1":`Configurações do Módulo Padrão Móvel`,
"template.report.overall.sales.opportunities":`Período total de vendas (Por tipo de oportunidade)`,
"label.password.update.success":`A senha foi alterada com sucesso.`,
"label.import.page3.gobackhome":`Voltar para casa`,
"label.phone":`Telefone`,
"label.detail.vlidaterule":`Ver Regras de Validação`,
"label.weixin.input.usernames":`Por favor, digite seu nome de usuário`,
"label.icon.85":`Transformador`,
"vue_label_systemSettings_partner":`Parceiro`,
"label.processsetting.new.process":`Novo processo`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lista de regras de pontuação principal`,
"setup.layout.component.area":`Área`,
"label.createnewpwdinformuser":`Gerar uma nova senha e notificar o usuário imediatamente`,
"label.pwinfo":`Detalhes da senha`,
"label.imgfield.type.url":`Imagem de referência`,
"label.attendance.sxccheckincy":`Check-In de membros da campanha`,
"lable.PowerProcess.condition.input":`Por favor, selecione a condição.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Recarga de material`,
"label.document.size.too.long":`Tamanho do documento excedido`,
"label.link":`Link de acesso`,
"label.partnerproduct.sort.repeat":`O nome da família de produtos é tomado.`,
"label.data.setok.e_desc2":`Página de Lista de Dados de Exportação`,
"front-project-module-v1-plase-input-project-name":`Por favor, insira o nome do projeto`,
"label.export":`Exportação`,
"label.icon.45":`Caldeira`,
"label.autoRegister.changepwd.title":`Defina sua senha de login`,
"label_clear_adjust":`Ajuste claro`,
"front-kefu-moudle-return-visit":`Revisão`,
"label.ems.compose":`Compor`,
"Pagelayout_Setup_002":`Você selecionou 3 listas relacionadas e adicionar mais listas relacionadas afetará o layout da página.`,
"label.service.gantt.skill.screening":`Use o filtro de Habilidade`,
"label.partnerCloud.basicSetting.enable":`A Nuvem de Parceiros será desativada. As ações de login e edição em sua organização serão desativadas automaticamente pelo sistema.`,
"label.workbanch.setup.description":`Você pode configurar as seguintes vistas para mostrar em My Workbanch.`,
"label.category.1":`Todos`,
"label.foldername":`Nome da pasta`,
"label.forecast.settings.shuliang":`Quantidade`,
"label.emailmerge.newtemplate.word":`Por favor, faça o upload de documentos do Microsoft Word.`,
"message.error.type":`tipo não pode estar vazio, você precisa passar público tipo público ou pessoal privado!`,
"label.manualallocation":`Atribuir manualmente`,
"label.addattachment.step2":`Passo 3 Clique em Upload File para carregar o arquivo`,
"label.company":`Empresa`,
"label_emailsync_status_export":`Exportar como arquivo em formato Excel_csv`,
"label.eventreminder":`Lembrete do evento`,
"label.emailtemplate.lookup":`Veja os modelos de e-mail`,
"label.customsetting.touse.getCustomSetting":`Consultar o tipo de "hierarquia" de configurações personalizadas, retornar o apiName e permissões correspondentes (ID é profile ID ou User ID ), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Utilização de recursos`,
"label.appointment.wizard.subtitle4":`Configurações de tempo e tampão`,
"label.donot.close.your.browser":`Durante este processo, por favor, não clique em outro link ou feche seu navegador web.`,
"label.multilang.customforcast.target":`Meta de {0}：`,
"setup_layout_label_newarea":`Nova área`,
"component.timeline.button.more":`Mais passos`,
"label.appointmentdetail.wizard.title3":`Duração`,
"label.help.new.features.pc":`Guia de operação das novas características do lado Pc-side`,
"label.mr.record":`Registro`,
"label.trigger.wgd":`Gatilhos não queimados`,
"label.icon.72":`Caixa de ferramentas`,
"setup.layout.label.detailpage":`Página de detalhes`,
"frame.personinfo.label.usethisimage":`Utilizaremos variações desta imagem em miniatura em torno da aplicação.`,
"label.multilingual.confirm.open":`Você tem certeza de que vai habilitar? A multilinguagem pode ser usada após a habilitação.`,
"label.recordcreater":`Criado por`,
"label.afterfinish":`Quando terminar, clique em Salvar`,
"label.companyinformation":`Informações sobre a empresa`,
"step1":`Passo 1`,
"label.sales.page.dashboard.add":`Adicionar à página inicial Painel de Controle`,
"label.processsetting.process.enabled.failed":`Falha em apagar o processo!`,
"label.document.history.date":`Data`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Todos os usuários podem acessar esta pasta`,
"april":`Abril`,
"label_emailsync_form_disconnect":`Cancelar Conncet`,
"label.appointment.wizard.subtitle4-2-6":`2 dias`,
"vue_label_notice_follow_success":`Seguiu-se`,
"label.startuploadfile.success":`Ao clicar no "Start Upload", se a barra de progresso atingir 100%, o arquivo é carregado com sucesso e desaparece na área superior.`,
"message.accesstoken.acquisition.failed":`Falha em obter o token de acesso!`,
"label.quickbooks.fieldlabel.fistname":`Primeiro nome`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`Você não tem permissão para ver este registro, por favor clique para voltar ao passo anterior.`,
"label.batchaddattachments":`Fixação de adição em massa`,
"label.ems.next":`Próximo`,
"label.quote.zhekou":`Desconto`,
"lable.product.notdel":`Porque ainda está no manual com outros registros do livro de preços. Os registros relacionados são os seguintes.`,
"label.ems.action":`Ação`,
"message.error.chart.type":`Os tipos de gráficos não podem estar vazios.`,
"label.conditiontag.lookup.value":`Valor`,
"label.chatter.allactivity":`Todas as atividades`,
"label.summaryreport":`Relatórios resumidos`,
"label.textmessage.vonage.action":`Ação`,
"label.ccpeak.must.result":`Deve ser usado como seguido por pseudônimos para buscar o resultado`,
"label.data.newtemplate.savetemp.desc":`Por favor, digite cuidadosamente o nome e a descrição do modelo para facilitar seu uso.`,
"label.projectManagement.search.for.users":`Busca por usuário`,
"component.milestones.label.title":`Marco histórico`,
"vue_label_applauncher_description_accountpool":`Use o Pool de Contas para administrar convenientemente o status de acompanhamento dentro da organização e motivar o pessoal a concluir a transação.`,
"label.import.index.startimport":`Iniciar Importação`,
"page.field.masterinput2":`Entrada Master-Detail`,
"label.mobile.change.owner.permission":`O novo proprietário deve ter permissões de "leitura" neste tipo de registro.`,
"label_partner_common_enable":`Habilitar a nuvem de parceiros`,
"label.log.browser":`Navegador`,
"label.app.step4":`Passo 4 Escolha as abas`,
"lable.quote.syncing.opportunity":`Oportunidades`,
"label.forecast.customforecast.foredis.jqz":`Valor exato`,
"label.forecast.forecastroleuserpage.title":`Designação do Gerente de Previsões`,
"label.starting.quarter":`Trimestre inicial`,
"label-combination-record":`Registro {index}`,
"label.here":`aqui`,
"label.weixin.underfind.error":`Erro desconhecido`,
"label.cloudccclass.list.tip.time":`Permitir que os desenvolvedores desenvolvam classes programadas na plataforma CloudCC.com, que podem ser usadas para programas programados.`,
"label.data.setok.t_desc1":`Se você precisar usar este modelo de dados derivados, por favor clique`,
"label.service.gantt.break.rules":`Quebra de regras`,
"label.weixin.no.pending.ywjh.qin":`Nenhuma oportunidade para os próximos 30 dias`,
"label.view.atleastone":`A lista não pode estar vazia.`,
"label.attendance.sxccheckin":`Participação em campanhas`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Você tem certeza de que quer apagar este modelo?`,
"label_chatter_theme":`Tópicos`,
"label.partner.new.step1":`Passo 1 Escolha o modelo que você gosta`,
"vue_label_commonobjects_view_settings":`Configurações de visualização Kanban`,
"UG_Contract_02":`O contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir os termos de fazer negócios com outras empresas. Use o CloudCC para estabelecer e documentar seus contratos existentes com suas contas e oportunidades de negócios. Acompanhe o contrato através do processo de aprovação. Use lembretes de fluxo de trabalho para lembrá-lo da prorrogação do contrato.`,
"label.setup.mobilesetup.isenableh5newandedit":`H5 em seu aplicativo móvel.`,
"label.attendance.edit":`Edição de Assiduidade`,
"label.service.miniProgram.fillImageLink":`Por favor, preencha o link do carrossel.`,
"label.b.c.without":`Os registros B podem ou não ter registros "C" relacionados.`,
"label.sso.key":`Código de Autorização`,
"label.star_click":`Clique para limpar`,
"vue_label_SMS_name_or_phone_number_lookup":`busca de nomes de registros`,
"label.case.copre.text":`Você também pode baixar um código QR do portal web dedicado a sua empresa e colocálo em seu site ou dispositivo, depois os clientes podem escanear o código QR para usar a versão web do portal do cliente.`,
"label.salescloud.forbidden.confirm":`Você tem certeza de que quer desativar as equipes de oportunidade?`,
"vue_label_chat_conformactivation":`Confirmar ativação`,
"label.emailtocloudcc.redmessage9":`Erro no banco de dados, favor entrar em contato com o administrador.`,
"label.sahreto":`Compartilhe com`,
"label.recordtype.sort":`Os tipos de registro são exibidos na ordem em que são salvos.`,
"label.allreport":`Todos os relatórios`,
"front-gantt-module-drag-and-drop-subtask":`Arraste (coloque em uma tarefa) para fazêla como uma subtarefa!`,
"label.permission.objlist.nopermission":`Sem acesso`,
"label_file_num":`Quantidade`,
"chatter.mostword":`Seu comentário é mais de 500 palavras, favor apagar e reentrar.`,
"label.h5.chatter.comment":`Comentário sobre o corpo`,
"vue_label_calendar_notice_havecreated":`Você criou um calendário`,
"label.tabpage.loadz":`Carregamento de página, por favor aguarde...`,
"chatter.w.p":`Telefone de trabalho`,
"label.chat.topic.name.desc":`Você só pode alterar o caso e o espaçamento dos nomes dos tópicos.`,
"label_partner_template_name":`Nome do modelo`,
"label.mobile.phone.required.examines.people":`É necessário o "Revised By".`,
"message.error.view.notexists":`A vista não existe.</br> Ou a vista pode ter sido modificada por outra pessoa, clique <a href='javascript:history.back();'> aqui </a>para trás.`,
"label.custom_time":`Tempo personalizado`,
"label_partner_workspace_member_all":`Todos`,
"lable.custom.year.name":`Nome do Ano Personalizado`,
"label.account.previous.M":`Último mês`,
"vue_label_commonobjects_detail_locking":`Fechadura`,
"label.brief.lead":`Líderes`,
"label.linkedin.setting.appsecret":`Senha da chave secreta`,
"label.query.detail.closepartner":`Desativar parceiros`,
"label.isEnableVisualpage_new.rightlist":`Páginas Personalizadas Ativas`,
"front-epwechat-module-v1-unbound-item3":` dados de informações autorizadas`,
"label.exchange.sync.setting.info":`Após criar uma conta de serviço com permissões de personalização para os usuários no Microsoft©Exchange, insira as credenciais da conta de serviço para permitir que o CloudCC se comunique com o servidor do Exchange. Se as credenciais da conta de serviço tiverem sido salvas, mas o usuário ainda não conseguir sincronizar os registros, certifique-se de que você configurou o Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`E-mail do grupo CloudCC envia e-mail com falha`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`O limite superior para edição de cada nível de desconto deve ser maior do que o limite inferior.`,
"label.visualpage.list.vpname":`Nome da página personalizada`,
"label.mask.length.error.message":`Campo de texto criptografado não pode ter mais de 255 caracteres`,
"label.h5.approval.actorname":`Apresentado por`,
"label.knowledgebase.view.translation":`Ver Tradução`,
"label.ems.edit":`Editar`,
"vue_label_commonobjects_view_reset_width":`Largura da coluna de reinicialização`,
"label.version.feature.controllist":`Lista de limites de funções`,
"label.setuppagelayout":`Layouts de página`,
"vue_label_commonobjects_view_new_view":`Nova visão`,
"label_tabpage_queuez":`Fila`,
"label.direct.dashboard.wait.me.approval":`Itens a serem aprovados`,
"message.report.error.noRelatedField":`Nenhum campo relacionado com o relatório. Eles podem ter sido excluídos, favor entrar em contato com seu administrador.`,
"label.ccchat.person.invite.notme":`Você não pode enviar convites para seu próprio endereço de e-mail.`,
"label.weixin.jieduan.finish":`Marcar a etapa atual como concluída`,
"vue_label_commonobjects_detail_?enter_subject":`Favor entrar o assunto`,
"label_starting_month":`Mês inicial`,
"label.address_linetwo":`Linha de endereço 2`,
"message.error.select.contiguous.item":`Seleção de itens relevantes com`,
"vue_label_pricebook_enterbookname":`Por favor, digite o nome da lista de preços`,
"label.cycleworkflowoperate":`Ações de Fluxo de Trabalho Periódico`,
"label.ems.withoneday":`Hoje`,
"component.todaytask.label.notask":`Hoje não há tarefa de expiração, tome um café.`,
"label.tianyancha.id":`Identificação da empresa`,
"label.user.illegal.login":`Login ilegal`,
"label.withgathercondition":`Por Critérios Resumidos`,
"label.foldervisitlimit":`Permissões de acesso`,
"label.ccchat.search.conversation":`Pesquise esta conversa`,
"lable.annual.project.report":`Relatório de conta do projeto neste ano`,
"template.chart.qzkhzhfx":`Análise de conversão de chumbo`,
"label.my":`Meu`,
"label.sendsms.batch.chosetemplate":`SMS em massa: Selecione um modelo ou edite o conteúdo`,
"label.callcenter.enterprise.number":`Empresa No.`,
"label_last_modified_by_time":`Último modificador e tempo`,
"message.fieldtrack.operaterecord":`Mudou <b>operatefield</b>f>b>operateold</b>to<b>operatenew</b>`,
"label.mobile.more.openin":`Aberto em...`,
"label.multilingual.tip2":`Você pode habilitar ou desabilitar o multilíngue.`,
"label.datamanage.lead.novalue":`Nota: O campo do nome de chumbo é nulo, os registros de contato não serão importados.`,
"label.custom.revoke":`Desfazer`,
"label_chatter_leaveword":`Comentário`,
"vue_label_ccchat_group_deletedgroup":`O grupo foi eliminado`,
"label.tabpage.operationz":`Campo, a operação não pode estar vazia`,
"label.user.organization.permit.overdue":`Sua licença de organização tem espiro, por favor entre em contato com o administrador!`,
"label.log.datetimeoruser.value":`Favor entrar o tempo de consulta e o nome de usuário.`,
"lable.product.stsp.noavailable":`Não há preço padrão disponível`,
"label.appservice.cannot.delete.app":`Você não pode excluir este aplicativo personalizado, porque alguns perfis estão usando este aplicativo personalizado como o aplicativo padrão.`,
"component.event.label.newevent":`Novo Evento`,
"label.view.sortview.exportview":`Vista de exportação`,
"label.uploadfilemaxsize":`O valor máximo de upload de arquivo permitido é`,
"label.event.weekview":`Visão da semana`,
"label.conversion_rate":`Taxa de conversão`,
"label.partnerCloud.partnerAccount.useWechat":`Use o scanner WeChat para pagar.`,
"UG_Forcast_05":`Configurações de previsão: passo {0}/{1}`,
"label.service.gantt.jobresour":`Mostrar apenas recursos de trabalho`,
"vue_label_campaign_fromopprotunities":`De {dsrjine} oportunidades de negócios`,
"label.app.skyblue":`Azul Céu`,
"label.chinacloudcc":`Cloud Computing China`,
"label.connectOtherFinalNumber":`Limite de Objeto Alcançado<br/> Você pode associar até quatro objetos a uma fonte de dados de relatório personalizada.`,
"label.redistributionrequest":`Reatribuir os pedidos de aprovação`,
"label.knowledge.category.button.one":`Adicionar Sub-categoria`,
"label.campagin.pcandmo":`PC e Celular`,
"label.project.milestone.date":`A data do marco deve estar dentro do intervalo de datas do projeto ao qual ele pertence.`,
"assetbom.transfer.notpermission":`Você não tem a autenticidade para migrar a lista técnica de ativos. Favor entrar em contato com o administrador.`,
"label.marketing.setting1":`Canais de Marketing`,
"label.select.file":`Selecione o arquivo`,
"message.error.object.contactadministrators":`O sistema é anormal, favor entrar em contato com o administrador do sistema para obter ajuda.`,
"label.custom.quarter.title":`Trimestre personalizado`,
"label.knowledge.case.settings":`Casos de fixação`,
"front-service-cloud-transfer-title":`Transferência Proprietário da lista técnica de ativos`,
"label.group.search.searchthisfeed":`Pesquise esta alimentação`,
"label.report.action.addtodashboard5":`Adicionar ao Novo Painel de Controle`,
"label.mobile.side.tab.remark2":`Ao definir o controle deslizante, você pode colocar os itens mais usados na posição frontal. histórico de chamadas, item de menu só pode ser usado para a versão andróide do CloudCC no lado móvel.`,
"contain":`Incluir`,
"label.select.template":`Selecione o modelo`,
"label.addattachment.step3.weixin":`Passo 3 Clique no botão "Completar" e volte para a página anterior.`,
"lable.Order.successfully":`Ordem de transferência para ativo com sucesso.`,
"label.user.title":`Título`,
"label.weixin.check.agreement":`Favor verificar o acordo relevante`,
"label.SMS.pfi":`Campo de número de telefone`,
"label.weixin.micro.research":`Micro Pesquisa`,
"label.projectManagement.assigned.work":`Trabalho designado`,
"label.document.login.error":`O login falhou, por favor tente novamente.`,
"label.mobile.phone.examines.people":`Revisado por`,
"label.safetyset":`Configurações de segurança`,
"label_function_tip":`Esta característica não é atualmente suportada pelos usuários do continente chinês. Agradecemos sua compreensão!`,
"label.app.sort":`Classificar aplicações`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Título`,
"label.event.moveup.3day":`3 dias à frente`,
"label.condition":`Condições`,
"label.description.message":`Máximo de 500 caracteres.`,
"label.ems.detailedsettings":`Ajustes detalhados`,
"label.repeat.condition.field.prompt":`Favor preencher um número no campo "De acordo com o tamanho dos caracteres" Filed！`,
"label.validate.function.funcExplain.OR":`Verifique se qualquer parâmetro é verdadeiro e retorna VERDADEIRO ou FALSO. Retorna FALSO somente se todos os parâmetros forem falsos.`,
"label.salecommit.allow.prediction.query":`Você não pode ver os painéis de controle de compromisso de vendas porque você não marcou a opção Permitir Previsões a partir do Setup-My Personal Information-Personal Settings.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Ver`,
"front-gantt-module-quick-create-task":`Criar tarefa rapidamente`,
"label.all_forms":`Todos os Formulários`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Dimensão estatística`,
"label.forecast.settings.data.chanpin":`Data do produto`,
"label.appointment.wizard.subtitle4-2-7":`3 dias`,
"front-web-module-v1-detail-comment-please":`Por favor, digite o feedback`,
"label_chatter_nextSevenday":`Próximos 7 dias`,
"homepage.components.desctiption":`Esta página permite a você criar e editar componentes que podem ser mostrados em um ou mais layouts de página inicial.`,
"label.customcomponent.page.index.table.namespace":`Prefixo do espaço de nomes`,
"label_emailtocloudcc_exists":`O e-mail já existe.`,
"label_tabpage_save":`Salvar`,
"label.mergeRechecking":`Verificar Duplicação e Fusão`,
"vue_label_helpcenter_view2":`Na visualização da tela dividida, você pode mudar rapidamente para visualizar as informações detalhadas de cada dado. <br> 3. Analisar rapidamente os dados de vendas<br> No canto superior direito da visualização, você pode abrir o gráfico na visualização para realizar uma análise visual simples dos dados na visualização. Ao mesmo tempo, você pode visualizar o painel e a lista de relatórios relacionados aos dados da visualização para uma análise mais detalhada. <br>?Clique no botão do gráfico no canto superior direito, você pode visualizar, criar, editar gráficos simples criados com dados de visualização, ou visualizar painéis relacionados à visualização atual. <br> Passo 1: Clique no botão do gráfico no canto superior direito para expandir o gráfico na página. Você pode visualizar e gerenciar os gráficos existentes de acordo com as permissões, e visualizar a lista de painéis relacionados com os dados de visualização. <br> Passo 2: Clique no botão Configurações, você pode criar, editar e excluir os gráficos de acordo com as permissões. Você pode criar quatro estilos de gráficos, gráfico de coluna vertical, gráfico de coluna horizontal, gráfico de torta e gráfico de funil. <br>?Clique no botão de relatório para visualizar os relatórios relacionados à visualização atual. <br> 4. Gerenciar dados na visualização <br>?Na visualização, de acordo com sua autoridade, você pode adicionar, editar, apagar e alterar o proprietário dos dados através dos botões no canto superior direito da visualização, ou ao lado de cada pedaço de dado. <br>?Use tags para auxiliar no gerenciamento de seus dados. Use o botão à direita para expandir a lista de gerenciamento de tags, e você pode filtrar os dados na visualização com base nas tags. Após clicar em Gerenciar tags, você também pode manter e gerenciar sua biblioteca de tags. Após selecionar os dados, use o botão Adicionar Tag no canto superior direito para adicionar tags aos dados em lotes.`,
"label.app.ismobile":`Exibido em aplicativo móvel`,
"chatter.group.changeTheGroupPicture":`Alterar a foto do grupo`,
"label.mr.descreption.reDataList2":`registros de repetição`,
"vue_label_chatter_agree_join":`Concordar em aderir`,
"label.planned.nextrun":`Executar na Próxima Programação`,
"Homepage.News.003":`Não é possível exibir notícias sem dados de contas, por favor, crie uma nova conta e as notícias relacionadas serão exibidas.`,
"label.summaryreport.selectpictype":`Selecione o tipo de gráfico e outras opções de gráficos`,
"label.app":`Aplicações`,
"label.trigger.name":`Nome do gatilho`,
"vue_label_email_private_template":`Modelo privado`,
"label.appointmentpage.wizard.subtitle1":`Escolher data e hora O fuso horário do Inviter é {0}`,
"label.partnerCloud.orderingPlatform.payment":`Pagamento de pedidos`,
"label.stdashbord.xsld.title":`Funil de vendas`,
"vue_label_pool_poolname":`Nome do pool de contas`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Mapa de Distribuição de Serviços de Compromisso`,
"front-lightning-module-v1-dashborad-target-value":`Valor Alvo`,
"label.reportsSubscriptionPage.email.keywords":`Busca após digitar a palavra-chave`,
"label.appointmentconfirmail.wizard.subtitle1":`Nome do evento`,
"label.limited_scanning":`O ingresso de admissão é apenas para escaneamento para registro no local`,
"label.weixin.nomore":`Não mais`,
"february":`Fevereiro`,
"label.view.filterbyowner":`Filtrar por Proprietário:`,
"label.contentType":`Extensão do documento`,
"label.customobjdel.master.hsiang":`O Campo de Relacionamento Master-Detail é criado neste objeto, portanto, não é possível apagá-lo.`,
"lable.Removal.succeeded":`Removido com sucesso.`,
"label.weixin.end.incorrect":`Data final inválida`,
"label.email.cc.recipients":`Destinatários do Cc`,
"label.taskevent.list":`Lista de atividades`,
"label.formula":`Fórmula`,
"label.h5.new.errorheader":`Reveja os erros desta página.`,
"label.emailobject.template.private":`Particular`,
"label.visualpage.component.n4":`4.Variável. Você pode usar as variáveis diretamente, e tome cuidado para não ter citações únicas.`,
"label.newemailnotice.step1":`Passo 1 Selecionar objeto`,
"label.chatter.file":`Arquivo`,
"vue_label_checkduplicate_rules":`Estabelecer regras de verificação duplicadas`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Fonte de dados do relatório personalizado`,
"vue_label_email_with_accessories":`Emails com anexos`,
"label_efine_assessment_cycle":`Estabelecer período de avaliação de desempenho`,
"label_emailtocloudcc_button_sure":`Confirme`,
"label.forecast.userenablepage.isusing":`Usuários capacitados`,
"lable.goal.description":`Descrição do objetivo`,
"message.error.serviceresource.relatedrecordid":`Cada usuário só pode ser adicionado como um recurso de serviço do tipo {0}.`,
"label.weixin.addbus.information":`Adicionar informações sobre veículos`,
"label.emailtocloudcc.button.view":`Ver`,
"label.detail.workflow":`Ver Fluxos de trabalho`,
"label.standardfilter":`Filtros padrão`,
"label.mobile.phone.results":`Desempenho`,
"chatter.feed.unavailabled":`Inacessível`,
"label.view.sortview":`Vista Ordenada`,
"label.availabilityobject.wizard.title":`Disponibilidade`,
"Main_Menu_Mobiledownload":`LIGUE-SE`,
"chatter.sticker":`Rastreado`,
"label.workflow.intruduce":`Configurar o fluxo de trabalho da organização através da criação de regras de fluxo de trabalho. Cada regra de fluxo de trabalho consiste em:`,
"label.customfields.richtext.tip":`Permite aos usuários inserir textos formatados, adicionar imagens e links. Até 32.768 caracteres em linhas separadas.`,
"label.new.cy.select":`Escolha uma nova moeda a partir da lista disponível.`,
"template.chart.schdzqzkhzhqk":`Conversão de Líderes em Campanhas`,
"label.forecast.customforecast.cpxl":`Família de produtos`,
"front-electronic-signature-open-service":`Habilitar a Assinatura E`,
"label.datamanage.import.field":`Campos de importação`,
"chatter.email.sendMessageToMe":`Envia-me uma mensagem`,
"message.cannotusebefore":`Observe que você não poderá utilizar este processo de aprovação até que ele tenha sido ativado.`,
"label.textmessage.vonage.api.secret":`Segredo API`,
"label_chatter_newEvent":`Novo evento`,
"label.ji.year":`{a} ano`,
"label.sendmail.step2":`Passo 2 Selecione um modelo de e-mail`,
"label.console.step5.record":`registros abertos`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Favor selecionar campo para agregar`,
"vue_label_commonobjects_detail_current_recorder":`O novo proprietário também será o proprietário dos registros relacionados a este projeto, e estes registros são de propriedade do gravador atual`,
"label.SMS":`Notificações SMS`,
"label.reconfigure.bundle":`Reconfigurar o pacote`,
"front-kefu-select-region":`Favor selecionar a área onde a instância está localizada`,
"chatter.feed.deletefeeds":`Você tem certeza de que quer apagar este post e seus comentários?`,
"label.customsetting.manage.introduce.h":`Se a configuração personalizada for uma hierarquia, você pode adicionar dados para o nível do usuário, perfil ou organização. Por exemplo, você pode querer exibir valores diferentes dependendo se um usuário específico está executando o aplicativo, um perfil específico, ou apenas um usuário geral.`,
"label.product.name":`Nome do produto`,
"vue_label_commonobjects_view_saveas":`Salvar como`,
"label.group.my.archived":`Meus Grupos Arquivados`,
"vue_label_pool_coflictmethods":`Conflito com o modo de venda atual`,
"label.appupload.upload":`Upload`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Taxa de conclusão da tarefa assinada`,
"label.dashboardStandard":`Painéis de Controle Padrão`,
"label.niboer.time":`Hora do Nepal`,
"label.emailtocloudcc.filed.email":`Email`,
"market.name.social.post":`Postos sociais`,
"evaluation.detail.notfound":`Comentários detalhados não são encontrados`,
"label.layoutoftestobj":`Layouts de objetos de teste`,
"label.example":`Exemplos`,
"label.campaign.channel.step6.remark6":`por favor, visite aqui`,
"chatter.emailLike":`Gosta`,
"label.knowledge.category.button.two":`Categoria de edição`,
"label.alluser":`Todos os usuários`,
"addadvancedconditions":`Adicionar condições avançadas`,
"message.selectgsummarycondition":`favor selecionar os critérios resumidos`,
"message.duplication.label.sectionremar2":`Nota: Todos os registros relacionados, incluindo quaisquer notas, anexos e atividades, serão associados ao novo registro fundido.`,
"vue_label_helpcenter_product&pricebook":`Os produtos são seu catálogo básico para todos os itens e serviços que você vende e seus preços padrão. A lista de preços permite que você crie uma coleção personalizada de produtos e lista de preços associados para usuários específicos.`,
"message.duplication.label.isprofile":`Por Permissão`,
"component_setup_label_milestonesfield":`Campo de marcos`,
"setup_layout_label_required":`Obrigatório`,
"component_chatter_label_title":`Último post`,
"label.assignment.setup.detail.order":`Ordenar ordem`,
"vue_label_pool_unassigned":`Não atribuído`,
"UG_Lead_007":`Sincronização com o Google`,
"label.knowledge.record":`Não existem dados relavantes!`,
"label_tabpage_filetypez":`Tipo de arquivo`,
"label.ccpeak.if.error.message":`Se um erro for retornado: use`,
"label.intialsubmitter":`Apresentadores iniciais`,
"label.wei.icon":`Ícone`,
"label.mask.show.last.4":`Máscara com os quatro últimos caracteres`,
"lable.PowerProcess.time.trigger":`Acionador de tempo (min)`,
"july":`Julho`,
"label.usestandardwizard":`Use o Assistente de Configuração Padrão`,
"label.two.quarter":`Segundo trimestre`,
"label.size":`Tamanho`,
"label.integrations.mailchimp.massage4":`Mailchimp não está atualmente instalado. Por favor, instale o Mailchimp em "Integrações".`,
"label_emailtocloudcc_step2total3":`Etapa 2 de 3`,
"vue_label_chat_customer_group_strategy":`Equipe do cliente`,
"label.searchvalue":`Encontrar valores`,
"label.sendemail.birthday.title":`Lembrete de aniversário`,
"label.projectManagement.planned.days":`Dias de planejamento (dia)`,
"label.service.gantt.workhours":`Com base no horário de trabalho`,
"label.notification.approval5":`Delegado approval：【提交人】is solicitando o 【对象】approval`,
"label.service.miniProgram.bindAddressDesc":`Portal Oficial do Mini Programa de Atendimento ao Cliente da CloudCC:`,
"chatter.error.wt":`Erro:Tipo de arquivo inválido.`,
"vue_label_calendar_my_calendar":`Meu Calendário`,
"label.customername":`Nome da conta`,
"label.salescloud.salesdashboard.huikuan.rankings":`Classificações de pagamento em equipe`,
"message.query.opportunity.contactrole.error":`Oportunidades de negócios de consulta falharam, favor entrar em contato com o administrador!`,
"noequal":`não igual a`,
"label.document.searchcustominfo":`Digite palavras-chave para encontrar documentos correspondentes.`,
"label.account.PreviousFQ":`FQ anterior`,
"label.file.f":`Arquivos`,
"label.dashboard":`Painéis de controle`,
"label.report.folder":`Folders`,
"batch.edit.permission.list":`Sem permissão para editar a lista de dados`,
"label.file.orderbyowner":`Ordenado pelo proprietário`,
"label.exchange.sync.account.password":`Senha da conta de serviço:`,
"pagecreator.button.publish":`Publicar`,
"label.modify":`Editar`,
"label.exchange.sync4":`Estados`,
"label.remark.information":`Descrição Informações`,
"label.service.without.major.event":`Nenhum evento importante a ser exibido`,
"label.knowledgebase.release.status":`Status de publicação`,
"label.tabpage.ok":`Confirme`,
"label_screening_assessment_content":`Conteúdo da avaliação do filtro`,
"label_partner":`Nuvem de parceiros`,
"label.user.detail":`Ver Usuários`,
"front-kefu-moudle-or-this":`ou, como este?`,
"label.unselect.object":`Objetos Opcionais`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Pressione {0} para remover o aplicativo de My Apps, Pressione {1} para adicionar aplicativo a My Apps.`,
"vue_label_dashboard_thisfolder":`Adicionar painel de controle público a esta pasta`,
"label.delete":`Excluir`,
"label.appexchange.installedpage.message1":`Você pode visualizar e baixar aplicativos diretamente na CloudCC App Store e instalá-los em seu ambiente CloudCC.com.`,
"label.mobile.phone.required.summary":`Resumo é necessário`,
"label.batchadd.newbatchpage.addtr":`Um máximo de 30 registros pode ser adicionado.`,
"label.partnerCloud.partnerAccount.lockLine":`Montante bloqueado`,
"label.emailsync.status.connectstatus":`Status da conexão`,
"label.campaignmember.main.importmember.lead":`Membros Importadores-Leads`,
"message.username.isnull":`Você deve inserir um valor para o nome de usuário.`,
"label.forecast.tree.enableuser":`Habilitar usuários`,
"label.multilang.view.viewmessage":`Esta visão tem sido aplicada ao dispositivo móvel. Um máximo de 10 campos pode ser escolhido, agora existem {0}:`,
"friday":`Sexta-feira`,
"label.sendemail.activity.neweventtitle":`Notificação de novos eventos`,
"label.page.addtabto.user":`Anexar a guia às customizações pessoais existentes`,
"front-kefu-moudle-v1-connect-phone":`Número de telefone do associado`,
"label.wei.pollis":`Vote em`,
"lable.opppdt.editPdt.title":`Editar Produtos de Oportunidade`,
"label.permission.objectpermission.recordfenpei":`Atribuição de tipo de registro`,
"pagecreator.layout.message.delete.success":`Layout excluído com sucesso`,
"label.dataimport.isdupecatcher":`Executar filtros`,
"label.deletelayout.tip":`Para excluir um layout de página, você deve selecionar outro para substituí-lo.`,
"label.projectManagement.No.matching.data":`Sem dados correspondentes.`,
"pagecreator_page_message_delete_success":`Página excluída com sucesso`,
"label_tabpage_equalz":`Igual a`,
"label.ems.emailsetup":`Configuração de e-mail`,
"label.decimaldigits":`Lugares decimais`,
"component.chatter.button.delete":`Excluir`,
"label.isallowreport":`Permitir relatórios`,
"label.view.appliedMobile.message":`Verifique este item, etapa 3. Selecione os campos a serem exibidos, e você pode selecionar até 6 campos`,
"label.must.positive.integer":`O número deve ser um número inteiro.`,
"label.preview.print.template":`Pré-visualização do modelo de impressão`,
"label.schedulejob.setup.schedule.start":`Início`,
"UG.Case.04":`Atribuição de casos`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Ativar Hover Detalhes`,
"vue_label_email_alltemplates":`Todos os modelos`,
"label_report_chose_obj":`favor selecionar relação de objeto e fonte de dados do relatório`,
"label.partnerCloud.productSet.del":`Excluir Item`,
"label.quote.shrdz":`Endereço do destinatário`,
"page.approval.history":`Histórico de aprovação`,
"lable.outlook.detail.prefc":`Sempre preferiu o CloudCC.com`,
"label.translation.unable.display.view":`Incapaz de exibir a visualização`,
"label.encrypt.change":`Converter Tipo Criptografado`,
"button.partner.workspace.login.logo.upload":`Carregar imagem`,
"label.batchadd.mustinput2":`é necessário, este registro não pode ser salvo se as informações necessárias estiverem vazias.`,
"label.dataimport.update.error.check":`Ocorreu um erro na atualização dos dados. Favor examinar estes dados cuidadosamente.`,
"label.staticresource.name.already.exists":`O nome único do recurso estático já existe!`,
"label.appupload.upload.install.success":`Instalado com sucesso`,
"label.conditiontag.lookup.true":`VERDADEIRO`,
"label.quickbooks.viewlist.customer":`CLIENTE`,
"label.field.edit.change2":`A pontuação mais alta é de pelo menos 1`,
"label.fianalrejectoperate":`Ações de Rejeição Final`,
"label.ccpeak.wgd":`Aulas não-filtradas`,
"label.reportsSubscriptionPage.condition.emailreport":`Resumo   relatório`,
"label.detailinf":`Detalhes`,
"label.eastem.standard.time":`Horário Padrão Oriental`,
"chatter.group.manager":`Gerente`,
"label.manage_columns":`Gerenciar cabeçalho`,
"label.daylight.time":`Horário de verão`,
"label.weixin.mycar.information":`Meus veículos`,
"label.ccpeak.help":`Ajuda para as aulas`,
"lable.outlook.detail.match":`Critérios de correspondência`,
"label.version.nonsupport.approval":`Os processos de aprovação não são suportados temporariamente.`,
"label.custom-tailor":`Personalizar`,
"label.showoperate":`Mostrar ações`,
"label.view_edit":`Ver e editar`,
"label.lead.score.prompt2":`Por favor, selecione o intervalo de pontuação (clique no botão [Lead Scoring]) e o sistema marcará os contatos selecionados de acordo com a regra de pontuação ativa.`,
"label.datamanage.savetemplate.error":`O modelo de economia falhou.`,
"label.source":`Fonte`,
"label.multilang.customfieldsetup.reference":`Este campo é referenciado por {0}`,
"chatter.poll.option7":`Escolha 7`,
"label.login.access.day":`dia(s)`,
"label.icon.66":`Equipamento`,
"label.tabpage.kanbansetup":`Configuração do painel de visualização`,
"label_emailtocloudcc_step1_lead2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registrados como registros de chumbo no CloudCC. Assegure-se de que nenhum negócio seja perdido.`,
"label.partnerCloud.partnerAccount.numericValue":`O valor da recarga deve ser um valor numérico.`,
"label.permission.detail.app.object.tip":`Objetos, campos e abas Configurações de acesso`,
"label.emailobject.template.subject":`Assunto`,
"template.report.month.customer":`Contas deste Mês`,
"label.weixin.formerly":`No passado`,
"label.contract":`Contratos`,
"label.help":`Ajuda`,
"vue_label_homepage_setdefault":`Definir como página inicial padrão`,
"label.icon.52":`Geração de energia`,
"label.customfields.file.count":`O número de arquivos`,
"UG_Account_07":`Conta de importação`,
"label.addattachment.ntko":`Editar Online`,
"label.service.ganttBaiduMap.assign.service":`Assing service appointment to this person`,
"vue_label_file_my_file":`Meu arquivo`,
"label.custom.page.hide":`Esconder`,
"label.addexistoperate":`Adicionar Operação Existente`,
"label.already.startdate":`Tempo de início`,
"label.partnerCloud.financeSetting.alipay":`Você precisa abrir uma conta comercial Alipay. Somente a conta comercial é suportada para ser como conta de recebimento. As taxas de transação serão cobradas pela Alipay ao recebedor do pagamento.`,
"label.dashboard.summary.editPageFooter":`Editar Rodapé`,
"label.category.8":`Bens de consumo`,
"label.forecast.customforecast.foretype.best":`Melhor caso`,
"message.validation.isnull":`Por favor, digite um valor`,
"label.savewxpay.failure":`Falha em salvar informações do WeChat comerciante de pagamentos`,
"label.file.stop.sharing.desc1":`Pare de compartilhar com`,
"label.opportunity.setting.showstage。read.info":`As etapas de oportunidade não podem ser modificadas manualmente após o ticking`,
"UG_Campaign_003":`Criar uma campanha`,
"label.edit.field.select.showoptions":`Mostrar todas as opções`,
"message.inputplatformpwd":`Digite a senha de administração`,
"vue_label_systemSettings_mobel_set":`Configuração de aplicativos móveis`,
"label.projectManagement.thefirstone":`Este é o primeiro registro`,
"label.data.newtemplate":`Criar modelo de exportação de dados`,
"label.monitorsys.delete.log":`Registro de Auditoria de Operação Chave`,
"label.template":`Modelos`,
"Lead.Auto.Scoring.Setting.001":`Pontuação automática ao editar ou salvar (exceto os cabos que são importados em lote ou criados por interface)`,
"label.operatesuccess":`Operação bem sucedida.`,
"label.send":`Enviar`,
"chatter.yp":`Esconder alimentação`,
"label.overall_responses":`Resposta geral`,
"vue_label_systemSettings_server_report":`Relatório de serviço`,
"label.icon.113":`Casa`,
"label.partnerCloud.basicSetting.domainSet":`Configurar nome de domínio`,
"label.login.access.text":`Para ajudar no suporte, você pode conceder ao administrador o acesso para fazer o login e visitar seus dados.`,
"vue_label_report_addrowlevelformula":`Adicionar fórmula em nível de linha`,
"message.duplication.label.mergeTitle":`Fundir Meu`,
"label.event.add":`Adicionar Evento`,
"vue_label_homepage_bigscreen_light":`Luz`,
"setup.chatter.enabled":`Não disponível, favor contatar o Administrador para habilitar o CCChat.`,
"label.inputreceiver":`Você pode digitar até cinco (5) endereços de e-mail para ser notificado. Cada endereço de e-mail é separado por ";".`,
"label.custom.page.custom.page":`Páginas personalizadas`,
"label.data.exp.csv":`formato CSV`,
"label.searchlayout.view.example":`Veja o exemplo`,
"label_tabpage_fullscreenz":`Tela cheia`,
"label.tabpage.last":`Último passo`,
"lable.outlook.mcto.accepemail":`Meus endereços de e-mail disponíveis`,
"front-electronic-signature-isopen":`Ativo`,
"vue_label_commonobjects_detail_earlier":`Ver mais cedo`,
"label.name.cannot.greater.str":`O nome pode digitar até 255 caracteres.`,
"label.weixin.activity.email":`Atividade: Email`,
"label.tabpage.unequalz":`Desigual a`,
"label_calendar_year":`Ano civil`,
"label.appupload.upload.installor":`Instalado por`,
"label.jixiaoswitchon":`Expandir`,
"label.user.congratulations.send.finish":`Parabéns, e-mail em massa completo.`,
"label.customsetting.touse.getListCustomSetting2":`Consultar os dados do tipo "list" de configurações personalizadas, retornar dados individuais correspondentes ao nome da API. Mapa do mapa = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`O tipo de registro mestre não pode ser atribuído ao perfil que já foi atribuído a um tipo de registro.`,
"label.tippage.li3":`Para que qualquer componente do painel de controle baseado no relatório da falha tenha sido removido`,
"label.weixin.no.name":`Nenhum assunto`,
"label.tabpage.viewz":`Imprimir vista atual`,
"label.create_contacts":`Criar Lista de Contatos`,
"vue_label_homepage_operationitem":`Por favor selecione o botão`,
"label.pc.ui.2018.switch.version":`Mudar para a versão`,
"label.salescloud.teamrole.main":`Contato principal`,
"label.reportsSubscription.format.report":`Relatório formatado (formato Excel .xlsx)`,
"label.forecast.customforecast.total":`Montante`,
"label.quickbooks.fieldlabel.lastname":`Sobrenome`,
"label.appointment.wizard.title2":`Detalhes da Reunião`,
"label.project.template.one":`Criar um projeto a partir de um modelo de projeto requer 2~3 minutos. Obrigado por sua espera paciente.`,
"label.timetrigger.workflow":`Quando o fluxo de trabalho está ativo.`,
"label.projectManagement.creator":`Criador`,
"label.customfields.formula.selectreturnfieldtype":`Favor selecionar o tipo de retorno da fórmula`,
"label.list.userinterface.dashboard.enable":`Habilitar novos componentes do Painel de Controle`,
"label.email.delete.html.format":`Todos os formatos html serão deletados. você tem certeza?`,
"label.appupload.install.modifyapi":`Modificar o nome conflitante da api:`,
"label.chat.add.topics":`Adicionar um tópico`,
"label.savepartner.fail":`Falha em salvar configurações para o Partner Cloud`,
"label.pc.query.new":`Veja seu último`,
"message.duplication.label.editfiltertitle":`Encontrar filtro duplicado Editar`,
"label.task":`Tarefas`,
"label.emailobject.emaildetail.title.toaddress":`Para:`,
"label.setup.mobile.bottombutton.select":`Selecione as 4 páginas de primeiro nível que você deseja mostrar no aplicativo móvel`,
"label.loginip.pagecue.invalido":`Endereço de Internet inválido`,
"label_tabpage_listshow":`A lista mostra`,
"component.newrecords.label.10records":`10 registros`,
"label_chatter_file":`Arquivo`,
"pagecreator.systemstyle.label.detailcolor":`Cor do texto de detalhe`,
"label.forecast.userenablepage.title":`Previsões Usuários`,
"front-project-module-v1-actual_working_hours":`Hora do homem relatada`,
"vue_label_systemSettings_Security":`Contenção de segurança`,
"label.processsetting.two.select.key.fields":`Etapa 2: Selecione campos-chave para cada etapa do processo e forneça orientação`,
"label.page.display1":`Registros por página`,
"label.appointmentpage.wizard.subtitle1.2":`O Fuso Horário do Inviter é {0}`,
"label.ggReleaseRange.searchTeam":`Procurar grupo público`,
"chatter.group.searchGroup":`Digite um nome de grupo...`,
"label_card_type":`Layout do cartão`,
"label.appupload.managed.tip":`Ser controlado significa que você só pode editar certos atributos.`,
"label.changemyshow":`Mudar minha tela`,
"label.custom.CustomQuarter":`Trimestre personalizado`,
"label.tobedelete":`Para ser excluído`,
"label.newPage.unuse":`Sua página está perdida.`,
"label.product.pricebooks":`Livros de preços`,
"label.mobile.layout":`Layouts de páginas de dispositivos móveis`,
"label.multilang.file.items":`{0} projetos:`,
"label.app.step4.tabused":`Separadores selecionados`,
"label_ccchat_create_account":`Criar uma conta`,
"message.startusingprocess":`Após ativar este processo de aprovação, você não pode adicionar ou remover etapas de aprovação. Além disso, alguns atributos de etapas de aprovação não serão editáveis. Você tem certeza de que deseja continuar?`,
"vue_label_email_please_add_a_theme":`Favor adicionar um tema antes de salvar como um modelo`,
"label.please.create.a.target.record.first.":`Por favor, crie primeiro um registro indicador`,
"label.processsetting.set.objandfile":`Passo 1: Selecione os objetos e campos que você deseja definir o processo`,
"label.newreport.group.data":`group（s）`,
"label.notcreatenew":`Não criar uma nova oportunidade após a conversão.`,
"lable.custom.CurrentandPreviousCY":`CY atual e CY anterior`,
"front-epwechat-module-v1-input-androidschema":`Por favor, digite o esquema Android`,
"label.projectManagement.unfinished.quantity":`Número Incompleto`,
"label.visualpage.idandname":`A identificação e o nome da página são:`,
"label.approvingprojects":`Itens a serem aprovados`,
"label.partnerCloud.financeSetting.weChat":`O serviço WeChat precisa ser aberto e o acordo de serviço de cobrança com a Tencent é necessário. A taxa de transação será cobrada pela Tencent ao recebedor do pagamento.`,
"label.quickbooks.viewlist.view":`Ver`,
"label.knowledge.category.hint.ten":`Grupo de categorias inativado`,
"report_type_label_productPricebooks":`Produtos e livros de preços`,
"label.fenbeitong.description":`Verificar e ativar o formulário de solicitação de viagem da FenBeiTong para auxiliar os funcionários na solicitação de viagens de negócios e reembolso de viagens
despesas`,
"label.ccchat.upload.change":`O que mudou? (opcional)`,
"label.emailsync.status.log":`Log de conexão`,
"label.addnew":`Adicionar Novo`,
"UG_contact_05":`Criar um contato`,
"label.appupload.componet.queryerror":`Ocorreu um erro durante a busca no omponente. Favor entrar em contato com seu administrador.`,
"label.salescloud.setting":`Configuração da equipe de vendas`,
"label.recurrencetimetriggeroperate":`Ações periódicas de acionamento do tempo`,
"label.event.moveup.4day":`4 dias à frente`,
"No.Hisitory.Activity":`Nenhuma atividade histórica`,
"label.validate.function.funcFormat.MINUTE":`MINUTOS(data)`,
"label.recentview.seloption3":`Modificado recentemente`,
"label.login.access.nopermission":`--Sem acesso...`,
"label.taskmenuandlink":`Botões de Tarefa e Links`,
"label.forecast.customforecast.foredis.sbw":`Milhões`,
"lable.PowerProcess.created.event":`criar marco miliário`,
"label.stdashbord.xsld.funnelchat":`Gráfico de funil de vendas`,
"label.step1.total7":`Etapa 1 de 7`,
"label.sendsms.batch.chosepersion":`SMS em massa: Selecione os destinatários`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Pontuação`,
"label.ccdocument.isdel.folder":`Você tem certeza de que quer apagar esta pasta?`,
"label.discard_change":`Sim, descarte de mudanças`,
"label.knowledgebase.assign":`Atribuir`,
"PersonalInfo_LoginHistory_001":`A Broswer valida o link de registro em sua caixa postal`,
"label.globalselect.deletedvlaue":`Conjunto de valores globais eliminados`,
"label.ems.lookup2":`Busca`,
"label.dataimport.system.unable.determine":`o sistema não pode determinar a perda do`,
"label.weixin.invitation.consultant":`Consultor convidado`,
"label.salescloud.salesdashboard.phone.rankings":`Ranking de Discagem`,
"label.knowledgebase.plan.release":`Plano para publicar`,
"label.integrations.first.half":`A visão atual no total`,
"label.icon.123":`Kit de Primeiros Socorros`,
"label.leadscore.isactivity":`Ativo`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Nova conta`,
"front-lightning-module-v1-details-page-chart-tittle":`Você pode inserir módulos de gráficos e diagramas na página de detalhes, e podem ser inseridos até 10 gráficos de relatórios. Por exemplo, você pode adicionar um módulo de gráfico de relatório para um registro com tipo de registro como Agente no objeto Contas, adicionar gráficos do valor de vendas do pedido do agente e relatório trimestral de vendas do agente ao módulo, e filtrar pelo nome da conta para visualizar os dados relacionados diretamente na página de detalhes da conta do agente.`,
"label.customobjects.fieldsrelation":`Campos e relações personalizadas`,
"label.dashboardSetup.left":`À esquerda`,
"label.mobile.app.sectionpart":`Seção de aplicativos móveis`,
"setup.mainpage.label.welcome25":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Controle de Segurança → Compartilhar Configurações.`,
"label.custombutton.edit.error":`Erro: O nome já está em uso ou já foi usado anteriormente, favor escolher um nome diferente.`,
"label.icon.48":`Ventilador de exaustão`,
"label.tabularreport.step2":`Passo 2 Selecione a coluna do relatório`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Dois`,
"UG_quota_01":`Gerenciar cotações de contas`,
"label.customcomponent.btn.usewhere":`Onde isso é usado?`,
"label.quickbooks.searchresault.email":`Email`,
"label.emailobject.appointment.urltext2":`reservar um tempo aqui`,
"label.tianyancha.field.relation.error":`Por favor, estabeleça primeiro a relação de mapeamento entre o campo de Tianyancha e o campo do cliente`,
"APPIntegration_Social_facebookerror":`Você deve digitar um URL válido para facebook.com`,
"label.notification.arketsea.transfer":`{5} transferido {0}：{1} de {2} para {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Taxa de conclusão da tarefa Total de recibos`,
"UG.Account.04":`Filtragem de conta de consulta passiva`,
"this.week":`Esta Semana`,
"label.email.track.attachment.num.control1":`O número de arquivos carregados excede 10, e não pode ser carregado`,
"label.exchange.sync.state.event":`Eventos`,
"vue_label_systemSettings_websitesetting":`Configuração da Web`,
"vue_label_file_replace_reason":`Motivo da substituição`,
"label.version.feature":`Características`,
"E":`Email`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Modelo`,
"label.chosesubject.meet":`Faça uma reunião`,
"UG.ST.003":`Você não tem permissão para criar {0}, entre em contato com o administrador, clique em confirmar para ir diretamente para a interface {0}.`,
"label.authorization.failure":`A autorização falhou. Por favor, re-autorize!`,
"label.newprocessstep3":`Passo 3 Especifique as Propriedades de Aprovação de Campo e Editabilidade de Registros`,
"lable.outlook.mcto.mostrecord":`Recorde com a maioria das atividades`,
"vue_label_normal_select":`Selecione`,
"label.partner.workspace.login.buttontext":`Texto dos botões`,
"template.chart.ydschdtj":`Estatísticas da Campanha Mensal`,
"label.ServiceCloud.zichanmingcheng":`Nome do ativo`,
"label.productsales.oppor.nooverdue":`Bom trabalho, sem oportunidades vencidas.`,
"label.appointment.wizard.subtitle3-5":`Sexta-feira`,
"label.payment.the.current.version":`Edição de Assinatura Atual`,
"label.reportlist.top":`Fixado ao topo`,
"label.emailobject.emaildetail.prompt":`Pronto`,
"label.weixin.endst":`O tempo de término não pode ser antes da hora de início.`,
"report_label_knowcreatehighlevelreport":`Como criar um relatório avançado?`,
"label.quickbooks.view.openestimates":`Estimativas abertas`,
"label.url.cannot.empty":`A URL não pode ser nula!`,
"label.emailnoticetemplate":`Modelos de Notificação por e-mail`,
"calendar.tips.task":`Nenhuma tarefa hoje`,
"label_partner_all_operate":`Operação`,
"message.duplication.label.cancelbutton":`Cancelar`,
"vue_label_SMS_addcontact":`Adicionar contato`,
"label.martrixreport.setsumfield2":`Selecione o campo que foi usado como coluna de resumo em seu relatório de matriz`,
"approval_request_email_body":`Os seguintes itens estão solicitando a aprovação Clique no link abaixo para aprovar a aprovação.`,
"label.emailobject.emaildetail.field.record":`Registro`,
"label.tab.page":`Página`,
"label_tabpage_prepagez":`Mostrar em todas as páginas`,
"label.iran.daylight.time":`Hora padrão do Irã`,
"label.event.nextweek":`Semana seguinte`,
"fliter.lastmonth":`Último mês`,
"label.group.no.recent.search":`Não existem grupos que tenham sido vistos recentemente.`,
"label.h5.act.confirm":`Confirme`,
"label_tabpage_mypotentialcustomers":`Minhas pistas`,
"label.tabpage.queuez":`Fila`,
"label.batch.edit.description":`Selecione para os campos que você deseja editar, selecione pelo menos um campo e até 5.`,
"label.batchadd.newbatchpage.deltr":`Mantenha-se pelo menos na linha.`,
"label.industrialandcommercialverification.instructions2":`A versão que você está usando é gratuita e o número máximo de consultas é de 10.000 vezes por dia. Se você precisar expandir o número de consultas, é recomendável adquirir o serviço. Após adquirir o serviço, você receberá o token do fornecedor, configure-o nesta página. O fornecedor continuará a lhe fornecer o serviço pago correspondente.`,
"label.rejectrequestbehaviour":`Realizar todas as rejeições <forte>e</sforte> todas as rejeições finais para esta etapa. (Rejeição final)`,
"label.batchCopy":`Clone do lote`,
"label.service.two":`Alguns filtros são definidos mas não referenciados nos Filtros Avançados.`,
"label.data.import.setup.detail.remark":`Se você verificar as seguintes opções, é realizado nos dados de importação.`,
"vue_label_file_delete_lib":`Excluir biblioteca de arquivos`,
"label.integerdigit":`O número de dígitos à esquerda da vírgula decimal`,
"label.profile.standardobjcontrol":`Permissões de objetos padrão`,
"label.reportrecords":`Registros`,
"label.noplan":`Você não tem nenhum evento programado para os próximos 7 dias.`,
"label.visualpage.ytype":`Painéis de controle`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Novo artigo`,
"label.Addressbook":`Contatos`,
"label.delete.reward.groups":`Excluir Grupo de Linha de Cotação`,
"label.appexchange.uninstallpage.message1":`Excluir permanentemente todos os componentes deste pacote （listed below）`,
"chatter.group.everyone":`Todos os usuários`,
"label.cooperation":`Cooperação`,
"label.uploadfail":`Upload Fracassado`,
"to":`para`,
"button_partner_delete":`Excluir`,
"attachment_select_warning_001":`O anexo está arquivado e o botão Arquivar não está disponível, favor selecionar novamente um anexo.`,
"label.step4.total4":`Etapa 4 de 4`,
"label.login.access.avalid":`Expira Hoje`,
"label.defaultview2":`Lista de pinheiros`,
"vue_label_commonobjects_detail_style":`Estilo de compra`,
"label.selectfield":`Selecione os campos`,
"label.report.select.column.collect":`Selecione a coluna a ser resumida`,
"lable.currencyAdv.newdaterate.existeddate":`A data já está sendo usada para HKD. Favor especificar uma data de início diferente.`,
"pagecreator_systemstyle_button_new":`Novo estilo`,
"label.ccchat.person.invite":`Os colegas convidam`,
"label.sendemail.recycle.clear":`Reciclagem clara`,
"label.usermanage.view.notexist":`A visão não existe`,
"setup_chatter_enabled":`Não disponível, favor contatar o Administrador para habilitar o CCChat.`,
"UG.Contract.01":`Gerenciar contrato`,
"label.martrixreport.2018.step4":`Passo 4 Selecione os critérios do relatório`,
"message.errorinscript":`Questões de roteiro de execução.`,
"label.knowledgebase.modification.date":`Data modificada`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Podem ser inseridos até 10 dígitos para o custo`,
"label.list.isActiveNewApproval":`Habilitar nova página de Aprovação`,
"label.mobile.main.page.icon.setup":`Configurações de ícones de aplicativos móveis`,
"label.select.customer":`Selecione a conta`,
"label.sharerule":`Configurações de compartilhamento`,
"label.fiscal.FY":`Ano fiscal`,
"label.appupload.component.type.customfield":`Campo personalizado`,
"label.emailobject.emailsend.sendindividually":`Enviar Individualmente`,
"label.new_formname":`Nome do novo formulário`,
"label.appointment.wizard.notif1":`O tempo final não deve ser anterior à hora de início`,
"front-console-conversation-evaluate-desc":`Resposta de avaliação de {evaluateInfoName}`,
"homepage.components.lasttime":`Data da última modificação`,
"vue_label_commonobjects_view_chart_deletechart":`Apagar tabela`,
"label.multilang.document.upload.fail":`{0} os arquivos foram carregados com sucessolt e {1} os arquivos falharam`,
"UG_contact_03":`Rastrear contatos em um só lugar, sinais de vendas`,
"label.marketsea.istoseafromother":`Permitir a transferência de outros pools de chumbo`,
"label.datamanage":`Administração de dados`,
"label.globaloperation.operationtype.create.data":`Criar registro`,
"label.customer.tab.step2.see":`Visibilidade do separador`,
"label.wtd.changefields.desc":`Após os usuários enviarem o formulário, eles serão levados à URL de retorno especificada em seu site, como uma página de "obrigado".`,
"label.ems.eamilinfo":`Informações por e-mail`,
"label.recordtypeselect.new":`Novo tipo de registro`,
"vue_label_report_output":`Tipo de saída da fórmula`,
"label.emailnotice":`Alerta de e-mail`,
"label.icon.196":`Papel higiênico`,
"label.emailsync.status.disabel":`Inativo`,
"label.tabpage.isdeleterecord":`Se apagar o registro selecionado`,
"message.selectoneoftypes":`Por favor, selecione um dos seguintes tipos`,
"label.import.index.createid":`Criar identificação`,
"vue_label_systemSettings_social2":`Configuração de conta de mídia social`,
"label.ccpeak.sel.time":`Classes programadas nesta pasta`,
"label.data.downpage.i_list.desc1":`Durante a importação, os dados que não são importados com sucesso porque os dados estão formatados incorretamente, ou porque o gatilho ou a regra de validação falha, gera o arquivo CSV a ser exibido na página atual. Os dados importados com sucesso não serão exibidos na página atual.`,
"label_adjust_forecast":`Ajustar previsão`,
"vue_label_normal_lead_sf":`Chumbo`,
"vue_label_report_notice1":`O relatório contém mudanças não salvas. Se você fechar o relatório, estas mudanças serão perdidas. Clique abaixo do botão "Salvar e fechar" para salvar as mudanças.`,
"label.notfiledpublicreport":`Relatórios públicos não arquivados`,
"one":`Um`,
"UG.Lead.008":`Código de escaneamento de cartões de visita`,
"label.archived":`Arquivado`,
"label.standardabstractfield":`Campos de resumo padrão`,
"vue_label_notice_add_fail":`Adicionar falhou`,
"label.sendemail.registIMUser.addresserror":`o endereço de e-mail do destinatário está incorreto`,
"label.ccdocument.toolbar.switch":`Interruptor da barra de ferramentas`,
"first":`O Primeiro`,
"label.icon.147":`Mouse`,
"vue_label_jihui_er":`Oportunidade 2`,
"label.ccchat.micropost.isedit":`Modificação de postagens e comentários`,
"label.department.next":`Próxima página`,
"front-kefu-moudle-confirm-disable-phone-user":`Você tem certeza de desativar a discagem para o usuário {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`A data de início e fim não atende à freqüência de assinatura!`,
"lable.account.NextpDays":`Próximos 120 dias`,
"UG_opportunity_007":`Papel de contato`,
"label.encrypt":`Criptografado`,
"label.knowledge.category.hint.three":`Eliminar ou substituir a categoria existente, o que remove todas as catetogias associadas ao artigo.`,
"label.customcomponent.usewhere.info":`A seguir estão todas as referências a este componente. Clique na etiqueta de referência para ver a definição.`,
"vue_label_import_addandupdate":`Adicionar e atualizar`,
"label.email.all.members":`Enviar a todos os membros do grupo por email`,
"component_task_button_save":`Salvar`,
"label.file.deleted.unavailable.desc":`O arquivo é excluído, não está disponível ou não está disponível agora.`,
"label.emailsync.status.viewlog":`Ver Diário de Bordo`,
"label.marketsea.othersetup":`Outras configurações`,
"label.data.exp.newtemppage":`Modelo Criar página`,
"vue_label_lead_score_successsful":`Pontuado com sucesso`,
"label.sendemail.activity.newtask":`Prezado #belongtoidccname, olá: seu colega #createbyidccname lhe designou uma nova tarefa em #createdate, que diz o seguinte:#sujeito:#subjeito:#expireData:#expireData:#artigo relacionado:  #Para mais detalhes, por favor visite este link:rr:n #caminho:rpm`,
"component.event.label.soon":`Imediatamente`,
"label.forecast.shrepage.getlist":`Voltar à Hierarquia de Previsões`,
"UG.solution.02":`A solução é uma solução interna da instituição para o problema que as contas encontram.`,
"label.weixin.data.approval":`O registro está sob aprovação`,
"label.build.pagelist":`Lista de páginas do construtor da página`,
"label.customsetting.type.hiberarchy":`Hierarquia`,
"label.forecast.ccfh":`Outdo`,
"label.Current.Window":`Displaye em Janela Existente`,
"label.appointmentdetail.wizard.title20":`Plano de domingo`,
"label.emailaddress":`Endereço de correio`,
"label.qetting_notifications":`Não está recebendo nossos emails? Certifiquese de ter adicionado os endereços de email do CloudCC à sua lista de permissão e ativado suas notificações de exportação.`,
"Homepage.News.001":`Notícias`,
"label.runreport":`Relatório de execução`,
"label.customer.tab.step3":`Passo 3 Adicionar aos aplicativos personalizados`,
"label.dashboard.snapshot.refresh":`Atualização`,
"label.approvepagelayout3":`Aprovar o layout da página`,
"vue_label_SMS_send_messages":`Enviar Mensagens`,
"label.executestate.old":`Executado`,
"label.approvalstep3":`Passo 3 Selecione o Aprovador Designado`,
"label.step3.total6":`Etapa 3 de 6`,
"front-kefu-moudle-v1-delete-templete":`Apagar modelo`,
"label.data.downpage.e.title.num3":`3、Users pode criar modelos de exportação de acordo com suas necessidades e selecionar o item "Export By Template", o que pode tornar a operação de exportação mais conveniente.`,
"label.attendance.outer":`Trabalhador móvel`,
"setup_layout_button_selectall":`Selecione Todos`,
"chatter.photo.img":`O tamanho máximo do arquivo é de 2 MB.`,
"front-dynamiclayout-module-v1-required":`O campo de {necessário} é definido conforme necessário.`,
"label.mytask":`Minhas Tarefas`,
"label.edit.customerinfo":`Perfil da empresa Editar`,
"label.processsetting.process.explain":`A configuração e utilização do processo permite aos usuários concentrarem-se nos itens mais importantes e mostrar-lhes palavras-chave e dicas no momento certo para ajudá-los a completar o processo.`,
"label.emailobject.subject":`Assunto`,
"label.mobileapp.scansetting.message":`Selecione se deseja salvar os cartões escaneados no formato de imagem na lista relacionada de "Notas e Anexos" de acordo com seu cenário de uso real. <br>Ativar: o cartão escaneado é automaticamente salvo no anexo enquanto o registro está sendo salvo. <br>Disable: salve somente o registro.`,
"front-epwechat-module-v1-android-autograph":`Assinatura do aplicativo Android`,
"label_component_helper_potentialcustom":`Leads designados a você hoje`,
"label.projectManagement.nodata.week.work":`Vamos acrescentar tarefas para organizar melhor o trabalho desta semana.`,
"label_tabpage_rolez":`Papel`,
"label.importsourcestep4":`Passo 3 Importe seus arquivos`,
"label.icon.50":`Bússola`,
"lable.service.prompt":`Incapaz de criar novos campos field，the número de campos alcançado limite.`,
"label.campaign.channel.input.page":`Especifique uma página da Web, geralmente definindo a página inicial da campanha como uma página de agradecimento.`,
"UG.homepage.001":`Ganhe mais negócios em menos tempo`,
"label.step4.total6":`Passo 4 de 6`,
"label.partner.required":`Erro: o domínio não pode estar vazio`,
"label.tag.manage.title":`Gerência- {0}`,
"label.data.downpage.i_title.num1":`1. O sistema só suporta o formato CSV comum.`,
"label.custom.quarter.end":`Data de fim de trimestre personalizada`,
"label.layout.distribute":`Atribuição do layout da página`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Importação`,
"label.texttemplate.usemergefields":`Utilize campos incorporados no modelo SMS.`,
"label.emailobject.sure":`Claro`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Se habilitar o h5 em seu lado móvel e editar`,
"label.tabpage.messagez":`Por favor, digite seu comentário`,
"label.mobile.phone.write.day.report":`Novas Notas Diárias de Trabalho`,
"label.data.setok.e.desc2":`Página de Lista de Dados de Exportação`,
"label.emailsync.message":`Pronto`,
"label.sales.page.mubiao":`Atingir o objetivo`,
"label.ccdocument.list":`Veja seu último documento`,
"label.tabpage.userGuidez":`Guia do usuário`,
"label.report.fields":`Campos disponíveis para relatórios`,
"vue_label_checkduplicate_at_same_time":`Satisfazer a todos ao mesmo tempo`,
"label.sms.phone":`Telefone de serviço`,
"UG_ST_004":`Você não tem a gestão de dados - "permissão de importação de dados, entre em contato com o administrador, clique em confirmar e vá diretamente para a interface {0}.`,
"label.mobile.nobindmobile":`Este número móvel não existe agora. Por favor, vincule o número de celular a partir das informações do usuário`,
"label.partnerCloud.basicSetting.intro":`O CloudCC suporta a configuração de vários sites para parceiros de diferentes tipos e configurar página de login, menus e permissões separadamente. Por exemplo, os varejistas podem criar vários sites para agentes locais e parceiros publicitários.`,
"label.trigger.targetobject":`Objetos Alvo`,
"label.ems.emailsyncperiod":`Período de sincronização de e-mail`,
"lable.Transformation.mode":`Modo de Transformação`,
"label.emailobject.new.template":`Adicionar novo modelo`,
"label.System.Setting":`Configurações do sistema`,
"label.emailtocloudcc.button.addemailaddress":`Adicionar Caixa de Correio Empresarial`,
"lable.a.total.of.invoices":`0 fatura no total`,
"label.multilang.customforcast.forecasthistory":`Histórico de previsão de {0}：`,
"label.role":`Papéis`,
"advancedconditions":`Condições avançadas de filtragem`,
"label.tabpage.beginz":`Comece em`,
"label.campagin.roi.khzhsl":`Quantidade de conversão de contas`,
"chatter.poll.option5":`Escolha 5`,
"label.weixin.horse.club.registered":`Registro de usuários da Aid-Max`,
"frame_personinfo_label_resizeimage":`Para fazer ajustes em sua imagem em miniatura, arraste e redimensione as linhas pontilhadas em sua foto de perfil acima.`,
"label.file.share.select.warning":`Foi criado para ser compartilhado!`,
"label.event.this.week":`Esta Semana`,
"label.data.import.object.label":`Rótulos de objetos`,
"label.visualpage.folder":`Pastas de páginas não arquivadas`,
"vue_label_report_saveandclose":`Salvar e fechar`,
"label.newdashboardpage.saveto":`Economize para`,
"label.partnerCloud.financeSetting.developerIDTwo":`ID do desenvolvedor`,
"lable.PowerProcess.created.ago.please":`Antes de criar um processo, por favor`,
"label.chatter.myfollowers":`Meus seguidores`,
"label.campaignmember.main.duplicatelist.title":`Memebers da campanha: Código de varredura para encontrar configurações duplicadas`,
"label.group.no.recent2":`Encontre grupos para participar`,
"label.icon.110":`Livro`,
"label.merge.my.account":`Fundir minhas contas`,
"setup.layout.button.quicksave":`Salvar rapidamente`,
"pagecreator.page.message.canntdelete":`A página atual não é permitida para excluir`,
"label.report.printable.view":`Vista para impressão`,
"ccchat_fieldtrack_fieldchange":`Mudar de {0} para {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Certificado de Identidade do Provedor`,
"label.step2.total2":`Etapa 2 de 2`,
"lable.product.pricebooks.isn":`Livros de preços ativos`,
"labal.emailtemplate.namemassage":`O nome único do modelo de correio já existe, favor reeditar`,
"only.one.field":`Apenas um campo pode ser selecionado.`,
"label.weixin.appr.audittime":`Data de Aprovação`,
"pagecreator.page.button.delete":`Excluir`,
"front-kefu-moudle-v1-Session-start-time":`A sessão começa em:`,
"label_chatter_state":`Status`,
"vue_label_systemSettings_lightningcustom":`Interface de usuário personalizada em Relâmpagos`,
"label.searchs":`Busca`,
"label.mobile.phone.not.read":`Não revisado`,
"label_chatter_allweather":`Para todas as condições climáticas`,
"label.enter.number":`Favor inserir um número inteiro entre 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`Quando habilitados, os contatos e departamentos da WeCom serão sincronizados com os usuários e funções da CloudCC`,
"label.emailfield":`Campos de e-mail`,
"pagecreator_button_next":`Próximo passo`,
"label.more.select.merge.records":`Você só pode selecionar até 3 dados para fundir`,
"lable.edit.queue.selobjct":`Objetos selecionados`,
"label.reportsSubscription.editsubscribe":`Editar Assinatura`,
"label.selectfieldtoautotransmit":`Selecione o campo utilizado para o roteiro de aprovação automatizado`,
"label.ccpeak.need.topass":`Necessidade de passar para`,
"label.checkfield.merge":`Fundir`,
"front-lighting-module-v1-detail-file-downlaodInfo":`O registro é bloqueado e não está disponível para download de arquivos. Favor entrar em contato com o administrador para desbloquear.`,
"vue.please.enter.a.chart.name":`Por favor, digite o nome do gráfico.`,
"label.data.dataexptemplate.desc3":`3. O modo de exportação é válido somente para os dados informados e não é valis para o modelo de exportação. O formato do arquivo para o modelo de exportação é CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Página inicial configurações de funções rápidas`,
"label.ems.connect.success":`Teste de e-mail bem-sucedido`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Janela dos pais`,
"label_file_size":`Espaço utilizado`,
"label.allocation.department":`Atribuir usuários`,
"label.browser":`Navegador`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Quarta-feira`,
"label.integrations.description1":`Exportar os dados na visão atual`,
"label.project360":`Projeto 360`,
"label.choose_formtype":`Escolha o tipo de formulário`,
"label_emailsync_status_connectstatus":`Status da conexão`,
"label.bmap.beijing.city":`Pequim`,
"label.mask.encryption.scheme":`Formato Criptografado`,
"label.imgfield.type":`Tipo de imagem`,
"label.person.target.responsible":`Selecione o supervisor de metas.`,
"label.appexchange.installedpage.installdate":`Data de instalação`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Este recurso está disponível apenas para usuários parceiros.`,
"label.profile.customfieldsafety":`Segurança de nível de campo personalizada`,
"label.no.target.models.available.":`Não há modelos indicadores disponíveis. Favor criar um modelo de indicador ou contatar o administrador.`,
"label.process.execute.tip":`Sua solicitação foi processada, aprovada ou rejeitada em massa levará algum tempo, e o sistema o informará pelo correio quando o processamento for concluído.`,
"label.app.step2.introduce":`Digite os seguintes campos para definir a aplicação personalizada`,
"label.loginip.cue":`Nenhuma faixa de IP é especificada e os usuários de qualquer endereço IP são autorizados a fazer o login.`,
"label.step1.select.tablayout":`Passo 1 Escolha o layout da guia`,
"mainpage.setup.chosecomponent.leastone":`Você deve selecionar um componente pelo menos na página inicial.`,
"label.custom.quarter.name":`Nome do Trimestre Personalizado`,
"chatter.ptup.link":`Postar um link`,
"label.compact.layout.frame.error2":`Informações detalhadas e lista relacionada devem estar na tela da esquerda`,
"vue_label_salesfunnel_notice7":`Número total de oportunidades de negócios com uma probabilidade de 100%/Número total de oportunidades de negócios com uma probabilidade de 0% ou 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`O comprimento do título é &nbsp;{0}&nbsp; mas o comprimento dos dados é &nbsp;{1}&nbsp;, o sistema não pode determinar quais &nbsp;{2}&nbsp; os campos são redundantes.`,
"label.owner.notnull":`O proprietário não pode estar vazio`,
"label.logintime.pagecue.invalidt":`A hora inicial não pode ser maior do que a hora final.`,
"vue_label_file_checked_num_limit":`O número de arquivos selecionados excede o limite`,
"front-email-payment-repayments":`Pagar novamente`,
"template.report.today.prospects":`Leads de Hoje`,
"label.weixin.appr.status":`Status`,
"label.knowledge.language.japanese":`Japonês`,
"label.event.reminder.lead.time":`Lembrete`,
"lable.custom.dep":`Clique no botão Novo para definir um novo ano personalizado.`,
"Dashboard_View_Createdbyme":`Painéis de controle criados por mim`,
"label.file.upload.fail":`O arquivo de upload falhou`,
"label.manager":`Gerente`,
"label.stdashbord.xsld.business.jine":`Montante`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`Ao contrário de`,
"label.file.search.people":`Procurar pessoas`,
"message.error.domain.format":`Os nomes de domínio só podem consistir em inglês e arrays`,
"label.firstisdefault":`Usar o primeiro valor como valor padrão`,
"label.discount":`Desconto`,
"label.mobile.phone.have.read":`Revisado`,
"label.field_selected":`Este campo foi selecionado`,
"label.payment.renew.now":`Renovar Agora`,
"label.multilang.lookfiltercondition.notsetup":`A condição da linha {0} está incorreta, nenhum operador está definido!`,
"label.projectManagement.Selectionday":`Selecione o dia`,
"label.user.organization.permit.licensenotstart":`A licença de sua organização não foi ativada, por favor tente novamente depois que a licença for ativada`,
"label.download.save.attachment":`Baixar e salvar em anexo`,
"lable.outlook.mcto.must":`Deve estar em formato de e-mail.`,
"vue_label_notice_unfollow_success":`Insegura com sucesso`,
"label.taskinfo":`Passo 2 Configurar Tarefa`,
"label.other.SMS":`Outros números de telefone`,
"label_partner_workspace_login_logo":`Logotipo do cabeçalho`,
"label.weixin.data.lock":`O registro está trancado.`,
"label.Yaxis":`Eixo Y`,
"lable.edit.queue.selobjdes":`Selecione os objetos que você deseja atribuir a esta fila. Os registros individuais para esses objetos podem então ser propriedade desta fila.`,
"label.campagin.roi.dcfezb":`Taxa de comparecimento`,
"label.marketseamemset.maximum":`Montante máximo`,
"label.owner":`Proprietário`,
"label.reportsubscribe.error.noview":`Favor preencher qual usuário você deseja executar este relatório como em "Executando como".`,
"label.icon.133":`Folder`,
"vue_label_file_share_files":`documentos compartilhados`,
"label.searchlayoutfilterfields.remark":`Selecione as colunas do campo de filtro a serem despachadas durante a busca na barra lateral da página inicial e a busca na página inicial da guia.`,
"vue_label_help_contract":`Contrato e plano de coleta`,
"component.chatter.button.message":`Comentário`,
"label.marketsea.recyclereminddays2":`Lembrete do dia (deve ser inferior ao número de dias sem acompanhamento após a obtenção)`,
"label.webtocloudcc.input.information":`A informação é necessária.`,
"vue_label_chatter_exit_group":`Deixe o grupo`,
"vue_label_lead_notcreatetask":`Não criar tarefa`,
"front-lightning-module-v1-dashborad-date-dimension":`Data Dimensão`,
"setup.layout.label.fieldlist":`Campos disponíveis`,
"label.leadscore.charname":`Nome do campo`,
"label.forecast.customforecast.mybest":`Meu melhor caso`,
"setup_mainpage_label_welcome24":`A plataforma CloudCC fornece configurações de acesso de segurança para todos os dados do objeto no sistema. O compartilhamento de dados e os direitos de acesso podem ser controlados através da definição de várias regras e condições.`,
"label.queue":`Filas de espera`,
"label.icon.159":`Chip`,
"label.path":`Caminho para a referência`,
"label.app.message.failtoget":`Falha na obtenção da lista de aplicações`,
"label.returntoprocess":`Voltar para a lista: Processos de Aprovação`,
"vue_label_commonobjects_detail_more_data":`Sem mais dados`,
"label.number":`Número`,
"label.product.find":`Encontrar livros de preços`,
"label.legend":`Lenda`,
"label.partner.workspace.member.profile":`Perfis disponíveis`,
"label.service.gantt.sum.appointments":`Marcações de serviço concluídas/Todas as marcações de serviço`,
"label.partnerCloud.financeSetting.paymentAllowed":`Permitindo recarga online`,
"label.integrations.upgrate":`Upgrate`,
"label.timzone.tip.info3":`Quando você usa a classe calendário para processar datas, você deve definir o fuso horário para a instância do calendário, e você pode selecionar um dos dois métodos a seguir para obter os objetos do calendário: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Adicionar conta de e-mail`,
"label.partneruser":`Usuário parceiro`,
"label.validate.globalvariable.user.roleId":`Identificação do papel`,
"pagecreator.layout.button.mergecell":`Fusão de células`,
"label.evacuantvalue":`Excluir valores`,
"label.setup.mini.msg":`Configuração da história/mensagem da marca`,
"label.icon.178":`Pessoas`,
"vue_label_pricebook_notice_cantbedeleted":`As entradas da lista de preços não podem ser eliminadas porque já existem registros aplicados à lista de preços. Você pode marcar as entradas da lista de preços como inativas em seu lugar.`,
"vue_label_appstore_application_recommendation":`Recomendação de aplicação popular`,
"label.version.createlimit":`Sua edição atual do CloudCC é {0}, e você pode criar {1}. {2}. Agora, o número de {2} é excedido ao máximo do seu plano de assinatura, por favor, atualize sua edição do CloudCC.`,
"message.duplication.label.sectionremar1":`Selecione os valores que você deseja manter no registro fundido. As linhas em destaque indicam campos que contêm dados conflitantes. O registro mestre selecionado reterá valores de campo somente leitura e ocultos.`,
"label.icon.1":`Nuvem`,
"label.salescloud.salesdashboard.sales.performance":`Resultados gerais dos contratos de venda`,
"System_AddressFieldType_Post":`Código Postal`,
"setup_object_field_dependency_label_mustone":`Você deve selecionar pelo menos 1 valor do campo dependente.`,
"label.appointmentdetail.wizard.title6":`Localização`,
"label.layout.testobj2":`Objeto de teste 2`,
"label.searchlayout.dupcacher.field":`Clique no link Localizar duplicatas e fundir para visualizar os campos duplicados.`,
"label.attendance.persons.title":`Usuários Adequados`,
"template.report.product.sales":`Venda de produtos`,
"label.editCustomReportType":`Relatório Personalizado Fonte de Dados Editar`,
"label.multilang.ui.setup.profile.alltime":`Todos os tempos são {0}`,
"label.service.dispatchingUnits.noservice.booking":`Sem compromisso de serviço`,
"label.validate.remark4":`Garantir que o número esteja dentro de uma faixa específica, tal como o desconto inferior a 30%.`,
"front-kefu-moudle-v1-Waiting-time":`Tempo de espera:`,
"label.weipagelayout.remark":`Usado no aplicativo móvel ou na página WeChat`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Por favor, digite a senha para {usuário}, e certifiquese de que ela contenha pelo menos`,
"message.error.user.data.null":`As informações do usuário não podem estar vazias!`,
"chatter.like.p":`Como este posto`,
"label.page.double.column.style.cloudcc":`O estilo de 2 colunas fornece funções úteis do CloudCC.com, como Busca e Itens Recentes, na mesma página que seu conteúdo incorporado.`,
"label.h5.iscloseaccount":`Você tem certeza de que quer sair da sessão?`,
"label.dataimport.insertdata.id.error":`Erro de formato, por favor, use uma combinação de letras e números.`,
"label_tabpage_sum":`Total`,
"front-epwechat-module-v1-addressbook-sync":`Livro de Contato de Sincronização`,
"label.setup.mobile.offlinecache.mostsave":`A plataforma pode definir a aba off-line padrão habilitada para o lado móvel até 10`,
"label.weixin.quickcreate":`Criação rápida`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Garantia`,
"label.icon.155":`Imagem`,
"label.In.the.search":`Pesquisando`,
"message.validation.isnotdateISO":`Data inválida (ISO)`,
"label.service.appointmentList.send.successfully":`Despacho com sucesso`,
"label.dynamicpage.error.exist":`Não existem dados dinâmicos de layout de página`,
"vue_label_SMS_otherpeople":`e {0} outros`,
"label.cloudccsite.url":`URL do site`,
"label.tabpage.contactsz":`Contatos`,
"vue_label_commonobject_notice_clickthename":`Se você precisar fazer o download do arquivo carregado, por favor clique no nome do arquivo`,
"vue_label_file_new_lib":`Nova biblioteca de arquivos`,
"label.chatter.card":`Cartão`,
"chatter.feed.menutype.user.allusercom":`Todos os Colegas`,
"label.exchange.sync2":`Configurações`,
"template.report.year.income":`Receita deste ano`,
"label.partner.template.detail":`Descrição das funções`,
"label.setup.service.template":`Modelo de relatório de serviço`,
"label.dataimport.insertdata.id.length":`Erro de formato, favor verificar este registro e modificá-lo. Por favor, observe que o comprimento é inferior a 20 caracteres.`,
"label.partnerCloud.financeSetting.collaborator":`ID do Cooperador`,
"label.processskipwizard":`Assistente de Início do Processo de Aprovação`,
"label.weixin.inputbusnumber":`Por favor, digite o número da placa`,
"label.dashboardSetup.d1":`Ponto de parada 1`,
"template.report.conversions.number.industry":`Número de Conversões de Leads (Por Indústria)`,
"vue_label_chat_group_chat":`bate-papo em grupo`,
"label.file.publicview.error":`O arquivo é excluído ou não existe ou não pode ser visualizado`,
"label.customfields.location.locationHelpText":`Por favor, digite um nome de localização, como "sede". Por favor, seja descritivo e específico, e tenha em mente que um registro pode ter múltiplas localizações, como "escritório de vendas da costa oeste" e "escritório de vendas da costa leste".`,
"message.duplication.label.blankmatchtip":`Defina o campo em branco para corresponder, o padrão é Falso`,
"message.appexchange.addtopackage":`Escolha um ou mais componentes para adicionar a este pacote!`,
"label.ems.return2query":`Voltar para a página de consulta de contas de e-mail adicionadas`,
"label_model_name":`Nome do modelo`,
"label.apiname.retainapi":`Nome é o nome reservado do sistema, por favor use um campo diferente de nome API.`,
"lable.Cancel.the.search":`Cancelar busca`,
"label.custom.viewport":`Ponto de vista`,
"label.weixin.polls.type":`Tipo`,
"label.opportunity.setting.showstage.label":`Promoção automotiva`,
"label_component_helper_businesschange_expiredtask":`Oportunidades com Tarefas Vencidas`,
"label.operator":`Operador`,
"label.ccpeak.use.class.time.listmap":`Acesso através de passagem na Lista<Mapa> coleção`,
"component_timeline_label_past":`Atividades passadas`,
"label.mobile.phone.submit":`Enviado por mim`,
"message.recordtype.new.subtip":`Digite um nome e uma descrição para o novo tipo de registro. O novo tipo de registro incluirá todos os valores da lista de seleção a partir do tipo de registro existente selecionado abaixo. Após salvar o novo tipo de registro, você será capaz de personalizar os valores da lista de seleção.`,
"UG_product_05":`Produto de importação`,
"label.validate.globalvariable.user.id":`Identificação do usuário`,
"label.umeng.activity.distribute":`você atribui a`,
"label.weixin.avote":`Vote`,
"label.weixin.already.sign":`Já assinou.`,
"label.emailmerge.mergepage.generator":`Gerar`,
"label.batchtransfer.transferto":`Transferência para`,
"label.tianyancha.industry":`Indústria`,
"label.addattachment.name":`Nome do arquivo`,
"label.customfields.formula.date.tip":`Para calcular uma data, por exemplo, adicionar dias a outras datas ou subtrair dias de outras datas.`,
"label.partnerCloud.orderingPlatform.noPayment":`Não pagar`,
"label.emailobject.failedtosend":`Falha no envio de`,
"label.knowledge.setting.data.three":`Um máximo de {contagem} de dados de grupos de categorias pode ser selecionado.`,
"label.weixin.input.maxlength.langtext":`Favor entrar aqui, até 32000 caracteres`,
"vue_label_calendar_delete_calendar":`Eliminar Calendário`,
"vue_label_commonobjects_detail_filter":`Filtro de colapso`,
"setup.layout.group.custompage":`Personalizar página`,
"component_sendmail_label_subject":`Tema`,
"label_tabpage_maxfilez":`O tamanho máximo do arquivo é`,
"label.logintime.pagecue":`Selecione a data e a hora em que os usuários com este perfil podem entrar no sistema. Observe que a hora exata do fuso horário especificado é usada para todos os horários. Mesmo que o usuário esteja em fusos horários diferentes, estas horas exatas são usadas para o horário de login.`,
"label.salescloud.salesdashboard.datetime":`Data de fechamento`,
"label.format":`Formato`,
"label.newfoundland.daylight.time":`Horário de verão de Newfoundland`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Copiar e colar o valor do campo no conteúdo do SMS`,
"message.chooseatleastoneforshare":`Favor selecionar pelo menos um usuário para compartilhar`,
"label.multilang.datamanage.importobjfield":`Coluna {0}`,
"label.denglu":`Login`,
"label.popup.infoz":`Pronto`,
"label.schedulejob.setup.schedule.onday":`A cada mês`,
"label.appointmentdetail.wizard.title16":`Plano de quarta-feira`,
"label.userphoto.dragtoadjust":`Arrastar para ajustar a miniatura`,
"label.product.series":`Família de produtos`,
"message.view.kanban.not.set.group.summary.field":`O painel de visão não define o campo de resumo do grupo`,
"page.un.activities":`Atividades não iniciadas`,
"label.exchange.sync3":`Configurações`,
"label.login.activityExpired":`O período ativo do usuário expirou, favor entrar em contato com o administrador do sistema.`,
"component_chatter_file_button_files":`Selecione um documento`,
"message.onlydelete.type":`Você só pode apagar os tipos de registros inativos. Portanto, você pode desativar os tipos de registro primeiro se quiser excluí-los.`,
"message.recordtype.selectlayouttouse":`Layout da página a ser usada`,
"label.knowledgebase.unable.restore.draft":`Não é possível recuperar rascunhos apagados.`,
"label.shangqing.name":`Informações comerciais`,
"label.weixin.target.payment":`Pagamento de metas`,
"label.chatter.sendEmailToGroupMember.check":`Veja os Posts`,
"front-kefu-moudle-v1-input-single-login-area":`Por favor, digite o nome de domínio de acesso único`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Secador de cabelo`,
"label.quickbooks.fieldlabel.company":`Empresa`,
"vue_label_email_are_you_sure_to_delete":`Você tem certeza de que vai apagar o correio?`,
"Pagelayout.Setup.005":`O nome tem que ser colocado em primeiro lugar.`,
"label.object.name.two":`Nome do objeto 2`,
"label.tabpage.completez":`Marcar o status selecionado para completar`,
"label.setup.mobile.bottombutton.saveerror":`Falha ao salvar configurações de página de primeiro nível`,
"label.report.action.addtodashboard8":`Selecione Dashboard Folder`,
"label.data.downpage.i_list.desc3":`Os usuários podem ver o motivo da importação falhou na última coluna do arquivo após os downloads.`,
"label.layout":`Layout`,
"label.marketsea.button.assign":`Atribuir`,
"UG.solution.03":`Criar uma solução`,
"label.ccchat.person.invited":`Convidar colegas`,
"label.ccchat.person.invite.address":`Destinatário`,
"label.displaytype1":`Link de Página de Detalhe`,
"label.tianyancha.h5.ziranrengudong":`Pessoa física acionista`,
"lable.SalesCommitmentKanBan.targetReceipts":`Recibos Alvo`,
"message.error.getitems.type":`getItems:tipo não pode estar vazio`,
"label.addattachment.list":`Os seguintes arquivos foram carregados`,
"label.datamanage.export.false":`Ocorreu um erro durante a exportação.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Texto dos botões`,
"label.emailtocloudcc.redmessage1":`Endereço de e-mail inválido`,
"label.weixin.polls.closed":`A votação está encerrada, o prazo é`,
"label.icon.165":`Chapéu`,
"vue_label_report_detailsonly":`Somente detalhes`,
"component.salesperformance.label.100finish":`Terminado`,
"november":`Novembro`,
"label.data.file.generatejwd":`Gerar o serviço de latitude e longitude de acordo com o endereço`,
"label.salescloud.opportunity.access":`Oportunidades de acesso`,
"label.isremider.remider":`Lembrete`,
"vue_label_total":`Total`,
"label.email.prompt.using.lightning.link":`Defina o link de email nas notificações do sistema para estar de acordo com os links de relâmpagos.`,
"label.knowledgebase.cancel.attached.articles":`Artigo anexado ao cânula`,
"label.version.custom.xslc":`Processo de vendas customizável`,
"component_setup_button_save":`Salvar`,
"label.ems.cc":`Cc`,
"label.edit.user":`Usuários Editar`,
"label.emailtocloudcc.select2":`Favor escolher o tipo`,
"label.industrialandcommercialverification.fieldnumber":`Nº de campos mapeados:4`,
"label.ccchat.havenot.joined.group":`Você não está em nenhum grupo ativo`,
"pagecreator_page_label_pagename":`Nome da página`,
"setup.layout.button.save":`Salvar`,
"label.campaignmember.main.updatestatus":`Status dos Membros da Campanha de Atualização em Massa`,
"label.tab.web.edit":`Edição da guia Web`,
"label.ring_chart":`Tabela de donuts`,
"label.usermanage.resetpwd.error":`A redefinição da senha falhou e o usuário não existe.`,
"label.Xaxisscope":`Escopo do eixo X`,
"label.app.new":`Novo aplicativo personalizado`,
"message.modifythereport":`O painel de instrumentos utiliza este relatório. Alterações podem invalidar o painel de controle que faz referência a este relatório.`,
"label.component.helper.businesschange.0activity":`30 dias sem nenhuma atividade`,
"label.weixin.fmu.noon":`PM`,
"label.enter.rule.name":`Digite o nome das regras`,
"lable.Confirm.recovery.potential.customers":`Confirmar para recuperar o chumbo {nome}.`,
"lable.PowerProcess.type.created":`Que tipo de processo de habilitação você deseja criar?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Tamanho do Orthogon`,
"label.projectManagement.new.service.appointment":`Novo compromisso de serviço`,
"label.multilang.totalpage2":`Um total de`,
"pagecreator.systemstyle.label.styledesc":`Descrição de estilo`,
"chatter.up":`Carregamento`,
"2018UI_Homepage_DataDeleted_Info":`Os dados que você deseja visualizar foram excluídos, por favor clique para voltar ao passo anterior.`,
"label.knowledge.draft.recordid":`O rascunho de identificação não pode ser nulo!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Ver toda a integração`,
"vue_label_file_num_limit_tip":`O número de arquivos excede o número pré-definido. Se você precisar substituir os arquivos, por favor, apague primeiro os arquivos carregados`,
"vue_label_commonobjects_view_refreshat":`Atualizado em {timeInterval} atrás`,
"laebe.data.exp.save.success":`Se você precisar usar este modelo para exportar dados, por favor, retorne ao "Export By Template" para operar.`,
"label.mr.caption.contact":`Encontrar duplicatas e fundir: Códigos para consulta de duplicatas de Contatos`,
"label.webtocloudcc.submit.error":`Falha na submissão`,
"label.multilang.datadelete.delmessage":`Registros bloqueados ({0}) não são permitidos para apagar:`,
"label.quickbooks.searchlist.total2":`Existem {0} pagamentos não vinculados para um valor total de {1}`,
"label.createnew":`Criar Novo...`,
"component.milestones.label.choicestate":`Confirme este status`,
"lable.outlook.edit.exist":`Este nome de campo já existe. Digite um nome de campo único.`,
"vue_label_dashboard_eachother":`Somente visões do mesmo relatório ou do mesmo objeto podem ser vinculadas`,
"label.new.role":`Novo papel`,
"message.error.operationType":`A operação não é definida ao chamar um serviço.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Favor selecionar os destinatários a enviar`,
"label.attendance.thanks":`Obrigado por sua participação!`,
"label.invoice.message.statusupdatefailed":`A atualização do status da fatura falhou, por favor tente novamente mais tarde.`,
"template.chart.yzhqzkhlyfx":`Análise da fonte de chumbo convertido`,
"chatter.feed.menutype.user.alluser":`Todos os Colegas`,
"UG_Forcast_04":`Iniciar o julgamento`,
"label.appupload.upload.tips.profile":`Nota: o componente "perfil" foi adicionado a este pacote e não pode ser adicionado novamente (é permitido adicionar até um componente de perfil por pacote).`,
"lable.PowerProcess.leave.the.process":`{describeName} Processo de Saída`,
"template.report.sales.cycle.opportunities":`Duração do Ciclo de Vendas (Por Tipo de Oportunidade)`,
"vue_label_calendar_please_fill_in_the_calendar":`Favor preencher o nome do calendário`,
"label.salescloud.unit.wanyuan":`unidade ( Yuan chinês)`,
"label.fileAPI":`Nome único do documento`,
"label.weixin.link":`Relacionado a`,
"label.service.seconds":`segs`,
"label.encd.visible":`Campo criptografado visível`,
"label.tianyancha.regstatus":`Status de funcionamento`,
"label.event.moveup.18hour":`18 horas à frente`,
"label.upper.bound":`Limite superior`,
"label.please.insertURL":`Favor digitar a URL a ser inserida.`,
"label.approval.notallowed.reject":`Recusa não permitida`,
"label.permission.fieldpermission":`Configurações de permissão de campo`,
"label.customcomponent.page.index.title":`Componentes personalizados`,
"label.quickbooks.viewlist.number":`NÃO.`,
"lable.list.queue.sendemail":`Enviar e-mail aos membros`,
"label.productsales.today.noevtadd":`Não há eventos abertos, você pode clicar em " " no canto superior direito para adicionar um novo evento.`,
"label.report.line.daixuan":`Coluna de relatório pendente`,
"label.reportsSubscription.select.start.endtime":`Por favor, selecione a hora de início e a hora de término!`,
"template.chart.schdyscb":`Custo orçamentado das campanhas`,
"label.sendemail.chat.addPostatsubject":`Fui mencionado no CloudCC CCChat micropost`,
"label.RelatedList":`Listas relacionadas`,
"label.knowledgebase.delete.translation.associated.with.draft":`O rascunho de tradução existente será vinculado à última versão publicada do artigo no idioma principal. Caso não exista uma versão publicada, todas as traduções serão excluídas.`,
"vue_label_chatter_submitted_review":`Você apresentou um pedido de adesão, por favor aguarde que o administrador analise`,
"label.layout.list2":`Lista 2`,
"label.manage.area":`Administrar Territórios`,
"label.manageapproveprocess":`Gerenciar processos de aprovação para`,
"workflow.action.tasks.assignortype.created":`Criado por`,
"label.custombutton.nonsupport.operation":`A versão atual não suporta a operação de botões e links padrão.`,
"label.ip":`Endereço IP`,
"label.chat.topic.desc.error.info":`A descrição do tema não pode exceder 1000 caracteres. Tente usar uma descrição temática mais curta.`,
"label_tabpage_cue":`Lembrete de informações`,
"label.integrations.mailchimp1":`Ao integrar o CloudCC ao MailChimp, seus usuários poderão importar leads e contatos selecionados de sua conta CloudCC para o MailChimp.`,
"label.email.track.required":`Informações requeridas`,
"label.set.case":`Por favor, defina primeiro o proprietário do caso.`,
"label.weixin.newspaper.coverage.number":`Número da folha de risco`,
"vue_label_approve_submitreason":`Motivo da apresentação`,
"message.oppdt.noenabledpricebook":`Sem livros de preços ativos`,
"label.partner.workspace.setup":`Configurações`,
"label.version.nonsupport.feature":`Este recurso não é suportado temporariamente. Se necessário, favor atualizar a versão CloudCC.`,
"com.cloudcc.login.error.message.licenseexpired":`A licença expirou`,
"label.emailsync.form.signin":`Login`,
"label.campaign.channel.input.to.chooselanguage":`Por favor, selecione um idioma`,
"label.tabpage.gotit":`Entendi.`,
"front-console-no-contact-tip":`Sem dados. Favor entrar em contato com a pessoa relevante e visualizar.`,
"label.approval.apiname":`O nome único utilizado pela API e pelos pacotes gerenciados deve começar com letra, e usar somente caracteres alfanuméricos e sublinhados. Os nomes não podem terminar com um sublinhado ou ter dois sublinhados consecutivos.`,
"label_emailtocloudcc_filed_ssl":`Conexão segura`,
"component_sendmail_label_fromuser":`Remetente`,
"front-kefu-moudle-v1-new-online-chats":`Novo Agente Online`,
"label.searchlayout.merge.duplicated.results":`Permitir encontrar duplicatas e fundir-se`,
"label.weixin.input.maxlength.remark":`Favor entrar aqui, até 500 caracteres`,
"component.telerecord.label.related":`Itens relacionados`,
"label.note":`Notas`,
"message.duplication.label.nletters":`personagens`,
"label.productsales.payment.phb":`Lista de pagamento`,
"label.forecast.editshrepage.desc":`Previsão:Especifique o compartilhamento deste registro. Você pode compartilhar este registro e os dados relacionados com um usuário, os usuários em uma determinada função, ou os usuários em uma determinada função mais todos os usuários em funções abaixo dessa função.`,
"vue.dashboard.setPenetrationSuccessful":`Conseguir a penetração!`,
"label.tabpage.noOperationz":`Este conteúdo é um item fixo e não pode ser operado!`,
"label.email.jump":`Redirecionando para um site de terceiros...`,
"label.appointmentpage.wizard.btn1":`Confirmar Reserva`,
"label.umeng.approval.pass":`#aprovador aprovou seu pedido de aprovação #obj.`,
"label.project.hit.twelve":`Lembrete de vencimento de marco miliário`,
"two":`Dois`,
"label.approvedinfo":`Informações sobre a aprovação`,
"label.import.step1.choosecsv":`Por favor, selecione o arquivo csv`,
"vue.please.select.the.expansion.method":`Por favor, selecione a forma de expansão.`,
"UG.homepage.005":`Inteligência de vendas`,
"Account.News.Setting.003":`Configurações gerais`,
"label.quickbooks.button.actions":`Ações`,
"lable.list.queue.email":`Email de fila`,
"label.name.lastname":`Sobrenome`,
"message.confirm":`Você tem certeza?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Data de encerramento do estágio atual`,
"label.knowledge.setting.title":`Configurações de conhecimento`,
"label.helptocreateprocess":`Para criar um novo processo de aprovação, clique em "Create New Approval Process" e selecione "Use Jump Start Wizard" para configurar seu processo de aprovação em alguns pequenos passos. Ou, selecione "Use Standard Wizard" para configurar todas as opções de aprovação.`,
"label.batcheditor.remark":`Registros múltiplos podem ser editados.`,
"label.page":`Página`,
"label.newfolder":`Criar Nova Pasta`,
"label.version.interceptor.api":`Interface API`,
"label.sms.toaddress":`recebeu um SMS`,
"front-kefu-moudle-noopen-callcenter":`A organização não ativou a função de call center, favor entrar em contato com o administrador`,
"label.data.exp.zip":`Formato de compressão`,
"lable.account.LastcDays":`Últimos 60 dias`,
"label.import.index.starttime":`Tempo estatutário`,
"label.dashboardall":`Todos os Dashboards`,
"label.create_socialpost":`Novo posto`,
"label.searchlayoutedit.remark":`Selecione os campos e botões exibidos ao clicar na busca da barra lateral na página inicial ou clique na busca da guia.`,
"message.servicecrew.violation":`Violação da alocação de recursos: os recursos de serviço são membros da equipe neste período.`,
"label.email.attrach.file":`Anexo`,
"report.label.folderandreport":`Relatórios e Pastas`,
"label.list.userinterface.sales.setup":`Configuração da página inicial de vendas`,
"label.martrixreport.2018.step1":`Passo 1 Criar um agrupamento`,
"label.campaignmember.selectmember.memberstatus":`Status de membro da campanha`,
"label.textmessage.vonage.api.key":`Chave API`,
"label.tabpage.next":`Próximo passo`,
"UG_Lead_006":`Visitante do site`,
"label.salescloud.salesdashboard.visit.rankings":`Visitar Rankings`,
"label.myevent":`Meus eventos`,
"label.activity.history":`História`,
"label_tabpage_kanban":`Configuração do painel de visualização`,
"label.weixin.allapp":`Todos os aplicativos`,
"label.query.clone.detail.choose.choosed":`Itens de linha selecionados`,
"message.error.view.errvalid":`Erro: O campo de nome único de visualização só pode conter sublinhados e caracteres alfanuméricos. Ele deve ser único, começa com uma letra, exclui espaços, não pode terminar com um sublinhado e não pode conter dois sublinhados consecutivos.`,
"label.customfields.searchrelation.dependobject.tip":`Selecione outro objeto associado a este objeto`,
"label.appointment.wizard.subtitle4-4-3":`3 semanas`,
"label.setup.mobile.offlinecache.saveerror":`A configuração do cache móvel off-line não é salva.`,
"label.planned.started":`Iniciado em`,
"label.page.step4.of.step5":`Passo 4 de 5`,
"label.tabpage.value":`Valor`,
"label.reportlist.allfolder":`Todas as Pastas`,
"label.callcenter.sure.disable.center":`Você tem certeza de desativar o call center atual?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Ir para Calendário`,
"label.setup.mobile.bottombutton.recovery.default":`Restaurar a inadimplência`,
"label.appointmentdetail.wizard.title15":`Plano de terça-feira`,
"label.icon.15":`Ordem de reparo`,
"component_sendmail_label_touser":`Para`,
"template.report.all.owner":`Proprietário de Leads`,
"front-Partner-email-tips":`Por favor, digite o email para o nome de usuário`,
"vue_label_systemSettings_mobelhomepagesetting":`Configuração da página inicial do aplicativo móvel`,
"label.service.newBuildDialog.aswellas":`e`,
"label.name":`Nome`,
"label.tag.search.taglist":`Lista de Tags`,
"label.partnerCloud.priceOfManual.theOnly":`Recomendase a criação do único livro de preços para cada usuário parceiro. Ou eles não podiam escolher um dos vários livros de preços enquanto faziam o pedido. O livro de preços padrão é aplicado se nenhum livro de preços específico tiver sido definido.`,
"label.knowledge.field.update":`é alterado de {2} para {3}.`,
"label.emailobject.save":`Salvar`,
"label.top.changeVersion":`Horizontal`,
"label.recordtype.edit.unselected":`Valores Existentes`,
"label.knowledgebase.additional.articles":`Anexar artigo`,
"label.lead.score.confirm":`Por favor, selecione o intervalo de pontuação, clique o botão [Lead Scoring] e o sistema pontuará os leads selecionados de acordo com a Lead Scoring Rule.<br>>br>Isso pode levar vários minutos. Você receberá um e-mail de confirmação uma vez concluído.<br>>br>>br>`,
"label.projectManagement.pleaseselectadate":`Favor selecionar a data`,
"label.appointment.wizard.subtitle5":`Nome da reunião`,
"label_setup_failed":`Falha na instalação`,
"label.chatter.collect":`Favoritos`,
"label.appointment.cancelappointment":`Cancelar`,
"front-console-response":`Tempo de resposta`,
"message.delete":`Você tem certeza de que quer apagar?`,
"label.dataimport.type.selected":`Selecione o tipo de importação`,
"label.new.target":`Novo Indicador`,
"vue_label_report_autoupdatepreview":`Prévisualização da atualização automática`,
"label.knowledgebase.guidance":`Orientação`,
"label.chatter.mail":`Correio`,
"label.login.verification.scan.code.acquisition":`Código de varredura para obter:`,
"label.customsetting.changefieldtype":`Mudar o tipo de campo`,
"label.data.dataexpalltype.all_desc2":`2. Leva algum tempo para exportar todos os dados. Quando a exportação estiver concluída, você receberá um e-mail de lembrete de que a exportação de dados foi bem sucedida.`,
"label.opportunity.contactisnull":`Nenhuma informação do cliente, não pode ser exibida.`,
"pagecreator_layout_button_upload":`Layout do upload`,
"label.dashboard.noRecord":`Sem Registros`,
"label.SMS.template":`Nome do modelo de SMS`,
"label.c.d.without":`Os registros C podem ou não ter registros "D" relacionados.`,
"UG.Case.05":`Crie um caso`,
"front-epwechat-module-v1-edit-selfapp":`Edit Seflcreated App`,
"label.role.createrole.tip":`Você pode construir sobre a hierarquia de papéis existente mostrada nesta página. Para inserir uma nova função, clique em <b> Adicionar Função</b>.`,
"label.grouping":`Grupo Por`,
"vue_label_email_upload_new_file":`Upload de novo arquivo`,
"label.notification.event3":`Seu evento 【事件名】 começa em 【开始时间】`,
"labe_benchmark_objects":`Objeto de referência`,
"component.chatter.button.collect":`Favoritos`,
"front-QBtoCC-sinchronies":`Sincronizando...`,
"message.submitpage.sms":`Parabéns. SMS enviados com sucesso.`,
"label.imgfield.width":`Largura`,
"label.send_email":`Enviar notificações de envio por email para`,
"label.queue.list":`Lista de filas`,
"label.tabpage.fieldoptions":`campo tipo de registro, campo lista de opções e campo lista de opções (escolha múltipla). recomenda-se digitar no máximo 10 palavras-chave, separadas por vírgulas para obter "ou relacionamento", como por exemplo: "Nova Iorque, Toronto, Tóquio".`,
"component.chatter.post.button.save":`Publicar`,
"chatter.group.groupDescriptionInformation":`Descrição do grupo`,
"label_setup_mobilesetup_isenableh5newandedit":`H5 em seu aplicativo móvel.`,
"lable.Confirm.recallpotential.customers":`Confirmar para reciclar {num} leads.`,
"label.knowledge.setting.hint.seven":`Selecione um nome dentre os seguintes e conceda acesso por escrito para contribuir com seus esforços.`,
"label.emailtocloudcc.redmessage2":`Por favor, digite a senha correta de sua conta de e-mail`,
"message.validation.equalTo":`Insira os mesmos valores.`,
"vue_label_help_golbal":`Navegação geral`,
"vue_label_chatter_delete_group_title":`Eliminar grupo`,
"label.user.login.success":`Login Sucesso no Login`,
"label.chatham.standard.time":`Tempo padrão de Chatham`,
"label.vlidaterule.example.percent":`O percentual de desconto não pode exceder 30%.`,
"label.group.field":`Especificação do campo de agrupamento`,
"label.trigger.operation.sharetab":`Formulário de ações acionadoras compartilhadas:`,
"label.mobile.phone.write.month.report":`Notas de Trabalho Mensais`,
"label.statusofconvers":`Status convertido`,
"label.version.emailtemplate.track":`Modelo de e-mail`,
"label.customobjects.onlytrackforupdate":`Rastrear apenas mudanças`,
"label_tabpage_enterviewname":`Passo 1, por favor, digite o nome da vista`,
"label.processsetting.three.enable":`Etapa 3: Ativar`,
"label.service.show.more.info":`Mostrar mais informações`,
"front-epwechat-module-v1-input-iosschema":`Por favor, digite o esquema iOS`,
"label.dataimport.datatype.error":`Erro de tipo de dado, verifique cuidadosamente se os dados e o título correspondem um a um.`,
"label.staticresource":`Recurso estático`,
"label.weixin.customize":`Personalizar`,
"label.product.edit.sel":`Editar Selecionado`,
"label.appointmentpage.wizard.notif5":`Formato de telefone inválido`,
"label.marketsea.basicsetup":`Configurações básicas`,
"label.workflow.supplyintruduce":`1.Critérios que fazem com que a regra de fluxo de trabalho seja executada.<br/> 2.Ações imediatas que executam quando um registro corresponde aos critérios. Por exemplo, o CloudCC pode enviar automaticamente um e-mail que notifica a equipe da conta quando uma nova oportunidade é criada.<br/>3.Ações dependentes do tempo que fazem fila quando um registro corresponde ao critério, e executam de acordo com o tempo de acionamento.`,
"label_report_line_tuozhuai":`Por favor, arraste e solte, ou clique duas vezes para selecionar a coluna de relatório e ajustar seus pedidos`,
"label.add.new.rule":`Adicionar Regras de Nova Geração`,
"label.marketing.setting2":`Configuração`,
"vue_label_chatter_delete_some_group":`Você tem certeza que deseja excluir o grupo "{groupInfoList}"?`,
"label.appupload.uploading.wait":`Por favor, aguarde`,
"label.linecondition.error":`Erro de condição da linha, descasamento do tipo de campo!`,
"chatter.group.request":`Solicitação`,
"label.recordtype.tabname.remark":`Use esta página para criar e manter tipos de registros para sua organização. Você pode exibir diferentes layouts de página e valores de lista de seleção com base nos tipos de registro. Para usar tipos de registro, adicione o campo Tipo de Registro aos layouts de sua página.`,
"setup_mainpage_label_welcome4":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object.`,
"vue_label_salesadvance":`Fase de vendas antecipadas`,
"vue_label_campaign_of_existing_campaign_members":`Favor definir o status dos membros da campanha existente`,
"label.report.object.detail.no.permission":`O tipo de relatório é alterado ou movido. Favor contatar o administrador para obter ajuda.`,
"label.weixin.untreated":`Aberto`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Atribuir automaticamente ao(s) aprovador(es).`,
"label.marketseamemset.containself":`Contém registros auto-construídos`,
"vue_label_report_drill":`Perfuratriz`,
"label.order.products.to.assets":`Converter produto de pedido em ativo`,
"label.recordtype.list":`Tipo de Registro Existente`,
"lable.outlook.detail.conflict":`Comportamento conflituoso`,
"pagecreator.page.label.layoutpreview":`Visualização do layout`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`A conversação de agentes é apoiada pela Easemob. Por favor, compre primeiro uma conta Easemob.`,
"label.convers":`Converta`,
"serviceappointment.worktype.isnot.father.worktype":`O tipo de trabalho associado a seu registro pai deve ser selecionado para esta nomeação de serviço.`,
"lable.tianyancha.h5.relatedcom":`Empresas Relavant`,
"label.reportsSubscriptionPage.schedulereport":`Relatório do cronograma`,
"label.workbanch.setup.showinworkbanch":`Exibição na minha bancada de trabalho`,
"label_emailsync_connectaccount":`Conectar conta de e-mail`,
"label.usermanage.license.not.qualified":`O sistema detectou que esta é uma licença de não conformidade, entre em contato com o fornecedor para obter a licença novamente!`,
"component_setup_label_displayfield":`Campo de exibição`,
"setup_layout_label_buttonarea":`Área de botões`,
"label.weixin.input.content":`Por favor, digite o conteúdo`,
"label.operatedata.importsuc":`Importação bem sucedida, você pode verificar o resultado da importação clicando na aba do objeto.`,
"label_tabpage_yes1z":`Sim1`,
"front-electronic-signature-describe":`Acesso à assinatura eletrônica, assinar um contrato em qualquer lugar e a qualquer momento. Assine com um clique, seguro e eficiente!`,
"label.event.this.month":`Neste Mês`,
"label.document.replaces":`Substitua`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Rastreamento de alimentação`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Por favor, acrescente o quadro`,
"label.cpq.main.quote.transfer.order":`Somente a cotação primária pode gerar pedidos.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Completar com sucesso`,
"label.appexchange.uninstallpage.uninstall":`Desinstalar`,
"label.campagin.roi.channel":`Canais`,
"label.multilang.versioncontrol.checkversion":`Sua versão atual do CloudCC é {0} o que lhe permite criar {1} {2} que atingiram o limite! Se necessário, por favor, atualize a versão CloudCC!`,
"label.emailobject.my.template":`Somente meus modelos`,
"label.edittimetrigger":`Tempo Disparador Editar`,
"label.setup.mobile.homepageshortcuts.saveerror":`As configurações de funções rápidas da página inicial móvel não são salvas.`,
"label.address.street":`Rua`,
"label.workflow.estimatecondition2":`criado`,
"label.wei.expiresdate":`Data de expiração`,
"label.quickbooks.viewlist.date":`DATA`,
"label.page.select.field.type":`Selecione o tipo de campo`,
"label.tabpage.mypotentialcustomers":`Minhas pistas`,
"label.file.library.editlib":`Editar Libray Details`,
"label.weixin.message.operateexception":`Pronto`,
"label.visualpage.staticresource.p1":`1. método de chamada. Refira os recursos estáticos selecionados, referenciando os botões de recursos estáticos`,
"label.icon.175":`Passagens aéreas`,
"chatter.edit.r":`Escreva um comentário...`,
"label.examinationandapproval.flow":`Processos de Aprovação`,
"label.mr.descreption.reDataList5":`conjuntos de dados.`,
"label.edit.field.select.showstyle":`Estilo de exibição`,
"label.reportsSubscriptionPage.condition.and":`E`,
"label.please.associations":`Por favor, escolha o objeto associado.`,
"label.service.dispatchingUnits.displays.service.appointments":`Mostrar compromissos de serviço que não estão associados a uma região`,
"label.addcurrent":`Adicionar Existentes`,
"label.search.change":`Personalização de objetos pesquisáveis`,
"message.schedulejob.error.modify":`Com base em um cronograma configurado, o trabalho nunca será acionado. Verificar os dados e reapresentar.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} links publicados para todos em {1}`,
"label.weixin.micro.oldid":`ID original da conta oficial do WeChat`,
"label.employees.only.invitation.code":`O sistema irá gerar um código de convite único para o funcionário, que pode ser usado para fazer convites e pode ser contado como desempenho individual. Observe que o proprietário principal será o atual proprietário da campanha de marketing ou do canal de marketing do convite. Você pode realocar os leads através das regras de alocação de leads. Para regras de alloacation`,
"lable.PowerProcess.event.msg":`Você pode adicionar ações de fluxo de trabalho dependentes do tempo que ocorrem em cada etapa (marco) no processo de concessão de direitos. Por exemplo, você pode configurar ações para enviar um e-mail ao proprietário do caso uma hora antes do vencimento de um marco, ou para atualizar automaticamente campos de casos específicos quando a primeira resposta a um marco for completada.`,
"label.file.share.email.content2":`Pré-missão: #sharerole`,
"label.querydetailservice.datalayout.notexist":`O layout correspondente do registro não existe.`,
"label.group.items":`Item de grupo`,
"label.istouse":`Disponível em`,
"front-electronic-signature-explain":`Fadada Esignature Descrição:`,
"label.partner.template.thumbnail":`Miniatura`,
"registration.page.selected.fields":`Campos obrigatórios da página de registro`,
"label.reportTypeCategoryLabel":`Fonte de dados`,
"vue_label_email_You_have_not_activated_the_mailbox":`Você não ativou a caixa postal`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Taxa de conclusão da tarefa`,
"label.forecast.detailforecast.program":`Itens Previstos`,
"label.page.display":`Mostrar`,
"label.passwordPolicy.setup.minute":`atas`,
"label.emailtocloudcc.step1total3":`Etapa 1 de 3`,
"label.file.title":`Título`,
"label.callcenter.private.key":`Chave secreta de acesso privado`,
"com.cloudcc.login.error.message.loginerror":`Sua identificação ou sua senha está incorreta`,
"UG_Lead_004":`Formulário web`,
"label_tabpage_recordsz":`Registro`,
"label.shangqing.discovery":`Descoberta de informações comerciais`,
"vue_label_notice_change_success":`Mudou com sucesso`,
"label.ems.other":`Outros`,
"loading":`Carregando...`,
"label.committedtoapprove":`Os Pedidos de Aprovação Submetidos`,
"label.category.4":`Financeiro`,
"template.report.folder.customer.situation":`Análise da situação das contas`,
"label.quickbooks.searchresault.phone":`Telefone`,
"label.ccpeak.ccobj.save":`Para salvar o CCObject no banco de dados, o método de chamada é`,
"label.knowledge.delete.linked":`Erro ao apagar o artigo associado`,
"label.forecast.settings.future2":`Futuros 2 ciclos`,
"message.error.displaytype.detail":`Tipo de display não pode estar vazio, Dia: dia, Mês: mês, Semana: semana, Disponibilidade: disponibilidade!`,
"front-template-V1-search-template-name":`Digite o nome do objeto e encontre`,
"label.sendsms.batch.step3.introduce":`Atividades de armazenamento de cada SMS`,
"UG.Forcast.08":`Passo anterior`,
"label.inputnameandintro":`Digite Nome e Descrição`,
"label.redistributioned":`Reatribuído`,
"label.service.dispatchingUnits.left.right.total":`{esquerda}-{direita} registros , {totalCount} registros no total.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Por favor, digite o horário de trabalho real`,
"label.exporttemplate":`Exportar o modelo`,
"label.data.downpage":`Página de download de dados`,
"message.please.choose.contact":`Favor selecionar um contato`,
"message.error.dataformat.error":`Erro no formato dos dados`,
"label.customsetting.changefieldtype.losevalue":`A mudança para o tipo de dado selecionado causará a perda de todos os dados existentes no campo.`,
"label.sendemail.chat.chattype":`O tipo de posto principal:`,
"label.ccdocument.upload.error":`Documento de carregamento de erro.`,
"label.quickbooks.view.all":`Todos`,
"label.data.downpage.e_title":`Passos para a exportação de dados`,
"lable.data.lock":`Os dados estão bloqueados, se você precisar editá-los, destrave-os primeiro.`,
"label.locked":`Fechado`,
"label.customfields.beforedeletedata":`A fim de preservar um registro de dados para referência futura, execute uma exportação de dados antes de excluir campos personalizados, clicando em Setup | Data Management | Data Export.`,
"label.productsales.oppor.noapproach":`Nenhuma oportunidade com uma data de contrato prevista de menos de 30 dias`,
"label.input.notmore.than.number":`Favor inserir um número menor ou igual a {0}.`,
"label.list.userinterface.isenable":`Habilitar a edição em linha`,
"label.listofshare":`Lista de informações para compartilhar`,
"label.emailsync.status.role":`Papel`,
"label.staticresource.useful.realtion":`Onde é utilizado este recurso estático`,
"label.sharerule.tip":`Esta página exibe as configurações de compartilhamento da sua organização. Estas configurações especificam o nível de acesso que seus usuários têm aos dados de outros.`,
"label.qrcodelogin.message.expired":`O Código QR expirou`,
"label.marketing.setting3":`Definição dos Canais de Marketing`,
"vue_label_statistical_field":`Campo estatístico`,
"message.view.addtomyhomepage":`Adicionar à minha página inicial Workbench`,
"label.customfields.percent.tip":`Permite que os usuários digitem um número percentual, por exemplo, "10" e automaticamente adiciona o sinal de porcentagem ao número.`,
"component_newrecords_label_10records":`10 registros`,
"Lead_Scoring_Warning_001":`Marcar um único registro de chumbo automaticamente ao criar ou editar. Mas você precisa pontuar manualmente vários registros de chumbo, ao importar ou criar por interface.`,
"label.project.planing":`Despacho Homemhora VS Reportado Homemhora neste ano`,
"label.data.exp.pwdverif":`As senhas são permitidas somente para letras e números.`,
"coderules.notEnable":`Favor contatar o administrador para ativar as regras de geração de código QR e código de barras.`,
"label.weixin.wdyj.jxhk":`Desempenho de Vendas-Pagamentos de Vendas Pessoais`,
"label.data.expnode.e_desc3":`3. Template Create: o usuário pode fazer o modelo de acordo com os campos e condições que serão exportados para atender às suas necessidades, o que é conveniente para uso na próxima vez.`,
"chatter.group.join":`Junte-se a`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Você tem certeza de que vai apagar esta pasta?`,
"label.exchange.sync.state.info":`Verifique o status do sistema para garantir que os registros estejam sincronizados entre o Exchange e o CloudCC.`,
"lable.outlook.mcto.emaildes":`Digite todos os endereços de e-mail dos contatos e contatos que você usou para enviar e-mail, e separados por vírgulas. somente e-mails enviados do endereço de e-mail abaixo podem ser adicionados ao Histórico de Atividades se os registros relacionados.`,
"label.ems.save":`Salvar`,
"vue_label_dashboard_maximumvalue":`Por favor, digite o valor máximo`,
"label.passwordPolicy.setup.norestriction":`Sem restrições`,
"label.multilang.customforcast.total":`Acumulação de {0}：`,
"label_partner_all_memo":`A lista mostra todas as nuvens de parceiros em sua organização. clique em url para fazer o login.`,
"Account.News.Setting.002":`Use as configurações de conta abaixo para especificar o comportamento padrão da conta para sua organização.`,
"label.essential":`necessário`,
"label.nonotice":`Sem mais lembretes`,
"vue_label_calendar_calendar_deleted_successfully":`Calendário apagado com sucesso`,
"message.huanxinagent.disable":`Agente inativo`,
"label.goto":`Saltar para`,
"label.chat.topic.add.favorite":`Acrescentar aos Favoritos`,
"label.trigger.targetobj":`Objeto Alvo`,
"label.form_fields":`Campos do formulário`,
"this.month":`Neste Mês`,
"vue_label_homepage_select_view":`Selecione Visualizar`,
"label.weixin.input.subject":`Favor preencher o assunto`,
"label.ems.emailType":`Tipo de caixa de correio`,
"vue_label_file_safe_type_file":`Favor confirmar que o arquivo não contém informações sensíveis. Por favor, considere compartilhar arquivos com usuários ou registros específicos`,
"label.version.case.automatic.upgrade":`Regras de Escalação e Atribuição de Casos`,
"label.input.invalid.credit.card.number":`Favor digitar o número válido do cartão de crédito`,
"component_timeline_label_future":`Próximo passo`,
"label.emailtemplate.cannotsupporthtml":`Tipo HTML não suportado atualmente`,
"label.appupload.install.error.info2":`{1} {0}' entra em conflito com os componentes existentes.`,
"label.custom.field.maping":`a este campo.`,
"encd":`Texto Criptografado(Mostrar Criptografado)`,
"label.service.newBuildDialog.filter.logic":`Lógica de filtragem`,
"label.customerinfo":`Perfil da empresa`,
"vue_label_applauncher_notice_activepoolsuccess":`Ativado com sucesso o pool de chumbo`,
"label.partner.workspace.member.choicepermission":`Selecione o conjunto de permissões`,
"front-gantt-module-this-task-of-other-tasks":`Esta tarefa existe como uma subtarefa e não pode ser uma subtarefa de outra tarefa!`,
"label_chatter_publish":`Publicar`,
"label.forecast.settings.mrfw":`Começando em`,
"label.Named.Filter":`Nome do filtro`,
"label.department.email":`Endereço de E-Mail`,
"label.updatingfield":`Campo para atualização`,
"label_partner_template_detail":`Descrição da função`,
"front-epwechat-module-v1-unbound-item":` vinculação de todas as empresas`,
"vue_label_file_lib_name":`Nome da biblioteca de arquivos`,
"label.notification.arketsea.distribution":`{5} atribuído {2}{0}：{1} a você`,
"vue_label_norm_removecomponent":`remover componente`,
"component.event.label.begindate":`*Tempo de partida`,
"chatter.note":`comentário(s) recebido(s)`,
"label.forecast.settings.type.all":`Anular Previsão`,
"label.compact.layout.frame.full":`Exibição em tela cheia`,
"label.approvalstep3intro":`Usando as opções abaixo, especificar o usuário a quem o pedido de aprovação deve ser atribuído.`,
"label.notification.approval6":`【被委派人名称】approved o pedido de aprovação da 【提交人】 de 【对象】【对象名称】for você.`,
"setup.object.field.dependency.label.actionfieldvalue":`Campo de controle`,
"label.multilang.page2":`Página`,
"vue_label_email_submitted":`Enviado em`,
"label.Standard.button":`Botões padrão`,
"vue_label_report_emailchoose":`Opção de e-mail`,
"page.field.masterinput.list":`Lista de dados de entrada Master-Detail`,
"label.martrixdown":`Matriz Down`,
"vue_label_helpcenter_opportunity":`No canto superior direito da vista, clique no ícone do funil de vendas para saltar para ver o funil de vendas.<br>Através da barra de progresso intuitiva, acompanhe o progresso de cada oportunidade de negócios, e clique no botão para marcar a conclusão do estágio atual, ou ajuste o estágio atual. Se você encontrar obstáculos no avanço das oportunidades de negócios, você também pode expandir a barra de progresso para visualizar as informações e algumas dicas quentes às quais deve ser dada mais atenção no estágio atual.<br>Através da lista relacionada do grupo de oportunidades de negócios, os dados das oportunidades de negócios podem ser compartilhados com outras pessoas que não têm acesso para visualizá-las, de modo a facilitar o trabalho colaborativo.<br>Na lista relacionada à função de contato sob a oportunidade de negócios, adicionar rapidamente a função na oportunidade ao contato no cliente correspondente, e então visualizar a relação superior e subordinada do contato relacionado através da rede de relacionamentos, e usar o gráfico do radar para avaliar o contato atual O valor das oportunidades, acompanhar, localizar pessoas-chave e verificar os contatos. Papel, status da visita, grau de relacionamento, estilo de compra e tempos de visita<br>?através da lista relacionada de produtos de oportunidades de negócios, é possível adicionar produtos na mesma lista de preços para a oportunidade de negócios, e editar o preço e a quantidade dos produtos.`,
"label.sso.ssoKeyMan":`Gerenciamento de chaves de assinatura única`,
"label.forecast.edit.desc":`Estabelecer uma cota de usuário para o seguinte período`,
"label.weixin.newspaper.coverage.time":`Data de risco`,
"label.pleaseselectpro":`Favor selecionar produtos`,
"label.bottonandlink":`Botões e Links`,
"label.donot.know.error":`Ocorreu um erro desconhecido, favor entrar em contato com o administrador.`,
"label.account_noordab":`Sua conta tem 0 relatórios personalizados e 2 painéis de controle.`,
"label.partnerCloud.orderingPlatform.toPay":`Pagamento por Fundo Parceiro`,
"label.many.dayline.nextday":`Dia seguinte`,
"lable.showmorerecords":`Mostrar mais`,
"front-lightning-module-v1-details-page-chart-record-type":`Por favor, selecione o tipo de registro`,
"label.ccpeak.query.record":`busca dos registros`,
"pagecreator.systemstyle.message.save.fail":`A economia de estilo falhou`,
"label.weixin.share.file":`Compartilhar arquivo`,
"errormessage.email.relatedorreceivermusthaveone.z":`Você deve selecionar um destinatário ou um assunto relacionado, pelo menos.`,
"chatter.save.f":`Salve Failed`,
"button.partner.create":`Novo`,
"label.marketseamemset.lead.title2":`Favor estabelecer um limite superior para o número de leads que afetam todos os membros. O limite não tem nada a ver com a piscina de alto mar.`,
"label.service.major.event.new":`Novo marco miliário`,
"label.version.custom.site":`Site personalizado`,
"label.permission.visualpagepermission":`Páginas Personalizadas Atribuídas`,
"lable.product.zongjia":`Preço total`,
"label.viewchart":`Ver Gráficos`,
"label.alaska.daylight.time":`Horário de verão do Alasca`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Permitir que mais usuários se tornem agentes e atendam aos visitantes, melhorar o atendimento ao cliente.`,
"component_assistant_label_todaylead":`As pistas atribuídas a você hoje`,
"label.sendemail.chat.addComentsfavorite":`Prezado #nome:\n ; olá! #userName respondeu ao seu post marcado.`,
"label.smstemplate.tip":`Todos os modelos de SMS na pasta selecionada estão listados abaixo. Clique no botão "Novo" para criar um novo modelo de texto ou HTML SMS. Você pode usar estes modelos de SMS ao enviar mensagens. Clique no link de funções para ver informações mais detalhadas".`,
"label.documentname":`Nome do documento`,
"label.icon.162":`Paisagem`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Campo tipo de registro, campo de lista de seleção e campo de lista de seleção ( multi-seleção), recomenda-se digitar até 10 palavras-chave, separadas por vírgulas. Como "Nova Iorque, Toronto, Tóquio".`,
"label.searchlayout.lookup.newfield":`Diálogos de Busca que aparecem quando você clica no novo botão nos campos de Busca.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`Esta é a primeira página.`,
"vue_label_appstore_crm_used_companies":`CRM utilizado por empresas listadas`,
"label.document.replace":`Substitua`,
"label.assignment.setup.newrule.title":`Nova regra de atribuição de casos`,
"component.chatter.label.mygroup":`Meu grupo`,
"lable.currencyAdv.exchangedate":`Faixa de datas`,
"label.quickbooks.button.viewinqb":`Ver em QuickBooks`,
"UG.homepage.004":`Automação`,
"label.currencyName":`Nome da moeda`,
"Homepage_News_001":`Notícias`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Mostrar botão de atualização`,
"label.list.projectSetting.isenable":`Habilitar temporizador do projeto (Incluir: marco, tarefa, sub-tarefa, problema)`,
"setup.layout.message.relatedlistbutton":`Selecione botões padrão para exibir no`,
"vue_label_homepage_homepageassignment":`Atribuição da página inicial da aplicação`,
"label.pending":`Pendente`,
"component.timeline.label.today":`Hoje`,
"front-kefu-moudle-free-hasexpire":`Seu teste gratuito expirou`,
"homepage.layout.customlayout":`Layout de página personalizado`,
"label.service.miniProgram.content":`Por favor, preencha o conteúdo.`,
"label.defaultline.must.int":`O número padrão de linhas só pode ser números inteiros positivos.`,
"label.mirror_issues":`Se o formulário não espelhar o que você vê de seu lado, leia nosso artigo sobre como solucionar problemas de exibição comuns.`,
"label.edit.select.two":`Lista de caixas de seleção única`,
"label.emailmerge.mergeFolder.tip":`A fusão de modelos leva algum tempo, durante a fusão, por favor não clique em outros links, feche seu navegador da web ou atualize a página.`,
"label.ServiceCloud.zichan.distributionMap":`Mapa de Distribuição de Ativos`,
"label.selectfile":`Selecione os arquivos`,
"vue_label_account_equitymanage":`Gerenciar a relação de equidade`,
"label.email.clearAll":`Limpar tudo`,
"label.selecting.parent.assets":`Escolha o bem dos pais`,
"component.setup.tabs.label.delete":`Excluir`,
"label.visualpage.top.must.is":`A primeira linha do cabeçalho do oage deve ser:`,
"label.SalesCommitmentDashboard":`Painéis de Compromisso de Vendas`,
"chatter.group.changeTheRole":`Mudar o papel`,
"label.dataimport.insertdata.error":`Ocorreu um erro durante a inserção de novos dados. Por favor, verifique estes dados cuidadosamente.`,
"label.partner":`Nuvem de parceiros`,
"label.process.async.execute.tip":`Seu pedido está em processamento. A aprovação leva certo tempo e o resultado será mostrado na página de detalhes. Por favor, aguarde.`,
"label.service.newBuildDialog.additional.conditions":`Condições adicionais`,
"label.name_copy":`Você está prestes a clonar esta forma existente. Por favor, digite um nome para a cópia.`,
"label.integrations.install":`Instalar`,
"label.edit.ccpeakfolder.time":`Classes programadas: Edição de pastas`,
"label.knowledgebase.filing.time":`Tempo Arquivado`,
"vue_label_chatter_success_exit_group":`Sair com sucesso do grupo`,
"font.market.module.v1.save.name":`Favor preencher o nome da reunião`,
"label.a.b.without":`Os registros A podem ou não ter registros "B" relacionados.`,
"label.chat.topic.desc":`Descrição`,
"label.field.editoptionlist.introduce":`Digite o nome do valor da lista de picking.`,
"label.versiontype.Enterprise":`Empresa`,
"message.selectrulecondition":`O pleasso especifica os critérios da regra`,
"label.custombutton.unknown.operation":`Ações inválidas`,
"label.pricecannotnull":`O preço é necessário`,
"component_salesperformance_label_target":`Meta`,
"pagecreator.page.message.delete.success":`Página excluída com sucesso`,
"label.help.new.features":`Novas características do CloudCC`,
"label.weixin.vehicle.owner.information":`Detalhes do proprietário do veículo`,
"label.exchange.sync.state.user.info":`Verifique o status de sincronização de um usuário para garantir que os registros estejam sincronizados entre o Exchange e o CloudCC. Se o usuário tiver um problema de sincronização entre Exchange e CloudCC, o usuário pode reiniciar o processo de sincronização. Reinicializa informações que o CloudCC para Exchange utiliza apenas e não exclui dados de seu servidor Microsoft Exchange ou do CloudCC.`,
"label.batcheditor":`Edição em massa`,
"report.label.knowcreatehighlevelreport":`Como criar um relatório avançado?`,
"label.dataimport.title.length":`O comprimento do título é`,
"label_model_description":`Descrição do modelo`,
"label.tabpage.ctbtsftcz":`Clique no verso para pesquisar o conteúdo`,
"label.channel.activity.member.owner":`Proprietário do Membro da Campanha`,
"label.ems.serverinfo":`Informações do servidor`,
"tjinvilid":`Condições ilegais`,
"label.nameofreport":`Nome do relatório`,
"label.ifapproverreject":`O que acontece se o aprovador rejeitar este pedido?`,
"label.wtd.changefields.title.desc2":`Se você precisa de um registro no aplicativo móvel "Web to CloudCC" para associar um lead, você precisa criar um campo do objeto atual para procurar o lead, e o nome do campo API é " lead_wtd".`,
"label_emailsync_form_connecttime":`Tempo Relacionado`,
"label.visualpage":`Página personalizada`,
"label.customlink":`Links personalizados`,
"label.lead.score.doing.remark":`Seu pedido foi processado e levará um certo tempo para a pontuação de chumbo. e o sistema o informará por e-mail quando concluído.`,
"label.h5.act.details":`Detalhes da atividade`,
"label.profile.setrecordtype":`Configurações do tipo de registro`,
"label.processsetting.process.enabled.successfully":`Habilite o processo com sucesso!`,
"label.campaign.url.overtime":`O link expirou.`,
"label.structureChart.notFiled":`Não Preenchido`,
"label.h5.chatter.something":`Você diz algo`,
"label.pm":`PM`,
"template.chart.rwlx":`Tipo de tarefa`,
"label.icon.42":`Nuvem`,
"label.project.hit.one":`Aviso de atribuição de subtarefa`,
"label.martrixreport.2018.step3":`Passo 3 Escolha os cabeçalhos das colunas`,
"label.wtd.changefields.newmo":`Gerar página móvel`,
"label.downloadTheTemplate":`Download do modelo`,
"label_chatter_assignPerson":`Pessoa designada`,
"label_emailtocloudcc_license":`Licença`,
"label.willdeletedlayout":`Layouts de página que você deseja excluir`,
"label.projectManagement.delete.question":`Todas as informações relacionadas a este assunto também serão apagadas se você apagar este assunto, e os dados não podem ser recuperados. Você tem certeza de confirmar a exclusão?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Habilitar regras de validação ao usar o Scan`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Note：double clique no espaço em branco contacts，can adicione um registro em branco`,
"label.step6.total6":`Passo 6 de 6`,
"label.knowledge.setting.hint.one":`O conhecimento permite ao cliente e ao pessoal de serviço fazer pleno uso dos artigos de conhecimento.`,
"label.usefieldautoassign":`Atribuir automaticamente um aprovador usando um campo de hierarquia padrão ou personalizado:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Valor do pedido:`,
"chatter.fieldtrack.operateupdate":`mudou um`,
"chatter.del.com":`Elimine este comentário`,
"report.reportdatasource.label":`Fonte de dados do relatório`,
"label.text":`Texto`,
"label.marketsea.select.member":`Membros opcionais`,
"label.typeofreceivers":`Tipo de destinatário`,
"label.knowledgebase.affect.existing.translations":`Sim, minhas modificações afetarão a tradução existente. Marcar como "Expirado".`,
"label.marketing.invitationmail":`Bem-vindo à nossa atividade, seu link de convite é:`,
"label.version.quotation.management":`Gestão de cotações`,
"label.dataimport.insertdata.error.unique":`$fieldName$ viola as restrições de singularidade ao inserir novos dados.`,
"label.emailmerge.list.newtemplate":`Novo modelo`,
"label.salescloud.salescloud.allteam":`Equipe All Opportunity baseada em todas as Equipes`,
"vue_label_commonobjects_detail_record_changes":`Mudanças nos registros de campo`,
"label.file.delete.info":`Eliminar arquivos`,
"vue_label_calendar_name":`Nome do Calendário`,
"label.version.support":`Apoio`,
"label.event":`Eventos`,
"label.searchlayout.lookup.searchdialog":`Diálogos de Busca que aparecem quando você clica no ícone de busca nos campos de busca.`,
"label.data.downpage.e_list.desc2":`Após a conclusão, você receberá um e-mail lembrando que os dados foram exportados com sucesso.`,
"label.partnerCloud.productSet.delIsTrue":`Você quer apagar este produto?`,
"label.tianyancha.businessverify.msg2":`Este acordo é um acordo entre o usuário (doravante chamado de usuário) e o CloudCC relativo ao uso da função de verificação de dados comerciais. este acordo descreve os direitos e obrigações do uso da função de verificação de dados comerciais e serviços relacionados entre o CloudCC e o usuário. este acordo pode ser atualizado pelo CloudCC a qualquer momento. os termos atualizados do acordo uma vez publicados, ele substituirá os termos originais do acordo sem aviso prévio.`,
"label.customobjects.cancleselectallfield":`Cancelar todos os campos selecionados`,
"image.up.maxsize":`O arquivo carregado é muito grande, por favor não exceda 2M.`,
"label.icon.8":`Arquivo`,
"label.donot.delete":`Você não tem permissão para excluir`,
"label.version.profile.and.layoutpage":`Perfis e layouts de página`,
"chatter.coll.s":`Remover este marcador de página`,
"label.icon.163":`Terra`,
"label_chatter_myfollowers":`Meus seguidores`,
"label.multilang.customforecast.refuse":`Rejeitar qualquer prioridade preditiva de {0}, mas aceitar prioridade preditiva de outros subordinados`,
"label.tabpage.findz":`Busca`,
"label.smstemplate.detailinfo":`Detalhes do modelo de SMS`,
"label.knowledge.setting.hint.nineteen":`Vamos começar`,
"label.mr.tip":`Favor completar as regras na linha {0}.`,
"label.icon.132":`Garantia`,
"label.customobjects.track.introduce2":`Lista relacionada à história. Sempre que um usuário modificar qualquer um dos campos selecionados abaixo, os antigos e novos valores dos campos são adicionados à lista relacionada ao Histórico, bem como a data, hora, natureza da mudança e o usuário que faz a mudança.`,
"label_emailtocloudcc_redmessage5":`Desconhecido Staus, favor entrar em contato com o administrador.`,
"label.must.select.field":`Erro de condição de linha, você deve selecionar um campo.`,
"label.tag.manage.modifiedby":`Última modificação por`,
"label.translation.start1":`Selecione um idioma (se você for um tradutor).`,
"label.ccchat.topic.searchs":`Tópico de busca`,
"label.mask.custom.example":`{AAAA}{****}{AAAAA} representa uma exibição criptografada de quinto a oitavo caracteres.`,
"setup_object_field_dependency_label_addtolist":`Adicionar os valores selecionados`,
"label.view.total.record":`Total selecionado 0 recorde.`,
"label.service.without.right":`Nenhum direito associado`,
"template.chart.wxqzkhyy":`Razões para Leads Inválidos`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Favor inserir um valor de ponto de parada 1`,
"message.pleaseinputmouthdistance":`Favor inserir o intervalo de mês válido.`,
"label.forgetPsd.tip":`Esqueça a senha, entre em contato com o administrador.`,
"label.projectManagement.planned":`Programado`,
"lable.Product.conversion.asset.operation":`Transferir produto para ativo`,
"label.search_forms":`Busca de Formulários`,
"label.sendemail.chat.addPostmainPagesubject":`Mensagem da página inicial do CloudCC CCChat`,
"label_tabpage_viewNamez":`Por favor, digite o nome da vista`,
"label_chatter_addresser":`Remetente`,
"Opportunity_Detailed_Phase_Change_Text_001":`Estágio de Oportunidades de Mudança`,
"label.what":`Página`,
"vue_label_systemSettings_set_android":`Configurar menus e recursos para Android e IOS para tornálo adequado para usuários comerciais.`,
"label.sell":`Venda`,
"template.report.folder.case":`Análise de casos`,
"label.customfields.profilefieldsafety":`Segurança de perfil em nível de campo`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`Concluído`,
"label.sendmail.step3.introduce1":`Você tem atualmente`,
"vue_label_calendar_other_calendars":`Outros Calendários`,
"label.donot.know.validate.field":`Campos de validação inválidos`,
"label.exportdetail":`Detalhes de exportação`,
"label.step.filter":`Especificar as condições do filtro`,
"label.campaignmember.main.hasMember":`Membros Existentes`,
"label.updown.suess":`Baixar com sucesso`,
"label.ems.browse":`Navegue`,
"front-email-payment-Invoice-login-account-describe":`Clique em "Continuar" para completar o pagamento da fatura digitalizando o código QR da Alipay ou faça o login Alipay.`,
"label.copyCustomReportType":`Clone Fonte de dados do relatório personalizado`,
"label.visualpage.write.class":`Editar código de classe na página com a mesma sintaxe de Java.`,
"label.setsharerule.tip":`<br>Utilizar regras de compartilhamento para fazer exceções automáticas às configurações de compartilhamento em toda a organização para conjuntos definidos de usuários.<br>Nota: "Funções e subordinados" inclui todos os usuários em uma função, e as funções abaixo dessa função.`,
"label.report.action.addtodashboard9":`Página de Lista de Painel`,
"label.cloudccsite.remark":`Descrição do site`,
"label_tabpage_noz":`Não`,
"chatter.up.limit":`O arquivo carregado é muito grande, por favor não exceda`,
"label.leadmarketsea.grouplist.title":`Configurações do grupo de liderança`,
"label.pc.user.help":`Guia do Usuário`,
"label.partnerCloud.orderingPlatform.relyOn":`Dependência`,
"label.appointmentpage.wizard.subtitle2":`Escolha o tempo`,
"label.deleteoneormore":`Excluir um ou vários`,
"january":`Janeiro`,
"label.delete.profile":`Eliminar perfil`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Cosmético`,
"vue_label_file_already_in_lib":`Já existe nesta biblioteca de arquivos`,
"label.icon.151":`VR`,
"label.withvalue":`Por valor`,
"label.tianyancha.businseeverify.opererror":`Por favor, tente novamente ou entre em contato com seu administrador de sistema!`,
"label.tabpage.individual":`Escolha individual`,
"label.layout.editdistribute":`Editar Designação`,
"label.smstemplate.lookup":`Veja o modelo de SMS`,
"pagecreator.systemstyle.button.delete":`Estilo de eliminação`,
"label.customer.tab.step2.same.option1":`Default On`,
"label.knowledgebase.no.results.knowledge":`Nenhum resultado em conhecimento`,
"label.data.exp.newtemporexp":`Selecione o método pelo qual os dados são exportados ou crie um novo modelo`,
"vue_label_chatter_refuse_join":`Recusar-se a aderir`,
"Homepage.News.002":`O componente de notícias não está disponível atualmente.`,
"label.log.requesttype":`Método de solicitação`,
"vue_label_dashboard_generatefromreport":`Gerar a partir do relatório`,
"label.knowledge.create.version":`Criar Versão`,
"label.emailtocloudcc.description2":`Conecte seu e-mail`,
"label.partnerCloud.partnerAccount.recharge":`O valor da recarga deve estar entre 0,1 e {limite superior}.`,
"label.customobjects":`Objetos personalizados`,
"label.schedulableprg.endtime":`A data de término deve ser posterior à data atual do sistema`,
"message.error.viewreport.confirmdelete":`Há gráficos que utilizam a visão/relatório atual como fonte de dados. Você também deseja excluir o gráfico?`,
"label.marketing.social.seting":`Configuração de mídias sociais`,
"chatter.follow.stop":`Pare de seguir este usuário`,
"label.notification.arketsea.return":`{5} devolvido {0}：{1} a {2}`,
"label.conditionsofnextapprover":`Há um ou mais próximos aprovadores especificados em seu pedido de aprovação selecionado. Use a seguinte caixa de pesquisa para especificar o próximo aprovador.`,
"label.partner.all.state":`Status`,
"mobel_web_closed":`Fechado`,
"label.icon.65":`Equipamento`,
"label.stdashbord.xsld.business.jinehj":`Montante total`,
"label.selectobject":`Selecione Objeto`,
"label.account.CurrentFQ":`FQ atual`,
"label.workflow.estimaterule":`Avalie a regra quando um registro é:`,
"label.list.userinterface.shownewrecordssetup":`Configurações de registros recentes`,
"label.tianyancha.businessverify.msg3":`1. taxa`,
"label.weixin..xsld.jieduan":`Estágio`,
"label.first.quarter":`Primeiro trimestre`,
"Opportunity.Detailed.Phase.Label.002":`{0} dia(s) na fase atual`,
"label_tabpage_page":`Página`,
"label_emailsync_status_time":`Hora`,
"label.pleaseselectaapprover":`Favor selecionar um aprovador`,
"label.emailtocloudcc.redmessage5":`Desconhecido Staus, favor entrar em contato com o administrador.`,
"label.four.quarter":`Quarto trimestre`,
"label_chatter_relateList":`Lista relevante`,
"label.customfields.new.step2.opration.exid.info":`Defina este campo como um identificador de registro único para um sistema externo`,
"label.projectManagement.nodata.overdue.tasks":`Ótimo! Nenhuma tarefa atrasada`,
"label.sendemail.activity.task.statuscompleted":`Caro #criatebyidccname Olá! \A tarefa que você designou para #belongtoidccname em #createdate é a seguinte: \Assunto: #sujeito: "Duetime": #ExpireDate #relacionedstr{r\n Conteúdo: #Por favor, visite o linkfor para mais detalhes: \Caminho #caminho por favor, note: #belongtoidccname está marcado como concluído. \rs #orgNameCRM System`,
"label.sso.saml.idp.config.issuer":`Emissor`,
"label.cannot.delete":`itens) não são permitidos excluir`,
"label.pigeonhole.sel_f":`Escolha as pastas a serem arquivadas`,
"label.customfields.text.tip":`Permite que os usuários digitem qualquer combinação de letras e números.`,
"message.error.user.service.common":`As operações falharam, favor entrar em contato com o administrador para obter ajuda.`,
"label.datamanage.account.information":`Informações sobre a conta`,
"vue_label_homepage_deleteprofilepage":`Excluir página inicial do perfil`,
"label.sendmail.step3.introduce3":`destinatário(s) selecionado(s) para receber este SMS.`,
"label.pc.ui.2018.recentitem":`Itens recentes`,
"label.report.loading":`À espera do carregamento`,
"vue_label_globalsearch_adjustment":`Método de ajuste`,
"label_report_line_yixuan":`Coluna de relatório selecionada`,
"label.h5.similar.opportunity.only.view":`Mostrar apenas`,
"label.marketactivitymember":`Membros da campanha`,
"label.recycle.execute.tip":`Seu pedido tem sido processado e levará algum tempo para limpar o cesto de reciclagem. Você será notificado pelo emissário quando concluído.`,
"label.permission.detail.system.setting":`Configurações de permissão de sistema`,
"label.RecordType":`Tipos de registros`,
"label.custom.error.between":`A data de início do ano ou a data de término do ano está entre os anos personalizados do histórico, favor verificar e reiniciar.`,
"vue_label_dashboard_selectview":`Selecione Visualizar`,
"label.tianyancha.businessverify.cancel":`Desativar a verificação de dados comerciais`,
"label.partnerCloud.financeSetting.MD5":`Chave Secreta MD5`,
"label.multilang.messagedetail.new.error":`Não podemos encontrar um usuário de Chat com {0} nome:`,
"label.callcenter.pleaseenter.private.key":`Por favor, digite a chave secreta de acesso privado`,
"label.umeng.activity.youdistribute":`Você foi designado para`,
"label.weixin.nickname":`Apelido`,
"label.customerinfo.mailusername":`E-mail Nome de usuário`,
"label.partnerCloud.orderingPlatform.discountPlan":`Nome da Tabela de Descontos:`,
"lable.account.year":`Ano fiscal`,
"T":`Hora`,
"System.Email.Template.Title":`Bem-vindo à plataforma CloudCC CRM`,
"label.login.type":`Tipos de Login`,
"label.notification.evaluation":`comentário esquerdo de {0} para o caso {1}.`,
"label.turntolist":`Saltar para Listas`,
"label.sort":`Ordenar`,
"vue_label_commonobject_notice_clickcross":`Se você precisar substituir o arquivo carregado, por favor clique no botão [X] e carregue novamente`,
"label.Select.maximumecords.operate":`Até 200 registros podem ser selecionados para processar.`,
"label.submission_rate":`Taxa de submissão`,
"label.datadelete.record.sucessfully":`registro(s) com sucesso!`,
"label.version.standard.dashboard":`Painéis de Controle Padrão`,
"label.task.postunsolve":`Tarefas em atraso`,
"label.Receivables.name":`Nome do recebedor`,
"label_tabpage_noOperationz":`Este conteúdo é um item fixo e não pode ser operado!`,
"label.attendance.onrecord":`Selecione pelo menos um registro`,
"label.partner.error2":`Erro: O nome de domínio só pode conter número ou letra.`,
"label.account.map":`Mapa da conta`,
"label.dashboardSetup.reference.legend":`Referência do Diagrama`,
"label.Yaxisscope":`Escopo do eixo Y`,
"label.hierarchy.tree.tip":`Selecione um registro no campo de pesquisa de cada aba para criar uma hierarquia. E a hierarquia é a seguinte:`,
"label.permission.objlist.columnsize":`Número total do campo`,
"label.setup.mobile.bottombutton.savesuccess":`Configurações de página de primeiro nível salvas`,
"label.mobile.side.tab.selected":`Já selecionado`,
"label.partner.donotdel.cause":`Porque tem relação com a seguinte nuvem de parceiros`,
"label.ccchat.message.new.error4":`Lembrete:`,
"vue_label_systemSettings_setorganization":`Configure aplicações para sua organização, personalize diferentes menus para várias divisões funcionais.`,
"label.umeng.approval.approvalmes4obj1":`Favor rever a aprovação a tempo`,
"UG_opportunity_010":`Criar uma transação`,
"label.tag.addtags.public":`Público`,
"System.TAB.SeeViewPageAmount":`Ver Páginas`,
"label.filterconditions":`Filtro`,
"front-personalEmailBox-module-v12-clear-not-associated":`Cancelar conexão irá limpar todos os emails não associados, você tem certeza de que irá cancelar a conexão?`,
"label.assign":`Atribuir`,
"label.layout.clone.tip":`Você pode selecionar um layout existente para clonar`,
"label.choose.relatedlist":`Selecione a lista relacionada que você deseja transferir`,
"label_chatter_recordcall":`Chamada gravada`,
"label.product.proofOne":`Em {0}, favor escolher até {1} opções de produtos.`,
"label.layout.availablefield.relatedlist":`Campos disponíveis / Listas relacionadas`,
"label.campaignmember.main.updateleadstatus":`Atualização do status - Leads Existentes`,
"label.custom.buttonandlink":`Botões personalizados`,
"label.view.manage":`Ver Gestão`,
"label.search.exp":`Selecione os objetos para os quais você deseja habilitar as seguintes características e clique em Salvar:`,
"vue_label_appstore_apply_to":`Aplicar para`,
"label.dashboard.message.refreshfail":`A atualização do painel de controle falhou`,
"UG_Case_02":`Os casos permitem que você responda e resolva problemas de conta. Os casos são um registro poderoso na Cloud CC que não só rastreia os problemas da conta, mas também exibe uma visão completa da conta.`,
"label.project.hit.three":`Lembrete diário de subtarefa`,
"label.tianyancha.businessverify.tip":`A função de verificação de dados comerciais é ativada para ajudar os usuários a inserir as informações corretas de registro comercial do cliente quando eles inserem os dados do cliente empresarial.`,
"label_emailsync_status_disconnect":`Cancelar Conncet`,
"label.rule.disabled.successfully":`Desativar as regras com sucesso`,
"label.custombutton.queryerror":`A consulta falhou, por favor, reabra.`,
"label.customfields.deletecannotresume":`Os dados correspondentes serão apagados permanentemente e não poderão ser recuperados.`,
"label.account.current.M":`Neste Mês`,
"label.under.approve.data":`os registros estão sendo verificados(`,
"vue_label_title_remainingdays":`Restantes dias`,
"label.partnerCloud.orderingPlatform.refundable":`Bônus disponível`,
"label.lookup.iscover":`Permitir a sincronização ao editar`,
"label.recordtype.detail.selectlist":`Listas de seleção disponíveis para edição`,
"label.sso.isActiveYes":`Sim`,
"label.service.appointmentList.canceltheSuccess":`Cancelado com sucesso`,
"label.escalation.setup.newentries.createfirst":`Quando o caso é criado, e desativar após o caso ser modificado pela primeira vez`,
"label.new.ccpeakfolder":`Classe : Nova Pasta`,
"lable.currencyAdv.exchagecurrency.after":`e depois`,
"label.majoranddetailrelation":`Relacionamentos Master-Detail`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Horário de trabalho`,
"label.forecast.customforecast.button.forehistory":`História Prevista`,
"label.mymasterplate":`Meus Modelos`,
"component.setup.tabs.label.memo":`Definir o nome da etiqueta da aba`,
"label.customfields.longtextarea.tip":`Permite que os usuários digitem até 32.000 caracteres em linhas separadas. Você pode criar até 10 campos de texto (longo) por objeto.`,
"label.service.miniProgram.fillJumpLink":`Por favor, preencha o link de salto.`,
"label.british.summer.time":`Tempo Médio Greenwich`,
"label.nogreate":`<=Menos que ou Igual`,
"label.assignment.setup.detail.sameuser":`O mesmo usuário`,
"mesage.error.profile.delate.user":`Impossível eliminar o perfil porque o usuário é atribuído ao perfil atual.`,
"label.tabpage.cownerz":`Mudança de proprietário`,
"label.multilang.dupicatecheck.processedcount":`Os grupos data，{0} duplicados foram treated，{1} os grupos de dados não foram treated：`,
"vue_label_report_notice_leavecertification":`Você certamente deixará esta página - os dados que você digitou podem não ser salvos`,
"label.master.required":`Ter campos obrigatórios de registros de crianças desaparecidas`,
"label.chatter.follow":`Siga`,
"label.dataimport.insertdata.error.repeat":`O registro duplica os dados no banco de dados original e o registro foi ignorado.`,
"label.sms.cgid":`Número da Galeria`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Campos de Objeto`,
"label.forecast.editshrepage.quanxian":`Nível de acesso de Peimissão compartilhada`,
"label.weixin.interactive.log":`Diário de Interação`,
"label.batchedit.remark":`Editar vários registros`,
"label.user.permissions.message":`Sem permissões para definir as informações do usuário.`,
"label.mobile.phone.month":`mês`,
"chatter.sel.u":`Selecione os usuários que você quer @ mencionar, ou digite o nome de usuário que você quer @`,
"label.service.gantt.assigned.work":`Trabalho Designado`,
"UG_ST_001":`Pronto`,
"label.edit.select.one":`Lista de queda`,
"label.forecast.shrepage.desc0":`Esta página lista os usuários, funções e zonas que têm acesso compartilhado ao {0}.`,
"label.multilingual.confirm.close":`Você tem certeza de que vai desativar? Não é possível usar o multilíngue após a desativação e o idioma do usuário será mudado para o idioma padrão.`,
"label.setting.intergrationlist.integration":`Integração`,
"label.leadscore.rule.list":`Lidera a lista de Regras de Pontuação`,
"component_telerecord_button_save":`Salvar`,
"label.weixin.save.log":`Salvar Diário de Bordo`,
"label.validate.function.funcExplain.DAY":`Retorna um dia do mês, você deve digitar um número entre 1 e 31.`,
"label.appointmentdetail.wizard.title1":`Nome`,
"label.multilang.feedtrack.dealkey":`Modificar {0} de {1} para {2}.`,
"label.optional.features":`Características opcionais`,
"vue_label_email_no_email":`Nenhum e-mail`,
"label.sendemail.chat.messagecontent":`O conteúdo da mensagem:`,
"label.tabpage.lessequalz":`Menor ou igual a`,
"setup.layout.label.setupfield":`Propriedades de campo`,
"label.approved.receiveApprovalEmail.option1":`Se eu sou um aprovador ou um aprovador delegado`,
"label.chatter.relateList":`Lista relevante`,
"component.sendmail.label.fromuser":`Remetente`,
"label.projectManagement.problem.status":`Status da emissão`,
"label.weixin.fmu.before.hour":`{0} hora(s) à frente`,
"chatter.feed.menutype.feed.mark":`Marcado`,
"label.addQuoteLineGroup":`Adicionar Grupo de Linha de Citação`,
"label.report.action.addtodashboard6":`Adicione`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`CQ atual e CQ anterior`,
"label.tabpage.emptyz":`Vazio`,
"less":`Menos do que`,
"label.h5.selectmostphotos":`No máximo nove fotos podem ser selecionadas`,
"UG.activity.04":`Caixa postal Outlook/Gmail, registrar correio`,
"template.chart.qbhtje":`Todo o valor do contrato`,
"label.tabpage.endz":`Fim`,
"label.partner.workspace.member":`Membro`,
"label.filter.error.filedvaluetoolong":`Erro: O valor do campo excede o limite máximo.`,
"label.months":`Mês`,
"button.partner.workspace.disable":`Cancelar ativação`,
"label.visualpage.checkpinyin.grammar":`Favor verificar a ortografia e a gramática.`,
"label.dashboardSetup.geshihua":`Formatação`,
"label.belongto":`Pertencem a`,
"label.upload.cannot.empty":`Você deve selecionar um arquivo para carregar.`,
"label.number.MaxCheck":`O máximo de {0} é {1}. Por favor, modifique a quantidade e salve as alterações.`,
"pagecreator.page.message.save.fail":`O salvamento da página falhou`,
"label.edit.SMS":`Notificação por SMS Editar`,
"UG_Lead_002":`Há muitas maneiras de identificar "leads" para seu produto ou serviço.`,
"label.quickcreate.active.quickcreate":`Habilitar a criação rápida`,
"label.recordtypeselect.tip":`Para pular esta etapa no futuro, estabeleça tipos de registros padrão.`,
"label.form_content":`Formulário`,
"workflow.action.tasks.assignortype.related":`Usuário relacionado`,
"vue_label_allsearch_set_more_items":`Você pode definir mais itens de busca na caixa drop-down do lado esquerdo da caixa de busca para continuar a busca`,
"label.tianyancha.businessverify.title":`Verificação de negócios`,
"label.errormessage.batchedit.norecord":`Sem dados.`,
"label.permission.appname":`Nome do aplicativo`,
"label.report.action.addtodashboard7":`Cancelar`,
"label.generated.transfer.product":`Gerar ativo de acordo com a forma de Conversão de Ativos.`,
"vue_label_commonobjects_detail_you":`Você`,
"label.user.captcha":`Verifique sua identidade`,
"label.notification.event4":`O evento 【事件名】 que você designou para 【被分配人】 começa em 【开始时间】`,
"label.version.setup":`Configuração`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Favor selecionar o layout e o tipo de registro`,
"label.role.add":`Adicionar papel`,
"label.versiontype.Unlimited":`Ilimitado`,
"label.partnerCloud.financeSetting.developerID":`Por favor, insira o ID do desenvolvedor.`,
"front-invoice-online-payment-setup-global":`Aplicar a Contas Globais`,
"vue_label_commonobjects_view_basis":`Base de classificação`,
"label.decimaldigits.tip":`O número de dígitos à direita da vírgula decimal`,
"vue_label_commonobjects_detail_selected":`Marcar como Estágio Atual`,
"label.data.export.page":`Ir para a página de exportação`,
"message.error.serviceresource.servicecrewid":`Cada equipe de serviço só pode ser adicionada como um registro de recurso de serviço do tipo tripulação.`,
"label.loginttime.alltime":`Todo o tempo é`,
"label.requiredinfo":`Informações requeridas`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Falha em remover o calendário`,
"pagecreator_systemstyle_button_delete":`Estilo de eliminação`,
"label.import.page3.continueimport":`Continuar a importar`,
"label.page.width":`Largura total da página`,
"label.campaignmember.selectmember.addmember":`Adicionar membros de`,
"label.finalreject":`Rejeição final`,
"label.isend":`Está Acabado`,
"front-console-conversation":`Diálogo`,
"label.mr.theLastGroupOfThisPage":`Este é o último conjunto de dados nesta página. Clique em [Voltar à Lista de Dados Duplicados] para ver mais dados duplicados.`,
"label.data.dataexpalltype.all_desc":`Exportar dados de todos os objetos que o usuário atual é acessado para ler.`,
"label_emailtocloudcc_redmessage7":`Erro de configuração, favor entrar em contato com o administrador.`,
"label.forecast.shrepage.classdes.all":`Acesso total - Os usuários podem visualizar e anular dados de previsão e ampliar o acesso a outros usuários através do compartilhamento.`,
"market.contacts":`Contato no mercado`,
"label.weixin.polls.voter":`Lista de Votados por`,
"template.report.industry.distribution.customers":`Distribuição da Indústria de Contas`,
"front-electronic-signature-setup":`Contrato Infor Preenchimento automático e configuração do preenchimento posterior`,
"vue_label_chatter_removecertification":`Você tem certeza de querer remover o membro "{nome}"?`,
"label.appointment.wizard.subtitle1-2":`15 min`,
"label.sso.saml.idp.config.custattr":`Atributo personalizado`,
"label_tabpage_totalTeamz":`Um total de grupos`,
"lable.outlook.detail.assigned":`Usuários Designados e Perfis`,
"label.department.user.delete":`Excluir`,
"label.customcomponent.check.label.same":`Este rótulo já existe.`,
"label.partner.error1":`Erro: o comprimento do domínio é muito longo`,
"label.escalation.setup.entrydetail.escalation.notify":`Notifique`,
"component_todaytask_label_choicestate":`Selecione o status`,
"label.customfields.fielddependency.new.step1":`<b>Passo1: </b> Selecione um campo de controle e um campo dependente. Clique em Continuar quando terminar.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Todos podem ver e solicitar a adesão a este grupo`,
"label.custom.pixel":`píxel`,
"label.quicksave":`Salvar rapidamente`,
"label.approved.persion":`Aprovador Delegado`,
"lable.info.queue.member":`Membros da fila`,
"label.addattachment.step2.weixin":`Passo 2 Clique em Upload para carregar os arquivos`,
"label.forecast.customforecast.title":`Previsões`,
"mainpage_setup_chosecomponent_leastone":`Você deve selecionar um componente pelo menos na página inicial.`,
"label.appointmentconfirmpage.wizard.title2":`Um convite de calendário foi enviado para seu e-mail.`,
"label.useallselectedapprover":`Requer que Todos os Aprovadores Selecionados <forte>Unanimemente </forte>Aprovado`,
"label.ccpeak.current.line.return":`Retorna da linha atual e não é mais executado para baixo.`,
"label_new_target_model":`Novo modelo alvo`,
"label.saving":`Salvando...`,
"label.mobile.phone.write":`Escreva para`,
"label.applt.updown.text":`Você também pode baixar o código QR de um portal de mini programa dedicado a sua empresa e colocar o código QR dentro de uma página web ou artigo público, e os clientes podem escanear o código QR para usar o mini programa.`,
"label.partner.common.manageSetup":`Configurações administrativas da nuvem de parceiros`,
"label.quickbooks.new":`Novo Cliente`,
"message.error.color":`A cor não pode estar vazia!`,
"label.project.template.two":`Pode haver apenas um conjunto de configurações sob cada tipo de registro por objeto!`,
"label.approval.input.des1":`Aprovar ou rejeitar nível por nível, e o nível máximo da hierarquia é:`,
"label.x.axis.cannot.empty":`O eixo X não pode ser nulo`,
"label.solomon.isiands.time":`Salomão é. Hora`,
"label.login.access.duedate":`Duração do acesso`,
"label.service.dispatch.booking.order":`Atribuir nomeação de serviço`,
"label_shareme_forecast":`Previsão compartilhada comigo`,
"label.custom.page.cuspage.height":`Altura(Pixels)`,
"label.quote.line.group.":`Você tem certeza de excluir o grupo de linhas de cotação do {nome do grupo}? As linhas de cotações neste grupo também serão apagadas após a operação.`,
"label.data.downpage.i_title.num6":`É recomendado importar um arquivo de teste contendo 5 registros antes de importar os dados para garantir que os dados que você deseja importar estejam corretos.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Gestão de contratos`,
"label.document.history.user":`Usuários`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Favor inserir o valor correto, até duas casas decimais.`,
"label.weixin.target.contract.jine":`Valor do contrato de destino`,
"lable.common":`￥0 no total`,
"front-kefu-moudle-sendemail-success":`O email foi enviado e o pessoal de vendas entrará em contato com você o mais rápido possível`,
"label.service.no.operation.time":`O registro atual não tem tempo de operação associado!`,
"label.info":`Informações`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Entrada de Regra Editar`,
"label.weixin.report.timeline":`Data Campo`,
"UG.quota.04":`Imprimir cotação`,
"label.social.user.exception":`Cinformação anormal do usuário social.`,
"label.import.index.failed":`Falha`,
"label.common.settings":`Configurações gerais`,
"label.nullvalue":`Valor nulo`,
"PageLayout_Search_MultiSearch_002":`Habilitar caixa de busca personalizada (Single Field Search)`,
"message.myselfreport":`Meus Relatórios Pessoais Personalizados`,
"label.productsales.today.noevttskaddtsk":`Não há eventos abertos e tarefas vencidas, você pode clicar em " " no canto superior direito para adicionar uma nova tarefa.`,
"lable.oppdt.noconditionrecrods":`Sem registros para exibir`,
"label.campaignmember.selectmember.deletelead":`Campanha: remover membros dos contatos`,
"label.marketingactivity":`Campanhas`,
"vue_label_pool_self-built":`Autoconstruído`,
"message.textareamaxlength":`O comprimento g não deve exceder 4000 caracteres`,
"label.valadate.must.value":`Deve inserir um valor`,
"label.tabpage.groupsVisiblez":`Alguns grupos de usuários são visíveis`,
"component.button.cancel":`Cancelar`,
"label.emailobject.list.inbox":`Caixa de entrada`,
"label.app.step1.error.labelexist":`ERROR: Esta etiqueta já existe ou já foi utilizada anteriormente.`,
"front-calendar-V1-Unable-to-display":`O registro não pode ser exibido no calendário para o campo final de um ou mais registros é anterior ao campo inicial.`,
"label.forecast.settings.prompt1":`Você deve selecionar pelo menos uma Medida de Previsão: Receita ou Quantidade.`,
"front-kefu-moudle-callout-missphone":`Chamadas perdidas`,
"label.tabpage.editz":`Editar`,
"vue_label_chatter_label_new_team":`Novo grupo`,
"label.version.formulafield":`Campo de Fórmula`,
"label.partner.step1":`Passo 1 selecione o modelo`,
"label.weixin.perfect.url":`Digite os detalhes do URL`,
"label.appointmentconfirmail.wizard.subtitle4":`Descrição`,
"label.step7.total7":`Passo 7 de 7`,
"setup.object.layout.label.selectedprofile":`Perfis selecionados`,
"label.payments.paytip5":`Por favor, digite o número correto de usuários!`,
"label.visualpage.open.type":`é aberto em estilo de página personalizada`,
"lable.Sort.field.tips":`Personalize a ordem de gravação na lista relacionada, selecionando os campos a serem classificados. Você pode ordenar com base em qualquer campo numérico ou de data dos objetos.`,
"label.nosharerules":`Não há regras de compartilhamento especificadas.`,
"label.service.miniProgram.bindSetOwner":`Proprietário de casos definidos`,
"report_label_highlevelreport":`Os relatórios avançados permitem criar as relações entre até 4 objetos.`,
"S":`Texto`,
"label.lastmodifyby":`Última modificação por`,
"label.customerinfo.mailaddress":`Endereço de e-mail`,
"vue_label_pool_converted":`Convertido`,
"UG.ST.004":`Você não tem a gestão de dados - "permissão de importação de dados, entre em contato com o administrador, clique em confirmar e vá diretamente para a interface {0}.`,
"label.view.application.mobile.terminal.filed":`Esta visão tem sido aplicada no aplicativo móvel. Um máximo de 10 campos estão disponíveis; são selecionados.`,
"chatter.feed.limitentity500":`Você pode acompanhar 500 colegas e registros.`,
"label.starttime":`Início`,
"chatter.emailToMe":`Lembre-me quando alguém:`,
"label.custom.Current.and.PreviousCQ":`CQ atual e CQ anterior`,
"label.my.logout":`Eu`,
"label.quickbooks.searchlist.enddate":`Data final`,
"label.ccservice.validate.length":`O comprimento do valor correspondente {2} do campo {1} sob o objeto API {0} é excedido. Por favor, reinicie-o!`,
"label.integrations.installed":`Instalado`,
"label.integrations.mailchimplist":`Lista Mailchimp`,
"label.checkfield.matchothers":`Combinar outros registros`,
"label.umeng.activity.event.distributewillbegin":`O evento #evento que você atribuiu ao #nome começa em #tempo.`,
"pool.notice.gotolightning":`Por favor, vá para o Menu Relâmpago se você quiser usar este recurso.`,
"label.batchtransfer.pleaseselecttransferreddata":`Selecione os dados que você deseja transferir`,
"label.mr.title.mailingAddress":`Endereço para correspondência`,
"vue_label_approve_no_response":`Nenhuma resposta`,
"component.event.label.title":`Próximos eventos`,
"label.mobile.setup.confirm":`Você está mudando a localização do ícone da guia padrão no aplicativo móvel. Depois que a mudança for bem sucedida, toda a configuração anterior do ícone da guia móvel será apagada, você precisa reiniciar o ícone da guia usada no aplicativo móvel. Se você não selecionar, o sistema irá selecionar aleatoriamente em seu catálogo de configuração.`,
"label.tianyancha.approvaltime":`Data de aprovação`,
"label.download_merge_file":`Download do arquivo fundido`,
"label_display_quota":`Mostrar Quota`,
"label.publishreadonly":`Somente leitura pública`,
"label.campagin.roi.query.roi":`ROI da campanha`,
"label.dashboardSetup.lookup":`Encontrar Painéis de Controle`,
"vue_label_notificationcenter_nomessages":`Nenhuma mensagem não lida`,
"label.create.object":`Criar Objeto`,
"label.social.campaign.null":`As informações do Campagin não podem estar vazias`,
"label.console.step6.left":`Fixados à esquerda e as listas são sempre visíveis.`,
"label.line":`Coluna`,
"label.bottonandlink.introduce":`Aqui está uma lista de botões e links. Adicione botões ou links, por favor edite o layout.<br/>Buttons e links podem ser adicionados à página de detalhes, lista relacionada e visualização de lista.<br/>`,
"label.layout.list1":`Lista 1`,
"label.mr.title.customerName":`Nome da conta`,
"label.user.text":`Texto`,
"label.nolastestrecord":`Nenhum último registro`,
"label.emailobject.appointment.urltext1":`Veja minha agenda e`,
"label.chat.topic.my.favorites":`Marcado`,
"label.select.dashboar.cd0":`O campo de agrupamento não pode estar vazio`,
"label.data.downpage.e_title.num2":`2. Se você optar por exportar dados de um único objeto, você precisa selecionar como os dados são exportados: exportação personalizada, exportação por modelo e modelo de exportação.`,
"message.error.user.service.login.unconn":`Rede ocupada, tente novamente ou entre em contato com o administrador.`,
"label.escalation.setup.newentries.title":`Entrada de Regra Editar`,
"label.import.step1.above2000":`Quando o gatilho é executado, um máximo de 2000 registros pode ser importado de cada vez. Favor dividi-los em vários arquivos e importá-los em lotes.`,
"label.ccchat.person.allowinvite":`Permitir que os colegas convidem`,
"label.input.number.between":`Favor inserir um número entre {0} e {1}.`,
"label.forecast.shrepage.wpfmanager":`Gerente de Previsões Delegado`,
"label_server_is_time_out":`O servidor está sem tempo. Por favor, tente novamente mais tarde.`,
"label.indochina.standard.time":`Índia Tempo Padrão`,
"label.cpq.quote.sync.opportunity.failure":`Somente a citação primária pode ser sincronizada com a oportunidade. Por favor, marque a caixa de cotação primária, depois comece a sincronizar.`,
"label.emailobject.send100emails":`Desculpe, você só pode enviar 100 e-mails por dia, por favor, selecione novamente!`,
"label.dashboard.snapshot.end":`A partir de`,
"label.jiandangfenpei.rightlist":`Perfis Atribuídos`,
"label.input.string.length.between":`Insira um fio de comprimento entre {0} e {1}.`,
"label.multilang.lookfiltercondition.select":`A condição da linha {0} está incorreta. Você deve selecionar um campo!`,
"label.datamanage.lead.namenull":`Nota: Se o nome de chumbo for nulo, o registro não será importado.`,
"label.forecast.detailforecast.button.saveandfresh":`Salvar`,
"label.venezuela.time":`Tempo Venezuela`,
"label.same.analyze.miaoshu1":`Se você precisar de mais regras, por favor use "`,
"label.twomb":`Somente o arquivo jpg/png é permitido para upload com um tamanho máximo de 2MB.`,
"label.event.moveup.7hour":`7 horas à frente`,
"label.weixin.forgot.password":`Esqueceu sua senha?`,
"label.import.page1.diledsizelimited":`2. O tamanho máximo de arquivo permitido é de 100M`,
"label.file.foldername":`Nome da pasta`,
"label.multilingual.open":`A gestão multilangiada está habilitada.`,
"label.dashboard.snapshot.refresh.failed":`Falha na atualização do painel de instrumentos`,
"label.marketsea.memberfieldselectone":`Campos de visualização e membros podem visualizar campos Por favor, selecione pelo menos um campo`,
"label.trigger.createdate":`Data de criação`,
"label.ccpeak.operation.sharetab":`Operar no formulário de compartilhamento:`,
"label.partner.message.admin.access":`Somente administradores podem fazer o log in`,
"label.emailsync.status.email":`E-mail com ação executada`,
"chatter.error":`Erro:Por favor, selecione um arquivo para carregar!`,
"label.role.viewinlist":`Mostrar em vista de lista`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Os usuários podem criar vários tipos de campos em todos os objetos do sistema CloudCC sem nenhum conhecimento de programação ou desenvolvimento de código. Os tipos de campos incluem: relação de busca, campo de seleção única, seleção de itens duplos, fórmula, numeração automática. Os tipos de campo incluem: URL, telefone, fax, e-mail, caixa de seleção, data, hora, número, texto, área de texto, lista de opções (seleção simples/múltipla), moeda, etc.`,
"label.delete.rule.successfully":`Eliminar as regras com sucesso`,
"label.field.duplicate.error.msg6":`Valor do campo duplicado. O valor sai em registro:`,
"label.stdashbord.xsld.business.jhzsl":`Oportunidades totais (Quantidade)`,
"label.compact.layout":`Layout das informações-chave`,
"label.checkfield.merge.introduce":`Selecione o valor que você deseja manter no registro fundido.`,
"earlieststarttime.duedate.time.illegal":`A hora real de início da nomeação do serviço deve ser menor ou igual ao tempo real de término.`,
"label.dataimport.validate.prompt":`Pronta Regra de Validação`,
"message.setuptip":`Você pode apagar os pacotes que criou.`,
"template.report.customer.collection.statistics":`Estatísticas de pagamento de contas`,
"vue_label_homepage_dashboardcomponents":`Editar componentes do painel de instrumentos`,
"setup.mainpage.label.welcome30":`A plataforma CloudCC é uma verdadeira plataforma de computação em nuvem. Os atributos abertos da plataforma, métodos de integração padrão e personalização flexível são aplicáveis a todas as indústrias, integrando software de terceiros, realizando a unificação em tempo real dos dados de gerenciamento empresarial e maximizando as necessidades de gerenciamento abrangente e profundo de nossos clientes. A plataforma CloudCC pode ser integrada com qualquer aplicativo ou sistema empresarial, incluindo software de terceiros, como SAP, Kingdee e UF. O método padrão de Web Service sob a arquitetura SOA flexível não tem nenhuma dependência destrutiva, técnica ou de fornecedores bloqueados.`,
"label.SMS.new.det":`Criar uma notificação por SMS para associar uma ou mais regras de fluxo de trabalho, processos de aprovação. Se a notificação por SMS for alterada, qualquer alteração será aplicada a todas as regras e aprovações associadas a ela.`,
"lable.product.page.previous":`Voltar para Anterior`,
"label.recordtype.labelname":`Rótulo do tipo de registro`,
"message.error.system.service.failure":`A execução do serviço falhou, favor contatar o administrador.`,
"label.visualpagefolder":`Pastas de página`,
"label.username":`Nome de usuário`,
"label.data.downpage.i.title.num5":`5、Please verificar a exatidão dos dados.`,
"label.permission.manage":`Gerenciar tarefas`,
"label_emailsync_status_user":`Usuários`,
"label.weixin.voting.least.two":`Há pelo menos duas opções de votação.`,
"label.tabpage.thisrecord":`Este registro`,
"label.icon.119":`Quadro negro`,
"label.partner.common.webSit":`Domínio`,
"label.email.form.html2":`[mudar para somente texto].`,
"label.appupload.upload.noversion":`Sem versões carregadas`,
"label.appointmentpage.wizard.subtitle1_2":`O Fuso Horário do Inviter é {0}`,
"MR":`Relação de Busca (Multi-Select)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Saldo disponível`,
"label.schedulejob.setup.schedule.st3":`A 3a.`,
"label.reportsSubscriptionPage.email.general":`Geral`,
"label.setsharerule.step4":`Passo 4 Selecione o nível de acesso para os usuários`,
"front-epwechat-module-v1-info-desc":`Por favor, obtenha informações do backend da WeCom e preencha aqui`,
"message.duplication.label.isactive":`Ativo`,
"pagecreator_systemstyle_label_linkcolor":`Cor do link`,
"label.import.page1.alertfiledsize":`Os arquivos carregados não devem exceder 100MB!`,
"tomorrow":`Amanhã`,
"label.publicdashboard":`Painéis de Painel Público não arquivados`,
"label.knowledgebase.same.taborworkspace":`A mesma aba ou espaço de trabalho`,
"homepage.layout":`Layouts da página inicial`,
"label.emailobject.trackemailopening":`Rastrear a abertura do e-mail`,
"label.unlock.tip":`Desbloquear os registros para edição`,
"lable.account.NextzDays":`Próximos 90 dias`,
"vue_label_report_throw":`Descartar`,
"label.icon.102":`Horário`,
"label.payments.paytip2":`Você atualizou para nossa edição paga, clique em Confirmar para fechar a janela e atualizar seu sistema de CRM.`,
"label.customfields.email.tip":`Permite que os usuários digitem um endereço de e-mail, que é validado para garantir um formato adequado. Se este campo for especificado para um contato ou lead, os usuários podem escolher o endereço ao clicar em Enviar um e-mail. Note que endereços de e-mail personalizados não podem ser usados para e-mails em massa.`,
"label.test_visitors":`Teste como seu formulário deve ficar quando visto pelos visitantes.`,
"label.workflow.immediatelyoperate":`Ações de Fluxo de Trabalho Imediatas`,
"label.approvalstep4.tip":`A página de aprovação é onde o aprovador realmente aprova ou rejeita o pedido. use as seguintes opções para selecionar os campos a serem exibidos nesta página.`,
"label.ccchat.person.invite.failsend":`O seguinte convite não foi enviado. favor entrar em contato com o administrador.`,
"label.import.index.obj":`Objeto`,
"label.multilang.leadscore.countnum":`{0} vezes:`,
"label.report.error.typefind":`Nenhum tipo de relatório encontrado por agrupamento de informações`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTO(texto, antigo_texto, novo_texto)`,
"label_tabpage_unpacketz":`Não há dados de agrupamento disponíveis!`,
"lable.Create.new.template":`Novo modelo de relatório de serviço`,
"label.knowledgebase.display.error":`Mostrar {a} Erros`,
"label.emailobject.template.message2":`O campo inserido no e-mail atual não corresponde ao registro associado, o que pode causar valores nulos.`,
"label.productsales.today.taskcomplete":`Preparado para ser concluído`,
"label.emailobject.selectone":`Por favor, selecione pelo menos um registro como destinatário do e-mail`,
"button_partner_workspace_saveas_memo":`Salvar a nuvem de parceiros atual como um "modelo".`,
"vue_label_help_detail":`Detalhes do Registro`,
"label.tabpage.minutesagoz":`Ata`,
"label_tabpage_characterz":`Caráter inicial`,
"message.error.accesstoken.null":`O Token não pode estar vazio!`,
"label.textMessageObject.send100":`Desculpe, você só pode enviar 100 mensagens de texto por dia, por favor, selecione novamente!`,
"vue_label_commonobjects_detail_record_call":`Registrar uma chamada`,
"label.campaignmember.main.addlead":`Adicionar Leads Existentes de Membros`,
"setup_mainpage_label_welcome30":`A plataforma CloudCC é uma verdadeira plataforma de computação em nuvem. Os atributos abertos da plataforma, métodos de integração padrão e personalização flexível são aplicáveis a todas as indústrias, integrando software de terceiros, realizando a unificação em tempo real dos dados de gerenciamento empresarial e maximizando as necessidades de gerenciamento abrangente e profundo de nossos clientes. A plataforma CloudCC pode ser integrada com qualquer aplicativo ou sistema empresarial, incluindo software de terceiros, como SAP, Kingdee e UF. O método padrão de Web Service sob a arquitetura SOA flexível não tem nenhuma dependência destrutiva, técnica ou de fornecedores bloqueados.`,
"label.file.library.deleteprompt":`Remover {0} da Biblioteca de Ativos ?`,
"label.wtd.changefields.title":`Configuração da Web para CloudCC`,
"label.sendmail.step1":`Passo 1 Especifique os destinatários para incluir`,
"label.cpq.newquote.createorder.checkbox.selected":`A caixa de seleção de Criar Ordem não pode ser selecionada durante a criação de uma nova cotação.`,
"label.emailtocloudcc.name":`Nome`,
"message.error.object.nullbinding":`a encadernação está vazia`,
"B":`Caixa de seleção`,
"label.pc.endtime":`Sua licença expirará em menos de 30 dias. favor renovar a tempo para garantir o uso contínuo.`,
"label.visualpage.section.start":`Use a etiqueta no início`,
"label.partnerCloud.basicSetting.available":`O nome de domínio está disponível.`,
"label.data.exportall.all_desc":`Exporta todos os dados para todos os objetos que o usuário atual tem permissão para visualizar.`,
"label.editor.layout":`Editar layout de busca`,
"label.send.chatter":`Enviar tagarelice`,
"label.h5.chatter.reply":`A resposta rápida`,
"component_chatter_post_button_file":`Acrescentar anexos`,
"label.emailobject.emaildetail.button.reply":`Resposta`,
"label.eidt.queue.title.desc":`O nome deve ser único, e o nome deve mendigar com uma carta. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado. Não deve ter mais de 40 caracteres.`,
"label.campaign.channel.input.url":`5.configurar as informações que os usuários verão após a inscrição, que podem ser uma página de agradecimento, um folheto ou um bilhete:`,
"label.compact.layout.assign.tip":`Esta tabela mostra as principais atribuições de layout de informações para diferentes tipos de registros.`,
"vue_label_fall":`Descer`,
"label.trigger.save.failed":`Salvo falha, os dados não podem ser nulos`,
"label.appupload.upload.tips.report":`NOTA: Os relatórios e relatórios antigos em "Meus relatórios personalizados" e "Relatórios públicos não arquivados" não podem ser adicionados aos pacotes e não serão exibidos nesta pasta".`,
"label.tianyancha.businessverify.rewriteall":`Preencher todos os dados`,
"label.campaign.channel.step6.remark4":`Observe que, o proprietário principal pode ser o proprietário da campanha atual ou a pessoa de solicitação do canal de marketing atual.`,
"front-kefu-moudle-called-num":`Número discado`,
"label.approvalstep4":`Passo 4 Selecione os campos a serem exibidos no layout da página de aprovação`,
"label.login.verification.please.scan":`Por favor, digitalize o código usando o aplicativo MFA em seu smartphone`,
"label.invoice.message.statusupdated":`Status da fatura atualizada`,
"label.pc.ui.2018.subject":`Tema`,
"label.area.notexist.userinfo":`O Grupo de Usuários não existe.`,
"label.newuser":`Novo Usuário`,
"label.chat.micropost.share":`Compartilhar o posto`,
"label.locatedupcurrentvalue":`O valor acima do atual`,
"vue_label_systemSettings_course":`Configuração do trajeto do relâmpago`,
"chatter.group.public":`Público`,
"label.reportsSubscription.entrance":`Assine`,
"front-kefu-moudle-v1-online-at":`Agente online`,
"label.rejectbehaviourselect":`Executar <forte>somente forte</forte> a rejeição desta etapa e enviar o pedido de aprovação de volta para o aprovador mais recente. (Voltar para a etapa anterior)`,
"vue_label_commonobjects_view_currentviewset":`Para cancelar a configuração da visualização padrão atual, você pode definir outra visualização como a visualização padrão.`,
"lable.currencyAdv.and":`e`,
"label.appexchange.installedpage.publish":`Publicado por`,
"label.tab.profile.ismobile":`Aplicar para aplicativo móvel`,
"label.data.setok.t.desc2":`Voltar à página de modelo de dados`,
"label.email_required":`O email é obrigatório.`,
"label.tabpage.fullscreenz":`Tela cheia`,
"chatter.sticker.set":`Rastreamento de alimentação`,
"label.mobile.phone.year":`ano`,
"label.projectManagement.next.page.before":`Página anterior`,
"pagecreator_button_pcpage":`Pc final`,
"label.dashboard.xsld.percent":`Porcentagem`,
"label.ccpeak.service.checkerror":`Falha na verificação da sintaxe.`,
"label.icon.26":`Folder`,
"label_partner_common_webSit_memo":`Nome de domínio padrão:`,
"label.unselectfile":`Nenhum arquivo selecionado`,
"label.take.notice":`Aviso`,
"message.error.filename.null":`fileName não pode estar vazio!`,
"vue_label_SMS_nophone":`Sem número de telefone`,
"label.area.assignuser":`Atribuir usuários`,
"label.icon.176":`Pronto`,
"label.icon.21":`Moeda`,
"message.error.system.service.deletedeny":`O Dada é associado e não pode ser excluído.`,
"label.compact.layout.main.tip":`Selecione o layout das informações-chave para usar quando este registro aparecer como um item de lista no CloudCC.`,
"label.emailtocloudcc.delete":`Excluir`,
"label.dashboardSetup.showdw.d2":`10 Milhões`,
"front-kefu-moudle-hqyyjlsb-admin":`Falha na gravação de voz, favor contatar o administrador para obter ajuda`,
"label.partnerCloud.basicSetting.userCounts":`Total de papéis do parceiro`,
"front-kefu-moudle-calling-num":`Número de chamada`,
"label.alldocument":`Todos os documentos`,
"coderules.nullvalue1":`Falha na geração. Favor inserir o valor para 【{0}】 usado nas regras de geração.`,
"lable.automatically.shared":`Compartilhado automaticamente`,
"label.batchadd.newbatchpage.save.emptyselect":`Favor verificar se há opções necessárias não selecionadas.`,
"vue_label_homepage_card_30dayswithout":`Oportunidades não contatadas por 30 dias`,
"label.multilang.dupicatecheck.onegroupnote":`Favor escolher pelo menos dois dados, clique no botão [Load selected information] para entrar na página de combinação de dados. Atualmente no grupo de dados {0}--existindo um total de {1}records..:`,
"UG.activity.03":`Reserve um horário`,
"label.pc.oldpage":`Página antiga`,
"label.exchange.sync.state.task.m2":`Os registros foram sincronizados nos últimos 60 minutos:`,
"label.setmovable":`Configurações de atividades`,
"label.sendemail.send.loginfail":`Falha no login na caixa postal, por favor reinicialize suas informações de e-mail.`,
"label.copy.quote.lines":`Linha de citação clone`,
"label.copying.reward.to.groups":`Cópia para grupos de linhas de citação`,
"label.ems.connect.error":`Falha na conexão do servidor, favor verificar.`,
"lable.account.Tomorrow":`Amanhã`,
"label.manageAll.sta2":`Aprovado`,
"label.create_form":`Novo formulário`,
"label.ems.saveDetail.error.msg":`Salvar falha.favor verificar conta e senha da caixa postal`,
"label.service.gantt.distribution.recommendation":`Atribuição Sugerida`,
"label.email.track.attachment.size.control2":`O tamanho do arquivo carregado excede 10m,e não pode ser carregado`,
"lable.product.pricebooks.add":`Acrescentar ao Livro de Preços`,
"label.login.time":`Tempo de Login`,
"label.tabpage.yes1z":`Sim1`,
"label.SalesCommitmentKanBan":`Painéis de Compromisso de Vendas`,
"label_partner_workspace_myspace":`Meu espaço de trabalho`,
"chatter.like":`como(s) recebido(s)`,
"lable.PowerProcess.number.input":`Por favor, digite um número inteiro.`,
"chatter.coll":`Favoritos`,
"label.campaign.channel.img.remark":`Observação: O tamanho da imagem não deve exceder 2M`,
"label.field.duplicate.error.msg7":`Dados duplicados`,
"vue_label_pool_discard":`Descartar`,
"label.service.gantt.total.planned.duration":`Soma da duração planejada para as nomeações de serviço`,
"label.weixin.click.loadmore":`Clique para carregar mais`,
"label.help.new.features.yd":`Novo guia de operação da interface móvel`,
"label":`Etiqueta`,
"label.quickbooks.viewlist.total1":`Existem {0} faturas de um valor total de {1}`,
"front-kefu-moudle-v1-input-publicKey":`Por favor, digite a chave compartilhada`,
"label.approval.allowed.reject":`Recusa permitida`,
"label.visualpage.folder.notdel":`Você não pode apagar esta pasta, porque alguns arquivos nela contidos.`,
"label.projectManagement.charging":`Carregamento`,
"label.ccservice.validate":`O formato do valor correspondente {2} do campo {1} sob o objeto API {0} está incorreto. Por favor, digite o número correto!`,
"message.unbind.mfadevice.no.permission":`Você não tem perimersão para destravar os dispositivos AMF. Por favor, entre em contato com seu administrador.`,
"label.partner.new.step3.meno":`Não tem certeza do que entrar? não se preocupe, você pode mudá-lo mais tarde a qualquer momento.`,
"label.import.page3.importsucceedtip":`Comece a importar com sucesso. Após a importação, um e-mail será enviado para sua caixa postal associada`,
"label.customsetting.visible.protect":`Protegido`,
"label.publishreadandwrite":`Leitura/escrita pública`,
"vue_label_file_add_most_once":`Adicionar no máximo uma vez`,
"label.salescloud.teamrole.optionlist.group":`Atribuir funções aos membros da equipe de oportunidade e aos membros da equipe de conta.`,
"label.appointment.wizard.subtitle7":`Localização`,
"label.task.dateminus":`Menos`,
"label.data.exp.zippwd":`Digite manualmente a senha do arquivo compactado`,
"UG_Forcast_09":`Próximo passo`,
"message.duplication.label.allselectlink":`[Selecionar todos]`,
"label.file.ccchat.selectfromcloudcc":`Selecione um arquivo do CloudCC`,
"label.ems.addaccount3":`Adicionar conta`,
"front-epwechat-module-v1-schedule-sync":`Horários de Sincronização`,
"label.h5.manage":`Gerenciar aplicações`,
"setup.layout.label.nobutton":`Sem botões disponíveis`,
"label_component_hotdeal":`Negócios quentes`,
"template.dashboard.contract.analysis":`Análise de Contratos e Contas a Receber`,
"vue_label_dashboard_editcomponent":`Componente de edição`,
"label.quotationInformation":`Informações sobre a citação`,
"label.data.file.validation_rules":`Executar Regras de Validação`,
"label.ccpeak.construction.shareobj":`Para construir uma forma de compartilhamento objeto de um objeto, você deve passar no nome da API e na marca de compartilhamento.`,
"label.wei.pollinformation":`Detalhes da Micro Votação`,
"label.quickbooks.viewlist.total3":`Há {0} pagamentos para um valor total de {1}`,
"label.paging.totalofpagesnoid":`Um total de {0} páginas`,
"label.unlock":`Desbloquear`,
"front-invoice-online-payment-information":`Informações sobre a fatura`,
"label.permission.systempermission":`Permissões do Sistema Atribuídas`,
"message.error.object":`Ao chamar um serviço, descobre-se que o objeto não está definido.`,
"font-trade-module-v1-invoice-intro":`Favor inserir o número da fatura ou o nome da fatura`,
"label.userinfo.pwdexpired":`A senha atual expirou. Por razões de segurança, você deve mudar sua senha agora.`,
"label.userphoto.photo":`Foto`,
"label.tabularreport.filterrecord":`Selecione os critérios de tge para determinar quais registros devem ser exibidos`,
"label.partnerCloud.orderingPlatform.rechargeIt":`O saldo de sua conta não é suficiente, por favor, reabasteçaa.`,
"label.icon.120":`Computador`,
"label.projectManagement.select.new.type":`Selecione o tipo de criação`,
"vue_label_commonobjects_detail_customer_details":`Carregamento dos detalhes do cliente`,
"label.ems.status":`Status`,
"label.validate.function.description":`Qualquer função que esteja em conformidade com a sintaxe java pode ser usada na regra de validação, e a expressão precisa retornar um valor booleano.<br>Você também pode usar uma função específica fornecida pelo CloudCC.
Por exemplo, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() retorna um objeto, ele precisa ser convertido para o tipo de campo correspondente.`,
"label.escalation.setup.newaction.step2":`Etapa 2 Selecione o usuário para auto-reatribuir os casos`,
"label.forecast.customforecast.searchforecast":`Encontre a previsão`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`O limite superior de cada nível deve ser maior do que o limite inferior ao fixar os preços por blocos.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Não apagar dados com id de registro {0}，failed razão: {1};`,
"page.field.masterinput.remark":`A Entrada Master-Detail ativada é usada para criar registros de lista relacionados na página de registro.`,
"lable.SalesCommitmentKanBan.contractName":`Nome do contrato`,
"front-gantt-module-add-milestone":`Adicionar marco miliário`,
"label.callcenter.save.error":`Por favor, não salve novamente`,
"label.workflow.selectobj":`Passo 1 Selecionar objeto`,
"label.validate.function.category.all":`-- Todas as categorias de funções...`,
"label.multilang.uploadifupage.select":`Você escolheu totalmente os arquivos {0}:`,
"label.weixin.dragsort":`Arraste os ícones em My Apps para classificá-los.`,
"N":`Número`,
"label.knowledge.article.translation.completed":`Tradução do artigo concluída`,
"label.weixin.myapp":`Meus aplicativos`,
"label.icon.138":`Moeda`,
"vue_label_chat_create_discussion_now":`Criar discussão agora`,
"label.knowledge.recover.article":`Restaurar artigo`,
"label.ccpeak.use.class.time.map":`Acesso por Passagem na Coleção de Mapas`,
"front-email-payment-error-tips":`Erro de interface`,
"label.service.gantt.ziyuan":`Somente para`,
"label.upload.error":`Falha`,
"label.staticresource.upload.error":`Erro no carregamento de recursos estáticos!`,
"com.cloudcc.login.error.message.loginfail":`A operação falhou, favor contatar a administração`,
"pagecreator_button_back":`Último Passo`,
"label_tabpage_skip":`Pular para`,
"label.pw.old":`Por favor, digite a senha antiga`,
"pagecreator.layout.label.modifylayout":`Editor de layout`,
"vue_label_chatter_share_group":`Compartilhe com o grupo`,
"label.app.edit":`Edição do aplicativo`,
"label.user.Email.repeat":`Duplicado por email. Este usuário não é suportado para encadernação com agente`,
"label.field.quilt":`Este campo é`,
"label.projectManagement.Groupuser":`Agrupamento por usuários`,
"label.deleteall":`Apagar tudo`,
"label.appexchange.download.tiaoguo.mes":`Ignorar a instalação dos seguintes componentes conflitantes:`,
"label.sendemail.recycle.operatehello":`#username hello:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`Você pode selecionar até 20 modelos!`,
"label.campaignmember.main.deleteleaddesc":`Retirar em massa todas as pistas desta campanha`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Dias no Estágio Atual`,
"vue_label_file_no_title":`Sem título`,
"label.data.dataexpalltype.all.desc":`Exportar dados de todos os objetos que o usuário atual é acessado para ler.`,
"label.dashboard.unit2":`Unidade: milhões`,
"label.list.userinterface.isrelatedlist":`Habilitar links da lista relacionada Hover Links`,
"label.role.tree":`Hierarquia de papel de sua organização`,
"label.campagin.roi.zcsl":`Matrícula`,
"message.error.forecast.setupchange":`Os dados que você tentou acessar puderam ser encontrados no bot. Eles poderiam ser apagados por outros usuários ou alterados.`,
"label.sendemail.changeowner.dataname":`O nome do documento é: arquivo #dataname`,
"label.salescloud.opportunity.contactrole.optionlist":`Oportunidade Contato Papéis de contato Valores da lista de picking`,
"setup_mainpage_label_welcome1":`Necessidade de permissão correspondente`,
"UG_activity_02":`Atribuir tarefas`,
"label.tabpage.erraddressz":`Formato incorreto do endereço de e-mail, favor digitar o endereço de e-mail corretamente`,
"label.weixin.nicheng":`WeChat Apelido`,
"label.forecast.settings.mrsz":`Medição Prevista`,
"label.campaign.channel.download.size3":`Tamanho pequeno: 300*300 pixels`,
"label.icon.73":`Máquina-ferramenta`,
"label.ServiceCloud.suoxuchanpin":`Produtos Necessários`,
"label.escalation.setup.newrule.description":`Digite o nome da regra e ative-a. A ativação desta regra irá desativar a regra de escalonamento do caso atual. Para desativar o escalonamento automático de casos, desative todas as regras de escalonamento de casos.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC ID`,
"label.validate.function.funcExplain.PRIORVALUE":`Retorna o tipo de objeto, o tipo de campo correspondente precisa ser convertido.`,
"Lead.Scoring.Warning.001":`Marcar um único registro de chumbo automaticamente ao criar ou editar. Mas você precisa pontuar manualmente vários registros de chumbo, ao importar ou criar por interface.`,
"label.tianyancha.businessverify.msg9":`O poder de interpretação deste acordo será investido na beijing shenzhou yundong science and technology co., ltd.`,
"label.compact.layout.tip":`O layout das informações chave é usado para exibir o campo chave dos detalhes do registro na página de detalhes.`,
"label.visualpage.btype":`Relatórios`,
"label.textmessage.vonage.settings":`Configurações`,
"label.field.not.exites":`não existe`,
"label.payment.switch.version":`Mudando para a nova edição`,
"label.ems.hour":`Hora`,
"label.weixin.cannot.edit":`O tipo de arquivo não pode ser editado`,
"chatter.pt.limit":`O tamanho máximo do arquivo é`,
"label.quote.detailinfo.add":`Adicionar itens de linha de cotação`,
"component.setup.label.displayfield":`Campo de exibição`,
"vue_label_report_reportfolder":`Pasta de relatório`,
"label.gbkencoding":`Chinês (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transferência para {TransferName}`,
"label.file.stop.sharing.desc2":`Compartilhando`,
"label.textmessage.messageCannoutuse":`Unavalible,favor entrar em contato com o Administrador para ativar as Mensagens de Texto.`,
"component_newrecords_label_type":`Tipo de armazenamento`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Novo Livro de Preços`,
"vue_label_newfile":`Novo arquivo`,
"label.reportTypcrtB":`Objeto associado (b) favor clicar para selecionar o objeto relacionado`,
"label.knowledgebase.type":`Categoria`,
"label.report.select.format":`Selecione o formato do relatório`,
"component.todaytask.label.title":`Hoje`,
"message.undelete":`Você tem certeza de que quer cancelar a exclusão?`,
"label.ccdocument.trace.retention":`Função de Retenção de Traços`,
"label.publicgroup.tip":`Um grupo público é um conjunto de usuários. Pode conter usuários individuais, outros grupos, os usuários em uma determinada função ou território, ou os usuários em uma função ou território mais todos os usuários abaixo dessa função ou território na hierarquia.`,
"label.forecast.settings.lable2":`Configurar a exibição da Previsão Padrão`,
"label.projectManagement.positive.integer":`Favor inserir um número inteiro positivo dentro de 0-24.`,
"label.projectManagement.one.work.list":`Por favor, preencha pelo menos uma lista de trabalho!`,
"label.or":`|Or`,
"label.projectManagement.no.person.in.charge":`Sem Supervisor`,
"vue_label_commonobjects_detail_an_email":`um email`,
"front-electronic-signature-field-mapping":`Adicionar Mapeamento de Campo`,
"label.marketsea.name.error":`O nome do pool de chumbo não pode estar vazio`,
"component.setup.button.appurl":`Sistema URL`,
"label.mr.title.button.group1":`O`,
"chatter.contact":`Contato`,
"vue_label_pool_hasfixed":`canais fixos de cooperação`,
"lable.list.queue.des":`Uma fila é um local onde os registros podem ser roteados para aguardar o processamento por um membro do grupo. Os registros permanecem na fila até que um usuário os aceite para a proeza ou até que sejam tran transferidos para outra fila. É possível especificar o conjunto de objetos que são suportados por cada fila, assim como o conjunto de usuários que têm permissão para recuperar registros da fila.`,
"label.reportsSubscriptionPage.condition":`Condições`,
"label.transwork":`Banco de Trabalho de Tradução`,
"label.batch.batchopration.resel":`Por favor, selecione novamente os dados que você deseja transferir e clique em "OK" para saltar para a página da lista de visualização.`,
"label.cloudccsite.new":`Novo site`,
"label.button.select.page.required.field":`Selecione os campos necessários para incluir em sua página:`,
"label.pagelayout":`Layouts de página`,
"label.weixin.trace.record":`Registros de Rastreamento`,
"label.emailtocloudcc.clear":`Limpar`,
"label.checkfield.find":`Encontrar duplicatas`,
"message.view.count.title0":`Resumo da página atual`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Freqüência`,
"setup.mainpage.label.welcome5":`Campo personalizado`,
"label.implementation.details":`Executar detalhes`,
"label.attendance.history":`Histórico de atendimento`,
"label.is.pigeonhole":`Arquivo`,
"lable.account.CurrentandPreviousFYt":`Atual e Anterior 2 FY`,
"label.forecast.customforecast.tab.opportunity":`Oportunidades`,
"label.version.business.track":`Rastreamento de Oportunidades`,
"label.profilelayoutedit.selectrecordtype.tip":`Selecione o tipo de registro para este perfil de usuários. Você precisa adicionar o campo de tipo de registro ao layout da página associado a este perfil para que ele possa ser exibido nas páginas de detalhes e nas páginas de edição.`,
"label.campagin.roi.zclzb":`Taxa de inscrição`,
"label.validate.function.funcFormat.WEEKDAY":`SEMANA(data)`,
"label.view.sort.message":`Ordenado por {!sort}`,
"page.field.masterinput.sort":`As entradas Master-Detail são exibidas na ordem em que são salvas.`,
"label.selected.field":`Campos de busca selecionados`,
"label.product.proofTwo":`Em {0}, favor escolher pelo menos {1} opções de produtos.`,
"vue_label_report_filtercondition":`Condição do filtro`,
"label.forecast.shrepage.desc1":`Esta página lista os usuários, funções e territórios que têm acesso compartilhado a`,
"label.file.copy.link":`Copiar link`,
"vue_label_chat_movedto":`{nome} movido {label} para {novo campo}`,
"label.layout.new.built":`Nova seção`,
"label_tabpage_crecordtypez":`Mudança de tipo de registro`,
"label.report.searchcustominfo":`Digite as palavras-chave para encontrar relatórios personalizados correspondentes`,
"chatter.feed.menutype.user":`Colegas`,
"label.recordtypeselect":`Selecione o tipo de registro`,
"label.partner.new.step3":`Passo 3 Digite o nome e a url`,
"label.newCustomReportType":`Nova fonte de dados de relatórios personalizados`,
"label.service.gantt.day.timescale":`Escala de tempo na visão do dia:`,
"label.displaytype3":`Botão Listar`,
"label.weixin.discharge.rate":`Volume de exaustão`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`A máscara exibe todos os caracteres`,
"label.quickbooks.fieldlabel.billingaddress":`Endereço para faturamento`,
"Dashboard.View.All":`Todos os Dashboards`,
"setup_mainpage_label_welcome22":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Newsletter Template → Email Template.`,
"chatter.group.groupInformation":`Informações sobre o grupo`,
"front-epwechat-module-v1-input-secret":`Por favor, digite o segredo`,
"lable.Set.value.prompt":`Ou, registros de filtro exibidos na lista relacionada. Escolha a caixa de seleção, ou os campos da lista de seleção e os valores que você gostaria de filtrar. Se entrar os valores manualmente, separe por favor com vírgulas.`,
"label.appupload.upload.from":`Por`,
"label.weixin.postunsolve":`Vencido`,
"label.cooperation.all":`Toda a cooperação`,
"lable.PowerProcess.close.time":`Com base no horário de fechamento do {detalheInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Por favor, selecione pelo menos um campo.`,
"label.emailtocloudcc.help":`Por favor, digite a senha correta do e-mail ou o código de autorização. Se seu servidor de e-mail precisar ligar o serviço IMAP/SMTP para fazer o login por uma conta de terceiros, você deve entrar nas configurações da conta de e-mail para ativar o serviço primeiro, e copiar o código de autorização aprovado para esta caixa de entrada de senha.`,
"label.attendance.offwork.time":`Fim do dia`,
"front-gantt-module-v1-project-gantt":`Gráfico de Gantt do Projeto`,
"label.chuangming.description":`Configure as informações do Chuangming para atender às necessidades dos serviços de envio e recebimento de SMS de sua organização.`,
"label.custom.lead.notice.account.name":`Há uma pista que, convertida, especifica que você é o proprietário da conta, contato e oportunidade. Nome da conta:`,
"label.emailobject.failedtosend1":`O envio falhou: A autenticação do e-mail é inválida, por favor reconnect！`,
"vue_label_ccchat_notice_updaterecordsuccess":`Este registro foi atualizado`,
"label.dayinmonth":`Meses".`,
"label.sendemail.chat.follow":`Prezado #nome:{\i1}olá! #userName:{\i1}nome do usuário segue você.`,
"label.emailsync.form.emialpassword":`Senha`,
"component_task_label_subject":`Tema`,
"label.projectManagement.please.enter.a.positive.integer":`Por favor, insira um número inteiro positivo.`,
"lable.account.NexteDays":`Próximos 7 dias`,
"label.appupload.upload.managed":`Pode ser criado, no máximo, um pacote controlado!`,
"label.data.dataexpalltype.all.desc1":`O 1、You pode empurrar para gerar automaticamente e inserir manualmente a senha do arquivo das compressas exportadas. A senha gerada automaticamente será enviada para a caixa postal dos usuários quando os dados forem exportados com sucesso. A senha inserida manualmente não será enviada para a caixa de correio, portanto os usuários precisam se lembrar da senha inserida. Caso não tenha sido inserida, a senha não será inserida por padrão.`,
"label.step1.total3":`Etapa 1 de 3`,
"label.escalation.setup.detail.section":`Detalhe da Regra`,
"front-gantt-module-drag-task-sorting":`Arraste as tarefas para o pedido`,
"label.isEnableVisualpage.new.title":`Habilitar acesso à página personalizada`,
"label_tabpage_yesz":`Sim`,
"label.emailobject.emaildetail.button.replyall":`Responder todos`,
"label.knowledge.setting.data.one":`Isto não pode acrescentar mais subcategoria.`,
"label.manageAll.sel.one3":`Itens I Aprovados`,
"UG_contact_01":`Como tirar o máximo proveito de seus contatos?`,
"font-trade-module-v1-invoice-name":`Nome da fatura`,
"label.central.daylight.time":`Hora central de luz do dia`,
"label.chatter.pastThirtyday":`Os últimos 30 dias`,
"vue_label_commonobjects_detail_activity_ownevent":`Evento disponível`,
"label.user.modify":`Edição do usuário`,
"label.uploadTemplate":`Carregar modelo`,
"setup_mainpage_label_welcome14":`Gestão do processo de personalização do fluxo de trabalho, aprovação`,
"label.workmate":`Colegas`,
"label.displaycolumns":`Colunas de exibição`,
"label.emailnoticeintro":`Os alertas por e-mail são os e-mails que as regras de fluxo de trabalho enviam quando acionados.`,
"label.knowledge.category.button.five":`Eliminar categoria`,
"template.report.business.opportunities.type":`Oportunidades por tipos`,
"vue_labenl_applauncher_moreapp":`Mais aplicativos`,
"label.captcha.expired":`O código de verificação está expirado, favor verificar novamente.`,
"template.chart.bnqzkhslmb":`Número Alvo de Leads para o Ano`,
"chatter.up.user.pic":`Carregar foto do usuário`,
"label.timezone.importtimezone.gmt":`Use o fuso horário gmt`,
"label.step.type":`Selecione o tipo de membro que você deseja pesquisar`,
"Dashboard.View.RecentlyView":`Visto recentemente`,
"label.reportinthisfolder":`Relatórios neste dossiê`,
"label.product.vies":`Vistas de produtos`,
"pagecreator_systemstyle_message_delete_fail":`A eliminação do estilo falhou`,
"label.multipleactivity.singleUser":`Usuário único`,
"vue_label_email_enter_subject":`Entrar assunto`,
"label_tabpage_alltabs":`Todas as abas`,
"label.publicgroup.groupname":`Nome do grupo`,
"template.report.sales.performance":`Desempenho dos vendedores`,
"label.newWindow":`Nova Janela`,
"label.forecast.editopp.forecastedit":`Previsão Editar`,
"label.data.import.setup.whichfield":`Qual campo você gostaria de usar para correspondência?`,
"label.noadd_dashboard":`Não adicionar ao painel de instrumentos`,
"label.subtotal":`Subtotal`,
"front-email-payment-weichat":`Por favor, use o WeChat "Scan".`,
"label.attendance.position.alert":`Por favor, selecione primeiro a máscara`,
"chatter.follow.me":`Siga-me`,
"label.mobile.more.details":`Editar detalhe do arquivo`,
"Dashboard_SelectBoardToDisplay":`Favor selecionar os painéis que você deseja mostrar na página de tabulação dashborad`,
"front-gantt-module-v1-search-project":`Pesquise seu projeto...`,
"label.paging.totalofpagereport":`Um total de {0} páginas({1})`,
"label.from.phone":`De`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Canais de Marketing ROI`,
"label.tabpage.selectcontentz":`Favor selecionar o conteúdo`,
"label.multilang.lookfiltercondition.valuetypenotmate":`A condição da linha {0} está incorreta, o tipo de valor não corresponde!`,
"label.interfaceconstraint.disabled":`A interface foi desativada, favor entrar em contato com o administrador de seu sistema.`,
"third":`O Terceiro`,
"label.quickbooks.viewlist.status":`ESTATUTO`,
"label.emailtocloudcc.select3":`Por favor, selecione o proprietário do registro`,
"label.projectManagement.week.work":`Meu trabalho para esta semana`,
"vue_label_pool_nodemand":`Nenhuma demanda`,
"label.version.two.developapi":`API de Desenvolvimento Secundário`,
"label.icon.82":`Impressora`,
"label.batchadd.newbatchpage.suclist":`dados da(s) peça(s) adicionados com sucesso`,
"label.checkfield.chooseatlast":`Por favor, selecione pelo menos dois`,
"label.quotation.deleteTip":`Favor selecionar as linhas de cotação a serem excluídas`,
"label.generatepage.title.desc2":`Clique em Salvar para gerar a página da Web e o link URL da Web que pode ser acessado.`,
"label.licence.total":`Licenças totais`,
"Y":`Relação de busca`,
"label.wuzibiekesitan.time":`Tempo Uzbequistão`,
"label.component.hotdeal.nodata":`Não há dados relacionados a oportunidades comerciais.`,
"label.data.exp.save":`Salvar o modelo`,
"label.appupload.upload.tips.dashboard":`NOTA: Os "dashbords em Meus Painéis Personalizados" e "Painéis Públicos NãoConfigurados" não podem ser adicionados aos pacotes e não serão mostrados nesta lista. Os relatórios antigos relacionados não podem ser carregados".`,
"lable.PowerProcess.new.PowerProcess":`Novo processo de concessão de direitos`,
"label.loginhis.search.download":`Considerando que existem muitos históricos de login, somente o histórico dentro de 2 meses pode ser baixado quando se procura por downloads.`,
"label.tabpage.deleteview":`Eliminar a visão`,
"label.chatter.recently":`Recentemente`,
"label.industrialandcommercialverification.title":`Verificação Industrial e Comercial`,
"message.nextapproverlost":`O próximo aprovador especificado é nulo.`,
"front-kefu-moudle-v1-mfsysy-time":`Dias restantes para trilha livre`,
"label.role.assign.tip":`Escolha um usuário na lista de Usuários Disponíveis e adicione-os à lista de Usuários Selecionados para designar usuários para a função`,
"label.addattachment.step2.intruduce":`Repita as etapas 1 e 2 para adicionar vários arquivos.`,
"vue_label_pool_returnreasondiscription":`Descrição do motivo do retorno`,
"label.weixin.report.range":`Gama`,
"label.wei.weiresearchtab":`Escolha do Micro Voto`,
"vue_label_report_setdrill":`Furadeira`,
"page_404_button_back":`Voltar à etapa anterior`,
"label.customfields.autonumber.tip":`Um número seqüencial gerado pelo sistema que utiliza um formato de exibição definido por você. O número é automaticamente incrementado para cada novo registro.`,
"label.ccpeak.return.allrecords":`Devolver todos os registros`,
"label.ccchat.notmember.active.group2":`Você não está no nome com`,
"label.uniquename":`Nome único`,
"label.emailtocloudcc.filed.ssl":`Conexão segura`,
"chatter.emailFollowMe":`Siga-me`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Direitos autorais. Todos os direitos reservados. Linha Direta de Atendimento ao Cliente`,
"label.projectManagement.actualworkinghours":`Horário de trabalho real`,
"label.quickbooks.fieldlabel.taxresale":`Revenda de impostos`,
"label.icon.12":`Serviço`,
"label.data.exp.dataexptemp":`Modelos de exportação de dados`,
"component_setup_tabs_label_add":`Adicionado`,
"label.appointmentdetail.wizard.title10":`Data de início`,
"label.multilingual.close":`O gerenciamento multilíngüe não está habilitado.`,
"message.error.username.notexist":`Nome de usuário inválido, favor entrar novamente.`,
"label.batchadd.newbatchpage.des2":`Se o tipo de campo for Auto Number, o número é automaticamente incrementado para cada novo registro sem entrada manual.`,
"vue_label_SMS_search":`Busca de pistas ou contatos`,
"label.appupload.successWithUrl":`Seu pacote agora está disponível para instalação usando a URL de instalação abaixo.`,
"UG_Forcast_06":`Por favor, selecione os usuários que têm permissão para prever`,
"vue_label_dashboard_secondarygroup":`Por favor, selecione o grupo secundário`,
"label.weixin..xsld.total":`Montante total no funil de vendas`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Falha em restaurar a inadimplência`,
"label.addrecurrencetimetrigger":`Adicionar acionador de tempo periódico`,
"label.emailsync.connectaccount":`Conectar conta de e-mail`,
"label_fiscal_years":`Exercício fiscal`,
"label.icon.164":`Técnico`,
"label.batchadd.mustinput":`Campo com`,
"message.newtabpage.nokeywords":`Seu termo de busca deve ter 1 ou mais caracteres. Ou você pode adicionar critérios de busca avançados.`,
"label.login.verification.mfa.desc3":`Se sua conta tiver sido compartilhada por várias pessoas, outras pessoas não vinculadas ao MFA não poderão fazer o login depois que você tiver vinculado o MFA com sucesso. A solução é ter outra pessoa instalando o aplicativo MFA e escaneando o código QR para esta página, ou salvar a imagem do código QR para posterior escaneamento por outras pessoas. Entretanto, em termos de melhores práticas de segurança, recomendamos que você cancele várias contas compartilhadas.`,
"label.partnerCloud.basicSetting.initialize":`Você não é capaz de mudar o nome de domínio após a inicialização.`,
"label.address.county":`Condado`,
"label.validate.function.funcFormat.TODAY":`HOJE()`,
"label.sso.addAKey":`Adicionar chaves`,
"label.myusergroup":`Meus Grupos de Usuários`,
"label.import.index.time-consuming":`Hora`,
"label_tabpage_systems":`Existem * sistemas`,
"batch.sendemail.s":`, Correio enviado com sucesso.`,
"label.appointment.wizard.subtitle4-1-1":`15 min`,
"label.projectManagement.delete.milestone":`Todas as informações relacionadas a este marco também serão apagadas se você apagar este marco, e os dados não podem ser recuperados. Você tem certeza de confirmar a eliminação?`,
"label.umeng.chatter.praise":`gostou de seu posto.`,
"font-evaluate-module-v1-evdetails":`Detalhe de avaliação:`,
"label.group.filter.resources.and":`Escolher um método de filtragem de recurso, E relação.`,
"label_emailtocloudcc_description":`Conecte sua conta de e-mail empresarial, tais como sales@company.com, info@company.com, support@company.com. Registre automaticamente os e-mails que você recebeu como leads e registros de casos no CloudCC para garantir o acompanhamento oportuno das cartas dos clientes.`,
"label.chat.topic.delete.prompt2":`Favor observar que tópicos com o mesmo nome em outras comunidades não serão excluídos.`,
"message.error.group.authorization":`Você não tem acesso para criar este grupo`,
"label.attendance.wz":`Localização`,
"vue_label_activity_notice_logacal_success":`Você registrou uma chamada`,
"label.emailtocloudcc.step1.case1":`E-mail para o caso`,
"label.h5.chatter.praisenum":`Recebeu elogios`,
"label_time_statistics_basis":`Base estatística de tempo`,
"label.onlyadmincanedit":`Os administradores <fortemente>ONLY</strong> podem editar registros durante o processo de aprovação.`,
"label.fieldtoolongmassage":`Campo`,
"label.sales.team.shared":`Oportunidades comerciais compartilhadas pelo grupo`,
"label_emailsync_status_department":`Departamento`,
"label.mobile.quickcreate.default.sellingfunnel":`Funil de vendas`,
"label.tabpage.closez":`Fechar`,
"homepage.components.two":`Passo 2 escolha o local onde os componentes personalizados são exibidos`,
"label.everyday":`Todos os dias`,
"lable.Product.to.asset.BOM":`Lista técnica de produto a ativo`,
"label.appointment.wizard.subtitle4-3":`O convidado é capaz de escolher um início em cada`,
"label.customobjects.standardfieldslist":`Lista de campos padrão`,
"label.customfields.suretodelete":`Sim, eu quero apagar o campo personalizado.`,
"component.chatter.label.to":`Para`,
"label.emailsync.form.seversetting":`Configuração`,
"label.service.gantt.enabled.resources":`Recurso ativado`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Quantidade de Pedidos Perdidos`,
"label.pc.trigger.apiname":`O nome API já existe, por favor tente novamente.`,
"label.icon.34":`Configurar`,
"label.schedulejob.setup.schedule.prgname":`Nome da Aplicação`,
"label.weixin.free.registration":`Cadastre-se gratuitamente`,
"label.placeholder":`Busca rápida`,
"label.emailobject.manage.template":`Gerenciar modelos`,
"label.knowledge.article.existsdata":`Existem outros dados não-qualificados.`,
"label.campaign.channel.lookup.ticket":`Verifique o bilhete`,
"label.searchlayout.relation.searchfield":`Pesquisar campos de filtros para listas relacionadas.`,
"label.recordid.cannot.empty":`A identificação do registro não pode ser nula`,
"label_partner_workspace_member_choice":`Selecione o perfil`,
"vue_label_campaign_amount":`Valor da renda`,
"label.niue.time":`Tempo Niue`,
"front-homepageobject-module-v1-workload-ranking":`Ranking de carga de trabalho`,
"message.error.datainvalid":`Erro: dados inválidos.`,
"vue_label_helpcenter_salesfunnel":`Use a nova versão do funil de vendas para analisar o acompanhamento das oportunidades de negócios e fornecer referências de dados para seu processo de vendas.<br> No canto superior esquerdo, os registros serão filtrados de acordo com condições como função ou proprietário, e todas as oportunidades de negócios visíveis sob as condições correspondentes serão visualizadas e analisadas. Clique na etapa do gráfico do funil de vendas para visualizar todos os registros sob essa etapa.`,
"vue_label_transferownernotice":`O proprietário do registro associado a este item também será alterado`,
"label.monitorsys.operator":`Atuado por`,
"label.please.codeNorm":`Por favor, escolha o código padrão.`,
"label.campaign.channel.step6.remark2":`Possibilitar a solicitação de funcionários`,
"market.potential.customers":`Líder de mercado`,
"label.customfields.phone.tip":`Permite que os usuários digitem qualquer número de telefone. Formata automaticamente como um número de telefone.`,
"label.currency.edit":`Currency Edit: Change Corporate Currency`,
"label.emailobject.emaildetail.button.markasunread":`Marcar como não lido`,
"label_partner_template_memo":`Título`,
"label.chat.message.search.all":`Pesquisar todas as informações`,
"label_tabpage_hoursagoz":`horas`,
"label.customcomponent.developer.help":`Componentes personalizados Ajuda ao desenvolvedor`,
"setup_mainpage_label_welcome":`Bem-vindo à plataforma CloudCC PaaS, as principais funções da plataforma são as seguintes:`,
"label.h5.similar.opportunity.list":`Os resultados incluem oportunidades fechadas, que têm um ou mais campos em comum com sua oportunidade. Oportunidades de bookmarking as adiciona à lista relacionada a Oportunidades similares na página de detalhes de sua oportunidade.`,
"vue_label_record_count":`Contagem recorde`,
"label.icon.29":`Demonstração`,
"pagecreator.page.label.pagelayout":`Layout da página`,
"label.ggReleaseRange.searchRole":`Procure uma função`,
"label.campagin.member.field.setup":`Configurações de campo dos membros da campanha`,
"augest":`Agosto`,
"label.salescloud.massloss.content":`A desativação das equipes de oportunidades removerá irreversivelmente as equipes existentes de todas as Oportunidades e excluirá as equipes de oportunidades padrão dos usuários.`,
"label.customfields.new.step2.opration.unique.info":`Não são permitidos valores duplicados.`,
"vue_label_email_optional_members":`Membros opcionais`,
"label.emailobject.attachment.download":`Download`,
"label.recordamount":`Contagem de registros`,
"front-kefu-moudle-call-recorder":`Gravação de chamadas`,
"label.more.info":`Detalhes`,
"vue_label_commonobjects_view_secondsbefore":`{segundos} segundos`,
"label.emailsync.status.action":`Ação`,
"label.customfields.totalsummary.collectedfields":`Objeto resumido`,
"label.knowledge.setting.hint.two":`Atenção: Você não pode desativar o Conhecimento uma vez ativado.`,
"label.login.access.yujidao":`Exp.`,
"label.assignment.setup.detail.description":`Adicionar entradas de regras que especifiquem os critérios usados para atribuir leads aos usuários automaticamente.`,
"message.error.marketsea.null":`Não existe um pool de chumbo`,
"lable.account.Current.CY":`CY atual`,
"vue_label_salesadvance_lost":`Perda`,
"label.file.ownedbyme":`De minha propriedade`,
"label.component.helper.nodata":`Nada precisa de sua atenção neste momento. por favor, verifique mais tarde.`,
"label.weixin.appr.pending.auditor":`Apresentado por`,
"UG_opportunity_004":`Tipo multi-serviços`,
"label.leadscore.setup":`Lidera as definições de pontuação`,
"label.addtimetrigger":`Adicionar gatilho de tempo`,
"label.mr.title.match":`Se corresponder exatamente`,
"label.projectManagement.Newmilestone":`Novo marco miliário`,
"label.preview":`Pré-visualização`,
"label.tabpage.issuez":`Edição`,
"label.img.max.size":`A imagem carregada é muito grande, e o tamanho máximo da imagem carregada é 500K, por favor, carregue novamente.`,
"label.mainpageset":`Configurar a página inicial Componentes`,
"label.user.login.false.lock":`Tentativas de login excedidas. A conta está bloqueada`,
"UG_solution_02":`A solução é uma solução interna da instituição para o problema que as contas encontram.`,
"vue_label_approve_put_away":`Colapso`,
"label.profile.existing":`Perfil Existente`,
"label.ems.logininfo":`Informações de login`,
"label.weixin.location.service":`Objetos que suportam serviços de localização`,
"label.multilang.datamoveaction.totaldata":`Há um total de {1} registros que satisfazem o condition，maximum 100 registros podem ser transferidos em um time！：`,
"label.ccdocument.cannot.update.set":`Este documento não pertence ao tipo Word ou Excel ou PPT do arquivo, não é carregado no modelo de pasta vermelha.`,
"vue_label_fliter_addfliter":`Adicionar Fliter`,
"label.custom.page.or.trigger":`(Páginas Personalizadas ou Gatilhos)`,
"label.tag.filter1":`Filtrar registros que contenham todas as tags selecionadas`,
"UG.homepage.006":`Visibilidade de 360 graus na atividade de sua conta através de pesquisas, chats ao vivo, e-mails, ordens de trabalho, postos na mídia social e até mesmo atividades de vendas (tais como leads, suporte de serviços e atividades).`,
"SCORE":`Pontuação`,
"label.file.library.managemembers2":`Gerenciar membros da biblioteca`,
"label.email.template.public.SMS":`Pasta Pública de Modelos de SMS`,
"label.leadscore.donot":`Incapaz de marcar contatos`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Pré-visualização`,
"UG_contact_04":`Ou`,
"label.ccchat.person.invite.eminfo":`{0} convidou você a participar {1} do CCChat. Com ccchat você pode conversar com seus colegas, criar equipes para seus projetos e compartilhar arquivos.`,
"setup_object_field_dependency_label_actionfieldvalue":`Campo de controle`,
"lable.Product.options":`Opções de produtos`,
"front-electronic-signature-add-autofill-field":`Adicionar Autofill Field`,
"label.customfields.totalsummary.selectcollectedfields":`Selecione Objeto a ser resumido`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Podem ser inseridos até 10 dígitos para o valor do contrato.`,
"label.forecast.shrepage.pagetitle":`Usuários, papéis e territórios compartilhados`,
"label.login.access.mark":`Para ajudar em questões de suporte, você pode conceder a seu administrador ou pessoal de suporte a capacidade de fazer o login como você e acessar seus dados.`,
"lable.outlook.edit.zdyout":`Mapeamento de campo de intercâmbio personalizado`,
"label.approveoperate":`Ações de aprovação`,
"label.tabpage.linknamez":`Nome do link`,
"label.report.error.deletehavedashboard":`Este relatório tem um novo painel de controle e não pode ser apagado.`,
"label.summaryreport.2018.step1":`Passo 1 Criar um agrupamento`,
"label.campaignmember.main.leadtomember.title":`Configuração do mapeamento de campo`,
"label.select.dashboar.type":`Selecione o tipo de Painel de Controle`,
"message.setup.field.picklist.valueexists":`Este valor da lista de picking já existe.`,
"label.loading":`Carregando...`,
"label.payments.paytip1":`Sua edição atual não é uma edição gratuita, por favor clique em Confirmar para atualizar ou re-logar.`,
"label.view.appliedMobile":`Aplicar para o aplicativo móvel`,
"label.multilang.forcast.financialyear":`{0} fiscal year：`,
"front-web-module-v1-detail-comment-opinion":`Feedback`,
"UG_Forcast_10":`Completo`,
"label.optionlistset":`Opções da lista de picking`,
"label.visualpage_list.vpname":`Nome da página personalizada`,
"vue_label_calendar_failed_to_delete_calendar":`Falha ao apagar o calendário`,
"label.json.string.null":`Vazio`,
"message.serviceappo.time.violation2":`A violação do tempo disponível para a marcação de serviço: O horário combinado de término do compromisso é anterior à data de vencimento do compromisso de serviço`,
"label.productsales.today.noevttsk":`Não há eventos em aberto e tarefas em expiração.`,
"label_tabpage_emptyz":`Vazio`,
"front-kefu-moudle-no-create":`Não criado`,
"label.wedge.shaped.tail.arrow.cannot.empty":`A seta de cunha traseira não pode ser nula`,
"label.continue.shopping":`Continuar comprando`,
"label.turntomain":`Saltar para o Conteúdo Principal`,
"component.assistant.label.nodata":`Nenhum evento hoje, favor verificar mais tarde.`,
"label.payments.paytip4":`Favor digitar o número de users！`,
"label.appupload.upload.versionName":`Nome da versão`,
"label.chatter.endData":`Data de término`,
"front-kefu-moudle-buytr-tip":`Esperamos que você possa ter uma grande experiência com o call center da CloudCC, e que você possa adquirir uma conta oficial de call center e nós lhe ofereceremos um melhor serviço.`,
"label.repw":`Repita a senha`,
"label.tabularreport.intro":`O relatório tabular é uma das formas mais simples e rápidas de listar os dados.`,
"label.selectoperatetype":`Selecione o tipo de ação`,
"setup.layout.label.required":`Obrigatório`,
"label.default.designee":`Perônio Despachado por Padrão`,
"label.ccdocument.cannotdel.folder":`Você não pode excluir esta pasta porque alguns arquivos nesta pasta.`,
"label.escalation.setup.newentries.inputentries":`Digite a regra de entrada`,
"label.emailobject.addnewtemplate":`Adicionar novo modelo`,
"label_chatter_content":`Conteúdo`,
"label.htyj.mubiao":`Objetivo`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Sexta-feira`,
"label_tabpage_fieldoptions":`campo tipo de registro, campo lista de opções e campo lista de opções (escolha múltipla). recomenda-se digitar no máximo 10 palavras-chave, separadas por vírgulas para obter "ou relacionamento", como por exemplo: "Nova Iorque, Toronto, Tóquio".`,
"label.mobiletablayoutedit.remark2":`Selecione os campos exibidos na página inicial da guia Mobile App.`,
"label.sendemail.chat.addComentsat":`Prezado #nome:\n #nome do usuárioNome do usuário mencionou você nos comentários.`,
"Z":`Fórmula`,
"label.multilang.batchdeleteaction.movesuccess":`Um total de {0} registros foi apagado successfully！：`,
"label.textmessage.vonage.message2":`Ao criar contas Vonage API, os usuários permitem que o CloudCC acesse sua conta Nexmo API para enviar e receber mensagens de texto.`,
"label.file.use.document":`Utilização do espaço de armazenamento`,
"UG.Lead.011":`Criar uma pista`,
"label.view.name":`Ver Nome`,
"label.data.downtemplate":`Download do modelo`,
"vue_label_appstore_get_now":`Obtenha-o agora`,
"label.controlfield":`Campo de controle`,
"label.dataimport.type.insert":`Inserir`,
"label.customfields.multiselect.tip":`Permite aos usuários selecionar vários valores a partir de uma lista que você define.`,
"label.weixin.approval.qxzjl":`Por favor, selecione o registro`,
"component.salesperformance.label.70finish":`Terminado - não processado (>70%)`,
"Lead_Auto_Scoring_Setting":`Definição da pontuação de chumbo`,
"pagecreator_layout_message_canntdelete":`O layout atual não é permitido excluir`,
"vue_label_report_exprotpage":`Página de exportação: Página {página}`,
"label.campaign.channel.step4":`Passo4: Selecione os campos obrigatórios a serem exibidos na página de registro do canal de marketing`,
"label.app.launcher":`Lançador de aplicações`,
"vue_label_campaign_selectedmember":`{member} membros da campanha selecionados`,
"label.mobile.quickcreate.default.approvals":`Aprovações`,
"label.view.step4":`Passo 4 Restringir a Visibilidade`,
"label.exchange.sync.state.user":`Status de sincronização do usuário`,
"label.forecast.customforecast.tab.forecast":`Previsões`,
"label.theUserLoginForTheFirstTime":`Primeiro login do usuário.`,
"label.workflowoperate.tip":`Especificar as ações de fluxo de trabalho que serão acionadas quando os critérios da regra forem cumpridos.`,
"font-evaluate-module-v1-ten-points":`Marca Positiva: 10 pontos`,
"label.knowledge.delete":`Erro ao apagar o conhecimento`,
"front-console-see-contacts":`Contatos {num} identificados`,
"label.h5.similar.opportunity.add.to.favorites":`Acrescentar aos Favoritos`,
"front-epwechat-module-v1-install-app":`Instalar na WeCom`,
"setup_layout_message_relatedlistbutton":`Selecione botões padrão para exibir na lista relacionada.`,
"label.salescloud.massloss.title":`Pode levar a grandes perdas de dados.`,
"front-console-conversation-btn1":`Anel de volta`,
"label.custom.canvasScale":`Balança de lona`,
"label.lead.score.doing":`No processo de pontuação de chumbo`,
"message.approval.step.validation.invalid.number":`Número inválido`,
"chatter.lk":`Como`,
"label.dashboardSetup.showmaxval":`Max Exibido`,
"label.keywords":`Palavras-chave`,
"vue_label_helpcenter_SMS":`Ligue a função SMS<br> Se o código de país do sistema CRM que você adquiriu é USA, então a função SMS está disponível no sistema de sua organização. O administrador da organização pode inserir o número de telefone adquirido por sua organização no sistema vonage no gateway vonage no aplicativo de integração de fundo, e então usar a função SMS no menu do aplicativo da nuvem de vendas.<br>caixa SMS<br> A caixa SMS é dividida em duas partes. À esquerda está o registro de leads ou contatos com SMS. Após clicar em um registro, os detalhes de envio e recebimento serão exibidos à direita. Você pode ver os registros de si mesmo e de seus subordinados.<br>enviar mensagem em grupo<br> Você pode enviar mensagens de texto em grupo no menu SMS, a lista de leads ou contatos e o botão para enviar mensagens SMS sobre os membros da campanha. Você só pode enviar mensagens de texto para clientes potenciais ou contatos no CRM. Após editar a mensagem de texto, selecione "Enviar", e um registro de grupo será gerado independentemente do número de destinatários, ou você pode selecionar "Enviar separadamente" para enviar as mensagens de texto separadamente Suporte a mensagens SMS separadas mostrando os campos mesclados inseridos no modelo SMS.`,
"label.emailobject.createnewavailability":`Criar nova disponibilidade`,
"front-kefu-moudle-buytr-send-email":`Você ainda não foi associado à caixa postal do sistema. Favor enviar um email para support@cloudcc.com e escrever sua intenção, nome da empresa e informações de contato, a equipe de vendas entrará em contato com você o mais rápido possível.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Detalhes do batepapo Collapse`,
"label.marketseamemset.lead.maxuser":`Número máximo de membros`,
"label.forecast.forecastroleuserpage.shre.manager":`Somente administradores podem compartilhar esta previsão`,
"label.file.noselect":`Nenhum arquivo é selecionado`,
"label.notification.task3":`【被分配人】 altere o status da tarefa que você designou para 【新状态】`,
"label.dependfield":`Campo Dependente`,
"lable.SalesCommitmentKanBan.receipts":`Recibos`,
"label_partner_workspace_member_search":`Busca`,
"label.share.originally.posted":`Cartaz inicial`,
"label.autonumber":`Número do carro`,
"label.view.sortview.name":`Ver Nome`,
"label.h5.add.activity":`Adicionar atividade`,
"label.textmessage.vonage.phone.number":`Número de telefone`,
"label.partnerCloud.financeSetting.enterApiKey":`Por favor, digite a chave secreta API`,
"label.industrialandcommercialverification.enablestatus":`Habilitar Status`,
"label.reportTypeFocusD1":`Especifique que tipo de registros (linhas) será o foco dos relatórios gerados por esta fonte de dados de relatório.`,
"vue_label_report_four-levelseriesobjecttree":`Árvore de objetos em série de quatro níveis`,
"label.mobile.default.catalogue":`Catálogo padrão`,
"label.partnerCloud.partnerAccount.again":`Recarga`,
"label.summaryreport.step2.new":`Passo 2 Selecione o método de agrupamento de dados resumidos`,
"label.tabpage.cancel":`Cancelar`,
"label.multilang.datamovelist.datamove":`Transferir vários {0} de um usuário para outro usuário:`,
"label.conferloginandvisitlimit":`Acesso Concedido para Login`,
"vue_label_help_viewhelpcenter":`Ver Centro de Ajuda CloudCC`,
"label.leadscore.norule":`Sem regras de pontuação de chumbo, favor criar uma regra de pontuação de chumbo ou ativar uma regra de saída`,
"label.tabpage.exitz":`Saída`,
"label.DeploymentStatus":`Status de Implantação`,
"label.layout.saving":`Salvando o Layout...`,
"label.emailobject.emaildetail.field.object":`Objeto`,
"label.customfields.searchrelation.fieldtag.tip":`Digite as etiquetas a serem usadas na exibição, na visualização do layout da página, na visualização do relatório e na visualização da lista.`,
"message.huanxin.bindtenant.notfound":`Agente não vinculado`,
"label.referpersonalias":`Apresentado por`,
"label.icon.31":`Computador`,
"label.appupload.upload.install.thispackage":`Este pacote`,
"label.appointment.wizard.subtitle1-1":`Personalizado`,
"pagecreator_page_message_save_fail":`O salvamento da página falhou`,
"label.lastset":`Finalmente, de acordo com`,
"label.version.support.limited":`Suporte Limitado`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Editar layout de busca`,
"template.dashboard.customer.analysis":`Análise de contas`,
"label.continue_editing":`Continuar Editando`,
"label.version.sum.customtab":`abas personalizadas`,
"label.validate.function.funcExplain.TIMEVALUE":`Retorna o valor da hora local sem a data`,
"label.import.page1.selectobjfromdata":`Selecionar objetos para importar dados`,
"label.partnerCloud.basicSetting.success":`Inicializar com sucesso`,
"label.customfields.fielddependency.cannotcreat":`O campo que você seleciona depende direta ou indiretamente de si mesmo, de modo que você não pode criar uma denpendência.`,
"label.umeng.activity.youhaveatask":`Você tem uma nova tarefa.`,
"label.file.folder.create":`Nova Pasta`,
"vue_label_campaign_member_status":`Status de membro`,
"lable.opppdt.addpdt.table.date":`Data`,
"label_partner_workspace_login_buttontext":`Texto dos botões`,
"label_other_mistakes":`Outros erros`,
"label.must.be.configured":`Deve ser configurado`,
"label.customize.memory.function.sorting.enable":`Ativar memória de ordenação de cabeçalhos`,
"setup.layout.label.areaname":`Nome da seção`,
"label_chatter_pastThirtyday":`Os últimos 30 dias`,
"setup_mainpage_label_welcome25":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Controle de Segurança → Compartilhar Configurações.`,
"label.ccchat.person.invite.succsend":`Um convite para participar do CCChat é enviado para`,
"label.select.time.range":`Por favor, escolha o intervalo de tempo`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Adicione produtos ao carrinho, onde você pode ajustar a quantidade e visualizar o preço.`,
"label.manageAll.sta1":`Pendente`,
"label.cy.select":`Escolha uma nova moeda a partir da lista disponível.`,
"chatter.lam":`Comentário`,
"label.partner.setup.title":`Configurações`,
"component.setup.label.displaybutton":`Botão de exibição`,
"component.salesperformance.label.target":`Objetivo`,
"label.campagin.channel":`Por favor, digite o valor do canal`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(campo)`,
"UG.homepage.009":`Acesso CRM`,
"label.file.item":`Projeto`,
"label.file.library.addmembprompt":`Os seguintes já são membros.`,
"label.bmap.releasePosition":`Localização`,
"setup_object_layout_label_selectedprofile":`Perfis selecionados`,
"label_emailsync_message":`Pronto`,
"label.view_submissions":`Ver Submissões`,
"lable.tianyancha.repeated":`Seleção repetida`,
"label.import.index.introduce":`Importe seus dados para o sistema em três etapas simples`,
"label.time.operation.new":`Novo Trabalho Programado`,
"label.projectManagement.Pleaseentersettlementtype":`Por favor, digite o tipo de liquidação`,
"label.icon.169":`Carro de turismo`,
"vue_label_commonobjects_detail_related_listview":`Lista`,
"label.view.step1":`Passo 1 Digite o nome da vista`,
"label.summaryreport.intro":`Relatórios resumidos mostram tanto o subtotal dos dados como outras informações resumidas.`,
"vue_label_file_input_correct_name":`Favor preencher o nome correto`,
"System_Email_Template_Title":`Bem-vindo à plataforma CloudCC CRM`,
"label.tianyancha.province":`Abreviação provincial`,
"label.deleteall.sure":`Você tem certeza de que quer apagar tudo?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Deve misturar números e letras maiúsculas e minúsculas`,
"front-lightning-module-v1-details-page-chart-select":`Escolha o objeto e o visor`,
"setup_mainpage_label_welcome8":`Personalização da interface de arrastar e soltar`,
"lable.outlook.edit.lastupc":`Último Contato Atualizado`,
"label.weixin.registered":`Cadastre-se`,
"vue_label_file_history_version":`Revisões`,
"vue_label_campaign_earned":`Quantia a ser recolhida`,
"label.staticresource.useful.realtion.tip":`Abaixo está uma lista de todas as páginas do CloudCC.com com referências a este recurso estático.`,
"vue_label_file_libraray":`Bibliotecas`,
"label.department.phone":`Número de celular`,
"label.emailtemplate.edit":`Editar modelo de e-mail`,
"label.processsetting.key.information.tips":`Principais informações e dicas`,
"label.summaryreport.step7":`Passo 7 Selecione o tipo de gráfico e o item de destaque`,
"label.chat.topic.remove.favorite":`Excluir dos Favoritos`,
"label.campagin.roi.ksrq":`Data de início`,
"label.data.downpage.e_title.e_btn":`Ir para a página de exportação e começar a exportar`,
"label.approvaldatamove.dname":`Aprovador atual`,
"lable.Partial.attributes":`Atributo Parcial`,
"template.report.enabled.products":`Produtos ativados`,
"lable.outlook.detail.cto":`CloudCC.com para Exchange`,
"label.sendemail.activity.newtasktitle":`Notificação de novas tarefas`,
"label.validate.function.funcFormat.DAY":`DIA(data)`,
"label.log.datetime.value":`Por favor, digite o tempo de consulta`,
"label.import.index.updaterecord":`Registro de atualização`,
"label.registration.page.invitation":`Página de inscrição convite`,
"pagecreator_systemstyle_label_detailcolor":`Cor do texto de detalhe`,
"label.tabname.cannot.empty":`O nome do separador não pode ser nulo`,
"label.data.newtemplate.savetemp":`Você pode salvar como modelo e usar os campos e critérios para esta exportação de dados como modelos de exportação de dados. Por favor, digite cuidadosamente o nome e a descrição do modelo para facilitar seu uso.`,
"label.ems.body":`Corpo`,
"enc":`Texto Criptografado(Armazenamento Criptografado)`,
"label.profile.mobile.setup.commonSaler":`Vendas em geral`,
"label.continueselectproduct":`Continuar para escolher os produtos`,
"label.event.new":`Novo Evento`,
"label.renametabandtaglib":`Renomear separador e rótulo`,
"label.qrcodelogin.message.exception":`Exceção do servidor, favor entrar em contato com seu administrador.`,
"label.service.gantt.locationToGantt":`Gráfico de Gantt`,
"label.mr.theLastGroup":`Este é o último grupo. Clique em "Voltar para ver a lista de registros duplicados" para ver os registros duplicados.`,
"label.report.export.format.content":`Exportar o cabeçalho do relatório atual, grupos e detalhes. O número máximo de detalhes que pode ser exportado é`,
"label.version.accountandcontact":`Contas e Contatos`,
"label.partnerCloud.financeSetting.enterMd5Key":`Por favor, insira a chave secreta do MDS.`,
"label.login.access.quater":`Semana`,
"vue_label_commonobjects_view_searchthisview":`Pesquise esta lista`,
"label.import.step1.allobj":`Todos os objetos`,
"front-efficient-project-management":`O Project Cloud oferece gerenciamento completo do ciclo de vida desde o início do projeto, planejamento, execução, controle até o fechamento, otimizando o processo de gerenciamento do projeto de acordo com suas necessidades comerciais e ajudandoo a gerenciar projetos de forma eficiente.`,
"label.includedvalue":`Incluir valores`,
"label.service.newBuildDialog.past.days":`dias passados`,
"vue_label_report_sortup":`Ordenar em ordem ascendente`,
"label.appointment.wizard.subtitle3-2":`Terça-feira`,
"label.dashboard.trend":`Tendência`,
"label.schedulejob.setup.schedule.st2":`O 2o.`,
"label.view.sortview.number":`Número de registros`,
"lable.Please.enable.order":`O pedido não é ativado, por favor, ativeo.`,
"label.datamanage.immediately.import":`Importação`,
"label.delete.condition":`Limpar`,
"label.dashboard.chooseDispalyOnTheHomePage":`Selecione a página inicial a ser exibida`,
"asset.accountid.contactid.required":`Cada ativo precisa ser associado a uma conta ou contato.`,
"label.mask.character":`Caráter da máscara`,
"lable.account.Previous.FY":`Ano Fiscal Anterior`,
"chatter.attachment":`Adicionar arquivos`,
"label.view_only":`Ver apenas`,
"label.tianyancha.name":`Nome da empresa`,
"label.service.gantt.avg.traveltime":`Tempo médio de viagem dos compromissos de serviço`,
"vue_label_pool_move":`Mudança`,
"label.import.index.beforeexport":`2、Before importação, por favor, certifique-se de importar todos os registros relacionados. Por exemplo, se você estiver importando registros de contato e quiser preencher o campo de conta, que é um campo de pesquisa, é necessário criar primeiro o registro de conta que você está preenchendo, depois importar o registro de contato e preencher o campo de conta com o nome ou ID do cliente correspondente.`,
"label.view.delete":`Excluir`,
"template.detail.info.link":`Detalhes Link`,
"label.sendemail.send.setfail":`A configuração de informações por e-mail falhou, favor preencher as informações corretas por e-mail.`,
"label_emailtocloudcc_redmessage11":`autenticação de SMTP fiailed. Favor verificar se o endereço de e-mail e a senha estão corretos.`,
"label.campaigns.memberalert":`Por favor, selecione um membro pelo menos`,
"label.schedulejob.setup.schedule.frequency":`Freqüência`,
"component.newrecords.label.all":`Ver tudo`,
"label.mr.caption.opportunity":`Encontrar duplicatas e fundir: Códigos para consulta de duplicatas de Oportunidades`,
"chatter.group.onlyMembers":`Somente os membros podem ver este grupo. E somente o proprietário do grupo tem permissão para adicionar membros da equipe.`,
"label.recordtype.edit.selectvalue.show":`Os valores da lista de picking são exibidos na ordem em que são gravados.`,
"message.textmaxlength":`Comprimento g não deve exceder 255 caracteres`,
"label.reportsSubscriptionPage.visibility":`Funcionando como`,
"label.umeng.chatter.addcoments":`Seu posto de nuvem tem 1 nova resposta`,
"chatter.up.f":`Upload Falha, erro desconhecido.`,
"label.icon.146":`Teclado`,
"lable.custom.CY.Ago":`2 CY Ago`,
"label.tabpage.step3":`Passo 3 selecione os campos a serem exibidos`,
"label.checkfield.introduce":`Defina os campos do objeto que podem ser usados para verificar duplicatas, e encontre as dupilcatas na lista de registros pelos campos que você definir.`,
"label.tag.addtags":`Adicionar Etiquetas`,
"label.service.newBuildDialog.characterlimit":`O nome excede o limite de 25 caracteres.`,
"font-evaluate-module-v1-evquestions":`Pergunta de avaliação`,
"label.knowledge.only.update.draft":`Atualizar apenas o rascunho`,
"label.partnerCloud.basicSetting.defaultCounts":`Número de funções padrão para adicionar conta de parceiro`,
"label.chat.topic.delete":`Excluir`,
"label.workflow.contentcondition":`os critérios são cumpridos`,
"vue_label_commonobjects_view_sortby":`Ordenar por {campo}`,
"label.passwordPolicy.setup.pwdremember24":`Lembrete (0) senha`,
"front-kefu-moudle-free-account":`Conta de teste`,
"label.marketsea.isautorecycle":`Permitir a reciclagem automática`,
"label.addattachment.view":`Ver arquivos`,
"vue_label_helpcenter_contact":`Nas informações detalhadas, clique no botão do diagrama em árvore ao lado do contato, você pode visualizar o diagrama hierárquico dos contatos, entender as relações entre o líder e os membros dos contatos relacionados, e visualizar algumas informações de campo de cada contato.`,
"label.taskevent":`Atividades`,
"label.industrialandcommercialverification.message":`Acabaram-se as consultas gratuitas de hoje`,
"label.object.already.delete":`O objeto eliminado`,
"label.project.hit.four":`Aviso de atualização da subtarefa`,
"label.taskpagelayout":`Layouts das páginas de tarefas`,
"label.version.sum.locationfield":`Campos de geolocalização`,
"front-sales-button-toQB":`Sincronização com QuickBooks`,
"label.app.oceanblue":`Azul-marinho`,
"label.operating":`Operando...`,
"label.customfields.formula.dateexample":`Data de Lembrete = FecharData - 7`,
"label.happen_delete":`O que acontece se eu apagar um formulário?`,
"label.service.appointmentList.plansToStart":`Plano de partida`,
"label.persmets.operate.licence":`Permissão`,
"label.mobile.quickcreate.default.activities":`Calendário`,
"label.australian.eastem.standard.time":`Horário de verão do leste australiano （New Sul Wales）`,
"label.emailobject.remove":`REMOVENDO`,
"label.weixin.vote":`Vote`,
"label.reportsSubscriptionPage.condition.aggregate":`Agregado`,
"front-kefu-moudle-has-unbind":`Você tem estado sem restrições`,
"chatter.group.newGroup":`Novo Grupo`,
"label.tabpage.systems":`Existem * sistemas`,
"label.textmessage.vonage.connect":`Conecte-se à Vonage`,
"label.campaign.channel.input.ticket":`Enviar bilhete de entrada`,
"label.ccpeak.query.sharetab":`Formulários de busca e compartilhamento`,
"label.reporttype":`Fonte de dados do relatório`,
"message.duplication.label.isprofiletip":`Se verificados, os dados que o usuário atual pode ver são verificados quando se encontram duplicatas. Caso contrário, verifique todos os dados.`,
"label.tianyancha.businessverify.xieyi":`Contrato de licença de usuário do CloudCC`,
"font-evaluate-module-v1-select-person":`Por favor, selecione a equipe de atendimento ao cliente`,
"vue_label_chatter_all_groups":`Todos os grupos`,
"label.recordtype.profile.setdefault":`Faça o Default`,
"label.mr.descreption.nocondition":`Não há duplicação de dados que atendam às condições.`,
"label.tabpage.askz":`O que você gostaria de perguntar`,
"label.marketsea.selectMember":`Selecione Membro`,
"template.report.stage.possibility.analysis":`Análise de Possibilidade de Estágio`,
"label.data.selectderivedobject":`Selecione o objeto a ser exportado`,
"label.customfields.formula.explain":`Descrição: atualmente suporta o número, porcentagem e outros campos dos quatro princípios, assim como valores de transporte do campo de pesquisa. Por exemplo: cálculo do número: unidade*unitprice&nbsp;&nbsp;&nbsp;&nbsp;valor de transporte do campo de pesquisa:contato__r.endereço`,
"vue_label_notice_change_fail":`A mudança falhou`,
"label.customobjects.trackoldandnewvalues":`Rastrear valores antigos e novos`,
"label.h5.leftprompt":`Você tem algum conteúdo editado que não foi enviado, tem certeza de que vai embora?`,
"label.select.field":`Campos disponíveis`,
"label.customobjects.layoutedit":`Atribuição do layout da página`,
"label.false":`FALSO`,
"UG_Forcast_07":`Permitir previsão`,
"vue_label_chatter_team_member":`membro do grupo`,
"label.tabpage.retypez":`Quando o tipo de registro é alterado, os valores existentes da lista de opções não serão automaticamente alterados. recomendamos atualizar o valor existente da lista de opções do registro no mesmo local.`,
"front-epwechat-module-v1-single-desc":`Single Sign On other ends of CloudCC through WeCom; Swift switch among all ends.`,
"label.closeandconverted":`Fechado-Convertido`,
"label.service.confirmed":`Confirmado`,
"label.partner.workspace.member.cloudcc":`Perfil CloudCC`,
"label.star.click":`Clique para limpar`,
"label.icon.135":`Moeda`,
"button_partner_workspace_login_logo_upload":`Carregar imagem`,
"message.error.sql.constraint.recordnotsingle":`Identificação externa configurada com sucesso. Motivo: este campo nos dados originais tem dados duplicados.`,
"label.ccchat.person.invite.errorpwd":`Usar pelo menos 8 caracteres e incluir uma combinação de números e caracteres`,
"label_tabpage_isdeleterecord":`Se apagar o registro selecionado`,
"label.weixin.prompt.message":`Mensagem imediata`,
"vue_label_chatter_view_original_post":`Ver post original`,
"label.multilingual.tip3":`A habilitação de múltiplos idiomas permite que cada usuário da organização configure os idiomas habilitados.`,
"label.dataimport.error.datetime":`Erro: Os dados e o formato de tempo estão incorretos`,
"label_tabpage_addcondition":`Adicione a condição`,
"label.query.detail.manageexcludeuser":`Gerenciar usuário externo`,
"label.tianyancha.creditcode":`Código de crédito social unificado`,
"label.cy.enter":`Insira a taxa de conversão de sua moeda corporativa para esta nova moeda.`,
"label.textmessage.vonage.message1":`Ao se integrar com a Vonage, os usuários podem enviar e receber mensagens de texto na plataforma CloudCC via Vonage. Entretanto, os usuários devem registrar as contas Vonage e comprar números de telefone antes de poderem enviar mensagens de texto.`,
"front-marketing-module-v1-share-invitation":`Convite para compartilhar o pessoal`,
"label.file.items":`artigo(s)`,
"label.otherwise":`Caso contrário`,
"label.permission.detail.system":`Sistema`,
"message.success.task.emailsend":`Salvar e enviar mensagem de e-mail com sucesso`,
"label.the.reward.group":`Grupo de Linha de Citação`,
"setup.layout.label.relatedlistsetup":`Configurações da lista relacionada`,
"label.empty":`Limpar`,
"label.weixin.cloudcc.user.binding":`Vinculação do usuário CloudCC`,
"label.file.what.change":`O que mudou?(opcional)`,
"label.search":`Busca`,
"label.mobile":`Móvel`,
"template.report.month.potential.customer":`Leads deste Mês`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Habilitar regras de validação ao usar o Scan`,
"lable.outlook.list.des":`A configuração do Exchange Sync define as configurações para que o CloudCC para Exchange se aplique a um grupo de usuários específico.`,
"label.appupload.install.error.info":`{0} "{1}" foi usado por {2}, favor renomear o {0} existente.`,
"label.tabpage.addoptionsz":`Adicionar opções`,
"label.arabian.standard.time":`Tempo padrão da Arábia`,
"label.thefirst":`A 1ª Coluna`,
"label_partner_workspace_login_footertext":`Texto do rodapé`,
"lable.Disabled.successfully":`Desativar com sucesso.`,
"label.confirm.del":`Os registros de aprovação pendentes, você tem certeza de que quer excluir?`,
"vue_label_normal_reregister":`Login novamente`,
"label_file_img":`Imagem`,
"label.salescloud.salesdashboard.sales.behavior":`Atividades de venda`,
"label.startdate":`Data de início`,
"label.field.duplicate.error.msg5":`Por favor, verifique todos os erros abaixo, tente novamente após a modificação.`,
"setup.main2018.label.managesetup":`Configurações de administração`,
"label.forecast.editshrepage.title":`Novo compartilhamento`,
"UG.solution.01":`Fornecer a solução`,
"label.knowledgebase.data.recovery.successfully":`Recuperar os dados {a} com sucesso`,
"label.pc.ui.2018.myccchat":`Meu CCChat`,
"label.attachement":`Notas`,
"message.mobilechooseatmostten":`Selecione até 10 campos`,
"label.campagin.roi.bhzeywjh":`Oportunidades totais`,
"label.autoresponserule":`Regras de Auto-Resposta`,
"label.attendance.yuyue":`Você não tem um compromisso, registre-se agora`,
"label.insert":`Inserir`,
"label.service.ganttBaiduMap.shutDown":`Você quer fechar?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Violação de zona: zona de recursos não é compatível com zona de serviço de nomeação.`,
"label.appointment.disable.function":`Função de desativação`,
"lable.currencyManage.manageexchangeRate.dis":`Para gerenciar taxas de câmbio datadas para sua organização, clique em Gerenciar taxas de câmbio datadas. As taxas de câmbio datadas são utilizadas em oportunidades, produtos de oportunidade e os relatórios associados a estes dois objetos.`,
"vue_label_file_upload_tip_newmsg":`Menos de {tamanho} O arquivo MB é recomendado para carregar, ou podem resultar problemas de carregamento lento.`,
"label.event.next.week":`Semana seguinte`,
"label.datamanage.import.contactfield":`Na tabela seguinte, selecione os campos no arquivo importado que devem ser importados em cada contato. Em seguida, clique em Next:`,
"label.projectManagement.time.allocated":`Tempo designado`,
"label_tabpage_isdeleteview":`Você tem certeza de apagar esta visão?`,
"label.pc.ui.2018.search":`PESQUISA...`,
"label.role.createrolelevel":`Criando a Hierarquia de Papéis`,
"label.tabpage.editview":`Editar vista`,
"label_partner_common_manageSetup":`Configurações administrativas da nuvem de parceiros`,
"label.service.gantt.noservice.resource":`Não foram encontrados recursos de serviço disponíveis sob o território de serviço selecionado.`,
"message.numbertoolarge":`O número é muito grande`,
"label.sendsms.success":`O texto foi enviado com sucesso`,
"UG.opportunity.009":`Ou`,
"label.ccpeak.construction.dataobj":`para construir um objeto de dados, o nome API do objeto deve ser passado em`,
"front-lighting-module-v1-detail-file-uploadInfo":`O registro está bloqueado e não está disponível para o upload de arquivos. Favor entrar em contato com o administrador para desbloquear.`,
"label.import.page2.newnotmatchfiled":`Um total de campos {{{{cm3}} no arquivo. {{{este.csvfiledlength - this.selectlength}}} não mapeado.`,
"label.ems.inputmailss":`Receber servidor de e-mail`,
"label.knowledgebase.data.published.successfully":`Publicar {a} dados com sucesso`,
"label_emailtocloudcc_position":`Posição`,
"label.data.exp.customexp":`Exportação personalizada`,
"component_chatter_post_button_user":`Acrescentar pessoas`,
"label.new.visualpagefolder":`Página Personalizada : Nova Pasta`,
"label.forecast.shrepage.classdes":`Descrição dos níveis de acesso`,
"label.task.overdue.unfinished":`Tarefas não processadas atrasadas`,
"label.ccchat.micropost.isedit.setting.info":`O autor do post ou comentário, o proprietário do registro, o moderador do CCChat e o moderador desta comunidade têm todos permissão para modificar este texto.`,
"label.recordname":`Nome do registro`,
"label.posted_your":`e afixado em seu`,
"label.globaloperation.operationtype.custom.page":`Página personalizada`,
"label_tabpage_busoppnamez":`Nome da oportunidade de negócios`,
"front-epwechat-module-v1-schedule-desc":`Sincronização dos horários da WeCom e eventos do CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`Com base no tempo de última modificação`,
"setup_layout_label_nofield":`Nenhum campo disponível`,
"label.sendemail.registIMUser.logininfo":`O portal de nuvem parceiro que você pode acessar é como abaixo:<br>`,
"label.weixin..xsld.kehu":`Contas`,
"label.display_thank":`Mostrar página de agradecimento`,
"label.group.no.my.group":`Não há correspondência no meu grupo.`,
"label.partnerCloud.newBuildSite.enterDomain":`Favor digitar o nome de domínio`,
"label.step1.total2":`Etapa 1 de 2`,
"label.ccpeak.delete.record":`Apagar os registros:`,
"label.customer.tab.step1.introduce":`Escolha o objeto personalizado para esta nova aba personalizada. Preencha outros detalhes.`,
"label_tabpage_newInterfacez":`A nova interface`,
"setup.mainpage.label.manageuser":`Gerenciar usuários`,
"label.partnerCloud.partnerAccount.completed":`Pagamento concluído?`,
"label.projectManagement.kanban":`Tarefa Kanban`,
"label.operate":`Ação`,
"label.service.dispatchingUnits.selected.time.range":`Exibir compromissos de serviço dentro do intervalo de tempo selecionado.`,
"component_setup_label_pagesize":`Números exibidos em cada página`,
"font-evaluate-module-v1-email-evaluation-settings":`Configuração de avaliação por email`,
"label.service.dispatchingUnits.skills":`Habilidade`,
"label.editrecurrencetimetrigger":`Edição do acionador de tempo periódico`,
"vue_label_file_edit_lib":`Editar biblioteca de arquivos`,
"label.campaignmember.selectmember.deleteconc":`Campanha: retirar membros dos contatos`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Segunda-feira`,
"front-detail-module-v1-by":`por`,
"label.mobile.home.page.date.signed":`Data de fechamento`,
"label.apply.send.success":`Enviar sucesso.`,
"label.app.choseimg":`Escolha o logotipo`,
"label.customsetting.visible":`Visibilidade`,
"label.sendemail.activity.task.distributetaskcompleted":`A tarefa que você designou para #belongtoidccname foi concluída.`,
"label.dashboard.snapshot.refreshing":`Refrescando`,
"label.document.name.already.exists":`Este documento já tem um nome único.`,
"label.ccchat.person.invite.needlastname":`Digite seu sobrenome`,
"pagecreator_page_button_copy":`Cópia`,
"label.appointmentpage.wizard.subtitle1-2":`Semana Anterior`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(data)`,
"label.profile.allowtocreateview":`Criar visões`,
"message.error.recordid":`A identificação do registro não pode estar vazia`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Voltar ao Papel Superior`,
"label.translation.start3":`Se necessário, selecione um objeto. Por exemplo, uma tarefa de fluxo de trabalho tem um objeto (Conta, Contato, etc.) para filtrar para termos traduzíveis.`,
"label.ccpeak.send.email":`Envie um e-mail para notificação:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Sem data de expiração`,
"label.permission.objectpermission.objpermission":`Configurações de permissão de objetos`,
"label.version.custom.report":`Relatórios padrão (página personalizada)`,
"label.title.qrcodeOrbarcode":`Gerar código de barras/código QR`,
"label.emailtocloudcc.step2.name":`Configurar a propriedade do e-mail`,
"label.reportsSubscription.edited.successfully":`Edite a assinatura do relatório com sucesso!`,
"label_tabpage_kanbansetup":`Configuração do painel de visualização`,
"label.tianyancha.regcapital":`Capital registrado`,
"front-epwechat-module-v1-web-single":`Logon único na Web:`,
"label.visualpage.display.top":`exibir cabeçalho, falso - não exibir cabeçalho`,
"label.customfields.fielddependency.selectcell":`Selecione pelo menos uma célula da lista abaixo`,
"label.paging.addmember.totalofpages":`Um total de {0} item(s)`,
"label.email.saveing":`Os dados estão economizando...`,
"label.userinfo.doublepwd.notnull":`Você deve repetir sua senha.`,
"label.appointment.wizard.subtitle4-4-2":`2 semanas`,
"label.chatter.BCC":`Bcc (cópia cega de cortesia)`,
"label.emailtocloudcc.description":`Conecte sua conta de e-mail empresarial, tais como sales@company.com, info@company.com, support@company.com. Registre automaticamente os e-mails que você recebeu como leads e registros de casos no CloudCC para garantir o acompanhamento oportuno das cartas dos clientes.`,
"label.sendemail.send.atlastone":`Você deve selecionar pelo menos um destinatário.`,
"label.mobile.phone.subordinate":`Incluir os subordinados`,
"label.data.choses.e_desc":`De acordo com suas necessidades, você pode exportar todos os dados ou exportar dados de um objeto.`,
"chatter.new":`Notícias`,
"vue_label_help_back":`Voltar`,
"label.skipwizardintro":`O Jump Start Wizard cria um processo de aprovação em uma etapa para você em poucos minutos.`,
"label.weixin.fmu.before.week":`{0} semana(s) adiante`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat gostou de seu posto`,
"lable.currencyAdv.andafterdate":`e depois`,
"label.sometoprocess":`Se apenas certos tipos de registros devem entrar nesse processo de aprovação, digite esse critério abaixo. Por exemplo, somente relatórios de despesas de funcionários da sede devem utilizar este processo de aprovação.`,
"label.campaignmember.main.updateleaddesc":`Atualizar o status de todos os leads de uma só vez`,
"label_partner_common_roleSetup":`Nuvem de parceiros e configurações do usuário`,
"label.console.step5.no":`Escolha Como os Registros são Exibidos`,
"label.salescloud.teamrole.optionlist.account":`Adicione um membro da equipe de contas a`,
"Report.Delete.Confirm.Title":`Por favor, confirme`,
"label.onclick":`Clique`,
"label.weixin.input.identifying.code":`Por favor, digite o código de verificação`,
"label.knowledge.translate":`Somente o artigo de conhecimento da edição principal no status de Rascunho ou Publicado pode ser traduzido.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Check in Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`E-mails adicionais`,
"label.icon.104":`Horário`,
"label.partnerCloud.exceedTwo":`A foto de perfil carregada não pode exceder 2MB!`,
"label_tabpage_thevalurofz":`O valor de`,
"front-lightning-module-v1-details-page-chart-maximum":`Podem ser inseridos até 50 caracteres.`,
"label.data.downpage.i.title.num6":`É recomendado importar um arquivo de teste contendo 5 registros antes de importar os dados para garantir que os dados que você deseja importar estejam corretos.`,
"label.ccpeak.update.record":`Modificar Registros`,
"label.dataimportandexport":`Importação e exportação de dados`,
"label.tabpage.notexceed25":`O registro selecionado não deve exceder 25`,
"label.starting":`Em andamento`,
"label.knowledge.language.spanish":`Espanhol`,
"label_emailtocloudcc_set":`Definir informações da caixa postal`,
"message.oneormoreneedsreport":`Favor apagar o painel de instrumentos de referência para o relatório e depois tentar novamente.`,
"label.attendance.xccheckin":`Check In`,
"label.emailmerge.editfolder.title":`Pastas de modelos para fusão de correio`,
"template.report.year.customer":`Leads deste ano`,
"label.partner.common.webSit.memo":`Nome de domínio padrão da nuvem de parceiros de sua organização:`,
"label.partnerCloud.financeSetting.onlinePayment":`Pagamento online`,
"Pagelayout.Setup.001":`Por favor, selecione as listas relacionadas que seriam exibidas no layout de flutuação.`,
"front-kefu-moudle-time-length":`Duração`,
"label.deleteObject":`O objeto é excluído.`,
"label.setup.mobile.homepageshortcuts.select":`Selecione 4 fucções rápidas para mostrar na área superior da __página inicial`,
"setup.mainpage.label.welcome26":`Gerenciamento de dados - Processamento em lote`,
"label.ServiceCloud.yuyuebainhao":`Nomeação de serviço nº.`,
"label.emailobject.emaildetail.button.addtolead":`Adicionar aos Leads`,
"label.event.single.view":`Visão de usuário único`,
"lable.product.pricebooks.ustand":`Escolha o preço padrão`,
"label.emailtocloudcc.department":`Departamento`,
"component_assistant_label_30daysnoact":`30 dias sem nenhuma campanha`,
"label.weixin.no.pending.qzkh.qin":`Desculpe, não há pistas para mostrar.`,
"label.vlidaterule.formula":`Fórmula de condição de erro`,
"label.tianyancha.h5.contact":`Informações de contato`,
"label.button":`Botões`,
"message.checkemail":`<forte>Error:</strong> há um erro em seu e-mail inserido, verifique por favor.`,
"lable.account.previous.CY":`CY Anterior`,
"label.icon.13":`Serviço`,
"chatter.coll.c":`Remover Bookmark`,
"label.knowledge.category.hint.four":`Alocação de categoria de dados`,
"label.tianyancha.phonenumber":`Número de telefone`,
"label.tablayoutedit.remark":`Selecione os campos e as páginas personalizadas exibidas na página inicial da guia.`,
"label.shareusers":`Compartilhe com os usuários`,
"label.endtime":`Fim`,
"label.length":`Comprimento`,
"label.umeng.activity.event.begin":`começar depois de`,
"label.tabpage.alltabs":`Todas as abas`,
"label.exact.query":`Buscas melhoradas`,
"label.weixin.skip":`Saltar para`,
"label.ems.cancel":`Cancelar`,
"label.trigger":`Gatilhos`,
"label.exchange.sync.setting":`Configuração do Exchange Sync`,
"label.product.pricebooks.name":`Nome do Livro de Preços`,
"label.relation.list.total":`Selecionado`,
"label.step2.total7":`Etapa 2 de 7`,
"label.martrixreport.2018.step6.new":`Passo 6 Selecione o tipo de gráfico e o item de destaque`,
"label.standard.buttonandlink.override":`Largura de sobreposição`,
"front-console-conversation-btn4":`Separar como novo caso`,
"vue_label_dashboard_range":`faixa`,
"label.app.sort.show":`A aplicação é exibida na ordem gravada.`,
"label.salescloud.teamrole.choose.correct":`Duplicação de usuários selecionados, favor corrigir`,
"label.schedule_post":`Publique`,
"front-kefu-moudle-server-request-num":`Lista de solicitação de serviços No.`,
"label.h5.logout":`Sair`,
"label.weixin.horse.club.member.message":`Informações sobre os membros da Aid-Max`,
"label.field.addoptionlist.introduce":`Insira um ou mais valores da lista de picking abaixo, com cada valor separado por uma nova linha.`,
"setup_layout_label_setupfield":`Propriedades de campo`,
"label.chatter.nextStep":`Próximo passo`,
"label.quickbooks.searchlist.total1":`Existem {0} faturas não vinculadas para um valor total de {1}`,
"label.tianyancha.h5.regcapital":`Capital registrado`,
"label.icon.184":`Assessoria`,
"label.dashboard.message.refreshtoomush":`A foto do painel é atualizada com muita freqüência, por favor, atualize-a mais tarde.`,
"label.umeng.approval.reject":`#approver rejeitou seu pedido de aprovação #obj.`,
"label.h5.chatter.newmessage":`Digite uma nova mensagem`,
"message.error.relationid":`relationid não pode estar vazia!`,
"label.setup.mobile.offlinecache.selectdefault":`Selecione as abas como abas padrão do cache offline`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Por favor, selecione 4 funções rápidas.`,
"label.projectManagement.Selectmonth":`Selecione o mês`,
"label.version.ultimate":`Edição final`,
"label.validate.remark5":`Os campos de data obrigatórios estão na ordem correta, por exemplo: a hora de início deve ser menor do que a hora final`,
"label.version.nowis":`Sua versão atual do CloudCC é`,
"front-kefu-moudle-CRM-set":`Configuração de CRM`,
"label.mr.title.customerAddress":`Endereço da conta`,
"label_emailtocloudcc_step1_name":`Escolha a função`,
"label.time.operation.edit":`Modificar os empregos programados`,
"label_tabpage_operationz":`Campo, a operação não pode estar vazia`,
"label.translation.start4":`Clique duas vezes na coluna de tradução para inserir novos valores.`,
"vue_label_systemSettings_request":`Pedido de Transferência de Lote`,
"label.maintenance.notice":`Aviso de manutenção`,
"label.customfields.txet.textlength.tip":`Favor inserir o comprimento máximo para um campo de texto abaixo E o comprimento máximo é de 255 caracteres.`,
"label.ccdocument.select.template.open":`Favor selecionar o modelo a ser aberto.`,
"vue_label_display_date_field":`Mostrar campos de datas`,
"label_partner_workspace_tab":`Tab`,
"lable.account.LasthDays":`Últimos 120 dias`,
"chatter.using.sticker":`Habilitar o rastreamento de alimentação`,
"message.save.dataerror":`Erro: salvar erro causado por longo comprimento de dados ou outros problemas. Por favor, modifique os dados para salvar novamente.`,
"vue_label_commonobjects_view_chart_newchart":`Novo quadro`,
"label.chat.micropost.a.group":`Grupo`,
"lable.currencyManage.advcurrencyunEnabled":`O Gerenciamento Avançado de Moeda não está habilitado`,
"label.appexchange.workflow":`Regras de fluxo de trabalho`,
"vue_label_calendar_show_details_and_add_events":`Mostrar detalhes e adicionar eventos`,
"label.salescloud.optionlist.inputname":`Por favor, digite o nome do valor da lista de seleção`,
"label.dashboard.folder":`Folders`,
"label.knowledgebase.permanently.remove.articles":`A eliminação do artigo arquivado também causará a eliminação permanente de outras versões relavantes.`,
"label.emailtocloudcc.titel":`Email para CloudCC`,
"label.visualpage.sel":`Páginas Personalizadas Nesta Pasta`,
"label.planned.all.work":`Todos os Trabalhos Planejados`,
"label.weixin.agree.agreement":`Concordar com o acordo relevante`,
"label.forecast.customforecast.qsn":`Ano de início`,
"label.appupload.managed":`Controlado`,
"template.report.folder.sale.index":`Análise de indicadores de vendas`,
"UG_opportunity_011":`Transação de importação`,
"label.validate.function.funcFormat.SECOND":`SEGUNDO(data)`,
"UG_homepage_005":`Inteligência de vendas`,
"label.clicktoreturn":`Clique aqui para voltar`,
"label.collectionofview":`Conjuntos de Vista`,
"com.cloudcc.login.error.message.nonuser":`Sua identificação não existe`,
"vue_label_systemSettings_emailsetting":`Configuração de email`,
"vue_label_email_mark_as":`Marcar como`,
"label.tabpage.customernamez":`Nome do cliente`,
"label.appupload.install.apicannotsame":`O novo nome da api não pode ser o mesmo que o valor original`,
"label.task.all.undealt":`Todas as tarefas em atraso não processadas`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Índice estatístico`,
"UG.quota.02":`Mudança de estágio de oportunidade`,
"label.approve":`Aprovar`,
"vue_label_calendar_remove_calendar":`Remover Calendário`,
"label.mr.title.contactName":`Nome para contato`,
"label.projectManagement.resource":`Gestão de recursos`,
"label.rejectbehaviour1":`Permitir que o aprovador escolha manualmente o número do passo de volta.  (voltar à etapa anterior N)`,
"label.publicgroup.relationship":`Participação em grupo`,
"Lead.Scoring.DetailedPage.Popup.Title":`Insight de chumbo`,
"label.owner.edit":`Proprietário Editar`,
"label.campaign.channel.ticket.mark":`NOTA: Salve o código QR no álbum de fotos usando a captura de tela do telefone celular ou salveo no telefone celular e digite a campanha com o código QR.`,
"label.opportunity.setting.showstage.info":`Se mostrar o palco de oportunidades no aplicativo CloudCC.`,
"label.emailobject.wizard.desc3":`Economize tempo usando modelos de e-mail`,
"label.cpq.quote.no.product.add":`Nenhum produto adicionado na cotação. Favor adicionar produto antes de gerar pedidos.`,
"label.customer.tab":`Separadores personalizados`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Data de encerramento do estágio atual`,
"component_telerecord_label_name":`Nomes`,
"label_component_helper_nodata":`Nada precisa de sua atenção neste momento. por favor, verifique mais tarde.`,
"label.dashboardSetup.d2":`Ponto de parada 2`,
"setup.mainpage.label.welcome4":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Object.`,
"label.step4.total5":`Passo 4 de 5`,
"label.payment.the.remaining.days":`Sua licença expira em {0} dias`,
"label.encoding":`Codificação`,
"label.setting.intergrationlist.status2":`Esta integração está atualmente instalada.`,
"label.new":`Novo`,
"label.search.searchsetup":`Configurações de busca`,
"label_tabpage_printz":`Imprimir`,
"report.type.label.customService":`Suporte ao cliente`,
"label.notification.addEmailObject.message":`Você recebeu um e-mail de {!fromaddress}, clique para ver mais detalhes`,
"label.icon.68":`Máquina`,
"UG.Lead.003":`Social`,
"label_mobile_default_field_service_home":`Página inicial do Service Cloud`,
"label.select.one.group":`Por favor, escolha pelo menos um grupo de linhas de cotação.`,
"front-kefu-moudle-trkey-nopower":`O par de chaves da Tianrun não tem permissões atribuídas`,
"label.chatter.cancel":`Cancelar`,
"label.weixin.report.optiondisplay":`Mostrar`,
"front-kefu-moudle-v1-System-version":`Versão do sistema:`,
"lable.product.pricebooks.editall":`Editar tudo`,
"label.group.no.recent3":`ou`,
"label.knowledge.article.delete":`Erro ao apagar o artigo de conhecimento.`,
"label.relateobj":`Relacionado a`,
"workflow.action.tasks.assignortype.type":`Tipo`,
"label.layout.selectedfields":`Campos Selecionados`,
"label.role.assign.operate":`Atribua outros usuários a esta função:<ul>>li>Clique na lista suspensa para visualizar todos os usuários disponíveis.</li>>li>Selecione um usuário na lista "Usuários Disponíveis" à esquerda e adicione-os à lista "Usuários Selecionados".</li></ul>`,
"label.field.insert":`Inserir campo`,
"label.icon.11":`Pessoas`,
"label.group.no.recent4":`iniciar um grupo.`,
"front-epwechat-module-v1-input-corpid":`Favor entrar Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Por favor, selecione primeiro um campo de controle.`,
"setup.mainpage.label.welcome19":`Instruções:  Clique no menu do lado esquerdo desta página → Manage Settings → Manage Users → Users, Roles, Profiles`,
"label.escalation.setup.list.rulename":`Nome da Regra`,
"label.ems.addaccount":`Adicionar conta agora`,
"label.reportsSubscription.details.only":`Somente detalhes (formato Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Agrupar por`,
"label.email.form.text":`Somente texto`,
"label.weixin.loginname":`Nome de Login`,
"label.forecast.settings.sr":`Receita`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} postagens publicadas para todos em {1}`,
"label.ccchat.enter.subject":`Favor entrar o assunto da votação`,
"label.customer.tab.introduce":`As abas de objetos personalizados parecem e se comportam como as abas padrão fornecidas com o CloudCC.`,
"message.login.mfaverification.wrong":`Erro de código de segurança.`,
"component.newrecords.label.name":`Nome`,
"label.salescloud.opportunity.addandedit.contactrole":`Adicionar e editar funções de contato`,
"label_emailtocloudcc_button_next":`Próximo`,
"label.console.step5":`Passo 5 Escolha como os registros são exibidos`,
"setup.main2018.label.norole":`Você não tem as permissões administrativas`,
"template.chart.ywjhqd":`Estágio de Oportunidade de Negócios`,
"label.instrumentPanel.breakpointOneLabelname":`Este valor deve ser maior do que o valor mínimo.`,
"label.qrcode":`Código QR`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`O ciclo de uma consulta não pode ser maior do que {c} meses.`,
"label.console.step7":`Passo 7 Atribuir perfil`,
"label.australian.central.standard.time":`Horário Padrão Central Australiano （Northern Territory）`,
"label_tabpage_deleteviewfailed":`Ver exclusão falhou`,
"vue_label_commonobjects_view_searchview":`Pesquisar nesta visão`,
"message.error.object.notexists":`O objeto não existe.`,
"label.tablecell":`Células`,
"vue_label_notice_edit_success":`Editar com sucesso`,
"label.customer.language":`Idioma padrão`,
"label.csrf":`Ativar a proteção de segurança csrf`,
"label.forecast.customforecast.submit.zhi":`para`,
"label.sso.saml.idp.config.desc2":`Clique em Enable Identity Provider para habilitar sua organização CloudCC.com como um provedor de identidade.`,
"label.export_data":`Dados de exportação`,
"component.todaytask.label.all":`Ver tudo`,
"label.h5.chatter.record":`Histórico`,
"front-vew-email-verification":`Ver email e verificar conta. Você só pode fazer o login depois de confirmar o email.`,
"laber.marketsea.del.error":`O pool de chumbo está ocupado e não pode ser apagado`,
"vue_label_notice_homepage_entername":`Por favor, digite o nome modificado`,
"UG.Forcast.01":`Previsão`,
"front-email-payment-tips":`O valor da fatura está vazio. Favor iniciar o pagamento online depois de preencher o valor da fatura.`,
"setup.mainpage.label.welcome2":`Base de dados personalizada (objeto)`,
"APPIntegration.Social.facebookerror":`Você deve digitar um URL válido para facebook.com`,
"label.profile.mobile.setup.stand":`Página inicial padrão`,
"label.custom.CY":`Ano Alfandegário`,
"label.knowledgebase.publishing.conditions":`Puxar {a} os dados falharam, eles estão fora do critério de publicação!`,
"label.tianyancha.description":`Permitir que TianYanCha verifique a verificação dos dados industriais e comerciais. Este serviço suporta os dados comerciais registrados na China Continental.`,
"label.appexchange.uninstallpage.title":`Desinstale o pacote irá\uff1a`,
"label.currencyRate":`Taxa de conversão`,
"setup_layout_label_areashow":`Cabeçalho da Seção de Display On`,
"label.setup.case.setting":`Mini Programa para o caso`,
"vue_label_commonobjects_view_fixed_at_most":`Apenas três colunas podem ser fixadas, no máximo`,
"template.report.month.income":`Receita deste mês`,
"label.sms.companyname":`Nome da empresa`,
"label.sendemail.registIMUser.waitmessage":`Infelizmente, você não tem um portal em nuvem parceiro que você pode acessar. aguarde, nosso administrador irá notificá-lo mais tarde. você pode visitar o endereço especificado para entrar na página de login. use o nome de usuário e a senha acima para fazer o login.`,
"label.custom.field.task.object":`Uma tarefa designada a você. Tarefa abjeta:`,
"message.pleaseselectdayinweek":`Por favor, selecione um dia da semana.`,
"label.chat.topic.favorites":`Favoritos`,
"UG.Campaign.004":`Campanha de importação`,
"label.approval.preview":`Pré-visualização do processo`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Escolha o idioma de destino e atribua o artigo à pessoa em questão ou à fila. A exportação de tradução geralmente é atribuída a uma fila e os artigos traduzidos internamente vão para uma pessoa.`,
"pagecreator_systemstyle_message_save_success":`Estilo salvo com sucesso`,
"label.outline":`Esboço`,
"label.read.only.field":`Campos somente leitura`,
"front-gantt-module-v1-early-warning":`Advertência antecipada`,
"label.file.ccchat.selectfrompc":`Selecione um arquivo de seu computador`,
"vue_label_systemSettings_social":`Mídias Sociais`,
"label_report_year_last_year":`Ano após ano`,
"lable.PowerProcess.Meet.the.conditions":`Os seguintes critérios devem ser atendidos:`,
"label.changemydisplay.list.title":`Mostrar`,
"UG_Forcast_03":`Iniciar o planejamento e executar estratégias comerciais. <br>Desejo-lhe uma boa previsão!`,
"label.sendemail.chat.sendmessage":`Prezado #nome:{\i1}olá! #userName:{nome do usuário:} enviou-lhe uma mensagem.`,
"label.huanxinconfig.secretid.lost":`o segredo não pode estar vazio`,
"label.icon.49":`Geração de energia`,
"chatter.feed.button.publish":`Compartilhe`,
"label.power":`^Potência`,
"label.partnerCloud.financeSetting.informationThree":`3. Após entrar na página de gerenciamento de chaves secretas, clique em mapi Gateway Product Key, e adquira a ID do parceiro e a chave secreta MDS.`,
"label.emailtocloudcc.step1.lead2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registrados como registros de chumbo no CloudCC. Assegure-se de que nenhum negócio seja perdido.`,
"label.knowledgebase.delete.draft.succeeded":`Eliminar a minuta com sucesso`,
"label.dashboardSetup.title":`Editor de componentes`,
"label.trigger.operation.email.template.map":`Voltar às informações do modelo, assunto do e-mail: m.get("assunto"); conteúdo do e-mail: m.get("contexto"); se o tipo de e-mail é texto: m.get("istext")`,
"label.dependencesearchfilter":`Filtros de pesquisa relacionados`,
"label.selected.search.length":`Não mais do que 10 campos de busca selecionados`,
"label.profile.commonusercontrol":`Permissões gerais do usuário`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`App`,
"label.customsetting.manage.position":`Localização`,
"vue_label_systemSettings_bindweb":`Web Bind`,
"label.loginservice.license.notexist":`A licença não existe.`,
"label.icon.43":`Sinos`,
"UG_homepage_003":`Visão 360 graus`,
"label.file_format":`Formato do arquivo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Domingo`,
"vue_label_chatter_post_has_delete":`Post foi apagado`,
"report_label_searchresult":`Resultados da busca`,
"label.tabpage.justsz":`Apenas`,
"Lead_Scoring_Setting_LevelSetting":`Configurações de Popularidade de Liderança`,
"setup.object.field.dependency.label.selectedfieldvalue":`Valores de campo disponíveis`,
"label.search.morelistview":`Mais vista da lista`,
"vue_label_homepage_won":`Fechado`,
"label.notification.last30days":`Últimos 30 dias`,
"vue_label_helpcenter_pool":`Use o pool de leads e o pool de contas para gerenciar seus dados de vendas.<br>Configurar o pool de contas<br> Criar o pool de contas em segundo plano, configurar os administradores e membros do pool de contas e configurar as regras de reciclagem automática em atraso, o que é conveniente para gerenciar a situação de acompanhamento de oportunidades dentro de sua equipe e incentivar os membros da equipe a acompanhar ativamente.<O administrador do pool de contas pode realizar operações como distribuição, reciclagem, descarte e transferência de registros no pool de contas e gerenciar os registros no pool de contas de forma unificada;<br> Os membros do pool de contas podem receber registros não alocados ou visualizar os registros pelos quais são responsáveis.`,
"label.emailsync.status.export":`Exportar como arquivo em formato Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Carrossel`,
"label.service.miniProgram.slideshowName":`Nome do Carrossel`,
"label.fieldupdate.selectobj":`Defina o objeto associado à atualização do campo, depois clique em Next. As atualizações de campo só podem ser associadas a regras de fluxo de trabalho e processos de aprovação do mesmo tipo.`,
"label.ccpeak.take.notice.sharetab":`Aviso: os campos na expressão do formulário compartilhado não exigem a adição de "__c".`,
"label.log.startdate.after.endate":`A hora de início não deve ser posterior à hora de término.`,
"label.rememberme":`Lembre-se de mim`,
"label.partner.all.maxNum":`Maiores dados de nuvens de popa:`,
"component.setup.iframe.label.inputurl":`Digite o endereço url`,
"label.h5.systemmessage":`Mensagem do sistema`,
"label.delete.date":`Apagar Data`,
"front-email-payment-select-month-tips":`Favor escolher MM`,
"front-kefu-moudle-bind-userinfo":`Informações sobre o usuário do Bind`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`O número de dígitos de chumbo não pode ser maior do que o número de dígitos de campo mapeados.`,
"label.event.dayview":`Visão do dia`,
"label.replace":`Substitua`,
"label.knowledgebase.search.knowledge.articles":`Artigo de Pesquisa de Conhecimento`,
"component_event_label_soon":`Imediatamente`,
"label.imgfield.upload":`Carregar imagem`,
"message.printable.view":`Vista para impressão`,
"vue_label_notice_uploadavatar_notice1":`O tamanho da imagem do avatar carregado não pode exceder 2MB`,
"label.visualpage.developer.help":`Ajuda ao desenvolvedor da página personalizada`,
"label.validate.function.funcFormat.IF":`IF(teste_lógico, valor_se_verdadeiro, valor_se_falso)`,
"label.sso.saml.sp.description1":`Configurações de Single Sign-On`,
"vue_label_calendar_step_1":`Etapa 1: Nomear o Calendário`,
"component.telerecord.button.save":`Salvar`,
"setup_mainpage_button_manageobject":`Gerenciamento de Objetos`,
"label.marketingactivityinfluence":`Influência da campanha`,
"label.quote.bjjsxx":`Informações sobre a aceitação de cotações`,
"label.appupload.upload.install.retry":`Reinstale`,
"label.layout.assignrules":`Regras de Atribuição`,
"UG.Lead.006":`Visitante do site`,
"label.workmate.searchs":`Buscar colegas`,
"label.visualpage_list.no":`Sem permissões de acesso às páginas personalizadas`,
"label.service.miniProgram.slideshowintroduce":`O nome do carrossel é usado apenas para identificar várias entradas de anúncio e não é exibido no anúncio.`,
"label.multilang.messagedetail.search.desc":`Não conseguimos encontrar uma mensagem com {0}:`,
"label.mobile.phone.read.note":`Por favor, digite as notas aqui`,
"label.passwordPolicy.setup.isUsingGotp":`Habilitar Login Verificação Secundária`,
"message.datetypeerror":`<forte>Error: </strong> Data inválida.`,
"label.searchlayout.listview.button":`Botões exibidos em vistas de lista.`,
"label.sectionpart":`Seção`,
"label.partnerCloud.basicSetting.userSetting":`Funções e configuração dos usuários`,
"System_Data_Import_Warning_MaxCount":`Sua organização só pode importar {0} dados de cada vez, o que agora está fora do limite, favor ajustar e reimportar.`,
"label.datamove.qualified.record":`registro(s) qualificado(s), cada vez pode transferir no máximo 100 registros`,
"component_task_label_priority":`Prioridade`,
"vue_label_report_me":`Eu`,
"label.college.duplicate.option":`As opções não podem ser repetidas!`,
"label.pw.letter":`Cartas`,
"label.file.sharedwithme":`Compartilhado comigo`,
"label.translation":`Traduzir`,
"lable.currencyAdv.exchagecurrency.before":`e antes`,
"label.file.share":`Compartilhe`,
"label.page.next":`Próximo`,
"label.autoRegister.changepwd.setpwd.notmatch":`Duas senhas são inconsistentes`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Obrigado`,
"vue_label_help_helponthispage":`Ajuda nesta página`,
"label.approvepagelayout":`Layout da página de aprovação`,
"vue_lightning_help_zero_distance_communication":`O suporte on-line ajudará você a economizar tempo entrando em contato com os especialistas do serviço CloudCC com distância zero.`,
"vue_label_normal_case_sf":`Caso`,
"label.report.line.tuozhuai":`Por favor, arraste e solte, ou clique duas vezes para selecionar a coluna de relatório e ajustar seus pedidos`,
"template.dashboard.management":`Gerenciamento de operações`,
"label.customcomponent.params.info.n1":`O valor "args" do "args" na etiqueta "componente" está no formato "json", por exemplo: args="name:'zhang',age:26", Em bloco de código cc, usar: String myName = nome; int myAge = idade;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Taxa de compromisso assinada`,
"label.add.status":`Adicionar status`,
"label.loss.customers":`Fechado / Conta Perdida`,
"vue_label_chatter_involving_me":`Envolvido`,
"label.update.input":`Por favor, corrija a entrada`,
"label.import.step1.commonobj":`Objetos gerais`,
"label.appupload.upload.tips.document":`Nota: documentos em "minhas pastas pessoais" e "modelos de pastas vermelhas" não podem ser adicionados ao pacote, nem podem ser exibidos nesta lista.`,
"label.appupload.install.complete":`Completo`,
"label.console.edit":`Console Editar`,
"setup.object.field.dependency.label.removefromlist":`Remover valores selecionados`,
"label.textmessage.groupsms.no.phone":`Sem telefone`,
"label.account.Current.and.NextFQ":`FQ atual e FQ seguinte`,
"label.sso.saml.sp.idtype.userid":`Assertion contém o ID do usuário do objeto do usuário`,
"label.data.import.setup.operate.update":`Atualizar os registros existentes, não inserir novos registros`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center integrado com AWS (Amazon Web Service) para fornecer serviços SaaS mais abrangentes`,
"label.version.bacheditordel":`Edição/eliminação/transferência em massa`,
"lable.even.higher":`Superior`,
"label.datetime.error":`O formato da data está incorreto`,
"vue_label_commonobjects_detail_customer_hierarchy":`Hierarquia de clientes`,
"label.startuploadfile":`Iniciar o Upload`,
"label.appointment.wizard.subtitle3-1":`Segunda-feira`,
"label.weixin.relevance":`Oportunidade associada`,
"label.datamanage.field.mapping.information":`Mapeamento de campo de configuração`,
"label.brief.lastweek":`Semana passada`,
"label.nextstep":`Próximo passo`,
"label.listtoshow":`Uma lista de processos de aprovação ativos e inativos para {0} é exibida abaixo.`,
"label.partner.ishave":`Erro: o domínio já existe`,
"label.service.miniProgram.name":`Favor preencher o nome.`,
"label.view.filterbyaddition":`Filtrar por campos adicionais (Opcional):`,
"label.projectManagement.nodata.task":`Sem registros de tarefas. Vamos adicionar informações sobre as tarefas!`,
"label.chooseemailtemplate":`Selecione o modelo de e-mail`,
"label.page.step4.add.profile":`Etapa 4 Adicionar aos perfis`,
"label.ems.mailtype":`Tipo de correio`,
"label.weixin.no.pending.projects.vg":`Bom trabalho, sem itens de aprovação pendentes`,
"label.tabpage.saveviewfailed":`A visão salvar falhou`,
"label.chat.file.upload.cancel":`Cancelar upload`,
"com.cloudcc.login.error.message.notenabled":`Sua identificação não ativada`,
"label.data.import.setup.operate.insertandupdate":`Atualizar os registros existentes e inserir novos registros`,
"label_target_type":`Tipo de objetivo`,
"label.notification.event2":`【被分配人】 visualizou o evento que você designou`,
"chatter.feed.menutype.feed.news":`O que eu sigo`,
"label.import.page1.suitedwayofcustomer":`Estilo de correspondência com o cliente`,
"label.import.page2.CloudCCfiled":`Campo CloudCC`,
"label.custom.quarter.start":`Trimestre Personalizado Data de Início`,
"label.page.including.tab":`Incluindo abas`,
"label.mobile.phone.day.plan2":`Hoje`,
"template.report.lead.conversion.statistics":`Estatísticas de Conversão de Leads`,
"label.show.type":`Tipo de Display`,
"label.weixin.no.pending.wdgz.qin.week":`Nenhum trabalho programado para esta semana.`,
"2018UI.Homepage.DataDeleted.Info":`Os dados que você deseja visualizar foram excluídos, por favor clique para voltar ao passo anterior.`,
"label.vlidaterule.message":`Mensagem de erro`,
"label.approval.remark":`Parecer de aprovação`,
"label.field.duplicate1":`Único`,
"label.batchtransfer":`Transferência em massa`,
"label.quickbooks.view.allinvoices":`Todas as faturas`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Marcar como status atual`,
"label_home_page_source":`Por favor, selecione a fonte de dados.`,
"front-kefu-moudle-v1-opencall-please":`Favor ativar o call center e depois configurar`,
"setup_layout_label_asc":`Ascendente`,
"label.use_tikect":`Usar o Ingresso de Admissão?`,
"label.tag.setup":`Configurações da etiqueta`,
"label.existinglayout":`Layout de Página Existente`,
"label.productsales.today.noevt":`Não há eventos abertos.`,
"message.error.view.date.validerr":`Favor inserir o formato da data válida (AAAA-MM-DD、MM/DDD/AAAAA) ou caracteres de data especiais`,
"label.mr.descreption.oneGroupReData3":`tem que lidar com o`,
"label.tianyancha.businessverify.msg1":`Com a função de verificação de dados comerciais habilitada, os usuários devem ler cuidadosamente e compreender plenamente os termos deste "contrato de licença de usuário" (doravante denominado "contrato"), incluindo a isenção de responsabilidade da beijing shenzhou yundong customer co., ltd. (doravante denominado "CloudCC") e as restrições do direito do usuário. por favor, leia-o cuidadosamente e opte por aceitar ou não este acordo.`,
"label.custom.CQ":`Trimestre personalizado`,
"label.version.custom.dashboard":`Painel de Controle Padrão (Página Personalizada)`,
"vue_label_commonobjects_detail_dragtoupload":`Arraste seu arquivo aqui, ou <em>clique e carregue</em>`,
"label.tabpage.addadvancedoptions":`Adicionar opções avançadas`,
"front-kefu-moudle-v1-Launch-page":`Página de aterrissagem:`,
"label.emailobject.tabname":`Email`,
"label.weixin.addmore":`Adicionar mais`,
"message.error.view.operator.validerr":`Operador inválido`,
"label.another_page":`Redirecionar para outra página`,
"label.reportTypeFocusD2":`Exemplo: Se informar sobre "Contatos com oportunidades com parceiros", selecione "Contatos" como o objeto principal.`,
"label.icon.47":`Barômetro`,
"label.task.today":`Hoje`,
"label.service.gantt.weekend.highlight":`Destaque o fim de semana`,
"label.customcomponent.referencetagname":`Nome do separador`,
"label.senderemail":`Endereço de e-mail do remetente`,
"label.defaultvalue":`Valor padrão`,
"label_tabpage_Sdfez":`dias`,
"pagecreator.page.label.pagename":`Nome da página`,
"vue_label_report_pagenumber":`Número de página no intervalo`,
"label.emailsync.connectaccount.description":`Adicione sua caixa postal pessoal aqui, e o CloudCC combinará automaticamente os contatos e leads no sistema de acordo com seus endereços de e-mail, sincronizando o conteúdo do e-mail com os registros para facilitar o rastreamento e a comunicação.`,
"label.schedulableprg.chooseweek":`Favor selecionar a data de cada semana`,
"lable.edit.queue.membercanuse":`Membros disponíveis`,
"lable.Quick.find":`Rápido olhar`,
"label.daynuminmonth":`Dia(s) do(s) mês(s)`,
"message.error.state":`O estado não pode estar vazio!`,
"label.introduction.the.form":`Descrição`,
"label.batchtransfer.pleaseselectcomefromuser":`Transferência de`,
"front-dashboard-module-implemented":`Realizado`,
"label.custombutton.newerror":`Novas criações falharam`,
"label.version.allow.size":`Se necessário, favor atualizar a versão CloudCC.`,
"label.weixin.account.loginpage":`Página de Login de Segurança da Conta`,
"message.pleaseselectfieldtype":`Por favor, selecione o tipo de campo`,
"component.setup.label.parentobject":`Objeto superior`,
"System.TAB.SeeViewAmount":`Ver Totais`,
"label.event.lastmonth":`Último mês`,
"label.taskrecordtype":`Tipos de registro de tarefas`,
"label.layout.selectedpages":`Páginas selecionadas`,
"label.appointmentdetail.wizard.title19":`Plano de sábado`,
"label_chatter_endData":`Data de término`,
"label.appupload":`Pacotes`,
"label.knowledgebase.article.link":`Artigo vinculado`,
"label.licence.enddate":`Data de Vencimento`,
"chatter.fieldtrack.record":`registro`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Semanalmente`,
"label.forecast.editshrepage.title2":`Compartilhando Edição`,
"label.attendance.onwork.time":`Início do dia`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Layout do upload`,
"label.input.notless.than.number":`Favor inserir um número maior ou igual a {0}.`,
"setup.mainpage.label.welcome13":`Instruções: Clique no menu superior → Relatórios → Novo`,
"label.forecast.settings.data.opp":`Data de encerramento da oportunidade`,
"vue_label_display_checkbox_field":`Mostrar os campos da caixa de seleção`,
"label.summaryreport.2018.step5":`Passo 5 Selecione o tipo de gráfico e o item de destaque`,
"front-lightning-module-v1-dashborad-one-statistic":`Favor escolher pelo menos um valor estatístico e tipo estatístico`,
"label.home.standard.dashboard.forcase":`Não é permitido fazer previsões e não é possível visualizar o painel de compromisso de vendas.`,
"page.field.track":`Histórico de rastreamento de campo`,
"label.dataimport.format.datetime.error":`Erro de formato, favor usar yyyy/MM/dd HH:mm:ss ou yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Escolha o Livro de Preços`,
"pagecreator_systemstyle_label_stylename":`Nome do estilo`,
"label.projectManagement.nodata.project":`Nenhum dado relacionado. Por que não criar projetos relacionados a mim?`,
"label.start_below":`Comece a compartilhar seu formulário com os contatos. Seu formulário foi publicado com segurança e está pronto para uso no endereço web abaixo.`,
"label.campaignmember.main.delete":`Membros da campanha de remoção em massa`,
"label.modifyall":`Modificar tudo`,
"label.homepage":`Página inicial`,
"vue_label_pool_adoptedbyme":`I Coletado`,
"label.email.clearItem":`Somente os e-mails sem itens associados são liberados.`,
"label.callcenter.login.Amazon.connect":`Fazer login na Amazon Connect`,
"label.import.page1.selectimportfiled":`Selecione o arquivo a importar`,
"message.error.id":`id não pode estar vazio!`,
"label.ggReleaseRange.searchUsers":`Pesquisar usuário parceiro`,
"label.changemypwd":`Alterar minha senha`,
"label.ccpeak.reference.parameters":`Os parâmetros que podem ser referências diretamente são:`,
"chatter.share.success.tip":`Sucesso! você compartilhou este posto para`,
"label.message.checkfailed":`A verificação da sintaxe falhou, o nome da classe existe.`,
"label.shangqing.introduction":`Integrar e analisar os recentes eventos quentes de leads ou clientes para ajudar o vendedor a entender os clientes de forma mais abrangente`,
"label.allemailnotice":`Todos os alertas por e-mail`,
"vue_label_report_copy":`Copiar relatório`,
"label.exchange.sync.state.setting":`Configurações de configuração`,
"label.merge.result.error1":`O seguinte registro é bloqueado, e nenhuma operação de "fusão" é permitida`,
"label.process.des":`Clique no link à esquerda para ver detalhes do registro atual.`,
"label.textmessage.vonage.create.lead.setting":`Criar novos contatos quando receber texto de números que não estão no sistema`,
"label.views":`Vistas`,
"label.notification.tip1":`Notificações`,
"label.forecast.detailforecast.returnforecast":`Voltar para Previsões`,
"label.knowledgebase.target.framework.name":`Nome da armação alvo`,
"label.brief.close.opportunities":`Fechado - ganho`,
"label.appointment.wizard.subtitle4-2":`O tempo mais curto para reparar em você`,
"vue_label_systemSettings_set_record":`Configurar o modo dispaly da lista relacionada, tentando alternar entre o Modo Cartão e o Modo Lista.`,
"pagecreator_page_message_publish_fail":`A publicação da página falhou`,
"vue_label_homepage_name":`Nome da página inicial`,
"label.weixin.no.pending.wdgz.qin.month":`Você não tem nenhuma programação programada para esta semana.`,
"label.campagin.register.page":`Página de registro de membro da campanha`,
"label.campaign.channel.edit":`Campanha: Canal de Marketing Editar`,
"label.folder":`Folder`,
"label.umeng.chatter.follow":`o seguiu.`,
"label.sso.theKeyToEdit":`Edição chave`,
"label.deletelayout":`Excluir layouts de página`,
"label.same.analyze.miaoshu":`A relação entre as condições acima é: "Nome da oportunidade" ou "Nome da conta" ou ("Contato móvel" e "E-mail de contato");`,
"label.ccpeak.sel":`Aulas nesta pasta`,
"label.tabpage.addtoworkbench":`Adicionar à bancada de trabalho da página inicial`,
"label.forecast.shrepage.classdes.r":`Somente leitura - O usuário pode ler os dados de previsão.`,
"homepage.custompagename":`Nome da página inicial personalizada`,
"label.sendemail.batchapprovalinfo":`Olá #nome: A operação de aprovação de lote que você realizou foi bem sucedida, com um total de #successnum aprovado com sucesso e #errornum falhado.`,
"front-email-payment-Invoice-alipay-describe":`Pagamento seguro e confiável`,
"setup.object.field.dependency.label.configured":`Layouts de página atribuídos ao Perfil`,
"label.potentialcustomers":`Líderes`,
"label.timetrigger.button":`O botão de disparo de tempo adicional não está disponível nos seguintes casos:`,
"label.category.10":`Advogado`,
"label.selectall":`Selecione Todos`,
"message.field.id.not.null":`A identificação do campo não pode estar vazia.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Favor entrar`,
"label.author":`Autor`,
"label.import.step1.csvonly":`1. Somente o arquivo em formato csv é suportado, e registros até {recordnumlimit} podem ser importados por uma vez. Até 2.000 registros podem ser importados se você precisar executar o gatilho. Os registros que excederem o limite serão automaticamente ignorados pelo sistema. Se você quiser importar mais dados, divida-os primeiro em vários arquivos e importe-os em momentos diferentes. .`,
"label.assignment.setup.newrule.name":`Nome da Regra`,
"label.campaignmember.selectmember.chosestatusdesc":`Por favor, selecione a campanha à qual deseja adicionar membros e edite o Status de Membro da Campanha. Crie uma nova campanha, você deve sair deste processo.`,
"label_tabpage_operation":`Operação`,
"label_tabpage_datatyoez":`Tipo de dados`,
"UG_product_04":`Criar produto`,
"label_emailtocloudcc_step1_case2":`Uma vez configurado, os e-mails recebidos nesta caixa de correio serão automaticamente registrados como registros de caso no CloudCC. De acordo com a caixa de saída, relacionar o caso ao contato e conta correspondentes, de modo a facilitar a aceitação e o acompanhamento dos casos.`,
"workflow.action.tasks.assignortype.role":`Papel`,
"vue_label_notice_refreshi_success":`Refrescar com sucesso`,
"label.notification.arketsea.abandon":`descartados {5} {2} {0}：{1}`,
"label.icon.36":`Computador`,
"chatter.group.cancelToJoin":`Cancelar para aderir`,
"label.publicgroups.edit":`Edit Public Group`,
"message.duplication.label.letternum":`Bocados de caracteres correspondentes`,
"label.brief.lost.opportunities":`Perdido`,
"setup.layout.label.nofield":`Nenhum campo disponível`,
"label.dataimport.isSharingRule":`Aplicar as regras de compartilhamento`,
"vue_label_opportunity_contactrole_synctocontacts":`Sincronizar informações para contatos`,
"attachment_button_massdownload":`Download em massa`,
"label.weixin.agreement.remark":`Este serviço WeChat é a ferramenta assistente do serviço de consultoria Aid-Max para os clientes, não é a base final para as companhias de seguros liquidarem reclamações, e as reclamações dos clientes devem ser liquidadas de acordo com as exigências ativas das companhias de seguros.`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ construtor / biblioteca de layout`,
"label.ccdocument.online.edit":`Edição on-line de documentos`,
"label.partner.setup.Enable":`Verifique`,
"label.log.state":`Status de ação`,
"label.lower.bound":`Baixo Limite`,
"label.timezone.isenable":`Habilitar usuário fuso horário múltiplo, depois permitir que o usuário defina fuso horário, e exibir data/hora por fuso horário do usuário.`,
"label.martrixreport.setrowtitle":`Especifique os cabeçalhos das colunas`,
"label.bottom":`Fundo`,
"label.multilang.ccchat.groupnotcontainsname":`Você não é membro de nenhum grupo que tenha {0} em seu nome`,
"label.step1.of.step5":`Etapa 1 de 5`,
"message.report.error.FieldListIsAmbiguous":`Há uma fórmula arquivada que foi referenciada no relatório, que causa uma exceção, favor remover o arquivo:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Mudar de {0} para {1}`,
"label.report.export.print.content":`Exportar os atuais cabeçalhos de relatórios, grupos e primeiros registros de 2000`,
"message.thanksusing":`Obrigado por utilizar o CloudCC.com`,
"label.reportexport.allobject":`Exportar todos os Objetos`,
"label.projectManagement.working.hours.per.day":`Horário de trabalho diário`,
"label.partnerCloud.financeSetting.enterCollaborator":`Por favor, insira o ID do colaborador`,
"label.defineReportRecords":`Definir Conjunto de Registros de Relatórios`,
"greate":`maior que`,
"label.sure_discard":`Você tem certeza de que vai desistir das mudanças?`,
"label.escalation.setup.newaction.notifyowner":`Notificar o proprietário do caso`,
"label.icon.28":`Chapéu de Doutor`,
"lable.PowerProcess.see.page":`Ver Marcos`,
"message.error.object.relogin":`Login falhou, por favor tente fazer o login novamente`,
"label.chatter.activity":`Atividades`,
"label.query.clone.detail.choose.canChoose":`Itens de linha disponíveis`,
"chatter.using.object":`Permitir o rastreamento de alimentação de objetos para que os usuários possam acompanhar os registros desse tipo de objeto. Selecione campos para rastrear para que os usuários possam ver atualizações de alimentação quando esses campos forem alterados nos registros que eles seguem.`,
"UG.opportunity.001":`Como você monitora suas vendas?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Mapa de Distribuição de Recursos de Serviços`,
"vue_label_email_current_email":`A inserção deste modelo irá sobrescrever o e-mail atual`,
"label.h5.approval.page.layout":`Você pode definir o layout da página de aprovação: >br>Configuração>Criar>Fluxo de trabalho&Aprovação>Processos de aprovação<br>selecionar processo de aprovação, clique no nome da aprovação<br>clicar Editar>Definir o layout da página de aprovação`,
"component.hots.label.title":`Negócios quentes`,
"mail.foldername.notOnly":`Este arquivo já existe`,
"label.customer.tab.step1":`Passo 1 Digite os detalhes`,
"label.delete.persion":`Eliminado por`,
"chatter.changed0":`Alterar {0} de {1} para {2}.`,
"homepage.components.type":`Tipo de Componente`,
"label.norfolk.isiands.time":`Tempo de Norfolk`,
"label.product.pricebooks.view":`Vistas do Livro de Preços`,
"label.forecast.customforecast.director":`Subordinados diretos`,
"label.emailtocloudcc.step3total3":`Etapa 3 de 3`,
"label.cloudccsite.end":`Página Inativa do Site`,
"label.login.verification.mfa.device":`Verificar o dispositivo AMF virtual`,
"chatter.follow":`Siga`,
"label.month's":`Mês`,
"label.sendmail.step1.introduce":`Selecione uma visualização abaixo que contenha os destinatários a serem incluídos neste e-mail.`,
"label.shangqing.title":`Configuração de informações comerciais`,
"label.rejectrecords":`Registros Rejeitados`,
"label.selectupdatevalue":`Valor que muda de`,
"vue_label_pricebook_disabled":`A lista de preços está desativada`,
"component.chatter.label.title":`Último post`,
"label.partner.all.workspace":`Espaço de trabalho`,
"label.querydetailservice.delete.message":`Dados excluídos ou inexistentes.`,
"label.objectRelationshipWithout":`com ou sem registros relacionados`,
"nocontain":`não contém`,
"label.partnerCloud.financeSetting.accountSettings":`Configuração do Fundo de Parceiros`,
"label.file.sharetype.owner":`Proprietário`,
"label.open.multilingual":`Habilitar Multilíngua`,
"label.searchresult.field":`Campos de resultados da busca`,
"label.tabpage.selectdate":`Selecione uma data`,
"label.h5.logouting":`Sair`,
"label.quickbooks.fieldlabel.payment":`Pagamento`,
"label.chatter.leaveword":`Comentário`,
"label.customfields.majoranddetailrelation.tip":`Criar uma relação pai-filho especial entre este objeto (filho ou details）and outro objeto (pai ou mestre), onde: <br>● os campos de relacionamento para todos os detalhes dos registros devem ser preenchidos. <br>● Uma vez salvo o valor do campo relacional, este não pode ser modificado. </li><br>● a propriedade e compartilhamento do registro de detalhes é determinada pelo registro mestre. </li><br>● quando o usuário apaga o registro mestre, todos os detalhes são apagados. </li><br>● é possível criar campos de resumo cumulativo no registro mestre para resumir os registros detalhados. </li><br> O campo de relacionamento permite ao usuário clicar no ícone de procura para selecionar um valor da lista pop-up. O objeto principal é a fonte do valor na lista. "`,
"label.batchapproveorrefuse":`Aprovação/Rejeição em massa`,
"label.copy.success":`Copiar com sucesso`,
"vue_label_show_record_count":`Mostrar contagem recorde`,
"label.ems.delete.false":`Falha em excluir`,
"label.new.Product.Goals":`Objetivo do novo produto`,
"label_chatter_BCC":`Bcc (cópia cega de cortesia)`,
"label.knowledgebase.data.archived.successfully":`{a} arquivo de dados com sucesso`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Seu {0}:{1} foi reciclado até {2} por {5}.`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Valor do pagamento:`,
"label.martrixreport.2018.step5.new":`Passo 5 Selecione os critérios do relatório`,
"label.testing":`Verificação...`,
"chatter.poll.option4":`Escolha 4`,
"lable.outlook.detail.otc":`Troca para CloudCC.com`,
"label.startuploadfile.batch.step2":`Passo 2 Clique no botão "start upload", carregue os arquivos`,
"lable.outlook.edit.outdes":`Digite os campos personalizados que você já criou em Exchange. Antes de mapear este campo personalizado do Exchange para um campo do CloudCC.com, o CloudCC.com verificará a existência do campo Exchange na primeira sincronização.`,
"hour":`Hora`,
"label.appointmentpage.wizard.notif4":`Formato de e-mail inválido`,
"label.import.index.state":`Status`,
"label.integrations.mailchimp.massage6":`Os dados selecionados mostrados na página atual poderão ser exportados para sua lista Mailchimp`,
"label.file.share.email.subject":`#sharedBy compartilhou um arquivo com você em #orgname`,
"label.assignment.setup.newentries.noassignment":`Não Reatribuir Proprietário`,
"label.dashboard.unit1":`Unidade: 10,000`,
"label.forecast.customforecast.foretype.commit":`Comprometido`,
"label.type":`Tipo`,
"label.partner.workspace.login.logo":`Logotipo do cabeçalho`,
"pagecreator_systemstyle_button_edit":`Estilo de edição`,
"label.displaytype2":`Botão Página de Detalhe`,
"email.one":`Prezado usuário: \n Bemvindo ao CloudCC. Você solicitou a redefinição de sua senha em {!operatetime}, por favor faça o login com o código de verificação abaixo dentro de 15 minutos: \Código de Verificação Aleatória: {Clique no link abaixo para redefinir sua senha: \n{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}n Importante: Se você não solicitou isto, ou se você acha que esta mensagem não deve chegar até você, por favor entre em contato com seu administrador imediatamente!`,
"label.partnerCloud.orderingPlatform.unavailable":`Não há produtos disponíveis`,
"vue_label_email_save_the_signature_successfully":`Salvar a assinatura com sucesso`,
"label.reportsSubscriptionPage.email.detailed":`Detalhado`,
"chatter.group.query":`Consulta`,
"label.translation.unsupported.format":`Formato sem suporte, suporte de importação em vários idiomas Formato de propriedade`,
"message.operateexception":`Pronto(Favor entrar em contato com seu Administrador).`,
"label.sendemail.chat.praiseFeedcomment":`Prezado #nome:{\i1}olá! #userName gostou de seu comentário (#href).`,
"label.recycle.clearmy":`Esvazie seu cesto de reciclagem`,
"label_tabpage_choose":`Selecione`,
"#label.importstep2tip":`Se você quiser carregar mais de um arquivo, você pode comprimir todos os arquivos juntos e importá-los.`,
"label.batchedit":`Mas Editar`,
"label.integrations.mailchimp.export":`Exportação para Mailchimp`,
"label.cloudccsite.name":`Nome do site`,
"serviceterritory.serviceappointment.iscontain.contain":`Não é possível apagar o território de serviço, pois ele está associado a um compromisso de serviço. Você pode desativar este território de serviço.`,
"label.sum":`Soma`,
"setup.mainpage.label.welcome29":`Integração API padrão com produtos de terceiros`,
"label.tabpage.nothingz":`Nada`,
"label.weixin.actual.contract.jine":`Valor real do contrato`,
"label.tabpage.emailaddressz":`De?Endereço`,
"label.dashboard.unit4":`Unidade: 10 milhões`,
"label.dashboard.data.labels":`Etiquetas de dados`,
"label.import.page2.oneonone":`Um campo CloudCC só pode corresponder a campos em um arquivo.`,
"homepage.components.name":`Componentes Nome`,
"template.report.task.theme":`Assunto da tarefa`,
"component.setup.label.setupsaveok":`Configurações de componentes salvas com sucesso`,
"front-epwechat-module-v1-add-selfapp":`Adicionar Seflcreated App`,
"label.to.save.the.current.page.information.button.":`Se você quiser salvar as informações da página atual, por favor clique no botão "Salvar rapidamente".`,
"vue_label_file_not_support_preview":`O arquivo não suporta pré-visualização, favor baixar e visualizar`,
"label.object.reached.limit":`O número de objetos que você pode criar atinge o limite superior.`,
"label.partnerCloud.basicSetting.online":`Ativar pagamento online`,
"label.app.step1.error.nameexist":`Este nome de grupo já existe ou já foi usado anteriormente. Por favor, escolha um nome diferente.`,
"label.workflowandapprove":`Fluxo de trabalho e aprovações`,
"label.recordtypeselect.change.tip":`Quando você muda o tipo de registro de um registro, os valores da lista de seleção existente não mudam automaticamente. Recomenda-se atualizar os valores existentes da lista de seleção do registro no mesmo local.`,
"label.summaryreport.step6":`Passo 6 Selecione os critérios do relatório`,
"Pagelayout.Setup.004":`Até 4 campos podem ser configurados`,
"label.file.attached":`Em anexo`,
"front-invoice-online-payment-setup-configure":`Clique em "Configurar agora", Configurar {nome} Interface de pagamento.`,
"label.approvaldatamove.submitdate":`Data de apresentação`,
"label.emailobject.time.from":`De:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`O campo $schemefield_name$ do registro já existe no banco de dados e não está mais inserido. O registro foi ignorado importação.`,
"assetbom.copy.notpermission":`Você não tem autoridade para clonar a lista técnica de bens. Favor entrar em contato com o administrador.`,
"lable.outlook.mcto.autoallocation":`Atribua-os automaticamente aos registros relacionados ao CloudCC.com.`,
"label.dataimport.but.datalength":`mas o comprimento dos dados é`,
"label.setuserstocommit":`Usando as opções abaixo, especificar quais usuários estão autorizados a submeter o pedido inicial para aprovação.`,
"component_telerecord_label_related":`Itens relacionados`,
"front-lighting-module-v1-detail-file-lockInfo":`O registro é bloqueado e não está disponível para adicionar arquivos. Favor entrar em contato com o administrador para desbloquear.`,
"pagecreator_layout_button_edit":`Editar layout`,
"label.app.step3.tabcanuse":`Abas disponíveis`,
"label.ems.delete.sure":`Você tem certeza de excluir esta informação de conta de e-mail?`,
"label.email.show":`Mostrar`,
"label.checkbox.unchecked":`Não selecionado`,
"message.error.operation":`Falha na operação, favor contatar o administrador.`,
"label.template.set.folder.only.upload.type.file":`As pastas marcadas em vermelho no modelo só podem ser usadas para carregar arquivos do tipo Word, Excel e PPT.`,
"label.knowledgebase.select.publish.status":`Por favor, escolha um status de publicação`,
"label.recordtype.tabname.edit":`Digite o novo nome para o tipo de registro selecionado, e então clique em "Salvar".`,
"label.tabpage.exportview":`Vista de exportação`,
"label.dataimport.insert.sharetab":`Falha ao inserir o formulário de compartilhamento`,
"vue_label_dashboard_penetrateto":`Penetrar para`,
"label.weixin.group.member":`Pessoal`,
"vue_label_systemSettings_customadd":`Extensão personalizada`,
"UG_Account_03":`Verificar e fundir proativamente as contas duplicadas`,
"label.singapore.standard.time":`Horário padrão de Cingapura`,
"label.weixin.captcha":`Código de Verificação`,
"Account_News_Setting_004":`Habilitar Notícias`,
"label_emailtocloudcc_select1":`Favor escolher`,
"label_ring_ratio":`Mês a mês`,
"label.industrialandcommercialverification.button.save":`Salvar`,
"label.approvalstep5.tip":`A página de aprovação é onde o aprovador realmente aprova ou rejeita o pedido. use as seguintes opções para selecionar as propriedades de edição dos campos a serem exibidos nesta página.`,
"label.import.page1.maxrecord{{30000}}":`1. Você pode importar {{{30000}} registros uma vez`,
"setup_object_layout_label_profileoptions":`Perfis disponíveis`,
"label.emailtemplate.type":`Tipo de gabarito`,
"label.searchlayout.tab.field":`Campos exibidos na página inicial da guia.`,
"chatter.news":`Mensagens`,
"label.pw.small.letter":`Caixa baixa`,
"label.notification.group3":`Seu pedido para se juntar ao grupo público foi rejeitado`,
"label.ccchat.day.before.yesterday":`Anteontem`,
"component.chatter.post.label.title":`Publicar`,
"label.tianyancha.type":`Tipo de representante legal`,
"label.detail.searchlayout":`Ver layout de busca`,
"vue_label_pool_deleteconfirm":`Você tem certeza de que deseja apagar o(s) registro(s) selecionado(s)?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Só suporta arquivos em formato csv, o suporte máximo é {{100}}mb, e um máximo de {30000}} registros podem ser importados uma vez; por favor, divida em vários arquivos e importe-os em etapas se o limite for excedido,`,
"label.h5.similar.opportunity.lookup":`Encontre oportunidades similares`,
"template.report.customer.list.opportunity":`Lista de Contas com Mais Oportunidades`,
"component_setup_iframe_label_memo":`Clique no ícone de configurações e digite o endereço url incorporado.`,
"label.version.allemail":`Email em massa`,
"lable.product.editp":`Edição de preços`,
"label.weixin.plate.number":`Número da placa`,
"font-evaluate-module-v1-disabled-successfully":`Opção de avaliação "Neutra" para deficientes com sucesso`,
"label.multilingual.tip1":`Use esta página para definir a linguagem de sua organização.`,
"label.japan.standard.time":`Tempo padrão do Japão`,
"lable.product.notdel.use":`Eliminar tentativas, pois ainda está associado aos seguintes registros. Neste caso, é recomendável desativar.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Editar`,
"label.partnerCloud.financeSetting.informationTwo":`2. No Centro de Comerciantes, clique em Gerenciamento de Conta  Gerenciamento de Conta  Gerenciamento de Produto PIDIKEY  Gerenciamento de Chave Secreta`,
"label.partnerCloud.partnerOrdering.permission":`Permissão para pedidos de parceiros`,
"vue_label_commonobjects_detail_company_hierarchy":`Hierarquia da empresa`,
"label.forecast.settings.sl":`Quantidade`,
"label.partner.workspace.tab.memo":`Selecionar abas para esta nuvem de parceiros. podem ser selecionadas abas padrão ou abas personalizadas.`,
"label.mr.mainRecord":`Registro mestre`,
"setup_mainpage_label_welcome20":`Correio, modelo SMS`,
"front-email-payment-select-date-tips":`Por favor, escolha YY`,
"label.dependencelisttag":`Rótulo da lista relacionada`,
"label.umeng.activity.eventof":`evento de`,
"label.sales.dashboard.collection":`Objetivo dos recibos`,
"report_label_folder":`Folders`,
"label.assignment.setup.newentries.step1":`Passo 1 Defina a ordem na qual esta entrada de regra será processada`,
"label.quote.shrname":`Nome do destinatário`,
"label.newreport.group.sum":`O número de agrupamentos`,
"label.number.MinCheck":`O mínimo de {a} é {0}. Por favor, modifique a quantidade e salve as alterações.`,
"label.chatter.save":`Salvar`,
"vue_label_email_all_email_templates":`Todos os modelos de e-mail`,
"message.summaryconditionnototal":`Condição de condições sumarizadas não pode usar campos Roll-Up!`,
"label.callboard":`Anúncios`,
"label.step2.total5":`Etapa 2 de 5`,
"vue_label_homepage_custom_homepage_page":`Página inicial personalizada`,
"label.data.newtemplate.e_seltype":`Selecione o método de exportação de dados`,
"label.data.dataexpalltype.all.desc2":`2、It leva algum tempo para exportar todos os dados. Quando a exportação estiver completa, você receberá um e-mail de lembrete de que a exportação de dados foi bem sucedida.`,
"lable.account.CalenderYear":`Ano Calendário`,
"message.error.data":`Os dados aprovados não podem estar vazios, favor verificar os parâmetros aprovados`,
"label.from_user":`Do usuário`,
"label.parentdepartment":`Departamento superior`,
"template.dashboard.product.analysis":`Análise de produtos`,
"label.tabpage.unpacketz":`Não há dados de agrupamento disponíveis!`,
"label.icon.107":`Comunicação`,
"label.monitorsys.operator.username":`Usuários`,
"label.serchreport":`Relatórios de busca`,
"label.payment.upgrade":`Atualização`,
"setup_layout_button_ok":`Confirme`,
"label.please.select.channel":`Favor selecionar o supervisor do canal.`,
"template.chart.txdrw":`Lembrete de tarefa`,
"chatter.group.accept":`Aceitar`,
"pagecreator_systemstyle_message_canntdelete":`O estilo atual não é permitido excluir`,
"label_tabpage_ctbtsftcz":`Clique no verso para pesquisar o conteúdo`,
"label.datamanage.select.accountfield":`(Selecione os campos correspondentes à conta importada)`,
"label.schedulejob.setup.list.title":`Empregos programados`,
"label.visualpage_list.title":`Acesso à página personalizada ativa`,
"label.mr.selectTwoData":`Favor selecionar pelo menos dois registros a serem fundidos.`,
"label.customer.tab.step2.different":`Aplicar uma visibilidade de aba diferente para cada perfil`,
"label.mobile.side.tab.can":`Disponível em`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`A conta CloudCC foi vinculada, se continuar, ao WeChat que anteriormente estava vinculado a esta conta CloudCC não poderá utilizar o sistema de micro CloudCC. Você quer continuar?`,
"label.applet.to.case":`Portal de atendimento ao cliente do miniprograma`,
"lable.outlook.detail.cmaping":`Campos de contato do mapa`,
"label.theUserActiveTime":`Período ativo do usuário`,
"label.event.moveup.9hour":`9 horas à frente`,
"vue_label_pool_other":`outros`,
"label.fieldname":`Nome do campo`,
"vue_label_notice_add_success":`Adicionado com sucesso`,
"label.conditiontag.lookup.insertbutton":`Inserção Selecionada`,
"label.identifying":`Identificação`,
"label.tabpage.uploadingz":`Carregamento`,
"label.view.introduce":`Editar Vista`,
"vue_label_dashboard_sortingmethod":`Favor selecionar o método de ordenação`,
"label.quote.number.introduce":`Digite o número de e descontos, e clique em Salvar.`,
"front-kefu-moudle-which-missphone-case":`Criar casos para os quais as chamadas foram perdidas`,
"label.sendemail.chat.response":`Resposta do CCChat:`,
"label.productsales.refreshTime":`Atualização mais recente`,
"lable.SalesCommitmentKanBan.phase":`Estágio`,
"label.version.sum.object":`objeto(s)`,
"label.defineReportStep2":`Etapa 2`,
"message.duplication.label.returnDuplications":`Voltar à Lista de Filtros de Duplicação`,
"label.lookover":`Ver`,
"label.quickbooks.button.copy2":`Copy CloudCC Detials To QuickBooks`,
"label.checkbox.true":`Sim`,
"label.profilename":`Nome do perfil`,
"label.finalapproveoperate":`Ações de aprovação final`,
"label.SMS.detailed":`Os alertas por SMS são enviados por regras de fluxo de trabalho quando são acionados.`,
"label.lasttimemodifier":`Última modificação por`,
"label.sso.summary":`Sumário`,
"label.customfields.encd.tip":`Permite aos usuários inserir qualquer combinação de letras e números e armazená-los em forma de texto claro que pode ser criptografado e pesquisado.`,
"vue_label_report_formulacolumn":`Coluna de fórmula em nível de linha`,
"vue_label_systemSettings_transfer":`Registros de transferência em lote`,
"lable.product.ecm":`Por favor, digite o valor correto.`,
"label.partner.setup":`Configurações de nuvens de parceiros`,
"label.same.analyze.miaoshu2":`função`,
"label.mobile.phone.day.summary":`Resumo diário`,
"label.ccchat.person.error.illdomain":`Erro: formato de domínio incorretamente preenchido`,
"label.knowledgebase.edit.as.draft":`Editar como rascunho`,
"message.duplication.label.newfilterule":`Nova duplicata e regra de correspondência`,
"vue_label_salesfunnel_notice1":`Resumo das oportunidades`,
"label.partnerCloud.partnerAccount.order":`Número do pedido :`,
"label.account.Current.and.PreviousFQ":`FQ atual e FQ anterior`,
"label.customfields.formula.dateandtimeexample":`Próximo = AGORA() 1`,
"label.area.unassign":`Usuários não designados`,
"label.at.my":`Conteúdo que mencionei (@)`,
"vue_label_calendar_notice_stopsharingfail":`Falha em parar de compartilhar`,
"label.data.file.validation.rules":`Executar Regras de Validação`,
"label.escalation.setup.entrydetail.escalation.hour":`Horas`,
"vue_label_ccchat_notice_pleaseentercontent":`Favor inserir o conteúdo e as opções`,
"label.forecast.edit.error1":`Erro: Moeda inativa`,
"label_emailtocloudcc_exists1":`Esta caixa de correio foi configurada para enviar um e-mail para Lead. Não repetir as configurações.`,
"label.trigger.send.email":`Notificações por e-mail via Triggers`,
"label.setmysafetysignagain":`Reinicializar minha marca de segurança`,
"label.callcenter.pleaseenter.access.keyID":`Por favor, digite a chave de identificação secreta`,
"chatter.poll.option10":`Escolha 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Configuração Unificada do Menu Inferior`,
"label.quickbooks.searchs":`Busca`,
"label.section":`Segmento`,
"label.customfields.fielddependency.new.tip":`Criar uma relação dependente que faz com que os valores em uma lista de seleção ou lista de seleção múltipla sejam filtrados dinamicamente com base no valor selecionado pelo usuário em outro campo.<ul ><li>O campo que aciona a filtragem é chamado de "campo de controle". As caixas de seleção padrão e personalizadas e as listas de seleção com pelo menos um e menos de 300 valores podem ser campos de controle. </li><li>O campo que tem seus valores filtrados é chamado de "campo dependente". Listas de seleção personalizadas e listas de seleção múltipla podem ser campos dependentes.</li></ul>`,
"label.customobjects.track.introduce3":`Favor observar: apenas parte dos campos diapositivos são rastreados e "Edited" será mostrado quando os campos de rastreamento forem rastreados.`,
"front-kefu-moudle-all-hidden-phone":`Ocultar o número de telefone globalmente`,
"vue_label_calendar_share_calendar_with_others":`Compartilhar calendário com outros`,
"label.case.copre":`Download do Código QR do Portal da Web`,
"label.conditiontag.lookup.pagetitle":`Selecione os valores da lista de picking`,
"UG.opportunity.004":`Tipo multi-serviços`,
"label.event.moveup.1day":`1 dia à frente`,
"label.industrialandcommercialverification.enablestatus1":`Habilitar a verificação de dados industriais e comerciais`,
"label.ccpeak.newrecord.getorpost":`Novo Registro: há duas maneiras de construir um CCObject usando CCObject.`,
"frame.personinfo.label.resizeimage":`Para fazer ajustes em sua imagem em miniatura, arraste e redimensione as linhas pontilhadas em sua foto de perfil acima.`,
"label.optional.searchresultfield":`Campos de resultados de pesquisa disponíveis`,
"UG.Contract.02":`O contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir os termos de fazer negócios com outras empresas. Use o CloudCC para estabelecer e documentar seus contratos existentes com suas contas e oportunidades de negócios. Acompanhe o contrato através do processo de aprovação. Use lembretes de fluxo de trabalho para lembrá-lo da prorrogação do contrato.`,
"label.group.activity":`Grupos ativos`,
"label.tabpage.characterz":`Caráter inicial`,
"label.globalsearch.tip":`Favor digitar o conteúdo da busca`,
"label.campaign.channel.download.size2":`Tamanho médio: 500*500 pixels`,
"label.step3.total4":`Etapa 3 de 4`,
"label.partnerCloud.payForFailure":`O pagamento falhou`,
"label.ggReleaseRange.editSuccess":`Editar com sucesso`,
"label.summaryinforelyon":`Dados resumidos por`,
"label.productsales.htyj":`Execução do contrato`,
"label.newpagelayout":`Novo layout de página`,
"front-gantt-module-input-task-name":`Favor inserir tarefa name！`,
"label.c_d_without":`Os registros "C" podem ou não ter registros "D" relacionados.`,
"label.licence":`Licenças`,
"setup.layout.button.selectall":`Selecione Todos`,
"label.app.step1.error.appnameexist":`Este nome de aplicativo já existe.`,
"label.cpq.quote.item.no.record":`Somente os produtos encomendados com registros podem ser transferidos para contratos.`,
"label.knowledgebase.noaffect.existing.translations":`Não, minhas modificações não afetarão a tradução existente.`,
"label.schedulejob.setup.schedule.editjob":`Edição de trabalhos programados`,
"lable.PowerProcess.Tips":`O processo de habilitação é uma linha de tempo customizável contendo todas as etapas (marcos) que poderiam apoiar o atendimento ao cliente e outros funcionários a completar todas as etapas a fim de resolver um caso apoiado ou um registro de ordem de trabalho. Depois que a configuração estiver completa, ela pode ser aplicada ao direito.`,
"label.campaignmember.selectmember.step2":`Passo 2 Selecione os membros que você deseja adicionar`,
"vue_label_calendar_stopsharing":`Você tem certeza de que vai parar de compartilhar o calendário`,
"vue_label_notice_savemenu_fail":`O menu salvar falhou`,
"message.error.getitems.id":`getItems: o id não pode estar vazio`,
"label.return.currencylist":`Voltar para a lista: Gerenciamento de moedas`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Publicar agora`,
"label.appupload.install.explain":`Instruções de instalação`,
"label.visualpage.folder.all":`Todas as Pastas de Página`,
"message.passwordPolicy.validate.complexReq2":`Erro: Sua senha deve ter uma mistura de letras maiúsculas e minúsculas e números.`,
"label.umeng.chatter.at":`mencionou você.`,
"label.mobile.phone.month.report":`Notas de Trabalho Mensais`,
"label.describableEditeSelectedFields":`Selecione os campos que são exibidos nas colunas do relatório por padrão quando você cria um novo relatório personalizado.`,
"component.event.label.subject":`Tema`,
"label.knowledgebase.edit.draft":`Editar Draft?`,
"label.customer.tab.step1.selectoneobject":`Selecione um objeto personalizado existente`,
"label_partner_step2":`Passo 2 confirmar modelo`,
"label_starting_annual":`Ano de início`,
"X":`Área de texto`,
"label.customer.tab.style":`Estilo de abas`,
"vue_label_commonobjects_detail_book":`Um livro de preços padrão`,
"chatter.email.referredToMe":`Me menciona em um posto`,
"label.enable.both.barcode.qrcode":`Ativar o código de barras e o código QR`,
"front-market-form-quired-choose":`Campos Necessários`,
"noinclude":`exclui`,
"label.sms.template.select":`Favor selecionar o modelo de SMS`,
"label.weixin.optionten":`Escolha 10`,
"message.duplication.label.matchlastletters":`Últimos N caracteres`,
"label.webtocloudcc.submit.success":`Apresentação bem-sucedida`,
"label.sales.dashboard.number":`Número`,
"label.custom.field":`Mapear este campo personalizado`,
"label.dataimport.of.field":`campo(s)`,
"label.view.new":`Criar nova visão`,
"UG_activity_03":`Reserve um horário`,
"label.customfields.image.tip":`Permite que os usuários carreguem fotos.`,
"label.startexport":`Iniciar Exportação`,
"vue_label_commonobjects_view_chart_verticalbar":`Gráfico de barras verticais`,
"label.ccchat.person.invite.allexist":`Todos que você convida já estão usando o CCChat`,
"label.fielddependence":`Dependências de campo`,
"label.scan.tip":`Favor usar o navegador IE7, IE8, Chrome ou Firefox, e recomenda-se usar uma resolução de mais de 1024×768.`,
"label.wei.weiactor":`Votado por`,
"label.service.miniProgram.quantity":`Podem ser criados até 20 registros de carrossel~`,
"vue_label_homepage_new_homepage_page":`Nova página inicial`,
"label.apply.telphone.validate.error":`Número de validação incorreto.`,
"component.assistant.button.newevent":`Novo Evento`,
"System_TimeField_Format_Warning":`Tempo inválido`,
"chatter.feed.publishfeed":`Correio`,
"label.setting.intergrationlist":`Lista de integração`,
"label.object.prefix":`Prefixo do objeto`,
"label.tippage.confirmed":`Sim, quero apagar a fonte de dados do relatório personalizado e todos os relatórios dependentes.`,
"label_emailsync_form_signin":`Login`,
"label.delete.cancel":`Não selecionado`,
"label.dashboard.myHomePage.des":`Selecione o painel de controle para diaplay em cada aplicativo.`,
"lable.account.FY.Ago":`2 FY Ago`,
"label.umeng.approval.reassign":`#O aprovador reatribuiu seu pedido de aprovação #obj.`,
"label.data.exp.zippwd2":`Gerar automaticamente a senha do arquivo compactado`,
"label.tabpage.contentz":`Por favor, digite o conteúdo`,
"label.callcenter.batch.add.number":`Adicionar Números em Batch`,
"label.tabpage.deleteviewsuccess":`Ver excluir sucesso`,
"setup_layout_group_field":`Campos`,
"label.appupload.component.addobj.scheme.label.suoshu":`Objeto`,
"front-project-module-v1-market-is-template":`Marcar como modelo`,
"label.service.gantt.one.esource.types":`e um dos seguintes tipos de recursos`,
"label.emailtocloudcc.search":`Busca`,
"label.mobile.home.page.myyj":`Meu desempenho`,
"vue_label_normal_invoice_sf":`Fatura`,
"label.permission.detail.app.fenpei.tip":`Especifique quais aplicações são visíveis no menu de aplicações.`,
"label.login.access.month":`Mês`,
"label_tabpage_retypez":`Quando o tipo de registro é alterado, os valores existentes da lista de opções não serão automaticamente alterados. recomendamos atualizar o valor existente da lista de opções do registro no mesmo local.`,
"label.ems.private.company.message":`As versões em nuvem privadas não suportam a edição on-line da caixa de e-mail da empresa.`,
"label.dataimport.length.check":`Comprimento acima de 18 bits, favor rever cuidadosamente o registro e modificá-lo.`,
"label.batchtransfer.type1":`Transferir as oportunidades em aberto que não pertencem ao titular da conta corrente`,
"vue_label_calendar_are_you_sure_to_remove":`Você tem certeza de remover este calendário`,
"label.icon.117":`Bolsa escolar`,
"vue_label_systemSettings_downloadapp":`Download do aplicativo móvel`,
"label.approval.project":`Itens a serem aprovados`,
"template.organization":`Nível Organizacional`,
"label.weixin.return.research":`Voltar para a página de detalhes da Micro Pesquisa`,
"label.ccchat.person.invite.addsay":`Adicionar uma mensagem opcional...`,
"UG.Case.02":`Os casos permitem que você responda e resolva problemas de conta. Os casos são um registro poderoso na Cloud CC que não só rastreia os problemas da conta, mas também exibe uma visão completa da conta.`,
"label_emailtocloudcc_step1":`Passo 1`,
"workflow.action.tasks.assignortype.owner":`Proprietário`,
"label.data.import.page":`Ir para a página de importação`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Largura(Pixels)`,
"label.customcomponent.referencetag":`Rótulo de referência`,
"label.tabpage.search":`Busca`,
"label.knowledge.searcharticle.casefields":`Campos de casos para pesquisa de artigos sugeridos`,
"setup_layout_message_relatedlistfield":`Selecione os campos a serem exibidos na lista relacionada. Você também pode reordenar os campos selecionados.`,
"label.relationobject.type":`Tipo de objeto relacionado`,
"UG_Account_02":`Algumas empresas prestam serviços a outras empresas, algumas colaboram diretamente com os usuários finais e outras servem às ONGs.`,
"UG_homepage_006":`Visibilidade de 360 graus na atividade de sua conta através de pesquisas, chats ao vivo, e-mails, ordens de trabalho, postos na mídia social e até mesmo atividades de vendas (tais como leads, suporte de serviços e atividades).`,
"chatter.poll.option1":`Escolha 1`,
"label.ccdocument.fieldforld":`O nome dos documentos da pasta pertence a`,
"label.wei.result":`Resultado`,
"label.recentview.new":`Último`,
"label.martrixreport.setsumfield":`Selecione o campo a ser usado como linha de resumo em seu relatório de matriz`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Segunda-feira`,
"label.marketsea.button.recycle":`Recicle`,
"label.standard.buttonandlink.info2":`Selecione a página customizada CloudCC.com para usar no lugar da URL CloudCC.com para este botão padrão ou link.`,
"label.reportsSubscription.select.two.months":`Favor selecionar uma faixa de datas dentro de dois meses para esta freqüência!`,
"label.standard.buttonandlink.page":`CloudCC Clássico`,
"vue_label_commonobjects_view_chart_horizontalbar":`Tabela de Barras Horizontais`,
"label.Remove":`Remover`,
"label.mobile.phone.receivable":`Pagamentos`,
"label.appupload.uploaddetail.goback":`Voltar ao pacote`,
"label.select.role":`Por favor, escolha um papel`,
"label.file.sharetype":`Tipo de ação`,
"label.app.chosetab":`Selecione as abas`,
"label.case.other.phone":`Outro número de telefone`,
"chatter.edit.cancel":`Suas mudanças foram canceladas.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Falha em obter o auth2cn!`,
"message.error.system.service.permissiondeny":`Desculpe, não é permitido que você seja atendido por este serviço, por favor entre em contato com seu administrador.`,
"label.chatter.mygroups":`Meus grupos`,
"label.umeng.approval.approvalpass":`O pedido de aprovação para o #obj é aprovado. #objnome`,
"label.chatter.owner":`Proprietário`,
"vue_label_commonobjects_view_kanban_view":`Vista Kanban`,
"message.please.choose.group.role":`Por favor, selecione o papel do grupo`,
"label.icon.136":`Moeda`,
"label_tabpage_selectdate":`Selecione uma data`,
"chatter.emailInformation":`Informações gerais`,
"front-lightning-module-v1-dashborad-bubble-size":`Tamanho da bolha`,
"label.stdashbord.xsld.business.wan":`miríade`,
"label.datamanage.field.notexist":`O campo correspondente ao objeto não existe.`,
"UG.Forcast.04":`Iniciar o julgamento`,
"UG.contact.02":`Envolva os contatos através de múltiplos canais, chamada, e-mail, social`,
"vue_label_pool_selecttransferinto":`Selecione o pool de chumbo a ser transferido para`,
"label.quote.xingming":`Nome`,
"label.customerinfo.userlicencenum":`Licenças de usuário`,
"label.group.no.my.archived":`Não foram encontrados grupos de arquivos correspondentes.`,
"label.weixin.add.activity.tel":`Adicionar chamada de atividade`,
"label.partner.setup.address":`Endereço da nuvem de parceiros`,
"label.data.file.i_title.num3":`3 O sistema lê previamente o arquivo de dados no servidor, depois inicia o back-end do importador em massa, cujos resultados serão notificados aos usuários pelo correio, e você não terá que esperar nesta página.`,
"label_sum_up":`SUM`,
"label.searchall.title":`Busca global`,
"label.bind.chooseone":`Escolha o Proprietário`,
"label.campaign.channel.input.owner.select1":`Proprietário da campanha atual`,
"front-kefu-moudle-v1-Expand-chat":`Expandir Detalhes do Chat`,
"label.component.hotdeal":`Negócios quentes`,
"component_event_label_title":`Próximos eventos`,
"No.planed.activity":`Nenhuma atividade planejada`,
"label.searchlayout.result.field":`Colunas de resultados de busca para busca e etiquetagem.`,
"label.leadscore.value":`Valor`,
"vue.dashboard.linkage.is.set.successfully":`Conexão estabelecida com sucesso!`,
"PersonalInfo.LoginHistory.001":`A Broswer valida o link de registro em sua caixa postal`,
"front-gantt-module-v1-problem-number":`Números de problemas`,
"label.page.step5.of.step5":`Passo 5 de 5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC Alerta de mensagem CCChat`,
"label.Linkedin_accounts":`Conta LinkedIn`,
"label.qrcode.useful.life":`Data de validade do Código QR`,
"deleterow":`Remover Fila`,
"label.forecast.settings.future1":`Futuro 1 ciclo`,
"message.error.group.operation":`Erro de preenchimento de grupo`,
"label_tabpage_loadz":`Carregamento de página, por favor aguarde...`,
"label.brackets.left":`(Parênteses abertos`,
"label.source.code":`Ver código fonte`,
"setup_layout_label_areasetup":`Propriedades da Seção`,
"component.assistant.label.todaylead":`As pistas atribuídas a você hoje`,
"label.qrcode_signin":`O QR Code é limitado a aplicações que requerem leitura de código no local e login`,
"label.calendarshare":`Compartilhamento de Calendário`,
"IMG":`Imagem`,
"label.use.rule.when.both":`Aplique esta regra ao habilitar código de barras e código QR ao mesmo tempo.`,
"label.ccpeak.addshare.record":`Novos registros de formulários compartilhados: Registros adicionados recentemente`,
"label.enable.email.tracking":`Habilitar o rastreamento de e-mail`,
"label.top.plsinput":`Pesquise esta lista...`,
"vue_label_helpcenter_case":`Os casos são perguntas, feedback ou problemas dos clientes. Os agentes de apoio podem analisar os casos para entender como oferecer um melhor serviço. Os representantes de vendas podem usar os casos para entender o impacto no processo de vendas. A resposta a casos individuais pode satisfazer seus clientes e melhorar a imagem de sua marca.`,
"label.useonly":`Particular`,
"label.displaytype":`Tipo de Display`,
"label.most.user.group":`Os usuários podem se juntar a até 100 Grupos de Usuários, e você já se juntou ao 100º Grupo de Usuários.`,
"label.umeng.activity.yourevent":`Seu evento`,
"label.forecast.shrepage.classdes.w":`Leitura/escrita - O usuário pode visualizar e substituir os dados de previsão.`,
"label.defaultaccess":`Acesso por padrão`,
"label.partner.new.step2":`Passo 2 confirmar modelo`,
"component_setup_iframe_label_title":`Personalizar página`,
"label.sso.saml.sp.idenitytype":`Tipo de identidade SAML`,
"label.dashboard.this.folder":`Painéis de Controle nesta Pasta`,
"label.data.newtemplate.e.seltype.desc":`Há dois tipos de dados derivados</li>> classeli`,
"label.forecast.customforecast.submit.tip1":`Envie sua previsão:`,
"label.version.workflow.and.approval":`Automação do fluxo de trabalho e do processo de aprovação`,
"label.tianyancha.tip":`O texto de entrada está incorreto, por favor, entre novamente!`,
"label.report_details":`Detalhes do relatório`,
"template.report.folder.contract.product":`Contrato e análise do produto`,
"label.all":`Todos`,
"label.version.area.long.rich":`{0} campos de texto rico ou de área de texto longo`,
"label.enc":`Armazenamento Criptografado`,
"vue_label_pricebook_enterproductname":`por favor, digite o nome do produto`,
"label.edit.quote.line":`Edit Quote Line`,
"label.edit":`Editar`,
"M":`Relacionamento Master-Detail`,
"front-kefu-phonenumber-exists":`O assento No.{a} já existe`,
"label.standardplatformuser":`Usuários da plataforma padrão`,
"label.custom.page.configuration":`Editar Componente de Console Personalizado`,
"url.error.contact.null":`O endereço do Microservice está vazio.`,
"label.sethelp":`Configurações de ajuda`,
"setup.mainpage.label.welcome23":`Configurações de segurança`,
"label.sales.page.dashboard.fenxi":`Painéis de análise de vendas`,
"label.limit":`Acesse`,
"maintenanceasset.asset.contractlineitem.illegal":`Você deve selecionar o bem no item do contrato antes de associar o item do contrato com o bem de manutenção.`,
"UG.contact.04":`Ou`,
"Opportunity.Detailed.Phase.Label.004":`Dia(s)`,
"label.emailobject.receive":`Para`,
"label.brief.new":`Recentemente Novo`,
"label.marketsea.button.adopt":`para coletar`,
"label.select.up.to.three.fields":`Podem ser selecionados, no máximo, três campos.`,
"vue_label_allsearch_noresults":`Procuramos por suas configurações de busca personalizadas, nenhum resultado correspondente encontrado com {userInput}.`,
"Report_CantDelete_Info":`{0} relatório é a fonte de dados para o painel de controle {1} e não pode ser apagado!`,
"label.chile.summer.time":`Horário de verão do Chile`,
"label.partnerCloud.menu.selectedMenu":`Menu selecionado (os menus conferidos serão sincronizados com o aplicativo)`,
"vue_label_report_onlysummary":`Apenas resumo`,
"front-template-V1-Applicable-object":`Por favor, escolha o objeto aplicável.`,
"label.invoice.message.sendfailed":`A fatura não foi enviada, por favor tente novamente mais tarde`,
"front-kefu-moudle-v1-use-free":`TRY FOR FREE`,
"label.rule.updated.successfully":`Atualizar as regras com sucesso`,
"label.owner.lastone":`A Grã-Bretanha tem pelo menos uma condição`,
"label.appointment.wizard.subtitle1":`Duração da reunião`,
"template.report.opportunities.closed.month":`Oportunidades Fechadas deste Mês`,
"label.tabpage.choosecontent":`Selecione o conteúdo do valor`,
"template.chart.jbnddxl":`Vendas de pedidos no último semestre`,
"label.fieldsecurity.detail":`Detalhes de segurança de campo`,
"label.knowledgebase.data.deleted.successfully":`{a} dados apagados sucessivamente`,
"label.sso.saml.idp.config.nameidfmt":`Nome Formato de identificação`,
"label.emailobject.prompt":`Pronto`,
"label.marketsea.isgetbyself":`Permitir que os membros se auto-recolham`,
"label.winxin.cancelprompt":`Você tem certeza de que vai sair? sua operação atual não está salva.`,
"label.appexchange.installedpage.message2":`Os aplicativos e componentes são instalados em pacotes. Quaisquer aplicativos, abas e objetos personalizados são inicialmente marcados como "Em desenvolvimento" e não são implantados para os usuários, o que permite que você teste e personalize antes de implantar. Você pode implantar os componentes individualmente usando os outros recursos em configuração ou como um grupo, clicando em Implantar.`,
"vue_label_import_importtype":`Tipo de importação`,
"label.data.importef.des":`Os arquivos que não foram importados serão salvos no servidor por 48 horas e serão automaticamente apagados após 48 horas.`,
"chatter.email.reply":`Comentários sobre meus posts`,
"label.stdashbord.xsld.business.sdl":`Taxa de perda`,
"labal.emailtemplate.namemessage":`O nome único do modelo de e-mail existe, favor entrar novamente.`,
"vue_label_email_Please_select_file":`Favor selecionar o arquivo`,
"label.event.modify":`Edição de eventos`,
"label.projectManagement.isnmber":`Por favor, digite um número com até uma casa decimal.`,
"lable.outlook.detail.emailst":`Configurações de e-mail`,
"label.partnerCloud.priceOfManual.isUsed":`Esta configuração determina se os parceiros podem ou não usar este livro de preços para fazer pedidos.`,
"setup_mainpage_label_welcome26":`Gerenciamento de dados - Processamento em lote`,
"label.file.version":`Versão`,
"pagecreator_systemstyle_label_bordercolor":`Cor da fronteira`,
"label.approval.isallowed.reject.prompt":`Você quer permitir a rejeição ao aprovar dados únicos? (A aprovação em massa pode sempre ser rejeitada).`,
"label.myinfo":`Informações pessoais`,
"front-template-V1-fontSize":`Tamanho da fonte`,
"lable.outlook.edit.alpreo":`Troca sempre preferida`,
"front-email-payment-card-number":`Número do cartão`,
"label.cpq.quote.pricebook.no.change":`Uma vez que o livro de preços para uma cotação tenha sido determinado, ele não pode ser alterado. Por favor, crie 1 novo registro de cotações para utilizar um novo livro de preços.`,
"vue_label_file_size_limit_tip":`O tamanho do arquivo excede o limite`,
"lable.PowerProcess.worktime":`Tempo de trabalho do processo de concessão de direitos`,
"label.monthly.month.report":`Relatório Mensal YoY e MoM`,
"front-kefu-moudle-v1-sydq-buyuser":`Seu rastro é devido. Por favor, compre o Easemob para continuar usando`,
"label_tabpage_Rolesz":`Papéis e subordinados`,
"chatter.f.n":`Siga este registro`,
"UG.Forcast.02":`As previsões são estimativas de vendas esperadas para um determinado período, e os modelos de previsão podem ajudá-lo a determinar a demanda do produto e a receita de vendas em um determinado período. Os gerentes podem usar previsões para estabelecer metas e medir o progresso da equipe. A previsão geral da organização pode refletir o resumo de todas as vendas por representante de vendas (independentemente do estágio de conclusão das vendas desde o estágio de pipeline até o estágio fechado).`,
"label.productsales.contract.phb":`Lista de contratos`,
"label.umeng.insert.approval.submit":`#o solicitante submete #obj para sua aprovação`,
"message.duplication.label.matchfirstletters":`Primeiros N caracteres`,
"label.partnerCloud.partnerAccount.toPay":`Ir para Pagamento`,
"label.model.un":`Modelo No.: UN6786`,
"label.save.c1":`O nome de "Web To CloudCC" deve ser único.`,
"week":`Semana`,
"Pagelayout.Setup.003":`O campo Nome deve ser selecionado`,
"label.query.detail.openpartnermessage":`Uma vez que o cliente é habilitado como parceiro, ele aparece nos relatórios filtrados e vistas de lista no campo ispartner. além disso, os usuários parceiros podem criar a partir de contatos associados a este cliente. você tem certeza?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(data)`,
"label.apply.send.false":`Enviar falha`,
"label.recordtype.edit.selectvalue":`Valores da lista de picking`,
"label.chosesubject":`Selecione um assunto abaixo`,
"label.validate.function.funcExplain.YEAR":`O ano da data de retorno é um número entre 1900 e 9999`,
"component.chatter.button.more":`Veja mais detalhes`,
"label.top.class.smallest":`O nível mínimo da hierarquia é 1.`,
"label.startingvalue":`Número inicial`,
"label.multi.layout.remark":`Layout que se aplica ao Master-Detail Input frontal e Mass Add`,
"label.role.availableuser":`Usuários disponíveis`,
"label.weixin.iebrowser":`A versão do navegador que você está usando atualmente é o IE6, que foi lançado pela Microsoft em 2001. Como a versão do navegador é muito baixa para que o CloudCC seja desenvolvido usando nova tecnologia, não é garantido que todas as funções serão usadas corretamente. Por favor, faça o download e atualize seu navegador a tempo.`,
"Homepage_News_004":`Nenhuma notícia recente.`,
"vue_label_normal_task_sf":`Tarefa`,
"label.version.nonsupport.trigger":`Gatilhos não suportados por enquanto.`,
"pagecreator_page_label_pagelayout":`Layout da página`,
"label_tabpage_step3":`Passo 3 selecione os campos a serem exibidos`,
"label.canOnlyUploadCSVFormatFile":`Carregar somente arquivos em formato CSV`,
"label.b.c.least":`Cada registro "B" deve ter pelo menos um registro "C" relacionado.`,
"label.list.userinterface.sales.enable":`Os painéis de vendas da página inicial permitem a visualização de dados`,
"label.umeng.approval.approvalreject":`O pedido de aprovação para o #obj é rejeitado. #objnome`,
"vue_labenl_normal_notice_share_fail":`A partilha falhou`,
"label_emailtocloudcc_tip":`Pronto`,
"label.h5.touchselect":`Clique para selecionar`,
"label.tabularreport":`Relatório Tabular`,
"label.app.defaulttab":`Separadores padrão`,
"label.validate.function.category.Datetime":`Data e hora`,
"vue_label_pricebook_editdetail":`Editar entradas da lista de preços`,
"vue_label_commonobjects_view_no_selected_record":`Nenhum registro selecionado`,
"chatter.changed":`Alterado`,
"label.asset.bom.based":`Gerar lista técnica de ativos de acordo com a estrutura do produto do pedido`,
"label.appointmentdetail.wizard.title8":`Comece em Cada`,
"label.area.query.user.error":`Os dados do usuário correspondentes ao território de consulta falharam, e a identificação do território estava vazia.`,
"page.field.masterinput":`Configurações de entrada Master-Detail`,
"chatter.selads":`Selecione Destinatários`,
"label.data.exp.please.savebutton":`Favor verificar "Salvar como modelo".`,
"label.members.activity":`Membros da campanha`,
"label.weixin.click.searchs":`Clique para buscar registro`,
"label.input.least.two":`Por favor, insira pelo menos dois caracteres`,
"label.marketing.seting":`Configurações da nuvem de marketing`,
"label.approveprocess.tip":`As aprovações são processos comerciais complexos que requerem coleta de informações e planejamento antes de serem implementados. Recomenda-se que você siga as instruções abaixo antes de começar.`,
"front-email-payment-Invoice-login-account":`Conta de Login`,
"label.selectmulti.mes":`Demasiados destinatários selecionados.`,
"label.workflow.gotolist":`Voltar para a lista: Fluxo de trabalho`,
"label.profile.fieldsafety":`Segurança em nível de campo`,
"front-project-module-v1-no-selectemplat":`Nenhum modelo disponível`,
"label.sendemail.queue.assigntitle":`O e-mail da fila de notificação de atribuição de objeto`,
"label.approval.mobile.comments.placeholder":`Por favor, digite um comentário aqui, até 1000 palavras`,
"vue_label_report_given":`específico`,
"vue_label_dashboard_groups":`Por favor, selecione o grupo`,
"label.service.gantt.popoverTip":`Distância de viagem/tempo de viagem`,
"label.mr.title.characters":`De acordo com o comprimento dos caracteres`,
"label.passwordPolicy.setup.day":`dias`,
"label_tabpage_personvisible":`Visível para o pessoal relevante`,
"ct":`Multimoedas`,
"label.chatter.newEvent":`Novo Evento`,
"vue_label_systemSettings_id":`Identidade de Login`,
"label.page.preview.web.tab":`Aba Web Preview`,
"label_emailsync_button_sure":`Confirme`,
"front-template-V1-Modification-time":`Tempo de modificação`,
"vue_label_homepage_edit_fixed_components":`Editar componentes fixos`,
"label.apply":`Aplicar`,
"Main.Menu.Mobiledownload":`LIGUE-SE`,
"vue_label_salesfunnel_notice6":`A quantidade total de oportunidades com uma probabilidade de 100% de`,
"label.chosesubject.sendemail":`Enviar e-mail`,
"label.changemydisplay.chagetab.des":`Escolha as abas que serão exibidas em cada uma de suas aplicações.`,
"label.attendance.setting.checkUser":`já existe em outros atendimentos.`,
"label.list.projectSetting.setup":`Configurações de gerenciamento de projetos`,
"label.app.introduce2":`Você pode personalizar os aplicativos existentes para corresponder à maneira como você trabalha, ou construir novos aplicativos agrupando as abas padrão e personalizadas.`,
"label_emailsync_form_emialpassword":`Senha`,
"label.Lightning.Setting":`Configuração de relâmpagos`,
"label.print.preview":`Vista para impressão`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Você ainda quer criar o evento neste período de tempo?`,
"label.mobile.phone.report.type":`Tipo de relatório`,
"lable.account.CalenderWeek":`Semana do Calendário`,
"label_emailtocloudcc_step3total3":`Etapa 3 de 3`,
"label_tabpage_emailaddressz":`Endereço de e-mail do remetente`,
"label.data.is_woking":`Operando`,
"label.knowledge.cancelattach.case":`Cancelar Anexar ao caso`,
"label.sendemail.chat.chatcontent":`O conteúdo do post principal:`,
"label.timezone.set":`Configurações territoriais`,
"label_tabpage_uploadingz":`Carregamento`,
"front-epwechat-module-v1-home-url":`URL da página inicial:`,
"label.reportsSubscription.select.subscription.frequency":`Por favor, selecione a freqüência de assinatura!`,
"label.validate.function":`função`,
"label.partnerCloud.orderingPlatform.quantity":`Quantidade`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Configurar um único login para autenticar usuários no CloudCC a partir de ambientes externos.`,
"label.ccchat.message.new.error1":`Não encontramos nenhum usuário de chat com {0} em seu nome.`,
"label.file.share.email.content3":`Para detalhes, por favor, faça o login no sistema CRM CloudCC.`,
"label.file.cancel.sharing":`Cancelar o compartilhamento`,
"label.changemydisplay.showalltabs.add":`Adicionar abas à sua tela padrão`,
"label_chatter_incident":`Evento`,
"label.file.folder.delete3":`Você tem certeza de que deseja excluir {nome do arquivo}？`,
"label_tabpage_delsuccessz":`Eliminar o sucesso`,
"label.view_contact":`Ver Contato`,
"label.deactivate":`Desativar`,
"label.Horizontal.Date":`Filtrar a nomeação do serviço de acordo com a data do nível.`,
"label.forecast.tree.title":`Hierarquia de Previsões`,
"vue_label_dashboard_dategruop":`Favor selecionar a base de agrupamento de datas`,
"label.version.nonsupport.custompage":`As páginas personalizadas não são suportadas temporariamente.`,
"label.tabpage.personvisible":`Visível para o pessoal relevante`,
"message.error.unknown":`Erro Desconhecido`,
"label.down":`Abaixo`,
"label.multilang.customforcast.financialyear":`{0} fiscal year：`,
"label.dataimport.type.error":`Digite o erro, por favor, verifique o registro e modifique.`,
"label.batchadd.newbatchpage.save.num":`Formato numérico incorreto`,
"front-Dev-V12.2.8-calendar-endField":`Campo final`,
"label.tabpage.rtemptyz":`O tipo de registro não pode estar vazio`,
"vue_label_dashboard_maximum":`Favor inserir o máximo`,
"label.expiredate":`Data de vencimento`,
"label_emailtocloudcc_button_view":`Ver`,
"label.event.future":`Eventos futuros`,
"label.mobile.app.layout":`Layout do aplicativo móvel`,
"label.emailobject.contacts":`  contato(s)`,
"label.approvalstep2.tip":`Especificar se um registro deve atender a certos critérios antes de entrar nesta etapa de aprovação.`,
"label.usefollowtoset":`Usando as opções abaixo, especificar o usuário a quem o pedido de aprovação deve ser atribuído.`,
"label.dashboard.summary.editPageHeader":`Edit Header`,
"label_partner_workspace_tab_memo":`Selecionar abas para esta nuvem de parceiros. podem ser selecionadas abas padrão ou abas personalizadas.`,
"front-lightning-module-v1-details-page-chart-title-supports":` O Título suporta a inserção de um nome de registro com um formato de {recordname}, tal como "Quantidade de oportunidade de {recordname}". Se o nome do registro atual for CloudCC, então ele será exibido como "Quantidade de Oportunidade de CloudCC".`,
"label.enable.generate.location.service":`Possibilita a geração de serviços de dados de latitude e longitude do cliente com base no endereço do cliente`,
"label.loginsystem":`Login`,
"label.email.template.edit.template":`Editar modelo`,
"vue_label_commonobjects_detail_share":`Participação na receita`,
"label.icon.142":`Casa`,
"label.maintype":`Mestre`,
"label.step2.total4":`Etapa 2 de 4`,
"label.select.intended.tablayout":`Escolha o layout da página da guia web que você deseja criar.`,
"label.custom.unit":`Unidade`,
"label.mr.title.phone":`Telefone`,
"label.compact.layout.frame.showtype":`Método de exibição:`,
"label.associations":`Objeto associado`,
"label.potentialcustomers.name":`Nome de chumbo`,
"label.edit.profile":`Editar Perfil`,
"label.tabpage.allvisible":`Todos os usuários são visíveis`,
"label.login.verification.confirmation.enabled":`Confirmar para habilitar`,
"vue_label_norm_recordselected":`{selectNum}  registro(s) selecionado(s)`,
"label.partner.workspace.member.selectedprofile":`Perfil selecionado`,
"label.divide":`/Divide`,
"label.version.case.control":`Gerenciamento de casos`,
"label.attendance.nocheckin":`Não Check-In`,
"vue_label_helpcenter_report2.1":`2. remover o agrupamento em fila: <br> A. Após encontrar o campo "agrupamento de linhas" que você deseja remover na lista "linha de grupo" à esquerda, clique no "×" na caixa de campo. <br> B. Ou encontre o campo "agrupamento de linhas" que você deseja remover no cabeçalho do relatório de visualização à direita, clique no botão "drop down" e clique em "delete group row".<br> Remove column grouping: <br> A. Após encontrar o campo "Agrupamento de Colunas" que você deseja remover na lista "Colunas de Grupo" à esquerda, clique em "×" na caixa de campo. <br> 1. B. Ou encontre o campo "Agrupamento de Linhas" que você deseja remover no cabeçalho da tabela do relatório anterior à direita, clique no botão "drop-down" e clique em "Delete Group Row". <br> Para remover um agrupamento de colunas:<br> A. Encontre o campo Agrupamento de Colunas que você deseja remover na lista de Colunas de Grupo à esquerda, e clique no "x" na caixa de campo. <br> B. Ou encontre o campo Agrupamento de Colunas que você deseja remover no cabeçalho da tabela do relatório de visualização à direita, clique no botão suspenso e clique em Excluir Coluna de Grupo. <br>? Personalizando granularidade de data para agrupamento de registros<br> Passo 1: Após agrupar os campos por data, você também pode personalizar a granularidade da data. Primeiro, selecione o campo de data pelo qual você deseja agrupar o relatório. Em seguida, clique no botão Dropdown próximo a este campo no cabeçalho do relatório de visualização e clique em Date Grouping Basis (Base de agrupamento de datas). <br> Passo 2: Selecione como você deseja agrupar: Dia, Mês, Ano, Trimestre Contábil, Ano Contábil, Trimestre Personalizado, Ano Personalizado. <br>? Etapa 1: Após encontrar a coluna que você deseja resumir no cabeçalho do relatório de previsão, clique no botão "drop-down" e clique em "Resumo". <br>?`,
"label.payment.renew":`Renovar`,
"vue_label_file_wrong_type":`Há um erro no tipo de upload do arquivo, o formato do arquivo que você está fazendo upload agora é {type}!`,
"UG_opportunity_005":`Processo de vendas múltiplas`,
"label.knowledge.language.korean":`Coreano`,
"label.customobjects.inputrecordtagandformat":`Digite a etiqueta e o formato do nome do registro`,
"label.h5.chatter.commentednum":`Receber uma resposta`,
"label.quickbooks.button.unlink":`Desbloqueio`,
"label.step5.total5":`Passo 5 de 5`,
"label.projectManagement.Selweek":`Selecione a Semana`,
"label.optional.searchfield":`Campos disponíveis para pesquisa`,
"label.mobile.quickcreate.default.signin":`Fazer o check-in`,
"label.visualpage.unable.parse":`Incapaz de resolver o marcador.`,
"mesage.error.role.delete":`Você não pode apagar o papel ao qual o papel de criança foi atribuído.`,
"label.role.user":`Usuários no papel`,
"button_partner_workspace_saveas":`Salvar como`,
"label.file.no.public.link.created":`Nenhum link público criado`,
"label.login.access.shenyu":`Restante`,
"label.ccchat.group.section":`Grupo`,
"label.weixin.object.notnull":`O tema não pode estar vazio`,
"label.accmarketsea.add.title":`Novo Pool de Contas`,
"label.sales.funnel.layout":`Layout do Funil de Venda`,
"pagecreator.page.button.edit":`Editar`,
"label_tabpage_entercontent":`Por favor, digite o conteúdo`,
"component_event_label_begindate":`*Tempo de partida`,
"label.file.versionhref":`Mudar para a nova versão da página`,
"label_chatter_send":`Enviar`,
"setup_layout_label_buttonlist":`Selecione os botões`,
"label.custom.Current.and.NexttCQ":`Atual e Próximo 3 CQ`,
"pagecreator_page_label_pagedesc":`Descrição da página`,
"label.appupload.upload.uploader":`Carregado por`,
"label.console.step5.tab.primary":`Como tabulação primária`,
"vue_label_globalsearch_expandlist":`Expandir a lista`,
"label.forecast.edit.userqu":`Meta`,
"label.step1.total5":`Etapa 1 de 5`,
"label.multilang.dupicatecheck.onegroupredata":`Progresso da verificação de duplicata e o total combination：a de {0} groups：`,
"vue_label_systemSettings_repeat":`Gerenciar Duplicações`,
"label.mobile.side.tab.error1":`Por favor, selecione os leilões comuns e as guias de aplicação que precisam ser exibidos.`,
"label.knowledgebase.reduction":`Restaurar`,
"label.standard.buttonandlink.override.usedefault":`Sem anulação(uso padrão)`,
"dateandtime":`Data/Hora`,
"label.group.activate.info":`Ativar grupo`,
"label.triggertotask":`Acionadores de tarefas`,
"label.emailobject.save.template":`Salvar rascunho como modelo`,
"label.audit.objInfo":`Detalhe do Processo de Aprovação`,
"label.callcenter.successfully.logged.account":`Conectado com sucesso!`,
"label_new_customer_target":`Nova meta para a conta`,
"label.campaign.channel.step5":`Passo 5: Pré-visualizar a página de registro do canal de marketing e o código fonte.`,
"label.log.type":`Tipos de operação`,
"front-template-V1-noTemplate":`Não foram encontrados modelos disponíveis sob o objeto trocado.`,
"label_report_line_daixuan":`Coluna de relatório pendente`,
"label.tianyancha.businessverify.relation.tip":`Escreva os campos devolvidos por tianyancha aos campos do cliente`,
"label.default.value":`Use este valor como o valor padrão para a lista de seleção principal`,
"label.weixin.campaign.attendance":`Participação em campanhas`,
"message.duplication.label.check":`Verifique`,
"label.salescloud.salescloud.yes2forbidden":`Sim, eu quero desativar a venda em equipe.`,
"lable.currencyAdv.exchagecurrency.rate":`Taxas de câmbio para:`,
"lable.Hide.title":`Ocultar títulos`,
"label.finishedreport":`Relatórios Gerados`,
"vue_label_account_business":`Transferir oportunidades de negócios fechados de proprietários de clientes`,
"vue_label_pool_assigned":`Atribuído`,
"label.report.export.error":`A operação de exportação encontrou uma exceção. Por favor, tente novamente.`,
"label.layout.availablefield":`Campos disponíveis`,
"label.licence.remainder":`Restantes licenças`,
"label.approval.idea.required":`É necessário um parecer de aprovação.`,
"front-kefu-moudle-needhand-createcase":`Confirmação manual é necessária antes da criação do caso`,
"label.dashboard.snapshot.Data.change":`Fonte de dados alterada, favor reconfiguração`,
"label.partner.workspace.login.footertext":`Texto do rodapé`,
"vue_label_chatter_upload_link_type":`Carregamento selecionado de linha tipo post`,
"front-dialog-module-v1-error-detail":`Detalhes do erro`,
"label.emailobject.sendgroupemail":`Enviar e-mail do grupo`,
"lable.newtabpage.allviews":`Todos os pontos de vista`,
"label.khdd":`Localização da conta`,
"vue_label_dashboard_sortfield":`Ordenar Campo`,
"label.form.sample":`Exemplo de formulário`,
"component_setup_button_cancel":`Cancelar`,
"vue_label_salesfunnel_notice5":`Quantidade de oportunidades de negócios com uma probabilidade de 1% - 99% * probabilidade`,
"pagecreator_systemstyle_label_modifystyle":`Editor de estilo`,
"UG_homepage_001":`Ganhe mais negócios em menos tempo`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Versão relâmpago`,
"label.knowledge.category.hint.two":`Use esta página para selecionar o grupo para Relâmpago depois de criar o grupo de categoria.`,
"label.south.africa.standard.time":`Tempo padrão da África do Sul`,
"label.service.gantt.reservation.number":`Número do pedido`,
"label.weixin.report.period":`Período`,
"label.leadtomap.exp":`Use as abas para mapear cada um dos campos de chumbo personalizados de sua organização em um de seus campos personalizados de conta, contato ou oportunidade. Estes mapeamentos são usados quando você converte os leads para contas, contatos ou oportunidades.`,
"label.currency.d":`Você pode mudar sua moeda corporativa para outra moeda suportada por sua organização. Todas as taxas de conversão de moedas já definidas no CloudCC.com serão modificadas apropriadamente para refletir a mudança.`,
"label.forecast.detailforecast.oppyclb":`Categorias de Previsões de Oportunidades`,
"label.reportsSubscriptionPage.email.selected":`Membros selecionados`,
"vue_label_homepage_componentname":`Por favor, digite o nome do componente`,
"lable.account.Previous.FYt":`Anterior 2 FY`,
"label.appupload.success":`Upload Completo`,
"label.customer.newtab":`Nova guia de página personalizada`,
"label.value.notnull":`Você deve inserir um valor.`,
"label.case.miniprogram.layout":`O layout da página de relatório do applet é o layout da página utilizado para a solicitação de serviço que foi enviada do final do applet, e este layout de página só pode ser editado e não pode ser apagado.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Favor entrar no formato correto.  Duas casas decimais podem ser mantidas.`,
"UG.Lead.004":`Formulário web`,
"label.umeng.activity.event.eventwillbeginnew":`Notificação de eventos: #evento começa em #begintime`,
"label.projectManagement.subtasks":`Sub-taks`,
"vue_label_checkduplicate_repeat_conditions":`Decidir condições repetidas`,
"label.subject":`Assunto`,
"label_search_otherusers_forecast":`Busca de previsões de outros usuários`,
"label_tabpage_namemandatory":`O nome da vista é obrigatório`,
"label.timezone.importtimezone":`A configuração do fuso horário para importação de dados`,
"label.mobile.buttom.team.init":`Inicialização do usuário da equipe`,
"label.checkfield.choosefield":`Selecione os campos para encontrar as duplicatas`,
"label.b_c_least":`Cada registro "B" deve ter pelo menos um registro "C" relacionado.`,
"label.knowledge.setting.hint.five":`Selecione um autor de Conhecimento`,
"label.h5.similar.opportunity.step2":`Etapa 2 Especifique os Critérios de Partida`,
"label.page.style.imbedded.cloudcc":`O estilo de página inteira dá a você maxmium screen real estate para o conteúdo que você embute na janela do CloudCC.com.`,
"label.sendemail.marketactivity.invitecode":`O código de inviolabilidade da campanha #campaignname`,
"label.block.pricing":`Preços por blocos`,
"message.error.field.number.zero":`O formato de comprimento do erro introduzido, não pode ser 0.`,
"pagecreator.systemstyle.message.save.success":`Estilo salvo com sucesso`,
"pagecreator_systemstyle_label_styledesc":`Descrição de estilo`,
"APPIntegration_Dropbox_setting_01":`Habilitar`,
"label_emailtocloudcc_redmessage2":`Por favor, digite a senha correta de sua conta de e-mail`,
"label.user.special.operations":`Utilizado somente em operação, não pode ser utilizado temporariamente, favor entrar em contato com o administrador!`,
"pagecreator_page_label_layoutpreview":`Visualização do layout`,
"APPIntegration_Dropbox_setting_03":`Habilite o Dropbox para permitir que você selecione arquivos do Dropbox e adicione-os como anexos.`,
"label.sure_leave":`Você tem certeza de que vai embora?`,
"label.applt.copylink":`Cópia do link do miniprograma`,
"label_tabpage_allpotentialcustomers":`Todas as pistas`,
"label.rulestrikedate":`Tempo de acionamento das regras`,
"label_tabpage_justsz":`Apenas`,
"label.customize.memory.function.sorting.title":`Personalizar minha função de classificação de memória`,
"message.duplication.label.mergebutton":`Fundir`,
"chatter.group.cancelRequest":`Pedido de cancelamento`,
"label.campaign.channel.step6.remark":`Se você confirmou a página de registro, clique em Gerar botão para gerar a página de registro.`,
"label.appupload.upload.install.abort":`Cancelar a instalação`,
"label.emailobject.proposetimes":`Propor tempos`,
"label.probability.cannot.empty":`Você deve inserir um número na sua possibilidade de oportunidade.`,
"vue_label_homepage_editkanban":`Editar Kanban`,
"lable.Related.template":`Modelos relevantes`,
"label.cloudccclass.list.cls.time":`Classes programadas`,
"component.task.label.enddate":`Data de expiração`,
"label.sendmail.step3":`Passo 3 Rever e confirmar`,
"label.projectManagement.Gridview":`Vista da grade`,
"label.emailobject.time":`Hora`,
"label.applt.address":`Portal de Atendimento ao Cliente do Miniprograma`,
"label.searchfield":`Campos de busca`,
"vue_label_calendar_please_enter_the_name":`Por favor, digite o nome`,
"label.list.userinterface.default.page.setup":`Página padrão do sistema`,
"label.detail.2018":`Detalhes`,
"label.webtocloudcc.success":`Suas informações foram enviadas com sucesso. Muito obrigado por sua participação, nós o atenderemos de todo o coração.`,
"component_telerecord_label_title":`Telefone para gravação`,
"label.setting.sureDelete.rules":`Você tem certeza de que quer apagar esta regra?`,
"vue_label_email_current_theme":`A inserção deste modelo cobrirá o assunto atual do e-mail.`,
"lable.Order.product":`Pedido Produto`,
"UG_product_02":`Os produtos referem-se a produtos ou serviços que são vendidos ou comprados.`,
"label.appexchange.task":`Tarefas de fluxo de trabalho`,
"label.selectprocesscondition":`Especificar condições para a etapa`,
"label.mobile.quickcreate.default.scan":`Digitalização`,
"label.tabpage.prepagez":`Mostrar em todas as páginas`,
"label.query.error":`Erro de consulta.`,
"label.tabularreport.2018.step1":`Passo 1 Escolha as colunas do relatório`,
"pagecreator.systemstyle.label.modifystyle":`Editor de estilo`,
"label.app.step3":`Passo 3 Escolha a fonte da imagem para o logotipo do aplicativo personalizado`,
"label_tabpage_rowsz":`Eliminar filas`,
"label.validate.function.funcExplain.SUBSTITUTE":`Substitui texto_novo por texto_antigo em uma cadeia de texto. Use SUBSTITUTO quando quiser substituir um texto específico em uma cadeia de texto.`,
"vue_label_checkduplicate_select_data_to_merge":`Selecione os dados a serem fundidos`,
"vue_label_commonobjects_view_chart_displaymode":`Modo de exibição`,
"label.industrialandcommercialverification.servicesetiings":`Configurações de serviço`,
"label.refresh":`Atualização`,
"label.taskfield":`Campos de tarefas`,
"label.notification.approval4":`【提交人】 está solicitando aprovação para 【对象】`,
"label.group.isusing":`Ativo`,
"label.language.settings":`Definição do idioma`,
"front-kefu-moudle-please-login":`Por favor, faça o login primeiro`,
"label.page.double.line.cloudcc":`2 Colunas Com Sidebar do CloudCC.com`,
"folder.error.delete":`1. A pasta atual contém relatórios e não pode ser apagada! 2. A pasta atual contém relatórios ocultos e não pode ser excluída! Relatório oculto é um relatório criado com base em um objeto logicamente eliminado (configurações-criação-deleted objects under the object), porque o objeto não é realmente eliminado, então o relatório é oculto`,
"eight":`Oito`,
"label.marketseamemset.user":`Membro`,
"label.recordnum":`Número de registro`,
"page.404.button.back":`Voltar ao Passo Anterior`,
"label.mobile.phone.month.plan":`Planos do próximo mês`,
"label.marketseamemset.account.title2":`Favor estabelecer um limite superior para o número de clientes que afetam todos os membros. O limite não está relacionado com o grupo de clientes principais.`,
"vue_label_chatter_current_avatar":`Avatar atual`,
"label.mobile.side.tab.remark3":`Mantenha pressionado o botão shift, clique ou clique em arrastar para selecionar uma série de itens adjacentes. mantenha pressionado o botão ctrl e clique para selecionar vários itens não aderentes.`,
"component.sendmail.label.touser":`Destinatário`,
"label.homeitems.noobject":`Sem assuntos`,
"template.report.overall.sales":`Período total de vendas (Por fonte líder)`,
"label.partner.donotdel":`não pode apagar`,
"label.service.miniProgram.bindCopyDesc":`Após vincular sua organização à conta oficial de sua empresa ou ao mini programa, você pode usar este endereço como seu próprio portal de atendimento ao cliente, copiando e pulando para este endereço.`,
"UG_Contract_01":`Gerenciar contrato`,
"UG_quota_06":`Crie uma cotação`,
"vue_label_report_deletereport":`Eliminar relatório`,
"front-epwechat-module-v1-input-appname":`Por favor, digite o nome da aplicação`,
"label_tabpage_deleteviewsuccess":`Ver excluir sucesso`,
"component_chatter_label_mygroup":`Meu grupo`,
"label.campagin.roi.leixing":`Tipo de campanha`,
"label.dashboard.myHomepageDashboard":`Meus Painéis de Homapage`,
"UG_solution_04":`Solução de importação`,
"label.knowledge.setting.hint.four":`Ativar o conhecimento`,
"label.campaign.channel.add.field":`Clique no botão para adicionar campos`,
"label.eastem.european.time":`Tempo do Leste Europeu`,
"label.partner.workspace.member.partner":`Perfil do parceiro CloudCC`,
"label.campaignmember.main.backtocampaign":`Voltar para Campanhas`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absoluto`,
"label.task.unsolve":`Todas as tarefas em aberto`,
"label.multilang.chatterservice.vote":`{0} bilhete(s)`,
"label.console":`Console`,
"label.emailsync.message1":`Se você cancelar a conexão, você não poderá sincronizar o conteúdo da caixa postal com os contatos e contatos, você tem certeza de que quer cancelar?`,
"pagecreator.systemstyle.label.stylename":`Nome do estilo`,
"setup_mainpage_label_welcome16":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, e mais.`,
"message.duplication.label.editfilterule":`Encontrar regras de filtro duplicadas`,
"Account.News.Setting.004":`Habilitar Notícias`,
"label_tabpage_saveviewsuccess":`Vista salva com sucesso`,
"label.forecast.forehistory.replacecommit":`Comprometa-se a Substituir`,
"pagecreator_button_cancel":`Cancelar`,
"label.knowledge.article.nomatch":`Não é possível arquivar este artigo para o rascunho associado existe. Favor apagar o rascunho e tentar novamente.`,
"vue_label_combined_field":`Sem campos para somar.`,
"label.batchadd.save.prompt":`registro(s)`,
"label.tabpage.summaryway":`Resumo por`,
"label.check.input.condition.two":`SQL não é suportado`,
"mail.apiCode.notOnly":`O único nome já existe`,
"UG.quota.01":`Gerenciar cotações de contas`,
"label.approved.receiveApprovalEmail.option3":`Somente se eu for um aprovador delegado`,
"label.stdashbord.xsld.business.img5":`Montante total de probabilidade 0%`,
"vue_label_chat_movedfromto":`{nome} moveu {label} de {oldField} para {novoField}`,
"label.customfields.new.step2.opration":`Opções gerais`,
"label.dashboardSetup.isurl":`Adicionar links`,
"label.forecast.settings.mrfwqj":`Ciclo de Previsões`,
"label.campaign.channel.field":`Campos`,
"label.weixin.optionthree":`Escolha 3`,
"label.safetystatement":`Declaração de segurança`,
"label.useskipwizard":`Use o Jump Start Wizard`,
"label.projectManagement.completion":`Status de conclusão`,
"label.customfields.fielddependency.new.step2":`<b>Passo 2: </b> Na página seguinte, edite as regras de filtragem que controlam os valores que aparecem no campo dependente para cada valor no campo de controle.`,
"setup.mainpage.label.welcome8":`Personalização da interface de arrastar e soltar`,
"label.emailobject.list.outbox":`Caixa de saída`,
"label.app.default.login.tab":`Aba de Login Padrão`,
"label.follow_emails":`O email de acompanhamento é uma ótima maneira de contatar seus visitantes rápida e facilmente, uma vez que eles enviem formulários.`,
"vue_label_homepage_application_page":`Página inicial da aplicação`,
"label.confirm.template":`Confirme`,
"lable.product.not":`Não foi possível apagar completamente`,
"label.multilang.feedtrack.dispalyinfo":`Você pode escolher o máximo de campos {0}:`,
"label.weixin.plz.inputsrhkey":`Por favor, digite uma palavra-chave de busca`,
"label.projectManagement.service.appointment":`Nomeação de serviço`,
"label.list.userinterface.watermark.enable":`Habilitar marcas d'água na página inicial, vistas, páginas de detalhes, relatórios e painéis no PC e no aplicativo móvel.`,
"label.confirmDelete":`Você tem certeza de que quer apagar esses dados?`,
"label.sso.description":`Os usuários podem acessar o sistema CloudCC.com sem fazer login de acordo com o nome de usuário e código de autorização.<br>Click URL abaixo para acessar o sistema CloudCC.com: _COPY7@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Utilize os links acima,'http://localhost:8080' substitua o acesso de sua organização ao link.'admin@dev.com' substitua seu nome de usuário da organização.<br>'dcc5c192facd7c08e124fbe93d8950b9' substitua seu código de autorização da organização.`,
"errormessage_email_atleastonereceiver_z":`Você deve selecionar ou editar um endereço de recebimento.`,
"C":`Resumo do Roll-Up`,
"label.service.major.event.edit":`Editar Marco`,
"label.icon.9":`Serviço`,
"label.visualpage.notvalidate.check":`Páginas personalizadas inválidas, favor consultar o Texto de Ajuda para verificar a página.`,
"label.audit.todo.from":`de`,
"label.directboss":`Esta função se reporta a`,
"label.manageAll.selpage":`Página`,
"label.console.step6.all":`Tela cheia, não fixada e as listas são visíveis somente quando a guia de navegação é selecionada.`,
"vue_label_pool_expiredate":`Data de expiração`,
"lable.no.matching.record":`Sem registro de correspondência`,
"label.standard.redirecterror":`Saltar para página personalizada através de botões padrão falhou.`,
"label.Platform.Setting":`Configurações da plataforma`,
"lable.outlook.edit.havenewc":`Contatos com atividades recém-criadas`,
"label.partnerCloud.partnerAccount.choosePayment":`Favor selecionar uma forma de pagamento`,
"label.weixin.optionsix":`Escolha 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Gasoduto`,
"page_404_button_toknowmore":`Saiba mais`,
"label.customfields.number.tip":`Permite que os usuários digitem qualquer número. Os zeros principais são removidos.`,
"label.import.index.processimport":`Importando`,
"label.quote.phone":`Telefone`,
"label.insert.approval":`Inserir Aprovação`,
"label.tabpage.printview":`Vista de Impressão`,
"lable.product.price":`Preço`,
"front-kefu-moudle-call-detail":`Detalhes da chamada`,
"label.umeng.approval.apply":`se aplica`,
"label.background.the.form":`Fundo do formulário`,
"chatter.f":`Seguidores`,
"label.quickbooks.searchresault.company":`Empresa`,
"vue_label_systemSettings_platformutils":`Ferramenta da plataforma`,
"front-quotation-v1-nofilles-tocreate":`Favor clicar em Gerar Orçamento e enviar após a geração.`,
"label.category.6":`Tratamento médico`,
"label.attendance.choose.positon":`Selecione Pontos de referência`,
"label.batchadd.newbatchpage.save.pho":`Formato de telefone inválido`,
"UG.Account.01":`Quem é sua conta?`,
"label.marketseamemset.addspecialuser":`Adicionar membros especiais`,
"label.query.detail.forbidpartneruser":`Proibir usuário parceiro`,
"label.stdashbord.xsld.business.ydzhl":`Taxa de ganhos`,
"vue_label_SMS_mymessagebox":`Minha caixa de mensagens`,
"label.knowledgebase.data.publishing.failed":`Publicar {a} os dados falharam. Favor escolher o artigo com status igual a Rascunho para publicar.`,
"label.wholestate":`Status geral`,
"label.selectedline":`Colunas Selecionadas`,
"label.validate.function.funcExplain.LEFT":`Retorna o número especificado de caracteres desde o início de uma cadeia de texto`,
"label.emailmerge.edittemplate.detail":`Detalhes do Modelo de Mescla de Correio`,
"vue_label_checkduplicate_checkduplicate":`Verificar duplicata`,
"label.knowledgebase.assign.articles":`Assing Articles`,
"label.tabpage.recordsz":`Registro`,
"label.field.img.validate.error":`O nome da variável após $User está mal escrito ou é uma referência ilegal de $User, favor verificar a ortografia.`,
"workorderlineitem.worktype.isnot.father.worktype":`O tipo de trabalho associado a seu registro pai deste item da ordem de trabalho deve ser selecionado.`,
"label.ccchat.group.name.noexist":`O nome do grupo que você inseriu não existe, por favor, entre novamente.`,
"label.weixin.sign.type":`Tipo de erro de entrada (saída).`,
"label.nowvaluereplace":`Substituir por Existente`,
"report_label_report":`Relatórios`,
"label.knowledge.setting.plus":`Mais configurações de conhecimento`,
"label.event.moveup.2day":`2 dias à frente`,
"label.translation.start":`Para começar no Workbench de Tradução:`,
"lable.PowerProcess.created.time":`Com base no tempo de criação do {detailInterestType}`,
"label.ems.step2":`Etapa 2`,
"label.tabpage.groupingemptyz":`Os itens de agrupamento não podem estar vazios`,
"pagecreator.layout.button.new":`Novo layout`,
"label.tabpage.listshow":`A lista mostra`,
"label.partnerCloud.productSet.optionName":`Nome da opção`,
"label.service.without.cycle":`Sem ciclo`,
"label.chatter.sendEmailToGroupMember.subject.V":`Votos publicados para todos em {1}`,
"label_target_model_dimension":`Dimensão do modelo alvo`,
"component.task.label.subject":`Tema`,
"label.custom.field.login.query.information":`Por favor, digite o sistema e veja os detalhes.`,
"label.validate.function.funcExplain.NOT":`Mude FALSO para VERDADEIRO ou mude VERDADEIRO para FALSO`,
"pagecreator_layout_button_horizontal":`Desmontagem lateral`,
"lable.Returned.to.successful":`Retornar com sucesso`,
"label.campaign.channel.ticket.title":`Ingresso de admissão`,
"label.ruleName.supportMaximum.50Characters":`Um máximo de 50 caracteres é suportado para o nome das regras.`,
"label.email.track.attachment.size.control1":`O tamanho total do anexo excede 20m, não pode ser carregado`,
"template.report.folder.opportunities":`Análise de Oportunidades`,
"label.knowledge.setting.data.eight":`Você vai apagar o grupo de categorias {flzmc} e suas categorias. Esta categoria não estará disponível para atribuição aos registros. Você tem 15 dias para cancelar a exclusão do grupo de categorias. Após 15 dias, ele será apagado permanentemente e não poderá ser recuperado. Você tem certeza de que deseja excluir este grupo de categorias e suas categorias?`,
"mail.id.notNull":`A identificação não pode estar vazia quando se apaga o modelo`,
"vue_label_normal_product_sf":`Produto`,
"vue_label_report_superiortothisrelationship":`A relação entre o objeto superior e este objeto`,
"label.leadscore.operation":`Operador`,
"label.customfields.formula.percentexample":`Desconto = (Montante - Desconto_Amount__c) / Montante`,
"component.setup.iframe.label.inputurlmemo":`Por favor, digite a url da página a ser importada`,
"label.icon.177":`Logotipo`,
"label.tabpage.myz":`Meu`,
"label.leadmarketsea.add.title":`Criar um grupo de líderes`,
"label.partnerCloud.partnerAccount.thePage":`Página {skippageNum}`,
"label.visualpage.some.size":`Capacidade de código: suporte máximo para caracteres de 300KB, aproximadamente 300.000 bytes.`,
"label.setwxpay.null":`As informações necessárias para configurar o pagamento WeChat estão vazias.`,
"label.icon.74":`Máquina-ferramenta`,
"font-evaluate-module-v1-evbad":`O tipo de avaliação é Negativa`,
"System.TimeField.Format.Warning":`Tempo inválido`,
"label.captcha":`Código de Verificação Aleatória`,
"label.payment.assessment":`Confira Outras Edições`,
"message.error.not.taskevent":`Objeto de evento não-tarefa`,
"font-evaluate-module-v1-evaluation":`Avaliação`,
"vue_label_commonobject_view_updatedago":`Atualizado {timeInterval} atrás`,
"label.sendemail.birthday.newevent":`Prezado {!ownerName}：\r}n {!objectLable} {!recordName} o aniversário será em 3 dias. Por favor, seja aware！r{!orgName}`,
"label.laststep":`Passo Anterior`,
"message.duplication.label.matchoption":`Opção de correspondência`,
"label.setupmultplerecordtype":`Tipos de registros múltiplos`,
"vue_label_account_unprocessed_oppprtunities":`Oportunidades não processadas`,
"KeyInformationLayout.DefaultLayout.Name":`Default do sistema`,
"label.partner.all":`Todas as nuvens de separação`,
"label.datamanage.export.error":`A exportação falhou`,
"label.standard.buttonandlink":`Botão padrão ou Link`,
"label.reportsSubscriptionPage.email":`Relatório por e-mail`,
"message.nogrammarfaultinformula":`Sem erros de sintaxe.`,
"front-kefu-moudle-nofind-instance":`Nenhuma instância encontrada`,
"label.is.delete.data":`Os registros que você deseja excluir contêm os registros que estão solicitando aprovação, você tem certeza de que deseja excluir?`,
"label.partner.error":`Erro: erro no formato do domínio`,
"label.notification.time2":`{0} minutos atrás`,
"label.ccchat.person.invite.needfirstname":`Digite seu nome`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`Sem Registros.`,
"label.readwrite":`Leitura/escrita`,
"label.partnerCloud.orderingPlatform.orderPayment":`Pagamento de pedidos`,
"label.accesslimittype":`Nível de acesso`,
"label.preciew_tab":`Link de prévisualização em nova guia`,
"label.attachment":`Anexo`,
"label_tabpage_helpNavigationz":`Ajuda e navegação`,
"label.dataimport.select":`Verifique estas informações, realize os dados de importação`,
"chatter.en.info":`Insira informações para que as pessoas possam saber mais sobre você.`,
"label.ccservice.validate.date":`O formato do valor correspondente {2} do campo {1} sob o objeto API {0} está incorreto. Por favor, digite o formato correto de data ou hora!`,
"label.social.posts.send":`Falha no correio`,
"label.emailobject.time.to":`Para:`,
"label.defineReportStep1":`Passo 1`,
"savefail":`Salvar falhou`,
"label.mr.descreption.title":`Fundir dados duplicados`,
"label.share.info.by":`Por`,
"label.list":`Lista`,
"label.event.select":`Selecionado`,
"message.accountmap.cannotfind":`O endereço da conta não pôde ser encontrado, favor atualizar o endereço da conta.`,
"label.choosefield":`Campos da Página de Aprovação`,
"label.forecast.settings.title":`Configurações de Previsões`,
"label.setup.log.datetime":`Log de comportamento de download dentro do intervalo de tempo de busca (Excel.xls)`,
"button_partner_new":`Nova nuvem de parceiros`,
"label.umeng.approval.dlsp.reject":`#aprovaçãonome rejeitou o pedido de aprovação do #actorname de #objAPIName #recordname para você.`,
"label.tabpage.totalTeamz":`Um total de grupos`,
"label.lead.score.prompt3":`Isto pode levar vários minutos. Você receberá um e-mail de confirmação uma vez concluído.`,
"label.schedulejob.setup.schedule.name":`Nome do cargo`,
"vue_label_report_advanced":`Quando o filtro avançado é ativado, escreva manualmente a condição do filtro na caixa de filtro avançado abaixo, o formato é mostrado na figura.`,
"label.emailsync.form.connecttime":`Tempo Relacionado`,
"front-gantt-module-v1-project-status":`Status do projeto`,
"label.field.for.example":`Por exemplo`,
"label.marketsea.manager.notnull":`O administrador não pode estar vazio.`,
"label.click.here":`&lt&lt Clique aqui para voltar`,
"UG.solution.04":`Solução de importação`,
"label.validate.function.funcExplain.IF":`Se a condição é verdadeira ou não, e se a condição é VERDADEIRA devolve um valor e a condição é FALSA, outro valor é devolvido.`,
"label.profile.settab":`Configurações das abas`,
"front-email-payment-weichat-tips":`Digitalize o código QR para pagar`,
"label.task.next.week":`Semana seguinte`,
"label.operatedata.selectobjectfields.tip":`Selecione os campos que deseja exportar, e você deve selecionar pelo menos no campo para exportar.<font color="red">Attention:Text Area(Rich) não pode ser exportada.</font>`,
"label.recalculate.alert":`Favor selecionar a regra de compartilhamento que você deseja recalcular.`,
"label.marketsea.noopportunitydays":`Dias sem criar oportunidades de negócios (precisa ser maior que o número de dias sem acompanhamento após a obtenção)`,
"label.chat.likeperson":` Pessoa(s)`,
"label.selectedFields":`Campos disponíveis`,
"label.App":`Aplicações`,
"label.file.type":`Tipo de arquivo`,
"permissionService.error1":`Licença de aplicação insuficiente.`,
"front-detail-module-v1-chart-display":`Visualização de gráficos`,
"label.audit.status":`Status de Aprovação`,
"UG.activity.05":`Telefone de gravação`,
"label.connectOtherObject":`( Clique para relacionar outro objeto )`,
"lable.currencyManage.unEnabledadvcurrency":`Desativar o Gerenciamento Avançado de Moeda`,
"label.ccpeak.getthree.function":`Há três funções, e`,
"label.weixin.new.weitoupiao":`Por favor, crie um novo micro voto, os usuários podem participar da votação e ter acesso aos resultados da votação em micro eventos no WeChat.`,
"label.tag.manage.prompt":`Tag já exsits！`,
"label.goon":`Continuar`,
"label.addworkflowoperate":`Adicionar Ação de Fluxo de Trabalho`,
"label.weixin.click.search":`Clique para buscar registro`,
"vue_label_report_deletecolumn":`Eliminar coluna`,
"label.ordercondition":`Ordenar por`,
"message.error.group.notallow":`O grupo não permite o arquivamento`,
"label.unread":`Emails não lidos`,
"vue_label_report_notice_namerequired":`O nome da coluna é obrigatório`,
"label.tabpage.entercontent":`Por favor, digite o conteúdo`,
"label.schedulejob.setup.schedule.startdate":`Data de início`,
"component_assistant_button_newtask":`Nova tarefa`,
"vue_label_report_notice_filter1":`Você tem que preencher manualmente o(s) filtro(s) avançado(s) abaixo, como mostrado na figura ao ativar o filtro avançado`,
"value":`Valores`,
"label.icon.70":`Serviço`,
"label.knowledgebase.delete.draft.t":`Eliminar rascunho`,
"label.setup.mini.bind":`Programas Bind Mini`,
"component_timeline_button_more":`Mais passos`,
"label_emailtocloudcc_redmessage4":`Por favor, insira os detalhes da porta`,
"label.field.input.number":`Por favor, digite os números válidos`,
"front-invoice-online-payment-setup-title":`Iniciar pagamento online`,
"front-kefu-moudle-called-user":`Chamada Pessoa`,
"label.currency.disable":`Moedas inativas`,
"label.user.alias":`Alias`,
"UG_quota_04":`Imprimir cotação`,
"label.chatter.delete":`Excluir`,
"label.addtocurrentcustomer":`Anexado às Contas Existentes`,
"message.error.recordid.null":`recordid não pode estar vazio!`,
"label.merge.records":`Fusão de registros`,
"report_label_norole":`Você não tem permissão para fazer isso, por favor, entre em contato com seu administrador.`,
"label.pqrs":`.`,
"label.email.attach.button":`Clique no botão "anexar`,
"label.tabpage.selrecordtypez":`Selecione o tipo de registro`,
"label.ServiceCloud.purchase.date":`Data de compra`,
"label.customreporttype.delete.prompt":`Favor excluir o seguinte relatório antes de excluir a operação de exclusão`,
"label.brief.total.page":`Um total de {total} página(s)`,
"label.reportsSubscription.unsubscribe":`Anular a inscrição`,
"label.ccpeak.take.notice.exp.order":`Notas: deve ser adicionado "__c" após o nome da API dos campos nas condições de expiração e de pedido.`,
"report_type_label_quote":`Citações`,
"label.file.norecord":`Nenhum item a ser exibido`,
"vue_label_checkduplicate_all_processed":`Todos os dados foram processados`,
"label.next":`Próximo`,
"label.icon.10":`Folder`,
"label.lanxin.title.setting":`Informações integradas`,
"label.h5.chatter.business":`Oportunidades associadas`,
"lable.are.you.sure.to.delete.this.view":`Você quer apagar esta visão?`,
"vue_group_no_operation_permission":`Sem permissão para operar!`,
"label.knowledge.archive.article":`Artigo de Arquivo`,
"vue_label_lead_":`Nenhuma regra de pontuação ativa disponível, favor entrar em contato com o administrador do sistema`,
"label.fiscal.error.between":`A data de início ou término do ano fiscal está entre os anos fiscais históricos, favor verificar e reiniciar`,
"label.stdashbord.xsld.business.qdzje":`Montante total (Oportunidades fechadas)`,
"label.calendar.day.view":`Visão do dia`,
"label.emailtocloudcc.tip":`Pronto`,
"label.schedulejob.setup.schedule.st1":`O 1o.`,
"label_tabpage_addtoworkbench":`Adicionar à bancada de trabalho da página inicial`,
"label.umeng.approval.waitapproval":`aguardar aprovação`,
"label.justcheckingwebsite":`Verificar apenas o site`,
"homepage.components":`Página inicial Componentes`,
"label.audit.remark":`Notas de Aprovação`,
"label.searchs.labelname":`Busca {fielabelNome}`,
"label.remarkofreport":`Nota de relatório`,
"label.weixin.isno":`se`,
"label.currencyCode":`Código da moeda`,
"label.service.resources":`Recursos`,
"label.clone_form":`Formulário de Clone`,
"label.weixin.view.information":`Ver detalhes`,
"UG_activity_05":`Telefone de gravação`,
"chatter.feed.menutype.user.recentuser":`Pessoas que recentemente viram`,
"label.marketsea.notfollowdays2":`Dias sem acompanhamento`,
"label.tabpage.namemandatory":`O nome da vista é obrigatório`,
"message.demo.nosupport":`Esta característica será implementada no próximo lançamento.`,
"label.mail.merge.template":`Fusão dos modelos de e-mail......`,
"label.sendemail.marketactivity.sign":`Notificação do sinal de campanha`,
"setup_layout_group_relatedlist":`Listas relacionadas`,
"label.pc.ui.2018.all.tabs":`Todos os menus`,
"label.field.lost.right.bracket":`O parêntese fechado se perde`,
"label.datamanage.contact.novalue":`Nota: O campo do nome do contato é nulo, os registros de contato não serão importados.`,
"label.version.unlimited.edition":`Edição Ilimitada`,
"vue_label_dashboard_selectsortfield":`Favor selecionar o campo de ordenação`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Visível para`,
"thursday":`Quinta-feira`,
"label.nextapprover":`Próximo Aprovador`,
"setup_mainpage_label_manageuser":`Gerenciar usuários`,
"label.saveandcontinue":`Salvar`,
"label.top.userCenter":`Centro Pessoal`,
"component.chatter.file.button.save":`Publicar`,
"label_emailsync_setting":`Configurações pessoais de e-mail`,
"label.usableshareuser":`Disponível Compartilhado para`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Exibir valores em ordem alfabética, não na ordem inserida`,
"label.list.button":`Atribuição de perfil`,
"chatter.up.m":`Erro:Os arquivos carregados são muito grandes. O tamanho máximo do arquivo é de 20 MB.`,
"label.knowledgebase.filters":`{a} filtros`,
"label.sso.saml.sp.idtype.username":`Assertion contém o nome de usuário do CloudCC do usuário`,
"vue_label_file_size_limit":`O tamanho do arquivo não excede {tamanho}Mb`,
"label.appupload.install.error.choice4":`Pular componentes conflitantes, não instalar componentes conflitantes`,
"label.currencyDecimalDigits":`Lugares decimais`,
"label.weixin.customer.details":`Detalhes da conta`,
"component.timeline.label.7daysahead":`7 dias antes`,
"label.sendsms.batch.step1":`Passo 1 Especifique os destinatários para incluir`,
"label.brief.opportunity1":`Oportunidades`,
"label.datamanage.click.importbutton":`Clique <b>Importar</b> e os dados serão importados para o sistema CloudCC.`,
"label_filter_benchmark_objects":`Objeto de referência do filtro`,
"label.area.record.notexist":`O registro não existe.`,
"label.event.overdue.unfinished":`Eventos em atraso`,
"label.file.publicview.errortype":`O tipo de arquivo dos não suporta pré-visualização`,
"label.setup.mobile.bottombutton.profile.setting":`Personalizar o menu inferior do perfil`,
"label.campaignmember.main.addleaddesc":`Adicionar todas as pistas existentes a esta campanha`,
"vue_label_approve_actual_operator":`Operador real`,
"label.version.essential":`Edição essencial`,
"lable.SalesCommitmentKanBan.commitments":`Gasoduto`,
"label.chatter.pastEvents":`Atividades passadas`,
"vue_label_calendar_choose_calendar_type":`Escolha o tipo de calendário`,
"label.service.dispatchingUnits.batch.send":`Atribuição de lotes`,
"chatter.poll.option8":`Escolha 8`,
"label_tabpage_summaryway":`Método sumário`,
"front-kefu-moudle-trindex-copy-num":`Favor copiar o nº da empresa na página inicial do sistema Tianrun`,
"lable.quote.syncing.syncfinish":`Sinc Concluído`,
"label.home.task.finish":`Tarefa concluída`,
"label.toleadfield":`Campos de chumbo do mapa`,
"label.everyone":`Todos`,
"label.multilang.databatchadd.success":`{0} os dados foram adicionados successfully：`,
"label.quote.createdate":`Criar data`,
"email.template.nopermission":`Somente administradores podem editar os modelos nesta pasta`,
"label.report.action.addtodashboard2":`Adicionar Painel de Controle`,
"label.campaign.name":`Nome da campanha`,
"label.check.input.condition":`Erro de sintaxe, favor verificar os critérios de filtragem que você inseriu`,
"front-epwechat-module-v1-upload-file":`Upload do documento de crédito:`,
"label.batchadd.newbatchpage.button.add":`Adicionar uma linha`,
"label.partnerCloud.footer":`Rodapé`,
"lable.Enter.template.name":`Por favor, digite o nome do tamplate.`,
"label_tabpage_last":`Último passo`,
"label.setup.mobile.bottombutton.setting":`Configurações de página de primeiro nível do aplicativo móvel`,
"label_emailtocloudcc_filed_emailto":`Envie um e-mail para`,
"label.data.downpage.e_title.num3":`3. Os usuários podem criar modelos de exportação de acordo com suas necessidades e selecionar o item "Exportar por modelo", o que pode tornar a operação de exportação mais conveniente.`,
"startwith":`Começa com`,
"vue_label_normal_cancel":`Cancelar`,
"label.reportTypcrtD":`Objeto associado (d) favor clicar para selecionar o objeto relacionado`,
"label.globalselect.disabledvalue":`Valor inválido`,
"vue_label_commonobjects_view_notice_deletecertification":`Você tem certeza de que deseja apagar o(s) registro(s) selecionado(s)?`,
"front-epwechat-module-v1-bound-role":`Papéis encadernados`,
"label.partnerCloud.financeSetting.gaofilter":`Condições de filtragem antecipada (por exemplo, 1 e 2 ou 3 )`,
"label.quote.sprname":`Nome do faturamento`,
"lable.asset.successfully":`Transferir produto para ativo com sucesso.`,
"label.projectManagement.service.appointment.work.noedit":`Incapaz de editar a hora de trabalho de prestação de serviços`,
"lable.tianyancha.h5.inputandsearch":`Digite palavras-chave para pesquisar empresas relevantes`,
"label.customcomponent.check.tag.firstrow":`A primeira linha deve ser`,
"label.knowledgebase.published.translations":`As traduções publicadas também serão arquivadas e a tradução em estado de rascunho será excluída.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Etapa 3 de 3`,
"label.stdashbord.xsld.business.img6":`Quantidade total de estágios oportunos com probabilidade 100%/(Quantidade total de estágios oportunos com probabilidade 100% Quantidade total de estágios oportunos com probabilidade 0%)`,
"component_button_cancel":`Cancelar`,
"label.delete.false.not.exists":`A eliminação falhou, porque os dados não existem.`,
"label.appupload.install.error.choice1":`Por favor, não instale`,
"label.Days.After.Horizontal.Date":`data de nível após`,
"setup_layout_button_additem":`Adicionar os itens selecionados`,
"UG.contact.05":`Criar um contato`,
"label.form.title":`Título do formulário`,
"label.horizontalbar-group":`Agrupamento de Linhas Horizontais - Fileiras`,
"component_sendmail_label_title":`Enviar e-mail`,
"label.passwordPolicy.setup.neverexpires":`Nunca expira`,
"label.sso.saml.idp.config.desc1":`Habilite o CloudCC.com como um provedor de identidade para que você possa usar o single sign-on com outros sites da Web`,
"label.chat.topic.desc.null":`Aprenda algumas informações sobre este tópico? No menu suspenso do canto superior direito, selecione editar detalhes.`,
"label.movablecustomerfield":`Atividade Campos personalizados`,
"label.trigger.folder":`Pastas de gatilho não arquivadas`,
"label.selectuploadfile":`Por favor, selecione um arquivo para carregar.`,
"front-email-payment-card-tips":`Por favor, digite o número do cartão`,
"label.tabpage.addcondition":`Adicione a condição`,
"label.number.MinAndMaxCheck":`O mínimo de {0} é {1}, o máximo é {2}. Por favor, modifique a quantidade e salve as alterações.`,
"vue_label_dashboard_dashboard":`Redenominado com sucesso o painel de controle`,
"label.objectDeleteList":`Eliminar lista de objetos`,
"lable.service.gantt.and":`E`,
"label.emailtocloudcc.step2":`Etapa 2`,
"label.chatter.postup":`Post Up`,
"label.personalsetting":`Configurações pessoais`,
"message.please.choose.permission":`Favor selecionar o acesso`,
"label.mobile.move":`Aplicação móvel`,
"label.Choose":`Escolhas`,
"label_chatter_vote":`Enquete`,
"label.weixin.user.select.one":`Selecione um usuário`,
"pagecreator.page.label.modifypage":`Editor de páginas`,
"label.select.partOrField":`Escolha as seções ou campos a serem controlados`,
"vue_label_helpcenter_chat":`1. Mensagens Instantâneas<br> A equipe pode substituir o WeChat corporativo, etc., permitindo que você envie mensagens de texto, arquivos, etc. para seus colegas da empresa enquanto trabalha no sistema CRM. Quando cada departamento da organização precisa estabelecer um grupo de discussão departamental, o líder do departamento pode iniciar um bate-papo em grupo na Equipe e adicionar membros do departamento ao bate-papo em grupo.<br> 2. Criar bate-papos em grupo para clientes e registros de oportunidades de negócios<br> Abra a página de detalhes do registro de clientes ou oportunidades de negócios e clique no botão "Equipe" no canto superior direito para criar um bate-papo em grupo sobre este registro na Equipe. Se o bate-papo em grupo não for criado pelo proprietário do disco, o proprietário do disco também será automaticamente puxado para o bate-papo em grupo. Outros podem entrar no bate-papo em grupo clicando no botão "Equipe" no canto superior direito da página de detalhes do registro ou após ser adicionado pelo proprietário do grupo.<br> 3. Rastrear registros no bate-papo em grupo<br> Criar um bate-papo em grupo para clientes e registros de oportunidades de negócios de acordo com o método em 4.2, e você pode rastrear a dinâmica dos registros no bate-papo em grupo enviando cartões. Se o usuário tiver acesso para visualizar os registros no cartão, quando o usuário clicar no cartão, poderá saltar diretamente para a página de informações detalhadas do objeto correspondente.<br>?Mudanças no campo de registros no bate-papo em grupo<br> Quando o registro é configurado com a lista relacionada ao "Rastreamento de campo" e os campos que precisam ser rastreados são configurados, quando o campo rastreado muda, o assistente de estratégia em grupo no bate-papo em grupo enviará um cartão com as informações da mudança de campo para o grupo .<br>? Quando o dono do registro muda, o assistente de estratégia em grupo no bate-papo em grupo enviará um cartão com as informações sobre a mudança de dono para o grupo.<br>? Após a criação do bate-papo em grupo de gravação, quando o registro da lista relacionada ao registro for adicionado, o assistente de equipe no bate-papo em grupo enviará um cartão com as informações básicas do registro recém-adicionado ao grupo. Por exemplo: quando um novo contato é adicionado à lista de registros de clientes, um cartão de "Novo contato" será recebido no bate-papo do grupo de clientes, e as informações básicas do novo registro podem ser vistas no cartão.`,
"label.tianyancha.business":`Informações sobre o registro de empresas`,
"chatter.group.groupMembersToFind":`Pesquisa de membros do grupo`,
"label.pc.ui.2018.pin.top":`Pino para cima`,
"label.forecast.forehistory.submitor":`Apresentado por`,
"vue_label_email_send_emails_separately":`Enviar e-mails com sucesso`,
"vue_label_homepage_select_display_field":`Selecione o campo`,
"label.partnerCloud.partnerAccount.accountBalance":`Balanço`,
"label.sendemail.template":`Selecione o modelo de e-mail`,
"label.service.violated":`Violado`,
"label.manageAll.title":`Centro de Aprovação`,
"label.forecast.settings.qy":`Habilitar o Compartilhamento de Previsões`,
"label.detailofshare":`Detalhes da regra de compartilhamento`,
"label.multilang.passwordpolicy.chechlength":`Erro: A senha não deve ter menos de {0} caracteres:`,
"label.visualpage.filesave.error":`Arquivo salvo falhou, por favor tente novamente.`,
"vue_label_campaign_please_select_member_status":`Por favor, selecione o status de membro`,
"homepage.components.sort":`Encomende os componentes`,
"label.brief.thismonth":`Neste Mês`,
"label_emailsync_connectaccount_description":`Adicione sua caixa postal pessoal aqui, e o CloudCC combinará automaticamente os contatos e leads no sistema de acordo com seus endereços de e-mail, sincronizando o conteúdo do e-mail com os registros para facilitar o rastreamento e a comunicação.`,
"label.sms.csid":`Número de Assinatura`,
"label.ccdocument.remark":`Descrição do documento`,
"label.forecast.customforecast.disdw":`Unidade de exibição`,
"label_tabpage_field":`Campo`,
"label.logintime.all":`O dia todo`,
"UG_Account_06":`Criar uma conta`,
"label.login":`Login`,
"label.dupicate.data.error":`Encontrar registros duplicados e erros de fusão, favor verificar.`,
"label.monitorsys.recent.logs":`Os últimos 200 logs são exibidos por padrão.`,
"message.chooseatleastonefield":`Escolha um campo pelo menos`,
"lable.PowerProcess.name1":`Nome do processo de concessão de direitos`,
"label.processdetail":`Detalhes da definição do processo`,
"label.upload.file.size.limit":`Os arquivos carregados não devem exceder 2MB!`,
"label.forecast.userenablepage.desc":`Os usuários habilitados para Previsões aparecem na lista de Usuários habilitados. Para ativar os usuários disponíveis, adicione-os à lista de Usuários Ativados. Para desabilitar usuários, remova-os.`,
"label.visualpage.type.detailembed":`Instrução de uso da página personalizada (o estilo da página é "detalheEmbed")`,
"label.textmessage.vonage.configurations":`Configurações`,
"label.report.select.chart.and.item":`Selecione a tabela e o item de destaque`,
"label.data.downpage.i.title.num1":`O sistema 1、The suporta apenas o formato CSV comum.`,
"label.mobileapp.scansetting":`Configurações móveis de varredura de aplicativos`,
"chatter.emailFollow":`Segue`,
"label.weixin.businformation":`Detalhes do veículo`,
"label.import.index.recentrecord":`Recente registro de importação`,
"label.case.update":`Atualização`,
"label.isEnableVisualpage.new.desc":`Selecione uma página personalizada disponível nas páginas personalizadas disponíveis e adicione-a às Páginas Personalizadas Selecionadas, clique em Salvar. Então os usuários com este perfil têm acesso às páginas personalizadas ativas.`,
"label.emailobject.wizard.title":`Conecte seu e-mail`,
"vue_label_ccchat_notice_deletepostsuccess":`Post suprimido com sucesso`,
"label.deleteQuoteLine":`Eliminar linha de cotações`,
"label.integrations.export.failed.Mailchimp":`A exportação falhou, por favor verifique sua conexão de rede e tente novamente mais tarde`,
"label.increase":` Mais`,
"label.setup.mobile.homepageshortcuts.setunable":`O módulo não aparece na página inicial`,
"label.ccchat.person.invite.toolong":`Você não pode inserir texto que exceda 255 caracteres`,
"label.knowledge.setting.help":`Ajuda ao cliente em auto-atendimento`,
"label.is_pigeonhole":`Arquivo`,
"message.atleastonecommitter":`Pelo menos um apresentado por quem`,
"label.emailobject.wizard.desc4":`Inserir um tempo de proposta para facilitar a nomeação de várias pessoas`,
"APPIntegration_Dropbox_setting_02":`Deficiente`,
"template.report.open.opportunities":`Oportunidades não fechadas`,
"label.goonwork":`Continuar a trabalhar`,
"label.isiands.time":`Tempo Isiands`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Regras ativadas (cada objeto suporta apenas um Código QR ou Código de Barras)`,
"label.summaryreport.2018.step2":`Passo 2 Resumir as informações por:`,
"pagecreator.systemstyle.message.delete.success":`Estilo eliminado com sucesso`,
"label.standarduser":`Usuários padrão`,
"label.reportsSubscription.succeeded":`Assine o relatório com sucesso!`,
"lable.Select.a.template":`Selecione um modelo existente como base do novo modelo.`,
"label.file.library.addfile2libsuccess":`{0} arquivo(s) carregado(s)!`,
"label.searchfield.instruction":`Se nenhum campo selecionado por padrão, a pesquisa por campo de resultados de pesquisa selecionado é selecionado como campo de resultados de pesquisa.`,
"U":`URL`,
"label.Time.slot.overlap":`Um ou vários slots de tempo têm intervalos de tempo sobrepostos. Favor atualizar para um intervalo de tempo que não se sobreponha.`,
"vue_label_chat_opportunity_details":`Detalhes da oportunidade`,
"label.knowledge.category.hint.seven":`Grupo de Categorias Selecionadas`,
"label.chatter.list":`Lista`,
"front-email-payment-Invoice-preview":`Prévisualização da fatura`,
"label_emailsync_message1":`Se você cancelar a conexão, você não poderá sincronizar o conteúdo da caixa de correio com os contatos e contatos, você tem certeza de que quer cancelar?`,
"label.summaryreport.step5":`Passo5 Especifique a ordem das colunas no relatório`,
"component_newrecords_label_name":`Nome`,
"label.appointment.wizard.subtitle4-4-5":`2 meses`,
"component_salesperformance_label_title":`Desempenho de vendas`,
"label.ccchat.person.invite.says":`Digamos:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Modificar o artigo`,
"label.componenteditor.Limit.number.components":`Até 15 componentes podem ser adicionados em uma única página.`,
"label.multilang.forecast.shrepage.desc":`Esta página listará os usuários, funções e regiões que têm acesso compartilhado ao {0}.`,
"label.chat.micropost.write.comment":`Escrever comentários`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Ativo`,
"label.ccpeakfolder.time":`Pastas de classe programadas`,
"label.partnerCloud.financeSetting.filter":`Condições do filtro:`,
"label.knowledge.delete.topicassignment":`Erro ao eliminar a atribuição de assunto`,
"label.file.orderbyname":`Ordenar por título`,
"vue_label_chat_activelater":`Ativo mais tarde`,
"chatter.reply":`comentário`,
"label.setup.profile.accordtext":`De acordo com o texto`,
"label.encd.plaintext":`Mostrar texto claro`,
"label.h5.approval.cannotreassignmark":`Os projetos de aprovação delegados não podem ser reatribuídos, favor selecionar novamente os projetos de aprovação.`,
"label.version.area.lookup":`{0} campos de área de texto ou relação de busca (multi-seleção)`,
"approval.request.email.body":`Os itens a seguir estão solicitando approval：\n clique no link abaixo para approve：\n`,
"label.user.mass.emails.select":`E-mail em massa: Selecione o modelo`,
"lable.quote.syncing.title":`Citações e Oportunidades de Sincronização`,
"vue_label_dashboard_dashboardaccess":`Acesso ao painel de controle`,
"label_emailtocloudcc_filed_owner":`Proprietário`,
"label.brief.page":`Página`,
"label.isEnableVisualpage_new.desc":`Selecione uma página personalizada disponível nas páginas personalizadas disponíveis e adicione-a às Páginas Personalizadas Selecionadas, clique em Salvar. Então os usuários com este perfil têm acesso às páginas personalizadas ativas.`,
"label.service.shift.view":`Vista dos turnos de trabalho`,
"label.emailsync.addnewaccount":`Adicionar nova conta`,
"label.forecast.settings.prompt":`A desativação do compartilhamento de previsões removerá todo o acesso compartilhado manualmente.`,
"front-electronic-signature-explain-second":`Ao vincular a assinatura eletrônica, favor preparar a foto da Enterprise Business License e o código de crédito social unificado.`,
"label.emailtocloudcc.redmessage3":`Favor inserir o endereço do servidor`,
"message.confirmgiveupedit":`Se você sair desta página, perderá todas as mudanças não salvas. Você quer continuar?`,
"label.gantt.plan.success":`Programado com sucesso`,
"label.monitorsys.type.error":`Por favor, selecione o tipo de busca.`,
"label.industrialandcommercialverification.button.setup":`Criado`,
"today":`Hoje`,
"label.attendance.setting.position":`Marcos de referência`,
"chatter.mynews":`Minhas mensagens`,
"label.recycle.dis.tip1":`O sistema manterá os dados no cesto de reciclagem por 15 dias, e os registros serão permanentemente apagados 15 dias depois que os registros forem inseridos no cesto de reciclagem.`,
"label.icon.81":`Refrigeração`,
"label.customer.tab.page.prompt":`Por favor, configure pelo menos uma página!`,
"label.globalselect.use":`Use o conjunto de valores da lista global de opções`,
"template.report.customer.sales.order":`Ordem de venda de contas com diferentes níveis`,
"vue_label_dashboard_lastruntime":`Último tempo de funcionamento`,
"label.edit.ccpeakfolder":`Classes：Folder Editar`,
"vue_label_lead_be_converted":`Foi convertido e não pode ser convertido`,
"label.tabpage.filenamez":`Nome do arquivo`,
"label.please.click.add.products.":`Favor clicar em "Adicionar produto" para adicionar produto ao livro de preços.`,
"label.followup_emails":`Uma vez que um visitante tenha enviado um formulário, o acompanhamento com um email é a你easy maneira de se conectar rapidamente com eles`,
"label.indochina.time":`Tempo Indochina`,
"message.error.task.email":`Anomalia na tarefa de correio`,
"label.dynamic.copy":`Copiar de forma síncrona as regras de layout`,
"label.log.d":`Baixar log de auditoria dentro do intervalo de tempo de busca (arquivo Excel.csv)>>`,
"pagecreator_layout_label_layoutname":`Nome do layout`,
"template.chart.htsktj":`Estatísticas de Cobrança de Contratos`,
"label.appointment.wizard.subtitle4-2-5":`1 Dia`,
"label.view_form":`Ver Formulário`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Adicionar Membros - Contatos Existentes`,
"message.get.userinfo.error":`Falha em obter informações do usuário`,
"label.department.username":`Nome do usuário`,
"label.ems.verifysuccess":`Conta de e-mail verificada com sucesso!`,
"label.batchedit.copyValue":`Aplicar a esta coluna`,
"label.trigger.triggerVersion":`Versão`,
"label.mr.descreption.oneGroupReData5":`grupos de dados não processados.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Descrição`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`Você não pode personalizar esta lista`,
"label.data.exp.please.nameanddes":`Favor inserir o nome e a descrição do modelo.`,
"label_partner_workspace_login":`Página de login`,
"label.notification.approval7":`【被委派人名称】rejected o pedido de aprovação da 【提交人】 de 【对象】【对象名称】for você.`,
"message.send.posts.image.error":`O upload da foto falhou!`,
"message.fieldtrack.operateupdate":`Alterado`,
"label.sharerule.grantuselevelconstructureaccess":`Conceder acesso usando Hierarquias`,
"label.translation.setup":`Configuração Multilíngüe`,
"PageLayout.Search.MultiSearch.003":`Selecione pelo menos um campo.`,
"label.ccchat.person.emaildomain":`Domínio do e-mail da empresa`,
"pagecreator.systemstyle.label.bordercolor":`Cor da fronteira`,
"label.submit":`Enviar para`,
"UG.Lead.001":`Como introduzir as pistas?`,
"label.icon.172":`Mapa`,
"label_chatter_owner":`Proprietário`,
"vue_label_systemSettings_Currency":`Gerenciamento de moedas`,
"page.layout.binfo":`Informações Essenciais`,
"label.version.date":`{0} campos de data`,
"label.data.is.woking":`Operando`,
"label.customfields.searchrelation.dependobjectDefault.tip":`Você pode selecionar um registro no item relacionado como o valor padrão para este campo`,
"label.partnerCloud.orderingPlatform.configuration":`Produtos Confugure`,
"lable.currencyManage.Enabledadvcurrency":`Habilitar o Gerenciamento Avançado de Moeda`,
"label.event.moveup.3hour":`3 horas à frente`,
"label.reportexport.object":`Objetos de exportação`,
"front-dialog-module-v1-requestid":`Solicitar ID`,
"label.pw.symol":`Símbolos`,
"label_group_field":`Especificação do campo de agrupamento`,
"label.recallapprove":`Solicitação de aprovação de recall`,
"vue_label_pool_deal_done":`Negócio fechado`,
"label.shangqing.description":`Esta é uma descrição da situação comercial`,
"label.view.allcansee":`Visível para <b>todos os usuários</b>`,
"chatter.poll.addOption":`Adicionar mais`,
"label.icon.112":`Alimentos`,
"label.ignorecase":`Tratar "ABC" e "abc" como valores duplicados (insensível a maiúsculas e minúsculas)`,
"label.email.track.edit":`Editar email`,
"label_tabpage_erraddressz":`Formato incorreto do endereço de e-mail, favor digitar o endereço de e-mail corretamente`,
"label_tabpage_viewz":`Imprimir vista atual`,
"component.timeline.label.future":`Próximo passo`,
"label.b_c_without":`Os registros "B" podem ou não ter registros "C" relacionados.`,
"label.version.autonumberfield":`Campo do número do automóvel`,
"label.appointmentdetail.wizard.title5":`URL do convite`,
"label.weixin.addoption":`Adicionar opção`,
"label.b.c":`Relação B a C`,
"chatter.group.complete":`Completo`,
"label.must.numeric.value":`O custo deve ser numérico.`,
"lable.edit.queue.memberdes":`Para adicionar membros a esta fila, selecione um tipo de membro, depois escolha a função ou usuário entre os "Membros Disponíveis" e mova-os para os "Membros Selecionados". Se o modelo de compartilhamento para todos os objetos da fila for Leitura/escrita/transferência pública, você não precisa designar usuários para a fila, pois todos os usuários já têm acesso aos registros para esses objetos.`,
"label.staticresource.chose.limit":`Os arquivos neste formato não são suportados temporariamente. Por favor, aguarde ansiosamente para melhorar esta função.`,
"vue_label_commonobjects_view_kanban_unset":`Favor selecionar a base de agrupamento nas configurações de visualização Kanban`,
"label.appexchange.download.merge.mes":`Os seguintes componentes conflitantes são instalados através de uma fusão:`,
"label.sharerule.baseofowner":`Com base no proprietário do registro`,
"label.email.template.manage.SMS":`Gerenciar o modelo de SMS`,
"label.imgfield.example.tip":`O ícone verde significa aprovado e o ícone vermelho significa rejeitado.`,
"template.report.potential.customer.industry":`Indústria de Líderes`,
"component_hots_label_title":`Negócios quentes`,
"label_file_use_document":`Utilização do espaço de armazenamento`,
"label.input.path":`Digite o caminho do arquivo`,
"label.partnerCloud.financialSetup":`Configuração financeira do parceiro`,
"label_tabpage_myz":`Meu`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Depois de excluir, você não poderá usar o Email to CloudCC, você tem certeza de que quer excluir?`,
"label.customfields.fielddependency.sure":`O campo de controle não inclui o valor do campo dependente. Você quer continuar?`,
"label.project.task.date":`A data da tarefa deve estar dentro do intervalo de datas do marco ao qual ela pertence.`,
"Report.CantDelete.Info":`{0} relatório é a fonte de dados para o painel de controle {1} e não pode ser apagado!`,
"label.assignment.setup.title":`Regras de Atribuição`,
"image.pt.most.maxsize":`O tamanho máximo do arquivo é de 2 MB.`,
"label.appupload.introduce":`Um pacote contém componentes como aplicativos, objetos, abas, gatilhos ou páginas. Estes pacotes podem ser publicados na CloudCC App Store para compartilhar publicamente. A lista abaixo exibe todos os pacotes criados por sua organização. Para criar um novo pacote, clique em Novo.`,
"label.import.page2.confirm":`Confirme`,
"label.console.step2.introduce":`Preencha os campos abaixo para definir o console.`,
"label.extendsfather":`Controlado pelos pais`,
"front-homepageobject-module-v1-year":`Este Ano`,
"front-grasp-sales-opportunities":`CRM ajuda você a dominar com precisão as oportunidades de vendas, adquirir mais leads, fornecer cotações rápidas e fechar mais negócios, ao mesmo tempo em que alcança o marketing omnichannel e melhora continuamente o ROI corporativo.`,
"label.tab.oldpage":`Página da versão antiga`,
"label.service.miniProgram.intro":`Introdução`,
"label.data.import.setup.operate.insert":`Não atualize os registros existentes, apenas insira novos registros.`,
"label.ccpeak.direction.for.use":`Descrição do Uso da Plataforma CloudCC [Versão 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat resposta micropost`,
"label.campaignmember.main.importmember.contacts":`Membros de importação - Contatos`,
"setup.mainpage.label.welcome20":`Correio, modelo SMS`,
"label.newbatcheditor.remark":`Para diferentes registros, existem diferentes tipos de registros. Por padrão, o layout de linha se o tipo de registro do primeiro registro for usado como o layout de pafe para edição em massa.`,
"label.step4.total7":`Passo 4 de 7`,
"label.campagin.roi.tzhbl":`Retorno do investimento`,
"label.emailmerge.mergepage.step3":`Registrar uma atividade`,
"label.marketsea.isrecyclecreatebyself":`Você quer reciclar uma conta auto-construída?`,
"message.mobilechooseatmost.five":`Um máximo de 5 campos pode ser selecionado no menu em dispositivos móveis.`,
"label.icon.171":`Casa de hóspedes`,
"label.saveandnext":`Salvar & Próximo`,
"label.import.page1.selectcodingtype":`Escolha o tipo de codificação`,
"label.searchlayout.displaybutton":`Botões Exibidos`,
"label.approvalstep5":`Passo 5 selecione as propriedades de edição dos campos a serem exibidos no layout da página de aprovação`,
"label.passwordPolicy.setup.enforcePswHis":`Aplicar o histórico de senhas`,
"vue_label_commonobjects_detail_contact_hierarchy":`Hierarquia de contatos`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Central de Atendimento Inteligente`,
"label.select.statistical.indicators":`Por favor, escolha o índice estatístico`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Bibliotecas`,
"lable.completion.rate.color.setting":`Ajuste de cor da taxa de conclusão`,
"label.name.firstname":`Primeiro nome`,
"setup_layout_label_readonly":`Read-Only`,
"label.chatter.recordcall":`registrou uma chamada`,
"label.service.appointmentList.service.empty":`O horário de serviço está vazio.`,
"component_milestones_label_choicestate":`Confirme este status`,
"label.approved.receiveApprovalEmail.option2":`Somente se eu for um aprovador`,
"label.marketseamemset.account.title":`Configurações dos membros do grupo de liderança`,
"label.changemydisplay.list.custom":`Personalizar minhas abas`,
"label.emailtemplate.selecttype":`Escolha o tipo de modelo de e-mail que você gostaria de criar.`,
"component_timeline_label_title":`Linha do tempo`,
"chatter.group.addRemoveMembers":`Adicionar/remover membros`,
"label.console.step6.width":`Largura`,
"pagecreator.systemstyle.message.delete.fail":`A eliminação do estilo falhou`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}products，{totalCount} pieces, original price：{currency} {originalPrice}，discount：{currency} {Redução}`,
"label.h5.share":`Compartilhe`,
"label.schedulejob.setup.list.tip":`Configuração de trabalhos de difícil execução, a serem executados automaticamente em intervalos semanais ou mensais.`,
"message.intheapproving":`O registro está solicitando aprovação e não pode ser reapresentado.`,
"vue_label_commonobjects_detail_real_time":`Após a adesão, a equipe será exibida em sua lista de equipes, e a dinâmica da equipe será afixada em tempo real.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Muito curto`,
"label.salescloud.forbiddenteamsales":`Proibir a equipe de vendas`,
"component.chatter.link.label.title":`Link`,
"label.layout.editsearchdistribute.page":`Selecione as páginas personalizadas devem ser incluídas na página inicial da guia`,
"label.dashboard.show.value.percent":`Mostrar valores ou mostrar %, por favor escolha pelo menos um`,
"label.everymonth":`Por mês`,
"label.campaign.channel.download.size1":`Tamanho grande: 1000*1000 pixels`,
"permissionService.error2":`Falha em adicionar permissões de solicitação de licença.`,
"button.partner.workspace.manage.memo":`Gerencie sua nuvem de parceiros e configure as propriedades da nuvem de parceiros.`,
"label.forecast.forehistory.commit.remark":`Notas de submissão`,
"six":`Seis`,
"label.datamanage.donot.export.object":`Objetos que não estão autorizados a exportar dados.`,
"label.schedulejob.setup.schedule.execute":`Executar`,
"lable.account.CurrentandPreviousCY":`CY atual e CY anterior`,
"label.temp.SMS":`Modelos de SMS`,
"label_partner_all_state":`Status`,
"label.editdocument":`Editar Propriedades`,
"front-epwechat-module-v1-ios-single":`iOS Single Sign On`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Todos os modelos`,
"label.allfolderreport":`Todas as Pastas de Relatórios`,
"label.layout.alltab":`Todas as abas`,
"lable.account.Yesterday":`Ontem`,
"label.formula.to.evaluate":`Avaliação da Fórmula`,
"component_setup_label_setupsaveok":`Configurações de componentes salvas com sucesso`,
"pagecreator_page_message_canntdelete":`A página atual não é permitida para excluir`,
"label.tab.message.failtotp":`Falha no topo da aba`,
"label.h5.chatter.location":`Inserir o local`,
"vue_label_commonobjects_view_chart_gotodashboard":`Ir para Dashboard`,
"label.data.exp.conf":`Você tem certeza de que quer exportar dados?`,
"label.currency.e":`Tipo de moeda Editar`,
"message.matrixReportSetupStage.column":`Favor selecionar 【Specify Coluna Headers】 base subtotal, e você deve selecionar uma base subtotal pelo menos em duas bases subtotal.`,
"font-evaluate-module-v1-have-comment":`Deixou uma avaliação`,
"chatter.feed.dao":`Para`,
"label.import.index.notice":`Nota:`,
"label.weixin.information":`Detalhes`,
"label.multilingual.tip5":`O status multilíngüe não é correto. Por favor, atualize e tente novamente!`,
"label.appointment.wizard.subtitle3-7":`Domingo`,
"label.emailobject.groupemail.fail.content":`Prezado (0), o seguinte é o endereço de e-mail que não foi enviado.1`,
"vue_label_notice_uploadavatar_fail":`Falha no upload de avatar`,
"chatter.group.myGroup":`Meus grupos`,
"label.ccpeak.object.fieldapi.name":`é o nome do campo API do objeto`,
"lable.activeCurrency":`Moedas Ativas`,
"label.file.save.to.send":`Salvar&Enviar`,
"label.emailmerge.list.editfolder":`Edição da pasta`,
"label.Path.Setting":`Configuração do caminho`,
"label.validate.function.funcFormat.DATE":`DATA(ano,mês,dia)`,
"message.objapiexists":`Este objeto API já existe.`,
"label.sendmail.batch.confirm":`E-mail em massa: Confirme`,
"message.approval.cannotsubmit.detail":`Este registro não satisfaz as condições ou apresentação inicial para qualquer processo de aprovação válido. Favor entrar em contato com seu administrador para assistência.`,
"setup.layout.button.deleteitem":`Remover os itens selecionados`,
"label.end.loginipIP":`Endereço IP final`,
"component_event_label_subject":`Tema`,
"message.500":`Ocorreu erro interno do servidor`,
"label.wei.polltype":`Tipos`,
"vue_label_norm_duplicate":`Duplicata`,
"label.addcycletrigger":`Adicionar gatilho periódico`,
"DetailedInfo.Activity.EmailMessage.01":`{0} envie um e-mail para {1}.`,
"No.Activity":`Nenhuma atividade`,
"label.chat.topic.add.topic":`Clique para adicionar um tópico`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Suas mudanças foram salvas.`,
"label.setsharerule.step3":`Passo 3 Selecione os usuários com os quais deseja compartilhar`,
"label.tabpage.Sdfez":`Dias atrás`,
"label_submit_forecast":`Apresentar previsão`,
"label.version.sum.formulafield":`campos de fórmula`,
"lable.weixin.you.invitation":`Seu convidado`,
"label.stacked.horizontalbar":`Linhas Horizontais Empilhadas`,
"label.file.anyone.can.link":`Qualquer pessoa com o link pode visualizar e baixar o arquivo.`,
"label.campaignmember.main.importmember.lead.desc":`Importação de leads de arquivos.`,
"UG_activity_01":`Como você rastreia seus registros para interagir com suas contas/equipas?`,
"label.reason":`Motivo`,
"label.version.free.createmax":`Permite que 2000 registros sejam criados, o limite superior foi atingido.`,
"label.brief.thisweek":`Esta Semana`,
"label.deleteobjinapprove":`Por favor, digite o comentário antes que você possa apagar este objeto do processo de aprovação.`,
"calendar.tips.event":`dia(s) sem eventos`,
"label.customerinfo.mailinfo":`Endereço de e-mail para toda a organização`,
"lable.electronic.signature":`Esignature`,
"label_emailsync_addnewaccount":`Adicionar nova conta`,
"label.layout.exampleoftesgobj":`Exemplo de objeto de teste`,
"label.happen_submit":`O que deve acontecer depois que um visitante envia este formulário`,
"label.forecast.customforecast.button.submit":`Enviar para`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`Para ser reparado`,
"lable.opppdt.selPdt.morecondtions":`Mais filtros`,
"label_invalid_token":`Ficha inválida`,
"label_chatter_postup":`Post Up`,
"label.escalation.setup.newaction.step1":`Etapa 1 Especifique os critérios de tempo para esta regra`,
"label.sendmail.step3.dealoption2":`Armazenar uma atividade para cada mensagem`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Você tem certeza de que quer excluir modelos em lote?`,
"vue_label_appstore_enter_website":`Entrar no site oficial`,
"label.when":`Tempo de publicação`,
"label.linellae":`Linhas`,
"label_chatter_detailinfo":`Informações detalhadas`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Taxa de conclusão da tarefa de recibos`,
"vue_label_homepage_dashboard_deleted":`O painel de instrumentos foi removido`,
"pagecreator.layout.button.vertical":`Desmontagem longitudinal`,
"label.redistribution1":`Selecione até 5 itens`,
"pagecreator_page_label_modifypage":`Editor de páginas`,
"label.Service.Cloud.Setting":`Configuração da nuvem de serviços`,
"setup_layout_label_pagename":`Nome do layout da página`,
"label.ems.send":`Enviar`,
"vue_label_commonobjects_view_kanban_notice1":`A visualização Kanban exibe apenas os primeiros 200 registros`,
"lable.outlook.detail.maping":`Mapeamentos de campo`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Ajuste do controle deslizante lateral móvel`,
"label.trigger.operation.email.template.param":`Parâmetros de passagem: idioma, ID do modelo de e-mail e ID do registro`,
"front-objectTemplate-V1-Select-a-template":`Selecione um modelo existente como base do novo modelo.`,
"label.email.template.delete.template":`Você tem certeza de que vai apagar este modelo?`,
"label.reportsSubscription.cancel":`Cancelar`,
"lable.quote.syncingfrom.firstsync.description":`Os produtos de oportunidade substituirão os itens da linha de cotação`,
"label.weixin.no.pending.xsld.qin":`Desculpe, não há dados de funil de vendas para mostrar.`,
"template.dashboard.sales.indicators":`Indicadores de vendas`,
"label.field.new":`Proporcionar aos usuários operações de avaliação e pontuação.`,
"label.generatepage.title.desc1":`Gerar versão móvel ou PC do código HTML com base nos campos selecionados, os usuários podem modificar o código conforme necessário.`,
"template.report.source.potential.customers":`Fonte dos Leads`,
"label.mr.title.queryData":`Encontrar duplicatas`,
"button_partner_workspace_enable":`Habilitar a nuvem de parceiros`,
"V":`Número do carro`,
"label.icon.19":`Folder`,
"vue_label_report_summaryformula":`Fórmula resumida`,
"label.appointment.wizard.subtitle2":`Faixa de datas disponíveis`,
"label.stdashbord.xsld.business.bjdzhl":`Taxa de Conversão de Estágio`,
"label.forecast.forehistory.deopportunity":`Oportunidades`,
"chatter.email.referredToMeLeaveMessage":`Me menciona em um comentário`,
"label.dategrouprelyon":`Critérios de agrupamento de datas`,
"label.sendmail.batch.finish":`E-mail em massa: Concluído`,
"label.weixin.allexpired":`Tudo Atrasado`,
"label.dashboardSetup.showdw.d4":`10 Mil`,
"message.duplication.label.masterRecord":`Registro mestre`,
"vue_label_calendar_availability":`Disponibilidade`,
"vue_label_chat_approval_message":`Mensagem de aprovação`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Por favor, selecione as opções`,
"label.israel.daylight.time":`Hora Padrão de Israel`,
"front-sales-search-QB":`0 dados no total, se deve criar uma nova conta no QuickBooks`,
"vue_label_account_change_customer":`Mudança de proprietário do cliente`,
"label.integrations.mailchimp2":`Veja mais sobre CloudCC e Mailchimp`,
"lable.product.pricebooks.onisu":`Livros de preços inativos`,
"front-electronic-signature-backfill-field":`Campo de enchimento`,
"label.document.myself.folder":`Minhas Pastas Pessoais`,
"label.event.moveup.10hour":`10 horas à frente`,
"report.label.report":`Relatórios`,
"label.validate.function.funcFormat.CONTAINS":`CONTEÚDO(texto, comparar_texto)`,
"label.usermanage.query.false":`A consulta falhou, o usuário não existe.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Por favor, digite EncodingAESKey`,
"label.event.multi.view":`Visão de múltiplos usuários`,
"label.h5.similar.opportunity.setup":`Configurações de Oportunidades Semelhantes`,
"label.setting.intergrationlist.button.install":`Instalar`,
"label.event.monthview":`Vista do mês`,
"label.version.weixin":`Versão WeChat`,
"label_emailtocloudcc_redmessage6":`A autenticação IMAP/SMTP falhou, favor verificar se o endereço de e-mail e a senha estão corretos.`,
"UG.homepage.003":`Visão 360 graus`,
"vue_label_calendar_shared_calendar":`Calendário de Ações`,
"label.select.hope.merge.num1.record":`Favor selecionar os registros que você deseja fundir em um único registro. Escolha um máximo de 3 registros de cada vez.`,
"label.createnewprocess":`Criar Novo Processo de Aprovação`,
"font-trade-module-v1-invoice-status":`Status de pagamento`,
"label.customerinfo.introduce":`Informações sobre a empresa`,
"label.objectname":`Nome do objeto`,
"label.chosen.field":`Campos Selecionados`,
"label_target_name":`Nome do modelo do gol:`,
"label.appointment.wizard.subtitle4-4-4":`1 mês`,
"label.emailobject.groupemail.msg1":`Nenhum endereço de e-mail`,
"label_component_hotdeal_nopermission":`Para ver seus dados relacionados a oportunidades de negócios, entre em contato com seu administrador do CloudCC.`,
"label.appointmentdetail.wizard.title13":`Descrição`,
"front-web-module-v1-detail-comment-title":`Favor comentar sobre este serviço`,
"label.visualpage.component.n1":`1.método de chamada.  `,
"lable.outlook.mcto.erecord":`os registros mais antigos criados`,
"label.weixin.del.log":`Diário de eliminação`,
"setup_mainpage_label_welcome23":`Configurações de segurança`,
"label.selectreportline":`Favor selecionar as colunas do relatório`,
"label.chatter.following":`A seguir`,
"seven":`Sete`,
"message.error":`Erro:`,
"label.mobile.phone.reporter":`Apresentado por`,
"label.valadate.telphone.false":`Número de telefone digite o erro, por favor entre novamente`,
"label.linkedin.setting":`Integrar LinkedIn H5 MiniApp`,
"label.mobile.side.tab.success":`Salvar a configuração do controle deslizante do lado móvel com sucesso.`,
"label.notification.approval3":`Solicitação de aprovação para o 【对象】is reatribuído para 【重新审批人】`,
"label.channel.invites.employees":`Convidando o pessoal deste canal`,
"label.assignment.setup.detail.assigner":`Atribuir a`,
"label.campaignmember.main.updatecontactdesc":`Atualizar o status de todos os contatos de uma vez`,
"label.permission.detail.app.fenpei":`Atribuir aplicações`,
"label.copydown":`Copiar para baixo`,
"label_emailsync_status_action":`Ação`,
"lable.Please.switch":`Favor mudar para o menu horizontal ou vertical para usar esta função.`,
"label_adjust_remark":`Observações sobre o ajuste`,
"label.weixin.newspaper.coverage.list":`Fichas de risco`,
"label.datamanage.contact.field":`Campos de contato`,
"label.partner.workspace.login.headerfooter":`Cabeçalho e Rodapé`,
"lable.account.quarter.ovdate":`Fim do dia do trimestre fiscal`,
"pagecreator.systemstyle.label.textcolor":`Cor do texto`,
"label.industrialandcommercialverification.fieldmappingsettings":`Configurações de mapeamento de campo`,
"component_chatter_button_message":`Comentário`,
"label.partnerCloud.enterAddress":`Por favor, digite o endereço`,
"label.email.template.recently.used":`Utilizados recentemente`,
"component.event.label.calendar":`Ver Calendário`,
"label.setup.mobile.offlinecache.setting":`Configurações de cache off-line do lado móvel`,
"label.custom.PreviousCQ":`CQ anterior`,
"lable.total.of.payments":`0 pagamento no total`,
"label.ccpeak.use.class.time.trigger":`Se o gatilho chamar a classe, você pode usar os métodos no CCService diretamente.`,
"label_tabpage_addresswrongz":`O formato do endereço da caixa postal está errado, por favor, digite corretamente o endereço da caixa postal!`,
"vue_label_homepage_select_components":`Selecione os componente`,
"front-kefu-moudle-v1-secretID-reinput":`Por favor, digite secretID`,
"label.ccdocument.select.template.red":`Por favor, selecione um conjunto de modelos.`,
"vue_label_email_public_template":`Modelo público`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`Este IP não está na faixa de IP.`,
"chatter.email.reply.collection":`Comentários sobre um item que eu bookmarquei`,
"label.integrations":`Integrações`,
"label.permission.modifyAppPermission.selectedapp":`Aplicativos selecionados`,
"label.privacystatement":`Declaração de privacidade`,
"label.specificvalue":`Um valor específico`,
"label.appointmentconfirmpage.wizard.subtitle2":`Data e hora`,
"label.message.ispartner.delete":`Como o contato já está associado com o usuário parceiro, o cliente não pode ser excluído.`,
"report_button_go":`Ir para`,
"label.h5.similar.opportunity":`Oportunidades similares`,
"UG_Lead_005":`Caixa de correio`,
"label.num.length.not.overstep":`o comprimento do valor não pode exceder 18 bits`,
"label.profile.mobile.setup.CEOandDirector":`Diretor de vendas e diretor de vendas`,
"label.addfield":`Adicionar campo`,
"template.dashboard.institutional.overview":`Visão geral da agência`,
"label_tabpage_datefield":`Quando o campo de data é igual, pode usar o formato "ontem", "hoje", "amanhã", "mês passado", "este mês", "próximo mês", "semana passada", "esta semana", "próxima semana" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"label.category.7":`Turismo`,
"UG_contact_02":`Envolva os contatos através de múltiplos canais, chamada, e-mail, social`,
"chatter.feed.menutype.feed.mecom":`Novo posto para mim`,
"vue_label_systemSettings_calltemplate":`Modelo de carta`,
"approval_process_errore":`Ocorreu um erro durante o salvamento, favor contatar o administrador.`,
"label.tabpage.choosefilez":`Selecione o arquivo`,
"label.changemydisplay.chagetab.cusapp":`Aplicativos personalizados`,
"clearadvancedoption":`Lógica de filtro clara`,
"front-epwechat-module-v1-binding-user":`Usuários vinculados`,
"label.customfields.fielddependency.null":`Não há dependências definidas.`,
"label.enterprise":`Edição Empresarial`,
"font-evaluate-module-v1-five-points":`Marca Neutra: 5 pontos`,
"lable.Synchronize.from.QuickBook":`Sincronização a partir do QuickBook`,
"front-gantt-module-v1-task-number":`Montante da tarefa`,
"label.currency.edit.newexchagecurrency":`Taxas de câmbio datadas`,
"label.partnerCloud.partnerSite":`Site parceiro`,
"label_tabpage_unequalz":`Desigual a`,
"label.version.solutions":`Soluções`,
"label.setting.intergrationlist.button.installed":`Instalado`,
"label.h5.chatter.share":`Compartilhar arquivos`,
"front-epwechat-module-v1-unbound-item4":` vinculação de contas externas`,
"label.textmessage.vonage.accessibility.setting":`Configuração de Acessibilidade`,
"font-evaluate-module-v1-evaluation-set":`Configurações de avaliação`,
"message.servicecrew.time.violation2":`Fora do tempo de trabalho`,
"label.processinfo":`Informações sobre o processo de aprovação`,
"label.knowledgebase.last.modified":`Última modificação`,
"label.to.phone":`Para`,
"label.baseoffirsttimereply":`Aprovar ou Rejeitar com base em<forte> Primeiro </forte>resposta`,
"label.projectManagement.startingEndingTime":`Hora`,
"label.licence.enable":`Ativo`,
"label.partnerCloud.basicSetting.cshua":`Inicializar a nuvem de parceiros`,
"APPIntegration.Dropbox.setting.03":`Habilite o Dropbox para permitir que você selecione arquivos do Dropbox e adicione-os como anexos.`,
"label.account.contact":`Contate a IA`,
"label.many.dayline.tab":`Marcar`,
"label.weixin.input.username":`Por favor, digite seu nome`,
"label.logintime.pagecue.invalido":`O tempo final deve ser o dia todo.`,
"label.icon.30":`Livro`,
"label_tabpage_advancedscreening":`Filtro avançado`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Sim, eu quero desativar o Advanced Currency Management.`,
"label.tab.web.new":`Nova guia Web`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Deficiente`,
"error.currencyAdv.deleteprecodedate":`Não é possível excluir a taxa de câmbio da data de uma moeda.`,
"message.error.view.checkbox.validerr":`Erro: favor usar verdadeiro ou falso`,
"UG_ST_006":`Entre diretamente`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3、Exported Dados bem sucedidos irão gerar um arquivo comprimido que os usuários podem baixar da página de lista de sucesso da exportação de acordo com as informações contidas no correio.`,
"vue_label_pool_returnreason":`Motivo do retorno`,
"label.list.userinterface.des":`Modificar a interface do usuário com as seguintes configurações:`,
"label.notification.approval2":`Pedido de aprovação para the【对象】is rejeitado por 【审批人】`,
"label.service.dispatchingUnits.the.level":`Nível`,
"front-email-payment-Invoice-preview-tips":`Todos os modelos de fatura estão atualmente desativados. Favor contatar o administrador para habilitar o modelo antes de gerar faturas.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Erro: um ou mais dos campos selecionados no componente não está mais disponível no relatório. <br>utilizar o editor de componentes do painel de instrumentos para selecionar um dos campos disponíveis.`,
"label.import.step2.chooseidorother":`2、You pode escolher usar o ID ou nome para corresponder ao registro e preencher o campo de busca. Se você precisar adquirir o ID do registro correspondente e outras informações, você pode criar um relatório e definir o nome do registro e o ID do registro como colunas de grupo e, em seguida, exportar o relatório.`,
"label.customobjects.introduce":`Os objetos personalizados são tabelas de banco de dados que permitem armazenar dados específicos de sua organização no CloudCC. Você pode usar objetos personalizados para ampliar a funcionalidade do CloudCC ou para construir novas funcionalidades de aplicativos.`,
"label.visualpage.oldsystem":`Versão antiga`,
"label.icon.94":`Livro`,
"label.setup.log.desctiption":`Você pode baixar o traço de comportamento de sua organização (Excel.xls)`,
"label.dynamicpage.layout":`Regras de Layout`,
"lable.list.queue.objct":`Objetos Suportados`,
"label.customfields.placeholder.tip":`A amostra de texto será exibida na caixa de entrada e desaparecerá após ganhar foco`,
"label.ems.activationtime":`Tempo de ativação`,
"label.detailinfo":`Detalhes`,
"label.icon.17":`Relatório`,
"label_emailtocloudcc_button_complete":`Terminar`,
"label.visualpage.component.n2":`2. Observe que as "etiquetas de componentes" não podem ser aninhadas dentro de "<cc>tags".`,
"label.object.name.one":`Nome do objeto 1`,
"label.summaryreport.step2":`Passo 2 Escolha os dados resumidos`,
"thisisanew":`Novidades!`,
"label.query.detail.editpartneruser":`Editar usuário parceiro`,
"label.tabpage.newview":`Criar uma nova visão`,
"label.partnerCloud.productSet.addNew":`Nova opção`,
"label.appupload.upload.new.remark":`Este é um novo componente`,
"label.case.ptext":`Nós vinculamos sua empresa à versão do portal no site. Copie o endereço da versão web do portal de atendimento ao cliente dedicado à sua empresa e adicione o portal em seu site oficial.`,
"lable.PowerProcess.name":`Processo de habilitação`,
"label_tabpage_choosefilez":`Selecione o arquivo`,
"homepage.components.place":`Posição dos componentes:`,
"lable.Synchronization.failure":`Failed to Sync`,
"label.dashboard.snapshot.get.data":`Obtenha seus dados`,
"label.input.invalid.format":`Por favor, digite o formato válido`,
"label.quickbooks.view.openinvoices":`Faturas abertas`,
"label.weixin.seating":`Cadeiras`,
"label.searchlayout.remark":`Os layouts de busca permitem selecionar os campos padrão e personalizados que são exibidos nos seguintes recursos de busca:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Atribuir a`,
"vue_label_calendar_availability_view":`Calendário-Avisibilidade`,
"label.country":`País`,
"label.campagin.roi.zl":`Visão geral`,
"lable.currencyManage.advcurrencyEnabled":`O Gerenciamento Avançado de Moeda está habilitado`,
"label.projectManagement.project.task":`Tarefa do projeto`,
"label.appointmentpage.wizard.subtitle3-2":`Email`,
"label.input.invalid.date":`Por favor, digite as datas válidas`,
"vue_label_chatter_my_followers":`Meus seguidores`,
"label.setupdevelop":`Desenvolver`,
"label.sendemail.send.checksend":`Verifique se o e-mail foi enviado com sucesso`,
"label.eventfield":`Campos de eventos`,
"label.ccpeak.ccobject.put":`uso colocado para atribuir ao CCobject, por exemplo:`,
"label.campaignmember.main.addMemberDesc":`Você pode pesquisar os contatos e leads existentes, adicioná-los a esta campanha, ou gerenciar os membros da campanha existente.`,
"label.knowledge.setting.hint.eleven":`Inserir categoria de dados`,
"label.knowledge.category.button.four":`Adicionar categoria de irmãos`,
"label.icon.27":`Aprenda`,
"vue_label_chatter_certification":`Você tem certeza de que quer {isStatus} "{títuloNome}"?`,
"label.data.downpage.i.title.btn":`Vá para a página de importação e comece a importar`,
"label.campaign.channel.step6.pc":`Gerar Página de PC`,
"label.mr.caption.rule":`Regras: você deve selecionar uma ou mais regras para encontrar duplicatas`,
"label.service.gantt.resourcestype":`Tipo de recurso`,
"label.searchfitconditions":`Encontrar que correspondam aos seguintes critérios:`,
"label.partner.template.name":`Nome do modelo`,
"setup.mainpage.label.welcome15":`As regras de fluxo de trabalho da Plataforma CloudCC automatizam o processo de suporte para suas vendas, marketing, e muito mais. Dependendo de um conjunto predefinido de regras, os registros podem ser automaticamente atribuídos aos usuários ou convertidos de um usuário para outro. O principal benefício da gestão do fluxo de trabalho é melhorar a eficiência do trabalho, eliminando muitas operações desnecessárias ao atualizar registros, e melhorar os níveis de processamento do negócio e otimizar os processos de controle, padronizando os métodos de trabalho e reduzindo os custos operacionais. Ele suporta aprovação infinita ilimitada para qualquer objeto e pode acionar e-mail de lembrete, lembrete por SMS, tarefa, atualização de campo e outras funções.`,
"vue_label_commonobjects_view_chart":`Quadro`,
"label.salescloud.teamrole.choose":`Por favor, selecione o papel da equipe`,
"lable.outlook.mcto.emailrel":`Associações de e-mail`,
"front-invoice-online-payment-setup-describe":`Acesso rápido, acesso com um clique. Serviço de pagamento online simples, seguro e rápido.`,
"label.korean.standard.time":`Horário padrão da Coréia`,
"label.lord.howe.standard.time":`Horário de verão de Lord Howe`,
"setup_layout_group_button":`Botões`,
"label.editdefaultshare":`Padrões de compartilhamento em toda a organização Editar`,
"label_fiscal_year":`Exercício fiscal`,
"label.appointmentdetail.wizard.title2":`Proprietário`,
"label.email":`Email`,
"label.city":`Cidade`,
"label.knowledgebase.data.recovery.failed":`Recuperar {a} os dados falharam`,
"setup_mainpage_label_welcome6":`Os usuários podem criar vários tipos de campos em todos os objetos do sistema CloudCC sem nenhum conhecimento de programação ou desenvolvimento de código. Os tipos de campos incluem: relação de busca, campo de seleção única, seleção de itens duplos, fórmula, numeração automática. Os tipos de campo incluem: URL, telefone, fax, e-mail, caixa de seleção, data, hora, número, texto, área de texto, lista de opções (seleção simples/múltipla), moeda, etc.`,
"label_emailtocloudcc_button_enable":`Ativo`,
"label.account.custom":`Trimestre fiscal personalizado`,
"label.custompublish_time":`Tempo de publicação do cliente`,
"label.dashboardSetup.selwz":`Posição exibida`,
"component_todaytask_label_all":`Ver Tudo`,
"label.service.resource.group.tip":`Os recursos de serviço que dizem respeito aos tipos de tripulação devem utilizar o tipo de tripulação.`,
"label.tianyancha.legalpersonname":`Nome da pessoa jurídica`,
"component.setup.label.titlefield":`Campo de título`,
"label.email.template.public.mail":`Pasta de modelos de emails públicos`,
"front-template-V1-DeleteTempalte":`Você tem certeza de excluir "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Descrição do layout`,
"vue_label_file_singel_upload":`Apenas um arquivo pode ser carregado. Se você precisar substituir o arquivo, favor apagar primeiro o arquivo carregado.`,
"label.view.hierarchy":`Ver Hierarquias`,
"label.file.owner.settings":`Configurações do proprietário`,
"label.sales.dashboard.name":`Nome`,
"label.offfer.filer.name":`Citação Nome do arquivo`,
"label.quickbooks.view.recentlypaid":`Recentemente pago`,
"label.step1.select.merge.records":`Passo 1 selecione os registros a serem fundidos`,
"message.recordtype.assignprofile.tip":`Selecione a caixa de seleção Habilitar para Perfil para tornar o novo tipo de registro disponível para um perfil. Os usuários atribuídos a este perfil poderão criar registros deste tipo de registro, ou atribuir este tipo de registro aos registros existentes. Para tornar o novo tipo de registro o padrão para um perfil, selecione a caixa de seleção Tornar padrão.`,
"label.appointmentdetail.wizard.title9":`Tempo de viagem`,
"label.group":`Grupos`,
"label.deltorecycle":`Excluir para Reciclagem`,
"label.import.index.numlimit":`1. Somente arquivos em formato csv são suportados, e até 30.000 registros podem ser importados por uma única vez (<estilo de varredura="cor: vermelho">até 2.000 registros podem ser importados se for necessário executar o trigger</span>). Os registros que excederem o limite serão automaticamente ignorados pelo sistema. Se você quiser importar mais dados, por favor, divida-os em vários arquivos primeiro e importe-os em momentos diferentes. .`,
"label.file.delete.desc":`A eliminação de um arquivo também o removerá de qualquer registro ou postagem adicional.`,
"UG_activity_04":`Caixa postal Outlook/Gmail, registrar correio`,
"label.event.all.undealt":`Todos os eventos não processados`,
"label.appupload.upload.install.error":`Esta aplicação não pode ser instalada. por favor, termine a instalação ou modifique a api do sistema e reinstale-a!`,
"template.chart.yqydcpsl":`Número de produtos ativados`,
"label.import.index.advancepreparation":`Preparativos preliminares`,
"label.eowechat.epdeptnamee":`Nome do Departamento WeCom`,
"front-kefu-moudle-please-input-servernum":`Favor entrar na lista de solicitação de serviços No.`,
"label.lookup.autocmp.nodata":`Sem dados de correspondência`,
"vue_label_pool_assign":`Atribuir`,
"label.knowledge.timing.publish":`A publicação cronometrada é falhada`,
"label.selected.groups":`Grupos de linhas de cotações selecionadas`,
"front-epwechat-module-v1-removesele-desc":`Após a eliminação, toda a configuração desta aplicação será removida. Você tem certeza de que vai apagar?`,
"label.batchtransfer.type2":`Transferência Oposição Fechada`,
"label.richtext":`Área de texto (Rich)`,
"label.icon.174":`Aeronave`,
"vue.please.select.grouping.basis":`Favor selecionar Grupo por opções.`,
"label.matrixreport":`Relatório Matricial`,
"label.jiandangfenpei.leftlist":`Perfis não atribuídos`,
"label_chatter_card":`Cartão`,
"label.file.enter.title":`Por favor, digite o título`,
"label.the.record.is.locked.and.cannot.be.selected.":`Este registro é bloqueado, não selecionável.`,
"label.partner.success":`O domínio Sucesso! está disponível`,
"label.selectreporttype":`Selecione a fonte de dados do relatório`,
"report.type.label.productPricebooks":`Produtos e livros de preços`,
"label.texttemplate.mergefields.tip":`Adicionar campos incorpóreos durante a edição de conteúdo SMS. Quando o SMS é enviado, os campos incorporados podem ser substituídos pelo texto correspondente. Por exemplo, {!Contact.name} pode ser substituído pelo nome do contato ao enviar o SMS.`,
"label.publicgroup.detail.showallusers":`Ver todos os usuários`,
"label.brief.follow":`Acompanhamento`,
"label.forecast.settings.qijian.p":`Previsão Trimestral`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Personalizar página`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(texto, comparar_texto)`,
"label.umeng.chatter.sendmessage":`enviou-lhe uma mensagem`,
"label.pc.layout":`Layout do PC`,
"label.currency.v":`Digite as casas decimais ( número de dígitos à direita do ponto decimal ) permitidas ao exibir os dados nesta nova moeda. Deve ser um número inteiro com valor entre 0 e 6.`,
"label.projectManagement.kanbantask":`Tarefa Kanban`,
"component_recdetail_label_title":`Informações detalhadas`,
"label.isremider":`Lembrete`,
"front-epwechat-module-v1-input-home-url":`Por favor, digite a URL da página inicial`,
"label.usefullife":`Prazo de validade`,
"label.visualpage.ptype":`Comum`,
"label.quote.name":`Nome da citação`,
"vue_label_report_addtocomponent":`Você tem certeza de que quer adicionar { nome } à biblioteca de componentes?`,
"label.dashboardSetup.showdw.d1":`100 Milhões`,
"label.validate.function.funcFormat.OR":`OU(lógico1,lógico2,...)`,
"label.component.helper.potentialcustom":`Leads designados a você hoje`,
"label.autoRegister.changepwd.setpwd.tip.number":`Pelo menos um número`,
"label.data.setok.e.desc3":`， faça o download de seus dados exportados.`,
"label.data.downpage.e.title.num4":`4、 Os arquivos de exportação têm dois formatos: formato CSV e o formato de compressão. O formato de compressão é dividido em dois tipos: um é para gerar automaticamente a senha do arquivo comprimido, o outro é para inserir manualmente a senha do arquivo comprimido.`,
"lable.quote.editqtpdt.description":`Selecione um livro de preços para esta cotação. Você só pode adicionar um produto de um único livro de preços, e mudar o livro de preços selecionado removerá todos os produtos existentes da cotação.`,
"front-kefu-moudle-edit-userinfo":`Editar informações do usuário`,
"label.please.ChooseMinAndMax":`Favor escolher pelo menos {0} opções de produtos, e até {1} podem ser selecionados.`,
"label.knowledgebase.archive.an.article":`Arquivar um artigo?`,
"label.multilang.customforcast.submit":`Você apresenta uma previsão de {0}ano fiscal{1} a {2}ano fiscal{3}?`,
"label.import.index.filename":`Nome do arquivo`,
"front-console-no-reco-contact":`O contato não pode ser identificado`,
"label.quantity.greater.than0":`A quantidade deve ser maior que 0.`,
"label.codeNorm":`Código Padrão`,
"label.average":`Média`,
"label.multilang.page1":`Página`,
"label.data.exp.save.ok":`Salvar modelo com sucesso`,
"message.error.delete.record":`O registro a ser apagado não foi encontrado!`,
"label.newvaluereplaceoldvalue":`Substituir globalmente um valor existente em uma lista de picking por um novo valor. Certifique-se de ter criado primeiro o novo valor no campo da lista de picking.`,
"label.tabpage.saveviewsuccess":`Vista salva com sucesso`,
"label.partnerCloud.productSet.parentOptions":`Opção dos pais`,
"label.emailtemplate.availablemergefields":`Campos de fusão disponíveis`,
"label.data.import.setup":`Configurações de importação de dados`,
"label.escalation.setup.entrydetail.escalation.action":`Ações de escalada`,
"System.TimeField.Description":`Permite que os usuários entrem em uma hora local. Por exemplo, "14:40", "14:40" e "14:40:00" são todos horários válidos para este campo.`,
"front-additional-products":`Comprar outros produtos`,
"label.appointment.wizard.subtitle4-4-1":`1 semana`,
"label.chatter.colleagues.list":`Lista de colegas`,
"label.log.invalid.data":`Data inválida`,
"label.file.preview.unconvert":`Nenhuma informação de pré-visualização é gerada, por favor clique nos detalhes da pré-visualização`,
"label.customer.detailed":`Escolha a página para esta nova guia. Digite outros detalhes.`,
"label.sendsms.content":`O conteúdo é o seguinte:`,
"label.exported_to":`O arquivo exportado será enviado por email para`,
"label.attendance.checkin":`Check In`,
"Dashboard.NoAccessRightToSee.Warning":`Você não tem permissão para visualizar os dashboads {0} que estão definidos como defualt aberto, favor reiniciar.`,
"message.choosedelete":`Favor selecionar os dados que você deseja excluir`,
"label_tabpage_choosecontent":`Selecione o conteúdo do valor`,
"label.no_responses":`Sem respostas`,
"report_type_label_customService":`Suporte ao cliente`,
"label.report.select.condition":`Condições`,
"label.umeng.activity.distributeevent":`lhe designou um evento.`,
"label.knowledge.language.portuguese":`Português`,
"label.knowledgebase.published":`Publicado em`,
"UG_opportunity_001":`Como você monitora suas vendas?`,
"label.mr.caption.scope":`Escopo: consultar todos os dados se não forem selecionados`,
"message.login.mfaverification.to.pclogin":`Sua organização habilitou a verificação do login secundário, o primeiro login requer a ligação ao dispositivo móvel, por favor, use o lado do PC para ligação ao login`,
"vue_label_dashboard_pleaseenterthecolorrange":`Favor entrar na faixa de cores`,
"label.emailsync.status.time":`Hora`,
"chatter.putup":`Compartilhe um arquivo`,
"vue_label_report_drillcondition":`Condição da perfuração`,
"label.emailobject.list.myemail":`Meu e-mail`,
"label_tabpage_andz":`E`,
"label.share_link":`Link para Ações`,
"label.emailtocloudcc.exists2":`Esta caixa de correio foi configurada para Enviar por e-mail para Case. Não repetir as configurações.`,
"label.icon.89":`Assessoria`,
"front-kefu-moudle-v1-qdygbzx-chat":`Você tem certeza de que vai desligar o batepapo online?`,
"label.approval.selectone":`Por favor, selecione pelo menos uma ação.`,
"chatter.group.groupName":`Nome do grupo`,
"label_chatter_relateitem":`Relacionado a`,
"label.file.folder.delete1":`Excluir pasta?`,
"Pagelayout_Setup_003":`O campo Nome deve ser selecionado`,
"setup_mainpage_label_welcome2":`Base de dados personalizada (objeto)`,
"pagecreator.systemstyle.label.linkcolor":`Cor do link`,
"label.task.this.week":`Esta Semana`,
"message.custom.field.donotdelete.report":`O campo é referenciado pelo relatório`,
"pagecreator.layout.button.delete":`Excluir layout`,
"label.reportsSubscriptionPage.condition.operator":`Operador`,
"label.location.display.type.degrees":`Graus, minutos, segundos`,
"label.appupload.upload.url":`URL de instalação`,
"label.logical.relation":`Relação lógica`,
"label.knowledge.publish.article":`Publicar artigo`,
"vue_label_commonobjects_detail_activity_commingtask":`Próxima tarefa disponível`,
"vue_label_pool_reason":`{0} razão`,
"front-gantt-module-subtasks-cannot-subtasks":`As subtarefas não podem aparecer sob subtarefas!`,
"label_tabpage_filesizez":`Tamanho do arquivo`,
"label.customfields.formula.returntype.monry.tip":`Calcule um valor em dólar ou outra moeda e formate automaticamente o campo como um valor em moeda.`,
"label.tabpage.allapplications":`Todas as aplicações`,
"message.duplication.label.matchcontainletters":`Conter`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Favor escolher "Um item de ordem de trabalho para cada ativo" como o tipo de ordem de trabalho de geração.`,
"label.preview_post":`Posto de Preview`,
"chatter.p.data":`Data de postagem`,
"label.isnot.right.number":`Número inválido`,
"label.contentsource":`Fonte de conteúdo`,
"message.groupandsummaryconditionsame":`As condições usadas para agrupar não podem ser as mesmas que as condições sumárias`,
"label.weixin.wdyj.nodata.qin":`Desculpe, {0} não tem dados.`,
"chatter.vote":`Votação(ões)`,
"label_partner_workspace_tab_option":`Abas disponíveis`,
"chatter.changeVote":`Mudança de voto`,
"label.data.file.i_title.num2":`2. Recomenda-se que os dados sejam exportados quando os dados forem importados, para que o documento de exportação seja usado como modelo para recolher os dados a serem importados, e depois importar. (Se os dados importados contiverem uma vírgula, substitua-a pelo símbolo @).`,
"label.relation.list.error":`Erro`,
"label.validate.function.funcExplain.MILLISECOND":`Retorno milissegundo do dia (Dos campos de data/hora)`,
"label.emailobject.emaildetail.button.relateto":`Relacionado a`,
"label.dashboard.dataSource":`Mostrar fonte de dados`,
"label.marketseamemset.lead.title":`Configurações dos membros do grupo de liderança`,
"label.appupload.addobj":`Adicionar ao pacote`,
"lable.outlook.mcto.domain":`Adicionar meu domínio (gmail.com) à lista de domínios excluídos.`,
"label.input.right.url":`Favor digitar a URL válida`,
"label.newprocessstep5.tip":`A página de aprovação é onde um aprovador irá realmente aprovar ou rejeitar um pedido. Usando as opções abaixo, escolha os campos a serem exibidos nesta página.`,
"label.schedulejob.setup.schedule.st4":`A 4a.`,
"label.emailsync.status.user":`Usuários`,
"front-kefu-moudle-v1-jymm-reinput":`Digite uma senha de 12 dígitos, combinando dois ou mais caracteres maiúsculos, minúsculos, numéricos e maiúsculos`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Nome da Regra de Pontuação`,
"label.mr.title.fieldName":`Nome do campo`,
"label.data.deriall":`Exportar tudo`,
"label.tianyancha.businessverify.step2":`Habilitar a etapa 2 de verificação de dados comerciais`,
"label.submissions":`Envios`,
"vue_label_calendar_removed_successfully":`Calendário removido com sucesso`,
"label.eventrecordtype":`Tipos de registros de eventos`,
"lable.outlook.detail.syndire":`Direção de Sincronização`,
"label.mobile.bind.fail":`Falha na ligação, por favor tente novamente mais tarde`,
"label.notification.task2":`【被分配人】 visualizou a tarefa que você designou`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Pagar por:`,
"label.escalation.setup.newaction.step3":`Passo 3 Selecione o usuário a ser notificado`,
"label.summaryreport.selectsum":`Escolha os dados resumidos e o tipo resumido`,
"label.components.setup":`Configurações de componentes`,
"label.taskevent.introduce":`Sua lista de atividades`,
"label.assignment.setup.detail.conditon":`Critérios`,
"front-lightning-module-v1-details-page-chart-select-statements":`Selecione o relatório`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`a fórmula avalia a verdadeira`,
"label_partner_common_setup":`Configuração geral`,
"label_chatter_dateRange":`Faixa de datas`,
"label.partner.workspace.tab.mobile.using":`Exibição no aplicativo móvel`,
"message.servicecrew.time.violation1":`Violação do tempo de atribuição: há um membro da equipe.`,
"report_label_projectcount":`itens, ordenar pelo nome do relatório`,
"label.file.uploadfile":`Upload de arquivos`,
"vue_label_commonobjects_detail_correct_email_address":`Favor inserir o endereço de e-mail correto`,
"lable.account.CurrentandNextCQr":`Atual e Próximo 3 CQ`,
"setup.layout.label.order":`Ordenar por`,
"label.service.major.event.independent":`Independente`,
"label.icon.38":`Posicionamento`,
"label.knowledge.draft.record":`O registro que você está tentando apagar não é encontrado.`,
"label_quota_percentage":`Mostrar porcentagem de conclusão da cota`,
"label.escalation.setup.entrydetail.escalation.minute":`Ata`,
"label.knowledgebase.edit.article.category":`Editar categoria do artigo`,
"Homepage_News_003":`Não é possível exibir notícias sem dados de contas, por favor, crie uma nova conta e as notícias relacionadas serão exibidas.`,
"label.mr.descreption.oneGroupNote3":`registros.`,
"label.customsetting.touse.getListCustomSetting":`Consultar os dados do tipo "list" de configurações personalizadas, retornar todos os dados correspondentes ao API Name. Mapa do mapa = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Erro: você deve inserir um valor`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Sexta-feira`,
"message.error.view.badprevilege.qin":`Desculpe, você não tem acesso a {1}, portanto nenhum dado mostrado</br>`,
"label.dashboard.distribution":`Distribuição`,
"label.field.value.save":`É sempre necessário um valor neste campo para salvar o recorde.`,
"label_custom_year":`Ano aduaneiro`,
"label.code.error":`O código contém comandos ou funções que não são permitidos como os seguintes:`,
"label.appexchange.uninstallpage.message2":`Remova permanentemente todos os seus ajustes personalizados para estes componentes`,
"label.global.search.obj":`Objeto de busca global`,
"label.emailobject.from":`De`,
"lable.opppdt.selPdt.byconditions":`Por campo`,
"chatter.p.note":`Notas sobre este posto`,
"label.hiddenformulaedit":`Editor de Fórmula Oculta`,
"label.editQuotation":`Editar Cotação`,
"label.notification.arketsea.collection":`{5} recolhido{2}{0}{0}:{1}:{1}`,
"label.timzone.tip.info1":`Quando se trata de salvar dados do tipo java.util.Date （insert e update）in um banco de dados, por exemplo, Quando se trata de salvar (inserir e atualizar) um banco de dados do tipo java.util.Date, por exemplo, TpSysTask task=new TpSysTask () ；task.setBeginTime (novo Date () ）；......dbman.insert (task) ou dbman.update (task); você deve alterar a nova data () para chamar TimeUtil.getNowDate (userInfo), portanto a declaração relevante no exemplo acima deve ser alterada para task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Converta`,
"front-kefu-moudle-IP-phone":`Telefone IP`,
"label.emailobject.list.draft":`Esboços`,
"label.tianyancha.businessverify.readandconfirm":`Eu li o acordo e concordo com ele`,
"label.win.customers":`Contas Fechadas-Vertidas`,
"vue_label_commonobjects_view_switch_display":`Seus registros são agrupados por tipo de registro, você pode clicar no nome do tipo de registro correspondente para mudar de exibição.`,
"pagecreator_systemstyle_label_textcolor":`Cor do texto`,
"label.autosearch.keywords":`Busca automática de palavras-chave completa`,
"label.knowledge.setting.data.six":`Você vai excluir a categoria {lbmc}, você tem certeza de continuar?`,
"front-console-sort-field":`Caso No.`,
"label.bangladesh.time":`Hora de Bangladesh`,
"label.dashboardSetup.number":`Valores numéricos`,
"lable.account.LastbDays":`Últimos 30 dias`,
"label.layout.searchdialog":`Diálogo de Pesquisa`,
"label.newprocessstep4.tip":`Selecione o modelo de e-mail que será usado para notificar os aprovadores de que um pedido de aprovação foi atribuído a eles. Observe que este modelo será usado para todas as etapas deste processo.`,
"label.nousing":`Inativo`,
"vue_label_report_detailline":`Linha de detalhes`,
"label.emailobject.template.message3":`O máximo de modelos de correio é alcançado!`,
"label.c.d":`Relação C a D`,
"message.report.error.fail":`Carga falhou, por favor tente novamente`,
"label.edit.ccdocument.content":`modificou a realização.`,
"label.textmessage.exceeded":`O número de seus modelos de texto ultrapassou o limite!`,
"label.saveas":`Salvar como`,
"label.visualpage.an.inline.style":`Incorporar tipo de página personalizada à página de detalhes e página inicial da guia`,
"label.pagelayout.remark2":`dados. Depois de criar layouts de página, clique no botão Atribuição de Layout de Página para controlar qual layout de página os usuários vêem por padrão.`,
"label.notification.approval1":`Pedido de aprovação para the【对象】is aprovado by【审批人】`,
"label.h5.chatter.image":`O upload do formato da imagem não é correto`,
"vue_label_dashboard_displayunit":`Por favor, selecione uma unidade de exibição`,
"label.knowledge.default.language":`Idioma padrão de conhecimento`,
"label.chatter.publish":`Publicar`,
"label.companyprofile.serveraddress":`Esta sincronização só sincroniza o servidor atual.`,
"label.chatter.groups":`Grupo`,
"label_set_successfully":`Definido com sucesso!`,
"label.quote.zongjia":`Preço total`,
"label.project.notice.endingdatelater":`A data final deve ser posterior ou igual à data de início.`,
"label.customfields.fielddependency.info":`Esta página permite definir as dependências entre os campos (por exemplo, listas de seleção dependentes).`,
"vue_label_lead_successful_conversion":`Conversão bem sucedida`,
"label.icon.93":`Livro`,
"shift.serviceresource.illegal":`O recurso de serviço não pertence ao território de serviço ou a data da mudança não está dentro do alcance da adesão.`,
"label.integrations.action.addnewlead":`Adicionar novas pistas`,
"label_display_all_zeros":`Mostrar todas as filas com valores zero`,
"canlendaryear":`Ano civil`,
"label_tabpage_selrecordtypez":`Selecione o tipo de registro`,
"vue_label_commonobjects_view_chart_funnel":`Tabela de funil`,
"label.layout3":`Layout 3`,
"label.logintime.cue":`Nenhum tempo de login especificado.`,
"label.service.miniProgram.lastDate":`Data da última modificação`,
"label.emailobject.view.fromcrm":`Emails de Contatos/Líderes`,
"pagecreator.button.mobilepage":`Lado móvel`,
"lable.oppt.jieduan.signcur":`Marcado como o estágio atual`,
"label.fullaccess":`Acesso total`,
"homepage.layout.pagename":`Nome do layout da página`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Por favor, selecione pelo menos um registro.`,
"label.view.sortview.closepage":`Fechar Janela`,
"label_forecast_type":`Tipo de previsão`,
"all.day":`O dia todo`,
"label.view.sortview.printpage":`Imprimir esta página`,
"message.integration.configure":`A configuração integrada está vazia!`,
"label.forecast.customforecast.foretype.close":`Fechado-Ganho`,
"label_chatter_like":`Como`,
"template.report.folder.customer.potential":`Análise de Leads`,
"label.umeng.approval.dlsp.approve":`#Aprovação de nome aprovado o pedido de aprovação do #actorname de #objAPIName #recordname para você.`,
"vue_label_normal_movedown":`Desça`,
"chatter.group.groupAccessPermissions":`Acesso de Grupo`,
"label.visualpage.tip":`Você pode criar sua própria página aqui`,
"message.validation.isnotdate":`Data inválida`,
"label.icon.173":`Veleiro`,
"label.icon.124":`Injeção`,
"label.import.page2.csvfiled":`Campo CSV`,
"setup_layout_component_area":`Área`,
"label.visualpage.workability.standard":`Classes padrão disponíveis na página`,
"label_emailtocloudcc_redmessage9":`Erro no banco de dados, favor entrar em contato com o administrador.`,
"label_tabpage_contactsz":`Contatos`,
"label.multilang.workflow.everydayinmonth":`{1} dias a cada {0} mês`,
"APPIntegration.Social.linkedinerror":`Você deve digitar uma URL válida para linkedin.com`,
"button_partner_workspace_manage_memo":`Gerencie sua nuvem de parceiros e configure as propriedades da nuvem de parceiros.`,
"template.chart.bnsrmb":`Meta de receita para o ano`,
"chatter.follow.now":`A seguir`,
"label.entitlement.process.condition.repeat":`Estabelecer repetição de marco miliário`,
"label.relationobject.isdl":`Delegado`,
"label.lasttimemodifieralias":`Último Modificador Alias`,
"vue_label_commonobjects_detail_task_name":`Editar nome da tarefa`,
"vue_label_homepage_quarterlyperformance":`Desempenho trimestral`,
"pagecreator.layout.message.delete":`Você apaga o layout selecionado atualmente?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Habilitar assinatura`,
"label.partnerCloud.financeSetting.create":`Criar fundos para usuários qualificados automaticamente quando novos parters são ativados.`,
"label.data.file.i.title.num1":`1. O arquivo importado deve ser um arquivo em formato CSV. O arquivo deve conter um título e não pode ser importado sem título.`,
"label_efine_assessment":`Ciclo de avaliação`,
"message.duplication.label.sectionTitle":`Selecione o valor a reter`,
"front-electronic-export-buttonExport":`Continuar a exportar`,
"message.submitpage.email":`Parabéns, e-mail enviado com sucesso.`,
"after":`Depois de`,
"label.version.nonsupport":`Sem suporte`,
"label.icon.105":`Horário`,
"label.quickcreate.titledesc":`Habilitar Quick Create permite aos usuários criar registros a partir do diálogo de busca.`,
"label.quote.number":`Digite a quantidade`,
"label.view.sortview.setdefault.prompt":`Fixe esta lista de visualização`,
"label.refertime":`Data de apresentação`,
"frame.personinfo.label.minipic":`Imagem em miniatura`,
"label.mobile.home.page.newopp":`Líderes recentemente criados`,
"label.address":`Endereço`,
"front-pay":`Pague`,
"label.chat.serviceAppointment":`Aviso de serviço`,
"label.umeng.activity.eventviewed":`O evento que você designou para #name é visto`,
"label.validate.function.funcExplain.DATE":`Criar data até o ano, mês e dia`,
"label.commiterselectapprover":`Deixe o apresentante escolher o aprovador manualmente.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Localização`,
"vue_label_display_text_field":`Mostrar campos de texto`,
"label.salescloud.teamrole":`Papel da equipe`,
"maintenanceplan.workorder.generate.limit":`A ordem de trabalho deve estar dentro do intervalo do cronograma de manutenção.`,
"label.campaignmember.selectmember.description":`selcet uma visão, depois adicionar os membros à Campanha, e o Status da Campanha Menmeber é`,
"label.ismodify":`Permitir a edição`,
"label.height":`Alto`,
"label.tabpage.thevalurofz":`O valor de`,
"label.create_successful":`Criar formulário com sucesso`,
"front-invoice-online-payment-setup-configure-dialog":`Configurar a interface de pagamento`,
"label.customerinfo.smsEid":`SMS Gateway EID`,
"label.visualpage.list.no":`Sem permissões de acesso às páginas personalizadas`,
"look.trigger.in":`Ver instruções`,
"label.setting.disable":`Desativar`,
"chatter.group.name":`Grupos`,
"label.solutionadministrator":`Gerente de soluções`,
"label.vlidaterule.top":`Topo da página`,
"pagecreator.layout.message.save.fail":`Falha no layout`,
"label.partnerCloud.orderingPlatform.noZero":`A quantidade não pode ser 0.`,
"label.customfields.suretodeleteprompt":`Confirmar os avisos de exclusão de campos personalizados`,
"button_partner_viewdetail":`Ver`,
"label.icon.122":`Casa`,
"label.customer.tab.step2.introduce":`Escolha os perfis de usuário para os quais a nova guia personalizada estará disponível. Você também pode examinar ou alterar a visibilidade das abas a partir dos detalhes e editar as páginas de cada perfil.`,
"label.task.delegated":`Delegado`,
"vue_label_salesadvance_averageamount":`Por transação do cliente`,
"vue_label_chat_invitedtojoin":`Convidamos você a participar do bate-papo em grupo`,
"label.data.downpage.e_title.num1":`1. Selecione os objetos que você deseja exportar, ou escolha exportar todos.`,
"label_display_options":`Opções de exibição`,
"vue_label_chatter_more_comments":`Mais comentários`,
"label.ggReleaseRange.publish":`Publicar Lista`,
"label.valuetype.notmate":`Erro de condição da linha, o tipo de valor não corresponde.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Última atividade sincronizada:`,
"label.dataimport.duplication.filter":`Encontrar filtros duplicados de prompts`,
"label.appdownload.uninstall":`Desinstalar`,
"message.error.task.add":`Nova anomalia de tarefa`,
"UG.Account.07":`Conta de importação`,
"label_tabpage_lastone":`Selecione pelo menos uma operação`,
"front-console-holdTime":`Tempo de atraso`,
"label.emailobject.schedule":`Veja minha agenda e marque uma hora aqui.`,
"label.lookup.locked.data":`Este registro é bloqueado, não eletivo`,
"label.assignment.setup.newentries.ifcondtions":`Execute esta regra se o`,
"label.magadan.time":`Hora de Pietro Pavlov`,
"message.error.serviceterritorymember":`Favor definir o recurso de serviço selecionado como membro do território de serviço dentro do intervalo de tempo do plano de nomeação de serviço.`,
"label_chatter_delete":`Excluir`,
"label.partner.workspace.member.permission":`Conjunto de permissões disponíveis`,
"label.notification.task5":`Sua tarefa está atrasada`,
"mary":`Maio`,
"label.homepagemodule":`Página inicial Componentes`,
"label.compact.layout.frame.error1":`A tela direita não pode ter nenhum conteúdo`,
"chatter.error.refresherror":`A atualização falhou, por favor, tente novamente.`,
"label.login.rememberPsd":`Lembre-se de mim`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lista de regras de pontuação principal`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Domingo`,
"label.visible":`Visível`,
"label.console.new":`Nova Consola`,
"label.mr.descreption.reDataList4":`milissegundos. por página.`,
"vue_label_notice_uploadavatar_notice2":`A imagem do avatar carregada só pode estar no formato JPG/PNG/GIF`,
"label.operation.error":`A operação falhou, por favor tente novamente.`,
"label.sendsms.context":`Conteúdo de SMS`,
"label.least.show.line":`(exibir pelo menos 4 linhas)`,
"label.tabpage.newWizardz":`Novo assistente de funções adicionado`,
"label.tippage.li2":`Excluir todos os relatórios com base em fonte de dados de relatório personalizada`,
"label.customfields.new.step2.opration.unique":`Único`,
"label.listofshare.remark":`Os usuários seguintes podem ver os registros`,
"label.address_information":`Informações de endereço`,
"label.projectManagement.overdue.tasks":`Tarefa vencida`,
"lable.account.PreviousCQ":`CQ anterior`,
"label.service.miniProgram.advertising":`O nome do anúncio é usado apenas para identificar várias entradas de anúncio e não é exibido no anúncio.`,
"label.integrations.mailchimp.exportlead":`Exportação selecionada leva ao Mailchimp`,
"label.payments.paytip3":`Favor selecionar um endereço para faturamento`,
"label.mobile.phone.screen":`Filtro`,
"label.h5.tome":`Sobre mim`,
"label.mobile.side.tab.remark1":`Adicione a aba CloudCC e objeto ao menu de navegação do controle deslizante do lado móvel.`,
"vue_label_calendar_choose_a_custom_color":`Escolha a cor personalizada deste calendário`,
"label.lastname":`Sobrenome`,
"vue_label_dashboard_selectreport":`Por favor, selecione o relatório`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Exportar o relatório como exibido no Cloud CC, incluindo o cabeçalho do relatório, o grupo e as informações do filtro.`,
"label_chatter_default":`Padrão`,
"label.globalSearch.info":`Busca de todos os objetos selecionados`,
"label.integrations.mailchimp.massage2":`Exportando os contatos selecionados para Mailchimp e você poderá ver os contatos na lista Mailchimp mais tarde`,
"label.tabpage.addresswrongz":`O formato do endereço da caixa postal está errado, por favor, digite corretamente o endereço da caixa postal!`,
"label.mobile.phone.customer.call":`Visitar Cliente`,
"vue_label_email_linkrecordfail":`Registro desvinculado`,
"lable.account.LastfDays":`Últimos 90 dias`,
"label.cpq.order.status.delete":`Esta ordem está ativa e não pode ser apagada`,
"label.ccchat.notmember.active.group":`Você não é membro`,
"label.savepayset.failure":`Falha em salvar a conta de pagamento on-line`,
"label.version.createlimitbyobject":`Sua edição atual do CloudCC é {0}, e você pode criar {1}. {2} para cada objeto. Agora, o número de {2} é excedido ao máximo de seu plano de assinatura, por favor, atualize sua edição CloudCC.`,
"approval.process.errore":`Ocorreu um erro durante o salvamento, favor contatar o administrador.`,
"label.stdashbord.xsld.business.reportanalysis":`Análise de gráficos`,
"label.login.verification.please.enter":`Por favor, digite o código de segurança que você recebe da aplicação MFA`,
"label.tabpage.cue":`Lembrete de informações`,
"vue_label_salesadvance_converserate":`Taxa de conversão`,
"label.marketsea.recyclereminddays1":`Antes da reciclagem automática`,
"label.import.page1.update":`Atualização`,
"label.document.folder":`Pastas de documentos`,
"label.h5.similar.opportunity.feature":`Esta característica permite ao usuário buscar oportunidades que compartilham campos comuns com a oportunidade. Uma vez ativado, uma lista relacionada a Oportunidades similares aparece no registro de oportunidades.`,
"label.myanmar.time":`Tempo de Mianmar`,
"monday":`Segunda-feira`,
"vue_label_account_shareholder":`Acionista`,
"button.partner.search":`Inquira`,
"label.partnerCloud.partnerAccount.topUpAmount":`Montante da recarga`,
"label.tabpage.refreshz":`Atualização`,
"lable.PowerProcess.complete":`Lixeiras de conclusão de marcos`,
"front-kefu-moudle- normal-phone":`Telefone geral`,
"label.user.unauthorized.organization":`Organização não autorizada, favor entrar em contato com o administrador.`,
"label.area.canot.save.nulldata":`Não é possível salvar os dados nulos`,
"label.version.role.management":`Gerenciamento de papéis`,
"label.recordtype.batchaddattachments.batch.remark":`Passo 1 Escolha o arquivo, Passo 2 Clique no botão "start upload", carregue os arquivos, Passo 3 Clique no botão para finalizar.`,
"label_tabpage_contentz":`Por favor, digite o conteúdo`,
"label.partner.workspace.member.all":`Todos`,
"label.validate.function.funcFormat.LEFT":`LEFT(texto, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Favor selecionar pelo menos um condutor ou contato`,
"label.appupload.install.error.choice5":`Parar a instalação imediatamente e produzir componentes conflitantes`,
"label.version.lookupmdfield":`Campo de Relacionamento Master-Detail`,
"setup.layout.label.desc":`Descendente`,
"vue_label_report_addsummaryformula":`Adicionar fórmula resumida`,
"label.done":`Feito`,
"label.input.samevalue":`Digite o mesmo valor`,
"label.SMS.next":`Selecione os objetos para as notificações por SMS e clique em "Next" (Avançar). As notificações por SMS só podem ser associadas com o mesmo tipo de regras de fluxo de trabalho e processos de aprovação.`,
"label.role.allunselectuser":`Todos os usuários não designados`,
"label.loginhistory":`Histórico de Login`,
"vue_label_report_addpublicreportstofolder":`Adicionar relatórios públicos a esta pasta`,
"label.email.track.no.attachment":`Sem anexos`,
"label_network_connection_failure":`A conexão de rede falhou.`,
"vue_label_file_delete_lib_member":`Excluir membro da biblioteca de arquivos`,
"label_partner_step1":`Passo 1 selecione o modelo`,
"label.password":`Senha`,
"label.select.the.fields.around.code":`Escolha os campos a serem exibidos ao redor do código QR/Código Bar.`,
"label.file.share.limit":`Além do limite de ações, nenhuma nova ação pode ser adicionada!`,
"label.desktop":`Desktop`,
"label.sendmail":`Enviar e-mail`,
"label.quote.detail":`Itens da linha de citação`,
"label.approvalstep2":`Etapa 2 Especifique os critérios da etapa`,
"label_component_hotdeal_nodata":`Não há dados relacionados a oportunidades de negócios.`,
"lable.reset":`Reinicialização`,
"label.eventpagelayout":`Layouts de página de eventos`,
"label.icon.100":`Papelaria`,
"UG.quota.03":`Modelo de citação`,
"label.calendar.week.view":`Visão da semana`,
"component_chatter_file_button_save":`Publicar`,
"label.as":`Como`,
"template.chart.yqxypjz":`Média Esperada de Resposta`,
"UG.Contract.03":`Criar contrato`,
"label.projectManagement.gantt":`Gráfico de Gantt`,
"label.forecast.edit.error0":`Erro: Você deve selecionar pelo menos uma moeda orporativa.`,
"label.ccpeak.delete.sharetab":`Eliminar o formulário de compartilhamento`,
"label.account.contact.goback":`Voltar às contas`,
"vue_label_email_insert_field":`Favor selecionar campo de inserção`,
"setup_object_field_dependency_label_fieldvalueoptions":`Valores de campo disponíveis`,
"label.salescloud.opportunity.contactrole.optionlist.main":`A seguir está a principal lista de valores da lista de opções para o campo de funções de contato sobre oportunidades`,
"label.huanxinconfig.tenantid.lost":`tenântida não pode estar vazia`,
"label.mask.show.last_4":`Máscara com os quatro últimos caracteres`,
"label.targer.name":`Nome do Indicador`,
"vue_label_commonobjects_detail_unlocksuccess":`Desbloqueado com sucesso`,
"front-kefu-moudle-length-min":`Duração (minutos)`,
"label.chat.topic.my.favorite":`Meus Tópicos Favoritos`,
"chatter.upload":`Upload`,
"message.cannotapproveit":`O pedido de aprovação não pode ser processado.`,
"label.weixin..xsld.order.by.jine":`Ordenar por valor de contrato`,
"label.projectManagement.wait.test":`À espera de testes.`,
"template.report.customer.contact.list":`Lista de contas de contato`,
"label.empty.recycle.bin":`Lixeira transparente`,
"label.detail.approveprocess":`Ver Processos de Aprovação`,
"label.appexchange.uninstallpage.message4":`Excluir permanentemente todos os relatórios, visualizações e abas personalizadas dos objetos personalizados neste pacote`,
"label.weixin.linkreport":`Relacionado a→Relatório`,
"label.tianyancha.orgnumber":`Código de organização`,
"Q":`Lista de picking (Multi-Select)`,
"pagecreator_systemstyle_message_save_fail":`A economia de estilo falhou`,
"label.partner.new":`Nuvem de parceiros: novo`,
"label.ems.accounttype":`Tipo de conta (a)`,
"label.weixin.next":`Próximo`,
"label.weixin.coach.interpret":`A Aid-Max reserva-se o direito de revisão e interpretação final dentro do escopo da lei de serviços WeChat.`,
"label.some":`registro(s)`,
"label.currency.rate":`Edição Moeda: Taxas de conversão`,
"label.emailobject.template.name":`Nome do gabarito`,
"UG.Campaign.001":`Campanhas de planejamento`,
"label.mr.descreption.reDataList3":`grupos de dados,tempo de consulta`,
"label.project.hit.nine":`Lembrete diário de emissão`,
"lable.PowerProcess.golist":`<<Back list：Entitlement Processo`,
"label.viewbuttonedit.remark":`Selecione os botões padrão e personalizados exibidos em primeiro plano.`,
"label.component.helper":`Assistente`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Pagamento assinado`,
"chatter.group.userName":`Nome de usuário`,
"label.mobile.phone.business":`Oportunidades`,
"label.quickbooks.payments":`PAGAM`,
"label.step6.total7":`Passo 6 de 7`,
"label.forecast.detailforecast.revenue":`Previsão de receita`,
"vue_label_commonobjects_view_chart_displayas":`Mostrar como`,
"label.recordeditoption":`Propriedades de edição de registros`,
"label.sendemail.send.sendfailstandby":`O envio de e-mail falhou, favor entrar em contato com seu administrador(caixa de saída de reserva)(código de erro:`,
"label.knowledgebase.reset.filter":`Filtro de reinicialização`,
"label.icon.111":`Alimentos`,
"label.standard.buttonandlink.firstsetting":`Substituição de propriedades`,
"front-filter-module-v1-filter-description":`O filtro flash não pode ser salvo. Aplicase somente à operação atual sem qualquer influência sobre as vistas ou outros usuários.`,
"label.showmore":`Veja mais`,
"UG_Lead_001":`Como introduzir as pistas?`,
"label.exchange.sync.state.setting.m1":`Conta do serviço de câmbio Miscrosoft fornecido:`,
"label.please.enter.channel.name":`Por favor, digite o nome do canal.`,
"label.emailtocloudcc.edit":`Editar`,
"label.layout.tabdialog":`abas`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Tarefas concluídas`,
"label.tabpage.enterviewname":`Passo 1, por favor, digite o nome da vista`,
"label.mobile.phone.not.to.choose":`Nenhum Selecionado`,
"label.datamanage.contact.namenull":`Nota: Nota: Se o nome do contato for nulo, o registro não será importado.`,
"LT":`Geolocalização`,
"label.exchange.sync.state.task.m3":`Registros sincronizados nas últimas 24 horas:`,
"lable.SalesCommitmentKanBan.contractOwner":`Proprietário do contrato`,
"vue_label_chatter_write_review":`Escreva um comentário`,
"label.h5.approval.enter.content":`Favor inserir notas de aprovação`,
"label.location.display.type":`Latitude e longitude exibem methode`,
"label.numberscannotnull":`O número não pode estar vazio`,
"label.icon.3":`Moeda`,
"setup_object_field_dependency_label_linkedfieldvalue":`Campo Dependente`,
"label.task.future":`Tarefas futuras`,
"label.look.more.record":`Mostrar mais`,
"vue_label_account_cases":`Transferir todos os casos de proprietários de clientes`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Rastreamento do histórico do conjunto`,
"ObjectDetailed.ViewKeyInformation.Layout":`Editar informações-chave`,
"label.layout.editsearchdistribute.tip":`Selecione os campos a serem incluídos neste layout de busca. Observe que suas escolhas determinam apenas a exibição dos resultados da pesquisa e não afetam os campos que são realmente pesquisados.`,
"label.emailtoall":`Enviar e-mails a todos os usuários.`,
"label_partner_new":`Nuvem de parceiros: novo`,
"label.direct.dashboard.me.not.approval":`Meus itens a aprovar`,
"label.platform.customize.customizeui":`IU personalizada`,
"label.userinfo.pwderror.againinput":`A senha digitada duas vezes não é a mesma. Por favor, entre novamente.`,
"label.customsetting.introduce":`Use configurações personalizadas para criar e gerenciar dados personalizados a nível da organização, perfil e usuário. Os dados das configurações personalizadas são armazenados no cache do aplicativo. Isto significa que você pode acessá-los de forma eficiente, sem o custo de consultas repetidas.`,
"label.file.owner":`Proprietário`,
"label.icon.7":`Pessoas`,
"label.document.query.button":`Clique em Procurar para encontrar o arquivo`,
"label.tabpage.turnoffsz":`Fechado  Convertido`,
"message.error.appid.appsecret.failed":`Falha na obtenção das chaves de secrest!`,
"vue_label_commonobjects_view_to_display_fields":`Selecione até 10 campos de exibição`,
"label.martrixreport.setlinetitle":`Especificar Cabeçalhos de Fileira`,
"vue_label_chatter_applycertification":`Concordar em "{nome}" para participar do bate-papo em grupo?`,
"front-electronic-export-success":`Exportar com sucesso, por favor verifique na lista Mailchimp`,
"label.emailsync.status.enable":`Conexão Ativa`,
"label.c_d":`Relação C a D:`,
"PageLayout_Search_MultiSearch_003":`Selecione pelo menos um campo.`,
"label.tabpage.newInterfacez":`A nova interface`,
"label.cutomsummaryfieldedit":`Resumo personalizado de campo Editar`,
"label.usermanage.view.field.notexist":`O campo correspondente à vista não existe.`,
"label.list.userinterface.dashboard.setup":`Configuração do painel de controle`,
"label.knowledgebase.delete.article":`Eliminar artigo`,
"label.dataimport.type.update":`Atualização`,
"label.marketsea.new":`Novo Pool`,
"label_tabpage_newlybuildz":`Novo`,
"vue_label_helpcenter_report1":`1.Construa um relatório<br> O relatório Lightning no sistema de gerenciamento de vendas Cloud CC é uma poderosa ferramenta de análise de dados. Muitos problemas de vendas podem ser resolvidos agrupando, filtrando e resumindo registros. Por exemplo: "Qual foi a receita gerada pelas novas oportunidades de negócios da empresa no último trimestre?" Gráficos de relatórios podem ser adicionados com base no preenchimento da visão geral dos dados. Após a conclusão do relatório, clique em Executar para visualizar os resultados completos dos dados. <br> Passo 1: Na guia do relatório, clique em "Novo Relatório";<br> Passo 2: Selecione a fonte de dados do relatório e depois clique em "Próximo";<br> A fonte de dados do relatório que você escolher pode determinar quais registros ou campos podem ser usados no relatório. Selecione ou procure por um objeto como o objeto principal. Você pode selecionar até 4 objetos que tenham corelação com o objeto principal, e você pode selecionar a relação entre os objetos. <No modo de edição, você pode personalizar o relatório, adicionar campos como colunas ao relatório, agrupar linhas e colunas e usar filtros para filtrar os dados do relatório até que os dados necessários sejam exibidos com precisão<br>Adicionar ou remover colunas e ajustar a ordem<br>Adicionar coluna: No modo de edição do relatório, clique na caixa de entrada "Coluna" no "Resumo" no lado esquerdo da página, e adicione colunas ao relatório após pesquisar o campo ou rolar a lista suspensa de campos e selecionar o campo de destino. <br> Remover coluna: <br> A. Após encontrar a "coluna" que você deseja remover na lista "coluna" à esquerda, clique no "×" na caixa de campo. <br> B. Ou encontre a "coluna" que você deseja remover no cabeçalho da visualização prévia do relatório à direita, clique no botão "drop-down" e clique em "apagar coluna".<br> A remoção da coluna do relatório não elimina o campo. Se você quiser restaurar a coluna após removê-la, basta adicioná-la novamente. <br> Ajuste a ordem da coluna: Arraste o campo "Column" (Coluna) na lista "Column" (Coluna) à esquerda para cima e para baixo para ajustar a ordem de arranjo da "Column" (Coluna). <br>Adicionar e remover agrupamento de linhas e agrupamento de colunas<br> Adicionar agrupamento de linhas: Clique na caixa de entrada "Grupo de linhas" no "Resumo" no lado esquerdo da página, e adicione campos de agrupamento de linhas de relatório para filtrar os dados após pesquisar o campo ou rolar a lista de campos drop-down e depois selecionar o campo de destino. <br> Sem adicionar agrupamento de colunas, você pode adicionar até três agrupamentos de linhas. <br> Adicionar agrupamento de colunas: quando o agrupamento de linhas existe, você pode adicionar agrupamento de colunas. Clique na caixa de entrada "Coluna de Grupo" no "Resumo" no lado esquerdo da página, selecione o campo após pesquisar ou role a lista suspensa de campos e selecione o campo desejado Formas de adicionar campos de agrupamento de colunas de relatório para filtrar dados. <br> Você pode adicionar até dois grupos de colunas. No caso de adicionar grupos de colunas, você pode adicionar até dois grupos de linhas. Os campos adicionados como grupos de linhas não podem ser adicionados como grupos de colunas. <br>`,
"label.notification.event1":`【分配人】 lhe designou um evento`,
"chatter.field":`Campo(s)`,
"chatter.feed.menutype.feed.newscom":`Tudo o que eu sigo`,
"label.attendance.range":`Faixa de freqüência`,
"vue_label_calendar_deleteconfirm":`Você tem certeza de que vai apagar o calendário {nome}`,
"label.ems.createTask":`Novo {tarefaNome}`,
"label.visualpage.wgd":`Páginas Personalizadas Não Arquivadas`,
"label.multilang.product.deleterederect1":`Sua tentativa de apagar <font style="font-weight:bold;">{0}</font> não pôde ser completada porque ainda está associada ao seguinte registro. Neste caso, recomendamos desativá-lo.`,
"label_emailtocloudcc_filed_servertype":`Servidor de e-mail`,
"label.umeng.insert.approval.dlsp.approvenew":`#O nome de usuário submete #objAPIName#recordname para sua aprovação`,
"label.tabpage.queue":`Fila`,
"label.approval.step":`Etapas de aprovação`,
"label.approvaldatamove.approvalprocessname":`Nome do processo`,
"label.actualapprovedpeople":`Aprovador real`,
"label.systemlog.f":`FALHA`,
"front-template-V1-addText":`Adicionar texto`,
"label.chat.like":`Como`,
"label.userinfo.oldpwd.notnull":`A senha antiga não pode estar vazia.`,
"label.service.all.done.major.event":`Você completou todos os marcos.`,
"label_chatter_to":`Para`,
"message.toomuchlinecannotoutput":`Demasiadas colunas de relatório são selecionadas e o relatório não pode ser emitido.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`O plano de manutenção foi atribuído ao ativo. Favor não atribuir repetidamente.`,
"lable.quote.syncing.firstsync.description":`Os itens da linha de cotação substituirão os produtos de oportunidade`,
"lable.outlook.mcto.saveemail":`Certifique-se de salvar os anexos de e-mail`,
"label.passwordPolicy.setup.pwdremember2":`2 senhas lembradas`,
"label.project.hit.five":`Aviso de atualização de tarefas`,
"label.linkedin.setting.appid":`Chave secreta`,
"label.dataimport.error.name.notnull":`Erro: o nome não pode ser nulo`,
"label.knowledge.case.field.selected":`Campos de casos selecionados`,
"label.version.datetime":`{0} campos de data/hora`,
"Dashboard_NoAccessRightToSee_Warning":`Você não tem permissão para visualizar os dashboads {0} que estão definidos como defualt aberto, favor reiniciar.`,
"label.login.access.permission":`Conceder acesso a`,
"label.operatedata.import.tip":`1. O arquivo importado deve ser um arquivo em formato CSV. O arquivo deve conter um título e não pode ser importado sem título. 2. Recomenda-se exportar antes de importar, comparar os dados que deseja importar para o modelo de dados com o documento de exportação, e depois importar.`,
"workflow.action.tasks.assignortype.rolename":`Nome do papel`,
"vue_label_account_quotations":`Transferir todas as cotações do proprietário do cliente`,
"lable.account.CurrentCQ":`CQ atual`,
"label.user.database.error":`Erro no banco de dados!`,
"label_emailtocloudcc_titel":`Email para CloudCC`,
"label_file_content":`Conteúdo do texto`,
"label.button.behavior":`Comportamento`,
"message.recordtype.new.tip":`Digite os detalhes`,
"label.ccchat.message.new.error3":`Erro: você não pode selecionar mais de 9 destinatários`,
"vue_label_commonobject_notice_lessthanwords":`O nome do arquivo deve ser menor que {FILE_NAME_COUNT} palavras!`,
"label.stacked.verticalline":`Colunas Empilhadas-Verticais`,
"vue_label_SMS_messagebox":`Caixa de mensagens`,
"label.appexchange.installedpage.message3":`</b>Dependente dos links ao lado de um pacote instalado, você pode tomar diferentes ações a partir desta página. Para excluir um pacote, clique em <b>Desinstalar</b>. Para gerenciar licenças de pacotes, clique em <b>Manage Licenses</b>.`,
"label.unusedapproveprocess":`Processos de aprovação inativos`,
"label.onlywithspecificconditions":`Somente os registros que atendam certos critérios devem ser incluídos no cálculo`,
"lable.outlook.mcto.formaterror":`Erro de formato`,
"label.area.parent":`Território dos pais`,
"vue_label_chat_activesuccess":`Ativado com sucesso`,
"label.setting.intergrationlist.button.upgrade":`Atualização`,
"label.page_hidden":`Campos ocultos para a página de registro`,
"label.customsetting.manage.belong":`Configuração Proprietário`,
"label.appointment.wizard.subtitle4-2-8":`7 dias`,
"template.chart.ydywjhxsje":`Valor mensal de vendas Oportunidades de negócios`,
"label.multilang.currencylist.after":`Depois de {0}`,
"vue_label_commonobjects_view_chart_countby":`Conte por`,
"label.week":`Semana`,
"label.emailtemplate.name":`Nome do gabarito`,
"label.umeng.sign":`assinado em`,
"label.appupload.upload.details":`Detalhes`,
"label.file.loading":`Carregamento`,
"label.newdetail.orgTitle":`Funções de contato`,
"label.salescloud.field.addoptionlist":`Adicionar valores da lista de picking`,
"pagecreator.page.funcpath":`/ construtor / lista de páginas`,
"Account.News.Setting.001":`Configurações da conta`,
"label.marketsea.getnoconversiondays":`Dias não convertidos (devem ser mais do que o número de dias sem acompanhamento após a obtenção)`,
"message.error.event.add":`Nova anomalia do evento`,
"front-electronic-export-choseChimp":`Favor selecionar a lista Mailchimp exportada`,
"vue_label_report_personothers":`Outros`,
"label.hierarchy.diagram":`Estrutura hierárquica`,
"label.stdashbord.xsld.business.yqsr":`Receita esperada`,
"label.chat.topic.max.count":`Você atingiu o número máximo de tópicos.`,
"label.sendemail.send.sendfail":`O envio de e-mail falhou, favor entrar em contato com seu administrador.`,
"registration.page.body.title":`Página de Inscrição`,
"label.userphoto.back":`Voltar`,
"label.service.without.timeslot":`Não parece haver nenhum espaço de tempo, vamos acrescentar!`,
"label.processsetting.remaining.quantity":`Podem ser inseridos até 255 caracteres, sobrando:`,
"label.sure.delete":`Confirmar para excluir`,
"front-epwechat-module-v1-callback":`Configuração de retorno de chamada`,
"front-email-payment-failed":`Desculpe, o pagamento falhou!`,
"label.icon.67":`Máquina`,
"UG_Forcast_01":`Previsão`,
"label.escalation.setup.newentries.step3":`Passo 3 Especifique como os tempos de escalonamento são definidos`,
"lable.account.NextCY":`Próximo CY`,
"report.type.label.quote":`Citações`,
"label.area.name":`Nome do território`,
"component.setup.label.object":`Objetos`,
"label.customsetting.type":`Tipo de ajuste`,
"label.showdetail":`Mostrar detalhes`,
"label.department.prev":`Página Anterior`,
"label.select.data.source.report":`Por favor, selecione o relatório de fonte de dados`,
"UG_homepage_002":`Gerencie suas pistas, leads, funis de transação de vendas e informações de conta com ferramentas comerciais integradas`,
"vue_label_report_notice_exprot1":`Somente as linhas de detalhe são exportadas. Utilize estes dados para mais cálculos ou upload para outros sistemas. Exportação por página, até 5000 itens em uma página`,
"message.error.task.phonecreate":`Anomalia na criação de tarefas telefônicas`,
"label_chatter_day":`Dia`,
"label.setinitialcommiter":`Etapa 6 Especifique os autores iniciais`,
"message.huanxinconfig.notfound":`A configuração Easemob não é encontrada`,
"label.customfields.file.count.tip":`Favor inserir o número de arquivos que podem ser inseridos neste campo, o padrão é 1`,
"label.weixin.appmanage":`Gestão de aplicativos`,
"label.approverautoconfirm":`Aprovador automatizado determinado por`,
"vue_label_CCChat_followers":`Seguidores`,
"label.usermanage.notselect":`Nenhum usuário é selecionado.`,
"label.item":`Item(s)`,
"label.sendemail.chat.linkurl":`A URL do link:`,
"label.sendmail.step3.deliveroptions":`Opções de entrega`,
"homepage.components.creationtime":`Data de criação`,
"label.pc.ui.2018.ccchat.setting":`Configuração do CCChat`,
"label.knowledge.search.result.highlight":`Destacar artigos relevantes nos resultados da busca`,
"label.data.downpage.e.title.num2":`2、If você escolhe exportar os dados de um único objeto, você precisa selecionar como os dados são exportados: exportação personalizada, exportação por modelo e modelo de exportação.`,
"label.field.duplicate.error.msg1":`Aqui estão os dados duplicados, verifique primeiro os duplicados, e depois configure uma propriedade única.`,
"label.campaign.channel.input.number.error":`Erro no formato do número`,
"label.goto.dashboard":`Ir para Painel de Controle`,
"com.cloudcc.login.error.message.invalid.ip":`Seu IP não está na faixa de IP.`,
"label.selectnewfieldvalue":`Especificar novo valor de campo`,
"label.appointmentdetail.wizard.title11":`Data final`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Data de início do estágio atual`,
"front-dynamiclayout-module-v1-readonly":`O campo de {required} está definido como Read Only (Somente leitura).`,
"vue_label_calendar_start_field":`Campo para começar`,
"label.weixin.recalculate.shared.failed":`O recálculo da regra de compartilhamento de objetos falhou.`,
"label.sendmail.step3.dealoptions":`Opções de processamento`,
"setup_layout_label_modifypage":`Edição do layout da página`,
"homepage.components.select.wide":`Selecione Componentes Amplos para Mostrar`,
"label.import.page1.laststep":`Anterior`,
"label.weixin.donot.permission":`Você não tem permissão para realizar esta operação.`,
"message.error.name.null":`O nome não pode estar vazio!`,
"label.salescloud.teamrole.optionlist":`Valores da lista de seleção de papéis da equipe`,
"component_setup_label_titlefield":`Campo de título`,
"vue_label_commonobjects_detail_have_been":`Você tem sido`,
"label.textmessage.vonage.setup":`Configuração de Vonage`,
"label.recordtype.profile.enableit":`Habilitar para Perfil`,
"UG.product.04":`Criar produto`,
"label.knowledge.No.related.articles":`Nenhum artigo relacionado...`,
"label.chat.muted":`Não Perturbar`,
"registration.page.field.selection":`Selecione o campo da página de registro`,
"label.project.hit.eleven":`Aviso de atribuição de emissão`,
"lable.newtabpage.advsearch":`Busca avançada`,
"label.report.share.roleandsub":`Papéis e subordinados internos`,
"component.salesperformance.label.nodata":`Adicione sua oportunidade de negócios e volte aqui para ver o gráfico de desempenho.`,
"label.submitted_on":`Submetido em`,
"label.file.create.link":`Criar link`,
"label.contact":`Contatos`,
"label.tab.message.failtoopenleft":`A operação de fusão não conseguiu abrir a coluna da esquerda`,
"label.replaces":`Substitua`,
"label.customcomponent.check.tag.startwith":`O componente deve começar com o rótulo &lt;cc:component&gt;.`,
"label.tab.web":`Separadores Web`,
"message.success.task.add":`Salvar com sucesso as informações da nova tarefa`,
"label.chatter.addresser":`Remetente`,
"label.mobile.homepage":`Página inicial`,
"label.data.imp.su.ok":`Importando`,
"label.knowledge.category.hint.one":`O grupo de categorias é a hierarquia das categorias de dados. Por exemplo, um grupo de categoria denominado "Localização" pode conter a hierarquia geográfica do continente, país, região e estado. Use esta página para gerenciar grupos e subcategorias de categorias.`,
"label.schedulejob.setup.schedule.weekly":`Semanalmente`,
"label.tag.manage.description":`Todas as tags de {0} são as seguintes. Você pode renomear ou excluir as tags disponíveis.`,
"label.tabcontrol":`Tabs`,
"label.field.duplicate3":`Tratar "ABC" e "abc" como valores duplicados __(insensível a maiúsculas e minúsculas)`,
"label.customsetting.type.list":`Lista`,
"lable.account.ovdate":`Data final do trimestre fiscal`,
"label_chatter_pastSevenday":`Os últimos 7 dias`,
"front-kefu-moudle-v1-lxndxsdb-free":`Por favor, entre em contato com seu representante de vendas e habilite o serviço de agente gratuito`,
"label.termsforusage":`Termos de uso`,
"label.forecast.settings.qijian.m":`Previsão do mês`,
"label_tabpage_viewname":`Ver nome`,
"label.report.action.addtodashboard1":`Adicionar ao Painel de Controle`,
"label_vue_create_edit_obj_create_event_dialog_desc":`O usuário que você designou já está engajado em horários:`,
"vue_label_report_standardfilter":`Filtro Padrão`,
"label.umeng.approval.submit":`#O solicitante submeteu um registro #obj para aprovação.`,
"label.tab.mobile.sign":`Ícone do lado móvel`,
"vue_label_commonobjects_detail_check_the_content":`Há um erro de verificação, favor verificar o conteúdo`,
"UG_Campaign_001":`Campanhas de planejamento`,
"chatter.group.baseInformation":`Informações básicas`,
"label.sendemail.send.noreceiver":`Nenhum destinatário ou endereço de destinatário está vazio.`,
"template.chart.yskje":`Quantia a receber`,
"label.textarea":`Área de texto`,
"vue_label_statistics_value":`Valor estatístico`,
"font-evaluate-module-v1-select-img":`Selecione a imagem`,
"label.totalof":`Você é um total de`,
"label.hangye":`Indústrias`,
"label.partner.common.setup":`Configurações comuns`,
"label.icon.78":`Agricultura`,
"lable.outlook.detail.addemail":`Adicionar e-mail`,
"label.ServiceCloud.fuwuquyu":`Território de serviço`,
"label.gb2312encoding":`Chinês (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min`,
"label_emailtocloudcc_reauthorization":`Reautorização`,
"label.approval.message":`Os pareceres de aprovação podem ser inseridos até 1000 caracteres.`,
"label_component_helper":`Assistente`,
"label.editRate":`editar taxas de câmbio`,
"label.setuptemplate":`Modelos de automação`,
"label_emailsync_button_cancel":`Cancelar`,
"label.marketseamemset.account.maxuser":`Número máximo de clientes`,
"label.someerror":`Por razões de segurança, sua sessão CloudCC está prestes a ficar sem tempo.<br>>br> O que você vai fazer a seguir?`,
"label_person_in_charge":`Supervisor`,
"label.visualpage.reference.standard.style":`Invocar o estilo padrão de Plataforma, estilo customizado-padrão`,
"errormessage_email_relatedorreceivermusthaveone_z":`Você deve selecionar um destinatário ou um assunto relacionado, pelo menos.`,
"label.insert.field.empty.continue":`Os registros com valor nulo de 【{resDataField}】 existem, portanto o código não pode ser gerado. Você quer continuar gerando?`,
"component.newrecords.label.title":`Registros recentes`,
"template.detail_info_link":`Detalhes Link`,
"component_setup_tabs_label_default":`Página predefinida`,
"label.emailobject.template.name.null":`O nome do modelo de correio não pode ser empty！`,
"label.knowledge.field.changed":`{1} é alterado`,
"homepage.components.select.narrow":`Selecione Componentes Estreitos para Mostrar`,
"label.mobile.phone.week":`Semana`,
"component_chatter_button_like":`Como`,
"label.brief.won":`Ganhou`,
"label.setup.profile.replaceme":`Substituir as coisas sobre mim`,
"label.knowledge.setting.enable.lightning":`Ativar o conhecimento sobre relâmpagos`,
"label.middle":`Médio`,
"label.icon.109":`Pessoas`,
"vue_label_normal_activity_sf":`Atividade`,
"chatter.poll.option6":`Escolha 6`,
"label.lanxin.setting":`Integrar Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Oportunidades totais`,
"label.emailobject.emaildetail.promptbutton1":`Confirme`,
"Opportunity.Detailed.Phase.Label.001":`Estágio`,
"label.customcomponent.params.info":`Como utilizar os parâmetros.`,
"label.emailtocloudcc.button.next":`Próximo`,
"front-email-payment-billing-date":`Data da fatura`,
"label.ems.with3day":`Dentro de 3 dias`,
"label.project.subtask.date":`A data da sub-tarefa deve estar dentro do intervalo de datas da tarefa a que pertence.`,
"label.role.allunselectanduseduser":`Todos os usuários não designados e ativos`,
"front-kefu-moudle-yes-wantbuy":`Sim, eu quero comprar`,
"label.looking_for":`Você conseguiu o que estava procurando?`,
"page.404.label.noresource":`Desculpe, o recurso que você quer acessar não existe.`,
"vue_label_ccchat_notice_deletecommentcertification":`Você tem certeza de que quer apagar este comentário?`,
"label.data.setok.e.desc1":`Exportar com sucesso, você receberá uma mensagem de alerta, os dados derivados são temporariamente armazenados no servidor, o sistema só para você economizar 48 horas, por favor, o mais rápido possível para`,
"label.weixin.confirm.delete":`Você tem certeza de que quer apagar esses dados?`,
"A":`Área de texto (rich text)`,
"template.report.sales.cycle":`Duração do ciclo de vendas`,
"label.service.shift":`Turnos de trabalho`,
"label.visualpage.display.side.bar":`exibir barra lateral, falso - não exibir barra lateral`,
"label.list.userinterface.chatter.showall":`A página inicial do CCChat mostra todos os posts por padrão`,
"vue_label_systemSettings_set_course":`Estabeleça o caminho adicionando dicas para cada etapa para guiar os usuários passo a passo.`,
"label.icon.156":`Pessoas`,
"label.marketsea.button.move":`Mudança`,
"front-email-payment-select-email":`Favor digitar o Código Postal`,
"front-electronic-signature-service-provider":`Prestador de serviços`,
"label.h5.add.checkin":`Fazer o check-in`,
"vue_label_amount_total":`Montante total`,
"label.campaign.channel.new":`Campanhas: Novo Canal de Marketing`,
"label.knowledgebase.restore.creates.draft":`Restore irá gerar um rascunho a partir da versão atual. Você precisa publicar o rascunho para que todos vejam.`,
"UG_Case_01":`Caso`,
"label.validate.function.funcExplain.CONTAINS":`Verifique se o texto contém um caráter específico e, em caso afirmativo, devolva VERDADEIRO, caso contrário devolva FALSO`,
"label.data.exp.savetemp":`Salvar como modelo`,
"front-project-module-v1-template-newcreate":`Criar Projeto a partir de Modelo de Projeto`,
"label.field.default.count":`Número de linhas padrão`,
"page.note.acc":`Notas`,
"label.close":`Fechar`,
"label.app.detailbeforeedit":`Detalhes do aplicativo personalizado abaixo. Clique em "Editar" para modificar os aplicativos personalizados.`,
"label.profile.standardfieldsafety":`Segurança padrão em nível de campo`,
"vue_label_report_notice_deletefilter":`Favor excluir primeiro o filtro avançado`,
"label.multilang.datamoveaction.movesuccess":`Um total de {0} registros foram transferidos com sucesso! ：`,
"label.emailmerge.edittemplate.descirption":`Digite informações sobre seu modelo de mala direta. Note que a descrição é exibida apenas no CloudCC.com, não no Word.`,
"label.visualpage.at.the.end":`Use a etiqueta no final`,
"label.exchange.sync.state":`Estado de Sincronia de Troca`,
"label.newdashboardpage.new":`Adicionar uma linha`,
"label.querydetailservice.profile.notsetup":`O perfil de sua conta não está definido.`,
"label.escalation.setup.detail.description":`Adicionar entradas de regras que especifiquem os critérios usados para escalar os casos. Você pode reordenar as entradas de regras nesta página depois de criá-las.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Se habilitar o h5 em seu lado móvel e editar`,
"vue_label_file_upload_tip_msg":`Recomendamos que o arquivo carregado seja inferior a 30MB, caso contrário, pode fazer com que a página seja carregada lentamente`,
"label.eowechat.epdeptid":`Identificação do Departamento WeCom`,
"label.adminorapprover":`Administradores <forte>OR</strong> o aprovador atualmente designado pode editar registros durante o processo de aprovação.`,
"label_emailtocloudcc_email":`Email`,
"setup_main2018_label_norole":`Você não tem as permissões administrativas`,
"label.onlyone":`Único`,
"label.sso.saml.idp.config.nameidtype":`Tipo de Assunto`,
"vue_label_normal_campaign_sf":`Campanhas`,
"label.icon.61":`Guindaste`,
"label.datatype":`Tipo de dados`,
"label.mobile.home.page.today.work":`Meus trabalhos`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat gostou de seu comentário`,
"chatter.sel.p":`0 selecionado.`,
"label.b_c":`Relação B a C:`,
"label.tabcontrolnameandtaglib":`Nomes e etiquetas de etiquetas`,
"label.globaloperation.tip":`Criar, editar e visualizar a operação global, que pode ser usada para páginas de detalhes.`,
"R":`Tipos de registros`,
"label.initcommiteoperate":`Ações iniciais de submissão`,
"front-kefu-moudle-v1-Operation-without0-permission":`Sem permissão para operar este registro, favor entrar em contato com o administrador`,
"button_partner_create":`Novo`,
"label.document.name.length.cannot.than":`O tamanho do nome do documento não pode exceder 255 caracteres.`,
"label.area.donot.delete":`Não é possível eliminar este território, pois o território atual tem um sub-território.`,
"label.currency.activation":`Ativar`,
"label.connect":`&Concatenate`,
"button.partner.viewdetail":`Ver`,
"setup_object_field_dependency_label_mustsetup":`Por favor, configure primeiro a dependência de campo e salve.`,
"label.SalesCommitmentKanBan.task":`Valor da Tarefa de Contas a Receber`,
"lable.quote.syncing.finishbutton":`Feito`,
"label.weixin.group.type":`Tipo de acesso`,
"vue_label_commonobjects_detail_relationship":`Grau de relacionamento`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Valores de campo disponíveis`,
"label.sso.lookAtTheKey":`Ver chave`,
"UG.opportunity.008":`Equipe de oportunidade`,
"label.customfields.new.step1":`Passo 1 Escolha o tipo de campo`,
"lable.qrcodeOrbarcode.rule":`Gerar Regras do Código QR/Código Bar`,
"vue_label_notice_nopermission_delete":`Lamentamos que você não tenha acesso para apagar este registro, por favor entre em contato com o administrador.`,
"label.customerobj.tab":`Separadores de objetos personalizados`,
"com.cloudcc.login.error.message.nolicens":`A licença não existe`,
"label.sendsms.batch.confirm":`SMS em massa: Confirme`,
"label.forecast.settings.sos":`Receita e quantidade`,
"label.calendar.addevent.notice.opencalendarfirst":`Por favor, abra meu calendário ou outros calendários antes de adicionar eventos`,
"message.success.task.phonerecord":`Salvar registros telefônicos com sucesso`,
"label.knowledgebase.create.new.subtab":`Nova Sub-tabela`,
"label.knowledge.article.recordid":`A identificação do artigo de conhecimento não pode ser nula`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Dias no Estágio Atual`,
"homepage.layout.nowpage":`Layout de Página Existente`,
"template.chart.khslph":`Número de Contas Classificadas`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`Não é possível eliminar o recurso de serviço para o qual foi designado um responsável de serviço. Você pode desativar este recurso de serviço.`,
"label.email.only.display.info":`Somente contatos ou colegas com endereços de e-mail armazenados são exibidos na caixa abaixo`,
"label.weixin..xsld.yjhtje":`Montante esperado do contrato`,
"label.permission.delete.permsets.error.prompt":`A permissão definida não pode ser apagada porque tem usuários designados para ela.`,
"label.ccchat.enter.two.choices":`Por favor, digite pelo menos duas opções`,
"label.edit.field.select.style2":`Uma opção por linha`,
"vue_label_email_please_enter_email_subject":`Por favor, digite o assunto do e-mail`,
"batch.sendemail.f":`o correio falhou.`,
"label.sms.senderr":`O envio de SMS falhou`,
"label.batchadd.newbatchpage.save.em":`Formato de e-mail inválido`,
"label.icon.96":`Bússola`,
"message.recordtype.deleterecord.tip":`Use esta página para substituir todos os tipos de pecord existentes por novos tipos de registro. Selecione o tipo de registro abaixo para re-palar quaisquer registros que contenham os tipos de registros excluídos. Se você quiser apenas excluir o tipo de registro de um tipo existente sem substituí-lo por um novo tipo de registro, por favor selecione "Nenhum".`,
"label.field.edit.max":`Pontuação máxima`,
"label.partnerCloud.orderingPlatform.preferential":`Desconto`,
"label.callcenter.login.later":`Entrar mais tarde`,
"batch.change.owner":`Por favor, selecione o proprietário`,
"label.version.allow.upload.size":`edição,arquivo de upload máximo permitido`,
"setup.mainpage.label.welcome17":`Configurações de permissão`,
"label.tag.sectionname":`Informações sobre a etiqueta`,
"label_partner_workspace_setup":`Configurações`,
"label.managecontrol":`Permissões administrativas`,
"label.timetrigger.condition":`A condição de avaliação é definida para cada vez que o registro é criado ou editado.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Semana`,
"front-verkoop-bywerking-error":`Atualização falhou`,
"label.allowcommittercallback":`Permitir que os apresentadores apresentem pedidos de aprovação de recall`,
"vue_label_commonobjects_detail_lead_finishistatus":`Marcar Status como Completo`,
"message.error.object.lookupmd":`o Campo de Relacionamento Mater-Detail é criado neste objeto`,
"label.stdashbord.xsld.business.img7":`Número de estágios com probabilidade 0% / (Número de estágios com probabilidade 100%   Número de estágios com probabilidade 0%)`,
"label.checkruleofevent":`Regras de validação de eventos`,
"front-epwechat-module-v1-single":`Sinal único ligado`,
"label.tabpage.save":`Salvar`,
"label_emailtocloudcc_search":`Busca`,
"label.tianyancha.h5.registeredPlace":`Local registrado(encurtamento)`,
"label.field.addoptionlist":`Adicionar valor à lista de picking: Lista de picking`,
"label.schedule_anotherpost":`Planejar outros cargos`,
"label.customfields.searchrelation.tip":`Cria uma relação que liga este objeto a outro objeto. O campo de relacionamento permite aos usuários clicar em um ícone de busca para selecionar um valor de uma lista popup. O outro objeto é a fonte dos valores da lista.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Recarga de conta`,
"label.projectManagement.view.details":`Ver detalhes`,
"label.sendemail.chat.praiseFeed":`Prezado #nome:{\i1}olá! #userName gostou de seu micropost.`,
"label.validate.function.category.Text":`Texto`,
"component.task.label.newevent":`Nova Tarefa`,
"label.data.import.setup.operate":`O que você quer fazer se você encontrar um registro existente?`,
"label.salescloud.salesdashboard.clear.option":`Opções claras`,
"lable.account.PreviousCY":`Anterior 2 CY`,
"label.appointment.wizard.subtitle8":`Nome da Empresa Visível para o Convidado`,
"label_emailsync_status_viewlog":`Ver Diário de Bordo`,
"message.duplication.label.filtertitle":`Encontrar filtros duplicados`,
"label.custom.quarter.description":`Esta página permite que você defina e edite o trimestre personalizado. A data do trimestre personalizado será gerada com base nas escolhas que você fizer abaixo.`,
"label_tabpage_filenamez":`Nome do arquivo`,
"lable.currencyAdv.andbefordate":`e antes`,
"label.version.nonsupport.sharerule":`As regras de compartilhamento não são suportadas temporariamente.`,
"front-epwechat-module-v1-unbound":`Desobstruir`,
"label.division":`Divisão`,
"label.data.import.setup.repeat":`Você quer evitar que registros duplicados sejam criados?`,
"label.callcenter.makesure.Amazon.connect":`Nota: Certifiquese de ter criado uma instância de Amazon Connect`,
"label.version.lead.control":`Gestão de liderança`,
"label.copying.reward.groups":`Grupo de Linha de Citação de Clone`,
"#label.severalorone":`Zip ou arquivo individual#`,
"label.mailinginfo":`Endereço para correspondência`,
"component.telerecord.label.title":`Registrar uma chamada`,
"label.godocumentlist":`Voltar para a lista: Documentos`,
"APPIntegration.Dropbox.setting.01":`Habilitar`,
"label.tianyancha.website":`Website`,
"label_tabpage_greaterequalz":`Maior ou igual a`,
"vue_label_campaign_influencedopportunity":`Oportunidade de negócios influenciada`,
"message.save.param.null":`O parâmetro está vazio, salvo falha`,
"front-epwechat-module-v1-domain":`Nome de domínio de confiança  JSSDK：`,
"label.allowreport":`Permitir relatórios`,
"label.service.major.event":`Marco histórico`,
"label.import.index.selectobjectandfiles":`Selecionar objeto e arquivo`,
"label.chatter.task":`Tarefa`,
"label.knowledge.setting.hint.twelve":`Inserir categoria de dados`,
"lable.account.CurrentandPreviousFY":`Atual e Anterior FY`,
"label.martrixreport.step3":`Passo 3 Selecione os dados resumidos`,
"front-console-select-cases":`O número do caso selecionado não pode exceder 10`,
"label.partnerCloud.partnerAccount.backHome":`Voltar à página inicial`,
"label.me.assign":`Atribuído por mim`,
"label.appointment.wizard.subtitle3":`Hora da reunião`,
"label.edit_columns":`Editar Colunas`,
"label.partnerCloud.orderingPlatform.useRebates:":`Use o Rebate:`,
"label.projectManagement.enter.up.to.10.digits":`Podem ser inseridos até 10 dígitos.`,
"label.integrations.description.mailchimp":`Ao integrar o CloudCC ao MailChimp, você poderá importar contatos e leads selecionados de sua conta CloudCC para o MailChimp e enviar o e-mail para os destinatários pretendidos.`,
"label.ccchat.person.error.requiredomain":`Erro: pelo menos um domínio necessário`,
"label.projectManagement.Pleaseselectitem":`Por favor, selecione o projeto`,
"label.netaccess":`Acesso à rede`,
"vue_label_SMS_searchobject":`Objeto de busca`,
"label.role.viewintree":`Mostrar na vista em árvore`,
"lable.SalesCommitmentKanBan.accountName":`Nome da conta`,
"label.please.contact.your.administrator":`Favor contatar o administrador para ativar as regras de geração de código QR/Código Bar`,
"label.sso.saml.sp.idenitysource":`SAML Local de Identidade`,
"label.queue.delete":`Excluir`,
"label.service.miniProgram.jumpLink":`Elo de salto`,
"label_set_ forecast_scope":`Faixa de previsão definida`,
"label.weixin.success.sign":`Conectou-se com sucesso, por favor, saiba.`,
"front-dialog-module-v1-error-code":`Código de erro`,
"label.projectManagement.nodata.problem":`Ótimo! Nenhum problema delicado precisa ser resolvido.`,
"label.myhomepage":`Minha página inicial`,
"label.exchange.sync.state.task.m1":`Última atividade sincronizada:`,
"label.pw.config":`Por favor, confirme sua senha`,
"front-console-new-contact":`Novo contato`,
"label.customfields.fielddependency.editexplain":`<li>Duplo clique em uma célula para alternar sua visibilidade para o valor do campo de controle mostrado no cabeçalho da coluna.</li><li>Para mudar várias células de uma vez, selecione várias células e então clique no botão Incluir valores ou excluir valores para mudar a visibilidade de todas as células selecionadas de uma vez.</li><li>Use SHIFT   clique para selecionar um intervalo de células adjacentes. Use CTRL   clique para selecionar várias células que não são adjacentes.</li><li>Use o botão Preview para testar os resultados.</li>`,
"setup_mainpage_label_welcome7":`Instruções: Clique no menu do lado esquerdo da página → Configurações da Aplicação → Criar → Objeto → Nome do Objeto → Campo personalizado.`,
"message.validation.sum":`Há muitos campos mostrados na página de aprovação, você pode selecionar até 190 campos.`,
"label.knowledge.attach.case":`Anexar ao caso`,
"front-electronic-signature-custom-field-type":`Tipos de campos personalizados`,
"vue_label_pricebook_activated":`A lista de preços é ativada`,
"vue.schedule.pre":`Esta é a minha agenda, por favor.`,
"Lead_Tools_BatchScoring":`Pontuação do Lote de Chumbo`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filtrar por`,
"label.report.no.recently":`Nenhum registro recente.`,
"label.service.gantt.dangerous.sum":`Número de compromissos de serviço em perigo.`,
"label.main.field":`Campo primário`,
"label.weixin.optionfive":`Escolha 5`,
"homepage.wide":`Coluna larga (direita)`,
"vue_label_notice_confirmdelatehomepage":`Você deseja apagar a página inicial?`,
"vue_label_report_exportpages":`Páginas de exportação: Não.`,
"label.select_compaign":`Escolha uma campanha`,
"attachment.button.massdownload":`Download em massa`,
"label.chatter.incident":`Evento`,
"label_partner_new_step1":`Passo 1 Selecione o modelo que você gosta`,
"button.partner.workspace.saveas.memo":`Salvar a nuvem de parceiros atual como um "modelo".`,
"vue_label_pricebook_edit":`Editar lista de preços`,
"label.weixin.privacy.rights":`Permissões de privacidade: Approximate location(web-based),Precise location(GPS).`,
"label.please.codeType":`Por favor, escolha o tipo de código.`,
"label.approveorrefuserequest":`Aprovar / Rejeitar`,
"message.error.sharemember":`O sharemember aprovado não pode estar vazio, por favor verifique os parâmetros aprovados!`,
"label.file.folder.edit":`Editar Pasta`,
"label.data.import.setup.repeat.yes":`Sim-Prevenir a criação de registros duplicados. Nota: Se desejar atualizar um registro existente, você deve selecionar esta opião.`,
"label.approveBeforeTheOperation":`Operar antes de aprovar`,
"vue_label_file_already_checked_file":`Os arquivos {CheckedWork} foram selecionados, até 10 arquivos podem ser adicionados de cada vez`,
"vue_label_hidden_record_count":`Esconder a contagem de registros`,
"UG_product_01":`Listar produtos/serviços`,
"label.tabpage.clearoptionsz":`Opções avançadas claras`,
"label.partnercloud.num.overstep":`O número máximo de nuvens de parceiros excedeu.`,
"label.tianyancha.businessverify.msg8":`Atualmente, esta função só apóia a consulta a empresas registradas para negócios na China continental, e tem certo atraso.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Insight de chumbo`,
"label.emailtocloudcc.email":`Email`,
"vue_label_pool_highcost":`Alto custo do produto`,
"label.callcenter.enterprise.configuration":`Por favor, copie o par chave na Interconexão do Sistema de Configuração Empresarial no sistema da Tianrun`,
"label.view.edit.search.prompt":`Por favor, digite as palavras-chave`,
"label.ems.sms":`Envie um texto`,
"label.emailobject.list.new":`Compor`,
"label.salescloud.forenableteamsales":`Habilitar a equipe de vendas`,
"pagecreator.systemstyle.funcpath":`/ construtor / biblioteca de estilo de marca`,
"label.partnerCloud.basicSetting.domain":`O domínio de primeiro nível não pode estar vazio`,
"label.projectManagement.Posttask":`Pós-tarefa`,
"label.tianyancha.businessverify":`Permitir a verificação de dados comerciais`,
"label.tianyancha.h5.info":`Informações básicas`,
"september":`Setembro`,
"chatter.poll.option9":`Escolha 9`,
"label.department.firstpage":`É a primeira página`,
"label.reportsSubscriptionPage.condition.button":`Adicionar Condição`,
"label.exchange.sync.state.task":`Tarefas`,
"pagecreator.layout.button.splitall":`Dividir tudo`,
"vue_label_calendar_please_select_the_start":`Favor selecionar o campo para começar`,
"label.tab.message.failtogettop":`Falha em obter a aba superior`,
"label.sharerule.organizationscopesetshare":`Padrões de organização`,
"label.delete.rules":`Eliminar regras`,
"label.recordtype.tabname.detail":`Clique em "Editar" para alterar as propriedades deste tipo de registro. Selecione os valores disponíveis da lista de opções para este tipo de registro, clicando no link editar na lista de valores da lista de opções.`,
"label.knowledge.setting.hint.ten":`Incerto do modo de organização? Não há problema. Você pode executar mais tarde.`,
"vue_label_norm_undone":`Esta operação não pode ser retirada`,
"label.trigger.line":`linha:`,
"lable.info.queue.reason":`Motivo para se tornar um membro`,
"label.validate.function.funcExplain.HOUR":`Reutrn Retorna hora do dia (dos campos de data/hora), variando de 0 -11`,
"label.update.document.content":`motificou o conteúdo do documento`,
"lable.Existing.template":`Modelos disponíveis`,
"label.summaryreport.step3":`Passo 3 Selecione o método de agrupamento de dados resumidos`,
"label.emailmerge.list.filetype":`Tipo de documento`,
"label.customfields.helptext.tip":`O texto é exibido na página de detalhes e editar página quando o usuário paira sobre o ícone de informação próximo a este campo.`,
"label.setting.intergrationlist.description":`As integrações CloudCC permitem visualizar e compartilhar dados entre aplicações comerciais sem sair de seu CRM. Algumas das integrações, como QuickBooks e Zapier, requerem permissões para torná-las disponíveis a seus usuários. Outras integrações, como o Gmail, o Outlook pode ser configurado por cada usuário individual em sua própria conta.`,
"component_milestones_label_title":`Marco histórico`,
"label.custom.AntiRevocation":`Cancelar Desfazer`,
"label.mobile.app.new.task":`Permitir a criação de novas tarefas e eventos em aplicativos móveis`,
"vue_label_opportunity_related_chooseproduct":`Escolha pelo menos um produto`,
"label.standardguest":`Convidado padrão`,
"label.icon.125":`Instrumento`,
"label.skipsomeset":`Como este é o Jump Start Wizard, o CloudCC escolhe automaticamente algumas configurações para você.`,
"label.forecast.shrepage.fmanager":`Gerente de Previsões`,
"label.mobile.quickcreate.default.work":`Escritório`,
"label.projectManagement.nodata.team.members":`Não consigo encontrar o membro do meu projeto`,
"label_social_media_account_settings":`Configuração de conta de mídia social`,
"UG.quota.05":`Bisync com Oportunidades`,
"label.partner.workspace.tab.selectedoption":`Abas selecionadas`,
"front-kefu-moudle-v1-clientID-reinput":`Por favor, digite clientID`,
"label.mobile.home.page.contract.value":`Montante esperado do contrato`,
"december":`Dezembro`,
"label.campagin.roi.dcrs":`Presença`,
"label.currency.edits":`Edição de moeda`,
"label.currency.company":`Moeda Corporativa`,
"label.customfields.newformula.nogrammererror":`Sem erros de sintaxe nos campos ou funções de fusão.`,
"label.version.nonsupport.api":`O Interfate API não é suportado temporariamente.`,
"label.data.file.i.title.num2":`2. Recomenda-se que os dados sejam exportados quando os dados forem importados, para que o documento de exportação seja usado como modelo para recolher os dados a serem importados, e depois importar. (Se os dados importados contiverem uma vírgula, substitua-a pelo símbolo @).`,
"front-console-conversation-title":`Avaliação de serviços`,
"front-kefu-moudle-call":`Ligue para`,
"vue_label_systemSettings_pagefooter":`Configuração do rodapé`,
"label.newRule.successfully.added":`Novas regras acrescentadas com sucesso.`,
"label.trigger.direction.for.use":`Instruções para Acionadores de Plataforma [Versão 2.0]`,
"label.instrumentPanel.maxLabelname":`Este valor deve ser maior que o valor mínimo, o valor do ponto de parada 1 e o valor do ponto de parada 2.`,
"label.same.month.report":`Relatório YoY e MoM`,
"label.knowledge.language.american":`Americano`,
"label.paging.totalof":`Um total de {0}`,
"label.tianyancha.businessverify.enable.error":`Para saber se a verificação dos dados comerciais está habilitada falha, favor contatar o administrador do sistema!`,
"vue_label_commonobjects_detail_email_template":`Use o modelo de e-mail`,
"message.error.save.failed":`Salvar failed！`,
"advancedoptions":`Adicionar Lógica de Filtro...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Favor selecionar o layout e o tipo de registro`,
"label.sendemail.recycle.operatesuccess":`você esvaziou com sucesso sua lixeira de reciclagem, apagando os dados de tamanho #.`,
"J":`Área de texto (Longo)`,
"message.validation.isnotmail":`Por favor, digite o endereço de e-mail inválido.`,
"label.timetrigger.before.lasttime":`1 hora antes da Data da Última Modificação`,
"label.tabpage.arecordtypez":`Tipo de registro disponível`,
"label.reportoption":`Opções de relatórios`,
"pagecreator.button.next":`Próximo passo`,
"assetbom.transferowner.notpermission":`Você não tem autoridade para transferir a lista técnica de bens. Favor entrar em contato com o administrador.`,
"label.toptitle.lightning":`Relâmpago`,
"label.copy.target":`Valor do Indicador Clone`,
"label.productsales.oppor.approach":`Oportunidades iminentes`,
"label.email.template.select":`Por favor, selecione um modelo de e-mail.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`O limite inferior para editar cada nível de desconto é necessário.`,
"label.tabularreport.step3":`Passo3 Definir a ordem das colunas no relatório`,
"label.multilang.cchttpservice.signin":`Prezado {0}, seu convidado {1} de {2} foi registrado com sucesso.`,
"label.appexchange.uninstallpage.message3":`Apagar permanentemente todos os dados dos objetos personalizados deste pacote`,
"label_tabpage_ownedz":`Totalmente`,
"label.tabularreport.2018.step2":`Passo 2 Selecione os critérios do relatório`,
"label.object":`Objeto`,
"template.report.contracted.customers":`Análise da Indústria de Contas Contratadas`,
"label.field.remark3":`Note que a exclusão de um campo personalizado excluirá quaisquer filtros que utilizem o campo personalizado. Também pode alterar o resultado das Regras de Atribuição ou Escalonamento que se baseiam nos dados do campo personalizado.`,
"label.eventview.issms":`Aviso SMS`,
"label.knowledge.language.brazilian":`Português (Brasil)`,
"vue_label_norm_viewfilter":`Aplique um filtro`,
"label.forecast.settings.qijian":`Período de Previsão`,
"label.startuploadfile.step.intruduce":`Clique em "Selecionar arquivo" para encontrar o arquivo e exibir os arquivos selecionados na região inferior.`,
"label.smstemplate":`Modelo de SMS`,
"vue_label_chatter_no_permission":`Você não tem acesso para ver este arquivo`,
"label.callcenter.Incorrect.data.filling":`Há um erro no preenchimento dos dados`,
"label.tag.search.button":`Busca por tags`,
"label.multiplyselectoptions":`Marque as opções da caixa`,
"lable.outlook.detail.mutual":`Bidirectional Sync`,
"label.workflow.estimatecondition1":`criado, e a qualquer momento é editado para posteriormente atender aos critérios`,
"label.validate.globalvariable.user.profileId":`Identificação do perfil`,
"UG.Campaign.003":`Criar uma campanha`,
"label.validate.function.funcExplain.ISNULL":`A expressão é nula e retorna VERDADEIRO, caso contrário, ela contém um valor e retorna FALSO.`,
"label.setting.intergrationlist.status0":`STATUS DE INTEGRAÇÃO`,
"label.copy_error":`Falha na cópia`,
"label.connectOtherNone":`O objeto selecionado não tem mais nenhum objeto relatável.`,
"label.bmap.beijing":`Pequim`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob é excluído. Por favor, conectese novamente!`,
"label.wei.pollsubject":`Votação Assunto`,
"APPIntegration_Social_twittererror":`Você deve digitar uma URL válida para o twitter.com`,
"label.appupload.install.apicannotuse":`O nome api ainda não está disponível`,
"label.returntolist":`Voltar à lista`,
"label.translation.start2":`Selecione um componente de configuração.`,
"lable.edit.queue.alter":`Selecione os objetos que você deseja atribuir a esta fila.`,
"label.campaign.channel.step3":`Passo3: Selecionar campos a serem exibidos na página de registro do canal de marketing`,
"label.data.newtemplate.e.seltype":`Selecione o método de exportação de dados`,
"front-kefu-moudle-hangup":`Desligar`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Os administradores e os gerentes de previsão podem compartilhar esta previsão`,
"label.knowledgebase.mark.as.new.version":`Marcar como novo lançamento`,
"label.conditiontag.lookup":`Consulta`,
"label.import.page3.importsucceed":`Importar com sucesso`,
"label.stdashbord.xsld.condtion":`Configurações de condição`,
"label_emailtocloudcc_redmessage10":`As informações expiraram, faça o login novamente.`,
"label.event.moveup.1hour":`1 hora à frente`,
"label.chat.topic.page.add.favorite":`Salvar como marcador de página do CCChat`,
"label.icon.88":`Assessoria`,
"page_404_label_noresource":`Desculpe, o recurso que você quer acessar não existe.`,
"label.quickbooks.refresh":`Atualização`,
"front-kefu-moudle-which-getphone-case":`Regras para a criação de casos após responder a uma chamada`,
"label.objecttab.edit":`Aba Objeto Editar`,
"label.data.file.the.trigger":`Executar o gatilho`,
"frame.personinfo.label.personimage":`Foto do perfil`,
"label_tabpage_turnoffsz":`Desligar - convertido`,
"label.sendmail.batch.chose":`E-mail em massa: Selecione Destinatários`,
"label.data.downpage.i_title":`Etapas de importação de dados:`,
"label.recycle.clearconfirm":`Você tem certeza?`,
"chatter.using":`Este usuário`,
"label.batchadd.newbatchpage.list":`Lista de dados de adição em massa`,
"pagecreator.systemstyle.button.new":`Novo estilo`,
"label.notification.serviceappointment.changestate":`Status de {1}{0} alterado para{2}{3}.`,
"label.weixin.weipollname":`Nome do Micro Voto`,
"label.tabpage.skip":`Pular para`,
"label.edit.field":`Campos de edição`,
"label.edit.new.rule":`Editar Regras de Geração`,
"label.approved.receiveApprovalEmail":`Receber e-mails de solicitação de aprovação`,
"label.dashboard.refreshNow":`Refrescar agora`,
"label.lookup.introduce":`Por favor, digite pelo menos 1 caractere para pesquisa fuzzy.`,
"homepage.components.newdes":`Certifique-se de que o código HTML inserido abaixo seja válido e bem formado. A escrita de código HTML inadequado em um componente ay faz com que toda a guia da página inicial seja exibida incorretamente.`,
"label.role.giveuserrole":`Atribuir funções aos usuários`,
"lable.opppdt.selPbk.subtitle":`Livro de preços`,
"setup_mainpage_label_welcome19":`Instruções:  Clique no menu do lado esquerdo desta página → Manage Settings → Manage Users → Users, Roles, Profiles`,
"setup.mainpage.label.welcome22":`Instruções: Clique no menu do lado esquerdo desta página → Manage Settings → Newsletter Template → Email Template.`,
"label.tianyancha.h5.zipcode":`Código Postal`,
"label_tabpage_allapplications":`Todas as aplicações`,
"label.chatter.like":`Como`,
"label.licence.noremainder":`Número insuficiente de licenças`,
"lable.outlook.edit.dataset":`Configurações de dados`,
"D":`Data`,
"label.detail":`Leia`,
"label.globaloperation.operationtype.custom_page":`Página personalizada`,
"label.addattachment.down":`Faça o download do arquivo`,
"label.data.exportall.all_btn":`Exportar todos os dados`,
"label.recordtypeselect.current":`Tipo de registro atual`,
"label.tabpage.entercusnamez":`Por favor, digite o nome do cliente`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Semana seguinte`,
"vue_label_report_everyday":`Todos os dias`,
"label.weixin.broadcasting":`Enviando...`,
"label.input.search.string":`Por favor, digite a seqüência de busca`,
"label.picandreporttype":`Tipo de gráfico`,
"label.setmulti":`Transferência múltipla`,
"label.visualpage.component.t":`Como utilizar componentes?`,
"label.knowledge.designate":`Somente artigo de conhecimento com status de Rascunho pode ser atribuído.`,
"label.enable.barcode.only":`Ativar somente código de barras`,
"vue_label_commonobjects_detail_a_group_strategy":`Estes dados carecem de proprietário e não podem criar uma equipe`,
"setup.layout.group.button":`Botões`,
"label.mini.layout.remark":`é o layout usado na janela que paira sobre a página.`,
"setup.mainpage.label.welcome3":`A criação de formulários na plataforma CloudCC baseia-se em bancos de dados personalizados (objeto), objetos definidos pelo usuário são tabelas de banco de dados que armazenam dados específicos de sua organização. As relações tabela a tabela podem ser facilmente estabelecidas sem qualquer desenvolvimento de programa.`,
"label.knowledge.draft.status":`O status dos artigos de pós-conhecimento deve ser Rascunho!`,
"label.manageAll.sel.one1":`Itens a serem aprovados`,
"label.campagin.roi.bhydkhywjh":`Quantidade de Oportunidades Fechadas`,
"label_partner_template_thumbnail":`Miniatura`,
"label.loginip.setup":`Login Gama IP`,
"label.data.downpage.e.title.e.btn":`Ir para a página de exportação e começar a exportar`,
"vue_label_appstore_project_management":`Gerenciamento de projetos`,
"assetbom.delete.notpermission":`Você não tem autoridade para excluir a lista técnica de bens. Favor entrar em contato com o administrador.`,
"vue.dashboard.setdrill.inThe":`sujeito a`,
"label.mobile.more.savephoto":`Salvar foto`,
"label.customerinfo.PageTriggerFag":`Sincronia:`,
"label.commonobjects.Nopermission":`Desculpe, você não tem permissão para editar estes dados, por favor entre em contato com o administrador do sistema.`,
"label.searchlayout.opperationtab.xsldfield":`Os campos exibidos quando você clica no link do Funil de Vendas na página inicial da guia de oportunidades.`,
"label.emailsync.form.disconnect":`Cancelar Conncet`,
"label.document.nofile.upload":`Nenhum upload de arquivo.`,
"label.appointmentpage.wizard.subtitle3-3":`Telefone`,
"message.custom.field.donotdelete":`O campo é usado e não pode ser apagado.`,
"chatter.using0":`{0}ms tem sido usado neste momento`,
"label.tabpage.multiple":`Múltipla escolha`,
"label.attendance.setting.sy.alert":`Você deve selecionar os usuários adequados para o atendimento.`,
"label.refuse":`Rejeitar`,
"label.log.button":`busca por nome de usuário`,
"component_chatter_link_label_title":`Link`,
"template.report.contract.collection":`Pagamento do contrato`,
"label.campaignmember.selectmember.step1":`Passo 1 Selecione a campanha e o status dos membros da campanha`,
"label.datamanage.warn.owner":`Atenção: se você continuar esta importação, todos os registros serão importados com você como o proprietário do registro.`,
"label.a.b":`Relacionamento de A a B`,
"label.app.step3.homeisfrist":`A página inicial deve ser a primeira.`,
"UG_Lead_003":`Social`,
"label.partner.workspace.member.choice":`Selecione o perfil`,
"lable.outlook.detail.emaping":`Campos de eventos do mapa`,
"label.service.appointmentList.gantt.chart.shows":`Data da exposição de Gantt`,
"label.mr.caption.account.result":`Encontrar duplicatas e fundir: Resultados para consulta de duplicatas de contas`,
"vue_label_chatter_approve_members_join":`Aprovar membros para se juntarem ao grupo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Dia`,
"pagecreator.systemstyle.label.modifycolor":`Editar cor`,
"label.tabpage.yesz":`Sim`,
"label.fieldtoolongmessage":`O campo excede o limite`,
"lable.account.year.name":`Nome do ano fiscal`,
"label.mini.layout":`Disposição do Hover`,
"label.icon.97":`Ensinando`,
"vue_label_chat_smart_assistant":`Assistente inteligente`,
"label.marketingmanagementuser":`Usuário de Marketing`,
"label_emailtocloudcc_description2":`Conecte seu e-mail`,
"label.campaign.channel.input.name":`1.Por favor, digite o nome do canal de marketing`,
"UG.homepage.007":`Do envio de e-mails de acompanhamento à automatização de campanhas de vendas, da criação de fluxos de trabalho utilizando nossa tecnologia Blueprint ao acionamento de macros personalizadas, automatizar tarefas diárias e focar mais na construção de relacionamentos.`,
"label.share":`Compartilhando`,
"label.step2.total6":`Etapa 2 de 6`,
"label.sendemail.chat.addComentspraise":`Prezado #nome:{\i1}olá! #userName respondeu ao micropost que você gostou`,
"label.icon.20":`Arquivo`,
"label.service.gantt.absenteeism":`Absenteísmo`,
"message.error.color.nagatice":`O número de páginas atuais não pode ser negativo.`,
"chatter.group.applyToJoin":`Solicite a adesão`,
"pagecreator_layout_message_delete":`Você apaga o layout selecionado atualmente?`,
"label.multilang.viewlist.count":`Um total de {0} records：`,
"message.notdesable.type":`Este tipo de registro não pode ser excluído porque o perfil a seguir usa este tipo de registro como valor padrão.`,
"label.standard.time":`Tempo padrão`,
"label_chatter_newpost":`Último posto`,
"front-epwechat-module-v1-binding":`Bind WeCom`,
"label.recent":`Recentes`,
"label.globaloperation.createfeeditem":`Criar um projeto de resumo`,
"label_partner_common_roleNum":`Número de funções`,
"front-template-V1-quikSearch":`Digite o nome do campo e encontre`,
"label_tabpage_haschangedz":`Este chumbo foi convertido`,
"label.service.work.order.line":`Itens da ordem de trabalho`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Configurações gerais`,
"label.event.moveup.15minutes":`15 minutos à frente`,
"vue_label_all_selected_objects":`Todos`,
"label.visualpage.an.inline.style.relatedlist":`Incorporar tipo de página personalizada às listas relacionadas`,
"label.umeng.approval.approvaling":`#o solicitante pede aprovação para #obj #objnome do proprietário #objnome do proprietário`,
"lable.SalesCommitmentKanBan.digital":`Dígito`,
"label.appupload.img.max.size":`A imagem que você carregou é muito grande, o tamanho máximo da imagem não deve exceder 20K, por favor, carregue novamente.`,
"vue_label_normal_top":`Top`,
"label.knowledge.language.traditional":`Chinês Tradicional`,
"homepage.layout.edit":`Editar layout de casa`,
"label.campagin.qrcode":`Código QR Campagin`,
"label.emailmerge.merge.emailmerge":`Fusão de e-mails`,
"label.icon.18":`Relógio`,
"vue_label_homepage_taskview":`Visão da tarefa`,
"label.search.related.record":`Não foram encontrados registros.`,
"label.report.reports":`Relatórios`,
"label.appointment.wizard.subtitle4-3-2":`15 min`,
"label.forecast.condition":`Critérios de Previsões`,
"label.westem.indonesia.time":`Hora da Indonésia Ocidental`,
"front-epwechat-module-v1-callback-desc":`Copie as seguintes informações para o backend da WeCom.`,
"label.version.group":`Edição em equipe`,
"label.allReportType":`Todas as fontes de dados de relatórios personalizados`,
"label.trigger.lastmodifydate":`Data da última modificação`,
"message.layout.unique.sectionfield":`A restrição de singularidade do campo no layout da página foi violada. Por favor, verifique e salve-o novamente.`,
"vue_label_systemSettings_mobelbottonsetting":`Configuração do menu inferior para aplicação móvel`,
"label.recordtype.selectonefield":`Selecione um campo pelo menos que você deseja adicionar`,
"label.notification.group1":`【申请人】 está se candidatando para fazer parte de seu grupo público`,
"component_todaytask_label_title":`Hoje`,
"label.assignment.setup.list.description":`Atribuir automaticamente leads aos usuários com base em critérios definidos por você. Você pode criar várias regras com condições diferentes.`,
"label.project.resource.data":`Este recurso de serviço foi designado para uma consulta de serviço, por favor não adicione repetidamente.`,
"label.emailmerge.newtemplate.file":`arquivo`,
"label.notification.task1":`【分配人】 lhe designou uma tarefa`,
"label.ServiceCloud.Overlapping":`Despachos de sobreposição de displays`,
"label.globalselect.used":`A posição do uso do campo`,
"setup_layout_button_layoutprop":`Adequações`,
"label.quickbooks.retrivingdata":`Recuperando dados...`,
"component.button.ok":`Confirme`,
"message.pleaseinputformula":`Favor inserir a fórmula`,
"label.h5.whatifollow":`O que eu sigo`,
"label.new.crew.target":`Novo objetivo de pessoal`,
"label_chatter_task":`Tarefa`,
"label.knowledge.setting.data.four":`Um máximo de {count} grupos categori pode ser selecionado.`,
"label.rule.not.enabled":``,
"label_in_scope":`Dentro da faixa`,
"label.partnerCloud.orderingPlatform.bundle":`Pacote`,
"label.emailtocloudcc.redmessage10":`As informações expiraram, faça o login novamente.`,
"label.knowledgebase.data.assignment.succeeded":`{a} dados atribuídos com sucesso`,
"vue_label_commonobjects_view_nokanban":`Ainda não foi criada uma visão kanban`,
"label.knowledgebase.article.cancelled.attaching.case":`O artigo {nome} foi cancelado para anexar a case！`,
"label.brief":`Sumário`,
"label.version.sum.app":`aplicações`,
"label.commoninfo":`Informações comuns`,
"vue_label_SMS_nodata":`Sem dados`,
"label.icon.153":`Informações`,
"label.conditiontag.lookup.false":`FALSO`,
"label.emailobject.view.unread":`E-mails não lidos`,
"label.staticresource.useful":`Onde isso é usado?`,
"label.ems.connect.test":`Teste`,
"vue_label_chat_group_assistant_notification":`Notificação de assistente de grupo`,
"label.multipleactivity.total":`Um total de`,
"vue_label_report_addtocomponentlibrary":`Adicionar à biblioteca de componentes`,
"font-evaluate-module-v1-following-personnel":`Notificar os usuários seguintes ao receber avaliação inferior a 3:`,
"label.setup.mobile.bottombutton.change.fail":`Falha na mudança`,
"front-epwechat-module-v1-unbound-item5":`e os dados não podem ser recuperados, você tem certeza de que vai destravar?`,
"label.customerinfo.smsUid":`SMS Gateway UID`,
"label.list.isOpenApprovalQueue":`Ativar Fila de Aprovação (não disponível em Aprovador de Seleção Manual)`,
"label.leadscore.setup.scorenumber":`Tempo(s)`,
"label.workflow.selectobj.introduce":`Selecione o objeto ao qual se aplica esta regra de fluxo de trabalho.`,
"label.visualpage.label.for.example":`Etiquetas de página, tais como:`,
"label.appointmentdetail.wizard.title17":`Plano de quinta-feira`,
"label.projectManagement.timeFrame":`A hora de início e de término da tarefa deve estar dentro do intervalo de tempo do marco miliário.`,
"lable.product.pricebooks.list":`O Price Book é uma lista de produtos com um preço especial e uma moeda definida. O Livro de Preços pode ser definido para várias moedas. Ao inserir um produto em um livro de preços, as oportunidades ou cotações só podem incluir produtos em um único livro de preços. Para editar o produto no livro de preços, clique no nome do livro de preços.`,
"font-trade-module-v1-delete-invoice":`Verificar a fatura`,
"vue_label_salesadvance_winamount":`Montante bruto de Won`,
"component.salesperformance.label.nopermission":`Para visualizar os dados relacionados às oportunidades de negócios, entre em contato com o administrador de seu sistema.`,
"vue_label_report_formatreport_desc":`Exportar o relatório com cabeçalhos de relatórios, grupos e configurações de filtros.`,
"label.enable.qrcode.only":`Ativar somente o código QR`,
"label.smstemplate.edit":`Editar modelo de SMS`,
"label.qrcodeSetting.detailed.information":`O código QR pode armazenar mais dados do que o código de barras e não é necessária a leitura linear. Portanto, o código QR é amplamente aplicado, incluindo rastreamento de produtos, identificação de itens, gerenciamento de documentação e marketing, etc.`,
"label.event.moveup.1week":`1 semana pela frente`,
"label.customize.memory.function.sorting.disable":`Desativar memória de ordenação de cabeçalhos`,
"label.icon.195":`Banheira`,
"label.compact.layout.assign":`Atribuição de layout de informações-chave`,
"label.icon.183":`Casa`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integrar o batepapo online da Easemob para fornecer um serviço SaaS mais abrangente.`,
"label.mycontact":`Meus Contatos`,
"label.tabularreport.2018.step3":`Passo 3 Selecione os critérios do relatório`,
"chatter.group.uploadGroupPicture":`Carregar foto do grupo`,
"label.total.forecast.setup":` previsão para-primeiro e set para-ser`,
"label.weixin.group.description":`Nota`,
"label.edit_emailfooter":`Editar Rodapé de email`,
"label.ems.create":`Novo`,
"label.weixin.optionseven":`Escolha 7`,
"font-evaluate-module-v1-continue-work":`Sua avaliação nos encorajou! Continuaremos a nos esforçar para fazer melhor!`,
"label.close.multilingual":`Desativar Multilíngua`,
"component.chatter.post.button.user":`Acrescentar pessoas`,
"label.use_QRcode":`Use o Código QR`,
"label.operatedata.exportsuc":`A exportação é um sucesso. Por favor, veja o e-mail para obter o link para download. Por favor, baixe seus arquivos exportados dentro de 48 horas. É recomendado que você apague o e-mail que contém o link de download de seus arquivos exportados.`,
"label.page.step2.define.content":`Passo 2 Definir conteúdo e propriedades de exibição`,
"label_tabpage_groupingitem":`Item de agrupamento`,
"label.customfields.placeholder":`Preencha a amostra`,
"vue_label_commonobjects_detail_enter_subject":`Favor entrar o tema`,
"label.multilang.workflow.everyotherdayinmonth":`{1} dias a cada {0} mês`,
"label.knowledgebase.data.archiving.failed":`{a} o arquivo de dados falhou`,
"vue_label_notice_nopermission_view":`Lamentamos que você não tenha acesso para ver este registro, por favor entre em contato com o administrador.`,
"vue_label_calendar_calendar_view":`Vista do calendário`,
"lable.outlook.edit.des":`Se um contato Exchange corresponder a vários contatos do CloudCC.com, sincronize-o com um contato do CloudCC.com que atenda aos seguintes critérios.`,
"label.custom.NextCQ":`Próximo CQ`,
"label.emailsync.form.stutas":`Status`,
"label.nameandintro":`Nome e Descrição`,
"label.dashboardSetup.showdw":`Unidade de exibição`,
"label.tianyancha.actualcapital":`Capital recebido`,
"front-kefu-moudle-info-delete-calluser":`As informações foram modificadas, favor entrar em contato com o administrador`,
"label.emailobject.list.all":`Todos`,
"label.campaign.channel.step7.send":`Favor selecionar os usuários para receber o e-mail`,
"label.formulafield.type":`Tipo de Retorno de Fórmula`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Quinta-feira`,
"label.chosesubject.eat":`Jantar programado`,
"label.back":`Voltar`,
"label.h5.allcompany":`Todos os postos de nuvem`,
"label.location.display.type.digital":`Digital`,
"label.datamanage.error.csv":`Formato de arquivo inválido, o sistema suporta apenas o formato CSV comum, por favor tente novamente.`,
"label.emailobject.mark":`Marcar`,
"setup_mainpage_label_welcome9":`Os usuários podem realizar a exibição de classificação e ajuste de layout de todos os elementos da página e a configuração de campos somente leitura e campos obrigatórios dos campos da página, arrastando e soltando o mouse sem desenvolvimento de código.`,
"label.icon.56":`Instrumento de medição`,
"label.forecast.edit.fwcd":`Comprimento de alcance`,
"vue_label_email_Please_select_related_items_first":`Por favor, selecione primeiro os itens relacionados`,
"label.icon.87":`Livro`,
"label.knowledgebase.recovery.was.successful":`A recuperação foi um sucesso`,
"label.emailobject.emaildetail.promptcontent":`Você tem certeza de que quer apagar isto email？`,
"label.delete.role":`Eliminar funções`,
"label.multiselect":`Lista de picking (Multi-Select)`,
"label.customerinfo.mailisnull":`Nenhum endereço de e-mail da empresa foi configurado.`,
"label.waitforamoment":`Carregamento de página, por favor aguarde...`,
"lable.edit.queue.tip":`Digite o nome da fila e o endereço de e-mail a ser usado ao enviar notificações (por exemplo, quando um caso foi colocado na fila). O endereço de e-mail pode ser para um indivíduo ou para uma lista de distribuição. Quando um objeto é atribuído a uma fila, somente os membros da fila serão notificados.`,
"lable.custom.y.d":`Esta página permite que você defina um registro anual personalizado. As datas para o ano personalizado serão geradas com base nas escolhas que você fizer abaixo.`,
"chatter.feed.content.user.searchbutton":`Busca`,
"label.data.downpage.i.list.desc3":`Os usuários podem ver o motivo da importação falhou na última coluna do arquivo após os downloads.`,
"label.tag.manage.createdby":`Criado por`,
"label.h5.similar.opportunity.last.months3":`Últimos 3 meses`,
"chatter.group.members":`Membros`,
"label.knowledgebase.data.translation.failed":`Traduzir {a] os dados falharam`,
"label.log.look":`Verifique as dicas de auditoria de configurações`,
"label.service.gantt.week.timescale":`Escala de tempo na visão da semana:`,
"label.userLicence":`Licença do usuário`,
"label.file.library.managemembers.permission":`Acesse`,
"label_emailtocloudcc_name":`Nome`,
"label.mr.mrSuccess":`Fusão completa`,
"vue_label_commonobject_view_notice_selectadd":`Favor selecionar os dados a serem acrescentados`,
"vue_label_commonobjects_detail_level":`Nível`,
"CloudCCCRM_ST_Info_TypeIn_001":`Favor entrar`,
"label_chatter_list":`Lista`,
"label_tabpage_optionsz":`Opções`,
"UG_homepage_008":`Compreender a situação atual dos negócios (briefings de vendas, quadros de liderança, funis de vendas, etc.), visualizar oportunidades de negócios que podem ser problemáticas, prever o desempenho futuro, aceitar e designar questões importantes em tempo hábil, e tomar decisões informadas.`,
"label.myselfdashboard":`Meus Painéis de Controle Pessoal`,
"label.globaloperation.operationtype.record_phone":`Telefone para gravação`,
"label.field.standard":`Campos padrão`,
"label.changemydisplay.appedit.check":`Sobregravar configurações pessoais personalizadas de aplicativos personalizados`,
"label.tianyancha.h5.legalpersonnames":`Representante legal`,
"label.tabpage.sorttypez":`Tipo de ordenação`,
"label.newdashboard.folder":`Novo Dashboard Folder`,
"label.campaign.channel.step6":`Passo 6: Gerar página de registro do canal de marketing`,
"label.ems.composeemail":`Enviar e-mail`,
"label.app.step4.tabcanuse":`Abas disponíveis`,
"label.sendmail.batch":`Email em massa`,
"label.process.execute.title":`Pendente`,
"lable.outlook.detail.lastup":`Última Atualização`,
"label_emailtocloudcc_delete":`Excluir`,
"lable.opppdt.selPdt.leastone":`Favor selecionar pelo menos uma fila`,
"label.customfields.new.step2.opration.exid":`Identificação externa`,
"label.assignment.setup.newrule.description":`Digite o nome da regra e selecione a caixa de seleção habilitada para usar esta regra para atribuição automática. A ativação desta regra irá desativar a regra de atribuição atual.`,
"label.campaign.channel.input.to.isactivity":`7.Active o canal de marketing`,
"label.document.return":`Voltar aos documentos`,
"label.data.downpage.i_title.num5":`5. Please check the accuracy of the data.`,
"label.taskinto":`As tarefas são os modelos que as regras de fluxo de trabalho utilizam ao atribuir tarefas automaticamente aos usuários.`,
"label.customfields.formula.textexample":`Nome completo = Sobrenome`,
"label.appointmentpage.wizard.subtitle1-1":`Semana seguinte`,
"label.weixin.radio":`Eleição única`,
"vue_label_file_replace_reason_check":`Motivo da substituição (opcional)`,
"label.sendemail.recycle.operateexception":`esvaziar seu cesto de reciclagem falhou, por favor, tente novamente.`,
"label.vlidaterule.formulaerror":`Exibir um erro se o Desconto for superior a 30%`,
"vue_label_campaign_existing_member_status":`Manter o status de membro existente`,
"label.service.miniProgram.fillSlideshowName":`Favor preencher o nome do carrossel.`,
"label_partner_workspace_login_headerfooter":`Cabeçalho e Rodapé`,
"label.quickbooks.viewlist.total2":`Existem {0} estimativas para um valor total de {1}`,
"chatter.viewingResults":`Ver Resultados`,
"label_tabpage_allvisible":`Todos os usuários são visíveis`,
"label.quote":`Citações`,
"label.changemydisplay.list.des":`Personalize as abas de acordo com suas necessidades`,
"label.leadscore.notimes":`Não há mais tempo para marcar contatos`,
"label.icon.51":`Geração de energia`,
"component.assistant.label.title":`Assistente`,
"label.emailobject.emailsent":`Email Sent！`,
"label.group.nofile":`Nenhum arquivo foi enviado a este grupo.`,
"label.foldervisitlimit2":`Todos os usuários não podem acessar esta pasta`,
"label.dataoperate":`Operação de dados`,
"label.addattachment.size":`Tamanho`,
"label.not.double":`Não são permitidos valores duplicados.`,
"label.customfields.formula.number.tip":`Calcular um valor numérico.`,
"lable.opppdt.addpdt.table.description":`Descrição da linha`,
"label.sms.isactivity":`Ativo`,
"label.campaign.channel.input.owner":`4.Quem será o principal proprietário deste canal:`,
"label.visualpage.notfound.error":`Ocorreu um erro desconhecido, favor entrar em contato com o administrador.`,
"label.mr.title.button.group3":`registros`,
"label_tabpage_beginz":`Comece em`,
"label_tabpage_queue":`Fila`,
"label.tabpage.advancedscreening":`Filtro avançado`,
"nogreate":`menor ou igual`,
"chatter.fields":`Campos em`,
"button_partner_workspace_manage":`Administração`,
"label.partnerCloud.orderingPlatform.search":`Buscar produtos`,
"message.password.isnull":`Por favor, digite sua senha.`,
"label.fenbeitong.title":`Configuração do FenBeiTong`,
"label.salescloud.contactrole.message.chooseatleastone":`Por favor, selecione pelo menos um contato.`,
"label.knowledge.delete.election":`Erro ao excluir a seleção da categoria de dados`,
"front-console-status-hoided":`Colocação`,
"label.lastmodifydate":`Data da última modificação`,
"vue_label_chat_deleting_chat":`Após a exclusão, o histórico do bate-papo será apagado e removido da lista da Equipe. Ao receber uma nova mensagem, ela aparecerá novamente na lista de Equipe.`,
"label.timeframe":`Período de tempo`,
"UG.opportunity.002":`Defina seu ciclo de vendas, configure a etapa`,
"label.templates.merge":`Por favor, selecione os modelos a serem fundidos. Um máximo de 20 pode ser selecionado.`,
"label.generatepage.c2":`O comprimento máximo é 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 senhas lembradas`,
"button.partner.workspace.enable":`Habilitar a nuvem de parceiros`,
"vue_label_pool_nopool_notice":`Você ainda não aderiu a nenhum pool, entre em contato com o administrador para criar ou aderir a um pool.`,
"label.layout.required.field.select":`Campos obrigatórios selecionados`,
"label.loginhis.date":`Digite a data de início e a data final.`,
"vue_label_commonobjects_detail_and_overdue":`Próximos e Vencidos`,
"label_tabpage_advancedsearch":`Busca avançada`,
"label.custom.field.login.home.query":`Por favor, vá para a página inicial e veja os detalhes da tarefa.`,
"page":`Página`,
"label_tabpage_onlymevisible":`É visível apenas para mim`,
"label.weixin.optionfour":`Escolha 4`,
"label.confirm.to.remove":`Confirmar para remover`,
"label.event.moveup.30minutes":`30 minutos à frente`,
"label.mail.merge.template.finish":`Fundir os modelos de e-mail preenchidos`,
"label.multilang.currencylist.before":`Antes de {0}`,
"label.goback":`para ir para o anterior`,
"label.unknown.prefix":`Prefixo inválido, favor entrar novamente.`,
"lable.account.CurrentandPreviousCYt":`Atual e Anterior 2 CY`,
"label.product.dent":`Digite sua palavra-chave e critérios de filtragem, depois clique em Pesquisar para iniciar sua pesquisa. Clique em Mais filtros para usar mais de um filtro. Os resultados da pesquisa incluem todos os registros que correspondem tanto à sua palavra-chave como às entradas do filtro.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operação`,
"label.knowledge.setting.hint.eight":`Mantenha tudo em ordem!`,
"label.sso.saml.sp.idtype.fid":`Assertion contém o ID da Federação do Objeto do Usuário`,
"vue_label_chat_voice":`Voz`,
"label.config.pw":`Confirmar nova senha`,
"lable.newtabpage.closesearchresult":`Resultados da pesquisa de colapso`,
"lable.account.NextWeek":`Semana seguinte`,
"label.ems.username":`Nome de usuário (u)`,
"vue_label_email_emails_from_potential":`E-mails de leads e contatos em seu CRM, e e-mails contendo-os em destinatários, serão categorizados aqui`,
"lable.approval.shared":`Aprovação de participação`,
"label.tabpage.allz":`Todos`,
"label.file.uploadfiles":`Upload de arquivos`,
"label.emailobject.text":`Texto:`,
"label.version.allow.create":`Permitir criar novos`,
"label.empty.field":`O campo não pode estar vazio.`,
"label.emailsync.status.department":`Departamento`,
"label.pw.str":`5 caracteres`,
"label.attendance":`Participantes`,
"label_mobile_buttom_team":`Equipe`,
"label.campaignmember.main.addcontactdesc":`Acrescentar todos os contatos existentes a esta campanha`,
"label.search.result":`Resultados da busca`,
"label.weixin.activity.account":`Visitantes da atividade`,
"label_tabpage_clearoptionsz":`Opções avançadas claras`,
"UG.activity.01":`Como você rastreia seus registros para interagir com suas contas/equipas?`,
"serviceappointment.new.status.limit":`Falha na criação de um novo compromisso de serviço com status de programado ou despachado.`,
"label.notice.higher":`Enviar e-mail ao gerente`,
"label.passwordPolicy.setup.gletters":`caráter(es)`,
"label.data.exportsf.des":`Os arquivos exportados com sucesso serão automaticamente apagados após 48 horas de economia no derver.`,
"label.view.onlymecansee":`Visível apenas para<b> me</b>`,
"UG.Lead.005":`Caixa de correio`,
"label.umeng.approval.approvalfail":`submetido a faild.`,
"label.huanxinconfig.clientid.lost":`o cliente não pode estar vazio`,
"label.campaignmember.main.updatecontactstatus":`Atualização - Contatos Existentes`,
"component_chatter_button_delete":`Excluir`,
"label.weixin.no.pending.projects.qin":`Nenhum item a aprovar.`,
"front-electronic-signature-auto-fill-field":`Campo de preenchimento automático`,
"message.resetpw":`Você tem certeza de que deseja redefinir sua senha?`,
"label.service.ganttBaiduMap.service.resourname":`Nome do Serviço de Recursos`,
"vue_label_pricebook_deleted":`Lista de preços excluída`,
"label.icon.193":`Banheira`,
"label.validate.function.funcFormat.NOT":`NÃO(lógico)`,
"label.address.city":`Cidade`,
"label.pc.ui.2018.searchs":`PESQUISA...`,
"label.yard":`Código de convite`,
"label.data.downpage.i_title.btn":`Vá para a página de importação e comece a importar`,
"label.useablereceivers":`Recipientes disponíveis`,
"label.cloudccsite.name.length":`Permite que os usuários digitem até 255 caracteres`,
"label.secrecy":`Confidencial`,
"label.campagin.roi.ydkhywjhzz":`Quantidade Total de Oportunidades Fechadas e Vencidas`,
"vue_label_report_conditiondesc_one":`Exceto para assinatura, você pode estabelecer condições para este relatório. Você será notificado se todas as condições forem cumpridas. Isto é opcional.`,
"label.datamanage.select.contactfield":`(Selecione o campo correspondente ao contato de importação)`,
"label.emailtocloudcc.filed.action":`Ação`,
"label.smstemplate.new":`Novo modelo de SMS`,
"label.mobile.side.tab.app":`Apps`,
"label.icon.118":`Relógio`,
"label.customfields.selectcontainfieldlayout.tip":`O campo será adicionado como o último campo na primeira seção de duas colunas destes layouts de página. O campo não aparecerá em nenhuma página se você não selecionar um layout. Para mudar a localização deste campo na página, você precisará personalizar o layout da página.`,
"Lead_Homepage_Tools_BatchScoring":`Pontuação do Lote`,
"lable.quote.syncing.quote":`Citações`,
"pagecreator.button.preview":`Pré-visualização`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Nenhum registro recente`,
"lable.info.queue.showallmember":`Ver Membros da Fila`,
"label.multilang.campaign.selelctmember.desc":`Selecione uma visão e selecione o membro a ser adicionado à campanha. O status de membro é {0}.`,
"label.notification.ccchat3":`【评论用户名】commented em seu posto.`,
"UG.product.03":`Manual de preços com suporte de várias moedas`,
"label.sso.saml.idp.config.pksize":`Tamanho da chave`,
"label.defineCustomReportType":`Definir a fonte de dados do relatório personalizado`,
"component.timeline.button.filter":`Filtro`,
"label.mr.nextGroup":`Pule o grupo e vá para o próximo grupo`,
"label.quote.sprdz":`Endereço para faturamento`,
"label.total.refuse.forecast.have.priority":`Recusar todas as prioridades da Previsão`,
"lable.product.peep":`Por favor, digite um preço válido.`,
"label.file.who.can.access":`Quem pode acessar`,
"label.page.last":`Última página`,
"label.icon.180":`Pessoas`,
"font-evaluate-module-v1-enabled-successfully":`Ativar com sucesso a opção de avaliação "Neural".`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Um ano`,
"label.login.bound.mfadevice.title":`Habilitar dispositivos de AMF virtuais`,
"vue_label_dashboard_statisticalvalue":`Por favor, selecione o valor estatístico`,
"label.ishistory":`História`,
"component.timeline.label.title":`Linha do tempo`,
"label.page.step3.of.step5":`Etapa 3 de 5`,
"label.assignment.setup.detail.section":`Detalhe da Regra`,
"label.salescloud.opportunity.nothave.main.contactrole":`Nenhum contato importante`,
"label.import.page1.limitedcsv":`Formato CSV APENAS para upload de arquivos`,
"label.icon.187":`Martelo`,
"label.emailobject.wizard.desc5":`Personalize sua assinatura para que seu correio fique melhor.`,
"vue_label_report_notice_copy_success":`Copie o relatório com sucesso!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Você não escolheu a regra da verificação em duplicata.`,
"label.componentEditor.upper.limit":`Até 100`,
"label.validate.function.funcExplain.ISNEW":`Verifique se o registro é novo, e retorna VERDADEIRO se é novo, caso contrário, retorna FALSO`,
"label.postalCode":`Código Postal`,
"label.dashboard.snapshot.enable.flag":`Habilitar instantâneos do painel de instrumentos`,
"vue_label_file_upload_type_size":`Somente arquivos {fileType} podem ser carregados, e não mais do que {tamanho}Mb`,
"label.appointment.wizard.subtitle3-6":`Sábado`,
"homepage.narrow":`Coluna estreita (esquerda)`,
"chatter.addmute.confirm":`Você tem certeza de que quer manter este posto "não perturbe"?`,
"label.lookup.account":`Pesquisar contas`,
"message.lostthemanager":`Esta apresentação requer a aprovação do gerente do usuário, e o valor do gerente do usuário é nulo. Por favor, entre em contato com seu administrador para saber mais.`,
"label.exchange.sync.state.contact.m3":`Registros sincronizados nas últimas 24 horas:`,
"label.version.phone.app":`Aplicação móvel`,
"label_tabpage_search":`Busca`,
"vue_label_helpcenter_campaign":`Nas informações detalhadas, clique no botão diagrama em árvore ao lado da campanha para visualizar o diagrama de estrutura hierárquica da campanha e entender a hierarquia pai-filho da campanha.<br>Gerenciar os contatos ou leads envolvidos na campanha através da lista relacionada de membros da campanha.`,
"front-lightning-module-v1-dashborad-last-year":`Ano passado`,
"label.campaign.channel.value":`Valores`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Para selecionar seu contato principal, salve esta etapa e escolha entre a Administração`,
"label.biaoqingfaxian.title":`Descoberta de Licitações e Concursos`,
"label.approved":`Aprovado`,
"label.hong.kong.time":`Hora de Hong Kong`,
"label.customfields.file.cannotopen":`Não é possível abrir o arquivo`,
"lable.New.tips":`Clique em "Novo" para criar um novo modelo de relatório de serviço com base em um modelo padrão ou em qualquer outro modelo selecionado. Favor ativar o modelo e começar a usálo.`,
"component.setup.tabs.label.add":`Adicionado`,
"label.forecast.forehistory.replacebest":`Melhor caso superado`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center integrado com TRRT para fornecer serviços SaaS mais abrangentes`,
"label.workflow.configrule":`Passo 2 Configurar regra de fluxo de trabalho`,
"label.dashboard.snapshot.refresh.frequently":`Instantâneos do painel de instrumentos são atualizados com muita freqüência, por favor tente novamente mais tarde.`,
"label.ems.editsetting":`Editar configuração de e-mail`,
"message.confirmdeleteAPP":`Você tem certeza de que quer apagar este aplicativo?`,
"label_chatter_activity":`Atividades`,
"label.editsharerules":`Regras de Compartilhamento Editar`,
"label.loginservice.license.notuse.must":`A licença não está disponível no momento, você deve`,
"label.import.step2.beforeexport":`1、Before importando, por favor, certifique-se de importar todos os registros relacionados. Por exemplo, se você estiver importando registros de contato e quiser preencher o campo de conta, que é um campo de pesquisa, você precisa criar primeiro o registro de conta que está preenchendo, depois importar o registro de contato e preencher o campo de conta com o nome ou ID da conta correspondente.`,
"label.chat.mute":`Não Perturbar`,
"label.icon.128":`Casa`,
"label.give":`&&E`,
"label.hide":`Não Mostrar`,
"label.relationobject.wpr":`Aprovador Delegado`,
"label.summation":`Soma`,
"label.layout.availabletab.details":`Detalhes`,
"label.circle":`Tabela de Donuts`,
"vue_label_opportunity_contactrole_add":`Adicionar funções de contato`,
"label.file.library.file2libsuccess":`Adicionado com sucesso!`,
"label.weixin.report.reportgenerated":`Relatório Gerado`,
"label.icon.91":`Pessoas`,
"report.label.pleaseinput":`Digite o que você deseja pesquisar`,
"label.escalation.setup.newaction.otheremail.tip":`Você pode digitar até cinco (5) endereços de e-mail para ser notificado. Cada endereço de e-mail é separado por ",".`,
"label.area.donot.have.data":`Sem dados`,
"label.customcomponent.btn.reference":`Referência de componentes`,
"label.appointmentdetail.wizard.title7":`Tempo de lembrete`,
"label.ccchat.with":`Tenha`,
"label.file.size":`Tamanho`,
"label.product.sort.beyond":`Um máximo de 10 níveis pode ser definido !`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Selecione as colunas`,
"label.appointmentpage.wizard.subtitle1_1":`Escolha data e hora`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Deve misturar números e letras maiúsculas e minúsculas, e caracteres especiais`,
"label_chatter_addressee":`Destinatário`,
"label.profile.remark2":`Se sua organização usa tipos de registro, use os links Editar na seção Configurações do tipo de registro abaixo para disponibilizar um ou mais tipos de registro aos usuários com este perfil.`,
"UG_Account_01":`Quem é sua conta?`,
"label.dataimport.error.contact.notnull":`Erro: o nome do contato não pode ser nulo.`,
"lable.account.CalenderQuarter":`Trimestre Calandra`,
"vue_label_commonobjects_detail_empty":`O preço de venda não pode estar vazio`,
"label.approveassigntemplate":`Aprovado para atribuir modelos de e-mail.`,
"label.objectRelationshipDescription1":`Esta fonte de dados do relatório irá gerar relatórios sobre`,
"vue_label_email_insertmergefield":`Inserir campo de fusão`,
"label.mobile.home.page.check.team":`Equipe`,
"lable.edit.queue.edit":`Edição da fila`,
"label.campagin.roi.query":`Ver o ROI da campanha`,
"label.dataimport.field.allow.access.to":`Os campos de dados não têm permissão de acesso, favor apagar manualmente o registro correspondente e tentar novamente.`,
"pagecreator.systemstyle.message.canntdelete":`O estilo atual não é permitido excluir`,
"label.searchkey":`Por favor, digite palavras-chave`,
"chatter.showall":`Mostrar tudo`,
"show":`Mostrar`,
"label.quote.choseproduct":`Selecione o produto`,
"label.report.selected.field":`Campos Selecionados`,
"label.globaloperation.operationtype.create_data":`Criar registro`,
"label.knowledge.setting.data.seven":`Eliminar Grupo de Categorias: {flzmc}`,
"chatter.email.mentionOrMessage":`Menções ou Mensagens`,
"label_tabpage_exclusivez":`Excluir`,
"chatter.en.userinfo":`Digite as informações a seu respeito.`,
"label.log.orgid":`Organização`,
"label.dataimport.insertdata.error.fieldrepeat.update":`O campo $schemefield_name$ no registro não pode ser encontrado no banco de dados e não pode ser atualizado. O registro ignorou a importação.`,
"vue_label_chatter_add_link_success":`Adicionado link com sucesso`,
"label.sender_details":`Para adicionar novos detalhes do remetente, crie um usuário em seu`,
"label.ccpeak.addwhere.condition":`Um critério "onde" pode ser adicionado`,
"label.datamove.total":`Total`,
"label.tianyancha.businessverify.warning":`Favor observar que esta verificação apóia apenas os dados comerciais registrados na China continental.`,
"label.emailmainbody":`Email do corpo`,
"label.justadmin":`Somente Administradores`,
"label.data.downpage.e.list.desc1":`Esta página exibe arquivos exportados com sucesso. Por favor, faça o download dos arquivos exportados em tempo hábil, acrescente o link para download em seu e-mail.`,
"label.reportsSubscriptionPage.email.value":`Valores Existentes`,
"message.error.serviceappointment":`Favor preencher a hora de início e a hora de término programada na hora marcada para o serviço.`,
"label.textMessageObject.selectone":`Favor selecionar pelo menos um registro como destinatário da mensagem de texto`,
"label.schedulejob.setup.schedule.plan":`Horário`,
"label.assignment.layout.field.isassigned":`Atribuir de acordo com as regras de atribuição ativa.`,
"label.captcha.error":`Erro de verificação!`,
"mobel_web_not_more_data":`Sem mais dados`,
"label.emailsync.form.emailaddress":`Endereço de e-mail`,
"label.loginservice.error":`Erro de login, favor entrar em contato com o administrador.`,
"label.integrations.description":`Conecte sua conta CloudCC a outras aplicações`,
"vue_label_homepage_notice_selectone":`Favor selecionar pelo menos um condutor ou contato`,
"label.chatter.default":`Padrão`,
"label.tabpage.datefield":`Quando o campo de data é igual, pode usar o formato "ontem", "hoje", "amanhã", "mês passado", "este mês", "próximo mês", "semana passada", "esta semana", "próxima semana" ou "AAAA-MM-DD、MM/DDD/AAAAA".`,
"front-kefu-moudle-myzdhsc-file":`Arquivo de gravação não encontrado ou não gerado`,
"label.createname":`Criador`,
"label.mobile.phone.enter.plan":`Insira seu plano`,
"report.label.highlevelreport":`Os relatórios avançados permitem criar as relações entre até 4 objetos.`,
"label.edit.select.label":`Modo de edição`,
"label.partnerCloud.financeSetting.deduction":`Após a ativação, as brincadeiras serão adicionadas à conta de descontos, renda de descontos e objeto de gastos de descontos. Os usuários parceiros podem usar a conta de desconto para deduzir o valor a ser pago.`,
"message.duplication.label.updateoption":`Ação de atualização`,
"label.custom.CurrentCQ":`CQ atual`,
"front-kefu-moudle-wait":`Aguardando`,
"sunday":`Domingo`,
"label.service.timezone":`Fuso horário`,
"setup.layout.label.selectfield":`Selecione os campos`,
"label_emailtocloudcc_filed_action":`Ação`,
"label.forecast.customforecast.mycommit":`Meu compromisso`,
"label.uploadsuc":`Upload Bem sucedido`,
"vue_label_commonobjects_view_notice_atleast1field":`Selecione pelo menos 1 campo de exibição`,
"label.dataimport.khmc.length":`Erro: o comprimento da conta é muito longo.`,
"label.isemailnotification":`Enviar e-mail de notificação`,
"label.addAPPexchange":`Adicionar aplicativos da CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Moeda:`,
"UG_quota_02":`Mudança de estágio de oportunidade`,
"label.customer.tab.step2.same.option3":`Separador Escondido`,
"H":`Telefone`,
"label_tabpage_searchz":`Busca`,
"vue_label_homepage_deleted":`Eliminado`,
"label.weixin.recent.view":`Vistas recentes`,
"template.report.opportunity.sales":`Volume de Vendas de Oportunidades`,
"label.customfields.new.step2.opration.unique.info.v1":`Tratar "ABC" e "abc" como valores duplicados (insensível a maiúsculas e minúsculas)`,
"savesuccess":`Salvo com sucesso`,
"label.partner.workspace.member.memo":`Todos os usuários com perfil e permissão selecionados podem acessar esta nuvem de parceiros.`,
"label.icon.23":`Droga`,
"lable.batchadd.service.cfq.before":`Gatilhos (Antes da inserção)`,
"label.instrumentPanel.breakpointTwoLabelname":`Este valor deve ser maior do que o valor mínimo e o valor do ponto de parada 1.`,
"message.selectgsummaryinformation":`Por favor, selecione os dados que você deseja resumir`,
"label.tianyancha.businessverify.msg6":`Esta função utiliza serviços de terceiros e pode ter um desempenho instável ou impossível devido ao alto uso simultâneo. A CloudCC não é responsável por qualquer responsabilidade.`,
"vue_label_helpcenter_report3":`3.A. Clique na caixa de busca de campo, selecione o campo desejado pesquisando-o ou rolando para baixo na lista de campos, selecione o operador do campo, digite ou selecione um valor, clique em Aplicar e o filtro de campo entra em vigor. <br> B. Clique no sinal " " acima da caixa de pesquisa de campo e digite a condição de filtragem avançada que consiste em números e letras na "Caixa de entrada de condição de filtro". Por exemplo, (1 e 2) ou 3.<br>? Edit Filters<br> Para editar os filtros, inclua os filtros padrão, e clique nos filtros. <br>? Remover filtros<br> Clique no ícone "x" em um filtro para removê-lo. <br>? Execute o relatório<br> Clique no botão Executar no canto superior direito da página de edição para ver os resultados completos do relatório. <br>? Salvar o relatório<br> Clique no botão "Salvar" no canto superior direito da página de edição, preencha o nome do relatório, selecione a pasta do relatório e salve-o. <Antes de criar uma pasta de relatórios, o sistema gera por padrão Minha Pasta de Relatórios Personalizada e Pasta Pública de Relatórios Não Arquivada. <br> Passo 1: Na aba Relatórios, clique em Nova Pasta de Relatórios<br> Passo 2: Na janela pop-up Nova Pasta de Relatórios, você pode escolher transferir relatórios da pasta Relatórios Públicos Não Arquivados para esta pasta. Você pode selecionar quais usuários podem acessar esta pasta e os direitos de acesso. <Passo 1: Na aba Relatórios, vá para a página de listagem de Relatórios e encontre o relatório que você deseja visualizar, alternando "Visualizado Recentemente", "Criei", "Todos os Relatórios", ou a pasta Relatórios. ou a pasta Relatórios para encontrar o relatório que você deseja visualizar. <br> Passo 2: Clique sobre o nome do relatório para visualizá-lo. Ou clique no botão suspenso na extrema direita do relatório e selecione Executar para ver o relatório. <br>Se você é um perfil de administrador, a partir da guia Relatórios, vá para a página Lista de Relatórios e clique no ícone da engrenagem ao lado do botão Nova Pasta para selecionar os campos a serem exibidos no cabeçalho da tabela da lista de relatórios em cada pasta. <Passo 1: Da aba Relatórios, vá para a página de lista de Relatórios, encontre o relatório que deseja exportar e clique no botão drop-down na extrema direita do relatório. <br> Passo 2: Selecione o tipo<br> Formatar relatório: contém os cabeçalhos dos relatórios, agrupamento, detalhes de filtragem. <br> Relatório somente de detalhes: Linhas de detalhes não-formatadas. <br> Etapa 3: Clique Exportar. O relatório de detalhes somente precisa ser exportado em páginas, com um máximo de 2000 dados por página.  `,
"label.batchdelete.success":`Eliminação em massa com sucesso`,
"label.newprocess5.seq":`Ordem`,
"label.knowledgebase.data.translated.successfully":`Traduzir {a] dados com sucesso`,
"label_enable_range":`Ativar a faixa`,
"label.ccchat.and":`E`,
"label.assignment.setup.list.norule":`Nenhuma regra especificada.`,
"vue_label_report_summaryformulacolumn":`Coluna de fórmula resumida`,
"label.field.edit.change1":`A pontuação máxima não deve exceder 100`,
"syntaxerror":`Erro de sintaxe, favor verificar os critérios inseridos.`,
"label.icon.116":`Casa`,
"lable.asset.BOM.according.to.product":`Gerar lista técnica de ativos de acordo com a estrutura do produto`,
"chatter.like.post":`as pessoas gostaram deste posto`,
"label.trigger.page":`Páginas de ativação`,
"vue_label_email_contact_adminstrator":`O sistema é anormal, favor entrar em contato com o administrador.`,
"label.workreport":`Notas de trabalho`,
"vue_label_homepage_edit_card_view":`Editar Vista do Cartão`,
"label_emailsync_status_disabel":`Inativo`,
"label.icon.54":`Escavadeira`,
"message.error.view.validerr.common":`A verificação falhou.`,
"label.exchange.sync.account.username":`Conta de serviço Nome de usuário(Domínio Nome de usuário ou UPN):`,
"label.dataimport.error.date":`Erro: Data:`,
"label.orgname":`Organização`,
"label.weixin.group.owner":`Proprietário`,
"vue_label_dashboard_colorrange":`Faixa de cores`,
"label.forecast.shrepage.tableth":`Acesso previsto`,
"label.related.disabled":`Listas relacionadas não estão habilitadas, favor contatar o administrador do sistema para habilitar as listas relacionadas no layout da página.`,
"label.version.product.management":`Gestão de produtos`,
"label.knowledge.new.article.published":`O artigo é publicado como um novo artigo.`,
"label.sendsms.batch.step4":`Passo 4 Seu SMS foi enviado.`,
"vue_label_commonobjects_detail_and_tasks":`Parabéns, todos os eventos e tarefas são processados`,
"label.salescloud.ci":`tempo(s)`,
"label.ccpeak.getapi.name.time":`Se você quiser usar os métodos da classe CCService, você precisa instanciar.`,
"label.escalation.setup.detail.conditon":`Critérios`,
"label.lbs.isUseLbs":`Habilitar serviços de localização`,
"front-lightning-module-v1-dashborad-color-depth":`Profundidade da cor`,
"date":`Data`,
"label.select.personnel":`Selecione o pessoal`,
"label.appointmentpage.wizard.notif3":`O e-mail é obrigatório!`,
"label.import.page1.pleaseselectwayofdealdata":`Favor selecionar o modo de processamento`,
"label.partner.all.memo":`A lista mostra todas as nuvens de parceiros em sua organização. clique em url para fazer o login.`,
"label.appointment.wizard.subtitle4-3-3":`30 min`,
"component_telerecord_label_subject":`Assunto`,
"label.sendsms.batch.finish":`SMS em massa: Concluído`,
"label.login.access.myusername":`Meu nome de usuário`,
"label.weixin.wechatnumber":`WeChat ID`,
"label.eowechat.status":`Status do usuário`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Pontuação`,
"label.appexchange.oldreport.noupload":`Relatórios Antigos - Não Carregar`,
"label.approverfieldediting":`Campo de Aprovação e Registros Capacidade de Edição`,
"label_tabpage_customernamez":`Nome do cliente`,
"vue_label_dashboard_linkagesettings":`Ajuste da ligação`,
"vue_label_ccchart_notice_deletecomment":`Você tem certeza de que quer apagar este comentário?`,
"label.allprofile":`Todos os Perfis`,
"label.campaignmember.main.addMember":`Adicionar membros - Pesquisar`,
"label.projectManagement.subtask.list":`Lista de sub-tarefas`,
"label.code.some.size":`Capacidade de código: máximo 200KB caracteres, aproximadamente 20.0000 bytes.`,
"front-custom-service":`Service Cloud fornece serviços personalizados eficientes e ágeis para os clientes, reduz o tempo de resolução do serviço e aumenta as taxas de resolução com o sistema inteligente de ordens de serviço, melhora a fidelidade do cliente e aumenta as taxas de recompra.`,
"label.SMS.det":`Detalhes da Notificação por SMS`,
"setup_layout_label_nobutton":`Sem botões disponíveis`,
"vue_label_email_Could_not_save_template":`Não foi possível salvar o modelo`,
"label.imgfield.height":`Altura`,
"label.leadscore":`Pontuação de chumbo`,
"setup_object_field_dependency_label_removefromlist":`Remover valores selecionados`,
"message.error.code.null":`O código de autorização não pode ser nulo!`,
"label.tianyancha.businessscope":`Escopo de negócios`,
"vue_label_chat_empty_message":`Mensagem vazia`,
"label.total":`Total`,
"label.delerror.list":`Lista de arquivos não selecionados`,
"label.selectedreceivers":`Destinatários selecionados`,
"label.layout.availablepages":`Páginas disponíveis`,
"label.pc.ui.2018.personalinfo":`Informações pessoais`,
"label.chat.topic.edit.detial":`Editar detalhes`,
"label.mr.descreption.reDataList1":`Na consulta para atender às condições de um total de`,
"label.document.value.too.long":`Este arquivo tem um tamanho superior a 5M!`,
"lable.opppdt.addpdt.table.listprice":`Preço de lista`,
"label.selectoperate":`Selecione a ação`,
"label.icon.5":`Moeda`,
"label.icon.126":`Cama de hospital`,
"label.hiddensearch":`Busca oculta`,
"label.view.sortview.exportble":`Exportável`,
"vue_label_homepage_noassignee":`Sem cessionário`,
"label.knowledgebase.close.and.resolve":`Fechado e resolvido`,
"label.licence.used":`Licenças usadas`,
"label.newprocessstep5":`Passo 5 Selecione os campos a serem exibidos no layout da página de aprovação`,
"vue_label_appstore_all_applications":`Todas as aplicações`,
"label.no.edit.permission":`Não é possível selecionar. Não há permissão para editar os registros selecionados.`,
"vue_label_calendar_calendar_added_successfully":`Calendário adicionado com sucesso`,
"report_line":`Campo de dados`,
"component.chatter.link.label.name":`Nome do link`,
"label.data.expnode.e_desc1":`1. Exportação personalizada: os usuários podem selecionar campos para exportar e definir condições de filtragem de acordo com suas necessidades.`,
"label.tabularreport.step4":`Passo 4 Escolha os critérios do relatório`,
"Opportunity.Detailed.Phase.Change.Text.001":`Estágio de Oportunidades de Mudança`,
"label.quickbooks.searchresault.action":`Ação`,
"component_timeline_label_today":`Hoje`,
"label.callboard.remark":`Favor inserir o anúncio de sua empresa abaixo.`,
"label.campagin.field.choose":`Selecione os campos a serem incluídos na página de registro de membros da campanha`,
"front-gantt-module-rolling-temporary-tasks":`Rolando para a tarefa temporária`,
"label.file.des":`Descrição`,
"Dashboard_View_RecentlyView":`Visto recentemente`,
"UG_Account_04":`Filtragem de conta de consulta passiva`,
"chatter.refresh":`Atualização`,
"label.tianyancha.companyorgtype":`Tipo de empresa`,
"label.chatter.dateRange":`Faixa de datas`,
"label.campagin.step3":`Passo 3: Gerar páginas`,
"label.appointmentdetail.wizard.title14":`Plano de segunda-feira`,
"setup.object.field.dependency.button.setdependency":`Configurações de dependência de campo`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Este território de serviço não está habilitado. Você só pode adicionar membros sob um território de serviço habilitado.`,
"template.chart.ygydyj":`Desempenho do pedido do empregado`,
"label.tag.edittags":`Editar Etiquetas`,
"label.clone":`Clone`,
"front-electronic-signature-setting-intro1":`Antes de vincular sua conta, é recomendável que você primeiro se registre e autentique na plataforma DocuSign.`,
"label_reach":`Desempenho`,
"label.tabpage.havez":`Em anexo`,
"label.email.clearCase":`Somente e-mails vazios não associados a casos`,
"label.customer.tab.all":`Todas as abas`,
"label.direct.dashboard.day.report":`Nova Nota de Trabalho Diário`,
"label_tabpage_exportview":`Vista de exportação`,
"label.passwordPolicy.setup.maxFailTimes":`Máximo de tentativas de login inválido`,
"label.processsetting.complete.enable":`Completar e ativar`,
"label.marketsea.memberfield":`Os campos podem ser viciados por membros`,
"label.report.export.format.title":`Formato Relatórios`,
"label.recycle.execute.title":`Limpeza do caixote do lixo da reciclagem.`,
"label.file.use.most.user":`Usuários com o maior espaço de armazenamento utilizado`,
"report_type_label_systemReport":`Relatórios do sistema`,
"label.customobjects.majorobject":`Objeto principal`,
"label.file.delete.public.link":`Eliminar link público`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Número de funções`,
"label.sendtonextapprover":`Enviado para a Próxima Aprovação`,
"label.notification.tip3":`Carregar mais 10 Notificações`,
"label.tabpage.placeenterz":`Por favor, entre?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Por favor, digite a url da página a ser importada`,
"label.umeng.activity.statuschange":`O status da tarefa que você designou para #name é alterado para #newstatus`,
"label.step3.restricted.visibility":`Passo 3 Restringir a Visibilidade`,
"label.multilang.datadelete.approvedata":`Registros sendo aprovados ({0}):`,
"label.reportsSubscription.save":`Salvar`,
"label.emailobject.template.visibility":`Visibilidade`,
"label_partner_step3":`Passo 3 Informações básicas`,
"label.product.across":`Livros de preços Accross`,
"label.same.analyze.opportunity.name":`Nome da oportunidade`,
"label.chatter.memotel":`Memo-telefone`,
"label.recentview.seloption2":`Recentemente Criado`,
"label.ccchat.message.search.desc1":`Não conseguimos encontrar nenhuma notícia com`,
"label.reportexport":`Exportação`,
"label.service.gantt.drop.tip":`Permissão negada: Você não tem permissões suficientes para operar. Favor entrar em contato com o administrador.`,
"label.australian.westem.standard.time":`Hora padrão ocidental australiana （Australia）`,
"label.emailobject.email":`Email`,
"Homepage_Contract_FieldMissed_DoesntSupport":`Não há campos "qdrq" e "htje" no objeto do contrato, portanto os dados não podem ser mostrados.`,
"label.email.cancel.upload.info":`Isto cancelará o processo de carregamento em andamento`,
"label.page.copy.merged.field.value":`Copiar valor do campo de fusão`,
"UG.ST.006":`Entre diretamente`,
"label.trigger.service.connot.access":`Declaração inacessível`,
"label.projectManagement.new.tasks":`Nova Tarefa`,
"lable.SalesCommitmentKanBan.receiptsRate":`Taxa de conclusão dos recibos`,
"label.productsales.oppor.overdue":`Oportunidades vencidas`,
"vue_label_pool_convertedbyme":`Convertido por mim`,
"label.loginip.pagecue.invalidt":`O endereço inicial da Internet é mais distante do que o endereço final da Internet ou o endereço inválido da Internet.`,
"label.campagin.roi.xyzj":`Resposta total`,
"label.visualpage.list.title":`Acesso à página personalizada ativa`,
"chatter.feed.searchinitvalue":`Digite o nome...`,
"label.export_submission":`Exportação dos dados enviados`,
"this.season":`Este trimestre`,
"label.forecast.settings.gx":`Compartilhamento de dados previsto`,
"label.tag.addtags.tagcolour":`Cor da etiqueta`,
"label.api":`Nome da API`,
"label.bulk.delete":`Eliminação em massa (Permanentemente)`,
"label.reportsSubscriptionPage.condition.emailoption":`Opções de e-mail`,
"vue_label_dashboard_newdashboardsuccessfully":`Criar com sucesso um novo painel de controle`,
"three":`Três`,
"label.prompt":`Pronto`,
"label.same.analyze.contact.phone":`Móvel`,
"label.icon.62":`Gasoduto`,
"label.forecast.shrepage.tableth.isnable":`Permitir o envio`,
"label.multilang.polloption.vote":`{0} bilhete(s)`,
"label.customfields.totalsummary.selecttotaltype":`Selecione o Tipo de Roll-Up`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Taxa de compromisso de recibos`,
"label.areaAndSub":`Território e Sub-Território`,
"vue_label_pool_recycle":`Recicle`,
"lable.outlook.detail.synset":`Configurações de Sincronização`,
"label.quote.detail.introduce":`Digite as palavras-chave, clique em "Pesquisar" para pesquisar, quando a pesquisa estiver concluída, clique em "Selecionar" para pular para o próximo passo.`,
"label.profile.customappset":`Configurações de aplicativos personalizados`,
"label.changemylanguage":`Mudança de Idioma`,
"message.approval.plzcapppor":`Escolha o aprovador`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Calendários e Recursos Públicos`,
"label.wtd.changefields.title.desc1":`Selecione os campos a serem incluídos em seu formulário Web-to-CloudCC, digite a URL de retorno especificada, depois clique em "Gerar".`,
"label.weixin.voting.not.empty":`As opções de votação não podem estar vazias`,
"label.campaign.channel.equal":`Igual a`,
"label.emailobject.emaildetail.button.back":`Voltar`,
"label.ccchat.person.invite.allowemails":`Para segurança, por favor, digite o endereço de e-mail somente terminado com o seguinte`,
"label.notEdit.message":`Desculpe, você não tem acesso para editar estes dados, por favor entre em contato com o administrador do sistema.`,
"label.layout.selectedfields.relatedlist":`Campos Selecionados / Listas Relacionadas`,
"label.weixin.voting.deadline":`Data limite`,
"label.document.upload":`Arquivo para upload`,
"label.import.page2.notmatchfiled":`{csvfiledlength} campos no arquivo no total. Os campos {difflength} não estão mapeados.`,
"label.data.exp.selzippwd":`Se você não preencher, não há senha comprimida por padrão.`,
"label.user.step2.select.email.template":`Passo 2 Selecione o modelo de e-mail`,
"label.currency.effective":`Moedas Ativas`,
"label.version.control.type":`Edição Organização`,
"label.projectManagement.Taskorproblem":`Tarefa/assessoria`,
"label.everyweek":`Semanalmente`,
"label.passwordPolicy.setup.pwdremember4":`4 senhas lembradas`,
"label.emailobject.groupemail":`E-mail do grupo`,
"label.approvepagelayout1":`Todos têm o mesmo layout`,
"label.integrations.mailchimp.massage5":`Importar os contatos e leads selecionados de sua conta CloudCC para MailChimp e enviar o e-mail para os destinatários pretendidos`,
"label.icon.22":`Adicione a`,
"Dashboard_View_All":`Todos os Dashboards`,
"label.import.page2.example":`Exemplo`,
"label.send.letter":`Enviar carta-convite`,
"label.mobilesectionpart":`Parte móvel`,
"component_setup_tabs_label_title":`Paginação de fichas`,
"label.knowledgebase.results":`{a} resultados`,
"label.field.remark":`Esta página permite que você especifique os campos que podem aparecer no`,
"vue_label_systemSettings_url":`Configuração do nome de domínio`,
"vue_label_SMS_failed_find_view_list":`Falha em encontrar a lista de visualização`,
"setup_layout_label_order":`Ordenar por`,
"label.customsetting.touse":`Usar configurações personalizadas`,
"label.product.enter":`Digite palavras-chave para encontrar os produtos correspondentes.`,
"label.email.template.private.SMS":`Pasta Exclusiva de Modelos de SMS`,
"vue_label_homepage_chart_deleted":`O quadro ou painel de controle foi removido`,
"label.conversion_pages":`Página de Conversão`,
"label.compact.layout.select":`Selecione os principais campos de layout de informações`,
"report_label_folderandreport":`Relatórios e Pastas`,
"label.product.entry":`Lista de preços`,
"label.campaignmember.main.manageMember":`Gerenciar membros`,
"front-QBtoCC-changing":`Atualizando...`,
"vue_label_pool_abandonreason":`Motivo do descarte`,
"template.report.customer.contract.statistics":`Análise contratual das contas`,
"label.invoice.message.sendsuccessully":`Fatura enviada com sucesso`,
"label.addcurrentoperate":`Adicionar Ação de Saída`,
"label.customerinfo.mailpwd":`Senha da caixa de correio`,
"batch.nochange.owner":`Sem permissão para mudar o proprietário do disco!`,
"label_tabpage_uploadfailez":`Upload falhou, por favor, recarregue.`,
"vue_label_systemSettings_mobelqrsetting":`Configuração de varredura de aplicativos móveis`,
"label.regular_field":`Domínio do formulário`,
"label.tabpage.delsuccessz":`Eliminar o sucesso`,
"label.Days.Before.Horizontal.Date":`data de nível antes`,
"label.evaluation.general":`Está bem`,
"chatter.notlike.p":`Pare de gostar deste posto`,
"label.chatter.send":`Enviar`,
"label.emailsync.button.cancel":`Cancelar`,
"label.notification.task4":`Sua tarefa está prestes a expirar hoje`,
"vue_label_helpcenter_detail1.2":`Alterar rapidamente o status da tarefa: marque a caixa de seleção na frente da tarefa no módulo "atrasado e próximo", e clique no botão Atualizar para alterar rapidamente o status da tarefa para "concluída".<br> Antes de atualizar, cancele a marcação e o status da tarefa não será alterado.<br> Tarefas com alta prioridade serão marcadas com um ícone "bandeira vermelha" na linha de tempo da atividade.<br> A seqüência de exibição da linha de tempo da atividade<br> Dispor em ordem inversa de acordo com a data de vencimento da tarefa, a data de vencimento da chamada gravada, a data de início do evento, a data de envio e recebimento de e-mails, e a data de envio e recebimento de SMS. Se as datas acima forem as mesmas, elas serão ordenadas na ordem inversa do tempo de criação do registro.<br>?Filtro da linha do tempo de atividade<br> Usar os filtros na linha do tempo do evento para restringir o escopo dos itens visíveis, focar em itens importantes e encontrar itens alvo. O filtro da linha do tempo inclui três tipos de filtros: intervalo de datas, atividade a ser exibida e tipo de atividade.<br> Atividades a serem exibidas: todas as atividades, minhas atividades<br> No filtro da linha do tempo do evento, esta opção pode limitar o intervalo de exibição do evento.<br> Minhas atividades: Mostrar as atividades das quais você participou, seja como proprietário ou como participante. Por exemplo, você é o proprietário que envia e-mails ou organiza eventos. Por exemplo, quando você é o destinatário do campo Cc ou Bcc do e-mail, isso significa que você está participando do evento.<br>`,
"component_chatter_post_label_title":`Publicar`,
"label.data.dataexptemplate.desc":`O modelo de exportação de dados criado pelos usuários é usado para exportar dados, e pode tornar a exportação de dados mais conveniente.`,
"label.helptext":`Texto de ajuda`,
"vue_label_norm_removecomponent_certify":`Confirmar componente de exclusão`,
"front-template-V1-Click-new-template":`Clique em "Novo" para criar um novo modelo. Ative e comece a usar este modelo`,
"label.optional_fields":`Campos opcionais`,
"label.delete_about":`Você vai apagar`,
"chatter.feed.initvalue":`Em que você está trabalhando?`,
"label.mail.configure":`Configure seu endereço de e-mail pessoal para enviar e receber mensagens na página inicial de e-mail do CloudCC e sincronize seu histórico de e-mail com os contatos e leads.`,
"label.project.hit.seven":`Lembrete de expiração de tarefas`,
"label.button.upgrade":`EDIÇÃO DE UPGRADE ou CHANGE EDITION`,
"lable.PowerProcess.event.name":`Nome do marco miliário`,
"label.weixin.confirm":`Confirme`,
"label.customfields.new.inputformula":`Insira a fórmula`,
"label.standard.buttonandlink.edit":`Substituir Botão ou link padrão`,
"workflow.action.tasks.assignortype.createdtype":`Tipo de criador`,
"front-email-payment-paypal-describe":`Clique em "Continuar", você pode acessar o site do PayPal ou criar uma conta PayPal para completar o pagamento da fatura.`,
"label.selectexistingoperate":`Selecione Ações Existentes`,
"label.workflow":`Fluxo de trabalho`,
"label.assignment.setup.detail.ruleentries":`Inscrições de Regras`,
"label.data.file.i.title.num3":`3 O sistema lê previamente o arquivo de dados no servidor, depois inicia o back-end do importador em massa, cujos resultados serão notificados aos usuários pelo correio, e você não terá que esperar nesta página.`,
"label.use.view":`Use as vistas existentes`,
"label.forecast.settings.moren":`Família de produtos padrão`,
"vue_label_calendar_add_share":`Adicionar ação`,
"label_tabpage_newview":`Criar uma nova visão`,
"label.recycle":`Lixeira`,
"UG_solution_03":`Criar uma solução`,
"label.customfields.formula.text.tip":`Crie uma cadeia de texto, por exemplo, concatenando outros campos de texto.`,
"vue_label_file_single_file_size":`Máximo suporte de arquivo único`,
"label.a.b.least":`Cada registro "A" deve ter pelo menos um registro "B" relacionado.`,
"label.validate.function.addtoformula":`Inserir função selecionada`,
"label_tabpage_pleaseSelectz":`Favor selecionar`,
"label.account.NextFQ":`Próximo FQ`,
"label.project.project.name":`O nome do projeto não pode ser repetido.`,
"label.emailtocloudcc.filed.owner":`Proprietário`,
"label.textmessage.template.message2":`O campo inserido no e-mail atual não corresponde ao registro associado, o que pode causar valores nulos.`,
"label.icon.92":`Livro`,
"label.trailerpage":`Página traseira`,
"component_event_label_noevent":`Parece que você completou seu trabalho hoje.`,
"label.trigger.tip":`Sobre os gatilhos`,
"label.knowledge.case.field.usable":`Campos de caixas disponíveis`,
"label.group.isusing.success":`Ativar com sucesso`,
"label.marketsea.nextnotfollowdays":`Desde o último acompanhamento`,
"component.todaytask.label.choicestate":`Selecione o status`,
"label.recordtype.main":`--Mestre--`,
"label.sendletter.step1":`Passo1: Especificar os destinatários dos convites`,
"label_tabpage_saveviewfailed":`A visão salvar falhou`,
"vue_label_report_notiec_selectone":`Cada registro de objeto pai deve ter pelo menos um registro de objeto relacionado`,
"UG_opportunity_003":`Rastreie seus canais de venda, crie painéis de controle`,
"#label.importsourcestep4":`Passo 4 Importe seus arquivos#`,
"front-kefu-moudle-v1-trrt-tip":`Você precisa associar usuários (agentes de atendimento ao cliente) com as extensões do TRRT para obter a função de "Clique para discar".`,
"UG.Forcast.09":`Próximo passo`,
"label.ggReleaseRange.subordinates":`Procurar papel e subordinado`,
"label.log.desctiption":`Você pode baixar o rastreamento de auditoria que contém mais informações (arquivo Excel.csv).`,
"label.submitted":`Enviado em`,
"label.validate.function.funcExplain.BEGINS":`Verifica se o texto começa com um caractere específico e, se for o caso, devolve VERDADEIRO, caso contrário devolve FALSO.`,
"label.campaign.channel.code":`Canal de Marketing Código QR`,
"chatter.group.theLastActivityDate":`Data da última atividade`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Favor inserir um valor de ponto de parada 2`,
"label.labeltranslation":`Traduzir rótulo`,
"label.multilang.product.deleterederect":`Sua eliminação de {0} não pôde ser concluída porque ainda está associada a registros em outros livros de preços. O registro associado é o seguinte.`,
"lable.currencyManage.manageRate.dis":`Para gerenciar taxas de câmbio para outros objetos, para adicionar novas moedas, para ativar ou desativar moedas, ou para mudar a moeda corporativa, clique em Gerenciar moedas.`,
"setup.layout.label.modifypage":`Edição do layout da página`,
"label.import.page2.editforname":`Favor editar o mapeamento para o campo {necessaryName} .`,
"label.searchlayout":`Layouts de busca`,
"label.chatter.loadmore":`Carregar mais`,
"label.trigger.folder.all":`Todas as Pastas de Gatilho`,
"label.export_submissions":`Envio do formulário de exportação`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Taxa total de conclusão da tarefa assinada`,
"KeyInformationLayout_DefaultLayout_Name":`Default do sistema`,
"label.h5.chatter.great":`como(s)`,
"label.call.center.configuration.enable":`Use as seguintes configurações para habilitar a função de Chamada ao Centro de sua organização`,
"label.overdate":`Data final`,
"chatter.poll":`Enquete`,
"label.login.input.verification.code":`Por favor, digite o código de segurança:`,
"label.file.sharetype.cooperation":`Colaborador`,
"label.app.step5":`Etapa 5 Atribuir a Perfis`,
"front-gantt-module-save-order":`Salvar a ordem`,
"label.globalselect.toallrecord":`Adicionar novos valores de lista de opções a todos os tipos de registros que utilizam este conjunto de valores globais`,
"setup.mainpage.label.welcome24":`A plataforma CloudCC fornece configurações de acesso de segurança para todos os dados do objeto no sistema. O compartilhamento de dados e os direitos de acesso podem ser controlados através da definição de várias regras e condições.`,
"homepage.layout.desctiption":`Esta página permite que você crie diferentes layouts de abas para a Home Tab.`,
"vue_label_SMS_notice_send_sussess":`SMS Enviado`,
"label.projectManagement.overdue":`Vencido`,
"label.assignment.setup.list.lead.description":`Atribua automaticamente leads aos usuários com base nas regras de atribuição de leads que você definir. Você pode criar várias regras com condições diferentes.`,
"label.list.projectSetting.des":`Você deseja enviar e-mails sob as configurações abaixo:`,
"setup.mainpage.label.welcome18":`As configurações de permissões de nível empresarial do CloudCC permitem controlar os direitos de uso de usuários individuais enquanto trabalham com dados e módulos. As configurações de permissões baseadas em funções também incluem posições de usuários, grupos, funções, regras de compartilhamento de dados e controles de segurança em nível de campo para permitir o compartilhamento de dados entre diferentes pessoas e departamentos da empresa.`,
"label.ratio":`YoY e MoM`,
"label.Xaxis":`X-Axis`,
"label.google.map":`Mapa Google`,
"Dashboard.SelectBoardToDisplay":`Favor selecionar os painéis que você deseja mostrar na página de tabulação dashborad`,
"label.data.newtemplate.e_conditions":`Condições de exportação`,
"label.emailtocloudcc.description3":`Conecte sua conta de e-mail empresarial, tais como sales@company.com, info@company.com, support@company.com. Registre automaticamente os e-mails que você recebeu como leads e registros de casos no CloudCC para garantir o acompanhamento oportuno das cartas dos clientes.`,
"label.page.select.profile":`Escolha os perfis de usuário para os quais a nova guia personalizada estará disponível. Você também pode examinar ou alterar a visibilidade das abas a partir dos detalhes e editar as páginas de cada perfil.`,
"label.chosen.button":`Botões selecionados`,
"front-epwechat-module-v1-info":`Informações de retaguarda da WeCom`,
"label.translation.select":`Critérios de filtragem`,
"ten":`Dez`,
"label.barcode":`Código de barras`,
"lable.product.nextdel":`Continue e exclua o record， exibido ou clique em`,
"label.default":`Padrão`,
"label.chatter.theme":`Tópicos`,
"vue_label_commonobjects_view_split_screen_view":`Vista da tela dividida`,
"label.ems.myemails":`Meus e-mails`,
"label.email.clearPersonalEmail":`Você quer esvaziar todos os e-mails sincronizados a partir da caixa de e-mail pessoal?`,
"label.login.access.admin":`O Administrador de sua empresa`,
"label.emailobject.wizard.desc":`Após conectar sua conta de email no CloudCC, você pode enviar emails diretamente do CloudCC enquanto os vincula automaticamente aos contatos, oportunidades e contatos relacionados. O histórico de comunicação é claramente organizado por linha do tempo.`,
"label.passwordPolicy.setup.minpwdlength":`Comprimento mínimo da senha`,
"choserow":`Escolher colunas para exibir`,
"front-epwechat-module-v1-role-binding":`Funções de encadernação`,
"lable.outlook.edit.newdata":`Tem a data de criação mais antiga`,
"label.schedulejob.setup.schedule.enddate":`Data final`,
"label.quickbooks.view":`Ver`,
"font-evaluate-module-v1-not-inform":`Notificação`,
"chatter.poll.option3":`Escolha 3`,
"setup_layout_label_selectfield":`Selecione os campos`,
"label.partner.common.roleSetup":`Funções do parceiro e configurações do usuário`,
"label_partner_new_step3":`Passo 3 digite o nome e a url`,
"label.transfer":`Transferência`,
"label.bmap.myaddress":`Minha localização`,
"label_tabpage_individual":`Escolha individual`,
"label.autoRegister.changepwd.setpwd.repassword":`Por favor, digite novamente a senha`,
"vue_label_commonobjects_detail_and_before":`Anteriormente`,
"front-kefu-moudle-v1-single-Login-area":`Nome de domínio com uma única assinatura`,
"label.replacedocument":`Substituir Documento`,
"label.validate.function.category.Logical":`Lógica`,
"label.companyprofile.syncsuccess":`Sincronização bem sucedida`,
"template.chart.rwzthyxj":`Assunto e prioridade da tarefa`,
"label.product.clearcondition":`Condições claras`,
"component_task_label_person":`* Pessoa designada`,
"label.tabpage.as":`Como`,
"message.error.calendar.add":`O calendário já foi adicionado`,
"label.marketsea.isrecycleleadcreatebyself":`Você quer reciclar eletrodos autoconstruídos?`,
"label.icon.57":`Barômetro`,
"UG.Lead.010":`Ou`,
"setup_object_field_dependency_label_configured":`Layouts de página atribuídos ao Perfil`,
"label.tianyancha.regnumber":`Código registrado`,
"front-kefu-moudle-v1-Opened-chats":`Habilitar o batepapo`,
"label_tabpage_converstatez":`Estado convertido`,
"label.bmap.beijing.haidianqu":`Shangdi 10 Street, Haidian District, Beijing`,
"label.startimport":`Iniciar Importação`,
"label.knowledgebase.application.default.settings":`Ajuste padrão da aplicação de relâmpagos`,
"lable.account.year.custom":`Anos fiscais personalizados`,
"label.event.nextmonth":`Próximo mês`,
"label.email.body":`Corpo`,
"setup.object.field.dependency.label.mustsetup":`Por favor, configure primeiro a dependência de campo e salve.`,
"label_tabpage_multiple":`Múltipla escolha`,
"label.task.this.month":`Neste Mês`,
"label.customfields.formula.moneyexample":`Margem Bruta = Montante - Custo__c`,
"label.tonewemailnotice":`Selecione o objeto para esta tarefa e clique em Next. As tarefas só podem ser associadas a regras de fluxo de trabalho e processos de aprovação do mesmo tipo.`,
"setup.mainpage.label.welcome11":`Relatório personalizado`,
"label.layout.availabletab":`Abas disponíveis`,
"label.data.importef":`Importação de arquivos defeituosos`,
"label.appupload.upload.alert":`Estas configurações determinam quais requisitos devem ser atendidos para instalar este pacote.`,
"label.sales.accountteam.shared":`Compartilhamento da equipe de contas`,
"lable.currency.addexchageRate":`Adicionar taxas de câmbio`,
"label.page.simplified.chinese":`Chinês (Simplificado)`,
"label.service.dispatchingUnits.search.service.area":`Buscar território de serviço`,
"lable.list.queue.name":`Nome da fila`,
"pagecreator.button.save":`Salvar`,
"label.ccpeak.support.function":`Suporta todos os tipos de funções de forma única`,
"label.tianyancha.legalpersonid":`Identificação de pessoa jurídica`,
"label.sendemail.chat.addPostmainPage":`Prezado #nome:{\i1}olá! #userName posts em sua página inicial do CCChat.`,
"batch.no.change":`Nenhuma permissão para transferir os dados.`,
"label.the.referenced":`invocado em`,
"label.input.webtab.information":`Preencha as informações sobre a guia web.`,
"vue_label_systemSettings_subscription":`Tipo de Assinatura`,
"label.login.access.title":`Acesso à conta de concessão Login`,
"label.schedulejob.setup.schedule.lastday":`a  last day`,
"label.synchronize.department":`Sincronizar usuários`,
"label_tabpage_lessequalz":`Menor ou igual a`,
"label.file.library.successmanagemember":`Salvo com sucesso`,
"label.service.major.event.oreder":`Sequência`,
"label.desktopintegration":`Integração da área de trabalho`,
"label.a_b":`Relacionamento de A a B`,
"every":`Cada`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`O conteúdo do arquivo não pode estar vazio.`,
"label.layout.detailoftestobj":`Detalhes do objeto de teste`,
"label.summaryreport.2018.step3":`Passo 3 Escolha os cabeçalhos das colunas`,
"UG.Lead.002":`Há muitas maneiras de identificar "leads" para seu produto ou serviço.`,
"label_partner_workspace_member_selectedprofile":`Perfil selecionado`,
"label.newdescription":`Nova nota`,
"vue_label_normal_moveup":`Subir`,
"label.mobile.quickcreate.default.logacall":`Histórico de chamadas`,
"userterritory.serviceterritory.user.unique":`A este usuário já foi atribuído este território de serviço. Por favor, não reafirme.`,
"label.weixin.record":`Registro`,
"front-kefu-moudle-connecting":`Conectando`,
"label.monitorsys.recent.operation.log":`Log de operações recentes`,
"lable.outlook.detail.lmaping":`Campos de chumbo do mapa`,
"lable.account.year.ovdate":`Data de término do ano fiscal`,
"vue.homepage.auditcard.record":`registros {recordTotal} records`,
"label.processsetting.delete.process.succeeded":`Apagar processo com sucesso!`,
"label.customerinfo.smsPwd":`Senha do SMS Gateway`,
"label.tolead.object":`Objetos de importação`,
"label.data.downpage.i.list.desc2":`Após a importação dos dados, você receberá um e-mail lembrando-o da importação com sucesso.`,
"label.sharerule.ruletype":`Tipo de regra`,
"label.reportsSubscriptionPage.email.toothers":`Envie a mim e a certos grupos de usuários`,
"label.emailobject.templates":`Modelos`,
"vue_label_checkduplicate_":`Análise de colisão`,
"label.campaign.channel.lookup.example":`Veja a amostra`,
"label.login.verification.please.note":`Por favor, observe:`,
"label.version.charge":`Cobrar`,
"label.ccdocument.show.trace":`Mostrar Traço`,
"label.sendemail.approval.submit":`Olá, #nome:\n #actorname the #objLabel-#recordname submitted by #actordate is waiting for your approval. please click the following link or log in to the crm system to enter the approval center for approval:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`O usuário pode completar a definição do relatório clicando no mouse, sem programação, e seguindo as etapas de solicitação do sistema. O sistema tem um relatório de lista, um relatório de resumo e um relatório de matriz para escolher. Opções de exibição para todos os campos também estão disponíveis. Remover informações desnecessárias sobre os campos. Ao mesmo tempo, ele fornece uma variedade de exibições gráficas incluindo tiras, linhas de dobra, anéis, funis e bolos, para que os usuários possam ver de relance.`,
"UG_contact_06":`Contatos de importação`,
"message.success.event.add":`Salvar com sucesso novas informações de eventos`,
"report.line":`Campo de dados`,
"label.approvepagelayout2":`Todos têm um layout diferente`,
"vue_label_normal_contract_sf":`Contrato`,
"label.tabpage.tpcustomersz":`Converta leads`,
"label.ccchat.message.new.error5":`Erro, sua mensagem não pode exceder 10000 caracteres.`,
"label.severalorone":`Arquivo individual`,
"pagecreator_systemstyle_label_buttonfontcolor":`Texto dos botões`,
"label.customer.tab.step3.introduce":`Escolha os aplicativos personalizados para os quais a nova guia personalizada estará disponível. Você também pode examinar ou alterar a visibilidade das abas a partir dos detalhes e editar as páginas de cada aplicativo personalizado.`,
"chatter.group.groupEdit":`Edição em grupo`,
"label.partnerCloud.partnerAccount.spending":`Gastos com bônus`,
"label.slip":`item)`,
"label.field.master.class":`O nível de relacionamento do principal-detalhe está além do nível 3`,
"label.sendemail.chat.addComentsmyFeed":`Prezado #nome:{\i1}olá! #userName respondeu ao seu micropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Selecione o Intervalo de Despacho`,
"label.knowledgebase.remove.article":`Você tem certeza de excluir os arquivos do formulário do artigo?`,
"label.appupload.notmanaged":`Descontrolado`,
"label.report.goto.step":`Ir para Passo`,
"label.publicgroup.save.mustbeselect":`Você deve selecionar os membros`,
"label.data.expnode.e.desc2":`2、Export por modelo: os usuários podem selecionar o modelo para exportar dados.`,
"UG.product.02":`Os produtos referem-se a produtos ou serviços que são vendidos ou comprados.`,
"label.sendemailtouser":`Você tem certeza de que deseja enviar e-mail aos usuários selecionados?`,
"label.knowledge.setting.hint.nine":`Se você não souber como o Conhecimento o beneficiará? Classifique artigos similares como a única categoria de dados e acumule a uma categoria mais ampla. Agora, vamos adicionar uma categoria de dados. Você pode adicionar mais categorias mais tarde.`,
"front-asset-module-v1-view-asset-bom":`Ver Lista técnica de ativos`,
"label_partner_all_enable":`Habilitar`,
"label.processsetting.disable.process.successfully":`Desabilitar o processo com sucesso`,
"label.call.center.enable":`Habilitar Call Center`,
"message.recordtype.applyitseparatly":`Aplique um layout de página diferente para cada perfil.`,
"label.weixin.report.customize":`Personalizar`,
"label.file.mongdb.file.is.not.exist":`O arquivo não existe`,
"label.chat.edit.topics":`Editar tópico`,
"label.knowledge.delete.searchterm":`Erro ao excluir o termo de busca promovido`,
"label_emailtocloudcc_redmessage3":`Favor inserir o endereço do servidor`,
"use":`Use`,
"label.batchtransfer.transferfrom":`Transferência de`,
"label.recycle.my":`Minha Lixeira`,
"label_json_string_null":`Vazio`,
"label.version.lookupfield":`Campo de Relacionamento Lookup`,
"lable.tianyancha.h5.searchf":`Não encontrado`,
"label.validate.globalvariable.description":`$User. [Field API] eg: $User.id <br>Os valores que você pode usar são: id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`Gênio das oportunidades`,
"label.applt.copy":`Clone de um toque`,
"chatter.emailMessageOrReply":`Posts ou comentários sobre meu post`,
"label.newreport.self":`Campos selecionados`,
"label.visualpage.checkpinxie":`Por favor, verifique a ortografia da página.`,
"label.knowledgebase.article.attaching.case":`O artigo {nome} foi anexado ao caso!`,
"label.dialogbox":`Caixa de Diálogo`,
"label.summaryreport.step3.new":`Passo 3 Selcet os dados a serem resumidos`,
"label.confirm":`Confirme`,
"label.mobile.buttom.team":`Equipe`,
"label.quickbooks.action.link":`Link`,
"vue_label_commonobjects_view_support_to_datas":`A operação suporta até 10 dados`,
"vue_label_helpcenter_homepage":`Cada usuário tem duas homepages desde o início, uma homepage padrão e uma homepage pessoal. O administrador pode atribuir ao usuário uma homepage de perfil correspondente, de acordo com o perfil do usuário. Note que a página inicial da versão Lightning e a página inicial da versão antiga não são interoperáveis.<br> 1. Homepage padrão<br> O conteúdo da homepage padrão é uniforme e não editável. Incluindo componente de desempenho trimestral, componente recentemente visto, componente de centro de aprovação, componente de evento de hoje, componente de tarefa, componente de oportunidade de negócios atrasada, componente de oportunidade de negócios de 30 dias, e componente de oportunidade de negócios futura<br> Componente de desempenho trimestral: todos podem definir suas próprias metas trimestrais<br> Componente recentemente visto: Exibir os 10 registros de objetos mais recentemente vistos<br> componente de oportunidades de negócios sem contato de 30 dias: Mostrar 5 oportunidades de negócios cujos dias sem contato são maiores que 30 dias e a probabilidade não é 0 ou 100<br>br> 2. Página inicial pessoal<br> Todos têm uma página inicial pessoal, e o conteúdo da página inicial pessoal pode ser personalizado para adicionar ou excluir componentes, ou arrastar e soltar para ajustar a posição e o tamanho dos componentes<br> Haverá um componente de briefing, componente de centro de aprovação, componente de oportunidade de negócios vencida, e um próximo componente de oportunidade de negócios por padrão ao abrir uma conta na página inicial pessoal<br> Página inicial pessoal permite até 15 componentes<br> 3. Página inicial de perfil<br> Os administradores podem criar/editar/apagar páginas iniciais de perfil personalizando a página inicial, e podem atribuir diferentes páginas iniciais a diferentes perfis, para que usuários com diferentes perfis possam ver diferentes páginas iniciais<br> Até 15 componentes por página inicial de perfil<br> 4. Adicionar componentes<br> Homepages pessoais e homepages de perfis podem ser personalizadas para adicionar componentes, você pode adicionar componentes de painel de instrumentos, componentes de tabela de painel de instrumentos e componentes de visualização de cartões<br> Componentes de painel de instrumentos: adicionar todo o painel de instrumentos do sistema à homepage. O número de subcomponentes no painel representa quantos componentes o componente do painel ocupa (a página inicial suporta até 15 componentes), e os dados do componente do painel após a adição não serão associados ao painel original (isto é, se o painel original for excluído, o componente do painel ainda pode funcionar) <br> Componente de tabela no painel: Você pode adicionar um componente gráfico específico no painel do sistema à página inicial, e a função de ligação do componente será inválida neste momento <br> Componente de visualização de cartão: Você pode escolher adicionar uma determinada visão de um objeto como fonte de dados à página inicial, e os campos e itens de operação podem ser personalizados. Mas observe que se a visualização da fonte de dados da visualização do cartão for excluída, a visualização do cartão não terá dados`,
"label.usersandlimit":`Usuários e Permissão`,
"label.sendmail.step3.introduce2":`destinatário(s) selecionado(s) para receber este e-mail.`,
"label.setupcustomfield":`Campos personalizados`,
"label.layout.last.notdel":`O último não tem permissão para apagar o layout.`,
"label.emailtocloudcc.redmessage7":`Erro de configuração, favor entrar em contato com o administrador.`,
"label.includedIn":`Contido em {parentproductname}`,
"label.permission.detail.app.pagesetting":`Configurações de páginas personalizadas`,
"label.addfile.tips":`{selectedNum} files have been selected. Até {originNum} arquivos podem ser adicionados por um único tempo.`,
"label.fieldinformation":`Detalhes do campo`,
"label.campagin.roi.sjcb":`Custo real`,
"label.email.all.works.company":`Todos os colegas da empresa`,
"label.currencyDesc":`Use esta página para definir todas as moedas utilizadas por sua organização. A Moeda Corporativa deve ser definida para a moeda em que sua sede corporativa reporta a receita. Se você designar uma moeda diferente como moeda corporativa, todas as taxas de conversão serão modificadas para refletir a mudança.`,
"label.file.details":`Detalhes`,
"label.foldervisitlimit3":`Somente os usuários seguintes podem acessar esta pasta:`,
"label.account.next.M":`Próximo mês`,
"label.oweralias":`Proprietário Alias`,
"label.projectManagement.entryname":`Nome do projeto`,
"label.customcomponent.page.add.title1":`Informações sobre componentes`,
"label.projectManagement.PleaseenterCreator":`Favor entrar um criador`,
"label.multipleactivity.memberselected":`Membros selecionados`,
"label_chatter_memotel":`Memo-telefone`,
"lable.Confirm.customers":`Confirmar para recuperar {num} leads.`,
"front-email-payment-Invoice-number":`Fatura No.`,
"label.not.appoint.validation":`Nenhum objeto é especificado para a regra de validação, favor especificar.`,
"label.peru.time":`Hora do Peru`,
"label.setting.intergrationlist.status3":`Login QuickBooks necessário`,
"vue_label_display_number_field":`Mostrar campos de números`,
"label_productline_count":`Quantidade da série de produtos`,
"label.data.downpage.i_title.num2":`2. Antes de começar a importar, certifique-se de que o nome do campo no arquivo que você deseja importar corresponda ao nome do campo objeto no CloudCC.`,
"label.field.duplicate4":`Tratar "ABC" e "abc" como valores diferentes __(sensível a maiúsculas e minúsculas)`,
"message.approval.step.validation.invalid.levels":`Pelo menos 1 nível`,
"label.tianyancha.businessverify.step1":`Habilitar a etapa 1 de verificação de dados comerciais`,
"label.hidedetail":`Ocultar detalhes`,
"UG_Lead_009":`Histórico de chamadas APP`,
"label.partnerCloud.newProductSeries":`Família de novos produtos`,
"label.brief.opportunities":`Total`,
"label.user.mfa.unbind.remind":`Você está prestes a destravar o AMF para os usuários selecionados e precisa religar o dispositivo AMF após o próximo login, você tem certeza?`,
"vue_label_report_grouprow":`Fila do grupo`,
"setup.layout.label.newarea":`Nova área`,
"label.nostart":`Não Iniciado`,
"UG_Lead_010":`Ou`,
"label.emailmerge.mergepage.record.requeired":`Favor selecionar os registros que você deseja fundir.`,
"label.appointmentpage.wizard.notif1btn1":`Confirme`,
"UG.Account.02":`Algumas empresas prestam serviços a outras empresas, algumas colaboram diretamente com os usuários finais e outras servem às ONGs.`,
"label.address.country":`País`,
"label.userinfo.updatepwd":`Mudança de senha`,
"label.salescloud.teamrole.optionlist.opportunity":`Adicionar membro da equipe de oportunidade a`,
"lable.account.Current.FY":`Atual FY`,
"chatter.coll.p":`Marcar este post`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Horário de verão do Atlântico`,
"label.recordslock":`Fechadura de Registro`,
"button_partner_search":`Inquira`,
"vue_label_salesfunnel_notice4":`Quantidade de oportunidades de negócios com uma probabilidade de 1% - 99%`,
"vue_label_report_statistics":`Estatísticas`,
"label.ccchat.notmember.active.group0":`Você não é membro de nenhum grupo de atividade com {0} em seu nome`,
"label.tag.manage.newtag":`Nova etiqueta`,
"label.customfileds.formula.dateandtime.tip":`Calcule uma data/hora, por exemplo, adicionando um número de horas ou dias a outra data/hora.`,
"label.weixin.mobile.fly.ios":`Compartilhar a partir de um dispositivo móvel (IOS)`,
"vue_label_file_over_file_size":`O tamanho do arquivo file.name  'name excede a predefinição do sistema!`,
"label.schedulejob.setup.schedule.last":`último`,
"label.ccchat.whose.name.contains":`de qualquer grupo ativo cujo nome contenha`,
"label.project.milestone.name":`Você não pode ter dois marcos com o mesmo nome em um projeto.`,
"message.passwordPolicy.validate.reuse":`Erro: Você não pode reutilizar esta senha antiga.`,
"label.stdashbord.xsld.business.img3":`A quantidade de probabilidade de 1%-99% * Probabilidade`,
"label.event.view.list":`Ver Lista`,
"label.workflow.ruletriggertime":`Tempo de acionamento das regras`,
"label.campaign.channel":`Canais de Marketing`,
"label.appexchange.emailnotice":`Alerta de e-mail de fluxo de trabalho`,
"label.icon.77":`Agricultura`,
"label.visualpage.display.value":`Digite os valores a serem exibidos e observe que não há espaços antes ou depois dele.`,
"label.forecast.customforecast.type.user":`Por usuário`,
"label_tabpage_lessz":`Menos de`,
"label.same.analyze.contact.email":`Email`,
"vue_label_report_range":`faixa`,
"lable.product.pricebooks.nr":`Você pode clonar o conteúdo dos livros de preços existentes selecionando na lista de seleção abaixo.`,
"label_mobile_buttom_team_setUp":`Configurações da equipe`,
"label.email.bcc.recipients":`Destinatários do Bcc`,
"vue_label_ccchat_notice_deletepostfail":`Falha em excluir correio`,
"label_file_type":`Tipo de arquivo`,
"label.multilang.feedtrack.operateupdate":`Um registro {0} foi modified：`,
"label.contractmanager":`Gerente de Contrato`,
"front-gantt-module-drag-one-task-sorting":`As tarefas só podem ser classificadas dentro do mesmo marco!`,
"label.partner.step2":`Passo 2 confirmar modelo`,
"front-epwechat-module-v1-again-binding":`Rebind`,
"label.service.miniProgram.imageSize":`Não mais que 2MB de imagem podem ser carregados!`,
"setup_main2018_label_managesetup":`Configurações de administração`,
"component_salesperformance_label_nopermission":`Para visualizar os dados relacionados às oportunidades de negócios, entre em contato com o administrador de seu sistema.`,
"lable.account.stadate":`Trimestre fiscal Data de início`,
"label.service.gantt.and.resourcestype":`e tipo de recurso é`,
"label.ems.attachfiles":`Adicionar anexo`,
"label.data.expnode.e.desc1":`1、 Exportação personalizada: os usuários podem selecionar campos para exportar e definir condições de filtragem de acordo com suas necessidades.`,
"vue_label_systemSettings_analyse":`Analisar`,
"label.project.all.date":`A data final deve ser posterior ou igual à data de início!`,
"vue_label_commonobjects_view_summary_basis":`Base de agregação`,
"template.chart.yywjhdschd":`Campanhas com Oportunidades`,
"vue_label_pool_notmeet":`Não atende às exigências do cliente`,
"label.attendance.manager":`Gerenciar o atendimento`,
"vue_labenl_normal_current":`Atual`,
"label.projectManagement.completed.quantity":`Quantidade de conclusão`,
"label.layout.testfield":`Campos de teste`,
"label.customfields.selectcontainrelatelistlayout":`Selecione os layouts de página que devem incluir esta lista relacionada`,
"label.fiji.time":`Hora de Fiji`,
"message.error.domain.already.exists":`O nome de domínio já existe.`,
"label.accountandcontact":`Contas/Contatos`,
"label.dashboardSetup.right":`Certo`,
"label.view.appliedMobile.xgry":`Verifique este item, os usuários relevantes podem ver a visualização na bancada de trabalho da página inicial`,
"label.file.share.all":`Qualquer usuário em sua empresa`,
"vue_label_pool_summary":`Total {0} registros(s), atualizados em {1}`,
"label.emailtemplate.new":`Novo modelo de e-mail`,
"label.tag.manage.button1":`Criar nova etiqueta`,
"label.data.exp.tempexppage":`Página do modelo de exportação de dados`,
"font-trade-module-v1-invoice-total":`Montante total da fatura`,
"label.folder.sort":`Classificar pasta`,
"label.multilang.campaign.countnum":`{0} tempo(s)`,
"label.homepagelayout":`Layouts da página inicial`,
"setup_layout_button_cancel":`Cancelar`,
"lable.Search.in.QuickBook":`Busca no QuickBook`,
"setup_fielddependency_label_pleaseclick":`Clique em Controlando o valor do campo para editar`,
"setup.fielddependency.label.pleaseclick":`Clique em Controlando o valor do campo para editar`,
"label.version.sum.field":`campo(s) personalizado(s)`,
"label.form.is.submitted.successful":`Prontidão de submissão de forma bem sucedida`,
"label.campaignmember.main.batchaddmember":`Membros da Campanha "Mass Add".`,
"label.sendemail.activity.newevent":`Prezado #belongtoidccname, olá: olá: o seu colega #createbyidccname atribuiu-lhe um novo evento em #createdate, que diz o seguinte:rr #sujeito: hora de início: #begintime#r hora de término: #final da hora: itens relacionados: #conteúdo relacionado: #conteúdo relacionado: #Para mais detalhes, visite este link:rpm Caminho:rpm sistemaorgNameCRM`,
"label.knowledgebase.select.target":`Por favor, escolha um alvo`,
"setup.layout.label.buttonlist":`Selecione os botões`,
"pagecreator.page.label.pagedesc":`Descrição da página`,
"label.version.professional":`Edição Profissional`,
"UG.Forcast.10":`Completo`,
"template.chart.schdyqsr":`Receita esperada das campanhas`,
"front-filter-module-v1-quick-filter":`Filtro Flash`,
"label.notification.group2":`Você se juntou com sucesso à equipe pública`,
"label.ServiceCloud.statistics.by.serviceArea":`Estatísticas por Território de Serviço`,
"label.validate.function.funcExplain.TIMENOW":`Retorna um tempo representando o momento atual`,
"label.brief.lastmonth":`Último mês`,
"label.weixin.member.states":`Status de membro`,
"template.chart.ljxsje":`Valor cumulativo de vendas`,
"label.eidt.queue.label.hasused2":`Este nome de fila já existe ou já foi usado anteriormente.`,
"label.textmessage.nophonenumber":`Este contato não tem um número de telefone celular registrado!`,
"label.task.new":`Nova Tarefa`,
"label.tabpage.grid":`A exibição da grade`,
"label.workbanch.setup.viewname":`Ver Nome`,
"front-gantt-module-temporary-tasks":`Tarefa Temporária`,
"label.reportTypeDescripe":`Com fonte de dados de relatório personalizada, você pode permitir que os usuários criem relatórios a partir dos objetos predefinidos, relações de objetos e campos que você especificar.`,
"setup_layout_label_fieldlist":`Campos disponíveis`,
"label.ggReleaseRange.searchforRole":`Procurar papel de parceiro`,
"label.datamanage.account.field":`Campos de Conta`,
"label_tabpage_groupingemptyz":`Os itens de agrupamento não podem estar vazios`,
"label.permission.edit.insertinfo":`Digite as informações do conjunto de permissões`,
"label.back_forms":`Voltar à lista de formulários`,
"vue_label_calendar_step_2":`Passo 2: Criar um calendário a partir de um objeto padrão ou personalizado.`,
"lable.outlook.mcto.out":`Domínios Excluídos`,
"label.workflow.accessnext":`Utilize este processo de aprovação se o seguinte`,
"label.data.exp.temppage":`Exportação de dados e criação de modelo de página`,
"label_tabpage_printview":`Vista de Impressão`,
"vue_label_report_preview":`Para ver as últimas edições, atualize para visualização.`,
"frame_personinfo_label_personimage":`Foto do perfil`,
"component.chatter.button.like":`Como`,
"label.ems.drafts":`Esboços`,
"front-lightning-module-v1-details-page-chart-report-name":`Nome do relatório`,
"label.partner.workspace.login":`Página de login`,
"include":`inclui`,
"label_length_20":`Limite o comprimento a 20 caracteres.`,
"component_event_button_save":`Salvar`,
"label.weixin.recalculate.shared.success":`Regra de compartilhamento de objetos sucesso no recálculo.`,
"message.duplication.errorinscript.lessthan2":`Você deve selecionar pelo menos dois registros para fundir.`,
"label_my_forecast":`Minha previsão`,
"label.ems.to":`Receptor`,
"label_mobile_buttom_team_init":`Inicialização do usuário da equipe`,
"label.sendemail.send.codeerror":`A conversão do código falhou, por favor, digite a codificação correta.`,
"lable.quote.syncing.and":`e`,
"label.campaignmember.selectmember.step1oftotal":`Etapa 1 de 2`,
"label.ems.step3":`Etapa 3`,
"lable.PowerProcess.detail.message":`Informações do processo de marco miliário`,
"chatter.poll.option2":`Escolha 2`,
"front-view-module-v12-verify-number":`Erro de formato numérico. Por favor, verifique os dados de entrada.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`As configurações de funções rápidas salvas.`,
"lable.outlook.edit.zdyoutfi":`Nome do campo de intercâmbio personalizado`,
"label.assignment.setup.newentries.inputentries":`Digite a regra de entrada`,
"label.customfields.money.tip":`Permite que os usuários digitem um valor em dólar ou outra moeda e formata automaticamente o campo como um valor em moeda. Isto pode ser útil se você exportar dados para o Excel ou outra planilha eletrônica.`,
"label.service.appointmentList.cancelThePlan":`Plano de cancelamento`,
"label.chat.topic.suggest.add.topic":`Sem sugestão, acrescente seu próprio tópico.`,
"vue_label_commonobjects_detail_tips":`Dicas`,
"message.error.view.nameexists":`Erro: O nome único da vista já existe.`,
"label_emailtocloudcc_step2_name":`Configurar a propriedade do e-mail`,
"label.field.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado. E o comprimento máximo é de 50 caracteres, o comprimento mínimo é de 2 caracteres. Observe que não pode ser uma palavra-chave de banco de dados.`,
"page.field.masterinput.remark2":`Por exemplo, quando você cria um novo pedido, você precisa habilitar este recurso para inserir as entradas da linha de pedido na mesma página. (esta característica é bem adequada para objetos na relação mestre-detalhe).`,
"label.rule.enabled.successfully":`Habilitar as regras com sucesso`,
"label.role.createrolelist.tip":`Abaixo está uma lista dos papéis para sua organização. Você pode ver mais informações clicando no link das funções.`,
"label.multilang.datamanage.dataimport.redundantmsg":`O comprimento do título é &nbsp;{0}&nbsp; mas o comprimento dos dados é &nbsp;{1}&nbsp;, o sistema não pode determinar quais &nbsp;{2}&nbsp; os campos são redundantes.`,
"label.visualpage.staticresource":`Introduzir o Recurso Estático`,
"chatter.group.members01":`Membros`,
"label.planned.workname":`Nome do cargo`,
"label.service.dispatchingUnits.gantt.data":`Data do jogo Gantt`,
"label.data.newtemplate.t.conditions":`Condições do modelo`,
"label.accmarketsea.edit.title":`Edição do pool de contas`,
"label_chatter_priority":`Prioridade`,
"label_mobile_buttom_team_open":`Habilitar a equipe no PC & App`,
"front-gantt-module-no-tasks-available":`Nenhuma tarefa disponível`,
"component.newrecords.label.type":`Tipo de armazenamento`,
"label.version.ccdocument.and.remark":`Notas & Anexos`,
"label.martrixreport.step2":`Selecione o modo de agrupamento usado para calcular os dados que você deseja cadastrar`,
"label.projectManagement.Scheduleinformation":`Informações sobre o calendário`,
"label.emailmerge.mergeFolder.description":`Nesta página você pode criar um documento do Microsoft Word que contém seus dados de contato. Por favor, selecione os modelos de mescla de correio, até 20.`,
"label.autoRegister.changepwd.setpwd.tip":`A senha precisa satisfazer as seguintes condições`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`O carrinho está vazio, por favor clique em "Adicionar Produtos" para adicionar.`,
"label.marketcloud_seminar":`Seminário Marketing Cloud`,
"label.knowledgebase.no.results.knowledge.search":`Nenhum resultado sobre "{a}" em Conhecimento`,
"label.createdate":`Data de criação`,
"vue_label_systemSettings_bazaar":`Mercado`,
"report_type_label_contractPayment":`Contratos e contas a receber`,
"label.myemailset":`Minhas configurações de e-mail`,
"label.emailtype":`Tipo de e-mail`,
"label.appexchange.uninstallpage.message5":`Eliminar permanentemente todas as relações e listas relacionadas associadas com os objetos personalizados deste pacote`,
"label.customerinfo.applicationlicencenum":`Número de licença de recurso`,
"label.product":`Produtos`,
"lable.opppdt.selPdt.subtitle":`Seleção de produtos para`,
"label_emailtocloudcc_step1_lead1":`Email para liderar`,
"label.multilang.recentview.query":`Veja seu último {0}{0}`,
"label.cumstom":`Personalizado`,
"lable.product.pep":`Por favor, digite o preço.`,
"label.suggestion":`Idéias`,
"vue_label_email_sentto":`enviado`,
"label.email.cancel":`Após o cancelamento da associação, a caixa postal não pode ser utilizada para enviar ou receber emails. Você tem certeza de que vai cancelar a associação?`,
"component_timeline_label_1monthahead":`1 mês antes`,
"setup_mainpage_label_welcome31":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Criar Aplicação →`,
"label.weixin.settlement.rate":`Taxa de realização dos assentamentos`,
"front-lightning-module-v1-details-page-chart-add-report":` Um máximo de 4 gráficos de relatório pode ser adicionado.`,
"label_related_list_types":`Lista relacionada tipo de versão de Relâmpago`,
"label.tabpage.converstatez":`Estado convertido`,
"label.chatter.ok":`Confirme`,
"lable.SalesCommitmentKanBan.contractRate":`Taxa de assinatura`,
"component.setup.label.setupsavefail":`Falha ao salvar as configurações dos componentes`,
"label.email.form.text2":`[mudar para html]`,
"UG.Lead.009":`Histórico de chamadas APP`,
"label.escalation.setup.newrule.title":`Regra de Escalação do Caso`,
"label.field.available.value":`Valores de campo disponíveis`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Falha ativada`,
"label.dashboard.show.total.percent":`Mostrar total ou mostrar %, por favor escolha pelo menos um`,
"label.schedulejob.setup.schedule.jobprg":`Programas de emprego`,
"label.select.email.type":`Por favor, selecione o tipo de email!`,
"chatter.group.allTheMembers":`Todos os membros`,
"label.webtab.validation.apiname":`Deve começar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado. E o comprimento máximo é de 20 caracteres, o comprimento mínimo é de 2 caracteres.`,
"label_partner_new_step3_name":`Nome`,
"vue_label_chatter_remove_member":`Remover membro`,
"label.customobjects.majorobject.tip":`Se você selecionar um objeto de relacionamento não detalhado por princípios, os dados resumidos não aceitam permissões`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Três`,
"label.weixin.senderror":`O envio falhou`,
"label.visiturl":`Visite o URL`,
"label.apply.img.error":`A entrada de caracteres no garfo é incorreta`,
"label.been.detained":`Desconto de reinicialização`,
"vue_label_helpcenter_dashboard2":`<br> No painel recém-criado, você precisa adicionar componentes primeiro, e selecionar a fonte de dados do relatório ou visualizar a fonte de dados da lista. Depois determine o tipo de gráfico usado e selecione o agrupamento correspondente e os dados estatísticos para criar o gráfico<br> Após adicionar os componentes, você pode clicar no botão "Reordenar" no painel para ajustar a posição e o tamanho dos componentes. <br> Se você precisar definir as condições de filtro de tempo para alguns componentes, você pode clicar em "Filter Condition Settings" para selecionar o componente para definir o campo de tempo que o componente precisa filtrar. Após a configuração, você pode filtrar por tempo no painel e selecionar o intervalo de tempo correspondente para atualizar os dados selecionados. <br>Nota: Um painel de controle suporta até 10 componentes. <br> 2. Penetração e ligação de componentes <br> No mesmo painel, o componente A pode definir os componentes B e C da mesma fonte de dados que seus objetos de ligação. Após a configuração estar concluída, clique em uma área de dados do componente A, componente B e componente C simultaneamente fará a recontagem de dados com base nas condições da área de dados do componente A. <br> Observe que clicar na área de dados do componente B ou do componente C não fará com que o componente A recontagem seja feita. Se você precisar atingir este efeito, você precisa definir o componente A como seu objeto de ligação no componente B/C. <br> Para cada componente do gráfico no painel, os dados vêm da visualização ou do relatório. Portanto, é fornecida uma função de penetração, ou seja, clicar na área de dados do componente pode saltar para a visualização do relatório e da lista correspondentes. Observe que se a fonte de dados original falhar, o componente não terá dados e a função de penetração também falhará. <br> Como tanto a penetração quanto a ligação são a área de dados do componente para clicar, ambos não podem ter efeito ao mesmo tempo. Se o componente tiver ambos os conjuntos de penetração e ligação, então o componente só pode ter uma função com efeito ao mesmo tempo, e você pode escolher a função com efeito alterando os estados de ligação e de penetração.`,
"vue_label_commonobject_view_notice_delete_false":`Os dados {0} não puderam ser apagados, a razão é {1};`,
"label.weixin.newspaper.coverage.information":`Detalhes da Ficha de Risco`,
"label.you.do.not.have.permission.to.operate.":`Você não tem acesso para operar.`,
"label.checkfield.match":`Combinar`,
"message.custom.field.donotdelete.ref":`Este campo é referenciado por outros campos`,
"label.version.maxsum":`Atingiu o limite superior.`,
"System.ChangeUser.Info.001":`O proprietário mudou e clique para voltar à página anterior.`,
"label.target":`Meta`,
"template.dashboard.behavior.analysis":`Análise das ações`,
"label.login.verification.enter.prompt":`Por favor, digite um código de segurança digital de 6 dígitos`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Permita que os usuários recebam e-mails do CCChat quando alguém o seguir, comente sobre seu post, e muito mais.`,
"label.accmarketsea.grouplist.title":`Configuração do grupo de contas`,
"label.stdashbord.xsld.business.danwei":`Unidade: 10 Mil`,
"label.app.step1.error.namenull":`Você deve digitar o nome do grupo público.`,
"label.login.button.verification":`Submeter-se para verificar`,
"label_tabpage_newWizardz":`Novo assistente de funções adicionado`,
"label.addattachment.step1.intruduce":`Digite o caminho do arquivo ou clique no botão para encontrar o arquivo.`,
"pagecreator.layout.funcpath":`/ construtor / biblioteca de layout`,
"fourth":`O Quarto`,
"label.timetrigger.after.lasttime":`Um dia depois da data da última modificação.`,
"vue_label_report_showme":`Mostre-me`,
"label.h5.similar.opportunity.end.date.in":`A data de término está dentro do seguinte período`,
"label.turntonextstep":`Volte para o próximo passo`,
"label.icon.106":`Horário`,
"label.user.receivenewsbulletin":`Receber a transmissão de notícias`,
"label.mask.card.number":`Número do cartão de crédito`,
"setup.object.layout.label.profileoptions":`Perfis disponíveis`,
"vue_label_systemSettings_obj":`Objetos e campos`,
"label.call.center.history.open":`Abrir automaticamente a página de histórico de chamadas`,
"label.attendance.cityname":`Por favor, digite o nome da cidade`,
"label.newemailnotice.tip":`Criar um alerta por e-mail para associar com uma ou mais regras de fluxo de trabalho ou processos de aprovação. Ao alterar um alerta por e-mail, quaisquer modificações serão aplicadas a todas as regras ou aprovações associadas a ele.`,
"label.app.step1.error.labelnull":`Error: Label não pode estar vazio.`,
"front-kefu-moudle-connect-free-account":`Associar os usuários do CloudCC às contas de teste do TRRT`,
"label.biaoqingfaxian.description":`Com o bid&tender discovery habilitado, um menu de bid&tender discovery pode ser adicionado ao front-end, onde os usuários podem visualizar informações de licitações de indústrias relevantes e converter dados de licitações em leads no sistema.`,
"label.filter":`Filtro`,
"label.data.downpage.e.title.num1":`1、Select os objetos que você deseja exportar, ou opte por exportar todos.`,
"label.h5.similar.opportunity.last.months12":`Últimos 9-12 Meses`,
"label.chatter.name":`Nome`,
"vue_label_helpcenter_email":`1. Enviar correio<br> Deixar o sistema para ir até sua caixa de correio para se comunicar com os contatos está desatualizado. No Cloud CC, você pode vincular seu endereço de e-mail pessoal para enviar e-mails diretamente do Cloud CC. Quando você digita o endereço de e-mail ou o nome do destinatário, ele pode corresponder ao seu contato ou lead record para você. Você também pode associar registros de e-mail com registros relacionados que foram configurados, e os e-mails que você enviar serão sincronizados na página de detalhes do registro.<br> 2. 4 funções comuns ao enviar e-mails<br> Ao enviar um e-mail, você pode usar as 4 funções abaixo do texto do e-mail para auxiliar seu trabalho.<br>Rastreamento de e-mail<br> Quando você ligar o rastreamento de e-mail, nós o ajudaremos a monitorar o número de vezes que este e-mail foi aberto e quando ele foi aberto pela última vez. Você pode passar o mouse sobre o ícone "olho" na lista da caixa de saída para visualizá-lo.<br>Upload Attachment<br> Clique em Upload attachment, você pode selecionar o arquivo que foi carregado para o sistema, ou você pode escolher carregar o arquivo. Você pode selecionar vários anexos, desde que o tamanho do anexo seja inferior a 20M.<br>Inserir campos fundidos<br> Quando o e-mail é associado a um registro de objeto, você pode clicar para inserir o campo fundido, selecionar o objeto associado, selecionar o campo que você deseja inserir, e inserir o texto de substituição após a vírgula no campo fundido, como {!Contact.FirstName,Sir ou Madam }. Ao salvar o modelo, os campos fundidos serão exibidos no texto de e-mail do modelo. Use os campos mesclados para personalizar o conteúdo do e-mail. Você pode adicionar texto de substituição a qualquer campo fundido. O texto de substituição é exibido somente quando o registro fundido não contém os dados do campo.<br>?Editar e habilitar assinatura<br> Quando você estiver enviando e-mails de trabalho, uma assinatura que possa representar sua identidade ajudará a melhorar o profissionalismo de seu trabalho. Clique no botão "Editar Assinatura", você pode editar suas informações básicas, e ajudá-lo a inserir fotos. Se você marcar "Habilitar Assinatura", sua assinatura será anexada ao corpo da mensagem toda vez que você compõe um e-mail. Você pode desativar a assinatura a qualquer momento.<br> 3. Filtre a caixa de entrada <br> Você pode filtrar todas as mensagens não lidas em sua caixa de entrada para facilitar seu trabalho. Quando você quiser baixar arquivos via e-mail, você pode filtrar todos os e-mails com anexos em sua caixa de entrada, para que você possa localizar rapidamente o e-mail de que precisa. Além disso, você pode ver rapidamente os registros de clientes no sistema que você rastreia através de e-mails, selecionando e-mails contendo oportunidades comerciais abertas ou selecionando e-mails enviados por leads ou contatos.<br> 4. Mailing em massa<br> Há um botão para o mailing em grupo no canto superior direito da lista de leads e contatos. Você pode enviar e-mails em massa para clientes potenciais ou registros de contatos com endereços de e-mail. Quando você tem um registro de atividades de marketing, você pode enviar e-mails para membros das atividades de marketing em lotes, o que também é conveniente para você enviar convites para eventos.`,
"front-kefu-moudle-auto-callphone":`Autocriar novos casos para chamadas conectadas`,
"label.fiscal.FQ":`Trimestre fiscal`,
"label_tabpage_groupsVisiblez":`Alguns grupos de usuários são visíveis`,
"UG.product.01":`Listar produtos/serviços`,
"vue_label_commonobjects_view_members":`Membros opcionais`,
"label.organization.id":`ID da organização`,
"label.tyle_preview":`Previsão de Estilo`,
"label.campaign.channel.input.to.owner":`6. Por favor, configure a possibilidade de notificar seus proprietários quando os membros da campanha assinarem:`,
"label.appointmentconfirmpage.wizard.notif1":`A consulta foi cancelada!`,
"lable.tianyancha.maping":`Mapeamento de campo`,
"front-kefu-moudle-v1-noadd-online-chats":`O agente online não é adicionado`,
"vue_label_commonobjects_detail_group_strategy":`Você tem certeza de entrar na equipe do cliente?`,
"vue_label_report_deletegrouprow":`Eliminar linha de grupo`,
"lable.account.y.d":`Esta página permite que você defina um registro de ano fiscal personalizado. As datas para o ano fiscal personalizado serão geradas com base nas escolhas que você fizer abaixo.`,
"label.visualpage.lllegal.definitions":`Definição inválida`,
"label.tabpage.enterrecordnamez":`Por favor, digite o proprietário do registro`,
"vue_label_report_howmuchlines":`Linhas {comprimento}`,
"homepage.components.custom":`Componentes personalizados`,
"label.campaign.channel.upload.img":`Carregar imagem`,
"UG_Case_03":`Atualização automática de casos`,
"label.approved.receiveApprovalEmail.option4":`Nunca`,
"System.Data.Import.Warning.MaxCount":`Sua organização só pode importar {0} dados de cada vez, o que agora está fora do limite, favor ajustar e reimportar.`,
"label.sent.sms":`enviou um SMS`,
"vue_label_dashboard_statistictype":`Tipo de estatística`,
"label_report_last_year_same":`Mesmo período no ano passado`,
"lable.Examle":`Exemplos`,
"label.customerinfo.PageTriggerFagTitle":`Leva duas horas para sincronizar.`,
"label.mobile.phone.read":`Revise`,
"label.product.gopage":`Ir para a página`,
"label.a_b_without":`Os registros "A" podem ou não ter registros "B" relacionados.`,
"front-kefu-moudle-callin-missphone":`Chamadas perdidas`,
"label.sso.saml.sp.idsource.attrname":`Nome do Atributo`,
"label.h5.chatter.colleagues2":`Colegas`,
"label.approveprocess":`Processos de Aprovação`,
"label.dataimport.error.name.null":`Erro: o nome é nulo`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Quando a filtragem avançada não está habilitada, diferentes condições de filtragem são "e", ou seja, registros que satisfazem as características comuns de 1 e 2 são exibidos no relatório. Por exemplo: 1 é uma oportunidade de negócios com um valor superior a 1 milhão, e 2 é uma data de contrato estimada igual a este mês, portanto o resultado do relatório é mais de 1 milhão de oportunidades de negócios neste mês.`,
"front-lightning-module-v1-dashborad-export-picture":`Exportar imagem`,
"label.activity.disabled":`Nenhuma atividade ativada, favor entrar em contato com seu administrador do sistema para ativar o histórico de atividades e atividades não processadas no layout da página.`,
"message_chooseatleastonefield":`Favor selecionar pelo menos um campo a ser exibido.`,
"label.case.text":`Os formulários de solicitação de serviço enviados através do site podem gerar registros de casos no sistema. Favor selecionar o usuário como o criador do registro do caso, e o usuário selecionado precisa ter permissão de criação para o objeto do caso. A página da web está disponível para computadores e telefones celulares.`,
"label.sendmail.step3.dealoption1":`BCC me em uma mensagem`,
"label.forecast.settings.title.remark":`A melhor estimativa da receita estimada para o usuário, que fornece uma visão comercial completa para os usuários`,
"label.apply.youxiaotime.finish.opperation":`Você tem 5 minutos para completar as ações. Por favor, ignore esta mensagem se a operação não for realizada pessoalmente.`,
"label.user":`Usuário`,
"pagecreator.page.button.copy":`Cópia`,
"label.userinfo.pwdupdate.or.reset":`Sua senha foi alterada pela última vez ou redefinida em`,
"label.fieldupdata":`Atualizações de campo`,
"label.sendemail.chat.followsubject":`O CloudCC CCChat tem alguém a seguir`,
"component_task_label_enddate":`Data de expiração`,
"label.campaign.channel.step6.remark5":`Você pode reatribuí-lo através das Regras de Atribuição de Chumbo. Saiba mais sobre as Regras de Atribuição de Chumbo.`,
"label.mr.title.mobilePhone":`Móvel`,
"label.notice":`Lembrete`,
"message.serviceappo.time.violation":`Violação do horário disponível de nomeação de serviço: O horário de início da consulta de serviço é posterior à primeira hora de início disponível.`,
"label.account":`Contas`,
"front-kefu-moudle-callcenter-user":`Usuários do Call Center`,
"label.usermanage.query.notexist":`O usuário da consulta não existe.`,
"label.forecast.userinfo.isnable":`Permitir Previsões`,
"label_partner_workspace_member":`Membro`,
"vue_label_dashboard_penetrationsetting":`Ajuste de Penetração`,
"chatter.fieldtrack.operatecreate":`criou um`,
"label_tabpage_tpcustomersz":`Converta leads`,
"label.emailtocloudcc.redmessage6":`A autenticação IMAP/SMTP falhou, favor verificar se o endereço de e-mail e a senha estão corretos.`,
"label.customfields.file.upload":`Upload`,
"label.forecast.isforecast":`Sem previsão ativada`,
"label_benchmark":`Referência`,
"label.exchange.sync.state.system":`Status de Sincronização do Sistema`,
"UG.opportunity.003":`Rastreie seus canais de venda, crie painéis de controle`,
"label.campaign.matchway.select.error":`Para atualizar os dados, favor selecionar o método de correspondência`,
"vue_label_dashboard_located":`Dashboard Folder`,
"front-electronic-signature-enter-object":`Por favor, digite o objeto`,
"vue_label_systemSettings_mobelquick":`Aplicações móveis Configuração rápida`,
"lable.outlook.list":`Configurações de Sincronização de Troca`,
"label.sendemail.approval.dlsp":`Olá, #dlspr:\n #actorname#objapiname-#recordname enviado por #actordate foi definido como seu aprovador proxy pelo aprovador original #spr e está aguardando sua aprovação.\n#please click no link abaixo ou faça o login no sistema crm para entrar no centro de aprovação para aprovação:\n#url#url! \Nome`,
"label.service.deleteCustomView.wanttoremove.filter":`Você tem certeza que quer remover o filtro "{nome}"?`,
"component_task_label_newevent":`Nova tarefa`,
"vue_label_commonobjects_view_chart_groupby":`Grupo Por`,
"front-kefu-moudle-v1-edit-chats":`Agente de edição`,
"pagecreator_page_message_delete_fail":`A exclusão de página falhou`,
"label.file.search":`Arquivos de Busca...`,
"label.projectManagement.Addpredecessors":`Adicionar pré-tarefa`,
"label_tabpage_norecordtypez":`Tipo de registro inutilizável`,
"label.come.recycle.bin":`Ir para a lixeira de reciclagem`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relativo`,
"label.customfields.address.tip":`Permite ao usuário selecionar província, cidade, campos de município e inserir informações específicas de endereço que podem ser usadas para calcular a latitude e longitude.`,
"label.weixin.optioneight":`Escolha 8`,
"label.recordtypeselect.modify":`Edit Record Type`,
"label.forecast.settings.future3":`Futuros 3 ciclos`,
"label.rename":`Renomear`,
"label.emailtocloudcc.button.complete":`Terminar`,
"chatter.new.at":`Atividade mais recente`,
"component.setup.label.milestonesfield":`Campo de marcos`,
"vue_label_commonobjects_detail_email_newaddress":`Enviar para`,
"lable.PowerProcess.big.event":`Marco miliário:`,
"label.appexchange.uninstallpage.confirm":`Sim, I quero desinstalar este pacote e excluir permanentemente todos os componentes associados`,
"label_mobile_buttom_homepage":`Página inicial`,
"label.sso.saml.idp.config.logouturl":`URL única de logout`,
"lable.quote.pdf.button.savetoquote":`Salvar para citar`,
"label.page.select.application":`Selecione os aplicativos personalizados nos quais você deseja usar as novas abas personalizadas. Você também pode visualizar ou modificar se uma guia aparece na página de detalhes e na página de edição de cada aplicativo personalizado.`,
"chatter.down":`Download`,
"label.tabpage.searchz":`Busca`,
"label.emailsync.form.action":`Ação`,
"label.campaignmember.setup.campaignmember.field":`Campos de membros de campanha`,
"label.version.remark":`Nota: A edição gratuita permite criar apenas 5 usuários, 2000 registros e você não pode importar ou exportar dados.`,
"label.selectoperateobject":`Selecione o objeto.`,
"label.appointmentdetail.wizard.title12":`Tempo de livro`,
"label.submitforapproval":`Submeter para aprovação`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`O limite inferior para edição de cada nível de desconto será igual ao limite superior do último nível.`,
"label.appupload.install.component.view":`Componentes de visualização`,
"label.profile.customobjcontrol":`Permissões de objetos personalizados`,
"label.customfields.configprofilefieldsafety.tip":`Selecione os perfis aos quais você deseja conceder acesso de edição a este campo via segurança de nível de campo. O campo será escondido de todos os perfis se você não adicioná-lo à segurança de nível de campo.`,
"label.service.gantt.service.resources":`Recursos de serviço`,
"label.input.right.emailaddress":`Por favor, digite o endereço de e-mail inválido.`,
"label.ccdocument.folder.notedit":`A pasta não é editável.`,
"label.data.choses.i.desc":`De acordo com suas necessidades, importe dados de um único objeto.`,
"label.icon.75":`Carro`,
"label.summaryreport.step4":`Passo 4 Escolha as colunas do relatório`,
"label.appupload.upload.install":`Instalar`,
"label.reportlist.newfolder":`Nova pasta de relatórios`,
"label.projectManagement.myproject":`Meu projeto`,
"label.true":`VERDADEIRO`,
"label.tabpage.reallproplez":`Proprietário do registro`,
"label.change.lead.share.error":`Sem direito de editar cliente`,
"F":`Data/Hora`,
"lable.account.CurrentandNextCQ":`CQ atual e CQ seguinte`,
"UG.activity.06":`Deseja acompanhar com contas`,
"UG.contact.03":`Rastrear contatos em um só lugar, sinais de vendas`,
"label.field.duplicate.error.msg2":`O ajuste de propriedade exclusivo falhou`,
"label.sales.dashboard.reality":`Pagamentos efetivos`,
"lable.PowerProcess.type":`Tipos de processo de concessão de direitos`,
"batch.selected.data":`Dados selecionados:`,
"#label.importsourcefilestep2":`Passo 2 Comprima seu arquivo(Opcional)#`,
"label.emailtemplate.select":`Por favor, escolha o modelo de e-mail que você deseja usar.`,
"chatter.most.w":`Você pode inserir até 500 caracteres`,
"vue_label_calendar_new_object_calendar":`Novo calendário de objetos`,
"label.aggregated_formsdata":`Dados agregados dos formulários`,
"label.knowledge.language.french":`Francês`,
"label.customfields.enc.tip":`Permite que os usuários digitem qualquer combinação de letras e números e os armazenem de forma criptografada. E não podem ser pesquisadas.`,
"label.icon.158":`Nuvem`,
"font-evaluate-module-v1-bad-review ":`Quando o tipo de avaliação é Negativa`,
"UG_quota_03":`Modelo de citação`,
"label.eidt.queue.label.hasused":`O rótulo já está em uso`,
"label.lookupfilter":`Filtros de busca`,
"label.callcenter.Instance.name":`Nome da instância`,
"label.commitertype":`Tipo de apresentador`,
"vue_label_checkduplicate_any_one":`Conheça qualquer um`,
"label.campaign.channel.input.img":`Favor selecionar a imagem de seu computador local como página de agradecimento`,
"vue_label_dashboard_pleaseenterafoldername":`Por favor, digite o nome de uma pasta`,
"label.tianyancha.look":`Ver`,
"label.tabpage.lastone":`Selecione pelo menos uma operação`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} está aguardando sua aprovação`,
"label.chat.topic.delete.prompt1":`A eliminação de um tópico leva tempo, o tópico continuará a ser preservado em postos e registros até que o processo seja concluído.`,
"component_setup_label_displaybutton":`Botão de exibição`,
"label.partnerCloud.backgroundImage":`Imagem de fundo`,
"label.mobile.phone.time.range":`Faixa de tempo`,
"label.page.url.address.remark":`Digite o endereço da página web no campo "Link URL". Você pode inserir um simples URL exatamente como ele aparece na barra de endereço do navegador, ou pode usar um ou mais campos de fusão para inserir dados específicos da organização do CloudCC.com nos parâmetros do URL. Alguns sites podem não funcionar em uma guia Web por causa das configurações de segurança do navegador, ou porque o site se impediu de ser exibido em um quadro.`,
"label.h5.copyemail":`O e-mail foi copiado`,
"label.view.step3":`Passo 3 Selecione os campos a serem exibidos`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Pré-visualização`,
"label.selectapprover":`Selecione o aprovador`,
"vue_label_normal_opportunity_sf":`Oportunidade`,
"label_emailtocloudcc_filed_port":`Porto`,
"mesage.errorinsaving":`Ocorreu um erro durante a gravação. Favor entrar em contato com seu administrador.`,
"label.partnerCloud.partnerCloudName":`Por favor, digite o nome da nuvem de parceiros`,
"lable.edit.queue.checkemail":`Erro: Endereço de e-mail inválido.`,
"label_builder":`Construtor de páginas`,
"component_setup_label_setupsavefail":`Falha ao salvar as configurações dos componentes`,
"label.icon.76":`Carro`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Mensalmente`,
"message.nopermession":`Sem permissões`,
"label.view.groupscansee":`Visível para <b>certer grupos de usuários</b>`,
"label.leadscore.rule.new":`Lead Scoring Rule: Nova Regra`,
"label.new.ccpeakfolder.time":`Classes programadas: Nova Pasta`,
"label.record":`Registros`,
"message.error.flabel":`As etiquetas de campo que você forneceu não podem conter aspas simples ou duplas em inglês.`,
"label.emailobject.emaildetail.promptbutton2":`Cancelar`,
"label.h5.phone":`Ligue para`,
"label.visualpage.error.deal.with":`Ocorreu um erro, favor contatar seu administrador`,
"label.button.step1.select.field":`Passo 1 Selecione os campos`,
"label.setsharerule.step1":`Passo 1 Selecione seu tipo de regra`,
"component.chatter.file.label.title":`Carregamento de arquivos`,
"front-epwechat-module-v1-appname":`Nome do aplicativo`,
"chatter.error.notsel":`Erro: Por favor, selecione uma imagem para carregar.`,
"label.updatevalue":`Valor exato que muda de`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} documentos postados para todos em {1}`,
"label_tabpage_grid":`A exibição da grade`,
"homepage.components.standard":`Componentes padrão`,
"label.movable":`Atividades`,
"label.report.selected.field.cannot":`Os campos selecionados não podem exceder 50.`,
"label.projectManagement.distribution.by.excess":`Atribuir por horas extras`,
"addrow":`Adicionar fileira`,
"label.approvaldatamove.p":`Use as seguintes opções para gerenciar vários pedidos de aprovação. Clique em "Procurar" para filtrar a solicitação de aprovação. Quando os resultados forem exibidos em uma visualização de lista, por favor especifique a ação.`,
"label.passwordPolicy.setup.title":`Políticas de senhas`,
"label.appointmentpage.wizard.title1":`{0} ({1}) está convidando você a`,
"label.tippage.li1":`Eliminar permanentemente a fonte de dados do relatório personalizado`,
"label.campagin.roi.dcl":`Taxa de comparecimento`,
"label.h5.new.errorbody":`Estes campos obrigatórios com * devem ser preenchidos.`,
"label.cy.enable":`Habilitar moeda`,
"label.currency.rate.e":`Edite as taxas de conversão para as moedas de sua organização.`,
"or":`Ou`,
"lable.custom.Previous.CYt":`Anterior 2 CY`,
"front-epwechat-module-v1-unbound-desc":`A remoção da encadernação limpará a conta vinculada. Você tem certeza de que vai destravar?`,
"pagecreator_button_publish":`Publicar`,
"font-evaluate-module-v1-case-owners":`Notificar o proprietário do caso:`,
"label.pw.new":`Favor digitar uma nova senha`,
"message.tabsearch.nokeywords":`Por favor, digite uma palavra-chave com pelo menos um caractere`,
"label.sendemail.send.erroruser":`Usuário incorreto`,
"label.personalinfo":`Minhas informações pessoais`,
"label.case":`Casos`,
"lable.product.pricebooks.now":`Livros de Preços Existentes`,
"label.ccpeak.take.notice":`Nota: ID, Número automático, Criado por, Data de criação e outros campos do sistema não precisam inserir os valores.`,
"label.page.first":`A 1ª página`,
"label.icon.168":`Visões`,
"label.choices":`Selecione`,
"label.is.delete.document":`Você tem certeza de que quer apagar este arquivo?`,
"homepage.layout.custom":`Layouts personalizados`,
"label.emailobject.template.insert.field":`Campos`,
"label.ccpeak.folder.all":`Todas as Pastas de Classe`,
"front-console-conversation-btn3":`Encaminhar email`,
"label.ems.port":`Porto`,
"label.app.introduce":`Um aplicativo é um grupo de abas que funciona como uma unidade para fornecer funcionalidade. Os usuários podem alternar entre aplicativos usando o menu suspenso do aplicativo no canto superior direito de cada página.`,
"label.file.library.managemembers.admin":`Administrador da Biblioteca`,
"vue_label_salesadvance_win":`Ganhou`,
"label.email.click.complete.info":`Clique no botão "terminar" para voltar à página anterior.`,
"label.umeng.activity.event.willbegin":`Seu evento #evento começa em #tempo.`,
"label.mobile.phone.week.summary":`Resumo Semanal`,
"label.quickbooks.fieldlabel.terms":`Termos`,
"lable.currencyManage.advcurrencyEnabled.dis":`Permite gerenciar taxas de câmbio datadas que mapeiam uma taxa de conversão de moeda para um intervalo de datas específico. Taxas de câmbio datadas são aplicadas aos campos de moeda sobre oportunidades, produtos de oportunidade e os relatórios associados a estes dois objetos.`,
"label.weixin.data.save.failed":`Falha em salvar dados.`,
"label.service.gantt.filter.logic":`Lógica de filtragem:`,
"vue_label_pool_adopt":`coletar`,
"label.emailobject.markasunread":`Marcar como não lido`,
"label_please_select_a_member":`Favor selecionar os membros.`,
"label.salescloud.unit.ci":`Unidade(Tempo)`,
"vue_label_pool_obsolete":`descartado`,
"label.cancelall":`Desmarcar todos`,
"label.exchange.sync.state.setting.m2":`Usuários em configurações ativas do CloudCC Exchange:`,
"vue_label_pool_claimtime":`Tempo de reclamação`,
"label.forecast.forehistory.history":`História Prevista`,
"label.knowledge.article.record":`O artigo de conhecimento é inqualificável.`,
"label.setting.intergrationlist.button.uninstall":`Desinstalar Integração`,
"label_tabpage_gotit":`Entendi.`,
"label.data.exp.csvform":`Válido somente para dados exportados.`,
"UG.Forcast.06":`Por favor, selecione os usuários que têm permissão para prever`,
"vue_label_report_savereport":`Salvar relatório`,
"setup.object.field.dependency.label.mustone":`Você deve selecionar pelo menos 1 valor do campo dependente.`,
"label.batchadd.newbatchpage.des1":`O campo do nome do registro é obrigatório e, caso contrário, o registro não será salvo.`,
"lable.custom.CurrentandPreviousCYt":`Atual e Anterior 2 CY`,
"label.versiontype.Professional":`Edição Profissional`,
"label.customfields.configprofilefieldsafety":`Estabelecer segurança em nível de campo`,
"label.ccpeak.wgd.time":`Aulas programadas não programadas`,
"component.telerecord.label.subject":`Tema`,
"label_year":`Ano`,
"pagecreator_layout_label_modifylayout":`Editor de layout`,
"label.compact.layout.frame.splitline":`Linha de separação da tela direita e da tela esquerda`,
"lable.PowerProcess.enter.the.process":`{describeName} Processo de entrada`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Por favor, selecione os dados importados`,
"label.setup.mobile.bottombutton.recovery.default.success":`Estado de sucesso da inadimplência restaurada com sucesso...`,
"label.datamanage.import.accountfield":`Selecione os campos no arquivo de importação que devem ser importados para cada conta da lista abaixo. Em seguida, clique em "Próximo Passo":`,
"vue_label_opportunity_related_list":`Adicionar à lista relacionada`,
"label.group.recent":`Grupos vistos recentemente`,
"vue_label_pool_finalclaimtime":`Tempo de reclamação final`,
"vue_label_homepage_30daysnocontact":`Oportunidades de negócios sem contato por 30 dias`,
"label.tianyancha.field.error":`Os dados de Tianyancha não foram encontrados, favor entrar em contato com o administrador do sistema para realizar a inicialização`,
"label.product.go":`Ir para Relatórios`,
"label.customsetting.manage.introduce":`Se a configuração personalizada for uma lista, clique em Novo para adicionar um novo conjunto de dados. Por exemplo, se sua aplicação tivesse uma configuração para os códigos de país, cada conjunto poderia incluir o nome do país e o código de discagem.`,
"label.task.dateadd":`Mais`,
"label.email.recipients.select":`Favor selecionar os destinatários`,
"chatter.emailListMyChat":`Gosta de um post ou um comentário que eu fiz`,
"label.batchadd.newbatchpage.save.name":`Se o nome for nulo, o sistema não adicionará este registro por padrão, certifique-se de que o nome não seja nulo e, em seguida, salve.`,
"UG_Lead_011":`Criar uma pista`,
"vue_label_salesfunnel_notice2":`Oportunidades totais em curso`,
"APPIntegration_Social_linkedinerror":`Você deve digitar uma URL válida para linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Nome da Conta de Consulta em Tempo Real`,
"label.stdashbord.xsld.business.ajssx":`Por Função`,
"lable.info.queue.showalluser":`Ver todos os usuários`,
"label.generatepage.c1":`Deve implorar com uma letra. Deve conter apenas letras maiúsculas e minúsculas, números e sublinhado.`,
"label.thenset":`E então, de acordo com`,
"label.salescloud.salescloud.defaultteam":`Grupo de usuários com oportunidades padrão`,
"label_partner_workspace_tab_selectedoption":`Abas selecionadas`,
"label.tippage.li":`Eliminar fonte de dados do relatório personalizado will：`,
"lable.quote.syncingfrom.syncingto":`Os produtos de oportunidade foram sincronizados para citar itens de linha`,
"label.emailobject.delete":`Excluir`,
"label.data.selectimportobject":`Selecione os objetos a importar`,
"label.knowledge.language.dutch":`Holandês`,
"message.campaign.page.overtime":`A página expirou.`,
"label.ccchat.message.search.desc4":`Verifique a ortografia das palavras de busca.`,
"label.login.forgetPsd":`Esqueça a senha`,
"vue_label_title_order":`Ordem`,
"template.report.contract.follow.status":`Status do Contrato de Acompanhamento`,
"label.forecast.edit.kjnd":`Ano fiscal`,
"front-electronic-export-listTitle":`Lista de chimpanzés por correio`,
"label.dataimport.error.khmc.notnull":`Erro: você deve digitar o nome da conta`,
"label.testobject":`Objeto de teste`,
"label_chatter_nextStep":`Próximo passo`,
"label.file.public.link.share":`Compartilhamento de links públicos`,
"label.weixin.organization.name":`Nome da organização`,
"label.quote.email":`Email`,
"label.reg_field":`Campo regular`,
"font-evaluate-module-v1-response":`Responder após a avaliação:`,
"label.chatter.sendmail":`Enviar e-mail`,
"label.weixin.start.incorrect":`Formato inválido da data de início`,
"component_chatter_link_label_url":`Link url`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Sim, eu quero habilitar o Gerenciamento Avançado de Moeda.`,
"label.east.africa.time":`Tempo da África Oriental`,
"label.product.proof.Three":`Em {0}, favor escolher um mínimo de {1} opções de produtos, mas até {2}.`,
"label_emailtocloudcc_filed_password":`Senha`,
"component.task.label.person":`* Pessoa designada`,
"pagecreator_systemstyle_label_buttonareacolor":`Cor da área de operação`,
"label.clearrule":`Regras claras`,
"lable.customer.access":`Permissão de acesso à conta`,
"label.finish.wait":`Seu pedido foi processado, por favor tenha o cuidado de verificar a notificação de conclusão em sua caixa postal.`,
"label.weixin.appr.auditor":`Aprovador`,
"label.tabpage.systemz":`Sistema(s)`,
"label.file.nocan.process.desc":`Incapaz de processar solicitações. não podemos lidar com a entrega do conteúdo`,
"label.relationobject.name":`Nome do objeto relacionado`,
"setup.layout.group.relatedlist":`Listas relacionadas`,
"label.generatepage.title":`Página da Web para CloudCC`,
"label.page.step3.input.url.information":`Passo 3 Digite os detalhes da URL`,
"label.change.to":`Mudar o status de membro da campanha para`,
"label.validate.function.funcFormat.TIMEVALUE":`VALOR HORÁRIO(data)`,
"label.partnerCloud.seriesSettings":`Configuração da família de produtos`,
"component.timeline.label.1monthahead":`1 mês antes`,
"label.batchadd.senumberpage.selnum":`Selecione o número de registros a serem adicionados`,
"label.downloadapp":`DISPONÍVEL EM`,
"label.dashboardSetup.showmainpage":`Exibido na página inicial`,
"label.h5.nophoneprompt":`O colega não inseriu o número de contato`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Você quer excluir o filtro "{nome}"?`,
"label.appupload.state1":`Enviado para`,
"component_timeline_button_filter":`Filtro`,
"label.passwordPolicy.setup.subtitle":`Defina as restrições de senha e as políticas de bloqueio de login para todos os usuários.`,
"vue_label_normal_quote_sf":`Citação`,
"label.productsales.today.noevttskaddall":`Não há eventos e tarefas em aberto, você pode clicar em " " no canto superior direito para adicionar novos eventos e tarefas.`,
"label.projectManagement.no.end.date":`Sem data final`,
"label.sendmail.batch.chosetemplate":`E-mail em massa: Selecione um modelo`,
"serviceterritorymember.serviceresource.isactive.notactive":`Este recurso de serviço não está habilitado. Você pode atribuir os territórios de serviço a um recurso de serviço habilitado.`,
"label.notification.event.overlapEvent.continue":`Continuar`,
"label.appupload.component.type.obj":`Objeto personalizado`,
"label.partnerCloud.financeSetting.basicConfiguration":`Caminho de acesso: Plataforma Pública  Desenvolvimento  Configuração Básica`,
"lable.outlook.detail.info":`Detalhes da Configuração da Sincronização de Câmbio`,
"vue_label_commonobjects_detail_activity_commingevents":`Próximo evento disponível`,
"coderules.nullvalue2":`Falha na geração. Favor inserir o valor para 【{0}】,【{1}】 usado nas regras de geração.`,
"label.version.sum.workflowrule":`regra(s) de fluxo de trabalho`,
"label.sso.saml.idp.config.enable":`Habilitar o Provedor de Identidade`,
"label.temp.exp.conf":`Você tem certeza de que quer exportar o modelo?`,
"label.department":`Departamento`,
"label.trigger.operation.email.template":`Obter informações sobre modelos de e-mail`,
"label.page.content.frame.height":`Altura da moldura do conteúdo (pixels)`,
"label.ServiceCloud.jinengyaoqiu":`Requisitos de habilidades`,
"PageLayout.Search.MultiSearch.001":`Selecione até 3 campos.`,
"label.error500":`Oops!Erro...<br />Por favor, contrate o administrador...`,
"label.appexchange.download.stop":`Parar a instalação com conflito`,
"label.service.dispatchingUnits.left.right.totalAll":`Atualmente, {esquerda}-{direita} registros, {totalCount} registros no total.`,
"label.tabpage.haschangedz":`Este chumbo foi convertido`,
"label.industrialandcommercialverification.button.cancel":`Cancelar`,
"label.edit.role":`Edição de papéis`,
"label.mr.descreption.condition2":`Regras - de acordo com os primeiros caracteres: digite um número, encontre as duplicatas de acordo com os primeiros caracteres do número inserido.`,
"label.testgrammer":`Verificar a sintaxe`,
"label.age":`Idade`,
"lable.real.time.chat":`O suporte técnico de conversação em tempo real é fornecido pela Easemob. Por favor, configure configuração avançada na Easmob.`,
"vue_label_opportunity_selected":`{sum} selecionado`,
"label.weixin.optionone":`Escolha 1`,
"label.file.delete.public.link.desc":`A eliminação do link público significa que ninguém pode acessar o arquivo com essa url.se você criar uma nova, será uma URL diferente.`,
"label_tabpage_cancel":`Cancelar`,
"template.report.opportunity.analysis":`Análise do Estágio de Oportunidades`,
"label.escalation.setup.newrule.inputrule":`Digite o nome da regra`,
"label.ccpeak.getapi.name":`Direcione o nome API do campo enquanto obtém o valor recorde:`,
"second":`A Segunda`,
"label_tabpage_uploadsz":`Upload`,
"label.description":`Notas`,
"label.ccchat.person.invite.notsamepwd":`Senha inconsistente`,
"label.mobile.app.isEnableAblumWatermark":`Adicionar marca d'água à foto selecionada dos álbuns móveis no checkin`,
"vue_label_allsearch_searchable_items":`Itens pesquisáveis`,
"lable.outlook.detail.react":`Atividades recentes`,
"label.sales.team":`Equipe de Oportunidades`,
"label.guif.standard.time":`Tempo padrão do Golfo`,
"label.emailobject.emaildetail.button.forward":`Avançar`,
"label.refused":`Rejeitado`,
"homepage.components.one":`Passo 1 Digite o nome do componente personalizado`,
"day":`Dia`,
"label.dataimport.error.number":`Erro: Número`,
"label.customer.tab.step2.same.option2":`Default Off`,
"component_button_ok":`Confirme`,
"label.allrecordmeetprocess":`Todos os registros devem entrar nesta etapa`,
"label.version.onefile.size":`Tamanho de cada anexo carregado`,
"label.partnerCloud.orderingPlatform.allProducts":`Todos os produtos`,
"pagecreator.page.message.publish.success":`Página publicada com sucesso`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Gama Anterior`,
"label.attendance.persons":`Usuários Adequados`,
"label.send.an.email":`Envie um e-mail`,
"registration.page.browser.title":`Registro do Canal de Marketing Campagin`,
"label.importfilestep3":`Passo 2 Selecione e carregue seu(s) arquivo(s)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Faixa seguinte`,
"label.ems.no.sync.msg":`Você ainda não configurou as informações de sincronização de correio.`,
"label.total_views":`Prévisualização do envio do formulário`,
"label.knowledge.article.notnull":`Por favor, escolha pelo menos um artigo.`,
"message.error.view.lastview.delete":`Não é possível excluir a última visualização de lista pública</br> Não é possível excluir a última visualização de lista pública que é visível para todos os usuários.<br>>br>>br>`,
"label.integrations.second.half":`peça(s) de dados, selecione os dados importados`,
"vue_label_systemSettings_mobelparams":`Configuração de parâmetros de aplicativos móveis`,
"message.choose.maximum":`Você pode escolher até 150 registros para compartilhar, agora`,
"vue_label_homepage_won&unprocessed":`Aberto Não processado`,
"UG.contact.01":`Como tirar o máximo proveito de seus contatos?`,
"label.data.import.setup.remark":`O administrador pode definir as regras a serem executadas ao importar dados, incluindo se deve executar regras de validação, gatilhos e duplicação e regras de correspondência.`,
"pagecreator_layout_message_delete_success":`Layout excluído com sucesso`,
"lable.account.name":`Nome do Trimestre Fiscal`,
"label.userinfo.must.updatepwd":`Por segurança, você deve mudar sua senha.`,
"label.mobile.phone.subordinate.setup":`Não é possível definir para conter subordinados, favor selecionar todos e defini-los para permitir previsões.`,
"label.monitorsys.delete.date":`Apagar Data`,
"label_emailsync_form_emailaddress":`Endereço de e-mail`,
"label.projectManagement.cancelled":`Cancelado`,
"label.partnerCloud.partnerAccount.rechargeAmount":`O valor da recarga deve estar entre 0,1 e 100000000.`,
"label.select.relatedlist.approval.layout":`Selecione Listas Relacionadas para exibir no Layout da Página de Aprovação`,
"label.userphoto.thumbnail":`Miniatura`,
"label.assignment.setup.list.rulename":`Nome da Regra`,
"label.emailtemplate.usemergefields":`Fundir campos em modelo de e-mail`,
"label.tabpage.enabletomobile":`Se a ativação do lado móvel`,
"setup_layout_label_desc":`Descendente`,
"vue_label_pool_abandonreasondiscription":`Descrição do motivo do descarte`,
"label.ems.outputmails":`Enviar servidor de e-mail (smtp)`,
"font-evaluate-module-v1-evall":`Todas as avaliações`,
"front-epwechat-module-v1-unbound-tips":`Os seguintes dados serão esclarecidos após a desobrigação:`,
"label.weixin.number.data":`Dados`,
"front-objectTemplate-V1-UseObject":`Objeto aplicável`,
"label.call.center.configuration":`Configurações do Call Center`,
"vue_label_systemSettings_website":`Portal de atendimento ao cliente`,
"lable.currencyAdv.foreverdate":`Data permanente`,
"label.globalselect.view":`Veja a lista de valores da opção definida`,
"component_newrecords_label_title":`Registros recentes`,
"component_assistant_label_title":`Assistente`,
"label.equals.deletebut.bulk.delete":`Inclui botão de apagar, apagar em massa (para Reciclagem)`,
"label.field.duplicate.error.msg4":`Erro: Dados inválidos.`,
"label.input.right.date":`Favor inserir o formato da data válida`,
"file.error.notsel":`Erro: favor selecionar o arquivo a ser carregado`,
"label.customcomponent.page.add.title":`Novo componente personalizado`,
"message.chooseatleastthreefield":`Escolha pelo menos 3 campos`,
"label.dataimport.system.unnecessary":`o sistema não pode determinar vários`,
"message.login.wrong":`Nome de usuário ou senha incorretos.`,
"label.appupload.install.recheck":`Verifique novamente`,
"label.ems.option":`Opção`,
"label.wei.subject.img":`Ícone do assunto`,
"chatter.emailReceiveOrNotAccept":`Selecione esta opção para permitir o lembrete CCChat, desmarcando esta opção impede que você receba o lembrete ccchat.`,
"label.icon.46":`Fornalha`,
"label.newpw":`Nova senha`,
"font-evaluate-module-v1-praise":`O tipo de avaliação é Positivo`,
"label.help.user":`Guia do Usuário`,
"label.callcenter.no.searchs":`Nenhuma consulta relevante para as informações`,
"UG_homepage_007":`Do envio de e-mails de acompanhamento à automatização de campanhas de vendas, da criação de fluxos de trabalho utilizando nossa tecnologia Blueprint ao acionamento de macros personalizadas, automatizar tarefas diárias e focar mais na construção de relacionamentos.`,
"label.saveandnew":`Salvar`,
"component_salesperformance_label_70finish":`Terminado - não processado (>70%)`,
"lable.account.dp":`Esta página permite que você defina anos fiscais personalizados.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} está em estado crítico. Favor processar o mais rápido possível`,
"label.workflow.edit.esimaterule":`Erro: você não pode alterar os critérios de avaliação para "toda vez que criar ou editar um registro" enquanto você tiver tempo de acionamento associado a esta regra.`,
"label.partnerCloud.basicSetting.feature":`Configurações funcionais`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Este serviço suporta apenas a China continental)`,
"vue_label_homepage_components":`Favor selecionar os componente`,
"label_chatter_allactivity":`Todas as atividades`,
"label.quickcreate.title":`Criação rápida de layouts`,
"label.tabpage.exclusivez":`Excluir`,
"front-service-cloud-transfer-desc":`Ao transferir o proprietário da lista técnica do ativo, o ativo circulante e o próprio ativo sob o ativo serão mudados de proprietário`,
"label.data.downpage.i.list.desc1":`Durante a importação, os dados que não são importados com sucesso porque os dados estão formatados incorretamente, ou porque o gatilho ou a regra de validação falha, gera o arquivo CSV a ser exibido na página atual. Os dados importados com sucesso não serão exibidos na página atual.`,
"template.report.individual.case.status":`Situação dos casos`,
"label.report.export.file.format":`Formato: Formato Excel .csv`,
"vue_label_filternotice1":`Ou seja, cada condição de filtro é cumprida ao mesmo tempo, por exemplo: 1 oportunidade de negócio com um montante superior a 1 milhão de oportunidades de negócio, 2 é uma oportunidade de negócio com uma data de contrato estimada igual a este mês, e o resultado da filtragem mostra oportunidades de negócio superiores a 1 milhão este mês; quando <estilo de varredura="cor: vermelho">o filtro avançado está habilitado</ varredura> Quando você precisa filtrar manualmente as condições para a caixa do filtro avançado`,
"label.lead.score.confirm1":`Isto pode levar vários minutos. Você receberá um e-mail de confirmação uma vez concluído.`,
"label.scores":`Pontuações`,
"label.dashboard.message.mainnoset":`O painel de bordo doméstico não está configurado`,
"label.customfields.optionlist.fieldvaluelist":`Favor inserir valores, com cada valor separado por uma nova linha`,
"label.autosearch.title":`Busca de título completa automaticamente`,
"label.knowledge.setting.hint.seventeen":`Criar alguns artigos`,
"label_tabpage_closez":`Fechar`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Carrinho`,
"label.recalculate":`Recalcule`,
"label.umeng.approval.approvalmes4obj":`#numsucc records foram aprovados em #obj, #numfailed reocrds não foram aprovados.`,
"label.appointment.wizard.subtitle2-2":`Para`,
"label.validate.function.funcExplain.AND":`Verifique se todos os parâmetros são verdadeiros. Retornar TRUE se todos os parâmetros são verdadeiros.`,
"label.recordtype.batchaddattachments.remark":`Passo 1 Escolher arquivo, Passo 2 Arquivo, Passo 3 Clique no botão "start upload", carregar arquivos, Passo 4 Clique no botão para finalizar.`,
"label.reportlist.findreport":`Encontrar relatórios`,
"label.partnerCloud.financeSetting.enterAppsecret":`Por favor, digite Appsecret`,
"label.campagin.roi.query2":`Ver Canais de Marketing ROI`,
"label.sendmail.notice.immediately":`Enviar notificações por e-mail`,
"label.file.library.managemembers1":`Gerenciar membros`,
"label.forecast.customforecast.foredis.yclb":`Categoria Previsão`,
"label.no.target.model.available.":`Nenhum modelo indicador disponível. Favor criar primeiro o modelo indicador, ou entrar em contato com o administrador do sistema.`,
"label.quote.contactname":`Nome do contato`,
"label.customer.tab.step2.same":`Aplicar visibilidade de uma aba a todos os perfis`,
"UG_product_03":`Manual de preços com suporte de várias moedas`,
"label.pc.system.prompt":`Pronta do sistema`,
"homepage.components.description":`Descrição do componente`,
"front-email-payment-safety-code":`Código de Segurança`,
"label.the.extra.reward.group.describes":`Adicionar descrição do grupo de linha de cotação`,
"label.isEnableVisualpage.new.rightlist":`Páginas Personalizadas Ativas`,
"label.icon.84":`Transformador`,
"label.chat.message.to":`Receptor`,
"lable.product.pricebooks.edit":`Edição do Livro de Preços`,
"label.partner.workspace.member.belong":`Pertence a`,
"pagecreator_systemstyle_message_delete_success":`Estilo eliminado com sucesso`,
"label.salescloud.teamrole.message.chooseatleastone":`Por favor, selecione pelo menos um usuário.`,
"label.knowledgebase.self.window":`Janela Idêntica`,
"label.product.cost":`Custo`,
"label.imgfield.remove":`Fotos claras`,
"label.event.lastweek":`Semana passada`,
"template.report.today.statistics":`Vendas de Hoje`,
"label.emailobject.recipients":`Destinatários({0})`,
"vue_label_commonobjects_view_successfully":`Definir a visão padrão com sucesso`,
"label.uploadfail.typeerror":`O upload falhou, o tipo de arquivo é inválido.`,
"vue_label_lead_required_fields":`Favor preencher os campos obrigatórios`,
"front-console-reopen":`Reabrir`,
"message.layout.unique.relatedlist":`Favor retornar às restrições exclusivas da lista relacionada no layout da página, favor confirmar e salvar novamente.`,
"label.emailobject.emaildetail.nextactivity":`Próximas atividades`,
"label.publicgroup.save.error":`Erro: um dos seguintes grupos já é o grupo mãe deste grupo`,
"label.editdefaultshare.tip":`Edite abaixo os padrões de compartilhamento em toda a sua organização. A alteração destas inadimplências fará com que todas as regras de compartilhamento sejam recalculadas. Isto pode exigir recursos e tempo significativos do sistema, dependendo da quantidade de dados em sua organização.`,
"label.icon.53":`Carro`,
"label.exchange.sync.state.setting.m3":`Usuários com endereços de e-mail Microsoft Exchange e CloudCC vinculados:`,
"label.currency.enable":`Moedas: Habilitar moeda`,
"component.timeline.label.past":`Atividades passadas`,
"workflow.action.tasks.assignortype.user":`Usuário`,
"setup_layout_label_relatedlistsetup":`Configurações da lista relacionada`,
"label.systemadmin":`Administrador de sistema`,
"label_tabpage_allz":`Todos`,
"label.ems.subject":`Assunto`,
"message.recordtype.selectlayout.tip":`Selecione o layout da página que os usuários com este perfil vêem para registros com este tipo de registro. Após salvar, escolha os valores da lista de seleção que estão disponíveis com este tipo de registro.`,
"label.current.version":`Versão atual do programa`,
"label.sourceoffile":`Sem tradução - Produz um conjunto de arquivos, por idioma, com texto que ainda não foi traduzido`,
"label.file.versionerror":`Favor usar a guia de recursos de arquivo na nova versão da interface`,
"label.validate.function.funcExplain.MINUTE":`Minuto de retorno do dia (dos campos de data/hora)`,
"abel.setup.mobile.bottombutton.profile.setting":`Personalizar o menu inferior do perfil`,
"label.recycle.dis.tip3":`Selecione Minha Lixeira a partir da lista suspensa para visualizar os itens que você excluiu. O administrador pode selecionar Toda Lixeira para visualizar todos os dados da organização que foram excluídos.`,
"message.selectnothing":`Nenhum Selecionado`,
"label.develop":`Desenvolver`,
"label.tab.lightningpage":`página da versão relâmpago`,
"label.chat.micropost.share.info":`Compartilhe`,
"label.block.pricing.editor":`Editor de preços de blocos`,
"label.ccchat.file.unavailable":`Este arquivo não está disponível`,
"label_component_helper_businesschange_0UntreatActivity":`Oportunidades sem atividade não processada`,
"label.search.setup.obj":`Pode colocar no máximo 100 objetos.`,
"component.setup.button.cancel":`Cancelar`,
"message.longtextareamaxlength":`O comprimento não pode exceder 32.000 caracteres`,
"vue_label_chat_removedby":`Você foi retirado do bate-papo do grupo pelo "Administrador".`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Não pode ser inferior a 8 caracteres`,
"label.informassigner":`Notificar a Pessoa Designada`,
"font-evaluate-module-v1-not-received":`Nunca receber qualquer avaliação de satisfação dos contatos`,
"label.trigger.triggertime":`Tempo de acionamento`,
"label.attendance.cannot.make":`Incapaz de marcar`,
"label.shouldallrecords":`Todos os registros devem ser incluídos no cálculo`,
"label.eidt.queue.alter1":`Por favor, selecione os membros da fila`,
"L":`Lista de picking`,
"label_emailtocloudcc_filed_email":`Email`,
"label.productsales.contract.badversion":`Sua edição atual não suporta a visualização do objeto do contrato, portanto você não pode visualizar os valores do contrato.`,
"label.tabpage.operation":`Operação`,
"label.file.copy.public.link":`O link público foi copiado`,
"label.all.SMS":`TODOS os alertas SMS`,
"UG_opportunity_008":`Equipe de oportunidade`,
"UG.Campaign.002":`Planejar, executar e monitorar a eficácia das atividades do mercado.`,
"label.jiandangfenpei.title":`Atribuição de perfil`,
"pagecreator.systemstyle.message.delete":`Você apaga o estilo selecionado atualmente?`,
"lable.outlook.mcto.repeat":`Se forem encontrados registros duplicados, o e-mail é associado com o`,
"label.user.field":`Campos de usuário`,
"vue_label_commonobjects_detail_market_hierarchy":`Hierarquia de mercado`,
"label.ems.emails":`Emails`,
"label.tabpage.deleteviewfailed":`Ver exclusão falhou`,
"label.data.exp.new.expobjtemp":`Criar o modelo de objeto exportado`,
"label.useformulassetval":`Usar fórmulas para definir novos valores`,
"label.service.newBuildDialog.six.fields":`Podem ser selecionados até 6 campos.`,
"error":`Erro`,
"template.chart.sdyyfx":`Análise da Razão Perdida`,
"label.icon.191":`Bigode`,
"label.app.step3.tabused":`Separadores selecionados`,
"label.user.level":`Nível do usuário`,
"label.custombutton.querydata.notexist":`Os dados não existem.`,
"label.executestate.calculating":`Calculando...`,
"label.visualpage.folder.notdel2":`1.Esta pasta contém arquivos e não pode ser apagada.2.Esta pasta contém arquivos ocultos e não pode ser apagada. Um arquivo oculto é criado a partir de um objeto lógico de exclusão (exclusão de Setup-Create-Obkects), que está oculto porque o objeto não é realmente excluído.`,
"vue_label_report_conditiondesc_three":`Você será notificado se todas as condições forem cumpridas`,
"approval.request.email.subect":`Pedido de Aprovação`,
"label.log.user.value":`Por favor, digite o nome do usuário para pesquisa!`,
"label.isCompanyCurrency":`Corporativo`,
"label.related.2018":`Listas relacionadas`,
"label.tonga.time":`Tempo de Tonga`,
"message.actionfailed":`A ação fracassou`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`A identificação do objeto da consulta não pode ser nula.`,
"label.list.userinterface.setup":`Interface do usuário`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`O formato do email é incorreto. Favor entrar novamente`,
"label.chatter.content":`Conteúdo`,
"label.projectManagement.Addnotes":`Adicionar Notas`,
"label.service.newBuildDialog.reservation":`Mostrando encomendado`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Os não-membros do grupo não podem convidar os usuários para participar de chats de grupo`,
"label_partner_workspace_member_belong":`Pertence a`,
"label.task.modify":`Tarefa Editar`,
"label.tabpage.transformationsz":`Converta`,
"label.new.password.no.indexof":`A nova senha não pode conter caracteres e espaços chineses.`,
"label.ji.quarter":`No. {a} Trimestre`,
"label.sso.isActiveNo":`Não`,
"label.mobile.phone.week.report":`Notas de trabalho semanais`,
"label.email.template.please.select.folder":`Favor escolher uma pasta`,
"label.pc.ui.2018.tab.groups":`Grupo de menu`,
"label.h5.approval.status":`Status de Aprovação`,
"setup.mainpage.label.welcome27":`A plataforma CloudCC fornece funções como importação, exportação, exclusão de lotes e transferência de lotes de todos os dados de objetos do sistema.`,
"vue_label_systemSettings_setHomePage":`Instalação`,
"label.select.button":`Botões disponíveis`,
"label_emailsync_status_enable":`Conexão Ativa`,
"label.trigger.triggerVersion.detail":`Este campo não é editável. Existem atualmente duas versões de gatilhos, 1.0 e 2.0, e todos os novos gatilhos são 2.0, a versão 1.0 foi proibida de ser criada.`,
"pagecreator_layout_message_save_fail":`Falha no layout`,
"label.salescloud.salesdashboard.10big":`Top 10 Oportunidades nos próximos 3 meses`,
"label.file.share.size":`O maxinum share e publiclink de cada arquivo é`,
"label.page.simple":`Simples`,
"pagecreator.page.message.delete":`Você exclui a página selecionada atualmente?`,
"label.weixin.newspaper.coverage.detailinfo":`Informações detalhadas sobre a folha de risco`,
"label.list.userinterface.chattersetup":`Configurações do CCChat`,
"lable.opppdt.addpdt.table.quantity":`Quantidade`,
"label.product.description":`Descrição do produto`,
"button_partner_back":`Retornar`,
"label.user.current.loginuser.sessionid":`O SessionID atual do usuário logado é:`,
"label.otherreport":`Outros relatórios`,
"pagecreator_button_mobilepage":`Lado móvel`,
"label.mobile.phone.state":`Status`,
"lable.currencyManage.unenableCurrencyAdv":`Desativar o Gerenciamento Avançado de Moeda.`,
"lable.product.addp":`Adicionar preço`,
"label.field.validate.notpass":`Sem erros de sintaxe.`,
"label.app.global.search.obj":`Até 10 objetos que você pode configurar para usar na busca global.`,
"label.group.archived":`Arquivo`,
"vue_label_approve_to_submit":`Para apresentar`,
"showfrom":`Mostrar de`,
"chatter.emailNotification":`Notificações por e-mail`,
"label.callcenter.pleaseenter.enterprise.number":`Por favor, digite o número do empreendimento.`,
"label.forecast.customforecast.forecastnumber":`Números Previstos`,
"label.vlidaterule.messagelocation":`Localização do erro`,
"label.h5.similar.opportunity.step3.conment":`A coluna Relevância, que representa o número de campos correspondentes, será sempre exibida.`,
"label.ccchat.group.gd.setting.info":`Modificar as configurações do grupo CCChat`,
"label.knowledgebase.delete.article.succeeded":`Eliminar artigo com sucesso`,
"message.layout.edit":`O gerenciamento do layout da página é uma função separada de valor agregado. Se sua organização confirmar que adquiriu o módulo de função, solicite a senha ao administrador do sistema. Entre em contato com o CloudCC.com para saber mais.`,
"label.case.create":`A caixa ({0}) é criada`,
"label.icon.170":`Compras`,
"message.error.contact.null":`O contato não pode estar vazio`,
"label.appupload.install.error.hasinstalled":`Este pacote de software já está instalado em sua organização. antes de instalar a nova versão, você precisa desinstalar a versão instalada primeiro.`,
"label.service.miniProgram.imageType":`Os formatos PNG, JPG e JPEG são suportados. São recomendadas imagens de 750*349 pixels. Passe o mouse sobre a imagem para carregar novamente ou excluir.`,
"label.leadscore.rule.edit":`Lidera a regra da pontuação: Regra de edição`,
"vue_label_commonobject_anytime":`A qualquer momento`,
"label.clearing.conditions":`Condições claras`,
"label.campagin.roi.ydkhjhze":`Quantidade total de oportunidades conquistadas pelos clientes`,
"Lead_Auto_Scoring_Setting_001":`Pontuação automática ao editar ou salvar (exceto os cabos que são importados em lote ou criados pela interface)`,
"pagecreator.systemstyle.label.buttonareacolor":`Cor da área de operação`,
"label.batchregist.huanxinuser.finish":`A inscrição de usuários em massa foi concluída`,
"UG_opportunity_006":`Gênio das oportunidades`,
"message.serviceappo.violation":`Violação do período de designação: está em conflito com outra designação de serviço.`,
"label.recordtypeselect.selectnew":`Selecione um novo tipo de registro`,
"Lead.Tools.BatchScoring":`Pontuação do Lote de Chumbo`,
"label.partnerCloud.financeSetting.enterWechat":`Favor entrar na conta do comerciante WeChat.`,
"label.philippine.time":`Hora das Filipinas`,
"five":`Cinco`,
"label_average_value":`AVERAGEM`,
"message.realdelete":`Você tem certeza?`,
"label.currency.note":`Digite as informações para a nova moeda. Observe que você não pode excluir uma moeda uma vez ativada.`,
"label.projectManagement.delete.prompt":`Excluir Pronto`,
"label.approval.present":`(Atual)`,
"label.escalation.setup.newrule.name":`Nome da Regra`,
"label.edit.list":`Lista de dados editável`,
"label.partnerCloud.financeSetting.informationOne":`1. Visite Alipay merchant center (b.alipay.com) e faça o login com o assinante Alipay.`,
"label.customfields.numberText":`2. A soma do comprimento do número inserido e o número de casas decimais não deve exceder 18 casas.`,
"label.biaoqing.businessverify.relation.tip":`Escreve o valor retornado do licitante no campo de chumbo`,
"label.icon.149":`Robô`,
"System.btn.SaveAndCommit":`Salvar e enviar`,
"label.calendar.many":`Multiusuário`,
"label.ccchat.create.email":`O email foi criado`,
"template.report.income.marketing.activities":`Relatório da receita da campanha`,
"label.ccchat.person.invite.needemail":`Digite um endereço de e-mail.`,
"template.report.open.amount":`Montante não fechado`,
"label.currentoperate":`Ações selecionadas`,
"label.finalapprove":`Aprovação final`,
"label.emailmerge.mergepage.step2":`2. Selecione o modelo de fusão de correio, até 20:`,
"label_tabpage_sorttypez":`Tipo de ordenação`,
"label.workbanch":`Minha bancada de trabalho`,
"font-evaluate-module-v1-disable":`Você tem certeza de desativar this？`,
"label.ServiceCloud.distributionMap":`Mapa de distribuição`,
"lable.Confirm.potential.customers":`Confirmar para coletar {num} leads.`,
"label.mobile.quickcreate.default.nearby":`Nas proximidades`,
"label.isremider.noremider":`Sem lembrete`,
"label.approval.select.step":`Selecione qual etapa de aprovação deve retornar`,
"chatter.error.pm":`Erro: O tamanho do arquivo é muito grande.`,
"UG_activity_08":`Reserve um horário`,
"label.marketsea.notwinopportunitydays":`Número de dias sem um negócio (precisa ser maior do que o número de dias sem criar uma oportunidade de negócio)`,
"label.selectpage":`Selecione uma página existente`,
"label.dashboard.dispalyOnTheHomePage":`Página inicial despalhada`,
"front-lightning-module-v1-details-page-chart-set-report":`Elaborar relatório`,
"vue_label_pool_mydeal":`Meu acordo`,
"vue_label_report_lastone":`Último`,
"label.tabpage.potentialcustomersz":`Líderes`,
"font-evaluate-module-v1-more-satisfied":`Nós não somos bons enough。 Nós o deixaremos mais satisfeito da próxima vez!`,
"label.trigger.instructions":`<p>Instruções para Use：</p>>p>li>Parâmetros podem ser diretamente citados:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li>>li>Quando desejar obter o valor do registro, por favor, "obtenha" diretamente o nome do campo API do campo</li>>li>Se criar novo registro, use "String id = IDGenerator".generateID("ID Prefixo")"</li><li>>Se precisar retornar mensagem de erro:Por favor, use "trigger.addErrorMessage("")";trigger irá retornar na linha atual,Sem execução mais longa Down！</li></p><font color="red">Nota:Suporte máximo 200KB caracteres,Cerca de 200.000 Bytes.</font><font size=3 color="red">【Key：Must Adicionar Notas!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Taxa de conclusão do compromisso`,
"label.umeng.approval.dlsp.approvenew":`Aprovação delegada: #actorname solicita aprovação #objapiname#recordname`,
"label.edit.visualpagefolder":`Página Personalizada : Editar Pasta`,
"label.pc.flash.teach":`Ensino de vídeo`,
"label.showsearch":`Mostrar Busca`,
"label.reportsSubscriptionPage.condition.title1":`Você será notificado quando todas as condições forem cumpridas(AND)`,
"label.h5.search.result":`Conde`,
"vue_label_commonobjects_view_chart_pie":`Gráfico de torta`,
"label_please_enter_currency":`Por favor, digite a moeda`,
"chatter.share.to.profile":`Seu perfil`,
"label.mykeeptouchset":`Minhas configurações de Keep In Touch`,
"label.profile.mustcopyaprofile":`Você deve selecionar um perfil existente para clonar.`,
"label.managereport":`Gerenciar Relatórios`,
"label.total.choice":`arquivos, selecionados`,
"label_emailtocloudcc_help":`Por favor, digite a senha correta do e-mail ou o código de autorização. Se seu servidor de e-mail precisar ligar o serviço IMAP/SMTP para fazer o login por uma conta de terceiros, você deve entrar nas configurações da conta de e-mail para ativar o serviço primeiro, e copiar o código de autorização aprovado para esta caixa de entrada de senha.`,
"label.trigger.sel":`Gatilhos nesta pasta`,
"label.dashboardLookUp":`Ver Painel de Controle`,
"label.batchadd.newbatchpage.save.emptytext":`Favor verificar se há informações obrigatórias não preenchidas.`,
"setup.mainpage.label.welcome16":`Instruções: Clique no menu do lado esquerdo da página → Application Settings → Create → Workflow, Approval Process, Tasks, Email Notification, Field Update, e mais.`,
"vue_label_email_mark as":`Marcar como`,
"label.customobjdel.cannot.delete.try":`O objeto não pode ser apagado porque está associado com a seguinte relação de outros objetos.`,
"label.customsetting.visible.public":`Público`,
"label.log.bit":`Bits`,
"label.data.exportall.all.desc":`Exporta todos os dados para todos os objetos que o usuário atual tem permissão para visualizar.`,
"message.login.mfadevice.already.bound":`O usuário já vinculou o dispositivo AMF.`,
"label.campaign.channel.please.img":`Favor fazer o upload da imagem`,
"assetbom.manage.notpermission":`Favor entrar em contato com seu administrador para permitir o acesso de gerenciar a lista técnica de ativos.`,
"schedstarttime.schedendtime.time.illegal":`A hora programada para o início do serviço deve ser menor ou igual à hora real de término.`,
"label.referperson":`Proprietário`,
"front-email-payment-area":`Distrito`,
"label.c.d.least":`Cada registro "C" deve ter pelo menos um registro "D" relacionado.`,
"label.weixin.longitude.isnull":`A longitude e a latitude estão vazias ou são inválidas`,
"setup.layout.button.ok":`Confirme`,
"vue_label_fiter_component_date_customdate":`Data personalizada`,
"label.enable.case.createarticle":`Permitir que os usuários criem artigos a partir de casos.`,
"label.event.moveup.8hour":`8 horas à frente`,
"label.input.most.string":`Por favor, digite até {0} caracteres`,
"lable.SalesCommitmentKanBan.contractEndDate":`Data de término do contrato`,
"label.visualpage.function.name":`Diga a função a ser:`,
"label_emailtocloudcc_redmessage1":`Endereço de e-mail inválido`,
"message.aliasnameinput":`Erro: O nome deve ser único, e implorar com uma carta. Ele deve conter apenas letras e números.`,
"label.data.exp.selectedtemp":`Selecione o modelo utilizado para a exportação de dados`,
"label.import.page1.suitedwayoflinkman":`Estilo de contato correspondente`,
"label.customsetting":`Configurações personalizadas`,
"label.versiontype.Free":`Plano Livre`,
"setup.layout.label.norelatedlist":`Nenhuma lista relacionada`,
"label.forecast.edittotal.de.leiji":`Rollup de`,
"label.customfields.file.max":`O arquivo carregado é muito grande, por favor não exceda 5m`,
"label_partner_all_workspace":`Espaço de trabalho`,
"label.searchrelation":`Relação de busca`,
"label.icon.185":`Assessoria`,
"label.service.gantt.effective":`Válido`,
"label.newreportstp1":`Passo 1 Selecionar formato tabular`,
"label.category.9":`Fabricação`,
"label.zuowei":`Como`,
"front-quotation-v1-select-quota":`Selecione a citação`,
"label.dashboard.refresh":`Atualização`,
"label.weixin.saveandnew.log":`Salvar`,
"label.report.list":`Listas de relatórios`,
"FL":`Arquivo`,
"label.h5.followingcolleagues":`Colegas em pousio`,
"template.report.conversions.number":`Número de Conversões de Leads (Por Proprietário)`,
"label.validate.function.funcFormat.MONTH":`MÊS(data)`,
"front-kefu-moudle-v1-tenant-ID":`Identificação do locatário`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Hora`,
"label.multilang.workflow.everyotherday":`A cada {0} dia`,
"label.chat.message.send.message":`Enviar informações`,
"label.knowledgebase.fast.operation.error":`Erro de operação rápida`,
"label.multilang.dupicatecheck.dumplicatedata":`Nos registros {0}, foi encontrado um total de {1} grupos de dados duplicados satisfazendo a condição, e a consulta levou {2} milissegundos. Cada página mostra {3} grupos de dados.`,
"vue_label_report_addFile_detail_Information":`Exportar apenas 2000 linhas de detalhes. Use estes dados para cálculos adicionais, ou carregue para outros sistemas.`,
"label.ccchat.message.search.desc3":`Dicas de busca`,
"message.deletereport.prompt":`Não é possível excluir este relatório`,
"pagecreator.page.message.save.success":`Página salva com sucesso`,
"vue_label_rise":`Ascender`,
"label.appupload.install.error.choicehead":`Como lidar com se os componentes existentes no sistema entram em conflito com os componentes a serem instalados?`,
"message.dispatch.violation":`Violação do tempo de atribuição: o período de atribuição não está dentro da faixa de tempo de trabalho dos recursos.`,
"label.tool":`Ferramentas`,
"label.sso.saml.idp.downloadcert":`Download do certificado`,
"label.chatter.detailinfo":`Informações detalhadas`,
"label.area.tree":`Territórios Vista de Hierachy Tree`,
"label.partnerCloud.priceOfManual.notEnabled":`Não Ativar`,
"label.chosesubject.call":`Ligue para`,
"label.leadscore.rule.detail":`Leads Scoring: Detalhe da Regra`,
"front-welcome-to-try":`Bemvindo ao Julgamento`,
"label.umeng.activity.event.willbegin1":`Evento #evento começa em #tempo.`,
"component.event.label.noevent":`Parece que você completou seu trabalho hoje.`,
"label.document.templatesetof.folder":`Conjunto de modelos de pasta`,
"label.quickbooks.none":`Nenhuma correspondência found，Please digite um nome para pesquisar ou criar um novo cliente`,
"label.assignment.setup.newrule.inputrule":`Insira o nome da Regra de Atribuição`,
"label.appointmentdetail.wizard.title4":`Nome da empresa`,
"label.malaysia.time":`Hora da Malásia`,
"label.partnerCloud.partnerAccount.way":`Método de recarga`,
"label.roleoflinkman":` Função de contato`,
"mesage.error.role.delate.user":`A função não pode ser apagada porque designou os usuários.`,
"chatter.warning":`Advertência: Se você selecionar um objeto diferente, suas alterações não serão salvas. Você tem certeza de que quer fazer isso?`,
"label.service.gantt.violations.sum":`Nomeações de serviço com violações`,
"label.permission.objectpermission.recordfenpei1":`Tipos de Registros Atribuídos`,
"label.mobile.phone.required.plan":`O plano é necessário`,
"label.after_leaving":`Os dados atuais não serão salvos após a saída`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Houve uma citação primária sob a oportunidade e transferida para a ordem.`,
"component.setup.iframe.label.title":`Personalizar página`,
"visit.dispatchplatform.nopermission":`Permissão negada: Você não está autorizado a acessar o console de despacho. Favor entrar em contato com o administrador.`,
"label.validate.function.funcExplain.RIGHT":`Retorna o número especificado de caracteres a partir do final de um texto`,
"component.chatter.link.button.save":`Publicar`,
"label.knowledge.selection":`Cada Conhecimento tem um máximo de 8 grupos de dados que podem ser selecionados.`,
"chatter.email.homePage":`Envie-me uma mensagem em minha página inicial do CCChat`,
"vue_label_commonobjects_view_copy_view":`Vista de cópia`,
"label.documentmessage":`Detalhes do documento`,
"label.emailtocloudcc.step1":`Passo 1`,
"label.user.mfa.unbind":`Desbloquear o AMF para os usuários selecionados`,
"label.stdashbord.xsld.business.sdzje":`Valor Total (Oportunidades Fechadas-Perdidas)`,
"vue.please.select.the.total.method":`Por favor, selecione o modo de totalização.`,
"label.stdashbord.xsld.business.img1":`Número de estágios com uma probabilidade de 1%  99%`,
"label.reportsSubscriptionPage.condition.title":`Além de subscrever, você pode estabelecer condições neste relatório. Você será notificado quando as condições forem cumpridas. Isto é opcional.`,
"chatter.sel.field":`Erro: Mais de 20 campos são selecionados.`,
"label.login.access.year":`Ano`,
"label.dashboard.all":`Todos os painéis de controle`,
"label.approver":`Aprovador`,
"Lead.Homepage.Tools.BatchScoring":`Pontuação do Lote`,
"lable.opppdt.selPdt.lesscondtions":`Menos filtros`,
"label.integrations.action.export":`Exportação`,
"label.datamanage.lookupandsure":`(Ver e confirmar)`,
"label.email.attach.to.mail":`Anexar ao e-mail`,
"message.nodataordeleted":`Os dados não existem ou foram apagados`,
"component_newrecords_label_all":`Ver tudo`,
"lable.currencyAdv.startdate.rate":`Mostrar todas as tarifas definidas para a data de início na seguinte faixa`,
"label.callbackoperate":`Ações de recall`,
"label.knowledge.setting.hint.eighteen":`Comece a criar um artigo para o conhecimento`,
"label.user.step4.submit.email":`Etapa 4 Seu e-mail enviar reuest foi enviado`,
"label.appointment.wizard.subtitle4-1":`Tempo de viagem entre eventos`,
"component.assistant.button.newtask":`Nova Tarefa`,
"label.icon.129":`Cartão`,
"label.relatedlist":`listas relacionadas`,
"label.report.recently":`Visto recentemente`,
"label.batchadd":`Acréscimo em massa`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" é excluído com sucesso`,
"label.appupload.upload.otherdetail":`Detalhes adicionais`,
"label.emailobject.link":`Link:`,
"label.quickbooks.createcustomer":`Criar cliente no QuickBooks`,
"report.label.projectcount":`itens, ordenar pelo nome do relatório`,
"vue_label_normal_contact_sf":`Contato`,
"chatter.group.groupActivities":`Todos os grupos`,
"label_tabpage_addoptionsz":`Adicionar opções`,
"label.knowledgebase.submit.for.translation":`Submeter para tradução`,
"vue_label_pool_notallowed":`A natureza do negócio não é permitida`,
"label.icon.80":`Fabricação de papel`,
"label.readonlys":`Somente leitura`,
"label.recordsediting":`Capacidade de edição de registros`,
"label.mr.title.email":`Email`,
"label.partner.all.enable":`Habilitar`,
"label.customsetting.manage.errmessage":`Mantenha os campos personalizados antes de gerenciar os dados.`,
"label.cloudccclass.list.cls":`Classe`,
"label.weixin.click.loadall":`Clique para carregar todos`,
"label.weixin.appr.initialtime":`Tempo apresentado`,
"UG_ST_002":`Determine`,
"setup_mainpage_label_welcome17":`Configurações de permissão`,
"label.appupload.state0":`Não Carregado`,
"label.icon.115":`Casa`,
"setup_mainpage_label_welcome5":`Campo personalizado`,
"lable.custom.year.ovdate":`Data de fim de ano personalizada`,
"label_tabpage_findz":`Busca`,
"label.appupload.uploading":`Carregando...`,
"setup.mainpage.label.welcome1":`Necessidade de permissão correspondente`,
"label.file.folder.delete2":`Eliminar biblioteca?`,
"2018UI_Homepage_DataNoAccess_Info":`Você não tem permissão para ver este registro, por favor clique para voltar ao passo anterior.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Havaí-Aleutian Standard Time`,
"template.report.unfinished.tasks":`Tarefas inacabadas`,
"vue_label_calendar_add_calendar":`Adicionar calendário`,
"label.button.sel.useremail":`Enviar e-mail para usuários selecionados`,
"user.email.template":`Caro{nome do usuário}：<br> O código do convite de [{Campaign.name}] mostra como segue<br>{Campaign.ColleagueInvitationLetter}<br>e a URL is：<br>{Campaign.ColleagueInvitationLetterLink}<br>Registro do código QR e registro do link URL são suportados para a presente campanha! Obrigado por seu apoio! <br>Marketing Executive:{Campaign.Owner}`,
"label.forecast.settings.shouru":`Receita`,
"label.casesensitive":`Tratar "ABC" e "abc" como valores diferentes (sensível a maiúsculas e minúsculas)`,
"message.pleaseinputrightdistanceweek":`Por favor, preencha a semana de intervalo correta.`,
"label.linellae-group":`agrupamento de colunas`,
"label.showdefault_times":`Mostrar tempo de publicação padrão`,
"label.smstemplate.finishmessagedetailinfo":`Completar os detalhes do modelo de SMS`,
"label.service.miniProgram.backgroundImage":`Foto de fundo`,
"label.recentview.news":`Últimos Registros`,
"label.reportType.chose.and.form":`Selecione a fonte de dados do relatório e um formato de relatório`,
"setup.layout.button.additem":`Adicionar os itens selecionados`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Um contrato é um acordo escrito entre as partes. Muitas empresas utilizam contratos para definir termos para a realização de negócios com outras empresas. Use o Cloud CC para estabelecer e documentar seus contratos existentes com seus clientes e oportunidades de negócios. Acompanhe o contrato através do processo de aprovação.<br>?Assista a função do contrato e gerencie suas transações através do plano de cobrança.`,
"label_mobile_version_nonsupport_feature":`Esta característica não é suportada na versão atual. Favor atualizar para a versão mais recente.`,
"label.icon.44":`Incêndio`,
"label.data.downpage.i.title.num3":`3、BBefore importando, certifique-se de importar todos os registros relacionados. Por exemplo: se houver uma relação de pesquisa entre os objetos que você está importando atualmente e os contatos, você deve importar primeiro os contatos e depois importar seus dados.`,
"label.mr.object.customer":`Contas`,
"label.social.user.null":`As informações do usuário do Social não podem estar vazias`,
"front-epwechat-module-v1-unbound-item2":` todos os dados das configurações de aplicação`,
"label.partnerCloud.partnerAccount.noempty":`A quantia da recarga não pode estar vazia.`,
"label.weixin.myapproval":`Minhas aprovações`,
"label.data.setok.e_desc1":`Exportar com sucesso, você receberá uma mensagem de alerta, os dados derivados são temporariamente armazenados no servidor, o sistema só para você economizar 48 horas, por favor, o mais rápido possível para`,
"lable.batchadd.service.cfq.after":`Gatilhos (após inserção)`,
"label.umeng.activity.youhaveanevent":`Você tem um novo evento.`,
"label_emailsync_status_connectaccounts":`Conta de e-mail conectada`,
"label.multilang.shenpi.count":`Um total de {0} records：`,
"pagecreator.page.message.delete.fail":`A exclusão de página falhou`,
"label.version.sum.lookupmdfield":`Campos de Relacionamento Master-Detail`,
"vue_label_pool_clueduplication":`Dica Duplicada`,
"label.system.setup.log":`Log de Comportamento do Sistema`,
"label.globaloperation.operationtype.send.e-mail":`Enviar e-mail`,
"vue_label_pricebook_entry":`Nova entrada na lista de preços`,
"label.forecast.forehistory.submit.date":`Data/Hora de entrega`,
"chatter.handle":`Em que você está trabalhando?`,
"lable.SalesCommitmentKanBan.complete":`Montante completado`,
"label.weixin.upload.pictures":`Carregar imagem`,
"label.create.document":`Novo documento`,
"vue_label_commonobjects_detail_unlockconfirm":`Confirmar para desbloquear?`,
"label.customer.page":`Fichas personalizadas`,
"button.partner.workspace.saveas":`Salvar como`,
"setup.layout.label.asc":`Ascendente`,
"label.ccpeak.folder.time":`Pastas de classe programadas não arquivadas`,
"label_tabpage_includez":`Incluir`,
"label.custom.button":`Botões personalizados`,
"label.weixin.binding":`Bind`,
"P":`Porcentagem`,
"chatter.stop.n":`Pare de seguir este registro`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Quarta-feira`,
"template.report.revenue.marketing.activities":`Receita da campanha`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Recibos reais`,
"vue_label_popularresults":`Resultados Populares`,
"label.log.belongs":`Parte subordinada`,
"label.profile.remark":`Os usuários com este perfil têm as permissões e layouts de página listados abaixo. Os administradores podem alterar seu perfil editando informações pessoais dos usuários.`,
"label.appupload.component.type.button":`Botão`,
"label.partner.all.operate":`Operação`,
"vue_label_notice_modify_fail":`Falha na edição`,
"label.icon.137":`Terra`,
"front-dialog-module-v1-nosupport-copy":`O clone não é suportado`,
"label.integrations.mailchimp.massage3":`Integração desinstalada com sucesso`,
"UG.opportunity.010":`Criar uma transação`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Você só pode escolher relatórios públicos, ou seja, relatórios com acesso para todos os usuários, e relatórios públicos não arquivados.`,
"System_btn_SaveAndCommit":`Salvar e enviar`,
"vue_label_dashboard_statisticaltype":`Por favor, selecione o tipo estatístico`,
"label.mr.object.opportunity":`Oportunidades`,
"label.area.detail.remark":`Ver Usuários neste Território`,
"label.view.sortview.index":`Ordem`,
"label.mobile.quickcreate.default.events":`Eventos`,
"label.product.price":`Preço de venda`,
"label.leadmarketsea.edit.title":`Edição do Lead Pool`,
"pagecreator.layout.button.edit":`Editar layout`,
"label.addressee":`Destinatários`,
"label.movablesearchlayout":`Layouts de pesquisa de atividades`,
"label.ems.confirm":`Confirme`,
"vue_label_file_save_to_file":`Salvar em arquivo`,
"component_chatter_button_more":`Veja mais detalhes`,
"label.ccdocument.hidden.trace":`Rastros ocultos`,
"label.partnerCloud.maximumTwo":`É suportado um arquivo máximo de 2M.`,
"label.event.moveup.4hour":`4 horas à frente`,
"label.batchadd.save":`Adicionar falha no compartilhamento`,
"label.passwordPolicy.setup.expireDate":`A senha do usuário expira em`,
"label.workflowrule":`Regras de fluxo de trabalho`,
"vue_label_notice_pleaseselecview":`Por favor, selecione uma vista`,
"label.h5.chatter.colleagues":`Sobre os colegas`,
"lable.opppdt.addpdt.subtitle":`Adicionar Produto a`,
"label.data.import.setup.repeat.no":`Não insira todos os registros em meu arquivo de importação.`,
"label.changeCorporate":`Trocar a moeda da empresa`,
"label.customfields.dateandtime.tip":`Permite que os usuários digitem uma data e hora, ou escolham uma data de um calendário popup. Quando os usuários clicam em uma data no popup, essa data e a hora atual são inseridas no campo Data/Hora.`,
"label.integrations.mailchimp.massage1":`Por favor, selecione 1 registro pelo menos para exportar`,
"lable.PowerProcess.custom":`Com base na condição personalizada`,
"label.service.editDialog.displays.service.appointmentsFordays":`Mostrar compromissos de serviço de {} dias antes da data de nível e {} dias após a data de nível.`,
"label.Receivables.ActualMoneyTime":`Data de Recebimento Real`,
"label.matrixreport.intro":`Os Relatórios Matrix mostram dados resumidos calculados em termos horizontais e verticais em forma de grade.`,
"message.validation.isnotnumber":`Por favor, digite o número inválido.`,
"label.partner.workspace.member.search":`Busca`,
"label.customfields.deletewill":`A eliminação de um campo personalizado será feita:`,
"label.content":`Conteúdo`,
"component.setup.button.weburl":`URL externa`,
"setup.mainpage.label.welcome28":`Instruções: Clique no menu do lado esquerdo desta página → Gerenciar Configurações → Gerenciamento de Dados → Importação e Exportação de Dados, Transferência de Lote, Excluir Lote.`,
"label.related.setup":`Definição de tarefas e eventos`,
"label.weixin.sign":`Caro, você já assinou, não é preciso fazer isso novamente`,
"label.norecord":`Sem Registros`,
"label.emailmerge.detail.emailtempldatemerge":`Modelos de fusão de correio`,
"label_emailsync_status_role":`Papel`,
"label.mobileapp.modelsetting2":`Selecione módulos que atendam às suas necessidades comerciais<br>Activate：allows módulos selecionados para mostrar em More Standard Function<br>Deactivate: os módulos selecionados não poderão ser mostrados em More  Standard Function.`,
"component.sendmail.label.title":`Enviar e-mail`,
"component_assistant_button_newevent":`Novo evento`,
"label.chatter.input":`Por favor, insira o conteúdo`,
"message.error.view.operate.rtnlink":`Clique<a href='javascript:history.back();'>here</a> para voltar.`,
"lable.new.profile":`Novo perfil`,
"label.custom.field.null":`Não há disponível`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Sábado`,
"label.stdashbord.xsld.business.img4":`Quantidade total de estágios com probabilidade de 100%`,
"pagecreator_layout_button_splitall":`Dividir tudo`,
"label.mobile.phone.total.amount":`Total Amount (ten thousand)`,
"label.ratifyhistory":`Histórico de aprovação`,
"label.projectManagement.Antecedents":`Pré-tarefa`,
"label.projectManagement.Newserviceappointment":`Nova nomeação de serviço`,
"label.delete.record.is.approval":`Os registros que você deseja excluir estão solicitando aprovação, você tem certeza de que deseja excluir?`,
"front-gantt-module-no-tasks-describe":`Você pode ver como os itens de trabalho são organizados ao longo do tempo, como eles se sobrepõem e como estão relacionados no diagrama de Gantt.`,
"vue_label_visualize_data":`Os dados de TianYanCha são preenchidos. Por favor, salve as mudanças.`,
"UG.activity.02":`Atribuir tarefas`,
"label.field.duplicate2":`Não são permitidos valores duplicados`,
"label.cloudccclass.list.tip":`Permite que os desenvolvedores desenvolvam classes na plataforma CloudCC.com que podem ser usadas para personalizar páginas e gatilhos.`,
"before":`Antes de`,
"UG.ST.001":`Pronto`,
"label_tabpage_userGuidez":`Guia do usuário`,
"vue_label_account_looking_for":`Por favor, digite o que você está procurando`,
"vue_label_calendar_notice_timecantmove":`A hora do calendário não pode ser alterada por arrastamento`,
"label.mobile.phone.enter.summary":`Digite seu resumo`,
"label.object.api.existed":`Este nome API objeto já existe, favor mudar outro nome API.`,
"label.weixin..xsld.order.by.time":`Encomendar por data próxima`,
"label.h5.chatter.whether":`Quer seja ou não`,
"label.file.delete.success":`Arquivo excluído com sucesso`,
"label.imgfield.type.url.tip1":`O usuário pode inserir o link que faz referência à figura, e definir o tamanho da figura adicionando`,
"label.tomanyrecords":`Mais de 5.000 itens no formulário.`,
"label.save.partnercloud":`Erro ao salvar o Partner Cloud`,
"vue_label_homepage_fliteritems":`Itens de configuração do filtro`,
"pagecreator_page_button_new":`Nova página`,
"label.sharerule.baseofcondition":`Com base em critérios`,
"label.dashboard.snapshot":`Snapshots de painel de instrumentos`,
"label.appointmentpage.wizard.subtitle1.1":`Escolha data e hora`,
"label.reportsSubscriptionPage.condition.emailsummary":`Apenas resumo`,
"chatter.group.showAll":`Mostrar tudo`,
"label.tabpage.helpNavigationz":`Ajuda e navegação`,
"label.emailtocloudcc.button.back":`Cancelar`,
"approval_request_email_subect":`Pedido de Aprovação`,
"label.lookup.error":`Ocorreu um erro durante a busca`,
"label.publicgroup.save.groupisnull":`Os dados do grupo são nulos durante a gravação. Por favor, salve-os novamente. Se houver algum erro, favor entrar em contato com seu administrador.`,
"label.pie":`Gráfico de torta`,
"chatter.feed.is":`é uma rede corporativa que permite que seus usuários trabalhem juntos, falem uns com os outros e compartilhem informações, tudo em tempo real.`,
"label.customfields.file.max5m":`O tamanho máximo do arquivo é de 5m`,
"com.cloudcc.login.error.message.vaildauthfail":`Autenticação de login inválida`,
"label.profile.appsetuppermission":`Gerenciamento de ajustes de aplicativos`,
"label.customfields.file.totalmax":`O arquivo carregado é muito grande, por favor não exceda 500m`,
"label.sms.list":`Lista de interfaces SMS`,
"message.error.referencedcolumnIdnotexist":`Os campos de referência do relatório foram eliminados e não podem ser exibidos corretamente. Favor entrar em contato com seu administrador para obter ajuda.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Elaboração de relatório`,
"label.recordtype.profile.enables":`Tipos de registros atualmente disponíveis`,
"chatter.this.n":`este registro`,
"label.only.upload.file":`Somente arquivos jpg/png são permitidos para upload e não mais que 500kb.`,
"vue_label_lead_conversion_failed":`A conversão falhou`,
"label.file.share.file.success":`Compartilhar arquivos com sucesso`,
"label.processsetting.delete.process":`Você tem certeza de que quer apagar o processo?`,
"message.uniquenamevalidate":`Deve mendigar com uma letra. Deve mendigar com uma letra. Deve conter apenas letras, números e sublinhado.`,
"label.group.archived.desc.info":`Este grupo foi arquivado para que você não possa criar novos posts ou compartilhar arquivos com este grupo. enabling group permite todas as funcionalidades.`,
"label.customer.maincontact":`Contato principal`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Receita das séries de produtos`,
"label.dashboardSetup.tz.ybb":`Saltar para Painel de Controle`,
"label.recordowner":`Proprietário do registro`,
"message.approval.othersdoing":`Outra pessoa está trabalhando neste processo, por favor, atualize para obter os dados mais recentes.`,
"Opportunity_Detailed_Phase_Label_002":`{0} dia(s) na fase atual`,
"label.field.validating.rule.isnot.passed":`A compilação da regra de validação falhou, favor verificar a sintaxe.`,
"label.textmessage.fieldskong":`Alguns dos campos inseridos na mensagem são nulos, favor editar e reenviar!`,
"com.cloudcc.login.error.message.islocked":`Sua identificação está bloqueada`,
"label.forecast.customforecast.foredis.debfb":`% Quota`,
"lable.opppdt.selPbk.changepbk.worning":`Modifique o livro de preços para esta oportunidade, e o produto de oportunidade associado a esta oportunidade será excluído. Você tem certeza?`,
"label.mr.backLookReData":`voltar, Ver a lista de dados duplicados`,
"label.quickbooks.searchqb":`Busca QuickBooks`,
"label.service.gantt.searchSkills":`Habilidades de busca`,
"label.account.Current.and.NexttFQ":`Atual e Próximo 3 FQ`,
"customer.notopen.chat":`A organização não ativou a função de batepapo, favor entrar em contato com o administrador`,
"vue_label_commonobjects_view_sum":`Total {total} registro(s)`,
"label.partnerCloud.orderingPlatform.adjust":`Ajustar Pedido Produto`,
"label.emailmerge.mergeFolder.tips":`Um arquivo do Microsoft Word com os dados de contato pode ser gerado nesta página. Por favor, escolha os modelos de email a serem fundidos, e um máximo de 20 modelos podem ser selecionados.`,
"vue_label_ccchat_notice_deletecommentfail":`Falha em excluir comentários`,
"label.emailsync.status":`Status do e-mail do usuário`,
"label.forecast.forecastroleuserpage.desc":`Atribuir um gerente de previsão a esta função. As previsões de seus subordinados serão agregadas às previsões de seu gerente .`,
"label.step1.total4":`Etapa 1 de 4`,
"front-kefu-moudle-confirm-fjcase":`Você tem certeza de que vai dividir este caso`,
"label.icon.60":`Guindaste`,
"label.appointmentpage.wizard.subtitle3":`Digite suas informações`,
"label.loginservice.license.exceed.time":`A licença expirou.`,
"label.customcomponent.check.tag.lastrow":`A última linha deve ser`,
"label.product.code":`Código do produto`,
"label.salescloud.salesdashboard.phone":`Telefone`,
"label_please_input_price_list_price":`Favor inserir o preço de tabela.`,
"label.multilang.page3":`página(s)`,
"label.file.lastmodifydate":`Tempo modificado`,
"label.icon.121":`Computador`,
"message.error.system.service.unknow":`Serviços desconhecidos, favor entrar em contato com seu administrador.`,
"label.thesecond":`A 2ª Coluna`,
"vue_label_report_conditiondesc_two":`Acrescentar condições a este relatório`,
"label.exchange.serverUrl":`Endereço do servidor`,
"RL":`referência`,
"label.emailobject.emailsend.sendindividuallyprompt":`Cada recibo receberá uma mensagem enviada somente a ele. Você é sure？`,
"label.appointmentconfirmpage.wizard.subtitle4":`Calças de treino`,
"message.save.opportunity.team.save.failed":`O grupo de oportunidades de negócios falhou`,
"vue_labenl_normal_notice_share_success":`Compartilhado com sucesso`,
"label.triggerfolder":`Pastas de gatilho`,
"label.more":`Mais`,
"label.file.num":`Quantidade`,
"label.dashboard.list.sortBy":`item(s), ordenar por tempo de acesso`,
"c":`Moedas`,
"label.weixin.detail.edit":`Editar`,
"label.escalation.setup.newentries.step2":`Passo 2 Selecione os critérios para esta entrada de regra`,
"label.report.error.prompt":`A configuração falhou. Somente o relatório de série com conjunto de linhas é suportado. Por favor, certifiquese de que se trata de um relatório público e não eliminado!`,
"label.notification.new":`Novo`,
"label_tabpage_releaseTourz":`Publicar guia`,
"label.icon.41":`Posicionamento`,
"label.sendsms.hello.new":`Olá, você tem um novo`,
"label.custom.combination":`Combine`,
"label.project.hit.fifteen":`Aviso de atribuição de marco`,
"label.campaign.channel.step6.mobile":`Gerar página móvel`,
"label.goback.N.step":`Retornar à etapa anterior N`,
"label_partner_all_name":`Nome da nuvem parceira`,
"label.usermanage.loginusername.exist":`O nome de usuário já existe.`,
"template.chart.cpxse":`Vendas de produtos`,
"chatter.feed.deletecomments":`Você tem certeza de que quer apagar este comentário?`,
"label.list.userinterface.show.newrcords.enable":`Desativar o último registro`,
"label.sso.saml.idp.config.enablelogout":`Habilitar logout único`,
"label.file.library.create":`Nova biblioteca`,
"label.event.moveup.half.day":`0,5 dia à frente`,
"label.stdashbord.xsld.business.jhzje":`Montante total de oportunidades`,
"label.partnerCloud.orderingPlatform.unitPrice":`Custo unitário`,
"label.recordtype.edit.attribute":`Propriedades gerais`,
"front-template-V1-TemplatePreview":`Prévisualização do modelo`,
"label.tabpage.personalCenterz":`Centro pessoal`,
"label.setuplookuplayout":`Layouts de busca`,
"label.no.merge.records":`Nenhum registro pode ser fundido`,
"label.attachementNew.set2":`Passo 2 Arquivo`,
"label.publicgroup.detail.showmembers":`Ver Membros do Grupo`,
"UG.Forcast.03":`Iniciar o planejamento e executar estratégias comerciais. <br>Desejo-lhe uma boa previsão!`,
"label.h5.manageprompt":`Selecione uma aba para adicionar a página inicial, ou clique na aba para abri-la.`,
"label.icon.145":`Relacionado`,
"label.select":`Selecione`,
"label.publicgroup":`Grupos Públicos`,
"label.customcomponent.usewhere.title":`Onde este componente é utilizado:`,
"label.custom.page.button.name":`Nome do Botão`,
"pagecreator_layout_button_vertical":`Desmontagem longitudinal`,
"label.marketsea.autorecyclerule":`Regras de reciclagem automática`,
"label.reportsSubscription.entrance.attachment":`formato Excel .xlsx`,
"component_chatter_button_collect":`Favoritos`,
"label.page.step2.of.step5":`Etapa 2 de 5`,
"label.reportsSubscription.addfile.helptext":`Você pode definir se deseja adicionar anexos de relatórios nos e-mails de assinatura, e o formato dos relatórios anexos.`,
"label.oldpw":`Senha antiga`,
"lable.SalesCommitmentKanBan.contractAmount":`Montante assinado`,
"lable.Bundle":`Pacote Superior`,
"label.weixin.unit.million":`Unidade (dez mil yuan)`,
"label.app.choseprofile":`Atribuir perfil`,
"label_tabpage_editz":`Editar`,
"label.email.attachement.size.info":`O arquivo não pode ser maior do que`,
"label.chatter.pastSevenday":`Os últimos 7 dias`,
"label.weixin.end.later.start":`A data de término deve ser posterior à data de início.`,
"label.passwordPolicy.setup.lockoutPeriod":`Período efetivo de bloqueio`,
"pagecreator_page_funcpath":`/ construtor / lista de páginas`,
"label.emailobject.apperror":`Nenhum serviço de correio disponível, favor entrar em contato com o administrador.`,
"label.custom.page.button.broadband":`Tamanho do Botão (Pixel)`,
"label.weixin.contract.rate":`Taxa de realização do contrato`,
"label.brief.payments":`Pagamentos`,
"lable.approvaldatamove.transfermsg":`Transferência em massa de todos os pedidos de aprovação pendentes para um novo usuário`,
"label.datamanage.account.namenull":`Nota: Se o nome da conta for nulo, o registro não será importado.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Montante total de recibos de rollup`,
"Opportunity_Detailed_Phase_Label_001":`Estágio`,
"vue_label_helpcenter_calendar2":`<br> Calendários de objetos: Os calendários que você cria com objetos exibem os dados do registro como entradas de calendário no campo de data na visualização do calendário. Você pode editar ou excluir calendários de objetos, e personalizar a cor para cada calendário de objetos. <br> Novo Evento<br> Você pode criar um novo evento na visualização do calendário de duas maneiras. <br> (1) Clique no botão Novo Evento no canto superior direito da visualização do calendário para criar um novo evento. Em um novo evento, você pode associar o evento a outros objetos, como oportunidades de negócios, selecionando outros objetos nos campos Itens relacionados e Nome. Os registros de eventos que estão associados a outros objetos são sincronizados no módulo Atividade da página de detalhes dos outros objetos. <br> (2) Ou você pode criar um novo evento clicando na grade do calendário. <br> Novo Calendário de Objetos<br> Passo 1: Clique na guia Calendário no menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Encontre Meus Calendários no lado direito da visualização, clique no ícone ao lado de Meus Calendários, e prossiga na janela pop-up do Novo Calendário de Objetos. <br> Passo 3: Comece nomeando o Calendário de Objetos criado. Selecione o objeto que é a base do calendário e selecione os campos que determinam o conteúdo da exibição do calendário, "Start field", "View filter", "Display field". O campo Iniciar determina o intervalo de tempo em que os dados são exibidos, você pode filtrar os dados por filtros de visualização, e o campo Exibir determina o que é exibido na entrada do calendário. <br> Outros calendários<br> Outros calendários contêm os calendários de outros usuários adicionados. Você pode adicionar calendários de pessoas que são subordinadas a você e compartilhar o calendário com você. <br> Compartilhar meu calendário de eventos<br> Passo 1: Clique na guia Calendário do menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Encontre Meus Eventos no lado direito da visualização do calendário sob Meus Calendários, clique no botão suspenso à direita de Meus Eventos, e selecione Compartilhar Calendário. <br> Passo 3: No pop-up do Calendário Compartilhado, selecione os usuários e os direitos de acesso com os quais você deseja compartilhar o calendário. Além disso, você também pode visualizar seus registros de calendário compartilhado clicando em "Quem atualmente tem acesso" e remover os registros compartilhados clicando no ícone "x" à direita dos registros compartilhados. <Uma vez que o calendário é compartilhado, seus colegas subordinados podem adicionar seu calendário de eventos a outros calendários e depois visualizar seu calendário de eventos. <br> Adicionar um calendário<br> Passo 1: Clique na guia Calendário no menu de navegação para ir para a página de visualização do Calendário. <br> Passo 2: Clique no botão suspenso para outros calendários no lado direito da visualização do calendário e selecione Adicionar Calendário. <br> Passo 3: No pop-up Calendários Compartilhados, selecione os calendários de eventos das pessoas que você deseja adicionar. Você pode selecionar os calendários de eventos de seus subordinados, bem como os calendários de eventos que são compartilhados com você. Clique em Adicionar para adicionar com sucesso. <br> Remover o calendário adicionado <br> Clique no botão suspenso à direita do calendário que você deseja remover abaixo dos outros calendários e selecione Remover.`,
"label.callcenter.Seat.number":`Número do assento`,
"vue_label_commonobjects_view_change_all_selected_records":`Alterar todos os registros selecionados`,
"label.user.notinuse":`O usuário está inativo, favor entrar em contato com seu administrador.`,
"label.usermanage.hasbeen.reached":`O número máximo de usuários licenciados foi alcançado, favor entrar em contato com o prestador de serviços para obter mais licenças.`,
"vue_label_help_list":`Vista de lista`,
"label.infomation.edit":`Informações Essenciais Editar`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`É Excluir`,
"label.unique.identification.number":`Código de Identificação Único`,
"label.weixin.no.pending.projects":`Nenhum item a aprovar`,
"label.projectManagement.Pleaseenteramember":`Por favor, digite um membro`,
"label.salescloud.salesdashboard.visit":`Visite`,
"label.weixin.user.registered":`Registro de usuário`,
"message.loginhistory.downloadcsv":`Faça o download do histórico de login dos últimos seis meses. ( CSV )`,
"label.icon.37":`Posicionamento`,
"template.chart.schdyqyx":`Resposta Esperada das Campanhas`,
"label.tel.ten":`Você pode digitar até 10 números de telefone a serem notificados por SMS, e cada número de telefone é separado por um ";".`,
"label.data.exp.objdata":`Você exportará os dados para este objeto de acordo com as seguintes condições`,
"label.loginservice.after.use":`depois disso, você pode usar o.`,
"pagecreator_systemstyle_message_delete":`Você apaga o estilo selecionado atualmente?`,
"label.globalselect.deleteerror":`Como este conjunto de valores da lista de opções é utilizado pelos seguintes campos, ele não pode ser excluído temporariamente.`,
"label.department.add":`Adicionar novo departamento`,
"label.attendance.dingwei":`Localização`,
"label.workflow.editrule":`Editar Regra`,
"lable.product.pecm":`Por favor, digite a quantia correta.`,
"label.icon.182":`Briefcase`,
"label.help.release.notes":`Notas de Lançamento do CloudCC R7.1`,
"UG.product.05":`Produto de importação`,
"label.email2":`Email`,
"label.weekrepeat":`Repetição da semana`,
"label.mr.descreption.oneGroupReData2":`conjunto(s)`,
"chatter.at.d":`Contribuição`,
"label.mr.descreption.oneGroupReData1":`Encontrar duplicados e processo de fusão: um total de`,
"label.weixin.mobile.fly.android":`Compartilhe no Android Mobile App`,
"label.brackets.right":`)Fechar parênteses`,
"message.recordtype.applytoAllProfiles":`Aplicar um layout de página a todos os perfis`,
"label.customcomponent.page.index.tip":`Semelhante à forma como a função funciona em uma linguagem de programação, os componentes personalizados permitem encapsular padrões de design comuns e depois reutilizá-los em uma ou mais páginas personalizadas.`,
"lable.List.properties":`Atributos da lista`,
"label.fieldinfo":`Detalhes do campo`,
"label.ems.error.fail":`A carga falhou, por favor tente novamente ou entre em contato com o administrador do sistema.`,
"label_emailsync_form_email":`Email`,
"lable.currencyManage.button.manageRate":`Gerenciar Moedas`,
"component_salesperformance_label_100finish":`Terminado`,
"label.knowledgebase.data.assignment.failed":`{a} a atribuição de dados falhou`,
"label.custom.buttonandlink.remark":`Selecione o comportamento: Exibir na janela existente/exibir na nova janela (Janela existente:despalhar na janela atual. Nova janela: exibir em nova janela)`,
"label.list.userinterface.watermark.setup":`Ajuste da marca d'água`,
"component_timeline_label_7daysahead":`7 dias antes`,
"label.sendemail.chat.replyinchat":`Comentários do correio:`,
"component.salesperformance.label.title":`Desempenho de vendas`,
"label.data.downpage.e.list.desc2":`Após a conclusão, você receberá um e-mail lembrando que os dados foram exportados com sucesso.`,
"vue_label_campaign_fromclosedopprotunities":`De {sjcb} oportunidades de negócios fechadas`,
"label.umeng.activity.taskviewed":`A tarefa que você designou para #name é visualizada`,
"vue_label_salesadvance_retentions":`Número de retenção`,
"label.fieldtag":`Etiqueta de campo`,
"label.quickbooks.button.searchinquickbooks":`Busca em QuickBooks`,
"label.quickbooks.viewlist.action":`AÇÃO`,
"label.weixin.sysapp":`Aplicações do sistema`,
"label.approval.examine.level":`Aprovar e rejeitar pelo usuário level， O nível máximo de usuário é`,
"label.appupload.upload.error":`Este aplicativo não pode ser instalado. Favor cancelar a instalação ou modificar a API dentro de seu sistema, e instalar novamente.`,
"label.emailtemplate":`Modelo de e-mail`,
"front-email-payment-Invoice-amount":`Valor da fatura`,
"label.viewselectedproducts":`Ver Produtos Selecionados`,
"label.tianyancha.businessverify.openfirst":`Favor ativar a verificação de dados comerciais`,
"lable.SalesCommitmentKanBan.returnAList":`Voltar para a lista: Colegas`,
"label.knowledgebase.nopublished.draft.translations":`Nenhuma versão publicada ou rascunho de tradução`,
"vue_label_calendar_day_view":`Vista do dia do calendário`,
"label.globalselect.remark":`O conjunto de valores da lista global de opções permite compartilhar valores entre objetos.`,
"label.orderby":`Ordenar por`,
"lable.weixin.LastaDaysFinished":`Concluído nos últimos 7 dias`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Permite gerenciar taxas de câmbio datadas que mapeiam uma taxa de conversão de moeda para um intervalo de datas específico. Taxas de câmbio datadas são aplicadas aos campos de moeda sobre oportunidades, produtos de oportunidade e os relatórios associados a estes dois objetos. Elas não são aplicadas aos campos em outros objetos ou outros tipos de relatórios. Por exemplo, a taxa de câmbio em 1 de janeiro era de 1 USD para 6,68 CNY, mas em 6 de fevereiro, mudou para 1 USD para 6,70 CNY. Suas oportunidades que fecharam entre 1º de janeiro e 6 de fevereiro utilizam a primeira taxa de câmbio (1 = 1,68), enquanto que as oportunidades que fecharam após 6 de fevereiro utilizam a segunda taxa de câmbio (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Um`,
"label.leadtoobjectfield":`Mapa Campos de chumbo personalizados`,
"label.dashboardSetup.shujuyuan":`Fontes de dados`,
"label.tabpage.userz":`Usuários`,
"label.sms.companyname.dsf":`Configuração do SMS-1`,
"label.step2.total3":`Etapa 2 de 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Arraste para reordenar tarefas!`,
"label.dashboard.snapshot.no.enabled":`A função de foto do painel não está ativada`,
"label.dashboard.unit3":`Unidade: unidade inteira`,
"label.forecast.shrepage.desc2":`Usuários, funções e territórios com acesso compartilhado.`,
"label.commonobjects.new":`Novo {nome do evento}`,
"label.view.nameonlyone":`Ver Nome Único`,
"label.assignment.setup.newentries.user":`Usuários`,
"label.otheremails":`E-mails adicionais`,
"component_sendmail_button_send":`Enviar`,
"vue_label_accountpool":`Pool de contas`,
"label.h5.approval.actortime":`Data de apresentação`,
"message.approval.cannotsubmit":`Incapaz de se submeter para aprovação`,
"vue_label_pool_createdbyme":`Criado por mim`,
"label.change.event":`Vista do evento`,
"vue_label_homepage_personalpage":`Página pessoal`,
"label.new.collect.target":`Novo Indicador de Agregado`,
"label.ServiceCloud.zichanxuhao":`Ativo No.`,
"label.product.userl":`Colunas para todos os usuários`,
"label.syslog":`Log do sistema`,
"label.reportcreatestatus":`Status de geração de relatórios`,
"label.datamanage.account.novalue":`Nota: O campo do nome da conta é nulo, os registros da conta não serão importados.`,
"label.letter.body":`Texto do convite`,
"label.select.please":`Favor selecionar`,
"label.escalation.setup.entrydetail.description":`1.Clique em Editar para alterar as entradas das regras. <br/>2.Clique em New para adicionar a operação de atualização.`,
"label.component.salesDashboard.nodata":`Adicione a oportunidade de negócios que você está usando, depois volte aqui para ver o desempenho.`,
"vue_label_helpcenter_account":`Nas informações detalhadas, clique no botão do diagrama em árvore ao lado do cliente para visualizar o diagrama hierárquico do cliente, entender a relação filho-pai dos clientes relacionados e visualizar algumas informações de campo de cada cliente.<br>?Ao mudar o proprietário de um cliente, você pode escolher mudar o proprietário das oportunidades de negócios, casos e outras informações relacionadas ao cliente ao mesmo tempo.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center (Central de Atendimento Inteligente AWS)`,
"label.productby":`Gerado por`,
"label.operation.date":`Data de operação`,
"label.name.donot.delete":`O nome não pode ser removido`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(data)`,
"label.escalation.setup.entrydetail.howescalationtime":`Como os tempos de escalonamento são definidos`,
"label.view.step2":`Etapa 2 Especificar os critérios de filtragem`,
"lable.outlook.edit.notnull":`Você deve digitar o nome do campo.`,
"label.knowledgebase.createnewbrowser":`Nova guia do navegador`,
"label.partner.all.name":`Nome da nuvem parceira`,
"chatter.group.groupSetUp":`Configurações do grupo`,
"label.reportlist.findfolder":`Encontre uma pasta...`,
"component.setup.tabs.label.title":`Paginação de fichas`,
"label.passwordPolicy.setup.pswComplexReq":`Requisitos de complexidade da senha`,
"label.emaildocument":`Enviar um documento na forma de um emai`,
"message.selectgsummaryconditon":`favor selecionar os critérios resumidos`,
"component_todaytask_label_notask":`Hoje não há tarefa de expiração, tome um café.`,
"label.user.organization.notexists":`A organização não é encontrada.`,
"label.isEnableVisualpage.new.leftlist":`Páginas personalizadas disponíveis`,
"label.mobile.phone.write.week.report":`Novas notas de trabalho semanais`,
"label.emailmerge.edittemplate.edit":`Edição de modelos de mescla de correio`,
"template.dashboard.folder.sales.manage":`Gestão de vendas`,
"label.confirm.order.productsToassets":`Você tem certeza de que quer converter o produto pedido em ativo?`,
"label.service.dispatchingUnits.leftRight.total":`Atualmente, {{{{esquerda }}-{{direita }} registros, {{{conta total }} registros no total.`,
"label.import.step1.chooseidorother":`2、You pode escolher usar o ID ou nome para corresponder ao registro e preencher o campo de busca. Se você precisar do ID do registro correspondente e outras informações, você pode criar um relatório e definir o nome do registro e o ID do registro como colunas de grupo, e então exportar o relatório.`,
"label_tabpage_completez":`Marcar o status selecionado para completar`,
"chatter.c.adr":`Endereço`,
"label.account.d":`Esta página permite que você defina e edite o trimestre fiscal personalizado. A data do trimestre fiscal personalizado será gerada com base nas escolhas que você fizer abaixo.`,
"label.tag.more50":`Criar até 50 tags`,
"setup.layout.label.areashow":`Cabeçalho da Seção de Display On`,
"label.partnerCloud.basicSetting.rebate":`Ativar o Rebate`,
"label.tabpage.greaterequalz":`Maior ou igual a`,
"vue.please.select.the.aggregate.basis":`Por favor, selecione as opções SUM BY.`,
"label.form":`Formulários`,
"label.chatter.colleagues.list.beizhu":`Habilitar`,
"label.priority":`Prioridade`,
"vue_label_checkduplicate_set_repeat_rules":`Estabelecer regras de repetição`,
"label.share_form":`Compartilhe seu formulário`,
"label_relation_shareholder":`Acionistas e subsidiárias não podem ser os mesmos.`,
"label.project.hit.sixteen":`Lembrete de validade de emissão`,
"label.service.miniProgram.imageFormat":`Somente imagens PNG, JPG e JPEG são suportadas para upload.`,
"label.summary.mode":`Método sumário`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Salve os campos e critérios selecionados pelos usuários como modelo e os usuários podem exportar dados diretamente através do modelo de exportação de dados.`,
"lable.evaluation.badreview":`Ruim`,
"label.total.tabs":`{0} Total {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Modelos nesta pasta`,
"vue_label_normal_notice_repeated":`Por favor, não adicione repetidamente`,
"label.icon.140":`Dados`,
"label.fromonetoanother":`de um usuário para outro`,
"label.user.list":`Todos os usuários`,
"label.file.prevent.share.operate":`Impedir que outros partilhem e não partilhem`,
"label.app.detail":`Detalhes do aplicativo`,
"label.h5.similar.opportunity.correlation":`Relatividade`,
"label_emailtocloudcc_filed_username":`Endereço de e-mail`,
"vue_labe_account_shareholdingratio":`Relação de participação acionária`,
"label.data.dataexpalltype.all_desc3":`3. Exported Dados bem sucedidos irão gerar um arquivo comprimido que os usuários podem baixar da página da lista de sucesso da exportação de acordo com as informações contidas no correio.`,
"label.callcenter.please.select .seatID":`Por favor, escolha o número do assento`,
"label.remark.length.cannot.than":`A descrição não pode incluir mais de 255 caracteres.`,
"label.batchtransfer.dateandtimetype.tip":`Para os campos de data/hora, digite o valor no seguinte formato:`,
"label.component.helper.businesschange.0UntreatActivity":`Oportunidades sem atividade não processada`,
"front-project-module-v1-plase-input-start-time":`Por favor, digite a data de início`,
"label.event.moveup.6hour":`6 horas à frente`,
"label.data.exp.tempexp":`Exportação por modelo`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Formato`,
"label.objectHasBeenDeleted":`Objetos eliminados`,
"label.ServiceCloud.chaxunchenggong":`Buscado com sucesso`,
"label.campaign.channel.input.notice.owner":`Notificar o Proprietário`,
"label.bajisitan.time":`Tempo Paquistão`,
"label.warnMes":`Objeto referenciado, exclusão falhou.`,
"lable.Up.to.ten.fields":`Escolha um objeto e acrescente até 10 campos ao gráfico. Clique nas setas para cima e para baixo para ordenar os campos.`,
"label.approverule":`Regras de Aprovação`,
"message.error.specific":`Retornar mensagem de erro específica`,
"front-template-V1-saveUse":`Salvar & Prévisualizar`,
"label.uploadfile.success":`carregado com sucesso`,
"label.tabname.donot.database.key":`O nome do separador não pode ser uma palavra-chave de banco de dados`,
"message.recordtype.selectlayout.select":`--Selecione o layout da página...`,
"front-detail-module-v1-list-cardview":`Vista de Lista/Cartão`,
"label.product.maintenance":`Manutenção`,
"vue_label_helpcenter_approve":`1. Itens a serem aprovados<br> Liste todos os itens que precisam de sua aprovação. Você pode procurar por registros a serem aprovados até a data de início, data final, apresentador, tipo de registro e itens relacionados do registro de aprovação.<br>Processar um único registro: Clique no botão esquerdo de cada registro.<br> A. Aprovação<br> Passo 1: Clique em "Aprovar" para abrir a página de solicitação de aprovação<br> Passo 2: Clique em "Aprovar" ou "Rejeitar" para completar a operação de aprovação.<br> Se a próxima etapa de aprovação na configuração do processo de aprovação precisar selecionar manualmente um aprovador, a etapa 3 é executada após "Aprovação".<br> Passo 3: Selecione o próximo aprovador para completar a operação de aprovação.<Se você precisar selecionar a etapa de retorno após a aprovação ser rejeitada na configuração do processo de aprovação, vá para a etapa 4 após "Rejeitar".<br> Etapa 4: Selecione a etapa de aprovação a ser devolvida para completar a operação de aprovação.<br> B. Redistribuição<br> Etapa 1: Clique em "Reatribuir"<br> Etapa 2: Encontre o reatribuidor<br> Etapa 3: Clique em "Reatribuir Pedido de Aprovação" para completar a reatribuição dos aprovadores.<br>Nota: Se você é o aprovador adjunto de um registro, você não pode realizar a operação de reatribuição.<br> Processar em lote vários registros: Após selecionar vários itens a serem aprovados, clique no botão de operação acima da lista.<br> C. Aprovação<br> Passo 1: Selecione vários registros a serem aprovados<br> Passo 2: Clique em "Aprovar"<br> Passo 3: Clique em "Aprovar" ou "Rejeitar" para completar a operação de aprovação.<br> Se você precisar selecionar a etapa de retorno após a aprovação ser rejeitada na configuração do processo de aprovação, vá para o passo 4 após "Rejeitar".<br> Etapa 4: Selecione a etapa de aprovação a ser devolvida para completar a operação de aprovação.<br> D. Redistribuição<br> Etapa 1: Selecione vários registros a serem aprovados<br> Etapa 2: Clique em "Reatribuir"<br> Etapa 3: Encontre reatribuidores<br> Etapa 4: Clique em "Reatribuir Pedido de Aprovação" para completar a reatribuição de aprovadores.<br> 2. Projetos apresentados<br> Lista todos os itens aprovados que você apresentou. Você pode pesquisar rapidamente o registro que deseja visualizar até a data de início, data final, apresentador, tipo de registro, itens relacionados e status de aprovação do registro de aprovação.<br> 3. Meus projetos aprovados<br> Lista todos os itens aprovados que você aprovou. Você pode procurar rapidamente pelo registro que deseja visualizar até a data de início, data final, apresentador, tipo de registro, itens relacionados e status de aprovação do registro de aprovação.<br> 4. Rejeitar itens <br> Lista todos os itens aprovados que você tenha rejeitado. Você pode procurar rapidamente pelo registro que deseja visualizar até a data de início, data final, apresentador, tipo de registro, itens relacionados e status de aprovação do registro de aprovação.`,
"label.knowledgebase.knowledge.article":`Artigo de conhecimento`,
"march":`Março`,
"label.accraditation":`Aprovar`,
"vue_label_pool_cantreach":`Não consegue alcançar o cliente`,
"label.service.appointmentList.startOf.maturityPeriod":`Início do período de vencimento`,
"message.huanxin.closed":`Função de batepapo inativo`,
"label.implementation.time.operation":`Executar trabalhos programados`,
"label.setting.intergrationlist.permissions":`PERMISSÕES DE INTEGRAÇÃO`,
"label.translation.norecord":`Sem Registros`,
"label.lack.expression":`A expressão é perdida`,
"setup.layout.message.relatedlistfield":`Selecione os campos a serem exibidos na lista relacionada.`,
"label.group.file":`Arquivos de grupo`,
"message.error.id.null":`Não há tais informações de identificação`,
"label.a_b_least":`Cada registro "A" deve ter pelo menos um registro "B" relacionado.`,
"label.addattachment.step3":`Passo 4 Clique em "Completo" para voltar para a página anterior.`,
"label.data.exportsf":`Arquivos Exportados`,
"label.callcenter.call.out":`Chamada`,
"front-electronic-export-exportIntro":`Os dados selecionados serão exportados para a lista Mailchimp que você selecionou`,
"label.custombutton.deletedata.notnull":`Os dados excluídos não podem estar vazios.`,
"UG.homepage.002":`Gerencie suas pistas, leads, funis de transação de vendas e informações de conta com ferramentas comerciais integradas`,
"label.globaloperation":`Operação global`,
"label.icon.58":`Trabalhador`,
"vue_label_salesadvance_lostrate":`Taxa de rotatividade`,
"chatter.from":`de`,
"front-epwechat-module-v1-account-binding":`Ligar por conta`,
"label.list.userinterface.old.page.setup":`Página antiga`,
"label.forecast.settings.periods":`&nbsp;ciclo(s)`,
"label.file.share.email.content":`#sharedBy compartilhou um arquivo com você em #orgname`,
"label.knowledge.category.hint.five":`Definição da categoria de dados`,
"setup.layout.label.selectedfield":`Selecione os campos`,
"label_business_income":`Receita de oportunidades de negócios`,
"vue_label_display_options_field":`Mostrar campos da lista de picking`,
"label.emailtocloudcc.set":`Definir informações da caixa postal`,
"label.knowledge.setting.data.five":`Eliminar categoria: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Empresa de fianças`,
"label.ccpeak.delete.recycle":`O registro será removido para o caixote da reciclagem`,
"label.leadconvers.tip":`As pistas não podem ser convertidas em contas, contatos, oportunidades e tarefas de acompanhamento. Você só deve converter uma pista depois de tê-la identificado como qualificada.`,
"label.rsa.key.invalid":`A chave pública é inválida, por favor, faça o login novamente.`,
"label.mobile.bind.success":`Ligar com sucesso`,
"label.emailtocloudcc.filed.servertype":`Servidor de e-mail`,
"label.user.new":`Novo Usuário`,
"label.setup.mobile.homepageshortcuts.remark":`As organizações podem definir as funções rápidas em nível organizacional mostradas na área superior da página inicial de acordo com o cenário empresarial.`,
"label_emailtocloudcc_select2":`Selecione o Tipo de Display`,
"page.send.email":`Enviar e-mail`,
"label.service.newBuildDialog.field.display":`Campos a serem exibidos`,
"vue_label_homepage_card_impending":`Oportunidades iminentes`,
"label.message.contactispartner.delete":`Um usuário parceiro está associado a este contato, não pode ser excluído`,
"label.attendance.checkout":`Confira`,
"label.emailmerge.newtemplate.description":`Digite informações sobre seu modelo de mala direta. Note que a descrição é exibida apenas no CloudCC.com, não no Word.`,
"laebe.data.exp.success":`Após a exportação bem sucedida, você receberá um lembrete por e-mail. Os dados exportados serão salvos no servidor por 48 horas. Favor baixar da página da lista de dados exportados o mais rápido possível.`,
"lable.Maximum.number":`É permitido um máximo de 50 caracteres para o nome do modelo.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Arrastar uma tarefa existente para a categoria atual`,
"label.forecast.tree.desc":`A hierarquia de previsão determina como as previsões se desenvolvem dentro da organização, e quem pode visualizá-las e ajustá-las. Ela é gerada automaticamente com base em sua hierarquia de funções, mas você pode precisar adicionar ou editar gerentes, representantes de vendas ou outros usuários.`,
"vue_label_chatter_upload_file_type":`Carregamento selecionado de arquivo tipo post`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Dimensão da análise`,
"vue_label_homepage_custom_homepage":`Página inicial personalizada`,
"label.icon.39":`Posicionamento`,
"label.appointmentpage.wizard.notif1":`Por favor, escolha uma hora antes!`,
"vue_label_report_filterby":`Filtrar por {condição de tela }`,
"label.argentina.time":`Tempo argentino`,
"label.role.assign.notremove":`Não é possível remover os usuários de <b>Selected Users</b> para "All Unassigend And Active Users" ou "All Unassigned Users".`,
"label.sharerule.detailsetshare":`Detalhes da regra de compartilhamento`,
"label.file.publicview.error1":`O arquivo é excluído ou o link público não é habilitado`,
"label.data.downpage.e_title.num4":`4. Os arquivos de exportação têm dois formatos: formato CSV e o formato de compressão. O formato de compressão é dividido em dois tipos: um é para gerar automaticamente a senha do arquivo comprimido, o outro é para inserir manualmente a senha do arquivo comprimido.`,
"label.knowledge.case.article":`Artigo de caso`,
"label.data.newtemplate.e.conditions":`Condições de exportação`,
"front-object-change-owner":`O proprietário do registro da lista relacionado que corresponde a esta conta também será mudado para o novo proprietário`,
"label.newdashboardpage.edittitle":`Editar título`,
"label.datamove.end.query.no.record":`Fim da consulta, sem registros qualificados.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Recebimentos Alvo`,
"label.orderagain":`Reordenar`,
"vue_report_dashboard_transfer":`Mover pasta`,
"label.view.sortview.default":`Vista padrão`,
"label.brasilia.time":`Horário de verão de Brasília`,
"label.industrialandcommercialverification.instructions":`Permitir a Verificação de Dados Industriais e Comerciais para auxiliar o usuário a inserir as informações corretas de registro industrial e comercial do cliente.`,
"label.chatter":`Posto de nuvem`,
"label.sso.goBackToList":`Voltar à lista: key Management`,
"label.mobile.side.tab.state":`Iniciar o controle deslizante personalizado`,
"label.weixin.addbus":`Adicionar veículos`,
"label.dropbox.description":`Vincule sua conta DropBox para utilizá-la no CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Coloque este filtro à disposição de todos os usuários.`,
"label.knowledge.language.thai":`Tailandês`,
"label.passwordPolicy.setup.foreverlock":`Para sempre(deve ser reiniciado por admin)`,
"label.bmap.unreported.location":`Você não compartilhou suas informações de localização. Por favor, crie uma conta oficial no WeChat .`,
"label.tag.field":`Etiquetas`,
"label.addyourlanguage":`Clique em Adicionar para adicionar os idiomas que sua organização suporta.`,
"label.chat.topic.my.use":`Tópicos que eu uso`,
"UG.contact.06":`Contatos de importação`,
"label.embed_code":`Código Embedar`,
"label.campaign.channel.input.chenben":`3. Custo real:`,
"label.quickbooks.estimates":`Estimativas`,
"label.report.items.i.created":`Relatórios que eu criei`,
"label.forecast.edit.fwqd":`Início da faixa`,
"label.validate.function.funcExplain.DATEVALUE":`Criar uma data a partir de sua data/hora`,
"vue_label_helpcenter_calendar1.1":`Os eventos são uma ferramenta poderosa para garantir que você sempre compreenda as relações com os clientes e feche negócios. Você pode associar eventos com oportunidades, leads, clientes e contatos. A visualização do calendário exibe principalmente registros de eventos.<br> 1. Vista do calendário e vista de lista<br>Ver calendário<br> Clique na guia calendário do menu de navegação para acessar a página do calendário. <br>Vista do calendário<br> Classificação das vistas de calendário: As vistas do calendário são divididas em vista do mês, vista da semana, vista do dia e vista da disponibilidade. Os dados registrados de diferentes intervalos de tempo podem ser exibidos separadamente através de diferentes estilos de grade. A visualização de disponibilidade exibe os dados do registro diário com cada calendário como dimensão, incluindo meu calendário e outros calendários. Clique no ícone "botão calendário" na parte superior direita da página do calendário para mudar as visualizações. <br> O que pode ser visualizado na visualização do calendário: O calendário inclui meu calendário e outros calendários. Você pode visualizar meu calendário na visualização do calendário, incluindo todos os dados gravados do meu calendário de eventos e do calendário de objetos. Nos referimos a estes registros como "entradas de calendário". <br> Você pode visualizar todos os eventos que você tem na visualização do calendário. O calendário que você criar com o objeto exibirá os dados como entradas do calendário na visão do calendário no campo de data. Você também pode visualizar outros calendários na visualização do calendário, ou seja, você pode visualizar qualquer entrada de calendário compartilhada por seus colegas que você tenha adicionado à visualização. <br>`,
"label.tabpage.rowsz":`Eliminar filas`,
"label.file.library.managemembers.memberlist":`Membros atuais`,
"label.report.action.addtodashboard4":`Adicionar ao Dshboard de Saída`,
"label.chat.send.voice":`Enviar uma mensagem de voz`,
"label.home.dashboard.add":`Adicionar à página inicial Painel de Controle`,
"front-dialog-module-v1-copied-requestid":`A identificação da solicitação é clonada`,
"label.customfields.exportdata":`Exportação de dados`,
"label.emailobject.signature":`Assinatura`,
"label.hide.source":`Ocultar código fonte`,
"label.icon.71":`Serviço`,
"vue_label_help_whatslightning":`O que é Relâmpago`,
"report.type.label.systemReport":`Relatórios do sistema`,
"front-kefu-moudle-v1-input-email":`Por favor, digite o endereço de email`,
"label.event.moveup.5minutes":`5 minutos à frente`,
"message.error.postsid.null":`A identificação do correio não pode estar vazia!`,
"UG.Account.05":`Diagrama da estrutura de contato`,
"label_emailtocloudcc_description3":`Conecte sua conta de e-mail empresarial, tais como sales@company.com, info@company.com, support@company.com. Registre automaticamente os e-mails que você recebeu como leads e registros de casos no CloudCC para garantir o acompanhamento oportuno das cartas dos clientes.`,
"report.label.searchresult":`Resultados da busca`,
"vue_label_report_detailsonly_desc":`Somente linhas de detalhes de exportação. Use estes dados para cálculos adicionais ou para fazer upload para outros sistemas.`,
"label.partnerCloud.partnerAccount.payment":`Valor do pagamento:`,
"vue_label_commonobjects_view_select_member":`Selecione um membro`,
"label.emailtocloudcc.step1.lead1":`Email para liderar`,
"label.forecast.settings.current":`Período atual`,
"label.canceluploadfile":`Cancelar upload`,
"label.manual.shared":`Compartilhamento manual`,
"label.document.uniquename.length.cannot.than":`A extensão do nome único do documento não pode exceder 255 caracteres.`,
"vue_label_lead_notcreateopportunity":`Não criar oportunidades`,
"APPIntegration.Social.twittererror":`Você deve digitar uma URL válida para o twitter.com`,
"message.duplication.label.errormessage":`Mensagem de erro`,
"label.file.img":`Imagem`,
"label.tabpage.sum":`Contagem total?`,
"label.permission.systempermission.fenpei":`Atribuição de permissões`,
"template.dashboard.folder.data":`Análise de dados`,
"label.sms.account":`Conta de usuário`,
"label.product.filter":`Filtro de produto`,
"label.file.content":`Conteúdo do texto`,
"label.percent":`Porcentagem`,
"label.single.attachment":`Único`,
"label.processsetting.failed.enable.process":`Falha em ativar o processo`,
"label.view.modify":`Editar`,
"label.knowledgebase.enter.keywords.filter":`Por favor, digite palavraschave para filtrar`,
"label.tabpage.uploadfailez":`Upload falhou, por favor, recarregue.`,
"label.please.enter.the.target.model.name":`Por favor, digite o nome do modelo alvo.`,
"label.layout.availabletab.related":`relacionado`,
"label.label":`Etiqueta`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Sábado`,
"label.addattachment.unit":`byte`,
"vue_label_commonobjects_view_selected":`{checkedLength} registro(s) selecionado(s)`,
"label.view.sortview.printble":`Imprimível`,
"label.umeng.insert.approval.approvaling":`#O solicitante submete #obj#objnome#doproprietário para sua aprovação`,
"label.forecast.customforecast.tztotal":`Montante Total Ajustado`,
"label.ccchat.failtoset":`erro de ajuste do ccchat`,
"label.ccchat.message.new.error2":`Usuário do CCChat`,
"label.validate.function.category.Advanced":`Avançado`,
"label.projectManagement.team.members":`Membros da equipe`,
"vue_label_report_clickcrosstofliter":`Clique nas interseções da tabela acima para filtrar os detalhes.`,
"lable.opppdt.selPdt.leasttwenty":`Você pode selecionar até 25 linhas`,
"label.campaign.channel.download":`Download do Código HD QR`,
"component_event_label_person":`Pessoa designada`,
"vue_label_homepage_new_homepage":`Nova página inicial`,
"label.version.sum.vlidaterule":`Regras de validação`,
"vue_label_chat_click_for_details":`Clique para maiores detalhes`,
"label.fold":`Dobrar`,
"label.readonly":`Somente leitura`,
"label.h5.similar.opportunity.result":`Oportunidades similares`,
"label.yourimportsuc":`Seu pedido de importação foi processado, por favor, veja seu e-mail.`,
"label.report.line.yixuan":`Coluna de relatório selecionada`,
"setup_layout_label_areaname":`Nome da seção`,
"label.forecast.edit.title":`Meta`,
"label.chatter.allweather":`Para todas as condições climáticas`,
"label.service.ganttBaiduMap.scheduled.endtime":`Data final planejada`,
"lable.create.new.list":`Nova Lista`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Digite sua palavra-chave e critérios de filtragem.depois clique em Pesquisar para iniciar sua pesquisa Clique em Mais filtros para usar mais de um filtro. Os resultados da pesquisa incluem todos os registros que correspondem tanto à sua palavra-chave como às entradas do filtro.`,
"label.file.versionerror1":`Você pode clicar no link abaixo para mudar diretamente para a nova aba de arquivo de interface, ou você pode usar a função de aba de arquivo depois de mudar manualmente para a nova interface`,
"label.under.approve.record":`Pendente`,
"front-epwechat-module-v1-open":`Habilitar`,
"label.projectManagement.delete.task":`Todas as informações relacionadas a esta tarefa também serão apagadas se você apagar esta tarefa, e os dados não podem ser recuperados. Você tem certeza de confirmar a exclusão?`,
"label.reportforms":`Relatórios`,
"label.tabpage.onlymevisible":`É visível apenas para mim`,
"label.customer.tab.please.name":`Por favor, digite o nome da guia`,
"label_emailsync_form_stutas":`Status`,
"message.recordtype.nolist":`Não há tipos de registros definidos.`,
"label.version.forecasting.sales":`Previsões`,
"chatter.sel.mostfield":`Você pode selecionar até`,
"label.data.derived":`Exportação de dados`,
"label.component.helper.businesschange.expiredtask":`Oportunidades com Tarefas Vencidas`,
"label.cycle":`Ciclo`,
"lable.product.standp":`Preço padrão`,
"label.sendemail.batchapproval":`Operação de aprovação de lotes`,
"message.organization.not.open.mffverification":`A organização não permite a certificação secundária.`,
"label.icon.131":`Guarda-chuva`,
"UG.activity.08":`Reserve um horário`,
"label_partner_workspace_member_choicepermission":`Selecione o conjunto de permissões`,
"label.reportTypeCategory":`Fonte de dados do relatório`,
"label.exporttwotype":`Você pode exportar dois tipos de texto`,
"message.oppdt.selectpricebook":`Por favor, selecione o livro de preços`,
"vue_label_dashboard_generatefromlistview":`Gerar a partir da lista`,
"label.quote.title":`Título`,
"label.tianyancha.businessverify.cancel.sure":`Após desativar a verificação dos dados comerciais, é impossível preencher as informações de registro da empresa ao criar/editar um cliente. está confirmado?`,
"label.save":`Salvar`,
"label.mobile.quickcreate.default.appstore":`Apps`,
"label.partnerCloud.orderingPlatform.configure":`{a} os produtos não são configurados, favor salvar após a configuração.`,
"front-epwechat-module-v1-unbound-role":`Funções não vinculadas`,
"label.partnerCloud.financeSetting.enterAlipay":`Por favor, digite a cidade de Alipay.`,
"label.validate.function.funcExplain.TODAY":`Voltar à data atual`,
"label.visualpage.parameter.values":`Exibir os valores dos parâmetros diretamente na página:`,
"label.version.task.and.activity":`Tarefas e atividades`,
"label.audit.history":`Histórico de aprovação`,
"setup.object.field.dependency.label.addtolist":`Adicionar os valores selecionados`,
"vue_label_report_exportquantity":`Quantidade exportada:`,
"label_tabpage_havez":`Em anexo`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Montante disponível do bônus`,
"label.createralias":`Criado por Alias`,
"label.created_followup":`Criar email de acompanhamento`,
"label_chatter_mygroups":`Meus grupos`,
"label.chat.topic.no.display":`Não há tópicos que possam ser exibidos`,
"vue_label_calendar_month_view":`Vista calendário-mês`,
"label.service.gantt.resources.assigned.work":`Recurso com Trabalho Designado`,
"UG_activity_07":`Criar uma tarefa`,
"label.quote.xsjg":`Preço de venda`,
"message.toomanyrows":`Demasiados registros para serem consultados.`,
"label.importsourcestep1":`Passo 1 Prepare o arquivo separado da guia traduzida`,
"vue_label_normal_appointment_sf":`Nomeação`,
"lable.list.queue.message":`A fila não pode ser apagada, pois há registros de objetos que pertencem à fila.`,
"label.service.major.event.desc":`O marco representa etapas dependentes do tempo no processo de apoio. Ele pode ser adicionado ao início do processo de concessão de direitos. Você pode então aplicar o processo ao direito de contas e criar caso ou ordem de trabalho a partir delas.`,
"label.ems.hostorport.null":`Tanto o servidor quanto a porta não podem estar vazios.`,
"chatter.group.private":`Particular`,
"label.icon.192":`Barra de sabão`,
"vue_label_systemSettings_list":`Configuração de exibição de lista relacionada`,
"label.activity.saveobj.notnull":`O objeto salvo não pode estar vazio.`,
"vue_label_chatter_current_no_people_approval":`Atualmente não há pessoas precisando de aprovação`,
"label.tianyancha.reglocation":`Endereço registrado`,
"UG_ST_005":`Já está, não me mostre esta página novamente e faça o login direto na próxima vez.`,
"label.vlidaterule.example.truetodisplay":`Esta mensagem aparecerá quando a fórmula de Condição de Erro for verdadeira`,
"label.icon.99":`Notas`,
"label.whenselectmoreapprover":`Quando você seleciona mais de um aprovador`,
"label.forecast.customforecast.directorbest":`Melhor caso de Subordinado Direto`,
"label.customsetting.view.introduce":`Forneça valores para os campos que você criou. Estes dados são armazenados em cache com a aplicação.`,
"label.there.are.no.unenabled.rules":`Todas as regras são habilitadas.`,
"front-project-module-v1-plase-selectemplat":`Favor selecionar o modelo do projeto`,
"label.campaignmember.selectmember.from":`De`,
"setup_layout_button_quicksave":`Salvar rapidamente`,
"label.setup.service.report":`Configuração do modelo de relatório de serviço`,
"label.visualpage.direction.for.use":`Instrução de Páginas Custome [versão 2.0]`,
"message.modify":`Você tem certeza de que quer modificar?`,
"label.sms.inside":`Interior`,
"label.category.3":`Educação`,
"label.login.mfadevice.verification.title":`Verificação de dispositivos AMF`,
"UG_Forcast_08":`Passo anterior`,
"label.projectManagement.unable.to.complete":`Incapaz de completar`,
"front-kefu-moudle-all-missphone":`Todas as chamadas perdidas`,
"font-evaluate-module-v1-emergency":`Advertência`,
"label.sso.saml.sp.idsource.attr":`A identidade está em um elemento Atributo`,
"chatter.not.meg":`Não é possível enviar uma mensagem vazia.`,
"label.chatter.startDate":`Dados iniciais`,
"label.emailobject.track.times":`Total aberto: {0}`,
"label.customsetting.fieldhasbeendeleted":`Campos eliminados`,
"label.knowledge.setting.hint.thirteen":`Adicionar outra categoria de dados`,
"message.duplication.label.newfiltertitle":`Nova regra duplicada`,
"setup_object_field_dependency_label_selectedfieldvalue":`Valores de campo disponíveis`,
"vue_label_calendar_who_currently_has_access":`Quem atualmente tem acesso`,
"message.passwordPolicy.validate.minlengthe":`caráter(es)`,
"label.emailsync.status.disconnect":`Cancelar Conncet`,
"label.applt.down.one":`Download Onetap`,
"label.manageAll.sel.one2":`Itens que eu apresentei`,
"message.error.SQLTimeout":`Devido à configuração inadequada do sistema ou consultas SQL personalizadas não otimizadas, o sistema excedeu a capacidade de consulta permitida, o que causou a falha da consulta. Favor entrar em contato com o administrador do sistema para o ajuste do sistema.`,
"label.global.search.obj.setup":`Configurações globais de objetos pesquisáveis`,
"vue_label_commonobjects_view_chat":`Equipe`,
"vue_label_systemSettings_startSet":`Iniciar a configuração`,
"label.quickbooks.viewlist.balance":`BALANÇO`,
"message.error.fieldid.null":`fieldid não pode estar vazio! Identificação do conteúdo do arquivo`,
"label.replaceallnullvalue":`Substituir todos os valores em branco`,
"label.georgia.time":`Hora da Geórgia`,
"label.hastransfer":`Contém convertido`,
"label.partner.all.description":`Descrição`,
"font-evaluate-module-v1-following-peopple":`Quando você receber a revisão negativa, notifique os seguintes usuários`,
"label_business_count":`Valor da oportunidade de negócios`,
"vue_label_ccchat_closedetail":`Fechar`,
"label.partner.all.disable":`Desativar`,
"label.view.relationship":`Relacionamentos Objeto`,
"label.noless":`>=Mais que ou Igual`,
"label.sendsms.batch.step2":`Passo 2 Selecione um modelo ou personalize seu conteúdo SMS`,
"label.stdashbord.xsld.business.jieduan":`Nome do Estágio`,
"label.appupload.component.type.trigger":`Gatilho`,
"label.knowledge.setting.data.two":`O nome da categoria é obrigatório.`,
"label.color.display.of.completion.rate":`Exibição colorida da taxa de preenchimento`,
"label.loginhis.default":`Liste os últimos 200 históricos por padrão`,
"vue_label_pricebook_book":`Lista de preços atual`,
"label.knowledgebase.data.deletion.failed":`{a} a exclusão de dados falhou`,
"label_partner_workspace_member_permission":`Conjunto de permissões disponíveis`,
"label.list.userinterface.approval.setup":`Configuração de Aprovação`,
"label.weixin.binding.effect":`Vinculação inválida, favor fazer o login novamente.`,
"label.appupload.install.newapicannotnull":`O novo nome da api não pode estar vazio`,
"chatter.feed.menutype.feed.company":`Todas as empresas`,
"label.assignment.setup.detail.email":`Email`,
"label_tabpage_selectcontentz":`Favor selecionar o conteúdo`,
"template.report.converted.leads.campaign":`Leads Convertidos de Campanhas`,
"label.forecast.season":`Este trimestre`,
"label.post":`Correio`,
"label.knowledge.setting.hint.fifteen":`A fundação foi lançada. Agora você e sua equipe podem escrever e organizar seus artigos de conhecimento.`,
"front-kefu-moudle-v1-Seats-name":`Apelido de Agente`,
"label.weixin.leadname":`Nome de chumbo`,
"label.account.quarter":`Trimestre`,
"label.detail.field":`Campos de visão`,
"label.icon.189":`Cosmético`,
"label.appointment.disable.reappointment":`Desativar reprogramação`,
"label.appointmentconfirmpage.wizard.subtitle1":`Nome do evento`,
"label.campaign.channel.step6.remark3":`O sistema irá gerar um código QR único para solicitação, que pode ser utilizado pelos funcionários e as solicitações realizadas podem ser contadas para seus desempenhos pessoais.`,
"System.AddressFieldType.Post":`Código Postal`,
"label_partner_new_step2":`Passo 2 Confirmar modelo`,
"vue_label_helpcenter_file":`Veja e gerencie seus arquivos<br> Use a nova versão do objeto de arquivo para ver e gerenciar arquivos de sua propriedade ou compartilhados por outros. Você pode visualizar os arquivos em alguns formatos online. <br>Biblioteca de arquivos<br> Use a função biblioteca de arquivos para estabelecer uma base de conhecimento da equipe, configurar diferentes administradores e membros para uma gestão conveniente; use a função pasta para classificar os arquivos.`,
"label.locateddowncurrentvalue":`O valor abaixo do valor atual`,
"label.tianyancha.businessverify.msg5":`2. confiabilidade do serviço`,
"label.setup.mobile.bottombutton.change.success":`Mudanças bem sucedidas`,
"label.appointmentconfirmail.wizard.subtitle2":`Hora`,
"label.email.address.lookup":`Pesquisar endereço de e-mail`,
"setup.mainpage.label.welcome":`Bem-vindo à plataforma CloudCC PaaS, as principais funções da plataforma são as seguintes:`,
"label.icon.55":`Bulldozer`,
"label_tabpage_enterrecordnamez":`Por favor, digite o proprietário do registro`,
"label.tabpage.andz":`E`,
"label.selectfiletoimport":`Selecione o arquivo a importar`,
"label.version.sum.trigger":`gatilho(s)`,
"label.multi.layout":`Layouts compactos`,
"pagecreator.button.back":`Último Passo`,
"label.imgfield.truetype":`Favor carregar o tipo de imagem correta`,
"front-kefu-moudle-v1-publicKey":`Chave compartilhada`,
"label.data.exp.newtemp":`Criar modelo`,
"label.martrixreport.2018.step4.new":`Passo 4 Escolha os cabeçalhos das colunas`,
"label.sendemail.chat.addComentsatsubject":`Fui mencionado na mensagem CCC do CloudCChat`,
"vue_label_applauncher_description_leadpool":`Use o Lead Pool para administrar convenientemente o status de acompanhamento dentro da organização e motivar o pessoal a concluir as transações.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Você só pode arquivar artigos publicados que não tenham rascunhos.`,
"label.projectManagement.bar.chart":`Gráfico de barras`,
"label.ccpeak.condition.return.sort":`Devolução e classificação por condições`,
"label.salescloud.opportunity.contactrole":`Oportunidade Função de contato`,
"label.language":`Idioma`,
"message.error.view.badprevilege":`Desculpe, não é permitido que você seja atendido por este serviço, por favor entre em contato com seu administrador.`,
"label.textmessage.managetemplates":`Gerenciar modelos`,
"message.error.type.null":`O tipo não pode ser nulo!`,
"setup.mainpage.label.welcome9":`Os usuários podem realizar a exibição de classificação e ajuste de layout de todos os elementos da página e a configuração de campos somente leitura e campos obrigatórios dos campos da página, arrastando e soltando o mouse sem desenvolvimento de código.`,
"label.appupload.component.type.page":`Páginas personalizadas`,
"label.textmessage.bookschedule":`Clique no link abaixo para ver e reservar minha agenda:`,
"component_chatter_post_button_save":`Publicar`,
"lable.oppt.jieduan.signcomplete":`Marcar a etapa como concluída`,
"label.help.notes":`AJUDA E GUIA`,
"label_tabpage_reallproplez":`Registrar todas as pessoas`,
"label.obtain.authorization.failure":`Falha na aquisição do código de autorização. Por favor, reautorize.`,
"label.account.FiscalQuarter":`Trimestre fiscal`,
"label.customsetting.savecustomvalue":`Os dados para este local já existem, por favor modifique-os e salve-os novamente.`,
"label.maximum":`Máximo`,
"component_chatter_file_label_maxsize":`O tamanho máximo do arquivo é de 20m`,
"c218":`Seu posto foi salvo como rascunho`,
"c875":`Novo posto para conversar`,
"c183":`Filtro de etiquetas`,
"c366":`Configurar a piscina`,
"c91":`Pontuação de interação por email`,
"c184":`Avanço de Palcos`,
"c750":`Iniciador:`,
"c619":`As mensagens no Twitter devem ter 280 caracteres ou menos. Tente usar as contrações para encurtar as coisas.`,
"c69":`A pagar`,
"c675":`Alinhado à esquerda`,
"c533":`Contagem de casos melhorados`,
"c167":`O comprimento do pedido é necessário`,
"c682":`Praça`,
"c960":`Super Edição`,
"c850":`Isto mostra o número atual de seguidores para cada uma de suas contas sociais, exceto para o Facebook, que mostra o número atual de páginas gostadas.`,
"c343":`Adicionar membros do projeto`,
"c8":`Escolha o formulário`,
"c157":`Modo de tomada de pedidos em aberto`,
"c397":`Tripulação de serviço`,
"c556":`as imagens não são publicadas`,
"c563":`Tempo ativo`,
"c179":`Logotipo do parceiro`,
"c147":`Regras de tomada de pedidos`,
"c303":`Obrigação legal`,
"c885":`Esconder a barra lateral`,
"c808":`Inserir imagem`,
"c718":`Continuar a criação`,
"c414":`Obrigado por seu tempo em completálo.`,
"c9":`Solicitação de funcionários`,
"c15":`Foi faturado. Favor selecionar novamente`,
"c59":`Por favor, vincule primeiro como administrador Easemob e depois entre na configuração avançada.`,
"c504":`Planejar projetos, designar trabalho, gerenciar recursos e colaborar com sua equipe para atingir as metas do projeto, controlar o progresso do projeto, entregar o projeto dentro do prazo e do orçamento.`,
"c836":`Conta Bind Fadada`,
"c187":`Página de agradecimento`,
"c208":`Download do pacote`,
"c952":`Brasil`,
"c104":`Responder uma vez`,
"c346":`Cálculo dos recursos da tarefa`,
"c913":`Expandir a barra lateral`,
"c571":`{O(s) formulário(s) foi(ão) selecionado(s)`,
"c44":`Escolha uma rede para se conectar`,
"label.social.posts.content.null":`O conteúdo da postagem está vazio`,
"c852":`Nome da empresa (Não preenchido)`,
"c561":`Aplicar filtro`,
"obtain.contract.envelopeid.fail":`Falha em obter informações de envelope ou informações de mensagem não vinculada`,
"c465":`Somente pedidos que utilizam a mesma moeda podem gerar uma fatura`,
"c982":``,
"c350":`Classificação de tarefas`,
"c352":`Calendário de Recursos Humanos`,
"c670":`Ícones gráficos`,
"front-electronic-signature-given":`Entrega`,
"c542":`Avaliação da satisfação`,
"c314":`Gerar Arquivo de Fatura`,
"c148":`Configuração da Notificação por email`,
"c47":`Conectar Domínio`,
"c754":`Preencher`,
"c326":`Lista técnica de ativos`,
"c289":`Preferência`,
"c196":``,
"c63":`Aberto {objNome}`,
"c769":`O documento de tarefa iniciado assinado será liberado após a revogação. Continuar a desfazer?`,
"c216":`Seu posto foi agendado`,
"c842":`Enviar Notificação de envio de email`,
"c389":`Território de serviço aos pais`,
"c7":`Proprietário da promoção`,
"c981":``,
"c143":`Selecione o usuário para receber notificações. Esta configuração pode ser alterada em qualquer página de desembarque em que o formulário for utilizado.`,
"c930":`Chave de posicionamento de funcionários`,
"c515":`Adicionar Resumo do Trabalho`,
"c393":`Membro do Território de Serviço`,
"c357":`Tarifa`,
"c597":`Bitola Alvo`,
"front-electronic-signature-cancelIntro1":`A assinatura E do DocuSign não estará disponível após a desobrigação. Você tem certeza de desvincular?`,
"c271":`Você tem um tempo limite para aceitar o pedido, número: {0}. Por favor, trateo prontamente e esteja ciente da demora do trabalho. Clique para ver mais >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`O Amap não funciona corretamente. Por favor, verifique se a chave secreta está correta!`,
"c424":`Gerenciamento do Território de Serviços`,
"c711":`Conecte suas contas sociais e alcance um mundo totalmente novo de fãs.`,
"c197":`Você atingiu o número máximo de envios. Obrigado por sua participação!`,
"front-electronic-signature-save-success":`Salvar o mapeamento com sucesso`,
"c765":`Bloqueado`,
"c286":`Nãoconformidade`,
"c145":`As horas de trabalho apresentadas para uma/múltiplas tarefas por pessoa por dia não podem exceder 24 horas.`,
"c264":`Gerenciar campos pessoais`,
"label.china":`China`,
"label.no.bind.mobile":`Sem celular. Por favor, vá para informações pessoais e vincule`,
"c95":`Eliminar produtos selecionados`,
"front-electronic-signature-open-signInfo1":`O Esign&stamp do DocuSign está habilitado. Por favor, desligueo e então ative o Esignature&stamp de Fadada.`,
"c391":`Ver Comentário`,
"c106":`Interações`,
"c519":`Todas as informações relacionadas a esta folha de tempos também serão apagadas se você apagar esta folha de tempos, e os dados não podem ser recuperados. Você tem certeza de confirmar a exclusão?`,
"c528":`Folha de tempos de registro`,
"c78":`Número do pedido`,
"c41":`Desobrigar com sucesso`,
"c517":`Favor inserir uma taxa de imposto válida`,
"c774":`Assine o progresso`,
"c296":`Favor preencher o campo nome`,
"c757":`Para aceitar`,
"front-electronic-signature-confirmintro":`Ligar com sucesso. Você pode iniciar agora a assinatura a partir do objeto Contratos.`,
"c446":`Status da tarefa`,
"c238":`{!ServiceResource.name} acedeu ao pedido. Conta: "{!ServicoApontamento.de.conta.nome}", Assunto: "{!ServiceAppointment.subject}", Número: "{!ServiceAppointment.name}".`,
"c980":``,
"c802":`Cada usuário só pode ser adicionado como um recurso de serviço`,
"c387":`Habilidades de recursos de serviço`,
"c965":`O serviço EaseMob não está habilitado`,
"c480":`Para qual lista devemos enviar?`,
"c937":`Mudança de número de telefone`,
"c632":`Ver no Facebook`,
"c131":`O campo de conta da fatura está vazio, favor acrescentar as informações.`,
"c680":`Branco`,
"c806":`Quando`,
"c649":`Você leu tudo o que estava em sua caixa de entrada.`,
"c797":`Contatos recentes`,
"c616":`Abrir link em nova janela`,
"c169":`Desculpe, você não tem permissão para ver este quadro`,
"c21":`O número do produto não pode ser menor do que o valor faturado`,
"c231":`Não pode ser menor do que o número de produtos que embalaram`,
"c555":`Sua imagem postada não foi publicada.`,
"c583":`Mapa da China`,
"front-electronic-signature-open-signInfo2":`O Esignature&stamp de Fadada está habilitado. Por favor, desligueo e habilite o Esignature&stamp do DocuSign`,
"c822":`Novos Contatos Externos`,
"c600":`Tabela numérica`,
"c442":`Sistema completo de gerenciamento de projetos`,
"c762":`Para assinar`,
"label.user.not.permission":`O usuário atual não tem permissão para operar`,
"c35":`Nome da Assinatura`,
"c921":`função(ões)`,
"c305":`Interesses Públicos`,
"c730":`Você não pode reutilizar a senha antiga`,
"c525":`Desativar Usuário do Portal`,
"c942":`América`,
"c780":`Processo de Assinatura`,
"c447":`Fonte Final do Canal`,
"c369":`Enviar arquivo de cotações`,
"c702":`Fazer rascunho`,
"c22":`O valor pago na fatura será maior do que o valor total se você continuar a criar este detalhe de pagamento. Por favor, reajuste o valor e economize novamente.`,
"c79":`Data do pedido`,
"c785":`Nome real (Opcional)`,
"label.insert.approval.reassign.error":`A aprovação no status de aprovação da inserção não pode ser reatribuída`,
"c273":`Aceitar o tempo limite para pedidos. Cancelar o despacho.`,
"c3":`Excluir gráfico com sucesso`,
"c448":`Sessão de batepapo`,
"c495":`Tudo o que você precisa para vender mais rápido e mais inteligente`,
"c429":`Despacho KPI`,
"c16":`Existem mais de um pedido faturado. Favor selecionar novamente`,
"c128":`Até 5 filas podem ser adicionadas`,
"c955":`A largura mínima de {label} é {minWidth}px`,
"c716":`Você está pronto para começar a postar diretamente do CloudCC`,
"c638":`Opções de publicação`,
"c746":`Pedido de revogação de destruição`,
"c534":`Contagem de casos encerrados`,
"c948":`Itália`,
"c317":`Enviar arquivo de pedido de compra`,
"c426":`Gerenciamento de recursos de serviço`,
"c457":`Valor agregado do contrato Ranking`,
"c263":`Campos pessoais`,
"c372":`Gerar ordem`,
"c907":`Disponível apenas na versão relâmpago`,
"c771":`Progresso de preenchimento`,
"c408":`Aplicação de serviço de campo personalizável`,
"c12":`Taxa de crescimento`,
"c379":`Detalhes de pagamento`,
"c410":`Tipo de trabalho`,
"c510":`Pedido de parceiros`,
"c701":`Campanha de Atribuição`,
"c617":`O texto é necessário para publicar um post`,
"c213":`Formato EPS`,
"c473":`O sistema irá gerar um código de convite único para os funcionários, que podem usar o código de convite para fazer convites e contar como desempenho pessoal. Favor observar que o proprietário principal será o atual proprietário da campanha ou do convite do canal de marketing.`,
"c975":``,
"c168":`Por favor, escolha uma tabela!`,
"c121":`Uncategorized`,
"label.send.invoice":`Enviar Fatura`,
"c792":`Confirmar Iniciar`,
"c686":`Tamanho`,
"c652":`Isto mostra o número de postos que foram preenchidos em suas contas dentro do período selecionado. Isto também inclui as postagens que foram publicadas em suas contas conectadas fora do CloudCC.`,
"c136":`Por favor, insira aqui uma breve introdução`,
"c662":`Ícone personalizado`,
"label.invoice.customer.is.error":`A geração de faturas só é suportada para pedidos feitos pelo mesmo cliente.`,
"c580":`Gráfico de bolhas`,
"c894":`Atribua campanha para o cargo e você pode rever todos os cargos relacionados na mesma campanha. Isto é utilizado para um esforço de marketing anlyazing.`,
"c570":`Projeto`,
"c133":`exceder`,
"c564":`Prezado usuário: \n Bemvindo ao sistema CloudCC. Você pediu para redefinir sua senha em {!operatetime}, por favor faça o login com o código de verificação abaixo dentro de 15 minutos: \Código de Verificação Aleatória: {!authcode}n Importante: Se você não solicitou esta operação, ou se você acha que esta mensagem não deve chegar até você, por favor contate seu administrador imediatamente!`,
"c854":`Parece que não há nada pubilizado.`,
"c775":`Interrompido`,
"c105":`Reproduzir mais de uma vez`,
"c729":`Favor confirmar se você configurou ou não a plataforma social. Ir para configurações backend  Integrações  Habilitar (Twitter/Facebook/LinkedIn)`,
"c491":`Desativado`,
"c609":`Marca registrada`,
"c611":`Link para`,
"c843":`Ver Submissão`,
"c933":`Página de Conversão`,
"c383":`Produtos de oportunidade`,
"c186":`A identificação única já existe. Por favor, não acrescente repetidamente`,
"c608":`Substitua`,
"c149":`Ativar notificação do Outlook (somente parte dos serviços de email de suporte)`,
"c486":`Responder ao endereço de email:`,
"c598":`Tabela de Donuts`,
"c726":`Pedido destruindo com sucesso`,
"c645":`Aprovar o rascunho`,
"label.verificationCode.is.invalid":`O código de verificação era inválido. Por favor, readquirao`,
"c904":`Entre`,
"c594":`Gráfico de linhas 2D`,
"c103":`Clique mais de uma vez`,
"c188":`comentário(s)`,
"c891":`O registro pode não ser um contato, oportunidade, chumbo ou conta`,
"c902":`Distância entre o endereço de entrada e o visitante`,
"c484":`Emails:`,
"c421":`Método de geração de ordens de trabalho`,
"c406":`Gestão automatizada de vendas`,
"c739":`Campanha: Solicitação de funcionários`,
"c329":`Substituição de ativos`,
"c351":`Freqüência de recorrência`,
"c622":`As estatísticas da rede são atualizadas pela última vez em`,
"2":`Configurar as opções de filtragem com sucesso`,
"c463":`Minhas Oportunidades`,
"c268":`Fundir informações com sucesso`,
"label.mobile.no.letter.blankcharacter":`O número de telefone não pode conter letras e caracteres em branco`,
"c438":`Transferência`,
"c581":`Tabela MoM&YoY`,
"c953":`Coréia do Sul`,
"c90":`Assunto`,
"c2":`Eliminar o painel de instrumentos com sucesso!`,
"c897":``,
"c444":`Primeira Fonte de Canal`,
"c242":`{!ServiceResource.name} rejeitou o pedido. Conta: "{!ServiceApontamento.conta.nome}", Número: "{!ServiceApontamento.nome}".`,
"c135":`Modelo em branco`,
"c659":`Sigame`,
"c773":`Finalizando`,
"c11":`Promoção do marketing de formulário`,
"c799":`Contatos externos`,
"c880":`editar postos sociais`,
"c890":`Enviar email de convite com sucesso`,
"c846":`Por favor, selecione uma consulta de serviço elegível`,
"front-electronic-signature-sucessSign":`Comece a assinar com sucesso`,
"c472":`Escolha um formulário para aplicar o cartaz em`,
"c963":`O campo do nome é obrigatório`,
"c390":`Território de Serviço à Criança`,
"c248":`A aceitação da transferência da ordem está pendente`,
"c646":`Fluxo de caixa de entrada`,
"c308":`Selecione pelo menos um dado`,
"c858":`Você tem certeza de que quer salvar {a} postos como rascunhos? Estes posts não serão publicados a menos que você os agende novamente.`,
"c152":`Número de compromissos de serviço concluídos no intervalo de tempo atualmente selecionado / Número de todos os compromissos de serviço no intervalo de tempo atualmente selecionado`,
"c316":`Ver Progresso do Caso`,
"c435":`Ver versão`,
"c362":`Restrições de produto anexas`,
"c800":`Favor entrar o nome ou nome da empresa`,
"c415":`Início programado`,
"c735":`O nome não pode ser repetido`,
"c903":`Selecione o ícone de aplicação`,
"label.insert.approval.massreassign.error":`Aprovações de lotes existentes A aprovação de inserção não pode ser reatribuída. O sistema irá autofiltrar para você`,
"c354":`Editar folha de tempos`,
"c409":`Plataforma de atendimento ao cliente de uma só vez`,
"c651":`Isto mostra o número de seguidores atuais para cada uma de suas contas sociais, exceto para o Facebook, que mostra o número de páginas atuais que você gosta.`,
"c582":`Mapa mundial`,
"c826":`Você tem certeza de que quer descartar suas mudanças?`,
"c781":`Empresa: Por favor, digite o nome da empresa na licença comercial. A verificação será feita ao assinar.`,
"c873":`Mais detalhes`,
"c837":`Após a desobrigação, a função Fadada Esignature não pode ser usada, e a função de preenchimento automático e de campo de preenchimento posterior que foram definidos serão apagados. Você tem certeza de destravar a conta?`,
"label.diedirect.sale":`Reduções Diretas de Preços`,
"c798":`Contatos Internos`,
"c368":`Gerar arquivo de citações`,
"c770":`Iniciado em`,
"c882":`Termos de serviço`,
"front-setting-dialog-title-two":`Configurado a partir da página de informações pessoais, se não for introduzido desta vez. Ata à medida que você digita o número`,
"c535":`Não resolvido`,
"front-electronic-signature-look-account":`Ver conta`,
"c19":`Modo de exibição de detalhes de registro`,
"c52":`Nome fiscal`,
"c388":`Direito de associação e uso`,
"c18":`Existem mais de uma ordem inativa, favor selecionar novamente`,
"c820":`Favor digitar o número de telefone/caixa postal`,
"c285":`Visão geral`,
"c478":`Autenticar o Mailchimp`,
"c164":`Favor inserir um valor inteiro de 060`,
"label.tip.excess.quota":`Este uso de recursos foi excedido`,
"c318":`Gerar arquivo de pedido de compra`,
"c698":`Rede Social`,
"c312":`Pedidos múltiplos ainda não são efetivos, favor selecionar novamente`,
"c110":`Agrupar por projetos`,
"c549":`O intervalo de datas não pode exceder 31 dias!`,
"c845":`Favor selecionar pelo menos uma consulta de serviço`,
"c282":`Gerenciar dados pessoais de clientes dentro do CRM`,
"c270":`Aceitando o tempo limite para pedidos`,
"c288":`Alterar base de processamento de dados`,
"c878":`Endereço atual`,
"c324":`Adicionar filas aos casos`,
"c129":`Esta ação apagará o arquivo permanentemente. Você quer continuar?`,
"c339":`Dados GDPR Destroy`,
"c405":`Tamanho da tripulação`,
"c848":`Contas Linkedin`,
"c345":`Modelo de projeto`,
"c591":`Mapa da Austrália`,
"c180":`Idioma na página de Login`,
"c126":`Entregue em`,
"c311":`Não efetivo, favor selecionar novamente`,
"c587":`Mapa do México`,
"c37":`Este é o texto a ser visto na página de preferência de comunicação por seu cliente`,
"c840":`Viva! Nada de postos de trabalho malucos.`,
"c241":`{!ServiceResource.name} rejeitou o pedido. Conta: "{!ServicoApontamento.de.conta.nome}", Assunto: "{!ServiceApontamento.assunto}", Número: "{!ServiceApontamento.nome}".`,
"c141":`A mensagem de agradecimento é necessária`,
"obtain.contract.fail":`Falha em adquirir informações contratuais`,
"c945":`Rússia`,
"c454":`Valor do Contrato Mensal`,
"c34":`Você tem 100 produtos em seu carrinho de compras. Por favor, limpe pelo menos um item antes de adicionar um novo produto.`,
"c243":`{!ServiceResource.name} rejeitou o pedido. Assunto: "{!ServiceApontamento.assunto}", Número: "{!ServiceApontamento.nome}".`,
"c548":`Tarefa/assessoria, subtarefa e projeto não podem ser editados a partir de uma folha de tempos`,
"c807":`Postar agora`,
"c590":`Mapa da Alemanha`,
"c831":`Certificando`,
"c198":`Seu formulário é publicado com segurança e pode ser usado na seguinte URL para compartilhar seu formulário como um link público.`,
"c977":``,
"c66":`As informações logísticas do produto são atualizadas para Entregue`,
"label.twitter.title.setting":`Informações integradas no Twitter`,
"c922":`Favor entrar em contato com o administrador para habilitar a equipe`,
"front-email-payment-Invoice-Tips":`Entre em contato com o administrador para ativar o PayPal ou VISA e depois iniciar o pagamento online`,
"c605":`	
Endereço padrão de faturamento`,
"c403":`Projetos`,
"c156":`Regras de tomada de pedidos para o lado móvel`,
"c635":`Agende outro posto`,
"c753":`Participante`,
"c647":`Todas as atividades`,
"c295":`Após o desligamento, todos os campos pessoais de marcação, base de processamento de dados e outras informações para cumprir com a DGPR serão removidos, exceto o histórico de operações para registros. Você tem certeza de que vai se desligar?`,
"c915":`Piscina aberta`,
"front-electronic-signature-signStatus":`Você começou a assinar online. O status do contrato é {signStauts}.`,
"c568":`Ajustar o layout`,
"c744":`Favor inserir um número válido entre 0 e 100`,
"c464":`postagem(s) são eliminados`,
"c385":`Resumo do trabalho`,
"c392":`Escolha a solução que você precisa`,
"c418":`Recursos de Serviços Atribuídos`,
"c256":`A mudança de conta limpará o pedido com itens selecionados. Tem certeza de que vai mudar?`,
"c690":`Carregamento de imagens`,
"c261":`Destruir dados`,
"c62":`Solicitação de funcionários`,
"c892":`O registro atual não foi encontrado`,
"c909":`As definições de preços para esta moeda foram acrescentadas. Por favor, não adicione novamente!`,
"c883":`&`,
"c134":`Limite superior dos membros do pool`,
"c896":`O registro bloqueou e não suporta a adição de arquivos. Favor entrar em contato com o administrador para desbloquear`,
"c974":``,
"c209":`Tamanho médio`,
"c185":`Estatísticas nesta página`,
"c796":`Favor entrar em contato com o administrador para estabelecer um modelo de contrato na plataforma Fadada antes de iniciar a assinatura.`,
"c60":`Contagem de projetos`,
"c866":`Aplicação de configuração`,
"c666":`Mostrar`,
"c219":`Seu posto foi excluído`,
"c732":`Pôster`,
"c155":`{nome} Nome`,
"c511":`Econtrato`,
"c240":`Rejeitado`,
"c468":`O tipo de ordenação está vazio`,
"c961":`Q{quarter} {ano}`,
"c404":`Uma ferramenta de marketing e geração de leads`,
"c586":`Mapa de Cingapura`,
"c694":`Largura/Altura`,
"c297":`Favor inserir o tipo de dados pessoais`,
"c860":`Alterar endereço`,
"c58":`Página inicial do projeto`,
"c920":`Se as regras de autoreciclagem forem configuradas, o sistema fará a autoreciclagem dos registros para o pool quando o chumbo não tiver sido convertido após o limite de tempo. Isso melhora a eficiência do acompanhamento do chumbo.`,
"c27":`Favor inserir a quantia flutuante para ajustar a quantia bruta, por exemplo,  10 ou 10.`,
"c94":`3 vezes acima`,
"c1":`Somente móvel`,
"c557":`Casos Recebidos`,
"c294":`Desligar as configurações de conformidade da GDPR`,
"c970":``,
"c565":`Atribuir esta tarefa a`,
"c668":`Alinhamento`,
"c972":``,
"c660":`Direitos autorais`,
"c433":`Rastreamento de campo do pool de chumbo`,
"c443":`Arquivo Todos`,
"c275":`{0} tem um timeout de aceitação da ordem, e o despacho é cancelado. Número: {1}. Clique para ver mais >`,
"c691":`Link(Opcional)`,
"c956":`Você ainda não ativou sua conta Mailchimp. Por favor, vá para configurações>Integração>Lista de integração para ativar sua conta Mailchimp ou contate o administrador.`,
"c910":`Nova Ordem de Trabalho`,
"c692":`Navegador padrão`,
"c355":`Adicionar Timesheets em lote`,
"c122":`Imagem do produto`,
"c395":`Tipo de território`,
"c689":`Altura máxima`,
"c344":`Ver Projeto com diagrama de Gantt`,
"c656":`Tempo de Atualização`,
"c943":`Japão`,
"front-electronic-signature-outerSinger":`Signatário externo`,
"front-generate-v1-invoiceDetail":`Detalhe da fatura`,
"front-electronic-signature-open-vertify":`Favor inserir o código de verificação`,
"c291":`Tipo de dados pessoais`,
"front-setting-phone-message":`Favor inserir o número de telefone`,
"c559":`Estojos Escalados`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`O Google map não funciona corretamente. Por favor, verifique se a chave secreta está correta!`,
"c259":`Noções básicas de processamento de dados`,
"c488":`Tempo Convidado`,
"c6":`Nome da promoção`,
"front-electronic-signature-signerInfo":`Configurar Informações Signatárias`,
"c512":`Membros do projeto`,
"c507":`Cultivo de chumbo`,
"c760":`Rejeitado`,
"c756":`Não enviar`,
"c321":`Requerido ou não`,
"c817":`Veja as configurações de permissão do menu de páginas personalizadas`,
"c949":`Espanha`,
"label.biaoqing.field.relation.tip":`Campo de descobertas de licitações e licitações`,
"c382":`Pontuação da Relação Líquida`,
"c265":`Esta ordem não pode ser alterada, pois ainda não está em vigor.`,
"c417":`Informações de trabalho dos recursos de serviço`,
"c847":`Contas Facebook`,
"c494":`Atingir uma gestão unificada de todos os canais no CloudCC Marketing Cloud. Construa conexões e confiança duradoura com seus clientes, impulsione o ROI com análises e transforme o alcance em receita.`,
"c86":`Campanha: Edit Employee Referal`,
"c776":`Desfazer com sucesso`,
"c709":`Escolha uma rede para se conectar`,
"label.mobile.orVerificationCode.is.error":`O número de telefone ou o erro do código de verificação`,
"c579":`Gráfico de radar`,
"c413":`Status de nomeação de serviço`,
"c950":`Países Baixos`,
"c573":`Gráfico de barras 2D`,
"label.choose.is.tax":`Escolha o tipo de imposto`,
"c768":`A tarefa de assinatura do contrato iniciado ainda não foi concluída. Favor baixar o documento depois que o contrato for assinado.`,
"c604":`O endereço de faturamento já existe, salvo o atual como novo endereço de faturamento`,
"c160":`Tratamento vencido`,
"c239":`Aceito`,
"c834":`Preliminar Aprovado`,
"c113":`Enviar {nome}`,
"c146":`Os produtos relevantes serão liberados após a troca da moeda. Você quer continuar a mudar?`,
"c313":`Enviar arquivo de fatura`,
"c140":`Escolha o objeto e o modelo`,
"c298":`Não conforme`,
"c681":`Círculo`,
"c870":`Você tem certeza de que vai excluir o lote?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> dias restantes no julgamento`,
"c88":`Dias restantes no julgamento`,
"c175":`Falha em obter informações detalhadas`,
"c64":`Se deve ou não abrir {objName}`,
"c319":`Configuração do Estilo do Formulário`,
"label.pay.online":`Iniciar o pagamento online`,
"c941":`China  Taiwan`,
"c550":`Favor escolher a data de início ou de término`,
"c365":`Sync Quote Line to Opportunity Product`,
"c908":`Selecione Ícone`,
"c260":`Solicitação para Destruir`,
"c50":`Taxa de imposto`,
"c869":`Você tem certeza de arquivar todos os dados`,
"c93":`Aberto Repetidamente`,
"c280":`Eliminar email`,
"c23":`O valor pago na fatura será maior do que o valor do pedido se você continuar a criar este detalhe de pagamento. Por favor, reajuste o valor e economize novamente.`,
"front-console-v1-see-contacts":`Identificou múltiplos contatos. Favor selecionar`,
"c607":`Já existe o endereço de remessa, salvo o atual como novo endereço de faturamento`,
"c229":`Eliminar marco miliário`,
"front-filter-v1-filter-by-name":`Filtrar por '{nome}'.`,
"c125":`Em trânsito`,
"c513":`Folhas de horas`,
"c80":`Endereço para faturamento`,
"c648":`Conversas`,
"c521":`Contagem de Encomendados`,
"c560":`Casos fechados`,
"c973":``,
"c509":`Lista de embalagem`,
"c685":`Adicionar novo endereço`,
"c178":`O formato da imagem carregada não é suportado. Favor carregar imagens no formato de png, jpg, e jpeg.`,
"c436":`Detalhes do Visitante`,
"front-electronic-signature-prepareTemplate":`Favor entrar em contato com o administrador para predefinir o modelo de contrato no sistema antes de começar a assinar.`,
"c749":`Processo de assinatura`,
"c114":`Favor clicar no botão Gerar {nome} para gerar {nome} antes de enviar.`,
"c898":``,
"c279":`Vendas`,
"c232":`Não pode exceder o número de produtos a serem embalados`,
"c911":`Despacho Cancelado`,
"c901":`Seu número de envios atingiu o limite.`,
"c663":`Texto alternativo`,
"c541":`Estatísticas de casos atuais`,
"c536":`Recebido`,
"front-project-v1-batch-deletion-confirmation-information":`A eliminação em lote dos registros selecionados também eliminará todas as informações associadas aos selecionados, e os dados não podem ser recuperados. Você tem certeza de que vai apagar?`,
"c893":`O usuário atual não pode ter acesso ao campo de endereço para editar detalhes da conta`,
"c623":`Monitor`,
"c493":`Shape Digital Marketing, Aproveite Todas as Oportunidades`,
"c327":`Hierarquia de ativos`,
"c747":`Seu número total de produtos está cheio. Favor excluir alguns produtos primeiro e depois continuar a adicionar produtos.`,
"c728":`Privacidade de dados`,
"front-reportlist-v1-optimizedReport":`relatórios são otimizados após consulta. Por favor, não modifique de forma aleatória.`,
"c741":`Por favor, preencha o conteúdo do correio!`,
"c643":`Detalhes do posto`,
"c537":`Tempo de resposta Avg`,
"front-electronic-signature-add-field":`Adicionar Campo de Enchimento`,
"c626":`Todos os usuários`,
"c199":`Link do formulário`,
"c917":`Use o pool para estimular o potencial da equipe e melhorar a eficiência do acompanhamento das contas. O administrador do pool faz uma gestão unificada para as contas e atribuições de lotes. O pessoal de vendas também pode selecionar leads e receber acompanhamento.`,
"c159":`O comprimento do pedido não excede um máximo de`,
"c640":`Posto de programação`,
"c192":`Layout atual da página:`,
"c978":``,
"c969":``,
"c871":`É assim que seu posto será exibido em {a}. Pequenas diferenças podem ocorrer se {a} fizer algum ajuste de layout.`,
"c814":`1{0} selecionado`,
"c235":`{!ServiceResource.name} acedeu ao pedido. Assunto: "{!ServiceApontamento.assunto}", Número: "{!ServiceApontamento.nome}".`,
"c215":`Seu posto foi publicado`,
"c425":`Gerenciamento de nomeação de serviços`,
"c182":`A ordem de trabalho e o registro do caso não podem ser conectados de uma só vez`,
"c194":`Número limite de envios`,
"c657":`Não há permissão para operate， favor entrar em contato com o administrador`,
"c855":`Parece que não há nada programado.`,
"c333":`Custo orçamentário`,
"c338":`Fornecedor  Destroy`,
"c431":`Hierarquia da campanha`,
"c374":`Produto do Livro de Preços`,
"c506":`Programação automatizada`,
"font-trade-module-invoice-totalMoney":`Total de contas a receber`,
"c203":`Compartilhe seus formulários através do Mailchimp`,
"c962":`{mês} {ano}`,
"c786":`Número de telefone/caixa de correio`,
"c469":`A página está em estado de edição. Os dados atuais não podem ser salvos se você deixar a página`,
"c137":`Escolha um modelo para o formulário`,
"c483":`Informações sobre a campanha`,
"c947":`França`,
"c190":`A moeda dos itens de pagamento deve ser consistente com a moeda do pedido, da fatura e do pagamento. Por favor, refine a moeda e economize novamente.`,
"c386":`Preenchido`,
"c803":`Contas: Todas as contas`,
"c759":`Para preencher`,
"c823":`Definição do pedido`,
"c422":`Método de Geração de Nomeações de Serviço`,
"c782":`Como Participar`,
"c416":`Relatório de Serviço Push Record`,
"c758":`Aceito`,
"c407":`Membro da equipe de serviço`,
"c51":`Novo imposto`,
"c844":`Bind DocuSign Conta`,
"c361":`Menu Editar`,
"c602":`Tabela Matricial`,
"c191":`É necessária a permissão de edição da visão atual`,
"c299":`Selecione pelo menos um objeto`,
"c432":`Histórico da campanha`,
"c650":`Publicar um novo post para iniciar uma nova conversação`,
"c531":`Contagem de Casos Recebidos`,
"c13":`O usuário atual não tem a permissão para editar`,
"c162":`Informar simultaneamente o cedente e o cessionário`,
"c171":`Participação acionária`,
"c230":`Eliminar tarefa`,
"c470":`Campos de preenchimento automático`,
"c367":`Gerar Contrato`,
"c26":`Estabelecer Desconto`,
"c705":`Publicações`,
"c613":`Página externa`,
"front-electronic-signature-openSign":`Comece a assinar`,
"c349":`Arrastar e Soltar`,
"c683":`Carregar mais`,
"c679":`Cinza`,
"c914":`Colapso da barra lateral`,
"c224":`Ir para Milestone`,
"c220":`Seu posto foi publicado sem sucesso`,
"c498":`O CloudCC Inventory suporta de forma eficiente os negócios on line e off line omnicanal, realizando o fluxo e a gestão de bens e fundos. Vários módulos são efetivamente combinados, e os usuários podem alcançar uma gestão refinada de pedidos para criar situações vantajosas para ambas as partes com parceiros.`,
"c566":`Autorecuperação do endereço da conta após salvar`,
"front-electronic-signature-ContractTemplate":`Escolha o modelo de contrato`,
"c540":`Solucionando o Tempo por Canais`,
"c793":`Modelos de documentos`,
"c293":`Definir objetos para permitir a conformidade da GDPR`,
"front-invoice-online-pay-again":`Você já iniciou um pagamento online. Por favor, não tente novamente.`,
"front-electronic-signature-open-password":`Por favor, digite a senha`,
"front-v1-partner-background-tooltip":`É suportado um arquivo máximo de 2M. É recomendado carregar imagens claras.`,
"c449":`Histórico do batepapo`,
"c30":`Clássico`,
"c245":`{!oldServiceResource.name} transferiu a ordem de trabalho numerada {!ServiceApontamento.name} para {!newServiceResource.name}.`,
"c923":`Aqui está sua equipe`,
"c24":`Mostrar Mapa`,
"c872":`Nome (Não preenchido)`,
"c886":`Barra lateral aberta`,
"c485":`Nome do formulário:`,
"c101":`pc(s)`,
"c816":`Ver post`,
"c445":`Papel do projeto`,
"c853":`Isto mostra o número de gostos e comentários para suas postagens publicadas.`,
"c398":`Comece agora`,
"c522":`Contagem de Faturados`,
"c287":`Conformidade`,
"c578":`Carta numérica MoM&YoY`,
"c40":`Por favor, digite a senha`,
"c631":`Ver no Twitter`,
"c489":`Tempo desativado`,
"c819":`Número de telefone/caixa de correio`,
"c935":`Tipo de formulário`,
"c625":`Todas as Campanhas`,
"c471":`Campanha: Indicação de funcionários`,
"front-electronic-signature-writen":`Preenchido`,
"c889":`Desativar a conta de usuário com sucesso`,
"c201":`Compartilhe este formulário através de sua mídia social`,
"c467":`O campo de classificação está vazio`,
"label.mobile.no.null":`O número de telefone não pode estar vazio`,
"c307":`Direito`,
"front-kefu-moudle-wait-calling":`Chamadas em andamento, por favor tente novamente mais tarde`,
"c784":`Por favor, digite o nome da empresa na licença comercial`,
"c490":`Última hora de Login`,
"c790":`Assinatura manuscrita`,
"c336":`Líderes  Destruir`,
"c453":`Página inicial Kanban`,
"c530":`Por favor, instale primeiro a caixa postal da empresa`,
"c610":`O ícone irá se conectar ao domínio mestre se você não tiver especificado a URL`,
"c359":`Quadro`,
"c193":`Limitações`,
"label.mobile.verificationCode.exceeded.times":`A contagem de tentativas foi excedida. Favor solicitar novamente`,
"c138":`Modelo de empresa`,
"c821":`Novos Contatos Internos`,
"c381":`Solicitar pagamento online`,
"c761":`Assinatura`,
"c964":`O campo de relação mestredetalhe é necessário`,
"c585":`Mapa do Reino Unido`,
"c500":`Fornecer soluções de atendimento ao cliente de uma só vez com processos padronizados e gerenciamento eficiente, coordenar recursos de serviço para fornecer o melhor suporte a seus clientes.`,
"c214":`Incluir bitmaps em três tamanhos e gráficos vetoriais em todos os formatos`,
"c714":`Agendar postos a serem publicados no momento certo.`,
"c552":`Rejeitado`,
"c684":`{sumTotalCount} mais`,
"c54":`Favor preencher o tipo de imposto`,
"c320":`Selecione os campos do formulário`,
"c236":`{!ServiceResource.name} acedeu ao pedido. Conta: "{!ServiceApontamento.conta.nome}", Número: "{!ServiceApontamento.nome}".`,
"c123":`Informações logísticas`,
"c654":`Voltar para a lista do Painel de Controle`,
"c335":`Margem de lucro`,
"c267":`Não foi possível comprometer mudanças para o critério não foi cumprido`,
"c226":`Ir para Subtarefa`,
"c102":`Clique uma vez`,
"c637":`Salvar como esboços`,
"c633":`Criar Novos Postos Sociais`,
"c777":`Configurar informações dos participantes`,
"c223":`Adicionar ao projeto`,
"c592":`Gráfico da cascata`,
"c315":`Somente pedidos válidos podem gerar faturas`,
"c89":`Nome do evento por email`,
"c108":`Automatch com sucesso`,
"c402":`Campo`,
"c748":`Favor selecionar um livro de preços para {título}. Você só pode adicionar produtos de um único livro de preços. A alteração do livro de preços selecionado resultará na exclusão de todos os produtos existentes.`,
"c501":`Ofereça um serviço de campo de qualidade a seus clientes`,
"c269":`Falha em fundir informações`,
"front-electronic-signature-open-confirm":`Conta vinculada`,
"c584":`Mapa dos Estados Unidos`,
"c437":`Sem sucesso`,
"c738":`Data de envio`,
"c274":`Você tem um tempo limite para aceitar o pedido, e o despacho é cancelado. Número: {0}. Clique para ver mais >`,
"c83":`Dados de pesquisa`,
"c206":`Formato PNG`,
"c309":`Enviar arquivo de pedido`,
"c539":`Proporção mais alta de fontes`,
"c304":`Principais Interesses`,
"c151":`Descrever brevemente o conteúdo principal da forma`,
"c639":`Postar agora`,
"c720":`No，thanks`,
"c801":`Novos Contatos`,
"c900":`Não há informações de endereço disponíveis para o visitante, portanto, a distância de checkin não pode ser calculada.`,
"c695":`Tamanho original`,
"c864":`Escolha um formulário`,
"c881":`Eu li e concordei`,
"c794":`Modelo de assinatura`,
"c543":`Avaliações Recebidas`,
"c466":`Somente pedidos que utilizam o mesmo livro de preços podem gerar uma fatura`,
"c867":`{userName} receberá um email de convite que solicitará a criação de uma senha para acessar sua Central de Ajuda.
Continuar?`,
"c529":`Não há formas disponíveis de recarga, favor entrar em contato com o administrador`,
"c742":`É possível selecionar um máximo de 4 imagens e cada uma delas não pode exceder 200K. Clique na imagem para selecionar.`,
"c430":`Termo de busca de desempenho`,
"c553":`Último Tempo Convidado`,
"c575":`Tabela de Colunas`,
"c124":`Entrega Pendente`,
"c629":`Sem sucesso`,
"c554":`Primeiro Tempo Convidado`,
"c547":`Últimos 7 dias`,
"c599":`Tabela Tabela`,
"c588":`Mapa do Canadá`,
"c703":`Via`,
"c713":`Criar postos sociais a partir de dentro do CloudCC.`,
"c142":`Esta é a ação que será tomada depois que um visitante apresentar o formulário em seu site`,
"c153":`Depois de limpar os produtos associados ao registro atual, você pode mudar a moeda.`,
"c253":`Cumprimento do GDPR`,
"c612":`Página interna`,
"c400":`Localização dos recursos de serviços`,
"c671":`Ícone e Palavra`,
"c20":`Não pode exceder a quantidade a ser faturada do pedido relacionado.`,
"c514":`Gráficos do relatório`,
"c946":`Reino Unido`,
"c717":`Novo posto`,
"c174":`Todos editados com sucesso`,
"c940":`China  Hong Kong`,
"c743":`Favor inserir números válidos`,
"c441":`Gestão empresarial e financeira inteligente`,
"c423":`Plataforma de Despacho`,
"c723":`Confirmar para solicitar a destruição`,
"c664":`Nenhuma rede social`,
"c859":`Favor inserir {0}`,
"c356":`Custo planejado`,
"c221":`Ir para Projeto`,
"front-email-payment-Invoice-Tips1":`Favor entrar em contato com o administrador para ativar WeChat, Alipay, PayPal ou VISA e então iniciar o pagamento online`,
"c99":`Produto QTY`,
"c278":`Você deseja excluir os seguintes emails?`,
"c364":`Linha de citação`,
"c572":`Os campos selecionados não podem estar vazios, por favor, adicione o(s) campo(s)`,
"c310":`Gerar arquivo de pedido`,
"c247":`Transferido`,
"c158":`Atribuir Limiar de Tempo`,
"c325":`Modelo de Notificação de Atribuição de Caso`,
"c877":`Preencher Nãoordenado`,
"front-filter-v1-press":`Imprensa`,
"c505":`Rastreamento de Visitantes`,
"c523":`Adicionar como usuário do Portal`,
"c727":`Destruir dados com sucesso`,
"front-electronic-signature-sended":`Enviado`,
"c150":`Favor preencher as informações necessárias`,
"c700":`ÚLTIMO TEMPO ATUALIZADO`,
"c824":`Assine em Ordem`,
"c710":`Uma casa para administrar todas as suas mídias sociais`,
"c358":`Orçamento`,
"c544":`Canais`,
"c212":`Formato SVG`,
"c165":`Favor inserir um valor inteiro de 024`,
"c932":`Spam`,
"c888":`Ativar a conta de usuário com sucesso`,
"c838":`Operador`,
"c98":`Categoria do produto`,
"c830":`CRIADOS POR`,
"c661":`Rede`,
"c818":`Configurações personalizadas do menu da página`,
"c861":`Escolha no Mapa`,
"c736":`Postado por`,
"c204":`Padrão`,
"c839":`Parece que não há nada programado.`,
"c456":`Quantia paga`,
"c341":`Contas finais`,
"c724":`Confirmar para destruir dados`,
"c865":`Eu li e concordo com {0} e {1}`,
"c332":`O montante não pode exceder a ordem a ser faturada`,
"c520":`O pagamento falhou. O abatimento disponível é insuficiente`,
"c906":`Menos`,
"c482":`Dê um nome ao seu Compagin:`,
"c49":`Atualização da configuração de segurança do domínio`,
"c725":`Revogar pedido de destruição com sucesso`,
"c76":`PAGAM`,
"c558":`Em casos de espera`,
"c876":`Assinatura nãoordenada`,
"front-invoices-v1-nofilles-tocreate":`Favor clicar no botão Gerar fatura para gerar uma fatura e, em seguida, enviála.`,
"c779":`Data limite de assinatura`,
"c603":`Carta Biaxial MoM&YoY`,
"c455":`Objetivo do contrato`,
"c428":`Despacho em modo mapa`,
"c55":`Favor preencher o valor do imposto`,
"c899":`Distância de checkin`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Nome do destinatário:`,
"label.social.posts.info":`Nenhum conteúdo post foi encontrado`,
"c704":`Público`,
"c673":`Imagem Web`,
"front-electronic-signature-singed":`Início da assinatura`,
"c722":`1 conta conectada`,
"c595":`Tabela de áreas`,
"c120":`tipo(s)`,
"c68":`Ordem a pagar`,
"c479":`Formulários CloudCC Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Assinatura eletrônica e estampagem`,
"c5":`Imposto`,
"c976":``,
"c812":`COMENTÁRIOS`,
"c532":`Contagem de casos de descanso`,
"c330":`Item de linha de contrato`,
"c249":`posto está saindo agora`,
"c630":`Vista no LinkedIn`,
"c958":`Posto como ID não pode estar vazio`,
"c170":`Falha na criação de dados com a identificação do registro {0}, razão falhada: {1};`,
"c810":`REPLIES`,
"c783":`Requisitos de Assinatura`,
"c968":``,
"c752":`Iniciar a tarefa de assinatura`,
"c439":`Visitante`,
"c67":`Submeter pedido com sucesso!`,
"front-generate-v1-invoice":`Gerar Fatura`,
"c477":`Você deve se autenticar com sua conta MailChimp. Clique no botão "Authenticate MailChimp" e você será redirecionado para Mail Chimp para enviar campanhas.`,
"c966":`Favor entrar em contato com o administrador`,
"c764":`Rejeitado`,
"c301":`Podem ser inseridos até 200 caracteres`,
"c61":`Por favor, abra primeiro o Conhecimento e depois useo`,
"c815":`Arquivar tudo`,
"c827":`Você tem mudanças não salvas nesta página que serão perdidas se você continuar.`,
"c688":`Largura máxima`,
"c33":`Editar Tipo de Assinatura`,
"c217":`postagem está saindo {data}`,
"c721":`Desconectar a coount`,
"c284":`Solicitação de dados de processo de clientes dentro do CRM`,
"c939":`China  Macau`,
"c503":`Acompanhe o progresso de seu projeto`,
"c492":`Convidado`,
"c73":`Balanço atual`,
"label.the.peoples.republic.of.china":`República Popular da China`,
"c828":`POST`,
"c36":`Prévisualização`,
"c954":`Novo número de telefone`,
"front-electronic-signature-innerSinger":`Signatário interno`,
"c508":`Análise do ROI`,
"c833":`Certificação Aprovada`,
"c207":`Formato vetorial`,
"c31":`Meia tela`,
"c71":`Favor escolher uma opção de pagamento`,
"c373":`Livro de Preços Padrão`,
"c545":`Tempo de solução (h)`,
"c77":`Módulo de configuração`,
"label.lastcompiledate":`Tempo da última compilação`,
"c119":`Confirmar recibo`,
"c281":`Processamento de dados`,
"c715":`A marca Monitor menciona e responde rapidamente.`,
"c127":`Gerenciar Colunas`,
"c283":`Solicitação de dados`,
"c919":`Use o pool para estimular o potencial da equipe e melhorar a taxa de conversão de chumbo. O administrador do pool faz uma gestão unificada para as atribuições de leads e lotes. O pessoal de vendas também pode selecionar os leads e receber acompanhamento.`,
"c82":`Somente para Relâmpagos`,
"front-file-delete-intro":`O arquivo foi removido`,
"c606":`Endereço padrão de envio`,
"c905":`Adicione`,
"c644":`TEMPO PUBLICADO`,
"c75":`Saldo do Rebate`,
"c884":`Política de Privacidade`,
"c538":`Tempo de resolução da Avg`,
"c322":`Nova Fatura`,
"c461":`Tendência de pagamento`,
"c825":`Empresas`,
"c56":`O total da fatura a receber e o valor a receber não são consistentes. Por favor, preencha novamente.`,
"c931":`Você não ativou o interruptor de posicionamento do funcionário e não pode usar o intervalo de compartilhamento de local. Continuar?`,
"c276":`Habilitar o cumprimento da GDPR`,
"c334":`Montante do orçamento`,
"c733":`Campanha: Novo cartaz`,
"c384":`Nova Lista de Embalagem`,
"c139":`Modelo de reunião`,
"c957":`O ID do comentário não pode estar vazio`,
"front-electronic-signature-nosign":`Nenhum prestador de serviço de assinatura eletrônica foi escolhido por sua organização. Favor contatar o administrador para habilitar este serviço.`,
"c419":`Plano de manutenção`,
"c934":`Título de Conversão`,
"c677":`Alinhado à direita`,
"c593":`Gráfico de linhas`,
"c272":`{0} tem um tempo limite de aceitação da ordem. Conta: {1}, Assunto: {2}, Número: {3}. Clique para ver mais >`,
"c811":`RETWEETS`,
"c451":`Estojo dividido`,
"c277":`Uma vez apagado o email, os seguintes emails também serão apagados e não serão enviados para contatos futuros. Isto é irriversível.`,
"c244":`{!ServiceResource.name} rejeitou o pedido. Número: "{!ServiceApontamento.nome}".`,
"c627":`Publicado em`,
"c601":`Tabela de alvos`,
"c251":`a(s) publicação(ões) póspublicação(ões) é(são) falhada(s)`,
"c202":`Participação no Mailchimp`,
"font-social-prohibit-create":`Você não pode criar um novo posto enquanto edita`,
"c394":`O CloudCC ajuda você a gerenciar o negócio online e melhorar a eficiência. Escolha o aplicativo que você deseja usar e siga a introdução e a orientação.`,
"c323":`Formato PDF`,
"front-setting-dialog-title-one":`A fim de evitar a perda de conta, faça o login rapidamente e recupere facilmente, por favor, vincule o número de telefone`,
"front-electronic-signature-cancelIntro2":`Se esta é sua primeira vez para vincular uma conta, por favor clique em Continuar para ir para o próximo passo. Se você estiver rebobinando após destravar, é recomendável clicar em Cancelar e rebobinar após limpar os dados de navegação.`,
"c353":`Exibição das folhas de tempos`,
"c621":`Conteúdo rico de texto`,
"front-v1-partner-image-tooltip":`É suportado um arquivo máximo de 2M. A imagem será redimensionada para {tamanho}. É recomendado carregar imagens claras com proporções similares.`,
"c772":`Finalizado em`,
"c734":`Nome do Canal de Cartazes`,
"c380":`Novo pagamento`,
"c979":``,
"c233":`Você não pode excluir a lista de status de embalagem do embarque`,
"c458":`Mapa de distribuição de contas`,
"c697":`Escolha o endereço da conta{nome}`,
"c476":`Escolha o funcionário para enviar o código de convite para`,
"c634":`Criar um posto envolvente e conectarse com o mundo`,
"c144":`O tempo final não pode exceder 2038. Por favor, selecione um novo horário final.`,
"c474":`Você pode reatribuir usando as regras de atribuição de liderança. Para as regras de atribuição, consulte`,
"c371":`Sincronização com a Oportunidade`,
"c420":`Ativos de manutenção`,
"c620":`Isto é usado para agrupar vários conteúdos para análise de um único esforço de marketing.`,
"c708":`Unificar ou não a escala`,
"c100":`Desconto`,
"c576":`Gráfico de Colunas 2D`,
"c751":`Data limite de assinatura:`,
"c252":`Configurações de conformidade`,
"c699":`Novo Apenas`,
"c74":`Pagamento por Rebate`,
"c805":`Escolha uma rede social para começar:`,
"c452":`Histórico de casos`,
"c740":`Favor selecionar um funcionário para enviar convite`,
"c596":`Gráfico Biaxial`,
"c832":`Revisando`,
"c971":``,
"c262":`História`,
"c363":`Sensível`,
"label.singleSignOn.is.invalid":`Loginfree era inválido`,
"c72":`Pagamento a terceiros`,
"c292":`Marketing`,
"c499":`Serviço ao cliente eficiente para impressionar os clientes`,
"c574":`Gráfico de barras empilhadas`,
"c618":`Alterar o conteúdo ou tempo de publicação para este post.  O Twitter não permite que mais de um post com o mesmo conteúdo seja publicado em 24 horas.`,
"front-setting-phone-format":`Favor inserir o número de telefone no formato correto`,
"c460":`Classificação do tamanho da conta`,
"c189":`A moeda da fatura deve ser consistente com a moeda do pedido. Por favor, refine a moeda e economize novamente.`,
"label.exe.supported.request.rejected":`exe. arquivo não é suportado para ser enviado. O pedido é recusado!`,
"c835":`Já existiu uma fatura para esta cotação. Para continuar ou não?`,
"c655":`Afixação a partir de`,
"c45":`Conectarse por`,
"c43":`Conectar conta`,
"c481":`Entrar como um usuário diferente`,
"c674":`Endereço externo`,
"c266":`Esta ordem não pode ser alterada, pois foi concluída`,
"c967":``,
"c154":`Favor pesquisar livros de preços após selecionar produtos`,
"c841":`Tem idéias? Esboço de fora.   `,
"c615":`Nenhuma conta foi selecionada`,
"c84":`Escolha emloyee para enviar o código de convite`,
"c401":`Serviço`,
"c290":`Objetos habilitados`,
"c205":`Download do Código QR`,
"c928":`Podem ser selecionados até 10 campos.`,
"c195":`Limite de submissão`,
"1":`Nenhuma ação disponível`,
"c46":`Autorizar com sucesso`,
"c459":`Valor do contrato assinado`,
"c250":`os postos são salvos como rascunhos`,
"c399":`Inventário`,
"c518":`O #recordName de #label falhou a aprovação por #failReason`,
"c396":`Escolha diferentes soluções`,
"c300":`Destruir solicitado por`,
"c789":`Método de Assinatura Irrestrita`,
"c874":`Você leu tudo o que estava em sua caixa de entrada.`,
"c38":`Número de bloco comunitário`,
"c228":`Adicionar Subtarefa`,
"c342":`Lucro`,
"c879":`Clonar postos sociais`,
"c173":`Rebobinar com sucesso`,
"c778":`Iniciador`,
"c211":`Tamanho pequeno`,
"c496":`CloudCC Sales Cloud  um CRM inteligente para todos os cenários para ajudálo a atingir suas metas de vendas`,
"c427":`Despacho em Modo Gráfico de Gantt`,
"c851":`Isto mostra o número de postagens que foram publicadas em suas contas dentro do período selecionado.`,
"c32":`Novo Tipo de Assinatura`,
"c28":`Crescimento ano a ano`,
"c163":`Simultaneamente, informar e cancelar o despacho`,
"c225":`Ir para a tarefa`,
"c569":`Por favor, escolha primeiro a conta`,
"c92":`Aberto uma vez`,
"c412":`Nomeação de serviço de autocriação`,
"c81":`Adicionar ao carrinho`,
"c653":`Isto mostra o número de gostos, reações e comentários para suas postagens publicadas. Isto também inclui posts que foram publicados para suas contas conectadas fora do CloudCC. Se você estiver procurando por retweets no Twitter, você os encontrará em Ações.`,
"c516":`Atendimento`,
"c918":`Se as regras de autoreciclagem forem configuradas, o sistema fará a autoreciclagem dos registros para o pool quando a conta não tiver fechado o negócio após o limite de tempo. Isso melhora a eficiência do acompanhamento da conta.`,
"c809":`LIKES`,
"c181":`Favor preencher a ordem de trabalho ou o registro do caso`,
"c745":`Por favor, digite até 2 casas decimais`,
"c669":`Cor`,
"c929":`Favor verificar a conexão de rede`,
"c117":`Economize e Pague`,
"c938":`China Continental`,
"c112":`Todos os modelos {nome} estão atualmente desabilitados. Favor contatar o administrador para habilitar o modelo antes de gerar o {nome}.`,
"c347":`Alterar horas de trabalho da tarefa do projeto`,
"c795":`Favor escolher o modelo de contrato`,
"c17":`Inativo. Por favor, selecione novamente`,
"c787":`Assinado pelo Operador`,
"c829":`CAMPAIGN`,
"c161":`Informe também`,
"c65":`Você quer mudar o status logístico do produto para Entregue`,
"c665":`Adicione mais um`,
"c767":`Verificar o progresso da assinatura`,
"c87":`QR Código do formulário de campanha`,
"c589":`Mapa da França`,
"front-electronic-signature-newTime":`Última Atualização em`,
"c813":`PARTILHAR`,
"c85":`{member} inviter selecionado`,
"c951":`Polônia`,
"c29":`Crescimento mês a mês`,
"c210":`Tamanho grande`,
"c39":`Arquivado`,
"c672":`Palavra`,
"c97":`Esta lista de seleção deve conter pelo menos uma opção "Convertido".`,
"c687":`Tamanho máximo`,
"c916":`Fechar piscina`,
"c475":`Por favor, preencha o formulário do proprietário da campanha`,
"c628":`Programado`,
"c788":`O livro de preços para esta oportunidade está atualmente desativado. Favor ativar o livro de preços antes de criar um novo pedido.`,
"c177":`Tamanho sugerido: 390*210`,
"c856":`Viva! Nada de postos de trabalho malucos.`,
"c70":`Informações sobre pedidos`,
"c546":`Últimas 24 horas`,
"c331":`Converta ativos`,
"label.order.paidamount.greater.than.total":`Após a criação dos novos detalhes de pagamento, o valor reembolsado do pedido será maior do que o valor do pedido. Por favor, reajuste o pagamento e depois salveo.`,
"c524":`Convide novamente`,
"c246":`{!oldServiceResource.name} transferiu a ordem de trabalho numerada {!ServiceAppointment.name} para você.`,
"label.parameter.is.incorrect":`Parâmetros errados`,
"c667":`Espaçamento de ícones`,
"c737":`Plataforma Social`,
"c48":`Desconectar`,
"c111":`Gerar {nome}`,
"c755":`Em seqüência`,
"c526":`Habilitar usuário do Portal`,
"c450":`Fundir casos`,
"front-electronic-export-reChoseChimp":`A visão atual não tem registro de dados e não pode ser exportada. Por favor, selecione uma nova visão`,
"label.invoice.paidamount.greater.than.total":`Após a criação dos novos detalhes de pagamento, o valor reembolsado da fatura será maior do que o valor total. Por favor, reajuste o pagamento e depois salveo.`,
"c222":`Editar Projeto`,
"c849":`Contas no Twitter`,
"c678":`Preto e Branco`,
"c502":`Oferecer soluções abrangentes para lidar com todos os processos envolvidos nos serviços de campo para agilizar as operações, melhorar a produtividade, aumentar a fidelidade e a satisfação dos clientes.`,
"c497":`Inventário mais inteligente, gestão empresarial e financeira mais forte`,
"c200":`Compartilhar nas mídias sociais`,
"c658":`Texto rico`,
"c434":`Novo contato relacionado`,
"c641":`Você só pode escolher não mais do que 4 images，click imagem selecionada para desmarcála. O tamanho da imagem que você carrega deve ser inferior a 200kb`,
"c944":`Alemanha`,
"c411":`Offset de data de vencimento`,
"c624":` Todas as contas`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c791":`Assinatura padrão`,
"c306":`Concorde`,
"c14":`O usuário atual não tem a permissão para excluir`,
"c176":`Somente imagens png, jpg e jpeg são suportadas para upload. A imagem carregada não pode exceder 2M.`,
"c166":`Favor inserir o comprimento máximo do pedido de acordo com as regras`,
"c731":`A alteração do livro de preços selecionado também excluirá todos os produtos existentes. Você tem certeza de que vai mudar para o novo livro de preços?`,
"c237":`{!ServiceResource.name} acedeu ao pedido. Número: "{!ServiceApontamento.nome}".`,
"c887":`Convidar de novo o usuário com sucesso`,
"c227":`Editar Subtarefa`,
"c257":`Contato disponível`,
"c712":`Relatar e comparar o desempenho entre redes, postos e campanhas.`,
"c107":`Pesquisar usuários por nome, conta e número de celular`,
"c370":`Contrato`,
"c895":`O cálculo da distância falhou, por favor, digite o endereço completo`,
"c693":`Autorregulação`,
"c763":`Assinado`,
"c302":`Interesses legítimos`,
"c577":`Tabela de Colunas Empilhadas`,
"c258":`Fazer uma reclamação`,
"c676":`Centro`,
"c868":`Após desativar esta conta, o sistema restringirá seu acesso ou operações em seu portal. Continuar?`,
"c53":`Razão (%)`,
"c527":`#userName atribuiulhe uma tarefa de aprovação`,
"label.facebook.title.setting":`Informações integradas no Facebook`,
"c340":`Mudar o proprietário do plano do projeto`,
"c706":`Sobre os gráficos`,
"label.mobile.used":`O número móvel tem sido utilizado`,
"c328":`Código QR do Ativo`,
"c337":`Contatos  Destroy`,
"c642":`Imagens recentes`
}